/* *****
This is a concatenated, un-minified file. It is NOT used by the theme by default.
We recommend using this file to make small edits to the theme's code.
For instructions on switching between minified and un-minified files see our documentation:
https://support.weareeight.com/hc/en-us/articles/360020366578-Un-minified-CSS-Javascript
***** */
/******/ (() => {
  // webpackBootstrap
  /******/ var __webpack_modules__ = {
    /***/ 816: /***/ (module) => {
      "use strict";

      var requestAnimFrame = (function () {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          function (callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();

      function decouple(node, event, fn) {
        var eve,
          tracking = false;

        function captureEvent(e) {
          eve = e;
          track();
        }

        function track() {
          if (!tracking) {
            requestAnimFrame(update);
            tracking = true;
          }
        }

        function update() {
          fn.call(node, eve);
          tracking = false;
        }

        node.addEventListener(event, captureEvent, false);

        return captureEvent;
      }

      /**
       * Expose decouple
       */
      module.exports = decouple;

      /***/
    },

    /***/ 626: /***/ (module, exports) => {
      "use strict";

      var _classCallCheck = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      };

      exports.__esModule = true;
      /**
       * Creates a new instance of Emitter.
       * @class
       * @returns {Object} Returns a new instance of Emitter.
       * @example
       * // Creates a new instance of Emitter.
       * var Emitter = require('emitter');
       *
       * var emitter = new Emitter();
       */

      var Emitter = (function () {
        function Emitter() {
          _classCallCheck(this, Emitter);
        }

        /**
         * Adds a listener to the collection for the specified event.
         * @memberof! Emitter.prototype
         * @function
         * @param {String} event - The event name.
         * @param {Function} listener - A listener function to add.
         * @returns {Object} Returns an instance of Emitter.
         * @example
         * // Add an event listener to "foo" event.
         * emitter.on('foo', listener);
         */

        Emitter.prototype.on = function on(event, listener) {
          // Use the current collection or create it.
          this._eventCollection = this._eventCollection || {};

          // Use the current collection of an event or create it.
          this._eventCollection[event] = this._eventCollection[event] || [];

          // Appends the listener into the collection of the given event
          this._eventCollection[event].push(listener);

          return this;
        };

        /**
         * Adds a listener to the collection for the specified event that will be called only once.
         * @memberof! Emitter.prototype
         * @function
         * @param {String} event - The event name.
         * @param {Function} listener - A listener function to add.
         * @returns {Object} Returns an instance of Emitter.
         * @example
         * // Will add an event handler to "foo" event once.
         * emitter.once('foo', listener);
         */

        Emitter.prototype.once = function once(event, listener) {
          var self = this;

          function fn() {
            self.off(event, fn);
            listener.apply(this, arguments);
          }

          fn.listener = listener;

          this.on(event, fn);

          return this;
        };

        /**
         * Removes a listener from the collection for the specified event.
         * @memberof! Emitter.prototype
         * @function
         * @param {String} event - The event name.
         * @param {Function} listener - A listener function to remove.
         * @returns {Object} Returns an instance of Emitter.
         * @example
         * // Remove a given listener.
         * emitter.off('foo', listener);
         */

        Emitter.prototype.off = function off(event, listener) {
          var listeners = undefined;

          // Defines listeners value.
          if (
            !this._eventCollection ||
            !(listeners = this._eventCollection[event])
          ) {
            return this;
          }

          listeners.forEach(function (fn, i) {
            if (fn === listener || fn.listener === listener) {
              // Removes the given listener.
              listeners.splice(i, 1);
            }
          });

          // Removes an empty event collection.
          if (listeners.length === 0) {
            delete this._eventCollection[event];
          }

          return this;
        };

        /**
         * Execute each item in the listener collection in order with the specified data.
         * @memberof! Emitter.prototype
         * @function
         * @param {String} event - The name of the event you want to emit.
         * @param {...Object} data - Data to pass to the listeners.
         * @returns {Object} Returns an instance of Emitter.
         * @example
         * // Emits the "foo" event with 'param1' and 'param2' as arguments.
         * emitter.emit('foo', 'param1', 'param2');
         */

        Emitter.prototype.emit = function emit(event) {
          var _this = this;

          for (
            var _len = arguments.length,
              args = Array(_len > 1 ? _len - 1 : 0),
              _key = 1;
            _key < _len;
            _key++
          ) {
            args[_key - 1] = arguments[_key];
          }

          var listeners = undefined;

          // Defines listeners value.
          if (
            !this._eventCollection ||
            !(listeners = this._eventCollection[event])
          ) {
            return this;
          }

          // Clone listeners
          listeners = listeners.slice(0);

          listeners.forEach(function (fn) {
            return fn.apply(_this, args);
          });

          return this;
        };

        return Emitter;
      })();

      /**
       * Exports Emitter
       */
      exports.default = Emitter;
      module.exports = exports["default"];

      /***/
    },

    /***/ 508: /***/ function (module) {
      (function webpackUniversalModuleDefinition(root, factory) {
        if (true) module.exports = factory();
        else {
        }
      })(typeof self !== "undefined" ? self : this, function () {
        return /******/ (function (modules) {
          // webpackBootstrap
          /******/ // The module cache
          /******/ var installedModules = {};
          /******/
          /******/ // The require function
          /******/ function __nested_webpack_require_574__(moduleId) {
            /******/
            /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) {
              /******/ return installedModules[moduleId].exports;
              /******/
            }
            /******/ // Create a new module (and put it into the cache)
            /******/ var module = (installedModules[moduleId] = {
              /******/ i: moduleId,
              /******/ l: false,
              /******/ exports: {},
              /******/
            });
            /******/
            /******/ // Execute the module function
            /******/ modules[moduleId].call(
              module.exports,
              module,
              module.exports,
              __nested_webpack_require_574__
            );
            /******/
            /******/ // Flag the module as loaded
            /******/ module.l = true;
            /******/
            /******/ // Return the exports of the module
            /******/ return module.exports;
            /******/
          }
          /******/
          /******/
          /******/ // expose the modules object (__webpack_modules__)
          /******/ __nested_webpack_require_574__.m = modules;
          /******/
          /******/ // expose the module cache
          /******/ __nested_webpack_require_574__.c = installedModules;
          /******/
          /******/ // define getter function for harmony exports
          /******/ __nested_webpack_require_574__.d = function (
            exports,
            name,
            getter
          ) {
            /******/ if (!__nested_webpack_require_574__.o(exports, name)) {
              /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter,
                /******/
              });
              /******/
            }
            /******/
          };
          /******/
          /******/ // define __esModule on exports
          /******/ __nested_webpack_require_574__.r = function (exports) {
            /******/ Object.defineProperty(exports, "__esModule", {
              value: true,
            });
            /******/
          };
          /******/
          /******/ // getDefaultExport function for compatibility with non-harmony modules
          /******/ __nested_webpack_require_574__.n = function (module) {
            /******/ var getter =
              module && module.__esModule
                ? /******/ function getDefault() {
                    return module["default"];
                  }
                : /******/ function getModuleExports() {
                    return module;
                  };
            /******/ __nested_webpack_require_574__.d(getter, "a", getter);
            /******/ return getter;
            /******/
          };
          /******/
          /******/ // Object.prototype.hasOwnProperty.call
          /******/ __nested_webpack_require_574__.o = function (
            object,
            property
          ) {
            return Object.prototype.hasOwnProperty.call(object, property);
          };
          /******/
          /******/ // __webpack_public_path__
          /******/ __nested_webpack_require_574__.p = "";
          /******/
          /******/
          /******/ // Load entry module and return exports
          /******/ return __nested_webpack_require_574__(
            (__nested_webpack_require_574__.s = 0)
          );
          /******/
        })(
          /************************************************************************/
          /******/ {
            /***/ "./dist/icons.json":
              /*!*************************!*\
  !*** ./dist/icons.json ***!
  \*************************/
              /*! exports provided: activity, airplay, alert-circle, alert-octagon, alert-triangle, align-center, align-justify, align-left, align-right, anchor, aperture, archive, arrow-down-circle, arrow-down-left, arrow-down-right, arrow-down, arrow-left-circle, arrow-left, arrow-right-circle, arrow-right, arrow-up-circle, arrow-up-left, arrow-up-right, arrow-up, at-sign, award, bar-chart-2, bar-chart, battery-charging, battery, bell-off, bell, bluetooth, bold, book-open, book, bookmark, box, briefcase, calendar, camera-off, camera, cast, check-circle, check-square, check, chevron-down, chevron-left, chevron-right, chevron-up, chevrons-down, chevrons-left, chevrons-right, chevrons-up, chrome, circle, clipboard, clock, cloud-drizzle, cloud-lightning, cloud-off, cloud-rain, cloud-snow, cloud, code, codepen, codesandbox, coffee, columns, command, compass, copy, corner-down-left, corner-down-right, corner-left-down, corner-left-up, corner-right-down, corner-right-up, corner-up-left, corner-up-right, cpu, credit-card, crop, crosshair, database, delete, disc, divide-circle, divide-square, divide, dollar-sign, download-cloud, download, dribbble, droplet, edit-2, edit-3, edit, external-link, eye-off, eye, facebook, fast-forward, feather, figma, file-minus, file-plus, file-text, file, film, filter, flag, folder-minus, folder-plus, folder, framer, frown, gift, git-branch, git-commit, git-merge, git-pull-request, github, gitlab, globe, grid, hard-drive, hash, headphones, heart, help-circle, hexagon, home, image, inbox, info, instagram, italic, key, layers, layout, life-buoy, link-2, link, linkedin, list, loader, lock, log-in, log-out, mail, map-pin, map, maximize-2, maximize, meh, menu, message-circle, message-square, mic-off, mic, minimize-2, minimize, minus-circle, minus-square, minus, monitor, moon, more-horizontal, more-vertical, mouse-pointer, move, music, navigation-2, navigation, octagon, package, paperclip, pause-circle, pause, pen-tool, percent, phone-call, phone-forwarded, phone-incoming, phone-missed, phone-off, phone-outgoing, phone, pie-chart, play-circle, play, plus-circle, plus-square, plus, pocket, power, printer, radio, refresh-ccw, refresh-cw, repeat, rewind, rotate-ccw, rotate-cw, rss, save, scissors, search, send, server, settings, share-2, share, shield-off, shield, shopping-bag, shopping-cart, shuffle, sidebar, skip-back, skip-forward, slack, slash, sliders, smartphone, smile, speaker, square, star, stop-circle, sun, sunrise, sunset, tablet, tag, target, terminal, thermometer, thumbs-down, thumbs-up, toggle-left, toggle-right, tool, trash-2, trash, trello, trending-down, trending-up, triangle, truck, tv, twitch, twitter, type, umbrella, underline, unlock, upload-cloud, upload, user-check, user-minus, user-plus, user-x, user, users, video-off, video, voicemail, volume-1, volume-2, volume-x, volume, watch, wifi-off, wifi, wind, x-circle, x-octagon, x-square, x, youtube, zap-off, zap, zoom-in, zoom-out, default */
              /***/ function (module) {
                module.exports = {
                  activity:
                    '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>',
                  airplay:
                    '<path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon>',
                  "alert-circle":
                    '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
                  "alert-octagon":
                    '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
                  "alert-triangle":
                    '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>',
                  "align-center":
                    '<line x1="18" y1="10" x2="6" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="18" y1="18" x2="6" y2="18"></line>',
                  "align-justify":
                    '<line x1="21" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="3" y2="18"></line>',
                  "align-left":
                    '<line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line>',
                  "align-right":
                    '<line x1="21" y1="10" x2="7" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="7" y2="18"></line>',
                  anchor:
                    '<circle cx="12" cy="5" r="3"></circle><line x1="12" y1="22" x2="12" y2="8"></line><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path>',
                  aperture:
                    '<circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line>',
                  archive:
                    '<polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line>',
                  "arrow-down-circle":
                    '<circle cx="12" cy="12" r="10"></circle><polyline points="8 12 12 16 16 12"></polyline><line x1="12" y1="8" x2="12" y2="16"></line>',
                  "arrow-down-left":
                    '<line x1="17" y1="7" x2="7" y2="17"></line><polyline points="17 17 7 17 7 7"></polyline>',
                  "arrow-down-right":
                    '<line x1="7" y1="7" x2="17" y2="17"></line><polyline points="17 7 17 17 7 17"></polyline>',
                  "arrow-down":
                    '<line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline>',
                  "arrow-left-circle":
                    '<circle cx="12" cy="12" r="10"></circle><polyline points="12 8 8 12 12 16"></polyline><line x1="16" y1="12" x2="8" y2="12"></line>',
                  "arrow-left":
                    '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>',
                  "arrow-right-circle":
                    '<circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line>',
                  "arrow-right":
                    '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>',
                  "arrow-up-circle":
                    '<circle cx="12" cy="12" r="10"></circle><polyline points="16 12 12 8 8 12"></polyline><line x1="12" y1="16" x2="12" y2="8"></line>',
                  "arrow-up-left":
                    '<line x1="17" y1="17" x2="7" y2="7"></line><polyline points="7 17 7 7 17 7"></polyline>',
                  "arrow-up-right":
                    '<line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline>',
                  "arrow-up":
                    '<line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline>',
                  "at-sign":
                    '<circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>',
                  award:
                    '<circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>',
                  "bar-chart-2":
                    '<line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line>',
                  "bar-chart":
                    '<line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line>',
                  "battery-charging":
                    '<path d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line x1="23" y1="13" x2="23" y2="11"></line><polyline points="11 6 7 12 13 12 9 18"></polyline>',
                  battery:
                    '<rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line>',
                  "bell-off":
                    '<path d="M13.73 21a2 2 0 0 1-3.46 0"></path><path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"></path><path d="M18 8a6 6 0 0 0-9.33-5"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                  bell: '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path>',
                  bluetooth:
                    '<polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"></polyline>',
                  bold: '<path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>',
                  "book-open":
                    '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>',
                  book: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>',
                  bookmark:
                    '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>',
                  box: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                  briefcase:
                    '<rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>',
                  calendar:
                    '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line>',
                  "camera-off":
                    '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"></path>',
                  camera:
                    '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle>',
                  cast: '<path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path><line x1="2" y1="20" x2="2.01" y2="20"></line>',
                  "check-circle":
                    '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>',
                  "check-square":
                    '<polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>',
                  check: '<polyline points="20 6 9 17 4 12"></polyline>',
                  "chevron-down":
                    '<polyline points="6 9 12 15 18 9"></polyline>',
                  "chevron-left":
                    '<polyline points="15 18 9 12 15 6"></polyline>',
                  "chevron-right":
                    '<polyline points="9 18 15 12 9 6"></polyline>',
                  "chevron-up":
                    '<polyline points="18 15 12 9 6 15"></polyline>',
                  "chevrons-down":
                    '<polyline points="7 13 12 18 17 13"></polyline><polyline points="7 6 12 11 17 6"></polyline>',
                  "chevrons-left":
                    '<polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline>',
                  "chevrons-right":
                    '<polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline>',
                  "chevrons-up":
                    '<polyline points="17 11 12 6 7 11"></polyline><polyline points="17 18 12 13 7 18"></polyline>',
                  chrome:
                    '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="21.17" y1="8" x2="12" y2="8"></line><line x1="3.95" y1="6.06" x2="8.54" y2="14"></line><line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>',
                  circle: '<circle cx="12" cy="12" r="10"></circle>',
                  clipboard:
                    '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>',
                  clock:
                    '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>',
                  "cloud-drizzle":
                    '<line x1="8" y1="19" x2="8" y2="21"></line><line x1="8" y1="13" x2="8" y2="15"></line><line x1="16" y1="19" x2="16" y2="21"></line><line x1="16" y1="13" x2="16" y2="15"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="12" y1="15" x2="12" y2="17"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
                  "cloud-lightning":
                    '<path d="M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"></path><polyline points="13 11 9 17 15 17 11 23"></polyline>',
                  "cloud-off":
                    '<path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                  "cloud-rain":
                    '<line x1="16" y1="13" x2="16" y2="21"></line><line x1="8" y1="13" x2="8" y2="21"></line><line x1="12" y1="15" x2="12" y2="23"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
                  "cloud-snow":
                    '<path d="M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"></path><line x1="8" y1="16" x2="8.01" y2="16"></line><line x1="8" y1="20" x2="8.01" y2="20"></line><line x1="12" y1="18" x2="12.01" y2="18"></line><line x1="12" y1="22" x2="12.01" y2="22"></line><line x1="16" y1="16" x2="16.01" y2="16"></line><line x1="16" y1="20" x2="16.01" y2="20"></line>',
                  cloud:
                    '<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>',
                  code: '<polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline>',
                  codepen:
                    '<polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"></polygon><line x1="12" y1="22" x2="12" y2="15.5"></line><polyline points="22 8.5 12 15.5 2 8.5"></polyline><polyline points="2 15.5 12 8.5 22 15.5"></polyline><line x1="12" y1="2" x2="12" y2="8.5"></line>',
                  codesandbox:
                    '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline><polyline points="7.5 19.79 7.5 14.6 3 12"></polyline><polyline points="21 12 16.5 14.6 16.5 19.79"></polyline><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                  coffee:
                    '<path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line>',
                  columns:
                    '<path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>',
                  command:
                    '<path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"></path>',
                  compass:
                    '<circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>',
                  copy: '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>',
                  "corner-down-left":
                    '<polyline points="9 10 4 15 9 20"></polyline><path d="M20 4v7a4 4 0 0 1-4 4H4"></path>',
                  "corner-down-right":
                    '<polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path>',
                  "corner-left-down":
                    '<polyline points="14 15 9 20 4 15"></polyline><path d="M20 4h-7a4 4 0 0 0-4 4v12"></path>',
                  "corner-left-up":
                    '<polyline points="14 9 9 4 4 9"></polyline><path d="M20 20h-7a4 4 0 0 1-4-4V4"></path>',
                  "corner-right-down":
                    '<polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>',
                  "corner-right-up":
                    '<polyline points="10 9 15 4 20 9"></polyline><path d="M4 20h7a4 4 0 0 0 4-4V4"></path>',
                  "corner-up-left":
                    '<polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>',
                  "corner-up-right":
                    '<polyline points="15 14 20 9 15 4"></polyline><path d="M4 20v-7a4 4 0 0 1 4-4h12"></path>',
                  cpu: '<rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line>',
                  "credit-card":
                    '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line>',
                  crop: '<path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path><path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>',
                  crosshair:
                    '<circle cx="12" cy="12" r="10"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line>',
                  database:
                    '<ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>',
                  delete:
                    '<path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line>',
                  disc: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="3"></circle>',
                  "divide-circle":
                    '<line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line><circle cx="12" cy="12" r="10"></circle>',
                  "divide-square":
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line>',
                  divide:
                    '<circle cx="12" cy="6" r="2"></circle><line x1="5" y1="12" x2="19" y2="12"></line><circle cx="12" cy="18" r="2"></circle>',
                  "dollar-sign":
                    '<line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>',
                  "download-cloud":
                    '<polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>',
                  download:
                    '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line>',
                  dribbble:
                    '<circle cx="12" cy="12" r="10"></circle><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"></path>',
                  droplet:
                    '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>',
                  "edit-2":
                    '<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>',
                  "edit-3":
                    '<path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>',
                  edit: '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>',
                  "external-link":
                    '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>',
                  "eye-off":
                    '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                  eye: '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>',
                  facebook:
                    '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>',
                  "fast-forward":
                    '<polygon points="13 19 22 12 13 5 13 19"></polygon><polygon points="2 19 11 12 2 5 2 19"></polygon>',
                  feather:
                    '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line>',
                  figma:
                    '<path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"></path><path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"></path><path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"></path><path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"></path><path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"></path>',
                  "file-minus":
                    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="9" y1="15" x2="15" y2="15"></line>',
                  "file-plus":
                    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line>',
                  "file-text":
                    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>',
                  file: '<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline>',
                  film: '<rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect><line x1="7" y1="2" x2="7" y2="22"></line><line x1="17" y1="2" x2="17" y2="22"></line><line x1="2" y1="12" x2="22" y2="12"></line><line x1="2" y1="7" x2="7" y2="7"></line><line x1="2" y1="17" x2="7" y2="17"></line><line x1="17" y1="17" x2="22" y2="17"></line><line x1="17" y1="7" x2="22" y2="7"></line>',
                  filter:
                    '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>',
                  flag: '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line>',
                  "folder-minus":
                    '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="9" y1="14" x2="15" y2="14"></line>',
                  "folder-plus":
                    '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="11" x2="12" y2="17"></line><line x1="9" y1="14" x2="15" y2="14"></line>',
                  folder:
                    '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>',
                  framer:
                    '<path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"></path>',
                  frown:
                    '<circle cx="12" cy="12" r="10"></circle><path d="M16 16s-1.5-2-4-2-4 2-4 2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                  gift: '<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>',
                  "git-branch":
                    '<line x1="6" y1="3" x2="6" y2="15"></line><circle cx="18" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><path d="M18 9a9 9 0 0 1-9 9"></path>',
                  "git-commit":
                    '<circle cx="12" cy="12" r="4"></circle><line x1="1.05" y1="12" x2="7" y2="12"></line><line x1="17.01" y1="12" x2="22.96" y2="12"></line>',
                  "git-merge":
                    '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M6 21V9a9 9 0 0 0 9 9"></path>',
                  "git-pull-request":
                    '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M13 6h3a2 2 0 0 1 2 2v7"></path><line x1="6" y1="9" x2="6" y2="21"></line>',
                  github:
                    '<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>',
                  gitlab:
                    '<path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"></path>',
                  globe:
                    '<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>',
                  grid: '<rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>',
                  "hard-drive":
                    '<line x1="22" y1="12" x2="2" y2="12"></line><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path><line x1="6" y1="16" x2="6.01" y2="16"></line><line x1="10" y1="16" x2="10.01" y2="16"></line>',
                  hash: '<line x1="4" y1="9" x2="20" y2="9"></line><line x1="4" y1="15" x2="20" y2="15"></line><line x1="10" y1="3" x2="8" y2="21"></line><line x1="16" y1="3" x2="14" y2="21"></line>',
                  headphones:
                    '<path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>',
                  heart:
                    '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>',
                  "help-circle":
                    '<circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>',
                  hexagon:
                    '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>',
                  home: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>',
                  image:
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>',
                  inbox:
                    '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>',
                  info: '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>',
                  instagram:
                    '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>',
                  italic:
                    '<line x1="19" y1="4" x2="10" y2="4"></line><line x1="14" y1="20" x2="5" y2="20"></line><line x1="15" y1="4" x2="9" y2="20"></line>',
                  key: '<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>',
                  layers:
                    '<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>',
                  layout:
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line>',
                  "life-buoy":
                    '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line><line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line><line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line><line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line><line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>',
                  "link-2":
                    '<path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"></path><line x1="8" y1="12" x2="16" y2="12"></line>',
                  link: '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>',
                  linkedin:
                    '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle>',
                  list: '<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>',
                  loader:
                    '<line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>',
                  lock: '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>',
                  "log-in":
                    '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line>',
                  "log-out":
                    '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>',
                  mail: '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>',
                  "map-pin":
                    '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>',
                  map: '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line>',
                  "maximize-2":
                    '<polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
                  maximize:
                    '<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>',
                  meh: '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="15" x2="16" y2="15"></line><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                  menu: '<line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>',
                  "message-circle":
                    '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>',
                  "message-square":
                    '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>',
                  "mic-off":
                    '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
                  mic: '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
                  "minimize-2":
                    '<polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
                  minimize:
                    '<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>',
                  "minus-circle":
                    '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line>',
                  "minus-square":
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line>',
                  minus: '<line x1="5" y1="12" x2="19" y2="12"></line>',
                  monitor:
                    '<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line>',
                  moon: '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>',
                  "more-horizontal":
                    '<circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle>',
                  "more-vertical":
                    '<circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle>',
                  "mouse-pointer":
                    '<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path><path d="M13 13l6 6"></path>',
                  move: '<polyline points="5 9 2 12 5 15"></polyline><polyline points="9 5 12 2 15 5"></polyline><polyline points="15 19 12 22 9 19"></polyline><polyline points="19 9 22 12 19 15"></polyline><line x1="2" y1="12" x2="22" y2="12"></line><line x1="12" y1="2" x2="12" y2="22"></line>',
                  music:
                    '<path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle>',
                  "navigation-2":
                    '<polygon points="12 2 19 21 12 17 5 21 12 2"></polygon>',
                  navigation:
                    '<polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>',
                  octagon:
                    '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>',
                  package:
                    '<line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                  paperclip:
                    '<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>',
                  "pause-circle":
                    '<circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line>',
                  pause:
                    '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>',
                  "pen-tool":
                    '<path d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path><path d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle>',
                  percent:
                    '<line x1="19" y1="5" x2="5" y2="19"></line><circle cx="6.5" cy="6.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle>',
                  "phone-call":
                    '<path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  "phone-forwarded":
                    '<polyline points="19 1 23 5 19 9"></polyline><line x1="15" y1="5" x2="23" y2="5"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  "phone-incoming":
                    '<polyline points="16 2 16 8 22 8"></polyline><line x1="23" y1="1" x2="16" y2="8"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  "phone-missed":
                    '<line x1="23" y1="1" x2="17" y2="7"></line><line x1="17" y1="1" x2="23" y2="7"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  "phone-off":
                    '<path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="23" y1="1" x2="1" y2="23"></line>',
                  "phone-outgoing":
                    '<polyline points="23 7 23 1 17 1"></polyline><line x1="16" y1="8" x2="23" y2="1"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  phone:
                    '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  "pie-chart":
                    '<path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path>',
                  "play-circle":
                    '<circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon>',
                  play: '<polygon points="5 3 19 12 5 21 5 3"></polygon>',
                  "plus-circle":
                    '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
                  "plus-square":
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
                  plus: '<line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>',
                  pocket:
                    '<path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path><polyline points="8 10 12 14 16 10"></polyline>',
                  power:
                    '<path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line>',
                  printer:
                    '<polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect>',
                  radio:
                    '<circle cx="12" cy="12" r="2"></circle><path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>',
                  "refresh-ccw":
                    '<polyline points="1 4 1 10 7 10"></polyline><polyline points="23 20 23 14 17 14"></polyline><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>',
                  "refresh-cw":
                    '<polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>',
                  repeat:
                    '<polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path>',
                  rewind:
                    '<polygon points="11 19 2 12 11 5 11 19"></polygon><polygon points="22 19 13 12 22 5 22 19"></polygon>',
                  "rotate-ccw":
                    '<polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>',
                  "rotate-cw":
                    '<polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>',
                  rss: '<path d="M4 11a9 9 0 0 1 9 9"></path><path d="M4 4a16 16 0 0 1 16 16"></path><circle cx="5" cy="19" r="1"></circle>',
                  save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline>',
                  scissors:
                    '<circle cx="6" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><line x1="20" y1="4" x2="8.12" y2="15.88"></line><line x1="14.47" y1="14.48" x2="20" y2="20"></line><line x1="8.12" y1="8.12" x2="12" y2="12"></line>',
                  search:
                    '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>',
                  send: '<line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>',
                  server:
                    '<rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line>',
                  settings:
                    '<circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>',
                  "share-2":
                    '<circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>',
                  share:
                    '<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line>',
                  "shield-off":
                    '<path d="M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"></path><path d="M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                  shield:
                    '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>',
                  "shopping-bag":
                    '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path>',
                  "shopping-cart":
                    '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>',
                  shuffle:
                    '<polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line>',
                  sidebar:
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line>',
                  "skip-back":
                    '<polygon points="19 20 9 12 19 4 19 20"></polygon><line x1="5" y1="19" x2="5" y2="5"></line>',
                  "skip-forward":
                    '<polygon points="5 4 15 12 5 20 5 4"></polygon><line x1="19" y1="5" x2="19" y2="19"></line>',
                  slack:
                    '<path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path><path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path><path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path><path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path><path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path><path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path><path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path><path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>',
                  slash:
                    '<circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>',
                  sliders:
                    '<line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line>',
                  smartphone:
                    '<rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
                  smile:
                    '<circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                  speaker:
                    '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><circle cx="12" cy="14" r="4"></circle><line x1="12" y1="6" x2="12.01" y2="6"></line>',
                  square:
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>',
                  star: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>',
                  "stop-circle":
                    '<circle cx="12" cy="12" r="10"></circle><rect x="9" y="9" width="6" height="6"></rect>',
                  sun: '<circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>',
                  sunrise:
                    '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="2" x2="12" y2="9"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="8 6 12 2 16 6"></polyline>',
                  sunset:
                    '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="9" x2="12" y2="2"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="16 5 12 9 8 5"></polyline>',
                  tablet:
                    '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
                  tag: '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>',
                  target:
                    '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>',
                  terminal:
                    '<polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line>',
                  thermometer:
                    '<path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path>',
                  "thumbs-down":
                    '<path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path>',
                  "thumbs-up":
                    '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>',
                  "toggle-left":
                    '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="8" cy="12" r="3"></circle>',
                  "toggle-right":
                    '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>',
                  tool: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>',
                  "trash-2":
                    '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>',
                  trash:
                    '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>',
                  trello:
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><rect x="7" y="7" width="3" height="9"></rect><rect x="14" y="7" width="3" height="5"></rect>',
                  "trending-down":
                    '<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline><polyline points="17 18 23 18 23 12"></polyline>',
                  "trending-up":
                    '<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline>',
                  triangle:
                    '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>',
                  truck:
                    '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>',
                  tv: '<rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><polyline points="17 2 12 7 7 2"></polyline>',
                  twitch:
                    '<path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"></path>',
                  twitter:
                    '<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>',
                  type: '<polyline points="4 7 4 4 20 4 20 7"></polyline><line x1="9" y1="20" x2="15" y2="20"></line><line x1="12" y1="4" x2="12" y2="20"></line>',
                  umbrella:
                    '<path d="M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"></path>',
                  underline:
                    '<path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path><line x1="4" y1="21" x2="20" y2="21"></line>',
                  unlock:
                    '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path>',
                  "upload-cloud":
                    '<polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline>',
                  upload:
                    '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line>',
                  "user-check":
                    '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline>',
                  "user-minus":
                    '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="23" y1="11" x2="17" y2="11"></line>',
                  "user-plus":
                    '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line>',
                  "user-x":
                    '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="18" y1="8" x2="23" y2="13"></line><line x1="23" y1="8" x2="18" y2="13"></line>',
                  user: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>',
                  users:
                    '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>',
                  "video-off":
                    '<path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                  video:
                    '<polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>',
                  voicemail:
                    '<circle cx="5.5" cy="11.5" r="4.5"></circle><circle cx="18.5" cy="11.5" r="4.5"></circle><line x1="5.5" y1="16" x2="18.5" y2="16"></line>',
                  "volume-1":
                    '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
                  "volume-2":
                    '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
                  "volume-x":
                    '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>',
                  volume:
                    '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>',
                  watch:
                    '<circle cx="12" cy="12" r="7"></circle><polyline points="12 9 12 12 13.5 13.5"></polyline><path d="M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"></path>',
                  "wifi-off":
                    '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path><path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
                  wifi: '<path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
                  wind: '<path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"></path>',
                  "x-circle":
                    '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
                  "x-octagon":
                    '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
                  "x-square":
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line>',
                  x: '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>',
                  youtube:
                    '<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>',
                  "zap-off":
                    '<polyline points="12.41 6.75 13 2 10.57 4.92"></polyline><polyline points="18.57 12.91 21 10 15.66 10"></polyline><polyline points="8 8 3 14 12 14 11 22 16 16"></polyline><line x1="1" y1="1" x2="23" y2="23"></line>',
                  zap: '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>',
                  "zoom-in":
                    '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line>',
                  "zoom-out":
                    '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line>',
                };

                /***/
              },

            /***/ "./node_modules/classnames/dedupe.js":
              /*!*******************************************!*\
  !*** ./node_modules/classnames/dedupe.js ***!
  \*******************************************/
              /*! no static exports found */
              /***/ function (module, exports, __webpack_require__) {
                var __WEBPACK_AMD_DEFINE_ARRAY__,
                  __WEBPACK_AMD_DEFINE_RESULT__; /*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
                /* global define */

                (function () {
                  "use strict";

                  var classNames = (function () {
                    // don't inherit from Object so we can skip hasOwnProperty check later
                    // http://stackoverflow.com/questions/15518328/creating-js-object-with-object-createnull#answer-21079232
                    function StorageObject() {}
                    StorageObject.prototype = Object.create(null);

                    function _parseArray(resultSet, array) {
                      var length = array.length;

                      for (var i = 0; i < length; ++i) {
                        _parse(resultSet, array[i]);
                      }
                    }

                    var hasOwn = {}.hasOwnProperty;

                    function _parseNumber(resultSet, num) {
                      resultSet[num] = true;
                    }

                    function _parseObject(resultSet, object) {
                      for (var k in object) {
                        if (hasOwn.call(object, k)) {
                          // set value to false instead of deleting it to avoid changing object structure
                          // https://www.smashingmagazine.com/2012/11/writing-fast-memory-efficient-javascript/#de-referencing-misconceptions
                          resultSet[k] = !!object[k];
                        }
                      }
                    }

                    var SPACE = /\s+/;
                    function _parseString(resultSet, str) {
                      var array = str.split(SPACE);
                      var length = array.length;

                      for (var i = 0; i < length; ++i) {
                        resultSet[array[i]] = true;
                      }
                    }

                    function _parse(resultSet, arg) {
                      if (!arg) return;
                      var argType = typeof arg;

                      // 'foo bar'
                      if (argType === "string") {
                        _parseString(resultSet, arg);

                        // ['foo', 'bar', ...]
                      } else if (Array.isArray(arg)) {
                        _parseArray(resultSet, arg);

                        // { 'foo': true, ... }
                      } else if (argType === "object") {
                        _parseObject(resultSet, arg);

                        // '130'
                      } else if (argType === "number") {
                        _parseNumber(resultSet, arg);
                      }
                    }

                    function _classNames() {
                      // don't leak arguments
                      // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                      var len = arguments.length;
                      var args = Array(len);
                      for (var i = 0; i < len; i++) {
                        args[i] = arguments[i];
                      }

                      var classSet = new StorageObject();
                      _parseArray(classSet, args);

                      var list = [];

                      for (var k in classSet) {
                        if (classSet[k]) {
                          list.push(k);
                        }
                      }

                      return list.join(" ");
                    }

                    return _classNames;
                  })();

                  if (typeof module !== "undefined" && module.exports) {
                    module.exports = classNames;
                  } else if (true) {
                    // register as 'classnames', consistent with npm package name
                    !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
                    (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                      return classNames;
                    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
                      (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                  } else {
                  }
                })();

                /***/
              },

            /***/ "./node_modules/core-js/es/array/from.js":
              /*!***********************************************!*\
  !*** ./node_modules/core-js/es/array/from.js ***!
  \***********************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_63153__
              ) {
                __nested_webpack_require_63153__(
                  /*! ../../modules/es.string.iterator */ "./node_modules/core-js/modules/es.string.iterator.js"
                );
                __nested_webpack_require_63153__(
                  /*! ../../modules/es.array.from */ "./node_modules/core-js/modules/es.array.from.js"
                );
                var path = __nested_webpack_require_63153__(
                  /*! ../../internals/path */ "./node_modules/core-js/internals/path.js"
                );

                module.exports = path.Array.from;

                /***/
              },

            /***/ "./node_modules/core-js/internals/a-function.js":
              /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/a-function.js ***!
  \******************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                module.exports = function (it) {
                  if (typeof it != "function") {
                    throw TypeError(String(it) + " is not a function");
                  }
                  return it;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/an-object.js":
              /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/an-object.js ***!
  \*****************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_64303__
              ) {
                var isObject = __nested_webpack_require_64303__(
                  /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
                );

                module.exports = function (it) {
                  if (!isObject(it)) {
                    throw TypeError(String(it) + " is not an object");
                  }
                  return it;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/array-from.js":
              /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/array-from.js ***!
  \******************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_64884__
              ) {
                "use strict";

                var bind = __nested_webpack_require_64884__(
                  /*! ../internals/bind-context */ "./node_modules/core-js/internals/bind-context.js"
                );
                var toObject = __nested_webpack_require_64884__(
                  /*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js"
                );
                var callWithSafeIterationClosing =
                  __nested_webpack_require_64884__(
                    /*! ../internals/call-with-safe-iteration-closing */ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js"
                  );
                var isArrayIteratorMethod = __nested_webpack_require_64884__(
                  /*! ../internals/is-array-iterator-method */ "./node_modules/core-js/internals/is-array-iterator-method.js"
                );
                var toLength = __nested_webpack_require_64884__(
                  /*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js"
                );
                var createProperty = __nested_webpack_require_64884__(
                  /*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js"
                );
                var getIteratorMethod = __nested_webpack_require_64884__(
                  /*! ../internals/get-iterator-method */ "./node_modules/core-js/internals/get-iterator-method.js"
                );

                // `Array.from` method
                // https://tc39.github.io/ecma262/#sec-array.from
                module.exports = function from(
                  arrayLike /* , mapfn = undefined, thisArg = undefined */
                ) {
                  var O = toObject(arrayLike);
                  var C = typeof this == "function" ? this : Array;
                  var argumentsLength = arguments.length;
                  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
                  var mapping = mapfn !== undefined;
                  var index = 0;
                  var iteratorMethod = getIteratorMethod(O);
                  var length, result, step, iterator;
                  if (mapping)
                    mapfn = bind(
                      mapfn,
                      argumentsLength > 2 ? arguments[2] : undefined,
                      2
                    );
                  // if the target is not iterable or it's an array with the default iterator - use a simple case
                  if (
                    iteratorMethod != undefined &&
                    !(C == Array && isArrayIteratorMethod(iteratorMethod))
                  ) {
                    iterator = iteratorMethod.call(O);
                    result = new C();
                    for (; !(step = iterator.next()).done; index++) {
                      createProperty(
                        result,
                        index,
                        mapping
                          ? callWithSafeIterationClosing(
                              iterator,
                              mapfn,
                              [step.value, index],
                              true
                            )
                          : step.value
                      );
                    }
                  } else {
                    length = toLength(O.length);
                    result = new C(length);
                    for (; length > index; index++) {
                      createProperty(
                        result,
                        index,
                        mapping ? mapfn(O[index], index) : O[index]
                      );
                    }
                  }
                  result.length = index;
                  return result;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/array-includes.js":
              /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/array-includes.js ***!
  \**********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_67506__
              ) {
                var toIndexedObject = __nested_webpack_require_67506__(
                  /*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js"
                );
                var toLength = __nested_webpack_require_67506__(
                  /*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js"
                );
                var toAbsoluteIndex = __nested_webpack_require_67506__(
                  /*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js"
                );

                // `Array.prototype.{ indexOf, includes }` methods implementation
                // false -> Array#indexOf
                // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
                // true  -> Array#includes
                // https://tc39.github.io/ecma262/#sec-array.prototype.includes
                module.exports = function (IS_INCLUDES) {
                  return function ($this, el, fromIndex) {
                    var O = toIndexedObject($this);
                    var length = toLength(O.length);
                    var index = toAbsoluteIndex(fromIndex, length);
                    var value;
                    // Array#includes uses SameValueZero equality algorithm
                    // eslint-disable-next-line no-self-compare
                    if (IS_INCLUDES && el != el)
                      while (length > index) {
                        value = O[index++];
                        // eslint-disable-next-line no-self-compare
                        if (value != value) return true;
                        // Array#indexOf ignores holes, Array#includes - not
                      }
                    else
                      for (; length > index; index++)
                        if (IS_INCLUDES || index in O) {
                          if (O[index] === el) return IS_INCLUDES || index || 0;
                        }
                    return !IS_INCLUDES && -1;
                  };
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/bind-context.js":
              /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/bind-context.js ***!
  \********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_69228__
              ) {
                var aFunction = __nested_webpack_require_69228__(
                  /*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js"
                );

                // optional / simple context binding
                module.exports = function (fn, that, length) {
                  aFunction(fn);
                  if (that === undefined) return fn;
                  switch (length) {
                    case 0:
                      return function () {
                        return fn.call(that);
                      };
                    case 1:
                      return function (a) {
                        return fn.call(that, a);
                      };
                    case 2:
                      return function (a, b) {
                        return fn.call(that, a, b);
                      };
                    case 3:
                      return function (a, b, c) {
                        return fn.call(that, a, b, c);
                      };
                  }
                  return function (/* ...args */) {
                    return fn.apply(that, arguments);
                  };
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/call-with-safe-iteration-closing.js":
              /*!****************************************************************************!*\
  !*** ./node_modules/core-js/internals/call-with-safe-iteration-closing.js ***!
  \****************************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_70317__
              ) {
                var anObject = __nested_webpack_require_70317__(
                  /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
                );

                // call something on iterator step with safe closing on error
                module.exports = function (iterator, fn, value, ENTRIES) {
                  try {
                    return ENTRIES
                      ? fn(anObject(value)[0], value[1])
                      : fn(value);
                    // 7.4.6 IteratorClose(iterator, completion)
                  } catch (error) {
                    var returnMethod = iterator["return"];
                    if (returnMethod !== undefined)
                      anObject(returnMethod.call(iterator));
                    throw error;
                  }
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/check-correctness-of-iteration.js":
              /*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/check-correctness-of-iteration.js ***!
  \**************************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_71254__
              ) {
                var wellKnownSymbol = __nested_webpack_require_71254__(
                  /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
                );

                var ITERATOR = wellKnownSymbol("iterator");
                var SAFE_CLOSING = false;

                try {
                  var called = 0;
                  var iteratorWithReturn = {
                    next: function () {
                      return { done: !!called++ };
                    },
                    return: function () {
                      SAFE_CLOSING = true;
                    },
                  };
                  iteratorWithReturn[ITERATOR] = function () {
                    return this;
                  };
                  // eslint-disable-next-line no-throw-literal
                  Array.from(iteratorWithReturn, function () {
                    throw 2;
                  });
                } catch (error) {
                  /* empty */
                }

                module.exports = function (exec, SKIP_CLOSING) {
                  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
                  var ITERATION_SUPPORT = false;
                  try {
                    var object = {};
                    object[ITERATOR] = function () {
                      return {
                        next: function () {
                          return { done: (ITERATION_SUPPORT = true) };
                        },
                      };
                    };
                    exec(object);
                  } catch (error) {
                    /* empty */
                  }
                  return ITERATION_SUPPORT;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/classof-raw.js":
              /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/classof-raw.js ***!
  \*******************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                var toString = {}.toString;

                module.exports = function (it) {
                  return toString.call(it).slice(8, -1);
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/classof.js":
              /*!***************************************************!*\
  !*** ./node_modules/core-js/internals/classof.js ***!
  \***************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_73012__
              ) {
                var classofRaw = __nested_webpack_require_73012__(
                  /*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js"
                );
                var wellKnownSymbol = __nested_webpack_require_73012__(
                  /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
                );

                var TO_STRING_TAG = wellKnownSymbol("toStringTag");
                // ES3 wrong here
                var CORRECT_ARGUMENTS =
                  classofRaw(
                    (function () {
                      return arguments;
                    })()
                  ) == "Arguments";

                // fallback for IE11 Script Access Denied error
                var tryGet = function (it, key) {
                  try {
                    return it[key];
                  } catch (error) {
                    /* empty */
                  }
                };

                // getting tag from ES6+ `Object.prototype.toString`
                module.exports = function (it) {
                  var O, tag, result;
                  return it === undefined
                    ? "Undefined"
                    : it === null
                    ? "Null"
                    : // @@toStringTag case
                    typeof (tag = tryGet((O = Object(it)), TO_STRING_TAG)) ==
                      "string"
                    ? tag
                    : // builtinTag case
                    CORRECT_ARGUMENTS
                    ? classofRaw(O)
                    : // ES3 arguments fallback
                    (result = classofRaw(O)) == "Object" &&
                      typeof O.callee == "function"
                    ? "Arguments"
                    : result;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/copy-constructor-properties.js":
              /*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/copy-constructor-properties.js ***!
  \***********************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_74453__
              ) {
                var has = __nested_webpack_require_74453__(
                  /*! ../internals/has */ "./node_modules/core-js/internals/has.js"
                );
                var ownKeys = __nested_webpack_require_74453__(
                  /*! ../internals/own-keys */ "./node_modules/core-js/internals/own-keys.js"
                );
                var getOwnPropertyDescriptorModule =
                  __nested_webpack_require_74453__(
                    /*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
                  );
                var definePropertyModule = __nested_webpack_require_74453__(
                  /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
                );

                module.exports = function (target, source) {
                  var keys = ownKeys(source);
                  var defineProperty = definePropertyModule.f;
                  var getOwnPropertyDescriptor =
                    getOwnPropertyDescriptorModule.f;
                  for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    if (!has(target, key))
                      defineProperty(
                        target,
                        key,
                        getOwnPropertyDescriptor(source, key)
                      );
                  }
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/correct-prototype-getter.js":
              /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/correct-prototype-getter.js ***!
  \********************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_75752__
              ) {
                var fails = __nested_webpack_require_75752__(
                  /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
                );

                module.exports = !fails(function () {
                  function F() {
                    /* empty */
                  }
                  F.prototype.constructor = null;
                  return Object.getPrototypeOf(new F()) !== F.prototype;
                });

                /***/
              },

            /***/ "./node_modules/core-js/internals/create-iterator-constructor.js":
              /*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-iterator-constructor.js ***!
  \***********************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_76425__
              ) {
                "use strict";

                var IteratorPrototype = __nested_webpack_require_76425__(
                  /*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js"
                ).IteratorPrototype;
                var create = __nested_webpack_require_76425__(
                  /*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js"
                );
                var createPropertyDescriptor = __nested_webpack_require_76425__(
                  /*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js"
                );
                var setToStringTag = __nested_webpack_require_76425__(
                  /*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js"
                );
                var Iterators = __nested_webpack_require_76425__(
                  /*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js"
                );

                var returnThis = function () {
                  return this;
                };

                module.exports = function (IteratorConstructor, NAME, next) {
                  var TO_STRING_TAG = NAME + " Iterator";
                  IteratorConstructor.prototype = create(IteratorPrototype, {
                    next: createPropertyDescriptor(1, next),
                  });
                  setToStringTag(
                    IteratorConstructor,
                    TO_STRING_TAG,
                    false,
                    true
                  );
                  Iterators[TO_STRING_TAG] = returnThis;
                  return IteratorConstructor;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/create-property-descriptor.js":
              /*!**********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-property-descriptor.js ***!
  \**********************************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                module.exports = function (bitmap, value) {
                  return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value: value,
                  };
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/create-property.js":
              /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/create-property.js ***!
  \***********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_78439__
              ) {
                "use strict";

                var toPrimitive = __nested_webpack_require_78439__(
                  /*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js"
                );
                var definePropertyModule = __nested_webpack_require_78439__(
                  /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
                );
                var createPropertyDescriptor = __nested_webpack_require_78439__(
                  /*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js"
                );

                module.exports = function (object, key, value) {
                  var propertyKey = toPrimitive(key);
                  if (propertyKey in object)
                    definePropertyModule.f(
                      object,
                      propertyKey,
                      createPropertyDescriptor(0, value)
                    );
                  else object[propertyKey] = value;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/define-iterator.js":
              /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/define-iterator.js ***!
  \***********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_79489__
              ) {
                "use strict";

                var $ = __nested_webpack_require_79489__(
                  /*! ../internals/export */ "./node_modules/core-js/internals/export.js"
                );
                var createIteratorConstructor =
                  __nested_webpack_require_79489__(
                    /*! ../internals/create-iterator-constructor */ "./node_modules/core-js/internals/create-iterator-constructor.js"
                  );
                var getPrototypeOf = __nested_webpack_require_79489__(
                  /*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js"
                );
                var setPrototypeOf = __nested_webpack_require_79489__(
                  /*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js"
                );
                var setToStringTag = __nested_webpack_require_79489__(
                  /*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js"
                );
                var hide = __nested_webpack_require_79489__(
                  /*! ../internals/hide */ "./node_modules/core-js/internals/hide.js"
                );
                var redefine = __nested_webpack_require_79489__(
                  /*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js"
                );
                var wellKnownSymbol = __nested_webpack_require_79489__(
                  /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
                );
                var IS_PURE = __nested_webpack_require_79489__(
                  /*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js"
                );
                var Iterators = __nested_webpack_require_79489__(
                  /*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js"
                );
                var IteratorsCore = __nested_webpack_require_79489__(
                  /*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js"
                );

                var IteratorPrototype = IteratorsCore.IteratorPrototype;
                var BUGGY_SAFARI_ITERATORS =
                  IteratorsCore.BUGGY_SAFARI_ITERATORS;
                var ITERATOR = wellKnownSymbol("iterator");
                var KEYS = "keys";
                var VALUES = "values";
                var ENTRIES = "entries";

                var returnThis = function () {
                  return this;
                };

                module.exports = function (
                  Iterable,
                  NAME,
                  IteratorConstructor,
                  next,
                  DEFAULT,
                  IS_SET,
                  FORCED
                ) {
                  createIteratorConstructor(IteratorConstructor, NAME, next);

                  var getIterationMethod = function (KIND) {
                    if (KIND === DEFAULT && defaultIterator)
                      return defaultIterator;
                    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype)
                      return IterablePrototype[KIND];
                    switch (KIND) {
                      case KEYS:
                        return function keys() {
                          return new IteratorConstructor(this, KIND);
                        };
                      case VALUES:
                        return function values() {
                          return new IteratorConstructor(this, KIND);
                        };
                      case ENTRIES:
                        return function entries() {
                          return new IteratorConstructor(this, KIND);
                        };
                    }
                    return function () {
                      return new IteratorConstructor(this);
                    };
                  };

                  var TO_STRING_TAG = NAME + " Iterator";
                  var INCORRECT_VALUES_NAME = false;
                  var IterablePrototype = Iterable.prototype;
                  var nativeIterator =
                    IterablePrototype[ITERATOR] ||
                    IterablePrototype["@@iterator"] ||
                    (DEFAULT && IterablePrototype[DEFAULT]);
                  var defaultIterator =
                    (!BUGGY_SAFARI_ITERATORS && nativeIterator) ||
                    getIterationMethod(DEFAULT);
                  var anyNativeIterator =
                    NAME == "Array"
                      ? IterablePrototype.entries || nativeIterator
                      : nativeIterator;
                  var CurrentIteratorPrototype, methods, KEY;

                  // fix native
                  if (anyNativeIterator) {
                    CurrentIteratorPrototype = getPrototypeOf(
                      anyNativeIterator.call(new Iterable())
                    );
                    if (
                      IteratorPrototype !== Object.prototype &&
                      CurrentIteratorPrototype.next
                    ) {
                      if (
                        !IS_PURE &&
                        getPrototypeOf(CurrentIteratorPrototype) !==
                          IteratorPrototype
                      ) {
                        if (setPrototypeOf) {
                          setPrototypeOf(
                            CurrentIteratorPrototype,
                            IteratorPrototype
                          );
                        } else if (
                          typeof CurrentIteratorPrototype[ITERATOR] !=
                          "function"
                        ) {
                          hide(CurrentIteratorPrototype, ITERATOR, returnThis);
                        }
                      }
                      // Set @@toStringTag to native iterators
                      setToStringTag(
                        CurrentIteratorPrototype,
                        TO_STRING_TAG,
                        true,
                        true
                      );
                      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
                    }
                  }

                  // fix Array#{values, @@iterator}.name in V8 / FF
                  if (
                    DEFAULT == VALUES &&
                    nativeIterator &&
                    nativeIterator.name !== VALUES
                  ) {
                    INCORRECT_VALUES_NAME = true;
                    defaultIterator = function values() {
                      return nativeIterator.call(this);
                    };
                  }

                  // define iterator
                  if (
                    (!IS_PURE || FORCED) &&
                    IterablePrototype[ITERATOR] !== defaultIterator
                  ) {
                    hide(IterablePrototype, ITERATOR, defaultIterator);
                  }
                  Iterators[NAME] = defaultIterator;

                  // export additional methods
                  if (DEFAULT) {
                    methods = {
                      values: getIterationMethod(VALUES),
                      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                      entries: getIterationMethod(ENTRIES),
                    };
                    if (FORCED)
                      for (KEY in methods) {
                        if (
                          BUGGY_SAFARI_ITERATORS ||
                          INCORRECT_VALUES_NAME ||
                          !(KEY in IterablePrototype)
                        ) {
                          redefine(IterablePrototype, KEY, methods[KEY]);
                        }
                      }
                    else
                      $(
                        {
                          target: NAME,
                          proto: true,
                          forced:
                            BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME,
                        },
                        methods
                      );
                  }

                  return methods;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/descriptors.js":
              /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/descriptors.js ***!
  \*******************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_84548__
              ) {
                var fails = __nested_webpack_require_84548__(
                  /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
                );

                // Thank's IE8 for his funny defineProperty
                module.exports = !fails(function () {
                  return (
                    Object.defineProperty({}, "a", {
                      get: function () {
                        return 7;
                      },
                    }).a != 7
                  );
                });

                /***/
              },

            /***/ "./node_modules/core-js/internals/document-create-element.js":
              /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/document-create-element.js ***!
  \*******************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_85211__
              ) {
                var global = __nested_webpack_require_85211__(
                  /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
                );
                var isObject = __nested_webpack_require_85211__(
                  /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
                );

                var document = global.document;
                // typeof document.createElement is 'object' in old IE
                var exist =
                  isObject(document) && isObject(document.createElement);

                module.exports = function (it) {
                  return exist ? document.createElement(it) : {};
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/enum-bug-keys.js":
              /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/enum-bug-keys.js ***!
  \*********************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                // IE8- don't enum bug keys
                module.exports = [
                  "constructor",
                  "hasOwnProperty",
                  "isPrototypeOf",
                  "propertyIsEnumerable",
                  "toLocaleString",
                  "toString",
                  "valueOf",
                ];

                /***/
              },

            /***/ "./node_modules/core-js/internals/export.js":
              /*!**************************************************!*\
  !*** ./node_modules/core-js/internals/export.js ***!
  \**************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_86501__
              ) {
                var global = __nested_webpack_require_86501__(
                  /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
                );
                var getOwnPropertyDescriptor = __nested_webpack_require_86501__(
                  /*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
                ).f;
                var hide = __nested_webpack_require_86501__(
                  /*! ../internals/hide */ "./node_modules/core-js/internals/hide.js"
                );
                var redefine = __nested_webpack_require_86501__(
                  /*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js"
                );
                var setGlobal = __nested_webpack_require_86501__(
                  /*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js"
                );
                var copyConstructorProperties =
                  __nested_webpack_require_86501__(
                    /*! ../internals/copy-constructor-properties */ "./node_modules/core-js/internals/copy-constructor-properties.js"
                  );
                var isForced = __nested_webpack_require_86501__(
                  /*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js"
                );

                /*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
                module.exports = function (options, source) {
                  var TARGET = options.target;
                  var GLOBAL = options.global;
                  var STATIC = options.stat;
                  var FORCED,
                    target,
                    key,
                    targetProperty,
                    sourceProperty,
                    descriptor;
                  if (GLOBAL) {
                    target = global;
                  } else if (STATIC) {
                    target = global[TARGET] || setGlobal(TARGET, {});
                  } else {
                    target = (global[TARGET] || {}).prototype;
                  }
                  if (target)
                    for (key in source) {
                      sourceProperty = source[key];
                      if (options.noTargetGet) {
                        descriptor = getOwnPropertyDescriptor(target, key);
                        targetProperty = descriptor && descriptor.value;
                      } else targetProperty = target[key];
                      FORCED = isForced(
                        GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key,
                        options.forced
                      );
                      // contained in target
                      if (!FORCED && targetProperty !== undefined) {
                        if (typeof sourceProperty === typeof targetProperty)
                          continue;
                        copyConstructorProperties(
                          sourceProperty,
                          targetProperty
                        );
                      }
                      // add a flag to not completely full polyfills
                      if (
                        options.sham ||
                        (targetProperty && targetProperty.sham)
                      ) {
                        hide(sourceProperty, "sham", true);
                      }
                      // extend global
                      redefine(target, key, sourceProperty, options);
                    }
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/fails.js":
              /*!*************************************************!*\
  !*** ./node_modules/core-js/internals/fails.js ***!
  \*************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                module.exports = function (exec) {
                  try {
                    return !!exec();
                  } catch (error) {
                    return true;
                  }
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/function-to-string.js":
              /*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/function-to-string.js ***!
  \**************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_90209__
              ) {
                var shared = __nested_webpack_require_90209__(
                  /*! ../internals/shared */ "./node_modules/core-js/internals/shared.js"
                );

                module.exports = shared(
                  "native-function-to-string",
                  Function.toString
                );

                /***/
              },

            /***/ "./node_modules/core-js/internals/get-iterator-method.js":
              /*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/get-iterator-method.js ***!
  \***************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_90762__
              ) {
                var classof = __nested_webpack_require_90762__(
                  /*! ../internals/classof */ "./node_modules/core-js/internals/classof.js"
                );
                var Iterators = __nested_webpack_require_90762__(
                  /*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js"
                );
                var wellKnownSymbol = __nested_webpack_require_90762__(
                  /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
                );

                var ITERATOR = wellKnownSymbol("iterator");

                module.exports = function (it) {
                  if (it != undefined)
                    return (
                      it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)]
                    );
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/global.js":
              /*!**************************************************!*\
  !*** ./node_modules/core-js/internals/global.js ***!
  \**************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_91626__
              ) {
                /* WEBPACK VAR INJECTION */ (function (global) {
                  var O = "object";
                  var check = function (it) {
                    return it && it.Math == Math && it;
                  };

                  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
                  module.exports =
                    // eslint-disable-next-line no-undef
                    check(typeof globalThis == O && globalThis) ||
                    check(typeof window == O && window) ||
                    check(typeof self == O && self) ||
                    check(typeof global == O && global) ||
                    // eslint-disable-next-line no-new-func
                    Function("return this")();

                  /* WEBPACK VAR INJECTION */
                }).call(
                  this,
                  __nested_webpack_require_91626__(
                    /*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"
                  )
                );

                /***/
              },

            /***/ "./node_modules/core-js/internals/has.js":
              /*!***********************************************!*\
  !*** ./node_modules/core-js/internals/has.js ***!
  \***********************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                var hasOwnProperty = {}.hasOwnProperty;

                module.exports = function (it, key) {
                  return hasOwnProperty.call(it, key);
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/hidden-keys.js":
              /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/hidden-keys.js ***!
  \*******************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                module.exports = {};

                /***/
              },

            /***/ "./node_modules/core-js/internals/hide.js":
              /*!************************************************!*\
  !*** ./node_modules/core-js/internals/hide.js ***!
  \************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_93334__
              ) {
                var DESCRIPTORS = __nested_webpack_require_93334__(
                  /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
                );
                var definePropertyModule = __nested_webpack_require_93334__(
                  /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
                );
                var createPropertyDescriptor = __nested_webpack_require_93334__(
                  /*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js"
                );

                module.exports = DESCRIPTORS
                  ? function (object, key, value) {
                      return definePropertyModule.f(
                        object,
                        key,
                        createPropertyDescriptor(1, value)
                      );
                    }
                  : function (object, key, value) {
                      object[key] = value;
                      return object;
                    };

                /***/
              },

            /***/ "./node_modules/core-js/internals/html.js":
              /*!************************************************!*\
  !*** ./node_modules/core-js/internals/html.js ***!
  \************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_94311__
              ) {
                var global = __nested_webpack_require_94311__(
                  /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
                );

                var document = global.document;

                module.exports = document && document.documentElement;

                /***/
              },

            /***/ "./node_modules/core-js/internals/ie8-dom-define.js":
              /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/ie8-dom-define.js ***!
  \**********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_94859__
              ) {
                var DESCRIPTORS = __nested_webpack_require_94859__(
                  /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
                );
                var fails = __nested_webpack_require_94859__(
                  /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
                );
                var createElement = __nested_webpack_require_94859__(
                  /*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js"
                );

                // Thank's IE8 for his funny defineProperty
                module.exports =
                  !DESCRIPTORS &&
                  !fails(function () {
                    return (
                      Object.defineProperty(createElement("div"), "a", {
                        get: function () {
                          return 7;
                        },
                      }).a != 7
                    );
                  });

                /***/
              },

            /***/ "./node_modules/core-js/internals/indexed-object.js":
              /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/indexed-object.js ***!
  \**********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_95796__
              ) {
                // fallback for non-array-like ES3 and non-enumerable old V8 strings
                var fails = __nested_webpack_require_95796__(
                  /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
                );
                var classof = __nested_webpack_require_95796__(
                  /*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js"
                );

                var split = "".split;

                module.exports = fails(function () {
                  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
                  // eslint-disable-next-line no-prototype-builtins
                  return !Object("z").propertyIsEnumerable(0);
                })
                  ? function (it) {
                      return classof(it) == "String"
                        ? split.call(it, "")
                        : Object(it);
                    }
                  : Object;

                /***/
              },

            /***/ "./node_modules/core-js/internals/internal-state.js":
              /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/internal-state.js ***!
  \**********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_96779__
              ) {
                var NATIVE_WEAK_MAP = __nested_webpack_require_96779__(
                  /*! ../internals/native-weak-map */ "./node_modules/core-js/internals/native-weak-map.js"
                );
                var global = __nested_webpack_require_96779__(
                  /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
                );
                var isObject = __nested_webpack_require_96779__(
                  /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
                );
                var hide = __nested_webpack_require_96779__(
                  /*! ../internals/hide */ "./node_modules/core-js/internals/hide.js"
                );
                var objectHas = __nested_webpack_require_96779__(
                  /*! ../internals/has */ "./node_modules/core-js/internals/has.js"
                );
                var sharedKey = __nested_webpack_require_96779__(
                  /*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js"
                );
                var hiddenKeys = __nested_webpack_require_96779__(
                  /*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js"
                );

                var WeakMap = global.WeakMap;
                var set, get, has;

                var enforce = function (it) {
                  return has(it) ? get(it) : set(it, {});
                };

                var getterFor = function (TYPE) {
                  return function (it) {
                    var state;
                    if (!isObject(it) || (state = get(it)).type !== TYPE) {
                      throw TypeError(
                        "Incompatible receiver, " + TYPE + " required"
                      );
                    }
                    return state;
                  };
                };

                if (NATIVE_WEAK_MAP) {
                  var store = new WeakMap();
                  var wmget = store.get;
                  var wmhas = store.has;
                  var wmset = store.set;
                  set = function (it, metadata) {
                    wmset.call(store, it, metadata);
                    return metadata;
                  };
                  get = function (it) {
                    return wmget.call(store, it) || {};
                  };
                  has = function (it) {
                    return wmhas.call(store, it);
                  };
                } else {
                  var STATE = sharedKey("state");
                  hiddenKeys[STATE] = true;
                  set = function (it, metadata) {
                    hide(it, STATE, metadata);
                    return metadata;
                  };
                  get = function (it) {
                    return objectHas(it, STATE) ? it[STATE] : {};
                  };
                  has = function (it) {
                    return objectHas(it, STATE);
                  };
                }

                module.exports = {
                  set: set,
                  get: get,
                  has: has,
                  enforce: enforce,
                  getterFor: getterFor,
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/is-array-iterator-method.js":
              /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/is-array-iterator-method.js ***!
  \********************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_99095__
              ) {
                var wellKnownSymbol = __nested_webpack_require_99095__(
                  /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
                );
                var Iterators = __nested_webpack_require_99095__(
                  /*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js"
                );

                var ITERATOR = wellKnownSymbol("iterator");
                var ArrayPrototype = Array.prototype;

                // check on default Array iterator
                module.exports = function (it) {
                  return (
                    it !== undefined &&
                    (Iterators.Array === it || ArrayPrototype[ITERATOR] === it)
                  );
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/is-forced.js":
              /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-forced.js ***!
  \*****************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_99926__
              ) {
                var fails = __nested_webpack_require_99926__(
                  /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
                );

                var replacement = /#|\.prototype\./;

                var isForced = function (feature, detection) {
                  var value = data[normalize(feature)];
                  return value == POLYFILL
                    ? true
                    : value == NATIVE
                    ? false
                    : typeof detection == "function"
                    ? fails(detection)
                    : !!detection;
                };

                var normalize = (isForced.normalize = function (string) {
                  return String(string).replace(replacement, ".").toLowerCase();
                });

                var data = (isForced.data = {});
                var NATIVE = (isForced.NATIVE = "N");
                var POLYFILL = (isForced.POLYFILL = "P");

                module.exports = isForced;

                /***/
              },

            /***/ "./node_modules/core-js/internals/is-object.js":
              /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-object.js ***!
  \*****************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                module.exports = function (it) {
                  return typeof it === "object"
                    ? it !== null
                    : typeof it === "function";
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/is-pure.js":
              /*!***************************************************!*\
  !*** ./node_modules/core-js/internals/is-pure.js ***!
  \***************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                module.exports = false;

                /***/
              },

            /***/ "./node_modules/core-js/internals/iterators-core.js":
              /*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/iterators-core.js ***!
  \**********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_101660__
              ) {
                "use strict";

                var getPrototypeOf = __nested_webpack_require_101660__(
                  /*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js"
                );
                var hide = __nested_webpack_require_101660__(
                  /*! ../internals/hide */ "./node_modules/core-js/internals/hide.js"
                );
                var has = __nested_webpack_require_101660__(
                  /*! ../internals/has */ "./node_modules/core-js/internals/has.js"
                );
                var wellKnownSymbol = __nested_webpack_require_101660__(
                  /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
                );
                var IS_PURE = __nested_webpack_require_101660__(
                  /*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js"
                );

                var ITERATOR = wellKnownSymbol("iterator");
                var BUGGY_SAFARI_ITERATORS = false;

                var returnThis = function () {
                  return this;
                };

                // `%IteratorPrototype%` object
                // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
                var IteratorPrototype,
                  PrototypeOfArrayIteratorPrototype,
                  arrayIterator;

                if ([].keys) {
                  arrayIterator = [].keys();
                  // Safari 8 has buggy iterators w/o `next`
                  if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
                  else {
                    PrototypeOfArrayIteratorPrototype = getPrototypeOf(
                      getPrototypeOf(arrayIterator)
                    );
                    if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
                      IteratorPrototype = PrototypeOfArrayIteratorPrototype;
                  }
                }

                if (IteratorPrototype == undefined) IteratorPrototype = {};

                // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
                if (!IS_PURE && !has(IteratorPrototype, ITERATOR))
                  hide(IteratorPrototype, ITERATOR, returnThis);

                module.exports = {
                  IteratorPrototype: IteratorPrototype,
                  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS,
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/iterators.js":
              /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/iterators.js ***!
  \*****************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                module.exports = {};

                /***/
              },

            /***/ "./node_modules/core-js/internals/native-symbol.js":
              /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/native-symbol.js ***!
  \*********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_103948__
              ) {
                var fails = __nested_webpack_require_103948__(
                  /*! ../internals/fails */ "./node_modules/core-js/internals/fails.js"
                );

                module.exports =
                  !!Object.getOwnPropertySymbols &&
                  !fails(function () {
                    // Chrome 38 Symbol has incorrect toString conversion
                    // eslint-disable-next-line no-undef
                    return !String(Symbol());
                  });

                /***/
              },

            /***/ "./node_modules/core-js/internals/native-weak-map.js":
              /*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/native-weak-map.js ***!
  \***********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_104608__
              ) {
                var global = __nested_webpack_require_104608__(
                  /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
                );
                var nativeFunctionToString = __nested_webpack_require_104608__(
                  /*! ../internals/function-to-string */ "./node_modules/core-js/internals/function-to-string.js"
                );

                var WeakMap = global.WeakMap;

                module.exports =
                  typeof WeakMap === "function" &&
                  /native code/.test(nativeFunctionToString.call(WeakMap));

                /***/
              },

            /***/ "./node_modules/core-js/internals/object-create.js":
              /*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-create.js ***!
  \*********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_105350__
              ) {
                var anObject = __nested_webpack_require_105350__(
                  /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
                );
                var defineProperties = __nested_webpack_require_105350__(
                  /*! ../internals/object-define-properties */ "./node_modules/core-js/internals/object-define-properties.js"
                );
                var enumBugKeys = __nested_webpack_require_105350__(
                  /*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js"
                );
                var hiddenKeys = __nested_webpack_require_105350__(
                  /*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js"
                );
                var html = __nested_webpack_require_105350__(
                  /*! ../internals/html */ "./node_modules/core-js/internals/html.js"
                );
                var documentCreateElement = __nested_webpack_require_105350__(
                  /*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js"
                );
                var sharedKey = __nested_webpack_require_105350__(
                  /*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js"
                );
                var IE_PROTO = sharedKey("IE_PROTO");

                var PROTOTYPE = "prototype";
                var Empty = function () {
                  /* empty */
                };

                // Create object with fake `null` prototype: use iframe Object with cleared prototype
                var createDict = function () {
                  // Thrash, waste and sodomy: IE GC bug
                  var iframe = documentCreateElement("iframe");
                  var length = enumBugKeys.length;
                  var lt = "<";
                  var script = "script";
                  var gt = ">";
                  var js = "java" + script + ":";
                  var iframeDocument;
                  iframe.style.display = "none";
                  html.appendChild(iframe);
                  iframe.src = String(js);
                  iframeDocument = iframe.contentWindow.document;
                  iframeDocument.open();
                  iframeDocument.write(
                    lt +
                      script +
                      gt +
                      "document.F=Object" +
                      lt +
                      "/" +
                      script +
                      gt
                  );
                  iframeDocument.close();
                  createDict = iframeDocument.F;
                  while (length--)
                    delete createDict[PROTOTYPE][enumBugKeys[length]];
                  return createDict();
                };

                // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
                module.exports =
                  Object.create ||
                  function create(O, Properties) {
                    var result;
                    if (O !== null) {
                      Empty[PROTOTYPE] = anObject(O);
                      result = new Empty();
                      Empty[PROTOTYPE] = null;
                      // add "__proto__" for Object.getPrototypeOf polyfill
                      result[IE_PROTO] = O;
                    } else result = createDict();
                    return Properties === undefined
                      ? result
                      : defineProperties(result, Properties);
                  };

                hiddenKeys[IE_PROTO] = true;

                /***/
              },

            /***/ "./node_modules/core-js/internals/object-define-properties.js":
              /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-properties.js ***!
  \********************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_107983__
              ) {
                var DESCRIPTORS = __nested_webpack_require_107983__(
                  /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
                );
                var definePropertyModule = __nested_webpack_require_107983__(
                  /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
                );
                var anObject = __nested_webpack_require_107983__(
                  /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
                );
                var objectKeys = __nested_webpack_require_107983__(
                  /*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js"
                );

                module.exports = DESCRIPTORS
                  ? Object.defineProperties
                  : function defineProperties(O, Properties) {
                      anObject(O);
                      var keys = objectKeys(Properties);
                      var length = keys.length;
                      var i = 0;
                      var key;
                      while (length > i)
                        definePropertyModule.f(
                          O,
                          (key = keys[i++]),
                          Properties[key]
                        );
                      return O;
                    };

                /***/
              },

            /***/ "./node_modules/core-js/internals/object-define-property.js":
              /*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-property.js ***!
  \******************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_109180__
              ) {
                var DESCRIPTORS = __nested_webpack_require_109180__(
                  /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
                );
                var IE8_DOM_DEFINE = __nested_webpack_require_109180__(
                  /*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js"
                );
                var anObject = __nested_webpack_require_109180__(
                  /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
                );
                var toPrimitive = __nested_webpack_require_109180__(
                  /*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js"
                );

                var nativeDefineProperty = Object.defineProperty;

                exports.f = DESCRIPTORS
                  ? nativeDefineProperty
                  : function defineProperty(O, P, Attributes) {
                      anObject(O);
                      P = toPrimitive(P, true);
                      anObject(Attributes);
                      if (IE8_DOM_DEFINE)
                        try {
                          return nativeDefineProperty(O, P, Attributes);
                        } catch (error) {
                          /* empty */
                        }
                      if ("get" in Attributes || "set" in Attributes)
                        throw TypeError("Accessors not supported");
                      if ("value" in Attributes) O[P] = Attributes.value;
                      return O;
                    };

                /***/
              },

            /***/ "./node_modules/core-js/internals/object-get-own-property-descriptor.js":
              /*!******************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-descriptor.js ***!
  \******************************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_110592__
              ) {
                var DESCRIPTORS = __nested_webpack_require_110592__(
                  /*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js"
                );
                var propertyIsEnumerableModule =
                  __nested_webpack_require_110592__(
                    /*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js"
                  );
                var createPropertyDescriptor =
                  __nested_webpack_require_110592__(
                    /*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js"
                  );
                var toIndexedObject = __nested_webpack_require_110592__(
                  /*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js"
                );
                var toPrimitive = __nested_webpack_require_110592__(
                  /*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js"
                );
                var has = __nested_webpack_require_110592__(
                  /*! ../internals/has */ "./node_modules/core-js/internals/has.js"
                );
                var IE8_DOM_DEFINE = __nested_webpack_require_110592__(
                  /*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js"
                );

                var nativeGetOwnPropertyDescriptor =
                  Object.getOwnPropertyDescriptor;

                exports.f = DESCRIPTORS
                  ? nativeGetOwnPropertyDescriptor
                  : function getOwnPropertyDescriptor(O, P) {
                      O = toIndexedObject(O);
                      P = toPrimitive(P, true);
                      if (IE8_DOM_DEFINE)
                        try {
                          return nativeGetOwnPropertyDescriptor(O, P);
                        } catch (error) {
                          /* empty */
                        }
                      if (has(O, P))
                        return createPropertyDescriptor(
                          !propertyIsEnumerableModule.f.call(O, P),
                          O[P]
                        );
                    };

                /***/
              },

            /***/ "./node_modules/core-js/internals/object-get-own-property-names.js":
              /*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-names.js ***!
  \*************************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_112394__
              ) {
                // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
                var internalObjectKeys = __nested_webpack_require_112394__(
                  /*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js"
                );
                var enumBugKeys = __nested_webpack_require_112394__(
                  /*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js"
                );

                var hiddenKeys = enumBugKeys.concat("length", "prototype");

                exports.f =
                  Object.getOwnPropertyNames ||
                  function getOwnPropertyNames(O) {
                    return internalObjectKeys(O, hiddenKeys);
                  };

                /***/
              },

            /***/ "./node_modules/core-js/internals/object-get-own-property-symbols.js":
              /*!***************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-symbols.js ***!
  \***************************************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                exports.f = Object.getOwnPropertySymbols;

                /***/
              },

            /***/ "./node_modules/core-js/internals/object-get-prototype-of.js":
              /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-prototype-of.js ***!
  \*******************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_113734__
              ) {
                var has = __nested_webpack_require_113734__(
                  /*! ../internals/has */ "./node_modules/core-js/internals/has.js"
                );
                var toObject = __nested_webpack_require_113734__(
                  /*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js"
                );
                var sharedKey = __nested_webpack_require_113734__(
                  /*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js"
                );
                var CORRECT_PROTOTYPE_GETTER =
                  __nested_webpack_require_113734__(
                    /*! ../internals/correct-prototype-getter */ "./node_modules/core-js/internals/correct-prototype-getter.js"
                  );

                var IE_PROTO = sharedKey("IE_PROTO");
                var ObjectPrototype = Object.prototype;

                // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
                module.exports = CORRECT_PROTOTYPE_GETTER
                  ? Object.getPrototypeOf
                  : function (O) {
                      O = toObject(O);
                      if (has(O, IE_PROTO)) return O[IE_PROTO];
                      if (
                        typeof O.constructor == "function" &&
                        O instanceof O.constructor
                      ) {
                        return O.constructor.prototype;
                      }
                      return O instanceof Object ? ObjectPrototype : null;
                    };

                /***/
              },

            /***/ "./node_modules/core-js/internals/object-keys-internal.js":
              /*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys-internal.js ***!
  \****************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_115046__
              ) {
                var has = __nested_webpack_require_115046__(
                  /*! ../internals/has */ "./node_modules/core-js/internals/has.js"
                );
                var toIndexedObject = __nested_webpack_require_115046__(
                  /*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js"
                );
                var arrayIncludes = __nested_webpack_require_115046__(
                  /*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js"
                );
                var hiddenKeys = __nested_webpack_require_115046__(
                  /*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js"
                );

                var arrayIndexOf = arrayIncludes(false);

                module.exports = function (object, names) {
                  var O = toIndexedObject(object);
                  var i = 0;
                  var result = [];
                  var key;
                  for (key in O)
                    !has(hiddenKeys, key) && has(O, key) && result.push(key);
                  // Don't enum bug & hidden keys
                  while (names.length > i)
                    if (has(O, (key = names[i++]))) {
                      ~arrayIndexOf(result, key) || result.push(key);
                    }
                  return result;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/object-keys.js":
              /*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys.js ***!
  \*******************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_116282__
              ) {
                var internalObjectKeys = __nested_webpack_require_116282__(
                  /*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js"
                );
                var enumBugKeys = __nested_webpack_require_116282__(
                  /*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js"
                );

                // 19.1.2.14 / 15.2.3.14 Object.keys(O)
                module.exports =
                  Object.keys ||
                  function keys(O) {
                    return internalObjectKeys(O, enumBugKeys);
                  };

                /***/
              },

            /***/ "./node_modules/core-js/internals/object-property-is-enumerable.js":
              /*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-property-is-enumerable.js ***!
  \*************************************************************************/
              /*! no static exports found */
              /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
                var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

                // Nashorn ~ JDK8 bug
                var NASHORN_BUG =
                  getOwnPropertyDescriptor &&
                  !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

                exports.f = NASHORN_BUG
                  ? function propertyIsEnumerable(V) {
                      var descriptor = getOwnPropertyDescriptor(this, V);
                      return !!descriptor && descriptor.enumerable;
                    }
                  : nativePropertyIsEnumerable;

                /***/
              },

            /***/ "./node_modules/core-js/internals/object-set-prototype-of.js":
              /*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-set-prototype-of.js ***!
  \*******************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_117944__
              ) {
                var validateSetPrototypeOfArguments =
                  __nested_webpack_require_117944__(
                    /*! ../internals/validate-set-prototype-of-arguments */ "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js"
                  );

                // Works with __proto__ only. Old v8 can't work with null proto objects.
                /* eslint-disable no-proto */
                module.exports =
                  Object.setPrototypeOf ||
                  ("__proto__" in {}
                    ? (function () {
                        var correctSetter = false;
                        var test = {};
                        var setter;
                        try {
                          setter = Object.getOwnPropertyDescriptor(
                            Object.prototype,
                            "__proto__"
                          ).set;
                          setter.call(test, []);
                          correctSetter = test instanceof Array;
                        } catch (error) {
                          /* empty */
                        }
                        return function setPrototypeOf(O, proto) {
                          validateSetPrototypeOfArguments(O, proto);
                          if (correctSetter) setter.call(O, proto);
                          else O.__proto__ = proto;
                          return O;
                        };
                      })()
                    : undefined);

                /***/
              },

            /***/ "./node_modules/core-js/internals/own-keys.js":
              /*!****************************************************!*\
  !*** ./node_modules/core-js/internals/own-keys.js ***!
  \****************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_119101__
              ) {
                var global = __nested_webpack_require_119101__(
                  /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
                );
                var getOwnPropertyNamesModule =
                  __nested_webpack_require_119101__(
                    /*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js"
                  );
                var getOwnPropertySymbolsModule =
                  __nested_webpack_require_119101__(
                    /*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js"
                  );
                var anObject = __nested_webpack_require_119101__(
                  /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
                );

                var Reflect = global.Reflect;

                // all object keys, includes non-enumerable and symbols
                module.exports =
                  (Reflect && Reflect.ownKeys) ||
                  function ownKeys(it) {
                    var keys = getOwnPropertyNamesModule.f(anObject(it));
                    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                    return getOwnPropertySymbols
                      ? keys.concat(getOwnPropertySymbols(it))
                      : keys;
                  };

                /***/
              },

            /***/ "./node_modules/core-js/internals/path.js":
              /*!************************************************!*\
  !*** ./node_modules/core-js/internals/path.js ***!
  \************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_120343__
              ) {
                module.exports = __nested_webpack_require_120343__(
                  /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
                );

                /***/
              },

            /***/ "./node_modules/core-js/internals/redefine.js":
              /*!****************************************************!*\
  !*** ./node_modules/core-js/internals/redefine.js ***!
  \****************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_120782__
              ) {
                var global = __nested_webpack_require_120782__(
                  /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
                );
                var shared = __nested_webpack_require_120782__(
                  /*! ../internals/shared */ "./node_modules/core-js/internals/shared.js"
                );
                var hide = __nested_webpack_require_120782__(
                  /*! ../internals/hide */ "./node_modules/core-js/internals/hide.js"
                );
                var has = __nested_webpack_require_120782__(
                  /*! ../internals/has */ "./node_modules/core-js/internals/has.js"
                );
                var setGlobal = __nested_webpack_require_120782__(
                  /*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js"
                );
                var nativeFunctionToString = __nested_webpack_require_120782__(
                  /*! ../internals/function-to-string */ "./node_modules/core-js/internals/function-to-string.js"
                );
                var InternalStateModule = __nested_webpack_require_120782__(
                  /*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js"
                );

                var getInternalState = InternalStateModule.get;
                var enforceInternalState = InternalStateModule.enforce;
                var TEMPLATE = String(nativeFunctionToString).split("toString");

                shared("inspectSource", function (it) {
                  return nativeFunctionToString.call(it);
                });

                (module.exports = function (O, key, value, options) {
                  var unsafe = options ? !!options.unsafe : false;
                  var simple = options ? !!options.enumerable : false;
                  var noTargetGet = options ? !!options.noTargetGet : false;
                  if (typeof value == "function") {
                    if (typeof key == "string" && !has(value, "name"))
                      hide(value, "name", key);
                    enforceInternalState(value).source = TEMPLATE.join(
                      typeof key == "string" ? key : ""
                    );
                  }
                  if (O === global) {
                    if (simple) O[key] = value;
                    else setGlobal(key, value);
                    return;
                  } else if (!unsafe) {
                    delete O[key];
                  } else if (!noTargetGet && O[key]) {
                    simple = true;
                  }
                  if (simple) O[key] = value;
                  else hide(O, key, value);
                  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
                })(Function.prototype, "toString", function toString() {
                  return (
                    (typeof this == "function" &&
                      getInternalState(this).source) ||
                    nativeFunctionToString.call(this)
                  );
                });

                /***/
              },

            /***/ "./node_modules/core-js/internals/require-object-coercible.js":
              /*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/require-object-coercible.js ***!
  \********************************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                // `RequireObjectCoercible` abstract operation
                // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
                module.exports = function (it) {
                  if (it == undefined)
                    throw TypeError("Can't call method on " + it);
                  return it;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/set-global.js":
              /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/set-global.js ***!
  \******************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_123762__
              ) {
                var global = __nested_webpack_require_123762__(
                  /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
                );
                var hide = __nested_webpack_require_123762__(
                  /*! ../internals/hide */ "./node_modules/core-js/internals/hide.js"
                );

                module.exports = function (key, value) {
                  try {
                    hide(global, key, value);
                  } catch (error) {
                    global[key] = value;
                  }
                  return value;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/set-to-string-tag.js":
              /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/set-to-string-tag.js ***!
  \*************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_124480__
              ) {
                var defineProperty = __nested_webpack_require_124480__(
                  /*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js"
                ).f;
                var has = __nested_webpack_require_124480__(
                  /*! ../internals/has */ "./node_modules/core-js/internals/has.js"
                );
                var wellKnownSymbol = __nested_webpack_require_124480__(
                  /*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js"
                );

                var TO_STRING_TAG = wellKnownSymbol("toStringTag");

                module.exports = function (it, TAG, STATIC) {
                  if (
                    it &&
                    !has((it = STATIC ? it : it.prototype), TO_STRING_TAG)
                  ) {
                    defineProperty(it, TO_STRING_TAG, {
                      configurable: true,
                      value: TAG,
                    });
                  }
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/shared-key.js":
              /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/shared-key.js ***!
  \******************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_125451__
              ) {
                var shared = __nested_webpack_require_125451__(
                  /*! ../internals/shared */ "./node_modules/core-js/internals/shared.js"
                );
                var uid = __nested_webpack_require_125451__(
                  /*! ../internals/uid */ "./node_modules/core-js/internals/uid.js"
                );

                var keys = shared("keys");

                module.exports = function (key) {
                  return keys[key] || (keys[key] = uid(key));
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/shared.js":
              /*!**************************************************!*\
  !*** ./node_modules/core-js/internals/shared.js ***!
  \**************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_126088__
              ) {
                var global = __nested_webpack_require_126088__(
                  /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
                );
                var setGlobal = __nested_webpack_require_126088__(
                  /*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js"
                );
                var IS_PURE = __nested_webpack_require_126088__(
                  /*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js"
                );

                var SHARED = "__core-js_shared__";
                var store = global[SHARED] || setGlobal(SHARED, {});

                (module.exports = function (key, value) {
                  return (
                    store[key] ||
                    (store[key] = value !== undefined ? value : {})
                  );
                })("versions", []).push({
                  version: "3.1.3",
                  mode: IS_PURE ? "pure" : "global",
                  copyright: "© 2019 Denis Pushkarev (zloirock.ru)",
                });

                /***/
              },

            /***/ "./node_modules/core-js/internals/string-at.js":
              /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/string-at.js ***!
  \*****************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_127098__
              ) {
                var toInteger = __nested_webpack_require_127098__(
                  /*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js"
                );
                var requireObjectCoercible = __nested_webpack_require_127098__(
                  /*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js"
                );

                // CONVERT_TO_STRING: true  -> String#at
                // CONVERT_TO_STRING: false -> String#codePointAt
                module.exports = function (that, pos, CONVERT_TO_STRING) {
                  var S = String(requireObjectCoercible(that));
                  var position = toInteger(pos);
                  var size = S.length;
                  var first, second;
                  if (position < 0 || position >= size)
                    return CONVERT_TO_STRING ? "" : undefined;
                  first = S.charCodeAt(position);
                  return first < 0xd800 ||
                    first > 0xdbff ||
                    position + 1 === size ||
                    (second = S.charCodeAt(position + 1)) < 0xdc00 ||
                    second > 0xdfff
                    ? CONVERT_TO_STRING
                      ? S.charAt(position)
                      : first
                    : CONVERT_TO_STRING
                    ? S.slice(position, position + 2)
                    : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/to-absolute-index.js":
              /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-absolute-index.js ***!
  \*************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_128446__
              ) {
                var toInteger = __nested_webpack_require_128446__(
                  /*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js"
                );

                var max = Math.max;
                var min = Math.min;

                // Helper for a popular repeating case of the spec:
                // Let integer be ? ToInteger(index).
                // If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
                module.exports = function (index, length) {
                  var integer = toInteger(index);
                  return integer < 0
                    ? max(integer + length, 0)
                    : min(integer, length);
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/to-indexed-object.js":
              /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-indexed-object.js ***!
  \*************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_129314__
              ) {
                // toObject with fallback for non-array-like ES3 strings
                var IndexedObject = __nested_webpack_require_129314__(
                  /*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js"
                );
                var requireObjectCoercible = __nested_webpack_require_129314__(
                  /*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js"
                );

                module.exports = function (it) {
                  return IndexedObject(requireObjectCoercible(it));
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/to-integer.js":
              /*!******************************************************!*\
  !*** ./node_modules/core-js/internals/to-integer.js ***!
  \******************************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                var ceil = Math.ceil;
                var floor = Math.floor;

                // `ToInteger` abstract operation
                // https://tc39.github.io/ecma262/#sec-tointeger
                module.exports = function (argument) {
                  return isNaN((argument = +argument))
                    ? 0
                    : (argument > 0 ? floor : ceil)(argument);
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/to-length.js":
              /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-length.js ***!
  \*****************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_130652__
              ) {
                var toInteger = __nested_webpack_require_130652__(
                  /*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js"
                );

                var min = Math.min;

                // `ToLength` abstract operation
                // https://tc39.github.io/ecma262/#sec-tolength
                module.exports = function (argument) {
                  return argument > 0
                    ? min(toInteger(argument), 0x1fffffffffffff)
                    : 0; // 2 ** 53 - 1 == 9007199254740991
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/to-object.js":
              /*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-object.js ***!
  \*****************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_131354__
              ) {
                var requireObjectCoercible = __nested_webpack_require_131354__(
                  /*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js"
                );

                // `ToObject` abstract operation
                // https://tc39.github.io/ecma262/#sec-toobject
                module.exports = function (argument) {
                  return Object(requireObjectCoercible(argument));
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/to-primitive.js":
              /*!********************************************************!*\
  !*** ./node_modules/core-js/internals/to-primitive.js ***!
  \********************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_132032__
              ) {
                var isObject = __nested_webpack_require_132032__(
                  /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
                );

                // 7.1.1 ToPrimitive(input [, PreferredType])
                // instead of the ES6 spec version, we didn't implement @@toPrimitive case
                // and the second argument - flag - preferred type is a string
                module.exports = function (it, S) {
                  if (!isObject(it)) return it;
                  var fn, val;
                  if (
                    S &&
                    typeof (fn = it.toString) == "function" &&
                    !isObject((val = fn.call(it)))
                  )
                    return val;
                  if (
                    typeof (fn = it.valueOf) == "function" &&
                    !isObject((val = fn.call(it)))
                  )
                    return val;
                  if (
                    !S &&
                    typeof (fn = it.toString) == "function" &&
                    !isObject((val = fn.call(it)))
                  )
                    return val;
                  throw TypeError("Can't convert object to primitive value");
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/uid.js":
              /*!***********************************************!*\
  !*** ./node_modules/core-js/internals/uid.js ***!
  \***********************************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                var id = 0;
                var postfix = Math.random();

                module.exports = function (key) {
                  return "Symbol(".concat(
                    key === undefined ? "" : key,
                    ")_",
                    (++id + postfix).toString(36)
                  );
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js":
              /*!*******************************************************************************!*\
  !*** ./node_modules/core-js/internals/validate-set-prototype-of-arguments.js ***!
  \*******************************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_133659__
              ) {
                var isObject = __nested_webpack_require_133659__(
                  /*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js"
                );
                var anObject = __nested_webpack_require_133659__(
                  /*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js"
                );

                module.exports = function (O, proto) {
                  anObject(O);
                  if (!isObject(proto) && proto !== null) {
                    throw TypeError(
                      "Can't set " + String(proto) + " as a prototype"
                    );
                  }
                };

                /***/
              },

            /***/ "./node_modules/core-js/internals/well-known-symbol.js":
              /*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/well-known-symbol.js ***!
  \*************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_134430__
              ) {
                var global = __nested_webpack_require_134430__(
                  /*! ../internals/global */ "./node_modules/core-js/internals/global.js"
                );
                var shared = __nested_webpack_require_134430__(
                  /*! ../internals/shared */ "./node_modules/core-js/internals/shared.js"
                );
                var uid = __nested_webpack_require_134430__(
                  /*! ../internals/uid */ "./node_modules/core-js/internals/uid.js"
                );
                var NATIVE_SYMBOL = __nested_webpack_require_134430__(
                  /*! ../internals/native-symbol */ "./node_modules/core-js/internals/native-symbol.js"
                );

                var Symbol = global.Symbol;
                var store = shared("wks");

                module.exports = function (name) {
                  return (
                    store[name] ||
                    (store[name] =
                      (NATIVE_SYMBOL && Symbol[name]) ||
                      (NATIVE_SYMBOL ? Symbol : uid)("Symbol." + name))
                  );
                };

                /***/
              },

            /***/ "./node_modules/core-js/modules/es.array.from.js":
              /*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.from.js ***!
  \*******************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_135432__
              ) {
                var $ = __nested_webpack_require_135432__(
                  /*! ../internals/export */ "./node_modules/core-js/internals/export.js"
                );
                var from = __nested_webpack_require_135432__(
                  /*! ../internals/array-from */ "./node_modules/core-js/internals/array-from.js"
                );
                var checkCorrectnessOfIteration =
                  __nested_webpack_require_135432__(
                    /*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js/internals/check-correctness-of-iteration.js"
                  );

                var INCORRECT_ITERATION = !checkCorrectnessOfIteration(
                  function (iterable) {
                    Array.from(iterable);
                  }
                );

                // `Array.from` method
                // https://tc39.github.io/ecma262/#sec-array.from
                $(
                  { target: "Array", stat: true, forced: INCORRECT_ITERATION },
                  {
                    from: from,
                  }
                );

                /***/
              },

            /***/ "./node_modules/core-js/modules/es.string.iterator.js":
              /*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.iterator.js ***!
  \************************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_136446__
              ) {
                "use strict";

                var codePointAt = __nested_webpack_require_136446__(
                  /*! ../internals/string-at */ "./node_modules/core-js/internals/string-at.js"
                );
                var InternalStateModule = __nested_webpack_require_136446__(
                  /*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js"
                );
                var defineIterator = __nested_webpack_require_136446__(
                  /*! ../internals/define-iterator */ "./node_modules/core-js/internals/define-iterator.js"
                );

                var STRING_ITERATOR = "String Iterator";
                var setInternalState = InternalStateModule.set;
                var getInternalState =
                  InternalStateModule.getterFor(STRING_ITERATOR);

                // `String.prototype[@@iterator]` method
                // https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
                defineIterator(
                  String,
                  "String",
                  function (iterated) {
                    setInternalState(this, {
                      type: STRING_ITERATOR,
                      string: String(iterated),
                      index: 0,
                    });
                    // `%StringIteratorPrototype%.next` method
                    // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
                  },
                  function next() {
                    var state = getInternalState(this);
                    var string = state.string;
                    var index = state.index;
                    var point;
                    if (index >= string.length)
                      return { value: undefined, done: true };
                    point = codePointAt(string, index, true);
                    state.index += point.length;
                    return { value: point, done: false };
                  }
                );

                /***/
              },

            /***/ "./node_modules/webpack/buildin/global.js":
              /*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
              /*! no static exports found */
              /***/ function (module, exports) {
                var g;

                // This works in non-strict mode
                g = (function () {
                  return this;
                })();

                try {
                  // This works if eval is allowed (see CSP)
                  g = g || Function("return this")() || (1, eval)("this");
                } catch (e) {
                  // This works if the window reference is available
                  if (typeof window === "object") g = window;
                }

                // g can still be undefined, but nothing to do about it...
                // We return undefined, instead of nothing here, so it's
                // easier to handle this case. if(!global) { ...}

                module.exports = g;

                /***/
              },

            /***/ "./src/default-attrs.json":
              /*!********************************!*\
  !*** ./src/default-attrs.json ***!
  \********************************/
              /*! exports provided: xmlns, width, height, viewBox, fill, stroke, stroke-width, stroke-linecap, stroke-linejoin, default */
              /***/ function (module) {
                module.exports = {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: 24,
                  height: 24,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": 2,
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                };

                /***/
              },

            /***/ "./src/icon.js":
              /*!*********************!*\
  !*** ./src/icon.js ***!
  \*********************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_139191__
              ) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                var _extends =
                  Object.assign ||
                  function (target) {
                    for (var i = 1; i < arguments.length; i++) {
                      var source = arguments[i];
                      for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                          target[key] = source[key];
                        }
                      }
                    }
                    return target;
                  };

                var _createClass = (function () {
                  function defineProperties(target, props) {
                    for (var i = 0; i < props.length; i++) {
                      var descriptor = props[i];
                      descriptor.enumerable = descriptor.enumerable || false;
                      descriptor.configurable = true;
                      if ("value" in descriptor) descriptor.writable = true;
                      Object.defineProperty(target, descriptor.key, descriptor);
                    }
                  }
                  return function (Constructor, protoProps, staticProps) {
                    if (protoProps)
                      defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                  };
                })();

                var _dedupe = __nested_webpack_require_139191__(
                  /*! classnames/dedupe */ "./node_modules/classnames/dedupe.js"
                );

                var _dedupe2 = _interopRequireDefault(_dedupe);

                var _defaultAttrs = __nested_webpack_require_139191__(
                  /*! ./default-attrs.json */ "./src/default-attrs.json"
                );

                var _defaultAttrs2 = _interopRequireDefault(_defaultAttrs);

                function _interopRequireDefault(obj) {
                  return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                  if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                  }
                }

                var Icon = (function () {
                  function Icon(name, contents) {
                    var tags =
                      arguments.length > 2 && arguments[2] !== undefined
                        ? arguments[2]
                        : [];

                    _classCallCheck(this, Icon);

                    this.name = name;
                    this.contents = contents;
                    this.tags = tags;
                    this.attrs = _extends({}, _defaultAttrs2.default, {
                      class: "feather feather-" + name,
                    });
                  }

                  /**
                   * Create an SVG string.
                   * @param {Object} attrs
                   * @returns {string}
                   */

                  _createClass(Icon, [
                    {
                      key: "toSvg",
                      value: function toSvg() {
                        var attrs =
                          arguments.length > 0 && arguments[0] !== undefined
                            ? arguments[0]
                            : {};

                        var combinedAttrs = _extends({}, this.attrs, attrs, {
                          class: (0, _dedupe2.default)(
                            this.attrs.class,
                            attrs.class
                          ),
                        });

                        return (
                          "<svg " +
                          attrsToString(combinedAttrs) +
                          ">" +
                          this.contents +
                          "</svg>"
                        );
                      },

                      /**
                       * Return string representation of an `Icon`.
                       *
                       * Added for backward compatibility. If old code expects `feather.icons.<name>`
                       * to be a string, `toString()` will get implicitly called.
                       *
                       * @returns {string}
                       */
                    },
                    {
                      key: "toString",
                      value: function toString() {
                        return this.contents;
                      },
                    },
                  ]);

                  return Icon;
                })();

                /**
                 * Convert attributes object to string of HTML attributes.
                 * @param {Object} attrs
                 * @returns {string}
                 */

                function attrsToString(attrs) {
                  return Object.keys(attrs)
                    .map(function (key) {
                      return key + '="' + attrs[key] + '"';
                    })
                    .join(" ");
                }

                exports.default = Icon;

                /***/
              },

            /***/ "./src/icons.js":
              /*!**********************!*\
  !*** ./src/icons.js ***!
  \**********************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_142349__
              ) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                var _icon = __nested_webpack_require_142349__(
                  /*! ./icon */ "./src/icon.js"
                );

                var _icon2 = _interopRequireDefault(_icon);

                var _icons = __nested_webpack_require_142349__(
                  /*! ../dist/icons.json */ "./dist/icons.json"
                );

                var _icons2 = _interopRequireDefault(_icons);

                var _tags = __nested_webpack_require_142349__(
                  /*! ./tags.json */ "./src/tags.json"
                );

                var _tags2 = _interopRequireDefault(_tags);

                function _interopRequireDefault(obj) {
                  return obj && obj.__esModule ? obj : { default: obj };
                }

                exports.default = Object.keys(_icons2.default)
                  .map(function (key) {
                    return new _icon2.default(
                      key,
                      _icons2.default[key],
                      _tags2.default[key]
                    );
                  })
                  .reduce(function (object, icon) {
                    object[icon.name] = icon;
                    return object;
                  }, {});

                /***/
              },

            /***/ "./src/index.js":
              /*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_143325__
              ) {
                "use strict";

                var _icons = __nested_webpack_require_143325__(
                  /*! ./icons */ "./src/icons.js"
                );

                var _icons2 = _interopRequireDefault(_icons);

                var _toSvg = __nested_webpack_require_143325__(
                  /*! ./to-svg */ "./src/to-svg.js"
                );

                var _toSvg2 = _interopRequireDefault(_toSvg);

                var _replace = __nested_webpack_require_143325__(
                  /*! ./replace */ "./src/replace.js"
                );

                var _replace2 = _interopRequireDefault(_replace);

                function _interopRequireDefault(obj) {
                  return obj && obj.__esModule ? obj : { default: obj };
                }

                module.exports = {
                  icons: _icons2.default,
                  toSvg: _toSvg2.default,
                  replace: _replace2.default,
                };

                /***/
              },

            /***/ "./src/replace.js":
              /*!************************!*\
  !*** ./src/replace.js ***!
  \************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_144107__
              ) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                var _extends =
                  Object.assign ||
                  function (target) {
                    for (var i = 1; i < arguments.length; i++) {
                      var source = arguments[i];
                      for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                          target[key] = source[key];
                        }
                      }
                    }
                    return target;
                  }; /* eslint-env browser */

                var _dedupe = __nested_webpack_require_144107__(
                  /*! classnames/dedupe */ "./node_modules/classnames/dedupe.js"
                );

                var _dedupe2 = _interopRequireDefault(_dedupe);

                var _icons = __nested_webpack_require_144107__(
                  /*! ./icons */ "./src/icons.js"
                );

                var _icons2 = _interopRequireDefault(_icons);

                function _interopRequireDefault(obj) {
                  return obj && obj.__esModule ? obj : { default: obj };
                }

                /**
                 * Replace all HTML elements that have a `data-feather` attribute with SVG markup
                 * corresponding to the element's `data-feather` attribute value.
                 * @param {Object} attrs
                 */
                function replace() {
                  var attrs =
                    arguments.length > 0 && arguments[0] !== undefined
                      ? arguments[0]
                      : {};

                  if (typeof document === "undefined") {
                    throw new Error(
                      "`feather.replace()` only works in a browser environment."
                    );
                  }

                  var elementsToReplace =
                    document.querySelectorAll("[data-feather]");

                  Array.from(elementsToReplace).forEach(function (element) {
                    return replaceElement(element, attrs);
                  });
                }

                /**
                 * Replace a single HTML element with SVG markup
                 * corresponding to the element's `data-feather` attribute value.
                 * @param {HTMLElement} element
                 * @param {Object} attrs
                 */
                function replaceElement(element) {
                  var attrs =
                    arguments.length > 1 && arguments[1] !== undefined
                      ? arguments[1]
                      : {};

                  var elementAttrs = getAttrs(element);
                  var name = elementAttrs["data-feather"];
                  delete elementAttrs["data-feather"];

                  var svgString = _icons2.default[name].toSvg(
                    _extends({}, attrs, elementAttrs, {
                      class: (0, _dedupe2.default)(
                        attrs.class,
                        elementAttrs.class
                      ),
                    })
                  );
                  var svgDocument = new DOMParser().parseFromString(
                    svgString,
                    "image/svg+xml"
                  );
                  var svgElement = svgDocument.querySelector("svg");

                  element.parentNode.replaceChild(svgElement, element);
                }

                /**
                 * Get the attributes of an HTML element.
                 * @param {HTMLElement} element
                 * @returns {Object}
                 */
                function getAttrs(element) {
                  return Array.from(element.attributes).reduce(function (
                    attrs,
                    attr
                  ) {
                    attrs[attr.name] = attr.value;
                    return attrs;
                  },
                  {});
                }

                exports.default = replace;

                /***/
              },

            /***/ "./src/tags.json":
              /*!***********************!*\
  !*** ./src/tags.json ***!
  \***********************/
              /*! exports provided: activity, airplay, alert-circle, alert-octagon, alert-triangle, align-center, align-justify, align-left, align-right, anchor, archive, at-sign, award, aperture, bar-chart, bar-chart-2, battery, battery-charging, bell, bell-off, bluetooth, book-open, book, bookmark, box, briefcase, calendar, camera, cast, circle, clipboard, clock, cloud-drizzle, cloud-lightning, cloud-rain, cloud-snow, cloud, codepen, codesandbox, code, coffee, columns, command, compass, copy, corner-down-left, corner-down-right, corner-left-down, corner-left-up, corner-right-down, corner-right-up, corner-up-left, corner-up-right, cpu, credit-card, crop, crosshair, database, delete, disc, dollar-sign, droplet, edit, edit-2, edit-3, eye, eye-off, external-link, facebook, fast-forward, figma, file-minus, file-plus, file-text, film, filter, flag, folder-minus, folder-plus, folder, framer, frown, gift, git-branch, git-commit, git-merge, git-pull-request, github, gitlab, globe, hard-drive, hash, headphones, heart, help-circle, hexagon, home, image, inbox, instagram, key, layers, layout, life-bouy, link, link-2, linkedin, list, lock, log-in, log-out, mail, map-pin, map, maximize, maximize-2, meh, menu, message-circle, message-square, mic-off, mic, minimize, minimize-2, minus, monitor, moon, more-horizontal, more-vertical, mouse-pointer, move, music, navigation, navigation-2, octagon, package, paperclip, pause, pause-circle, pen-tool, percent, phone-call, phone-forwarded, phone-incoming, phone-missed, phone-off, phone-outgoing, phone, play, pie-chart, play-circle, plus, plus-circle, plus-square, pocket, power, printer, radio, refresh-cw, refresh-ccw, repeat, rewind, rotate-ccw, rotate-cw, rss, save, scissors, search, send, settings, share-2, shield, shield-off, shopping-bag, shopping-cart, shuffle, skip-back, skip-forward, slack, slash, sliders, smartphone, smile, speaker, star, stop-circle, sun, sunrise, sunset, tablet, tag, target, terminal, thermometer, thumbs-down, thumbs-up, toggle-left, toggle-right, tool, trash, trash-2, triangle, truck, tv, twitch, twitter, type, umbrella, unlock, user-check, user-minus, user-plus, user-x, user, users, video-off, video, voicemail, volume, volume-1, volume-2, volume-x, watch, wifi-off, wifi, wind, x-circle, x-octagon, x-square, x, youtube, zap-off, zap, zoom-in, zoom-out, default */
              /***/ function (module) {
                module.exports = {
                  activity: ["pulse", "health", "action", "motion"],
                  airplay: ["stream", "cast", "mirroring"],
                  "alert-circle": ["warning", "alert", "danger"],
                  "alert-octagon": ["warning", "alert", "danger"],
                  "alert-triangle": ["warning", "alert", "danger"],
                  "align-center": ["text alignment", "center"],
                  "align-justify": ["text alignment", "justified"],
                  "align-left": ["text alignment", "left"],
                  "align-right": ["text alignment", "right"],
                  anchor: [],
                  archive: ["index", "box"],
                  "at-sign": ["mention", "at", "email", "message"],
                  award: ["achievement", "badge"],
                  aperture: ["camera", "photo"],
                  "bar-chart": ["statistics", "diagram", "graph"],
                  "bar-chart-2": ["statistics", "diagram", "graph"],
                  battery: ["power", "electricity"],
                  "battery-charging": ["power", "electricity"],
                  bell: ["alarm", "notification", "sound"],
                  "bell-off": ["alarm", "notification", "silent"],
                  bluetooth: ["wireless"],
                  "book-open": ["read", "library"],
                  book: [
                    "read",
                    "dictionary",
                    "booklet",
                    "magazine",
                    "library",
                  ],
                  bookmark: ["read", "clip", "marker", "tag"],
                  box: ["cube"],
                  briefcase: ["work", "bag", "baggage", "folder"],
                  calendar: ["date"],
                  camera: ["photo"],
                  cast: ["chromecast", "airplay"],
                  circle: ["off", "zero", "record"],
                  clipboard: ["copy"],
                  clock: ["time", "watch", "alarm"],
                  "cloud-drizzle": ["weather", "shower"],
                  "cloud-lightning": ["weather", "bolt"],
                  "cloud-rain": ["weather"],
                  "cloud-snow": ["weather", "blizzard"],
                  cloud: ["weather"],
                  codepen: ["logo"],
                  codesandbox: ["logo"],
                  code: ["source", "programming"],
                  coffee: [
                    "drink",
                    "cup",
                    "mug",
                    "tea",
                    "cafe",
                    "hot",
                    "beverage",
                  ],
                  columns: ["layout"],
                  command: ["keyboard", "cmd", "terminal", "prompt"],
                  compass: ["navigation", "safari", "travel", "direction"],
                  copy: ["clone", "duplicate"],
                  "corner-down-left": ["arrow", "return"],
                  "corner-down-right": ["arrow"],
                  "corner-left-down": ["arrow"],
                  "corner-left-up": ["arrow"],
                  "corner-right-down": ["arrow"],
                  "corner-right-up": ["arrow"],
                  "corner-up-left": ["arrow"],
                  "corner-up-right": ["arrow"],
                  cpu: ["processor", "technology"],
                  "credit-card": ["purchase", "payment", "cc"],
                  crop: ["photo", "image"],
                  crosshair: ["aim", "target"],
                  database: ["storage", "memory"],
                  delete: ["remove"],
                  disc: ["album", "cd", "dvd", "music"],
                  "dollar-sign": ["currency", "money", "payment"],
                  droplet: ["water"],
                  edit: ["pencil", "change"],
                  "edit-2": ["pencil", "change"],
                  "edit-3": ["pencil", "change"],
                  eye: ["view", "watch"],
                  "eye-off": ["view", "watch", "hide", "hidden"],
                  "external-link": ["outbound"],
                  facebook: ["logo", "social"],
                  "fast-forward": ["music"],
                  figma: ["logo", "design", "tool"],
                  "file-minus": ["delete", "remove", "erase"],
                  "file-plus": ["add", "create", "new"],
                  "file-text": ["data", "txt", "pdf"],
                  film: ["movie", "video"],
                  filter: ["funnel", "hopper"],
                  flag: ["report"],
                  "folder-minus": ["directory"],
                  "folder-plus": ["directory"],
                  folder: ["directory"],
                  framer: ["logo", "design", "tool"],
                  frown: ["emoji", "face", "bad", "sad", "emotion"],
                  gift: ["present", "box", "birthday", "party"],
                  "git-branch": ["code", "version control"],
                  "git-commit": ["code", "version control"],
                  "git-merge": ["code", "version control"],
                  "git-pull-request": ["code", "version control"],
                  github: ["logo", "version control"],
                  gitlab: ["logo", "version control"],
                  globe: ["world", "browser", "language", "translate"],
                  "hard-drive": ["computer", "server", "memory", "data"],
                  hash: ["hashtag", "number", "pound"],
                  headphones: ["music", "audio", "sound"],
                  heart: ["like", "love", "emotion"],
                  "help-circle": ["question mark"],
                  hexagon: ["shape", "node.js", "logo"],
                  home: ["house", "living"],
                  image: ["picture"],
                  inbox: ["email"],
                  instagram: ["logo", "camera"],
                  key: ["password", "login", "authentication", "secure"],
                  layers: ["stack"],
                  layout: ["window", "webpage"],
                  "life-bouy": ["help", "life ring", "support"],
                  link: ["chain", "url"],
                  "link-2": ["chain", "url"],
                  linkedin: ["logo", "social media"],
                  list: ["options"],
                  lock: ["security", "password", "secure"],
                  "log-in": ["sign in", "arrow", "enter"],
                  "log-out": ["sign out", "arrow", "exit"],
                  mail: ["email", "message"],
                  "map-pin": ["location", "navigation", "travel", "marker"],
                  map: ["location", "navigation", "travel"],
                  maximize: ["fullscreen"],
                  "maximize-2": ["fullscreen", "arrows", "expand"],
                  meh: ["emoji", "face", "neutral", "emotion"],
                  menu: ["bars", "navigation", "hamburger"],
                  "message-circle": ["comment", "chat"],
                  "message-square": ["comment", "chat"],
                  "mic-off": ["record", "sound", "mute"],
                  mic: ["record", "sound", "listen"],
                  minimize: ["exit fullscreen", "close"],
                  "minimize-2": ["exit fullscreen", "arrows", "close"],
                  minus: ["subtract"],
                  monitor: ["tv", "screen", "display"],
                  moon: ["dark", "night"],
                  "more-horizontal": ["ellipsis"],
                  "more-vertical": ["ellipsis"],
                  "mouse-pointer": ["arrow", "cursor"],
                  move: ["arrows"],
                  music: ["note"],
                  navigation: ["location", "travel"],
                  "navigation-2": ["location", "travel"],
                  octagon: ["stop"],
                  package: ["box", "container"],
                  paperclip: ["attachment"],
                  pause: ["music", "stop"],
                  "pause-circle": ["music", "audio", "stop"],
                  "pen-tool": ["vector", "drawing"],
                  percent: ["discount"],
                  "phone-call": ["ring"],
                  "phone-forwarded": ["call"],
                  "phone-incoming": ["call"],
                  "phone-missed": ["call"],
                  "phone-off": ["call", "mute"],
                  "phone-outgoing": ["call"],
                  phone: ["call"],
                  play: ["music", "start"],
                  "pie-chart": ["statistics", "diagram"],
                  "play-circle": ["music", "start"],
                  plus: ["add", "new"],
                  "plus-circle": ["add", "new"],
                  "plus-square": ["add", "new"],
                  pocket: ["logo", "save"],
                  power: ["on", "off"],
                  printer: ["fax", "office", "device"],
                  radio: ["signal"],
                  "refresh-cw": ["synchronise", "arrows"],
                  "refresh-ccw": ["arrows"],
                  repeat: ["loop", "arrows"],
                  rewind: ["music"],
                  "rotate-ccw": ["arrow"],
                  "rotate-cw": ["arrow"],
                  rss: ["feed", "subscribe"],
                  save: ["floppy disk"],
                  scissors: ["cut"],
                  search: ["find", "magnifier", "magnifying glass"],
                  send: [
                    "message",
                    "mail",
                    "email",
                    "paper airplane",
                    "paper aeroplane",
                  ],
                  settings: ["cog", "edit", "gear", "preferences"],
                  "share-2": ["network", "connections"],
                  shield: ["security", "secure"],
                  "shield-off": ["security", "insecure"],
                  "shopping-bag": ["ecommerce", "cart", "purchase", "store"],
                  "shopping-cart": ["ecommerce", "cart", "purchase", "store"],
                  shuffle: ["music"],
                  "skip-back": ["music"],
                  "skip-forward": ["music"],
                  slack: ["logo"],
                  slash: ["ban", "no"],
                  sliders: ["settings", "controls"],
                  smartphone: ["cellphone", "device"],
                  smile: ["emoji", "face", "happy", "good", "emotion"],
                  speaker: ["audio", "music"],
                  star: ["bookmark", "favorite", "like"],
                  "stop-circle": ["media", "music"],
                  sun: ["brightness", "weather", "light"],
                  sunrise: ["weather", "time", "morning", "day"],
                  sunset: ["weather", "time", "evening", "night"],
                  tablet: ["device"],
                  tag: ["label"],
                  target: ["logo", "bullseye"],
                  terminal: ["code", "command line", "prompt"],
                  thermometer: [
                    "temperature",
                    "celsius",
                    "fahrenheit",
                    "weather",
                  ],
                  "thumbs-down": ["dislike", "bad", "emotion"],
                  "thumbs-up": ["like", "good", "emotion"],
                  "toggle-left": ["on", "off", "switch"],
                  "toggle-right": ["on", "off", "switch"],
                  tool: ["settings", "spanner"],
                  trash: ["garbage", "delete", "remove", "bin"],
                  "trash-2": ["garbage", "delete", "remove", "bin"],
                  triangle: ["delta"],
                  truck: ["delivery", "van", "shipping", "transport", "lorry"],
                  tv: ["television", "stream"],
                  twitch: ["logo"],
                  twitter: ["logo", "social"],
                  type: ["text"],
                  umbrella: ["rain", "weather"],
                  unlock: ["security"],
                  "user-check": ["followed", "subscribed"],
                  "user-minus": ["delete", "remove", "unfollow", "unsubscribe"],
                  "user-plus": ["new", "add", "create", "follow", "subscribe"],
                  "user-x": [
                    "delete",
                    "remove",
                    "unfollow",
                    "unsubscribe",
                    "unavailable",
                  ],
                  user: ["person", "account"],
                  users: ["group"],
                  "video-off": ["camera", "movie", "film"],
                  video: ["camera", "movie", "film"],
                  voicemail: ["phone"],
                  volume: ["music", "sound", "mute"],
                  "volume-1": ["music", "sound"],
                  "volume-2": ["music", "sound"],
                  "volume-x": ["music", "sound", "mute"],
                  watch: ["clock", "time"],
                  "wifi-off": ["disabled"],
                  wifi: ["connection", "signal", "wireless"],
                  wind: ["weather", "air"],
                  "x-circle": [
                    "cancel",
                    "close",
                    "delete",
                    "remove",
                    "times",
                    "clear",
                  ],
                  "x-octagon": [
                    "delete",
                    "stop",
                    "alert",
                    "warning",
                    "times",
                    "clear",
                  ],
                  "x-square": [
                    "cancel",
                    "close",
                    "delete",
                    "remove",
                    "times",
                    "clear",
                  ],
                  x: ["cancel", "close", "delete", "remove", "times", "clear"],
                  youtube: ["logo", "video", "play"],
                  "zap-off": ["flash", "camera", "lightning"],
                  zap: ["flash", "camera", "lightning"],
                  "zoom-in": ["magnifying glass"],
                  "zoom-out": ["magnifying glass"],
                };

                /***/
              },

            /***/ "./src/to-svg.js":
              /*!***********************!*\
  !*** ./src/to-svg.js ***!
  \***********************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_157167__
              ) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                var _icons = __nested_webpack_require_157167__(
                  /*! ./icons */ "./src/icons.js"
                );

                var _icons2 = _interopRequireDefault(_icons);

                function _interopRequireDefault(obj) {
                  return obj && obj.__esModule ? obj : { default: obj };
                }

                /**
                 * Create an SVG string.
                 * @deprecated
                 * @param {string} name
                 * @param {Object} attrs
                 * @returns {string}
                 */
                function toSvg(name) {
                  var attrs =
                    arguments.length > 1 && arguments[1] !== undefined
                      ? arguments[1]
                      : {};

                  console.warn(
                    "feather.toSvg() is deprecated. Please use feather.icons[name].toSvg() instead."
                  );

                  if (!name) {
                    throw new Error(
                      "The required `key` (icon name) parameter is missing."
                    );
                  }

                  if (!_icons2.default[name]) {
                    throw new Error(
                      "No icon matching '" +
                        name +
                        "'. See the complete list of icons at https://feathericons.com"
                    );
                  }

                  return _icons2.default[name].toSvg(attrs);
                }

                exports.default = toSvg;

                /***/
              },

            /***/ 0:
              /*!**************************************************!*\
  !*** multi core-js/es/array/from ./src/index.js ***!
  \**************************************************/
              /*! no static exports found */
              /***/ function (
                module,
                exports,
                __nested_webpack_require_158389__
              ) {
                __nested_webpack_require_158389__(
                  /*! core-js/es/array/from */ "./node_modules/core-js/es/array/from.js"
                );
                module.exports = __nested_webpack_require_158389__(
                  /*! /home/travis/build/feathericons/feather/src/index.js */ "./src/index.js"
                );

                /***/
              },

            /******/
          }
        );
      });
      //# sourceMappingURL=feather.js.map

      /***/
    },

    /***/ 65: /***/ (
      __unused_webpack_module,
      __unused_webpack_exports,
      __webpack_require__
    ) => {
      /* provided dependency */ var jQuery = __webpack_require__(755);
      /*
       * jQuery FlexSlider v2.7.2
       * Copyright 2012 WooThemes
       * Contributing Author: Tyler Smith
       */
      (function ($) {
        var focused = true;

        //FlexSlider: Object Instance
        $.flexslider = function (el, options) {
          var slider = $(el);

          // making variables public

          //if rtl value was not passed and html is in rtl..enable it by default.
          if (
            typeof options.rtl == "undefined" &&
            $("html").attr("dir") == "rtl"
          ) {
            options.rtl = true;
          }
          slider.vars = $.extend({}, $.flexslider.defaults, options);

          var namespace = slider.vars.namespace,
            msGesture =
              window.navigator &&
              window.navigator.msPointerEnabled &&
              window.MSGesture,
            touch =
              ("ontouchstart" in window ||
                msGesture ||
                (window.DocumentTouch && document instanceof DocumentTouch)) &&
              slider.vars.touch,
            // deprecating this idea, as devices are being released with both of these events
            eventType = "click touchend MSPointerUp keyup",
            watchedEvent = "",
            watchedEventClearTimer,
            vertical = slider.vars.direction === "vertical",
            reverse = slider.vars.reverse,
            carousel = slider.vars.itemWidth > 0,
            fade = slider.vars.animation === "fade",
            asNav = slider.vars.asNavFor !== "",
            methods = {};

          // Store a reference to the slider object
          $.data(el, "flexslider", slider);
          // Private slider methods
          methods = {
            init: function () {
              slider.animating = false;
              // Get current slide and make sure it is a number
              slider.currentSlide = parseInt(
                slider.vars.startAt ? slider.vars.startAt : 0,
                10
              );
              if (isNaN(slider.currentSlide)) {
                slider.currentSlide = 0;
              }
              slider.animatingTo = slider.currentSlide;
              slider.atEnd =
                slider.currentSlide === 0 ||
                slider.currentSlide === slider.last;
              slider.containerSelector = slider.vars.selector.substr(
                0,
                slider.vars.selector.search(" ")
              );
              slider.slides = $(slider.vars.selector, slider);
              slider.container = $(slider.containerSelector, slider);
              slider.count = slider.slides.length;
              // SYNC:
              slider.syncExists = $(slider.vars.sync).length > 0;
              // SLIDE:
              if (slider.vars.animation === "slide") {
                slider.vars.animation = "swing";
              }
              slider.prop = vertical
                ? "top"
                : slider.vars.rtl
                ? "marginRight"
                : "marginLeft";
              slider.args = {};
              // SLIDESHOW:
              slider.manualPause = false;
              slider.stopped = false;
              //PAUSE WHEN INVISIBLE
              slider.started = false;
              slider.startTimeout = null;
              // TOUCH/USECSS:
              slider.transitions =
                !slider.vars.video &&
                !fade &&
                slider.vars.useCSS &&
                (function () {
                  var obj = document.createElement("div"),
                    props = [
                      "perspectiveProperty",
                      "WebkitPerspective",
                      "MozPerspective",
                      "OPerspective",
                      "msPerspective",
                    ];
                  for (var i in props) {
                    if (obj.style[props[i]] !== undefined) {
                      slider.pfx = props[i]
                        .replace("Perspective", "")
                        .toLowerCase();
                      slider.prop = "-" + slider.pfx + "-transform";
                      return true;
                    }
                  }
                  return false;
                })();
              slider.isFirefox =
                navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
              slider.ensureAnimationEnd = "";
              // CONTROLSCONTAINER:
              if (slider.vars.controlsContainer !== "")
                slider.controlsContainer =
                  $(slider.vars.controlsContainer).length > 0 &&
                  $(slider.vars.controlsContainer);
              // MANUAL:
              if (slider.vars.manualControls !== "")
                slider.manualControls =
                  $(slider.vars.manualControls).length > 0 &&
                  $(slider.vars.manualControls);

              // CUSTOM DIRECTION NAV:
              if (slider.vars.customDirectionNav !== "")
                slider.customDirectionNav =
                  $(slider.vars.customDirectionNav).length === 2 &&
                  $(slider.vars.customDirectionNav);

              // RANDOMIZE:
              if (slider.vars.randomize) {
                slider.slides.sort(function () {
                  return Math.round(Math.random()) - 0.5;
                });
                slider.container.empty().append(slider.slides);
              }

              slider.doMath();

              // INIT
              slider.setup("init");

              // CONTROLNAV:
              if (slider.vars.controlNav) {
                methods.controlNav.setup();
              }

              // DIRECTIONNAV:
              if (slider.vars.directionNav) {
                methods.directionNav.setup();
              }

              // KEYBOARD:
              if (
                slider.vars.keyboard &&
                ($(slider.containerSelector).length === 1 ||
                  slider.vars.multipleKeyboard)
              ) {
                $(document).bind("keyup", function (event) {
                  var keycode = event.keyCode;
                  if (!slider.animating && (keycode === 39 || keycode === 37)) {
                    var target = slider.vars.rtl
                      ? keycode === 37
                        ? slider.getTarget("next")
                        : keycode === 39
                        ? slider.getTarget("prev")
                        : false
                      : keycode === 39
                      ? slider.getTarget("next")
                      : keycode === 37
                      ? slider.getTarget("prev")
                      : false;
                    slider.flexAnimate(target, slider.vars.pauseOnAction);
                  }
                });
              }
              // MOUSEWHEEL:
              if (slider.vars.mousewheel) {
                slider.bind(
                  "mousewheel",
                  function (event, delta, deltaX, deltaY) {
                    event.preventDefault();
                    var target =
                      delta < 0
                        ? slider.getTarget("next")
                        : slider.getTarget("prev");
                    slider.flexAnimate(target, slider.vars.pauseOnAction);
                  }
                );
              }

              // PAUSEPLAY
              if (slider.vars.pausePlay) {
                methods.pausePlay.setup();
              }

              //PAUSE WHEN INVISIBLE
              if (slider.vars.slideshow && slider.vars.pauseInvisible) {
                methods.pauseInvisible.init();
              }

              // SLIDSESHOW
              if (slider.vars.slideshow) {
                if (slider.vars.pauseOnHover) {
                  slider.hover(
                    function () {
                      if (!slider.manualPlay && !slider.manualPause) {
                        slider.pause();
                      }
                    },
                    function () {
                      if (
                        !slider.manualPause &&
                        !slider.manualPlay &&
                        !slider.stopped
                      ) {
                        slider.play();
                      }
                    }
                  );
                }
                // initialize animation
                //If we're visible, or we don't use PageVisibility API
                if (
                  !slider.vars.pauseInvisible ||
                  !methods.pauseInvisible.isHidden()
                ) {
                  slider.vars.initDelay > 0
                    ? (slider.startTimeout = setTimeout(
                        slider.play,
                        slider.vars.initDelay
                      ))
                    : slider.play();
                }
              }

              // ASNAV:
              if (asNav) {
                methods.asNav.setup();
              }

              // TOUCH
              if (touch && slider.vars.touch) {
                methods.touch();
              }

              // FADE&&SMOOTHHEIGHT || SLIDE:
              if (!fade || (fade && slider.vars.smoothHeight)) {
                $(window).bind(
                  "resize orientationchange focus",
                  methods.resize
                );
              }

              slider.find("img").attr("draggable", "false");

              // API: start() Callback
              setTimeout(function () {
                slider.vars.start(slider);
              }, 200);
            },
            asNav: {
              setup: function () {
                slider.asNav = true;
                slider.animatingTo = Math.floor(
                  slider.currentSlide / slider.move
                );
                slider.currentItem = slider.currentSlide;
                slider.slides
                  .removeClass(namespace + "active-slide")
                  .eq(slider.currentItem)
                  .addClass(namespace + "active-slide");
                if (!msGesture) {
                  slider.slides.on(eventType, function (e) {
                    e.preventDefault();
                    var $slide = $(this),
                      target = $slide.index();
                    var posFromX;
                    if (slider.vars.rtl) {
                      posFromX =
                        -1 * ($slide.offset().right - $(slider).scrollLeft()); // Find position of slide relative to right of slider container
                    } else {
                      posFromX = $slide.offset().left - $(slider).scrollLeft(); // Find position of slide relative to left of slider container
                    }
                    if (
                      posFromX <= 0 &&
                      $slide.hasClass(namespace + "active-slide")
                    ) {
                      slider.flexAnimate(slider.getTarget("prev"), true);
                    } else if (
                      !$(slider.vars.asNavFor).data("flexslider").animating &&
                      !$slide.hasClass(namespace + "active-slide")
                    ) {
                      slider.direction =
                        slider.currentItem < target ? "next" : "prev";
                      slider.flexAnimate(
                        target,
                        slider.vars.pauseOnAction,
                        false,
                        true,
                        true
                      );
                    }
                  });
                } else {
                  el._slider = slider;
                  slider.slides.each(function () {
                    var that = this;
                    that._gesture = new MSGesture();
                    that._gesture.target = that;
                    that.addEventListener(
                      "MSPointerDown",
                      function (e) {
                        e.preventDefault();
                        if (e.currentTarget._gesture) {
                          e.currentTarget._gesture.addPointer(e.pointerId);
                        }
                      },
                      false
                    );
                    that.addEventListener("MSGestureTap", function (e) {
                      e.preventDefault();
                      var $slide = $(this),
                        target = $slide.index();
                      if (
                        !$(slider.vars.asNavFor).data("flexslider").animating &&
                        !$slide.hasClass("active")
                      ) {
                        slider.direction =
                          slider.currentItem < target ? "next" : "prev";
                        slider.flexAnimate(
                          target,
                          slider.vars.pauseOnAction,
                          false,
                          true,
                          true
                        );
                      }
                    });
                  });
                }
              },
            },
            controlNav: {
              setup: function () {
                if (!slider.manualControls) {
                  methods.controlNav.setupPaging();
                } else {
                  // MANUALCONTROLS:
                  methods.controlNav.setupManual();
                }
              },
              setupPaging: function () {
                var type =
                    slider.vars.controlNav === "thumbnails"
                      ? "control-thumbs"
                      : "control-paging",
                  j = 1,
                  item,
                  slide;

                slider.controlNavScaffold = $(
                  '<ol class="' +
                    namespace +
                    "control-nav " +
                    namespace +
                    type +
                    '"></ol>'
                );

                if (slider.pagingCount > 1) {
                  for (var i = 0; i < slider.pagingCount; i++) {
                    slide = slider.slides.eq(i);

                    if (undefined === slide.attr("data-thumb-alt")) {
                      slide.attr("data-thumb-alt", "");
                    }

                    item = $("<a></a>").attr("href", "#").text(j);
                    if (slider.vars.controlNav === "thumbnails") {
                      item = $("<img/>").attr("src", slide.attr("data-thumb"));
                    }

                    if ("" !== slide.attr("data-thumb-alt")) {
                      item.attr("alt", slide.attr("data-thumb-alt"));
                    }

                    if (
                      "thumbnails" === slider.vars.controlNav &&
                      true === slider.vars.thumbCaptions
                    ) {
                      var captn = slide.attr("data-thumbcaption");
                      if ("" !== captn && undefined !== captn) {
                        var caption = $("<span></span>")
                          .addClass(namespace + "caption")
                          .text(captn);
                        item.append(caption);
                      }
                    }

                    var liElement = $("<li>");
                    item.appendTo(liElement);
                    liElement.append("</li>");

                    slider.controlNavScaffold.append(liElement);
                    j++;
                  }
                }

                // CONTROLSCONTAINER:
                slider.controlsContainer
                  ? $(slider.controlsContainer).append(
                      slider.controlNavScaffold
                    )
                  : slider.append(slider.controlNavScaffold);
                methods.controlNav.set();

                methods.controlNav.active();

                slider.controlNavScaffold.delegate(
                  "a, img",
                  eventType,
                  function (event) {
                    event.preventDefault();

                    if (watchedEvent === "" || watchedEvent === event.type) {
                      var $this = $(this),
                        target = slider.controlNav.index($this);

                      if (!$this.hasClass(namespace + "active")) {
                        slider.direction =
                          target > slider.currentSlide ? "next" : "prev";
                        slider.flexAnimate(target, slider.vars.pauseOnAction);
                      }
                    }

                    // setup flags to prevent event duplication
                    if (watchedEvent === "") {
                      watchedEvent = event.type;
                    }
                    methods.setToClearWatchedEvent();
                  }
                );
              },
              setupManual: function () {
                slider.controlNav = slider.manualControls;
                methods.controlNav.active();

                slider.controlNav.bind(eventType, function (event) {
                  event.preventDefault();

                  if (watchedEvent === "" || watchedEvent === event.type) {
                    var $this = $(this),
                      target = slider.controlNav.index($this);

                    if (!$this.hasClass(namespace + "active")) {
                      target > slider.currentSlide
                        ? (slider.direction = "next")
                        : (slider.direction = "prev");
                      slider.flexAnimate(target, slider.vars.pauseOnAction);
                    }
                  }

                  // setup flags to prevent event duplication
                  if (watchedEvent === "") {
                    watchedEvent = event.type;
                  }
                  methods.setToClearWatchedEvent();
                });
              },
              set: function () {
                var selector =
                  slider.vars.controlNav === "thumbnails" ? "img" : "a";
                slider.controlNav = $(
                  "." + namespace + "control-nav li " + selector,
                  slider.controlsContainer ? slider.controlsContainer : slider
                );
              },
              active: function () {
                slider.controlNav
                  .removeClass(namespace + "active")
                  .eq(slider.animatingTo)
                  .addClass(namespace + "active");
              },
              update: function (action, pos) {
                if (slider.pagingCount > 1 && action === "add") {
                  slider.controlNavScaffold.append(
                    $('<li><a href="#">' + slider.count + "</a></li>")
                  );
                } else if (slider.pagingCount === 1) {
                  slider.controlNavScaffold.find("li").remove();
                } else {
                  slider.controlNav.eq(pos).closest("li").remove();
                }
                methods.controlNav.set();
                slider.pagingCount > 1 &&
                slider.pagingCount !== slider.controlNav.length
                  ? slider.update(pos, action)
                  : methods.controlNav.active();
              },
            },
            directionNav: {
              setup: function () {
                var directionNavScaffold = $(
                  '<ul class="' +
                    namespace +
                    'direction-nav"><li class="' +
                    namespace +
                    'nav-prev"><a class="' +
                    namespace +
                    'prev" href="#">' +
                    slider.vars.prevText +
                    '</a></li><li class="' +
                    namespace +
                    'nav-next"><a class="' +
                    namespace +
                    'next" href="#">' +
                    slider.vars.nextText +
                    "</a></li></ul>"
                );

                // CUSTOM DIRECTION NAV:
                if (slider.customDirectionNav) {
                  slider.directionNav = slider.customDirectionNav;
                  // CONTROLSCONTAINER:
                } else if (slider.controlsContainer) {
                  $(slider.controlsContainer).append(directionNavScaffold);
                  slider.directionNav = $(
                    "." + namespace + "direction-nav li a",
                    slider.controlsContainer
                  );
                } else {
                  slider.append(directionNavScaffold);
                  slider.directionNav = $(
                    "." + namespace + "direction-nav li a",
                    slider
                  );
                }

                methods.directionNav.update();

                slider.directionNav.bind(eventType, function (event) {
                  event.preventDefault();
                  var target;

                  if (watchedEvent === "" || watchedEvent === event.type) {
                    target = $(this).hasClass(namespace + "next")
                      ? slider.getTarget("next")
                      : slider.getTarget("prev");
                    slider.flexAnimate(target, slider.vars.pauseOnAction);
                  }

                  // setup flags to prevent event duplication
                  if (watchedEvent === "") {
                    watchedEvent = event.type;
                  }
                  methods.setToClearWatchedEvent();
                });
              },
              update: function () {
                var disabledClass = namespace + "disabled";
                if (slider.pagingCount === 1) {
                  slider.directionNav
                    .addClass(disabledClass)
                    .attr("tabindex", "-1");
                } else if (!slider.vars.animationLoop) {
                  if (slider.animatingTo === 0) {
                    slider.directionNav
                      .removeClass(disabledClass)
                      .filter("." + namespace + "prev")
                      .addClass(disabledClass)
                      .attr("tabindex", "-1");
                  } else if (slider.animatingTo === slider.last) {
                    slider.directionNav
                      .removeClass(disabledClass)
                      .filter("." + namespace + "next")
                      .addClass(disabledClass)
                      .attr("tabindex", "-1");
                  } else {
                    slider.directionNav
                      .removeClass(disabledClass)
                      .removeAttr("tabindex");
                  }
                } else {
                  slider.directionNav
                    .removeClass(disabledClass)
                    .removeAttr("tabindex");
                }
              },
            },
            pausePlay: {
              setup: function () {
                var pausePlayScaffold = $(
                  '<div class="' +
                    namespace +
                    'pauseplay"><a href="#"></a></div>'
                );

                // CONTROLSCONTAINER:
                if (slider.controlsContainer) {
                  slider.controlsContainer.append(pausePlayScaffold);
                  slider.pausePlay = $(
                    "." + namespace + "pauseplay a",
                    slider.controlsContainer
                  );
                } else {
                  slider.append(pausePlayScaffold);
                  slider.pausePlay = $("." + namespace + "pauseplay a", slider);
                }

                methods.pausePlay.update(
                  slider.vars.slideshow
                    ? namespace + "pause"
                    : namespace + "play"
                );

                slider.pausePlay.bind(eventType, function (event) {
                  event.preventDefault();

                  if (watchedEvent === "" || watchedEvent === event.type) {
                    if ($(this).hasClass(namespace + "pause")) {
                      slider.manualPause = true;
                      slider.manualPlay = false;
                      slider.pause();
                    } else {
                      slider.manualPause = false;
                      slider.manualPlay = true;
                      slider.play();
                    }
                  }

                  // setup flags to prevent event duplication
                  if (watchedEvent === "") {
                    watchedEvent = event.type;
                  }
                  methods.setToClearWatchedEvent();
                });
              },
              update: function (state) {
                state === "play"
                  ? slider.pausePlay
                      .removeClass(namespace + "pause")
                      .addClass(namespace + "play")
                      .html(slider.vars.playText)
                  : slider.pausePlay
                      .removeClass(namespace + "play")
                      .addClass(namespace + "pause")
                      .html(slider.vars.pauseText);
              },
            },
            touch: function () {
              var startX,
                startY,
                offset,
                cwidth,
                dx,
                startT,
                onTouchStart,
                onTouchMove,
                onTouchEnd,
                scrolling = false,
                localX = 0,
                localY = 0,
                accDx = 0;

              if (!msGesture) {
                onTouchStart = function (e) {
                  if (slider.animating) {
                    e.preventDefault();
                  } else if (
                    window.navigator.msPointerEnabled ||
                    e.touches.length === 1
                  ) {
                    slider.pause();
                    // CAROUSEL:
                    cwidth = vertical ? slider.h : slider.w;
                    startT = Number(new Date());
                    // CAROUSEL:

                    // Local vars for X and Y points.
                    localX = e.touches[0].pageX;
                    localY = e.touches[0].pageY;

                    offset =
                      carousel && reverse && slider.animatingTo === slider.last
                        ? 0
                        : carousel && reverse
                        ? slider.limit -
                          (slider.itemW + slider.vars.itemMargin) *
                            slider.move *
                            slider.animatingTo
                        : carousel && slider.currentSlide === slider.last
                        ? slider.limit
                        : carousel
                        ? (slider.itemW + slider.vars.itemMargin) *
                          slider.move *
                          slider.currentSlide
                        : reverse
                        ? (slider.last -
                            slider.currentSlide +
                            slider.cloneOffset) *
                          cwidth
                        : (slider.currentSlide + slider.cloneOffset) * cwidth;
                    startX = vertical ? localY : localX;
                    startY = vertical ? localX : localY;
                    el.addEventListener("touchmove", onTouchMove, false);
                    el.addEventListener("touchend", onTouchEnd, false);
                  }
                };

                onTouchMove = function (e) {
                  // Local vars for X and Y points.

                  localX = e.touches[0].pageX;
                  localY = e.touches[0].pageY;

                  dx = vertical
                    ? startX - localY
                    : (slider.vars.rtl ? -1 : 1) * (startX - localX);
                  scrolling = vertical
                    ? Math.abs(dx) < Math.abs(localX - startY)
                    : Math.abs(dx) < Math.abs(localY - startY);
                  var fxms = 500;

                  if (!scrolling || Number(new Date()) - startT > fxms) {
                    e.preventDefault();
                    if (!fade && slider.transitions) {
                      if (!slider.vars.animationLoop) {
                        dx =
                          dx /
                          ((slider.currentSlide === 0 && dx < 0) ||
                          (slider.currentSlide === slider.last && dx > 0)
                            ? Math.abs(dx) / cwidth + 2
                            : 1);
                      }
                      slider.setProps(offset + dx, "setTouch");
                    }
                  }
                };

                onTouchEnd = function (e) {
                  // finish the touch by undoing the touch session
                  el.removeEventListener("touchmove", onTouchMove, false);

                  if (
                    slider.animatingTo === slider.currentSlide &&
                    !scrolling &&
                    !(dx === null)
                  ) {
                    var updateDx = reverse ? -dx : dx,
                      target =
                        updateDx > 0
                          ? slider.getTarget("next")
                          : slider.getTarget("prev");

                    if (
                      slider.canAdvance(target) &&
                      ((Number(new Date()) - startT < 550 &&
                        Math.abs(updateDx) > 50) ||
                        Math.abs(updateDx) > cwidth / 2)
                    ) {
                      slider.flexAnimate(target, slider.vars.pauseOnAction);
                    } else {
                      if (!fade) {
                        slider.flexAnimate(
                          slider.currentSlide,
                          slider.vars.pauseOnAction,
                          true
                        );
                      }
                    }
                  }
                  el.removeEventListener("touchend", onTouchEnd, false);

                  startX = null;
                  startY = null;
                  dx = null;
                  offset = null;
                };

                el.addEventListener("touchstart", onTouchStart, false);
              } else {
                el.style.msTouchAction = "none";
                el._gesture = new MSGesture();
                el._gesture.target = el;
                el.addEventListener("MSPointerDown", onMSPointerDown, false);
                el._slider = slider;
                el.addEventListener(
                  "MSGestureChange",
                  onMSGestureChange,
                  false
                );
                el.addEventListener("MSGestureEnd", onMSGestureEnd, false);

                function onMSPointerDown(e) {
                  e.stopPropagation();
                  if (slider.animating) {
                    e.preventDefault();
                  } else {
                    slider.pause();
                    el._gesture.addPointer(e.pointerId);
                    accDx = 0;
                    cwidth = vertical ? slider.h : slider.w;
                    startT = Number(new Date());
                    // CAROUSEL:

                    offset =
                      carousel && reverse && slider.animatingTo === slider.last
                        ? 0
                        : carousel && reverse
                        ? slider.limit -
                          (slider.itemW + slider.vars.itemMargin) *
                            slider.move *
                            slider.animatingTo
                        : carousel && slider.currentSlide === slider.last
                        ? slider.limit
                        : carousel
                        ? (slider.itemW + slider.vars.itemMargin) *
                          slider.move *
                          slider.currentSlide
                        : reverse
                        ? (slider.last -
                            slider.currentSlide +
                            slider.cloneOffset) *
                          cwidth
                        : (slider.currentSlide + slider.cloneOffset) * cwidth;
                  }
                }

                function onMSGestureChange(e) {
                  e.stopPropagation();
                  var slider = e.target._slider;
                  if (!slider) {
                    return;
                  }
                  var transX = -e.translationX,
                    transY = -e.translationY;

                  //Accumulate translations.
                  accDx = accDx + (vertical ? transY : transX);
                  dx = (slider.vars.rtl ? -1 : 1) * accDx;
                  scrolling = vertical
                    ? Math.abs(accDx) < Math.abs(-transX)
                    : Math.abs(accDx) < Math.abs(-transY);

                  if (e.detail === e.MSGESTURE_FLAG_INERTIA) {
                    setImmediate(function () {
                      el._gesture.stop();
                    });

                    return;
                  }

                  if (!scrolling || Number(new Date()) - startT > 500) {
                    e.preventDefault();
                    if (!fade && slider.transitions) {
                      if (!slider.vars.animationLoop) {
                        dx =
                          accDx /
                          ((slider.currentSlide === 0 && accDx < 0) ||
                          (slider.currentSlide === slider.last && accDx > 0)
                            ? Math.abs(accDx) / cwidth + 2
                            : 1);
                      }
                      slider.setProps(offset + dx, "setTouch");
                    }
                  }
                }

                function onMSGestureEnd(e) {
                  e.stopPropagation();
                  var slider = e.target._slider;
                  if (!slider) {
                    return;
                  }
                  if (
                    slider.animatingTo === slider.currentSlide &&
                    !scrolling &&
                    !(dx === null)
                  ) {
                    var updateDx = reverse ? -dx : dx,
                      target =
                        updateDx > 0
                          ? slider.getTarget("next")
                          : slider.getTarget("prev");

                    if (
                      slider.canAdvance(target) &&
                      ((Number(new Date()) - startT < 550 &&
                        Math.abs(updateDx) > 50) ||
                        Math.abs(updateDx) > cwidth / 2)
                    ) {
                      slider.flexAnimate(target, slider.vars.pauseOnAction);
                    } else {
                      if (!fade) {
                        slider.flexAnimate(
                          slider.currentSlide,
                          slider.vars.pauseOnAction,
                          true
                        );
                      }
                    }
                  }

                  startX = null;
                  startY = null;
                  dx = null;
                  offset = null;
                  accDx = 0;
                }
              }
            },
            resize: function () {
              if (!slider.animating && slider.is(":visible")) {
                if (!carousel) {
                  slider.doMath();
                }

                if (fade) {
                  // SMOOTH HEIGHT:
                  methods.smoothHeight();
                } else if (carousel) {
                  //CAROUSEL:
                  slider.slides.width(slider.computedW);
                  slider.update(slider.pagingCount);
                  slider.setProps();
                } else if (vertical) {
                  //VERTICAL:
                  slider.viewport.height(slider.h);
                  slider.setProps(slider.h, "setTotal");
                } else {
                  // SMOOTH HEIGHT:
                  if (slider.vars.smoothHeight) {
                    methods.smoothHeight();
                  }
                  slider.newSlides.width(slider.computedW);
                  slider.setProps(slider.computedW, "setTotal");
                }
              }
            },
            smoothHeight: function (dur) {
              if (!vertical || fade) {
                var $obj = fade ? slider : slider.viewport;
                dur
                  ? $obj.animate(
                      {
                        height: slider.slides
                          .eq(slider.animatingTo)
                          .innerHeight(),
                      },
                      dur
                    )
                  : $obj.innerHeight(
                      slider.slides.eq(slider.animatingTo).innerHeight()
                    );
              }
            },
            sync: function (action) {
              var $obj = $(slider.vars.sync).data("flexslider"),
                target = slider.animatingTo;

              switch (action) {
                case "animate":
                  $obj.flexAnimate(
                    target,
                    slider.vars.pauseOnAction,
                    false,
                    true
                  );
                  break;
                case "play":
                  if (!$obj.playing && !$obj.asNav) {
                    $obj.play();
                  }
                  break;
                case "pause":
                  $obj.pause();
                  break;
              }
            },
            uniqueID: function ($clone) {
              // Append _clone to current level and children elements with id attributes
              $clone
                .filter("[id]")
                .add($clone.find("[id]"))
                .each(function () {
                  var $this = $(this);
                  $this.attr("id", $this.attr("id") + "_clone");
                });
              return $clone;
            },
            pauseInvisible: {
              visProp: null,
              init: function () {
                var visProp = methods.pauseInvisible.getHiddenProp();
                if (visProp) {
                  var evtname =
                    visProp.replace(/[H|h]idden/, "") + "visibilitychange";
                  document.addEventListener(evtname, function () {
                    if (methods.pauseInvisible.isHidden()) {
                      if (slider.startTimeout) {
                        clearTimeout(slider.startTimeout); //If clock is ticking, stop timer and prevent from starting while invisible
                      } else {
                        slider.pause(); //Or just pause
                      }
                    } else {
                      if (slider.started) {
                        slider.play(); //Initiated before, just play
                      } else {
                        if (slider.vars.initDelay > 0) {
                          setTimeout(slider.play, slider.vars.initDelay);
                        } else {
                          slider.play(); //Didn't init before: simply init or wait for it
                        }
                      }
                    }
                  });
                }
              },
              isHidden: function () {
                var prop = methods.pauseInvisible.getHiddenProp();
                if (!prop) {
                  return false;
                }
                return document[prop];
              },
              getHiddenProp: function () {
                var prefixes = ["webkit", "moz", "ms", "o"];
                // if 'hidden' is natively supported just return it
                if ("hidden" in document) {
                  return "hidden";
                }
                // otherwise loop over all the known prefixes until we find one
                for (var i = 0; i < prefixes.length; i++) {
                  if (prefixes[i] + "Hidden" in document) {
                    return prefixes[i] + "Hidden";
                  }
                }
                // otherwise it's not supported
                return null;
              },
            },
            setToClearWatchedEvent: function () {
              clearTimeout(watchedEventClearTimer);
              watchedEventClearTimer = setTimeout(function () {
                watchedEvent = "";
              }, 3000);
            },
          };

          // public methods
          slider.flexAnimate = function (
            target,
            pause,
            override,
            withSync,
            fromNav
          ) {
            if (!slider.vars.animationLoop && target !== slider.currentSlide) {
              slider.direction = target > slider.currentSlide ? "next" : "prev";
            }

            if (asNav && slider.pagingCount === 1)
              slider.direction = slider.currentItem < target ? "next" : "prev";

            if (
              !slider.animating &&
              (slider.canAdvance(target, fromNav) || override) &&
              slider.is(":visible")
            ) {
              if (asNav && withSync) {
                var master = $(slider.vars.asNavFor).data("flexslider");
                slider.atEnd = target === 0 || target === slider.count - 1;
                master.flexAnimate(target, true, false, true, fromNav);
                slider.direction =
                  slider.currentItem < target ? "next" : "prev";
                master.direction = slider.direction;

                if (
                  Math.ceil((target + 1) / slider.visible) - 1 !==
                    slider.currentSlide &&
                  target !== 0
                ) {
                  slider.currentItem = target;
                  slider.slides
                    .removeClass(namespace + "active-slide")
                    .eq(target)
                    .addClass(namespace + "active-slide");
                  target = Math.floor(target / slider.visible);
                } else {
                  slider.currentItem = target;
                  slider.slides
                    .removeClass(namespace + "active-slide")
                    .eq(target)
                    .addClass(namespace + "active-slide");
                  return false;
                }
              }

              slider.animating = true;
              slider.animatingTo = target;

              // SLIDESHOW:
              if (pause) {
                slider.pause();
              }

              // API: before() animation Callback
              slider.vars.before(slider);

              // SYNC:
              if (slider.syncExists && !fromNav) {
                methods.sync("animate");
              }

              // CONTROLNAV
              if (slider.vars.controlNav) {
                methods.controlNav.active();
              }

              // !CAROUSEL:
              // CANDIDATE: slide active class (for add/remove slide)
              if (!carousel) {
                slider.slides
                  .removeClass(namespace + "active-slide")
                  .eq(target)
                  .addClass(namespace + "active-slide");
              }

              // INFINITE LOOP:
              // CANDIDATE: atEnd
              slider.atEnd = target === 0 || target === slider.last;

              // DIRECTIONNAV:
              if (slider.vars.directionNav) {
                methods.directionNav.update();
              }

              if (target === slider.last) {
                // API: end() of cycle Callback
                slider.vars.end(slider);
                // SLIDESHOW && !INFINITE LOOP:
                if (!slider.vars.animationLoop) {
                  slider.pause();
                }
              }

              // SLIDE:
              if (!fade) {
                var dimension = vertical
                    ? slider.slides.filter(":first").height()
                    : slider.computedW,
                  margin,
                  slideString,
                  calcNext;

                // INFINITE LOOP / REVERSE:
                if (carousel) {
                  margin = slider.vars.itemMargin;
                  calcNext =
                    (slider.itemW + margin) * slider.move * slider.animatingTo;
                  slideString =
                    calcNext > slider.limit && slider.visible !== 1
                      ? slider.limit
                      : calcNext;
                } else if (
                  slider.currentSlide === 0 &&
                  target === slider.count - 1 &&
                  slider.vars.animationLoop &&
                  slider.direction !== "next"
                ) {
                  slideString = reverse
                    ? (slider.count + slider.cloneOffset) * dimension
                    : 0;
                } else if (
                  slider.currentSlide === slider.last &&
                  target === 0 &&
                  slider.vars.animationLoop &&
                  slider.direction !== "prev"
                ) {
                  slideString = reverse ? 0 : (slider.count + 1) * dimension;
                } else {
                  slideString = reverse
                    ? (slider.count - 1 - target + slider.cloneOffset) *
                      dimension
                    : (target + slider.cloneOffset) * dimension;
                }
                slider.setProps(slideString, "", slider.vars.animationSpeed);
                if (slider.transitions) {
                  if (!slider.vars.animationLoop || !slider.atEnd) {
                    slider.animating = false;
                    slider.currentSlide = slider.animatingTo;
                  }

                  // Unbind previous transitionEnd events and re-bind new transitionEnd event
                  slider.container.unbind("webkitTransitionEnd transitionend");
                  slider.container.bind(
                    "webkitTransitionEnd transitionend",
                    function () {
                      clearTimeout(slider.ensureAnimationEnd);
                      slider.wrapup(dimension);
                    }
                  );

                  // Insurance for the ever-so-fickle transitionEnd event
                  clearTimeout(slider.ensureAnimationEnd);
                  slider.ensureAnimationEnd = setTimeout(function () {
                    slider.wrapup(dimension);
                  }, slider.vars.animationSpeed + 100);
                } else {
                  slider.container.animate(
                    slider.args,
                    slider.vars.animationSpeed,
                    slider.vars.easing,
                    function () {
                      slider.wrapup(dimension);
                    }
                  );
                }
              } else {
                // FADE:
                if (!touch) {
                  slider.slides
                    .eq(slider.currentSlide)
                    .css({ zIndex: 1 })
                    .animate(
                      { opacity: 0 },
                      slider.vars.animationSpeed,
                      slider.vars.easing
                    );
                  slider.slides
                    .eq(target)
                    .css({ zIndex: 2 })
                    .animate(
                      { opacity: 1 },
                      slider.vars.animationSpeed,
                      slider.vars.easing,
                      slider.wrapup
                    );
                } else {
                  slider.slides
                    .eq(slider.currentSlide)
                    .css({ opacity: 0, zIndex: 1 });
                  slider.slides.eq(target).css({ opacity: 1, zIndex: 2 });
                  slider.wrapup(dimension);
                }
              }
              // SMOOTH HEIGHT:
              if (slider.vars.smoothHeight) {
                methods.smoothHeight(slider.vars.animationSpeed);
              }
            }
          };
          slider.wrapup = function (dimension) {
            // SLIDE:
            if (!fade && !carousel) {
              if (
                slider.currentSlide === 0 &&
                slider.animatingTo === slider.last &&
                slider.vars.animationLoop
              ) {
                slider.setProps(dimension, "jumpEnd");
              } else if (
                slider.currentSlide === slider.last &&
                slider.animatingTo === 0 &&
                slider.vars.animationLoop
              ) {
                slider.setProps(dimension, "jumpStart");
              }
            }
            slider.animating = false;
            slider.currentSlide = slider.animatingTo;
            // API: after() animation Callback
            slider.vars.after(slider);
          };

          // SLIDESHOW:
          slider.animateSlides = function () {
            if (!slider.animating && focused) {
              slider.flexAnimate(slider.getTarget("next"));
            }
          };
          // SLIDESHOW:
          slider.pause = function () {
            clearInterval(slider.animatedSlides);
            slider.animatedSlides = null;
            slider.playing = false;
            // PAUSEPLAY:
            if (slider.vars.pausePlay) {
              methods.pausePlay.update("play");
            }
            // SYNC:
            if (slider.syncExists) {
              methods.sync("pause");
            }
          };
          // SLIDESHOW:
          slider.play = function () {
            if (slider.playing) {
              clearInterval(slider.animatedSlides);
            }
            slider.animatedSlides =
              slider.animatedSlides ||
              setInterval(slider.animateSlides, slider.vars.slideshowSpeed);
            slider.started = slider.playing = true;
            // PAUSEPLAY:
            if (slider.vars.pausePlay) {
              methods.pausePlay.update("pause");
            }
            // SYNC:
            if (slider.syncExists) {
              methods.sync("play");
            }
          };
          // STOP:
          slider.stop = function () {
            slider.pause();
            slider.stopped = true;
          };
          slider.canAdvance = function (target, fromNav) {
            // ASNAV:
            var last = asNav ? slider.pagingCount - 1 : slider.last;
            return fromNav
              ? true
              : asNav &&
                slider.currentItem === slider.count - 1 &&
                target === 0 &&
                slider.direction === "prev"
              ? true
              : asNav &&
                slider.currentItem === 0 &&
                target === slider.pagingCount - 1 &&
                slider.direction !== "next"
              ? false
              : target === slider.currentSlide && !asNav
              ? false
              : slider.vars.animationLoop
              ? true
              : slider.atEnd &&
                slider.currentSlide === 0 &&
                target === last &&
                slider.direction !== "next"
              ? false
              : slider.atEnd &&
                slider.currentSlide === last &&
                target === 0 &&
                slider.direction === "next"
              ? false
              : true;
          };
          slider.getTarget = function (dir) {
            slider.direction = dir;
            if (dir === "next") {
              return slider.currentSlide === slider.last
                ? 0
                : slider.currentSlide + 1;
            } else {
              return slider.currentSlide === 0
                ? slider.last
                : slider.currentSlide - 1;
            }
          };

          // SLIDE:
          slider.setProps = function (pos, special, dur) {
            var target = (function () {
              var posCheck = pos
                  ? pos
                  : (slider.itemW + slider.vars.itemMargin) *
                    slider.move *
                    slider.animatingTo,
                posCalc = (function () {
                  if (carousel) {
                    return special === "setTouch"
                      ? pos
                      : reverse && slider.animatingTo === slider.last
                      ? 0
                      : reverse
                      ? slider.limit -
                        (slider.itemW + slider.vars.itemMargin) *
                          slider.move *
                          slider.animatingTo
                      : slider.animatingTo === slider.last
                      ? slider.limit
                      : posCheck;
                  } else {
                    switch (special) {
                      case "setTotal":
                        return reverse
                          ? (slider.count -
                              1 -
                              slider.currentSlide +
                              slider.cloneOffset) *
                              pos
                          : (slider.currentSlide + slider.cloneOffset) * pos;
                      case "setTouch":
                        return reverse ? pos : pos;
                      case "jumpEnd":
                        return reverse ? pos : slider.count * pos;
                      case "jumpStart":
                        return reverse ? slider.count * pos : pos;
                      default:
                        return pos;
                    }
                  }
                })();

              return posCalc * (slider.vars.rtl ? 1 : -1) + "px";
            })();

            if (slider.transitions) {
              if (slider.isFirefox) {
                target = vertical
                  ? "translate3d(0," + target + ",0)"
                  : "translate3d(" + (parseInt(target) + "px") + ",0,0)";
              } else {
                target = vertical
                  ? "translate3d(0," + target + ",0)"
                  : "translate3d(" +
                    ((slider.vars.rtl ? -1 : 1) * parseInt(target) + "px") +
                    ",0,0)";
              }
              dur = dur !== undefined ? dur / 1000 + "s" : "0s";
              slider.container.css(
                "-" + slider.pfx + "-transition-duration",
                dur
              );
              slider.container.css("transition-duration", dur);
            }

            slider.args[slider.prop] = target;
            if (slider.transitions || dur === undefined) {
              slider.container.css(slider.args);
            }

            slider.container.css("transform", target);
          };

          slider.setup = function (type) {
            // SLIDE:
            if (!fade) {
              var sliderOffset, arr;

              if (type === "init") {
                slider.viewport = $(
                  '<div class="' + namespace + 'viewport"></div>'
                )
                  .css({ overflow: "hidden", position: "relative" })
                  .appendTo(slider)
                  .append(slider.container);
                // INFINITE LOOP:
                slider.cloneCount = 0;
                slider.cloneOffset = 0;
                // REVERSE:
                if (reverse) {
                  arr = $.makeArray(slider.slides).reverse();
                  slider.slides = $(arr);
                  slider.container.empty().append(slider.slides);
                }
              }
              // INFINITE LOOP && !CAROUSEL:
              if (slider.vars.animationLoop && !carousel) {
                slider.cloneCount = 2;
                slider.cloneOffset = 1;
                // clear out old clones
                if (type !== "init") {
                  slider.container.find(".clone").remove();
                }
                slider.container
                  .append(
                    methods
                      .uniqueID(slider.slides.first().clone().addClass("clone"))
                      .attr("aria-hidden", "true")
                  )
                  .prepend(
                    methods
                      .uniqueID(slider.slides.last().clone().addClass("clone"))
                      .attr("aria-hidden", "true")
                  );
              }
              slider.newSlides = $(slider.vars.selector, slider);

              sliderOffset = reverse
                ? slider.count - 1 - slider.currentSlide + slider.cloneOffset
                : slider.currentSlide + slider.cloneOffset;
              // VERTICAL:
              if (vertical && !carousel) {
                slider.container
                  .height((slider.count + slider.cloneCount) * 200 + "%")
                  .css("position", "absolute")
                  .width("100%");
                setTimeout(
                  function () {
                    slider.newSlides.css({ display: "block" });
                    slider.doMath();
                    slider.viewport.height(slider.h);
                    slider.setProps(sliderOffset * slider.h, "init");
                  },
                  type === "init" ? 100 : 0
                );
              } else {
                slider.container.width(
                  (slider.count + slider.cloneCount) * 200 + "%"
                );
                slider.setProps(sliderOffset * slider.computedW, "init");
                setTimeout(
                  function () {
                    slider.doMath();
                    if (slider.vars.rtl) {
                      if (slider.isFirefox) {
                        slider.newSlides.css({
                          width: slider.computedW,
                          marginRight: slider.computedM,
                          float: "right",
                          display: "block",
                        });
                      } else {
                        slider.newSlides.css({
                          width: slider.computedW,
                          marginRight: slider.computedM,
                          float: "left",
                          display: "block",
                        });
                      }
                    } else {
                      slider.newSlides.css({
                        width: slider.computedW,
                        marginRight: slider.computedM,
                        float: "left",
                        display: "block",
                      });
                    }
                    // SMOOTH HEIGHT:
                    if (slider.vars.smoothHeight) {
                      methods.smoothHeight();
                    }
                  },
                  type === "init" ? 100 : 0
                );
              }
            } else {
              // FADE:
              if (slider.vars.rtl) {
                slider.slides.css({
                  width: "100%",
                  float: "right",
                  marginLeft: "-100%",
                  position: "relative",
                });
              } else {
                slider.slides.css({
                  width: "100%",
                  float: "left",
                  marginRight: "-100%",
                  position: "relative",
                });
              }
              if (type === "init") {
                if (!touch) {
                  //slider.slides.eq(slider.currentSlide).fadeIn(slider.vars.animationSpeed, slider.vars.easing);
                  if (slider.vars.fadeFirstSlide == false) {
                    slider.slides
                      .css({ opacity: 0, display: "block", zIndex: 1 })
                      .eq(slider.currentSlide)
                      .css({ zIndex: 2 })
                      .css({ opacity: 1 });
                  } else {
                    slider.slides
                      .css({ opacity: 0, display: "block", zIndex: 1 })
                      .eq(slider.currentSlide)
                      .css({ zIndex: 2 })
                      .animate(
                        { opacity: 1 },
                        slider.vars.animationSpeed,
                        slider.vars.easing
                      );
                  }
                } else {
                  slider.slides
                    .css({
                      opacity: 0,
                      display: "block",
                      webkitTransition:
                        "opacity " +
                        slider.vars.animationSpeed / 1000 +
                        "s ease",
                      zIndex: 1,
                    })
                    .eq(slider.currentSlide)
                    .css({ opacity: 1, zIndex: 2 });
                }
              }
              // SMOOTH HEIGHT:
              if (slider.vars.smoothHeight) {
                methods.smoothHeight();
              }
            }
            // !CAROUSEL:
            // CANDIDATE: active slide
            if (!carousel) {
              slider.slides
                .removeClass(namespace + "active-slide")
                .eq(slider.currentSlide)
                .addClass(namespace + "active-slide");
            }

            //FlexSlider: init() Callback
            slider.vars.init(slider);
          };

          slider.doMath = function () {
            var slide = slider.slides.first(),
              slideMargin = slider.vars.itemMargin,
              minItems = slider.vars.minItems,
              maxItems = slider.vars.maxItems;

            slider.w =
              slider.viewport === undefined
                ? slider.width()
                : slider.viewport.width();
            if (slider.isFirefox) {
              slider.w = slider.width();
            }
            slider.h = slide.height();
            slider.boxPadding = slide.outerWidth() - slide.width();

            // CAROUSEL:
            if (carousel) {
              slider.itemT = slider.vars.itemWidth + slideMargin;
              slider.itemM = slideMargin;
              slider.minW = minItems ? minItems * slider.itemT : slider.w;
              slider.maxW = maxItems
                ? maxItems * slider.itemT - slideMargin
                : slider.w;
              slider.itemW =
                slider.minW > slider.w
                  ? (slider.w - slideMargin * (minItems - 1)) / minItems
                  : slider.maxW < slider.w
                  ? (slider.w - slideMargin * (maxItems - 1)) / maxItems
                  : slider.vars.itemWidth > slider.w
                  ? slider.w
                  : slider.vars.itemWidth;

              slider.visible = Math.floor(slider.w / slider.itemW);
              slider.move =
                slider.vars.move > 0 && slider.vars.move < slider.visible
                  ? slider.vars.move
                  : slider.visible;
              slider.pagingCount = Math.ceil(
                (slider.count - slider.visible) / slider.move + 1
              );
              slider.last = slider.pagingCount - 1;
              slider.limit =
                slider.pagingCount === 1
                  ? 0
                  : slider.vars.itemWidth > slider.w
                  ? slider.itemW * (slider.count - 1) +
                    slideMargin * (slider.count - 1)
                  : (slider.itemW + slideMargin) * slider.count -
                    slider.w -
                    slideMargin;
            } else {
              slider.itemW = slider.w;
              slider.itemM = slideMargin;
              slider.pagingCount = slider.count;
              slider.last = slider.count - 1;
            }
            slider.computedW = slider.itemW - slider.boxPadding;
            slider.computedM = slider.itemM;
          };

          slider.update = function (pos, action) {
            slider.doMath();

            // update currentSlide and slider.animatingTo if necessary
            if (!carousel) {
              if (pos < slider.currentSlide) {
                slider.currentSlide += 1;
              } else if (pos <= slider.currentSlide && pos !== 0) {
                slider.currentSlide -= 1;
              }
              slider.animatingTo = slider.currentSlide;
            }

            // update controlNav
            if (slider.vars.controlNav && !slider.manualControls) {
              if (
                (action === "add" && !carousel) ||
                slider.pagingCount > slider.controlNav.length
              ) {
                methods.controlNav.update("add");
              } else if (
                (action === "remove" && !carousel) ||
                slider.pagingCount < slider.controlNav.length
              ) {
                if (carousel && slider.currentSlide > slider.last) {
                  slider.currentSlide -= 1;
                  slider.animatingTo -= 1;
                }
                methods.controlNav.update("remove", slider.last);
              }
            }
            // update directionNav
            if (slider.vars.directionNav) {
              methods.directionNav.update();
            }
          };

          slider.addSlide = function (obj, pos) {
            var $obj = $(obj);

            slider.count += 1;
            slider.last = slider.count - 1;

            // append new slide
            if (vertical && reverse) {
              pos !== undefined
                ? slider.slides.eq(slider.count - pos).after($obj)
                : slider.container.prepend($obj);
            } else {
              pos !== undefined
                ? slider.slides.eq(pos).before($obj)
                : slider.container.append($obj);
            }

            // update currentSlide, animatingTo, controlNav, and directionNav
            slider.update(pos, "add");

            // update slider.slides
            slider.slides = $(slider.vars.selector + ":not(.clone)", slider);
            // re-setup the slider to accomdate new slide
            slider.setup();

            //FlexSlider: added() Callback
            slider.vars.added(slider);
          };
          slider.removeSlide = function (obj) {
            var pos = isNaN(obj) ? slider.slides.index($(obj)) : obj;

            // update count
            slider.count -= 1;
            slider.last = slider.count - 1;

            // remove slide
            if (isNaN(obj)) {
              $(obj, slider.slides).remove();
            } else {
              vertical && reverse
                ? slider.slides.eq(slider.last).remove()
                : slider.slides.eq(obj).remove();
            }

            // update currentSlide, animatingTo, controlNav, and directionNav
            slider.doMath();
            slider.update(pos, "remove");

            // update slider.slides
            slider.slides = $(slider.vars.selector + ":not(.clone)", slider);
            // re-setup the slider to accomdate new slide
            slider.setup();

            // FlexSlider: removed() Callback
            slider.vars.removed(slider);
          };

          //FlexSlider: Initialize
          methods.init();
        };

        // Ensure the slider isn't focussed if the window loses focus.
        $(window)
          .blur(function (e) {
            focused = false;
          })
          .focus(function (e) {
            focused = true;
          });

        //FlexSlider: Default Settings
        $.flexslider.defaults = {
          namespace: "flex-", //{NEW} String: Prefix string attached to the class of every element generated by the plugin
          selector: ".slides > li", //{NEW} Selector: Must match a simple pattern. '{container} > {slide}' -- Ignore pattern at your own peril
          animation: "fade", //String: Select your animation type, "fade" or "slide"
          easing: "swing", //{NEW} String: Determines the easing method used in jQuery transitions. jQuery easing plugin is supported!
          direction: "horizontal", //String: Select the sliding direction, "horizontal" or "vertical"
          reverse: false, //{NEW} Boolean: Reverse the animation direction
          animationLoop: true, //Boolean: Should the animation loop? If false, directionNav will received "disable" classes at either end
          smoothHeight: false, //{NEW} Boolean: Allow height of the slider to animate smoothly in horizontal mode
          startAt: 0, //Integer: The slide that the slider should start on. Array notation (0 = first slide)
          slideshow: true, //Boolean: Animate slider automatically
          slideshowSpeed: 7000, //Integer: Set the speed of the slideshow cycling, in milliseconds
          animationSpeed: 600, //Integer: Set the speed of animations, in milliseconds
          initDelay: 0, //{NEW} Integer: Set an initialization delay, in milliseconds
          randomize: false, //Boolean: Randomize slide order
          fadeFirstSlide: true, //Boolean: Fade in the first slide when animation type is "fade"
          thumbCaptions: false, //Boolean: Whether or not to put captions on thumbnails when using the "thumbnails" controlNav.

          // Usability features
          pauseOnAction: true, //Boolean: Pause the slideshow when interacting with control elements, highly recommended.
          pauseOnHover: false, //Boolean: Pause the slideshow when hovering over slider, then resume when no longer hovering
          pauseInvisible: true, //{NEW} Boolean: Pause the slideshow when tab is invisible, resume when visible. Provides better UX, lower CPU usage.
          useCSS: true, //{NEW} Boolean: Slider will use CSS3 transitions if available
          touch: true, //{NEW} Boolean: Allow touch swipe navigation of the slider on touch-enabled devices
          video: false, //{NEW} Boolean: If using video in the slider, will prevent CSS3 3D Transforms to avoid graphical glitches

          // Primary Controls
          controlNav: true, //Boolean: Create navigation for paging control of each slide? Note: Leave true for manualControls usage
          directionNav: true, //Boolean: Create navigation for previous/next navigation? (true/false)
          prevText: "Previous", //String: Set the text for the "previous" directionNav item
          nextText: "Next", //String: Set the text for the "next" directionNav item

          // Secondary Navigation
          keyboard: true, //Boolean: Allow slider navigating via keyboard left/right keys
          multipleKeyboard: false, //{NEW} Boolean: Allow keyboard navigation to affect multiple sliders. Default behavior cuts out keyboard navigation with more than one slider present.
          mousewheel: false, //{UPDATED} Boolean: Requires jquery.mousewheel.js (https://github.com/brandonaaron/jquery-mousewheel) - Allows slider navigating via mousewheel
          pausePlay: false, //Boolean: Create pause/play dynamic element
          pauseText: "Pause", //String: Set the text for the "pause" pausePlay item
          playText: "Play", //String: Set the text for the "play" pausePlay item

          // Special properties
          controlsContainer: "", //{UPDATED} jQuery Object/Selector: Declare which container the navigation elements should be appended too. Default container is the FlexSlider element. Example use would be $(".flexslider-container"). Property is ignored if given element is not found.
          manualControls: "", //{UPDATED} jQuery Object/Selector: Declare custom control navigation. Examples would be $(".flex-control-nav li") or "#tabs-nav li img", etc. The number of elements in your controlNav should match the number of slides/tabs.
          customDirectionNav: "", //{NEW} jQuery Object/Selector: Custom prev / next button. Must be two jQuery elements. In order to make the events work they have to have the classes "prev" and "next" (plus namespace)
          sync: "", //{NEW} Selector: Mirror the actions performed on this slider with another slider. Use with care.
          asNavFor: "", //{NEW} Selector: Internal property exposed for turning the slider into a thumbnail navigation for another slider

          // Carousel Options
          itemWidth: 0, //{NEW} Integer: Box-model width of individual carousel items, including horizontal borders and padding.
          itemMargin: 0, //{NEW} Integer: Margin between carousel items.
          minItems: 1, //{NEW} Integer: Minimum number of carousel items that should be visible. Items will resize fluidly when below this.
          maxItems: 0, //{NEW} Integer: Maxmimum number of carousel items that should be visible. Items will resize fluidly when above this limit.
          move: 0, //{NEW} Integer: Number of carousel items that should move on animation. If 0, slider will move all visible items.
          allowOneSlide: true, //{NEW} Boolean: Whether or not to allow a slider comprised of a single slide

          // Browser Specific
          isFirefox: false, // {NEW} Boolean: Set to true when Firefox is the browser used.

          // Callback API
          start: function () {}, //Callback: function(slider) - Fires when the slider loads the first slide
          before: function () {}, //Callback: function(slider) - Fires asynchronously with each slider animation
          after: function () {}, //Callback: function(slider) - Fires after each slider animation completes
          end: function () {}, //Callback: function(slider) - Fires when the slider reaches the last slide (asynchronous)
          added: function () {}, //{NEW} Callback: function(slider) - Fires after a slide is added
          removed: function () {}, //{NEW} Callback: function(slider) - Fires after a slide is removed
          init: function () {}, //{NEW} Callback: function(slider) - Fires after the slider is initially setup
          rtl: false, //{NEW} Boolean: Whether or not to enable RTL mode
        };

        //FlexSlider: Plugin Function
        $.fn.flexslider = function (options) {
          if (options === undefined) {
            options = {};
          }


          if (typeof options === "object") {

            return this.each(function () {
              var $this = $(this),
                selector = options.selector ? options.selector : ".slides > li",
                $slides = $this.find(selector);

              if (
                ($slides.length === 1 && options.allowOneSlide === false) ||
                $slides.length === 0
              ) {
                $slides.fadeIn(400);
                if (options.start) {
                  options.start($this);
                }
              } else if ($this.data("flexslider") === undefined) {

                new $.flexslider(this, options);
              }
            });
          } else {
            // Helper strings to quickly perform functions on the slider
            var $slider = $(this).data("flexslider");
            switch (options) {
              case "play":
                $slider.play();
                break;
              case "pause":
                $slider.pause();
                break;
              case "stop":
                $slider.stop();
                break;
              case "next":
                $slider.flexAnimate($slider.getTarget("next"), true);
                break;
              case "prev":
              case "previous":
                $slider.flexAnimate($slider.getTarget("prev"), true);
                break;
              default:
                if (typeof options === "number") {
                  $slider.flexAnimate(options, true);
                }
            }
          }
        };
      })(jQuery);

      /***/
    },

    /***/ 357: /***/ (
      __unused_webpack_module,
      __unused_webpack_exports,
      __webpack_require__
    ) => {
      /* provided dependency */ var __webpack_provided_window_dot_jQuery =
        __webpack_require__(755);
      /*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
      (function ($) {
        var defaults = {
          url: false,
          callback: false,
          target: false,
          duration: 120,
          on: "click", // other options: mouseover, grab, click, toggle
          touch: true, // enables a touch fallback
          onZoomIn: false,
          onZoomOut: false,
          magnify: 1,
        };

        // Core Zoom Logic, independent of event listeners.
        $.zoom = function (target, source, img, magnify) {
          var targetHeight,
            targetWidth,
            sourceHeight,
            sourceWidth,
            xRatio,
            yRatio,
            offset,
            $target = $(target),
            position = $target.css("position"),
            $source = $(source);

          // The parent element needs positioning so that the zoomed element can be correctly positioned within.
          target.style.position = /(absolute|fixed)/.test(position)
            ? position
            : "relative";
          target.style.overflow = "hidden";
          img.style.width = img.style.height = "";

          $(img)
            .addClass("zoomImg")
            .css({
              position: "absolute",
              top: 0,
              left: 0,
              opacity: 0,
              width: img.width * magnify,
              height: img.height * magnify,
              border: "none",
              maxWidth: "none",
              maxHeight: "none",
            })
            .appendTo(target);

          return {
            init: function () {
              targetWidth = $target.outerWidth();
              targetHeight = $target.outerHeight();

              if (source === target) {
                sourceWidth = targetWidth;
                sourceHeight = targetHeight;
              } else {
                sourceWidth = $source.outerWidth();
                sourceHeight = $source.outerHeight();
              }

              xRatio = (img.width - targetWidth) / sourceWidth;
              yRatio = (img.height - targetHeight) / sourceHeight;

              offset = $source.offset();
            },
            move: function (e) {
              var left = e.pageX - offset.left,
                top = e.pageY - offset.top;

              top = Math.max(Math.min(top, sourceHeight), 0);
              left = Math.max(Math.min(left, sourceWidth), 0);

              img.style.left = left * -xRatio + "px";
              img.style.top = top * -yRatio + "px";
            },
          };
        };

        $.fn.zoom = function (options) {
          return this.each(function () {
            var settings = $.extend({}, defaults, options || {}),
              //target will display the zoomed image
              target = (settings.target && $(settings.target)[0]) || this,
              //source will provide zoom location info (thumbnail)
              source = this,
              $source = $(source),
              img = document.createElement("img"),
              $img = $(img),
              mousemove = "mousemove.zoom",
              clicked = false,
              touched = false;

            // If a url wasn't specified, look for an image element.
            if (!settings.url) {
              var srcElement = source.querySelector("img");
              if (srcElement) {
                settings.url =
                  srcElement.getAttribute("data-src") ||
                  srcElement.currentSrc ||
                  srcElement.src;
              }
              if (!settings.url) {
                return;
              }
            }

            $source.one(
              "zoom.destroy",
              function (position, overflow) {
                $source.off(".zoom");
                target.style.position = position;
                target.style.overflow = overflow;
                img.onload = null;
                $img.remove();
              }.bind(this, target.style.position, target.style.overflow)
            );

            img.onload = function () {
              var zoom = $.zoom(target, source, img, settings.magnify);

              function start(e) {
                zoom.init();
                zoom.move(e);

                // Skip the fade-in for IE8 and lower since it chokes on fading-in
                // and changing position based on mousemovement at the same time.
                $img
                  .stop()
                  .fadeTo(
                    $.support.opacity ? settings.duration : 0,
                    1,
                    $.isFunction(settings.onZoomIn)
                      ? settings.onZoomIn.call(img)
                      : false
                  );
              }

              function stop() {
                $img
                  .stop()
                  .fadeTo(
                    settings.duration,
                    0,
                    $.isFunction(settings.onZoomOut)
                      ? settings.onZoomOut.call(img)
                      : false
                  );
              }

              // Mouse events
              if (settings.on === "grab") {
                $source.on("mousedown.zoom", function (e) {
                  if (e.which === 1) {
                    $(document).one("mouseup.zoom", function () {
                      stop();

                      $(document).off(mousemove, zoom.move);
                    });

                    start(e);

                    $(document).on(mousemove, zoom.move);

                    e.preventDefault();
                  }
                });
              } else if (settings.on === "click") {
                $source.on("click.zoom", function (e) {
                  if (clicked) {
                    // bubble the event up to the document to trigger the unbind.
                    return;
                  } else {
                    clicked = true;
                    start(e);
                    $(document).on(mousemove, zoom.move);
                    $(document).one("click.zoom", function () {
                      stop();
                      clicked = false;
                      $(document).off(mousemove, zoom.move);
                    });
                    return false;
                  }
                });
              } else if (settings.on === "toggle") {
                $source.on("click.zoom", function (e) {
                  if (clicked) {
                    stop();
                  } else {
                    start(e);
                  }
                  clicked = !clicked;
                });
              } else if (settings.on === "mouseover") {
                zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

                $source
                  .on("mouseenter.zoom", start)
                  .on("mouseleave.zoom", stop)
                  .on(mousemove, zoom.move);
              }

              // Touch fallback
              if (settings.touch) {
                $source
                  .on("touchstart.zoom", function (e) {
                    e.preventDefault();
                    if (touched) {
                      touched = false;
                      stop();
                    } else {
                      touched = true;
                      start(
                        e.originalEvent.touches[0] ||
                          e.originalEvent.changedTouches[0]
                      );
                    }
                  })
                  .on("touchmove.zoom", function (e) {
                    e.preventDefault();
                    zoom.move(
                      e.originalEvent.touches[0] ||
                        e.originalEvent.changedTouches[0]
                    );
                  })
                  .on("touchend.zoom", function (e) {
                    e.preventDefault();
                    if (touched) {
                      touched = false;
                      stop();
                    }
                  });
              }

              if ($.isFunction(settings.callback)) {
                settings.callback.call(img);
              }
            };

            img.setAttribute("role", "presentation");
            img.alt = "";
            img.src = settings.url;
          });
        };

        $.fn.zoom.defaults = defaults;
      })(__webpack_provided_window_dot_jQuery);

      /***/
    },

    /***/ 755: /***/ function (module, exports) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
       * jQuery JavaScript Library v3.6.0
       * https://jquery.com/
       *
       * Includes Sizzle.js
       * https://sizzlejs.com/
       *
       * Copyright OpenJS Foundation and other contributors
       * Released under the MIT license
       * https://jquery.org/license
       *
       * Date: 2021-03-02T17:08Z
       */
      (function (global, factory) {
        "use strict";

        if (true && typeof module.exports === "object") {
          // For CommonJS and CommonJS-like environments where a proper `window`
          // is present, execute the factory and get jQuery.
          // For environments that do not have a `window` with a `document`
          // (such as Node.js), expose a factory as module.exports.
          // This accentuates the need for the creation of a real `window`.
          // e.g. var jQuery = require("jquery")(window);
          // See ticket #14549 for more info.
          module.exports = global.document
            ? factory(global, true)
            : function (w) {
                if (!w.document) {
                  throw new Error("jQuery requires a window with a document");
                }
                return factory(w);
              };
        } else {
          factory(global);
        }

        // Pass this if window is not defined yet
      })(
        typeof window !== "undefined" ? window : this,
        function (window, noGlobal) {
          // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
          // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
          // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
          // enough that all such attempts are guarded in a try block.
          "use strict";

          var arr = [];

          var getProto = Object.getPrototypeOf;

          var slice = arr.slice;

          var flat = arr.flat
            ? function (array) {
                return arr.flat.call(array);
              }
            : function (array) {
                return arr.concat.apply([], array);
              };

          var push = arr.push;

          var indexOf = arr.indexOf;

          var class2type = {};

          var toString = class2type.toString;

          var hasOwn = class2type.hasOwnProperty;

          var fnToString = hasOwn.toString;

          var ObjectFunctionString = fnToString.call(Object);

          var support = {};

          var isFunction = function isFunction(obj) {
            // Support: Chrome <=57, Firefox <=52
            // In some browsers, typeof returns "function" for HTML <object> elements
            // (i.e., `typeof document.createElement( "object" ) === "function"`).
            // We don't want to classify *any* DOM node as a function.
            // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
            // Plus for old WebKit, typeof returns "function" for HTML collections
            // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
            return (
              typeof obj === "function" &&
              typeof obj.nodeType !== "number" &&
              typeof obj.item !== "function"
            );
          };

          var isWindow = function isWindow(obj) {
            return obj != null && obj === obj.window;
          };

          var document = window.document;

          var preservedScriptAttributes = {
            type: true,
            src: true,
            nonce: true,
            noModule: true,
          };

          function DOMEval(code, node, doc) {
            doc = doc || document;

            var i,
              val,
              script = doc.createElement("script");

            script.text = code;
            if (node) {
              for (i in preservedScriptAttributes) {
                // Support: Firefox 64+, Edge 18+
                // Some browsers don't support the "nonce" property on scripts.
                // On the other hand, just using `getAttribute` is not enough as
                // the `nonce` attribute is reset to an empty string whenever it
                // becomes browsing-context connected.
                // See https://github.com/whatwg/html/issues/2369
                // See https://html.spec.whatwg.org/#nonce-attributes
                // The `node.getAttribute` check was added for the sake of
                // `jQuery.globalEval` so that it can fake a nonce-containing node
                // via an object.
                val = node[i] || (node.getAttribute && node.getAttribute(i));
                if (val) {
                  script.setAttribute(i, val);
                }
              }
            }
            doc.head.appendChild(script).parentNode.removeChild(script);
          }

          function toType(obj) {
            if (obj == null) {
              return obj + "";
            }

            // Support: Android <=2.3 only (functionish RegExp)
            return typeof obj === "object" || typeof obj === "function"
              ? class2type[toString.call(obj)] || "object"
              : typeof obj;
          }
          /* global Symbol */
          // Defining this global in .eslintrc.json would create a danger of using the global
          // unguarded in another place, it seems safer to define global only for this module

          var version = "3.6.0",
            // Define a local copy of jQuery
            jQuery = function (selector, context) {
              // The jQuery object is actually just the init constructor 'enhanced'
              // Need init if jQuery is called (just allow error to be thrown if not included)
              return new jQuery.fn.init(selector, context);
            };

          jQuery.fn = jQuery.prototype = {
            // The current version of jQuery being used
            jquery: version,

            constructor: jQuery,

            // The default length of a jQuery object is 0
            length: 0,

            toArray: function () {
              return slice.call(this);
            },

            // Get the Nth element in the matched element set OR
            // Get the whole matched element set as a clean array
            get: function (num) {
              // Return all the elements in a clean array
              if (num == null) {
                return slice.call(this);
              }

              // Return just the one element from the set
              return num < 0 ? this[num + this.length] : this[num];
            },

            // Take an array of elements and push it onto the stack
            // (returning the new matched element set)
            pushStack: function (elems) {
              // Build a new jQuery matched element set
              var ret = jQuery.merge(this.constructor(), elems);

              // Add the old object onto the stack (as a reference)
              ret.prevObject = this;

              // Return the newly-formed element set
              return ret;
            },

            // Execute a callback for every element in the matched set.
            each: function (callback) {
              return jQuery.each(this, callback);
            },

            map: function (callback) {
              return this.pushStack(
                jQuery.map(this, function (elem, i) {
                  return callback.call(elem, i, elem);
                })
              );
            },

            slice: function () {
              return this.pushStack(slice.apply(this, arguments));
            },

            first: function () {
              return this.eq(0);
            },

            last: function () {
              return this.eq(-1);
            },

            even: function () {
              return this.pushStack(
                jQuery.grep(this, function (_elem, i) {
                  return (i + 1) % 2;
                })
              );
            },

            odd: function () {
              return this.pushStack(
                jQuery.grep(this, function (_elem, i) {
                  return i % 2;
                })
              );
            },

            eq: function (i) {
              var len = this.length,
                j = +i + (i < 0 ? len : 0);
              return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
            },

            end: function () {
              return this.prevObject || this.constructor();
            },

            // For internal use only.
            // Behaves like an Array's method, not like a jQuery method.
            push: push,
            sort: arr.sort,
            splice: arr.splice,
          };

          jQuery.extend = jQuery.fn.extend = function () {
            var options,
              name,
              src,
              copy,
              copyIsArray,
              clone,
              target = arguments[0] || {},
              i = 1,
              length = arguments.length,
              deep = false;

            // Handle a deep copy situation
            if (typeof target === "boolean") {
              deep = target;

              // Skip the boolean and the target
              target = arguments[i] || {};
              i++;
            }

            // Handle case when target is a string or something (possible in deep copy)
            if (typeof target !== "object" && !isFunction(target)) {
              target = {};
            }

            // Extend jQuery itself if only one argument is passed
            if (i === length) {
              target = this;
              i--;
            }

            for (; i < length; i++) {
              // Only deal with non-null/undefined values
              if ((options = arguments[i]) != null) {
                // Extend the base object
                for (name in options) {
                  copy = options[name];

                  // Prevent Object.prototype pollution
                  // Prevent never-ending loop
                  if (name === "__proto__" || target === copy) {
                    continue;
                  }

                  // Recurse if we're merging plain objects or arrays
                  if (
                    deep &&
                    copy &&
                    (jQuery.isPlainObject(copy) ||
                      (copyIsArray = Array.isArray(copy)))
                  ) {
                    src = target[name];

                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) {
                      clone = [];
                    } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
                      clone = {};
                    } else {
                      clone = src;
                    }
                    copyIsArray = false;

                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);

                    // Don't bring in undefined values
                  } else if (copy !== undefined) {
                    target[name] = copy;
                  }
                }
              }
            }

            // Return the modified object
            return target;
          };

          jQuery.extend({
            // Unique for each copy of jQuery on the page
            expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),

            // Assume jQuery is ready without the ready module
            isReady: true,

            error: function (msg) {
              throw new Error(msg);
            },

            noop: function () {},

            isPlainObject: function (obj) {
              var proto, Ctor;

              // Detect obvious negatives
              // Use toString instead of jQuery.type to catch host objects
              if (!obj || toString.call(obj) !== "[object Object]") {
                return false;
              }

              proto = getProto(obj);

              // Objects with no prototype (e.g., `Object.create( null )`) are plain
              if (!proto) {
                return true;
              }

              // Objects with prototype are plain iff they were constructed by a global Object function
              Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
              return (
                typeof Ctor === "function" &&
                fnToString.call(Ctor) === ObjectFunctionString
              );
            },

            isEmptyObject: function (obj) {
              var name;

              for (name in obj) {
                return false;
              }
              return true;
            },

            // Evaluates a script in a provided context; falls back to the global one
            // if not specified.
            globalEval: function (code, options, doc) {
              DOMEval(code, { nonce: options && options.nonce }, doc);
            },

            each: function (obj, callback) {
              var length,
                i = 0;

              if (isArrayLike(obj)) {
                length = obj.length;
                for (; i < length; i++) {
                  if (callback.call(obj[i], i, obj[i]) === false) {
                    break;
                  }
                }
              } else {
                for (i in obj) {
                  if (callback.call(obj[i], i, obj[i]) === false) {
                    break;
                  }
                }
              }

              return obj;
            },

            // results is for internal usage only
            makeArray: function (arr, results) {
              var ret = results || [];

              if (arr != null) {
                if (isArrayLike(Object(arr))) {
                  jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
                } else {
                  push.call(ret, arr);
                }
              }

              return ret;
            },

            inArray: function (elem, arr, i) {
              return arr == null ? -1 : indexOf.call(arr, elem, i);
            },

            // Support: Android <=4.0 only, PhantomJS 1 only
            // push.apply(_, arraylike) throws on ancient WebKit
            merge: function (first, second) {
              var len = +second.length,
                j = 0,
                i = first.length;

              for (; j < len; j++) {
                first[i++] = second[j];
              }

              first.length = i;

              return first;
            },

            grep: function (elems, callback, invert) {
              var callbackInverse,
                matches = [],
                i = 0,
                length = elems.length,
                callbackExpect = !invert;

              // Go through the array, only saving the items
              // that pass the validator function
              for (; i < length; i++) {
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) {
                  matches.push(elems[i]);
                }
              }

              return matches;
            },

            // arg is for internal usage only
            map: function (elems, callback, arg) {
              var length,
                value,
                i = 0,
                ret = [];

              // Go through the array, translating each of the items to their new values
              if (isArrayLike(elems)) {
                length = elems.length;
                for (; i < length; i++) {
                  value = callback(elems[i], i, arg);

                  if (value != null) {
                    ret.push(value);
                  }
                }

                // Go through every key on the object,
              } else {
                for (i in elems) {
                  value = callback(elems[i], i, arg);

                  if (value != null) {
                    ret.push(value);
                  }
                }
              }

              // Flatten any nested arrays
              return flat(ret);
            },

            // A global GUID counter for objects
            guid: 1,

            // jQuery.support is not used in Core but other projects attach their
            // properties to it so it needs to exist.
            support: support,
          });

          if (typeof Symbol === "function") {
            jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
          }

          // Populate the class2type map
          jQuery.each(
            "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
              " "
            ),
            function (_i, name) {
              class2type["[object " + name + "]"] = name.toLowerCase();
            }
          );

          function isArrayLike(obj) {
            // Support: real iOS 8.2 only (not reproducible in simulator)
            // `in` check used to prevent JIT error (gh-2145)
            // hasOwn isn't used here due to false negatives
            // regarding Nodelist length in IE
            var length = !!obj && "length" in obj && obj.length,
              type = toType(obj);

            if (isFunction(obj) || isWindow(obj)) {
              return false;
            }

            return (
              type === "array" ||
              length === 0 ||
              (typeof length === "number" && length > 0 && length - 1 in obj)
            );
          }
          var Sizzle =
            /*!
             * Sizzle CSS Selector Engine v2.3.6
             * https://sizzlejs.com/
             *
             * Copyright JS Foundation and other contributors
             * Released under the MIT license
             * https://js.foundation/
             *
             * Date: 2021-02-16
             */
            (function (window) {
              var i,
                support,
                Expr,
                getText,
                isXML,
                tokenize,
                compile,
                select,
                outermostContext,
                sortInput,
                hasDuplicate,
                // Local document vars
                setDocument,
                document,
                docElem,
                documentIsHTML,
                rbuggyQSA,
                rbuggyMatches,
                matches,
                contains,
                // Instance-specific data
                expando = "sizzle" + 1 * new Date(),
                preferredDoc = window.document,
                dirruns = 0,
                done = 0,
                classCache = createCache(),
                tokenCache = createCache(),
                compilerCache = createCache(),
                nonnativeSelectorCache = createCache(),
                sortOrder = function (a, b) {
                  if (a === b) {
                    hasDuplicate = true;
                  }
                  return 0;
                },
                // Instance methods
                hasOwn = {}.hasOwnProperty,
                arr = [],
                pop = arr.pop,
                pushNative = arr.push,
                push = arr.push,
                slice = arr.slice,
                // Use a stripped-down indexOf as it's faster than native
                // https://jsperf.com/thor-indexof-vs-for/5
                indexOf = function (list, elem) {
                  var i = 0,
                    len = list.length;
                  for (; i < len; i++) {
                    if (list[i] === elem) {
                      return i;
                    }
                  }
                  return -1;
                },
                booleans =
                  "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
                  "ismap|loop|multiple|open|readonly|required|scoped",
                // Regular expressions

                // http://www.w3.org/TR/css3-selectors/#whitespace
                whitespace = "[\\x20\\t\\r\\n\\f]",
                // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
                identifier =
                  "(?:\\\\[\\da-fA-F]{1,6}" +
                  whitespace +
                  "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
                attributes =
                  "\\[" +
                  whitespace +
                  "*(" +
                  identifier +
                  ")(?:" +
                  whitespace +
                  // Operator (capture 2)
                  "*([*^$|!~]?=)" +
                  whitespace +
                  // "Attribute values must be CSS identifiers [capture 5]
                  // or strings [capture 3 or capture 4]"
                  "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                  identifier +
                  "))|)" +
                  whitespace +
                  "*\\]",
                pseudos =
                  ":(" +
                  identifier +
                  ")(?:\\((" +
                  // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
                  // 1. quoted (capture 3; capture 4 or capture 5)
                  "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
                  // 2. simple (capture 6)
                  "((?:\\\\.|[^\\\\()[\\]]|" +
                  attributes +
                  ")*)|" +
                  // 3. anything else (capture 2)
                  ".*" +
                  ")\\)|)",
                // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
                rwhitespace = new RegExp(whitespace + "+", "g"),
                rtrim = new RegExp(
                  "^" +
                    whitespace +
                    "+|((?:^|[^\\\\])(?:\\\\.)*)" +
                    whitespace +
                    "+$",
                  "g"
                ),
                rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
                rcombinators = new RegExp(
                  "^" +
                    whitespace +
                    "*([>+~]|" +
                    whitespace +
                    ")" +
                    whitespace +
                    "*"
                ),
                rdescend = new RegExp(whitespace + "|>"),
                rpseudo = new RegExp(pseudos),
                ridentifier = new RegExp("^" + identifier + "$"),
                matchExpr = {
                  ID: new RegExp("^#(" + identifier + ")"),
                  CLASS: new RegExp("^\\.(" + identifier + ")"),
                  TAG: new RegExp("^(" + identifier + "|[*])"),
                  ATTR: new RegExp("^" + attributes),
                  PSEUDO: new RegExp("^" + pseudos),
                  CHILD: new RegExp(
                    "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                      whitespace +
                      "*(even|odd|(([+-]|)(\\d*)n|)" +
                      whitespace +
                      "*(?:([+-]|)" +
                      whitespace +
                      "*(\\d+)|))" +
                      whitespace +
                      "*\\)|)",
                    "i"
                  ),
                  bool: new RegExp("^(?:" + booleans + ")$", "i"),

                  // For use in libraries implementing .is()
                  // We use this for POS matching in `select`
                  needsContext: new RegExp(
                    "^" +
                      whitespace +
                      "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                      whitespace +
                      "*((?:-\\d)?\\d*)" +
                      whitespace +
                      "*\\)|)(?=[^-]|$)",
                    "i"
                  ),
                },
                rhtml = /HTML$/i,
                rinputs = /^(?:input|select|textarea|button)$/i,
                rheader = /^h\d$/i,
                rnative = /^[^{]+\{\s*\[native \w/,
                // Easily-parseable/retrievable ID or TAG or CLASS selectors
                rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                rsibling = /[+~]/,
                // CSS escapes
                // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
                runescape = new RegExp(
                  "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])",
                  "g"
                ),
                funescape = function (escape, nonHex) {
                  var high = "0x" + escape.slice(1) - 0x10000;

                  return nonHex
                    ? // Strip the backslash prefix from a non-hex escape sequence
                      nonHex
                    : // Replace a hexadecimal escape sequence with the encoded Unicode code point
                    // Support: IE <=11+
                    // For values outside the Basic Multilingual Plane (BMP), manually construct a
                    // surrogate pair
                    high < 0
                    ? String.fromCharCode(high + 0x10000)
                    : String.fromCharCode(
                        (high >> 10) | 0xd800,
                        (high & 0x3ff) | 0xdc00
                      );
                },
                // CSS string/identifier serialization
                // https://drafts.csswg.org/cssom/#common-serializing-idioms
                rcssescape =
                  /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                fcssescape = function (ch, asCodePoint) {
                  if (asCodePoint) {
                    // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                    if (ch === "\0") {
                      return "\uFFFD";
                    }

                    // Control characters and (dependent upon position) numbers get escaped as code points
                    return (
                      ch.slice(0, -1) +
                      "\\" +
                      ch.charCodeAt(ch.length - 1).toString(16) +
                      " "
                    );
                  }

                  // Other potentially-special ASCII characters get backslash-escaped
                  return "\\" + ch;
                },
                // Used for iframes
                // See setDocument()
                // Removing the function wrapper causes a "Permission Denied"
                // error in IE
                unloadHandler = function () {
                  setDocument();
                },
                inDisabledFieldset = addCombinator(
                  function (elem) {
                    return (
                      elem.disabled === true &&
                      elem.nodeName.toLowerCase() === "fieldset"
                    );
                  },
                  { dir: "parentNode", next: "legend" }
                );

              // Optimize for push.apply( _, NodeList )
              try {
                push.apply(
                  (arr = slice.call(preferredDoc.childNodes)),
                  preferredDoc.childNodes
                );

                // Support: Android<4.0
                // Detect silently failing push.apply
                // eslint-disable-next-line no-unused-expressions
                arr[preferredDoc.childNodes.length].nodeType;
              } catch (e) {
                push = {
                  apply: arr.length
                    ? // Leverage slice if possible
                      function (target, els) {
                        pushNative.apply(target, slice.call(els));
                      }
                    : // Support: IE<9
                      // Otherwise append directly
                      function (target, els) {
                        var j = target.length,
                          i = 0;

                        // Can't trust NodeList.length
                        while ((target[j++] = els[i++])) {}
                        target.length = j - 1;
                      },
                };
              }

              function Sizzle(selector, context, results, seed) {
                var m,
                  i,
                  elem,
                  nid,
                  match,
                  groups,
                  newSelector,
                  newContext = context && context.ownerDocument,
                  // nodeType defaults to 9, since context defaults to document
                  nodeType = context ? context.nodeType : 9;

                results = results || [];

                // Return early from calls with invalid selector or context
                if (
                  typeof selector !== "string" ||
                  !selector ||
                  (nodeType !== 1 && nodeType !== 9 && nodeType !== 11)
                ) {
                  return results;
                }

                // Try to shortcut find operations (as opposed to filters) in HTML documents
                if (!seed) {
                  setDocument(context);
                  context = context || document;

                  if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (
                      nodeType !== 11 &&
                      (match = rquickExpr.exec(selector))
                    ) {
                      // ID selector
                      if ((m = match[1])) {
                        // Document context
                        if (nodeType === 9) {
                          if ((elem = context.getElementById(m))) {
                            // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (elem.id === m) {
                              results.push(elem);
                              return results;
                            }
                          } else {
                            return results;
                          }

                          // Element context
                        } else {
                          // Support: IE, Opera, Webkit
                          // TODO: identify versions
                          // getElementById can match elements by name instead of ID
                          if (
                            newContext &&
                            (elem = newContext.getElementById(m)) &&
                            contains(context, elem) &&
                            elem.id === m
                          ) {
                            results.push(elem);
                            return results;
                          }
                        }

                        // Type selector
                      } else if (match[2]) {
                        push.apply(
                          results,
                          context.getElementsByTagName(selector)
                        );
                        return results;

                        // Class selector
                      } else if (
                        (m = match[3]) &&
                        support.getElementsByClassName &&
                        context.getElementsByClassName
                      ) {
                        push.apply(results, context.getElementsByClassName(m));
                        return results;
                      }
                    }

                    // Take advantage of querySelectorAll
                    if (
                      support.qsa &&
                      !nonnativeSelectorCache[selector + " "] &&
                      (!rbuggyQSA || !rbuggyQSA.test(selector)) &&
                      // Support: IE 8 only
                      // Exclude object elements
                      (nodeType !== 1 ||
                        context.nodeName.toLowerCase() !== "object")
                    ) {
                      newSelector = selector;
                      newContext = context;

                      // qSA considers elements outside a scoping root when evaluating child or
                      // descendant combinators, which is not what we want.
                      // In such cases, we work around the behavior by prefixing every selector in the
                      // list with an ID selector referencing the scope context.
                      // The technique has to be used as well when a leading combinator is used
                      // as such selectors are not recognized by querySelectorAll.
                      // Thanks to Andrew Dupont for this technique.
                      if (
                        nodeType === 1 &&
                        (rdescend.test(selector) || rcombinators.test(selector))
                      ) {
                        // Expand context for sibling selectors
                        newContext =
                          (rsibling.test(selector) &&
                            testContext(context.parentNode)) ||
                          context;

                        // We can use :scope instead of the ID hack if the browser
                        // supports it & if we're not changing the context.
                        if (newContext !== context || !support.scope) {
                          // Capture the context ID, setting it first if necessary
                          if ((nid = context.getAttribute("id"))) {
                            nid = nid.replace(rcssescape, fcssescape);
                          } else {
                            context.setAttribute("id", (nid = expando));
                          }
                        }

                        // Prefix every selector in the list
                        groups = tokenize(selector);
                        i = groups.length;
                        while (i--) {
                          groups[i] =
                            (nid ? "#" + nid : ":scope") +
                            " " +
                            toSelector(groups[i]);
                        }
                        newSelector = groups.join(",");
                      }

                      try {
                        push.apply(
                          results,
                          newContext.querySelectorAll(newSelector)
                        );
                        return results;
                      } catch (qsaError) {
                        nonnativeSelectorCache(selector, true);
                      } finally {
                        if (nid === expando) {
                          context.removeAttribute("id");
                        }
                      }
                    }
                  }
                }

                // All others
                return select(
                  selector.replace(rtrim, "$1"),
                  context,
                  results,
                  seed
                );
              }

              /**
               * Create key-value caches of limited size
               * @returns {function(string, object)} Returns the Object data after storing it on itself with
               *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
               *	deleting the oldest entry
               */
              function createCache() {
                var keys = [];

                function cache(key, value) {
                  // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                  if (keys.push(key + " ") > Expr.cacheLength) {
                    // Only keep the most recent entries
                    delete cache[keys.shift()];
                  }
                  return (cache[key + " "] = value);
                }
                return cache;
              }

              /**
               * Mark a function for special use by Sizzle
               * @param {Function} fn The function to mark
               */
              function markFunction(fn) {
                fn[expando] = true;
                return fn;
              }

              /**
               * Support testing using an element
               * @param {Function} fn Passed the created element and returns a boolean result
               */
              function assert(fn) {
                var el = document.createElement("fieldset");

                try {
                  return !!fn(el);
                } catch (e) {
                  return false;
                } finally {
                  // Remove from its parent by default
                  if (el.parentNode) {
                    el.parentNode.removeChild(el);
                  }

                  // release memory in IE
                  el = null;
                }
              }

              /**
               * Adds the same handler for all of the specified attrs
               * @param {String} attrs Pipe-separated list of attributes
               * @param {Function} handler The method that will be applied
               */
              function addHandle(attrs, handler) {
                var arr = attrs.split("|"),
                  i = arr.length;

                while (i--) {
                  Expr.attrHandle[arr[i]] = handler;
                }
              }

              /**
               * Checks document order of two siblings
               * @param {Element} a
               * @param {Element} b
               * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
               */
              function siblingCheck(a, b) {
                var cur = b && a,
                  diff =
                    cur &&
                    a.nodeType === 1 &&
                    b.nodeType === 1 &&
                    a.sourceIndex - b.sourceIndex;

                // Use IE sourceIndex if available on both nodes
                if (diff) {
                  return diff;
                }

                // Check if b follows a
                if (cur) {
                  while ((cur = cur.nextSibling)) {
                    if (cur === b) {
                      return -1;
                    }
                  }
                }

                return a ? 1 : -1;
              }

              /**
               * Returns a function to use in pseudos for input types
               * @param {String} type
               */
              function createInputPseudo(type) {
                return function (elem) {
                  var name = elem.nodeName.toLowerCase();
                  return name === "input" && elem.type === type;
                };
              }

              /**
               * Returns a function to use in pseudos for buttons
               * @param {String} type
               */
              function createButtonPseudo(type) {
                return function (elem) {
                  var name = elem.nodeName.toLowerCase();
                  return (
                    (name === "input" || name === "button") &&
                    elem.type === type
                  );
                };
              }

              /**
               * Returns a function to use in pseudos for :enabled/:disabled
               * @param {Boolean} disabled true for :disabled; false for :enabled
               */
              function createDisabledPseudo(disabled) {
                // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
                return function (elem) {
                  // Only certain elements can match :enabled or :disabled
                  // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                  // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                  if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                      // Option elements defer to a parent optgroup if present
                      if ("label" in elem) {
                        if ("label" in elem.parentNode) {
                          return elem.parentNode.disabled === disabled;
                        } else {
                          return elem.disabled === disabled;
                        }
                      }

                      // Support: IE 6 - 11
                      // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                      return (
                        elem.isDisabled === disabled ||
                        // Where there is no isDisabled, check manually
                        /* jshint -W018 */
                        (elem.isDisabled !== !disabled &&
                          inDisabledFieldset(elem) === disabled)
                      );
                    }

                    return elem.disabled === disabled;

                    // Try to winnow out elements that can't be disabled before trusting the disabled property.
                    // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                    // even exist on them, let alone have a boolean value.
                  } else if ("label" in elem) {
                    return elem.disabled === disabled;
                  }

                  // Remaining elements are neither :enabled nor :disabled
                  return false;
                };
              }

              /**
               * Returns a function to use in pseudos for positionals
               * @param {Function} fn
               */
              function createPositionalPseudo(fn) {
                return markFunction(function (argument) {
                  argument = +argument;
                  return markFunction(function (seed, matches) {
                    var j,
                      matchIndexes = fn([], seed.length, argument),
                      i = matchIndexes.length;

                    // Match elements found at the specified indexes
                    while (i--) {
                      if (seed[(j = matchIndexes[i])]) {
                        seed[j] = !(matches[j] = seed[j]);
                      }
                    }
                  });
                });
              }

              /**
               * Checks a node for validity as a Sizzle context
               * @param {Element|Object=} context
               * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
               */
              function testContext(context) {
                return (
                  context &&
                  typeof context.getElementsByTagName !== "undefined" &&
                  context
                );
              }

              // Expose support vars for convenience
              support = Sizzle.support = {};

              /**
               * Detects XML nodes
               * @param {Element|Object} elem An element or a document
               * @returns {Boolean} True iff elem is a non-HTML XML node
               */
              isXML = Sizzle.isXML = function (elem) {
                var namespace = elem && elem.namespaceURI,
                  docElem =
                    elem && (elem.ownerDocument || elem).documentElement;

                // Support: IE <=8
                // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
                // https://bugs.jquery.com/ticket/4833
                return !rhtml.test(
                  namespace || (docElem && docElem.nodeName) || "HTML"
                );
              };

              /**
               * Sets document-related variables once based on the current document
               * @param {Element|Object} [doc] An element or document object to use to set the document
               * @returns {Object} Returns the current document
               */
              setDocument = Sizzle.setDocument = function (node) {
                var hasCompare,
                  subWindow,
                  doc = node ? node.ownerDocument || node : preferredDoc;

                // Return early if doc is invalid or already selected
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if (
                  doc == document ||
                  doc.nodeType !== 9 ||
                  !doc.documentElement
                ) {
                  return document;
                }

                // Update global variables
                document = doc;
                docElem = document.documentElement;
                documentIsHTML = !isXML(document);

                // Support: IE 9 - 11+, Edge 12 - 18+
                // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if (
                  preferredDoc != document &&
                  (subWindow = document.defaultView) &&
                  subWindow.top !== subWindow
                ) {
                  // Support: IE 11, Edge
                  if (subWindow.addEventListener) {
                    subWindow.addEventListener("unload", unloadHandler, false);

                    // Support: IE 9 - 10 only
                  } else if (subWindow.attachEvent) {
                    subWindow.attachEvent("onunload", unloadHandler);
                  }
                }

                // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
                // Safari 4 - 5 only, Opera <=11.6 - 12.x only
                // IE/Edge & older browsers don't support the :scope pseudo-class.
                // Support: Safari 6.0 only
                // Safari 6.0 supports :scope but it's an alias of :root there.
                support.scope = assert(function (el) {
                  docElem
                    .appendChild(el)
                    .appendChild(document.createElement("div"));
                  return (
                    typeof el.querySelectorAll !== "undefined" &&
                    !el.querySelectorAll(":scope fieldset div").length
                  );
                });

                /* Attributes
	---------------------------------------------------------------------- */

                // Support: IE<8
                // Verify that getAttribute really returns attributes and not properties
                // (excepting IE8 booleans)
                support.attributes = assert(function (el) {
                  el.className = "i";
                  return !el.getAttribute("className");
                });

                /* getElement(s)By*
	---------------------------------------------------------------------- */

                // Check if getElementsByTagName("*") returns only elements
                support.getElementsByTagName = assert(function (el) {
                  el.appendChild(document.createComment(""));
                  return !el.getElementsByTagName("*").length;
                });

                // Support: IE<9
                support.getElementsByClassName = rnative.test(
                  document.getElementsByClassName
                );

                // Support: IE<10
                // Check if getElementById returns elements by name
                // The broken getElementById methods don't pick up programmatically-set names,
                // so use a roundabout getElementsByName test
                support.getById = assert(function (el) {
                  docElem.appendChild(el).id = expando;
                  return (
                    !document.getElementsByName ||
                    !document.getElementsByName(expando).length
                  );
                });

                // ID filter and find
                if (support.getById) {
                  Expr.filter["ID"] = function (id) {
                    var attrId = id.replace(runescape, funescape);
                    return function (elem) {
                      return elem.getAttribute("id") === attrId;
                    };
                  };
                  Expr.find["ID"] = function (id, context) {
                    if (
                      typeof context.getElementById !== "undefined" &&
                      documentIsHTML
                    ) {
                      var elem = context.getElementById(id);
                      return elem ? [elem] : [];
                    }
                  };
                } else {
                  Expr.filter["ID"] = function (id) {
                    var attrId = id.replace(runescape, funescape);
                    return function (elem) {
                      var node =
                        typeof elem.getAttributeNode !== "undefined" &&
                        elem.getAttributeNode("id");
                      return node && node.value === attrId;
                    };
                  };

                  // Support: IE 6 - 7 only
                  // getElementById is not reliable as a find shortcut
                  Expr.find["ID"] = function (id, context) {
                    if (
                      typeof context.getElementById !== "undefined" &&
                      documentIsHTML
                    ) {
                      var node,
                        i,
                        elems,
                        elem = context.getElementById(id);

                      if (elem) {
                        // Verify the id attribute
                        node = elem.getAttributeNode("id");
                        if (node && node.value === id) {
                          return [elem];
                        }

                        // Fall back on getElementsByName
                        elems = context.getElementsByName(id);
                        i = 0;
                        while ((elem = elems[i++])) {
                          node = elem.getAttributeNode("id");
                          if (node && node.value === id) {
                            return [elem];
                          }
                        }
                      }

                      return [];
                    }
                  };
                }

                // Tag
                Expr.find["TAG"] = support.getElementsByTagName
                  ? function (tag, context) {
                      if (typeof context.getElementsByTagName !== "undefined") {
                        return context.getElementsByTagName(tag);

                        // DocumentFragment nodes don't have gEBTN
                      } else if (support.qsa) {
                        return context.querySelectorAll(tag);
                      }
                    }
                  : function (tag, context) {
                      var elem,
                        tmp = [],
                        i = 0,
                        // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                        results = context.getElementsByTagName(tag);

                      // Filter out possible comments
                      if (tag === "*") {
                        while ((elem = results[i++])) {
                          if (elem.nodeType === 1) {
                            tmp.push(elem);
                          }
                        }

                        return tmp;
                      }
                      return results;
                    };

                // Class
                Expr.find["CLASS"] =
                  support.getElementsByClassName &&
                  function (className, context) {
                    if (
                      typeof context.getElementsByClassName !== "undefined" &&
                      documentIsHTML
                    ) {
                      return context.getElementsByClassName(className);
                    }
                  };

                /* QSA/matchesSelector
	---------------------------------------------------------------------- */

                // QSA and matchesSelector support

                // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
                rbuggyMatches = [];

                // qSa(:focus) reports false when true (Chrome 21)
                // We allow this because of a bug in IE8/9 that throws an error
                // whenever `document.activeElement` is accessed on an iframe
                // So, we allow :focus to pass through QSA all the time to avoid the IE error
                // See https://bugs.jquery.com/ticket/13378
                rbuggyQSA = [];

                if ((support.qsa = rnative.test(document.querySelectorAll))) {
                  // Build QSA regex
                  // Regex strategy adopted from Diego Perini
                  assert(function (el) {
                    var input;

                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML =
                      "<a id='" +
                      expando +
                      "'></a>" +
                      "<select id='" +
                      expando +
                      "-\r\\' msallowcapture=''>" +
                      "<option selected=''></option></select>";

                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) {
                      rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    }

                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) {
                      rbuggyQSA.push(
                        "\\[" + whitespace + "*(?:value|" + booleans + ")"
                      );
                    }

                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
                      rbuggyQSA.push("~=");
                    }

                    // Support: IE 11+, Edge 15 - 18+
                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                    // Adding a temporary attribute to the document before the selection works
                    // around the issue.
                    // Interestingly, IE 10 & older don't seem to have the issue.
                    input = document.createElement("input");
                    input.setAttribute("name", "");
                    el.appendChild(input);
                    if (!el.querySelectorAll("[name='']").length) {
                      rbuggyQSA.push(
                        "\\[" +
                          whitespace +
                          "*name" +
                          whitespace +
                          "*=" +
                          whitespace +
                          "*(?:''|\"\")"
                      );
                    }

                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) {
                      rbuggyQSA.push(":checked");
                    }

                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) {
                      rbuggyQSA.push(".#.+[+~]");
                    }

                    // Support: Firefox <=3.6 - 5 only
                    // Old Firefox doesn't throw on a badly-escaped identifier.
                    el.querySelectorAll("\\\f");
                    rbuggyQSA.push("[\\r\\n\\f]");
                  });

                  assert(function (el) {
                    el.innerHTML =
                      "<a href='' disabled='disabled'></a>" +
                      "<select disabled='disabled'><option/></select>";

                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");

                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) {
                      rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    }

                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) {
                      rbuggyQSA.push(":enabled", ":disabled");
                    }

                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) {
                      rbuggyQSA.push(":enabled", ":disabled");
                    }

                    // Support: Opera 10 - 11 only
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                  });
                }

                if (
                  (support.matchesSelector = rnative.test(
                    (matches =
                      docElem.matches ||
                      docElem.webkitMatchesSelector ||
                      docElem.mozMatchesSelector ||
                      docElem.oMatchesSelector ||
                      docElem.msMatchesSelector)
                  ))
                ) {
                  assert(function (el) {
                    // Check to see if it's possible to do matchesSelector
                    // on a disconnected node (IE 9)
                    support.disconnectedMatch = matches.call(el, "*");

                    // This should fail with an exception
                    // Gecko does not error, returns false instead
                    matches.call(el, "[s!='']:x");
                    rbuggyMatches.push("!=", pseudos);
                  });
                }

                rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
                rbuggyMatches =
                  rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));

                /* Contains
	---------------------------------------------------------------------- */
                hasCompare = rnative.test(docElem.compareDocumentPosition);

                // Element contains another
                // Purposefully self-exclusive
                // As in, an element does not contain itself
                contains =
                  hasCompare || rnative.test(docElem.contains)
                    ? function (a, b) {
                        var adown = a.nodeType === 9 ? a.documentElement : a,
                          bup = b && b.parentNode;
                        return (
                          a === bup ||
                          !!(
                            bup &&
                            bup.nodeType === 1 &&
                            (adown.contains
                              ? adown.contains(bup)
                              : a.compareDocumentPosition &&
                                a.compareDocumentPosition(bup) & 16)
                          )
                        );
                      }
                    : function (a, b) {
                        if (b) {
                          while ((b = b.parentNode)) {
                            if (b === a) {
                              return true;
                            }
                          }
                        }
                        return false;
                      };

                /* Sorting
	---------------------------------------------------------------------- */

                // Document order sorting
                sortOrder = hasCompare
                  ? function (a, b) {
                      // Flag for duplicate removal
                      if (a === b) {
                        hasDuplicate = true;
                        return 0;
                      }

                      // Sort on method existence if only one input has compareDocumentPosition
                      var compare =
                        !a.compareDocumentPosition - !b.compareDocumentPosition;
                      if (compare) {
                        return compare;
                      }

                      // Calculate position if both inputs belong to the same document
                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      // eslint-disable-next-line eqeqeq
                      compare =
                        (a.ownerDocument || a) == (b.ownerDocument || b)
                          ? a.compareDocumentPosition(b)
                          : // Otherwise we know they are disconnected
                            1;

                      // Disconnected nodes
                      if (
                        compare & 1 ||
                        (!support.sortDetached &&
                          b.compareDocumentPosition(a) === compare)
                      ) {
                        // Choose the first element that is related to our preferred document
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (
                          a == document ||
                          (a.ownerDocument == preferredDoc &&
                            contains(preferredDoc, a))
                        ) {
                          return -1;
                        }

                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (
                          b == document ||
                          (b.ownerDocument == preferredDoc &&
                            contains(preferredDoc, b))
                        ) {
                          return 1;
                        }

                        // Maintain original order
                        return sortInput
                          ? indexOf(sortInput, a) - indexOf(sortInput, b)
                          : 0;
                      }

                      return compare & 4 ? -1 : 1;
                    }
                  : function (a, b) {
                      // Exit early if the nodes are identical
                      if (a === b) {
                        hasDuplicate = true;
                        return 0;
                      }

                      var cur,
                        i = 0,
                        aup = a.parentNode,
                        bup = b.parentNode,
                        ap = [a],
                        bp = [b];

                      // Parentless nodes are either documents or disconnected
                      if (!aup || !bup) {
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        /* eslint-disable eqeqeq */
                        return a == document
                          ? -1
                          : b == document
                          ? 1
                          : /* eslint-enable eqeqeq */
                          aup
                          ? -1
                          : bup
                          ? 1
                          : sortInput
                          ? indexOf(sortInput, a) - indexOf(sortInput, b)
                          : 0;

                        // If the nodes are siblings, we can do a quick check
                      } else if (aup === bup) {
                        return siblingCheck(a, b);
                      }

                      // Otherwise we need full lists of their ancestors for comparison
                      cur = a;
                      while ((cur = cur.parentNode)) {
                        ap.unshift(cur);
                      }
                      cur = b;
                      while ((cur = cur.parentNode)) {
                        bp.unshift(cur);
                      }

                      // Walk down the tree looking for a discrepancy
                      while (ap[i] === bp[i]) {
                        i++;
                      }

                      return i
                        ? // Do a sibling check if the nodes have a common ancestor
                          siblingCheck(ap[i], bp[i])
                        : // Otherwise nodes in our document sort first
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        /* eslint-disable eqeqeq */
                        ap[i] == preferredDoc
                        ? -1
                        : bp[i] == preferredDoc
                        ? 1
                        : /* eslint-enable eqeqeq */
                          0;
                    };

                return document;
              };

              Sizzle.matches = function (expr, elements) {
                return Sizzle(expr, null, null, elements);
              };

              Sizzle.matchesSelector = function (elem, expr) {
                setDocument(elem);

                if (
                  support.matchesSelector &&
                  documentIsHTML &&
                  !nonnativeSelectorCache[expr + " "] &&
                  (!rbuggyMatches || !rbuggyMatches.test(expr)) &&
                  (!rbuggyQSA || !rbuggyQSA.test(expr))
                ) {
                  try {
                    var ret = matches.call(elem, expr);

                    // IE 9's matchesSelector returns false on disconnected nodes
                    if (
                      ret ||
                      support.disconnectedMatch ||
                      // As well, disconnected nodes are said to be in a document
                      // fragment in IE 9
                      (elem.document && elem.document.nodeType !== 11)
                    ) {
                      return ret;
                    }
                  } catch (e) {
                    nonnativeSelectorCache(expr, true);
                  }
                }

                return Sizzle(expr, document, null, [elem]).length > 0;
              };

              Sizzle.contains = function (context, elem) {
                // Set document vars if needed
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if ((context.ownerDocument || context) != document) {
                  setDocument(context);
                }
                return contains(context, elem);
              };

              Sizzle.attr = function (elem, name) {
                // Set document vars if needed
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if ((elem.ownerDocument || elem) != document) {
                  setDocument(elem);
                }

                var fn = Expr.attrHandle[name.toLowerCase()],
                  // Don't get fooled by Object.prototype properties (jQuery #13807)
                  val =
                    fn && hasOwn.call(Expr.attrHandle, name.toLowerCase())
                      ? fn(elem, name, !documentIsHTML)
                      : undefined;

                return val !== undefined
                  ? val
                  : support.attributes || !documentIsHTML
                  ? elem.getAttribute(name)
                  : (val = elem.getAttributeNode(name)) && val.specified
                  ? val.value
                  : null;
              };

              Sizzle.escape = function (sel) {
                return (sel + "").replace(rcssescape, fcssescape);
              };

              Sizzle.error = function (msg) {
                throw new Error(
                  "Syntax error, unrecognized expression: " + msg
                );
              };

              /**
               * Document sorting and removing duplicates
               * @param {ArrayLike} results
               */
              Sizzle.uniqueSort = function (results) {
                var elem,
                  duplicates = [],
                  j = 0,
                  i = 0;

                // Unless we *know* we can detect duplicates, assume their presence
                hasDuplicate = !support.detectDuplicates;
                sortInput = !support.sortStable && results.slice(0);
                results.sort(sortOrder);

                if (hasDuplicate) {
                  while ((elem = results[i++])) {
                    if (elem === results[i]) {
                      j = duplicates.push(i);
                    }
                  }
                  while (j--) {
                    results.splice(duplicates[j], 1);
                  }
                }

                // Clear input after sorting to release objects
                // See https://github.com/jquery/sizzle/pull/225
                sortInput = null;

                return results;
              };

              /**
               * Utility function for retrieving the text value of an array of DOM nodes
               * @param {Array|Element} elem
               */
              getText = Sizzle.getText = function (elem) {
                var node,
                  ret = "",
                  i = 0,
                  nodeType = elem.nodeType;

                if (!nodeType) {
                  // If no nodeType, this is expected to be an array
                  while ((node = elem[i++])) {
                    // Do not traverse comment nodes
                    ret += getText(node);
                  }
                } else if (
                  nodeType === 1 ||
                  nodeType === 9 ||
                  nodeType === 11
                ) {
                  // Use textContent for elements
                  // innerText usage removed for consistency of new lines (jQuery #11153)
                  if (typeof elem.textContent === "string") {
                    return elem.textContent;
                  } else {
                    // Traverse its children
                    for (
                      elem = elem.firstChild;
                      elem;
                      elem = elem.nextSibling
                    ) {
                      ret += getText(elem);
                    }
                  }
                } else if (nodeType === 3 || nodeType === 4) {
                  return elem.nodeValue;
                }

                // Do not include comment or processing instruction nodes

                return ret;
              };

              Expr = Sizzle.selectors = {
                // Can be adjusted by the user
                cacheLength: 50,

                createPseudo: markFunction,

                match: matchExpr,

                attrHandle: {},

                find: {},

                relative: {
                  ">": { dir: "parentNode", first: true },
                  " ": { dir: "parentNode" },
                  "+": { dir: "previousSibling", first: true },
                  "~": { dir: "previousSibling" },
                },

                preFilter: {
                  ATTR: function (match) {
                    match[1] = match[1].replace(runescape, funescape);

                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(
                      runescape,
                      funescape
                    );

                    if (match[2] === "~=") {
                      match[3] = " " + match[3] + " ";
                    }

                    return match.slice(0, 4);
                  },

                  CHILD: function (match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
                    match[1] = match[1].toLowerCase();

                    if (match[1].slice(0, 3) === "nth") {
                      // nth-* requires argument
                      if (!match[3]) {
                        Sizzle.error(match[0]);
                      }

                      // numeric x and y parameters for Expr.filter.CHILD
                      // remember that false/true cast respectively to 0/1
                      match[4] = +(match[4]
                        ? match[5] + (match[6] || 1)
                        : 2 * (match[3] === "even" || match[3] === "odd"));
                      match[5] = +(match[7] + match[8] || match[3] === "odd");

                      // other types prohibit arguments
                    } else if (match[3]) {
                      Sizzle.error(match[0]);
                    }

                    return match;
                  },

                  PSEUDO: function (match) {
                    var excess,
                      unquoted = !match[6] && match[2];

                    if (matchExpr["CHILD"].test(match[0])) {
                      return null;
                    }

                    // Accept quoted arguments as-is
                    if (match[3]) {
                      match[2] = match[4] || match[5] || "";

                      // Strip excess characters from unquoted arguments
                    } else if (
                      unquoted &&
                      rpseudo.test(unquoted) &&
                      // Get excess from tokenize (recursively)
                      (excess = tokenize(unquoted, true)) &&
                      // advance to the next closing parenthesis
                      (excess =
                        unquoted.indexOf(")", unquoted.length - excess) -
                        unquoted.length)
                    ) {
                      // excess is a negative index
                      match[0] = match[0].slice(0, excess);
                      match[2] = unquoted.slice(0, excess);
                    }

                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                  },
                },

                filter: {
                  TAG: function (nodeNameSelector) {
                    var nodeName = nodeNameSelector
                      .replace(runescape, funescape)
                      .toLowerCase();
                    return nodeNameSelector === "*"
                      ? function () {
                          return true;
                        }
                      : function (elem) {
                          return (
                            elem.nodeName &&
                            elem.nodeName.toLowerCase() === nodeName
                          );
                        };
                  },

                  CLASS: function (className) {
                    var pattern = classCache[className + " "];

                    return (
                      pattern ||
                      ((pattern = new RegExp(
                        "(^|" +
                          whitespace +
                          ")" +
                          className +
                          "(" +
                          whitespace +
                          "|$)"
                      )) &&
                        classCache(className, function (elem) {
                          return pattern.test(
                            (typeof elem.className === "string" &&
                              elem.className) ||
                              (typeof elem.getAttribute !== "undefined" &&
                                elem.getAttribute("class")) ||
                              ""
                          );
                        }))
                    );
                  },

                  ATTR: function (name, operator, check) {
                    return function (elem) {
                      var result = Sizzle.attr(elem, name);

                      if (result == null) {
                        return operator === "!=";
                      }
                      if (!operator) {
                        return true;
                      }

                      result += "";

                      /* eslint-disable max-len */

                      return operator === "="
                        ? result === check
                        : operator === "!="
                        ? result !== check
                        : operator === "^="
                        ? check && result.indexOf(check) === 0
                        : operator === "*="
                        ? check && result.indexOf(check) > -1
                        : operator === "$="
                        ? check && result.slice(-check.length) === check
                        : operator === "~="
                        ? (
                            " " +
                            result.replace(rwhitespace, " ") +
                            " "
                          ).indexOf(check) > -1
                        : operator === "|="
                        ? result === check ||
                          result.slice(0, check.length + 1) === check + "-"
                        : false;
                      /* eslint-enable max-len */
                    };
                  },

                  CHILD: function (type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth",
                      forward = type.slice(-4) !== "last",
                      ofType = what === "of-type";

                    return first === 1 && last === 0
                      ? // Shortcut for :nth-*(n)
                        function (elem) {
                          return !!elem.parentNode;
                        }
                      : function (elem, _context, xml) {
                          var cache,
                            uniqueCache,
                            outerCache,
                            node,
                            nodeIndex,
                            start,
                            dir =
                              simple !== forward
                                ? "nextSibling"
                                : "previousSibling",
                            parent = elem.parentNode,
                            name = ofType && elem.nodeName.toLowerCase(),
                            useCache = !xml && !ofType,
                            diff = false;

                          if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                              while (dir) {
                                node = elem;
                                while ((node = node[dir])) {
                                  if (
                                    ofType
                                      ? node.nodeName.toLowerCase() === name
                                      : node.nodeType === 1
                                  ) {
                                    return false;
                                  }
                                }

                                // Reverse direction for :only-* (if we haven't yet done so)
                                start = dir =
                                  type === "only" && !start && "nextSibling";
                              }
                              return true;
                            }

                            start = [
                              forward ? parent.firstChild : parent.lastChild,
                            ];

                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                              // Seek `elem` from a previously-cached index

                              // ...in a gzip-friendly way
                              node = parent;
                              outerCache =
                                node[expando] || (node[expando] = {});

                              // Support: IE <9 only
                              // Defend against cloned attroperties (jQuery gh-1709)
                              uniqueCache =
                                outerCache[node.uniqueID] ||
                                (outerCache[node.uniqueID] = {});

                              cache = uniqueCache[type] || [];
                              nodeIndex = cache[0] === dirruns && cache[1];
                              diff = nodeIndex && cache[2];
                              node = nodeIndex && parent.childNodes[nodeIndex];

                              while (
                                (node =
                                  (++nodeIndex && node && node[dir]) ||
                                  // Fallback to seeking `elem` from the start
                                  (diff = nodeIndex = 0) ||
                                  start.pop())
                              ) {
                                // When found, cache indexes on `parent` and break
                                if (
                                  node.nodeType === 1 &&
                                  ++diff &&
                                  node === elem
                                ) {
                                  uniqueCache[type] = [
                                    dirruns,
                                    nodeIndex,
                                    diff,
                                  ];
                                  break;
                                }
                              }
                            } else {
                              // Use previously-cached element index if available
                              if (useCache) {
                                // ...in a gzip-friendly way
                                node = elem;
                                outerCache =
                                  node[expando] || (node[expando] = {});

                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache =
                                  outerCache[node.uniqueID] ||
                                  (outerCache[node.uniqueID] = {});

                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex;
                              }

                              // xml :nth-child(...)
                              // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                              if (diff === false) {
                                // Use the same loop as above to seek `elem` from the start
                                while (
                                  (node =
                                    (++nodeIndex && node && node[dir]) ||
                                    (diff = nodeIndex = 0) ||
                                    start.pop())
                                ) {
                                  if (
                                    (ofType
                                      ? node.nodeName.toLowerCase() === name
                                      : node.nodeType === 1) &&
                                    ++diff
                                  ) {
                                    // Cache the index of each encountered element
                                    if (useCache) {
                                      outerCache =
                                        node[expando] || (node[expando] = {});

                                      // Support: IE <9 only
                                      // Defend against cloned attroperties (jQuery gh-1709)
                                      uniqueCache =
                                        outerCache[node.uniqueID] ||
                                        (outerCache[node.uniqueID] = {});

                                      uniqueCache[type] = [dirruns, diff];
                                    }

                                    if (node === elem) {
                                      break;
                                    }
                                  }
                                }
                              }
                            }

                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return (
                              diff === first ||
                              (diff % first === 0 && diff / first >= 0)
                            );
                          }
                        };
                  },

                  PSEUDO: function (pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args,
                      fn =
                        Expr.pseudos[pseudo] ||
                        Expr.setFilters[pseudo.toLowerCase()] ||
                        Sizzle.error("unsupported pseudo: " + pseudo);

                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) {
                      return fn(argument);
                    }

                    // But maintain support for old signatures
                    if (fn.length > 1) {
                      args = [pseudo, pseudo, "", argument];
                      return Expr.setFilters.hasOwnProperty(
                        pseudo.toLowerCase()
                      )
                        ? markFunction(function (seed, matches) {
                            var idx,
                              matched = fn(seed, argument),
                              i = matched.length;
                            while (i--) {
                              idx = indexOf(seed, matched[i]);
                              seed[idx] = !(matches[idx] = matched[i]);
                            }
                          })
                        : function (elem) {
                            return fn(elem, 0, args);
                          };
                    }

                    return fn;
                  },
                },

                pseudos: {
                  // Potentially complex pseudos
                  not: markFunction(function (selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [],
                      results = [],
                      matcher = compile(selector.replace(rtrim, "$1"));

                    return matcher[expando]
                      ? markFunction(function (seed, matches, _context, xml) {
                          var elem,
                            unmatched = matcher(seed, null, xml, []),
                            i = seed.length;

                          // Match elements unmatched by `matcher`
                          while (i--) {
                            if ((elem = unmatched[i])) {
                              seed[i] = !(matches[i] = elem);
                            }
                          }
                        })
                      : function (elem, _context, xml) {
                          input[0] = elem;
                          matcher(input, null, xml, results);

                          // Don't keep the element (issue #299)
                          input[0] = null;
                          return !results.pop();
                        };
                  }),

                  has: markFunction(function (selector) {
                    return function (elem) {
                      return Sizzle(selector, elem).length > 0;
                    };
                  }),

                  contains: markFunction(function (text) {
                    text = text.replace(runescape, funescape);
                    return function (elem) {
                      return (
                        (elem.textContent || getText(elem)).indexOf(text) > -1
                      );
                    };
                  }),

                  // "Whether an element is represented by a :lang() selector
                  // is based solely on the element's language value
                  // being equal to the identifier C,
                  // or beginning with the identifier C immediately followed by "-".
                  // The matching of C against the element's language value is performed case-insensitively.
                  // The identifier C does not have to be a valid language name."
                  // http://www.w3.org/TR/selectors/#lang-pseudo
                  lang: markFunction(function (lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) {
                      Sizzle.error("unsupported lang: " + lang);
                    }
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function (elem) {
                      var elemLang;
                      do {
                        if (
                          (elemLang = documentIsHTML
                            ? elem.lang
                            : elem.getAttribute("xml:lang") ||
                              elem.getAttribute("lang"))
                        ) {
                          elemLang = elemLang.toLowerCase();
                          return (
                            elemLang === lang ||
                            elemLang.indexOf(lang + "-") === 0
                          );
                        }
                      } while ((elem = elem.parentNode) && elem.nodeType === 1);
                      return false;
                    };
                  }),

                  // Miscellaneous
                  target: function (elem) {
                    var hash = window.location && window.location.hash;
                    return hash && hash.slice(1) === elem.id;
                  },

                  root: function (elem) {
                    return elem === docElem;
                  },

                  focus: function (elem) {
                    return (
                      elem === document.activeElement &&
                      (!document.hasFocus || document.hasFocus()) &&
                      !!(elem.type || elem.href || ~elem.tabIndex)
                    );
                  },

                  // Boolean properties
                  enabled: createDisabledPseudo(false),
                  disabled: createDisabledPseudo(true),

                  checked: function (elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return (
                      (nodeName === "input" && !!elem.checked) ||
                      (nodeName === "option" && !!elem.selected)
                    );
                  },

                  selected: function (elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) {
                      // eslint-disable-next-line no-unused-expressions
                      elem.parentNode.selectedIndex;
                    }

                    return elem.selected === true;
                  },

                  // Contents
                  empty: function (elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for (
                      elem = elem.firstChild;
                      elem;
                      elem = elem.nextSibling
                    ) {
                      if (elem.nodeType < 6) {
                        return false;
                      }
                    }
                    return true;
                  },

                  parent: function (elem) {
                    return !Expr.pseudos["empty"](elem);
                  },

                  // Element/input types
                  header: function (elem) {
                    return rheader.test(elem.nodeName);
                  },

                  input: function (elem) {
                    return rinputs.test(elem.nodeName);
                  },

                  button: function (elem) {
                    var name = elem.nodeName.toLowerCase();
                    return (
                      (name === "input" && elem.type === "button") ||
                      name === "button"
                    );
                  },

                  text: function (elem) {
                    var attr;
                    return (
                      elem.nodeName.toLowerCase() === "input" &&
                      elem.type === "text" &&
                      // Support: IE<8
                      // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                      ((attr = elem.getAttribute("type")) == null ||
                        attr.toLowerCase() === "text")
                    );
                  },

                  // Position-in-collection
                  first: createPositionalPseudo(function () {
                    return [0];
                  }),

                  last: createPositionalPseudo(function (
                    _matchIndexes,
                    length
                  ) {
                    return [length - 1];
                  }),

                  eq: createPositionalPseudo(function (
                    _matchIndexes,
                    length,
                    argument
                  ) {
                    return [argument < 0 ? argument + length : argument];
                  }),

                  even: createPositionalPseudo(function (matchIndexes, length) {
                    var i = 0;
                    for (; i < length; i += 2) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  odd: createPositionalPseudo(function (matchIndexes, length) {
                    var i = 1;
                    for (; i < length; i += 2) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  lt: createPositionalPseudo(function (
                    matchIndexes,
                    length,
                    argument
                  ) {
                    var i =
                      argument < 0
                        ? argument + length
                        : argument > length
                        ? length
                        : argument;
                    for (; --i >= 0; ) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  gt: createPositionalPseudo(function (
                    matchIndexes,
                    length,
                    argument
                  ) {
                    var i = argument < 0 ? argument + length : argument;
                    for (; ++i < length; ) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),
                },
              };

              Expr.pseudos["nth"] = Expr.pseudos["eq"];

              // Add button/input type pseudos
              for (i in {
                radio: true,
                checkbox: true,
                file: true,
                password: true,
                image: true,
              }) {
                Expr.pseudos[i] = createInputPseudo(i);
              }
              for (i in { submit: true, reset: true }) {
                Expr.pseudos[i] = createButtonPseudo(i);
              }

              // Easy API for creating new setFilters
              function setFilters() {}
              setFilters.prototype = Expr.filters = Expr.pseudos;
              Expr.setFilters = new setFilters();

              tokenize = Sizzle.tokenize = function (selector, parseOnly) {
                var matched,
                  match,
                  tokens,
                  type,
                  soFar,
                  groups,
                  preFilters,
                  cached = tokenCache[selector + " "];

                if (cached) {
                  return parseOnly ? 0 : cached.slice(0);
                }

                soFar = selector;
                groups = [];
                preFilters = Expr.preFilter;

                while (soFar) {
                  // Comma and first run
                  if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) {
                      // Don't consume trailing commas as valid
                      soFar = soFar.slice(match[0].length) || soFar;
                    }
                    groups.push((tokens = []));
                  }

                  matched = false;

                  // Combinators
                  if ((match = rcombinators.exec(soFar))) {
                    matched = match.shift();
                    tokens.push({
                      value: matched,

                      // Cast descendant combinators to space
                      type: match[0].replace(rtrim, " "),
                    });
                    soFar = soFar.slice(matched.length);
                  }

                  // Filters
                  for (type in Expr.filter) {
                    if (
                      (match = matchExpr[type].exec(soFar)) &&
                      (!preFilters[type] || (match = preFilters[type](match)))
                    ) {
                      matched = match.shift();
                      tokens.push({
                        value: matched,
                        type: type,
                        matches: match,
                      });
                      soFar = soFar.slice(matched.length);
                    }
                  }

                  if (!matched) {
                    break;
                  }
                }

                // Return the length of the invalid excess
                // if we're just parsing
                // Otherwise, throw an error or return tokens
                return parseOnly
                  ? soFar.length
                  : soFar
                  ? Sizzle.error(selector)
                  : // Cache the tokens
                    tokenCache(selector, groups).slice(0);
              };

              function toSelector(tokens) {
                var i = 0,
                  len = tokens.length,
                  selector = "";
                for (; i < len; i++) {
                  selector += tokens[i].value;
                }
                return selector;
              }

              function addCombinator(matcher, combinator, base) {
                var dir = combinator.dir,
                  skip = combinator.next,
                  key = skip || dir,
                  checkNonElements = base && key === "parentNode",
                  doneName = done++;

                return combinator.first
                  ? // Check against closest ancestor/preceding element
                    function (elem, context, xml) {
                      while ((elem = elem[dir])) {
                        if (elem.nodeType === 1 || checkNonElements) {
                          return matcher(elem, context, xml);
                        }
                      }
                      return false;
                    }
                  : // Check against all ancestor/preceding elements
                    function (elem, context, xml) {
                      var oldCache,
                        uniqueCache,
                        outerCache,
                        newCache = [dirruns, doneName];

                      // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                      if (xml) {
                        while ((elem = elem[dir])) {
                          if (elem.nodeType === 1 || checkNonElements) {
                            if (matcher(elem, context, xml)) {
                              return true;
                            }
                          }
                        }
                      } else {
                        while ((elem = elem[dir])) {
                          if (elem.nodeType === 1 || checkNonElements) {
                            outerCache = elem[expando] || (elem[expando] = {});

                            // Support: IE <9 only
                            // Defend against cloned attroperties (jQuery gh-1709)
                            uniqueCache =
                              outerCache[elem.uniqueID] ||
                              (outerCache[elem.uniqueID] = {});

                            if (skip && skip === elem.nodeName.toLowerCase()) {
                              elem = elem[dir] || elem;
                            } else if (
                              (oldCache = uniqueCache[key]) &&
                              oldCache[0] === dirruns &&
                              oldCache[1] === doneName
                            ) {
                              // Assign to newCache so results back-propagate to previous elements
                              return (newCache[2] = oldCache[2]);
                            } else {
                              // Reuse newcache so results back-propagate to previous elements
                              uniqueCache[key] = newCache;

                              // A match means we're done; a fail means we have to keep checking
                              if ((newCache[2] = matcher(elem, context, xml))) {
                                return true;
                              }
                            }
                          }
                        }
                      }
                      return false;
                    };
              }

              function elementMatcher(matchers) {
                return matchers.length > 1
                  ? function (elem, context, xml) {
                      var i = matchers.length;
                      while (i--) {
                        if (!matchers[i](elem, context, xml)) {
                          return false;
                        }
                      }
                      return true;
                    }
                  : matchers[0];
              }

              function multipleContexts(selector, contexts, results) {
                var i = 0,
                  len = contexts.length;
                for (; i < len; i++) {
                  Sizzle(selector, contexts[i], results);
                }
                return results;
              }

              function condense(unmatched, map, filter, context, xml) {
                var elem,
                  newUnmatched = [],
                  i = 0,
                  len = unmatched.length,
                  mapped = map != null;

                for (; i < len; i++) {
                  if ((elem = unmatched[i])) {
                    if (!filter || filter(elem, context, xml)) {
                      newUnmatched.push(elem);
                      if (mapped) {
                        map.push(i);
                      }
                    }
                  }
                }

                return newUnmatched;
              }

              function setMatcher(
                preFilter,
                selector,
                matcher,
                postFilter,
                postFinder,
                postSelector
              ) {
                if (postFilter && !postFilter[expando]) {
                  postFilter = setMatcher(postFilter);
                }
                if (postFinder && !postFinder[expando]) {
                  postFinder = setMatcher(postFinder, postSelector);
                }
                return markFunction(function (seed, results, context, xml) {
                  var temp,
                    i,
                    elem,
                    preMap = [],
                    postMap = [],
                    preexisting = results.length,
                    // Get initial elements from seed or context
                    elems =
                      seed ||
                      multipleContexts(
                        selector || "*",
                        context.nodeType ? [context] : context,
                        []
                      ),
                    // Prefilter to get matcher input, preserving a map for seed-results synchronization
                    matcherIn =
                      preFilter && (seed || !selector)
                        ? condense(elems, preMap, preFilter, context, xml)
                        : elems,
                    matcherOut = matcher
                      ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                        postFinder ||
                        (seed ? preFilter : preexisting || postFilter)
                        ? // ...intermediate processing is necessary
                          []
                        : // ...otherwise use results directly
                          results
                      : matcherIn;

                  // Find primary matches
                  if (matcher) {
                    matcher(matcherIn, matcherOut, context, xml);
                  }

                  // Apply postFilter
                  if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);

                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while (i--) {
                      if ((elem = temp[i])) {
                        matcherOut[postMap[i]] = !(matcherIn[postMap[i]] =
                          elem);
                      }
                    }
                  }

                  if (seed) {
                    if (postFinder || preFilter) {
                      if (postFinder) {
                        // Get the final matcherOut by condensing this intermediate into postFinder contexts
                        temp = [];
                        i = matcherOut.length;
                        while (i--) {
                          if ((elem = matcherOut[i])) {
                            // Restore matcherIn since elem is not yet a final match
                            temp.push((matcherIn[i] = elem));
                          }
                        }
                        postFinder(null, (matcherOut = []), temp, xml);
                      }

                      // Move matched elements from seed to results to keep them synchronized
                      i = matcherOut.length;
                      while (i--) {
                        if (
                          (elem = matcherOut[i]) &&
                          (temp = postFinder
                            ? indexOf(seed, elem)
                            : preMap[i]) > -1
                        ) {
                          seed[temp] = !(results[temp] = elem);
                        }
                      }
                    }

                    // Add elements to results, through postFinder if defined
                  } else {
                    matcherOut = condense(
                      matcherOut === results
                        ? matcherOut.splice(preexisting, matcherOut.length)
                        : matcherOut
                    );
                    if (postFinder) {
                      postFinder(null, results, matcherOut, xml);
                    } else {
                      push.apply(results, matcherOut);
                    }
                  }
                });
              }

              function matcherFromTokens(tokens) {
                var checkContext,
                  matcher,
                  j,
                  len = tokens.length,
                  leadingRelative = Expr.relative[tokens[0].type],
                  implicitRelative = leadingRelative || Expr.relative[" "],
                  i = leadingRelative ? 1 : 0,
                  // The foundational matcher ensures that elements are reachable from top-level context(s)
                  matchContext = addCombinator(
                    function (elem) {
                      return elem === checkContext;
                    },
                    implicitRelative,
                    true
                  ),
                  matchAnyContext = addCombinator(
                    function (elem) {
                      return indexOf(checkContext, elem) > -1;
                    },
                    implicitRelative,
                    true
                  ),
                  matchers = [
                    function (elem, context, xml) {
                      var ret =
                        (!leadingRelative &&
                          (xml || context !== outermostContext)) ||
                        ((checkContext = context).nodeType
                          ? matchContext(elem, context, xml)
                          : matchAnyContext(elem, context, xml));

                      // Avoid hanging onto element (issue #299)
                      checkContext = null;
                      return ret;
                    },
                  ];

                for (; i < len; i++) {
                  if ((matcher = Expr.relative[tokens[i].type])) {
                    matchers = [
                      addCombinator(elementMatcher(matchers), matcher),
                    ];
                  } else {
                    matcher = Expr.filter[tokens[i].type].apply(
                      null,
                      tokens[i].matches
                    );

                    // Return special upon seeing a positional matcher
                    if (matcher[expando]) {
                      // Find the next relative operator (if any) for proper handling
                      j = ++i;
                      for (; j < len; j++) {
                        if (Expr.relative[tokens[j].type]) {
                          break;
                        }
                      }
                      return setMatcher(
                        i > 1 && elementMatcher(matchers),
                        i > 1 &&
                          toSelector(
                            // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                            tokens.slice(0, i - 1).concat({
                              value: tokens[i - 2].type === " " ? "*" : "",
                            })
                          ).replace(rtrim, "$1"),
                        matcher,
                        i < j && matcherFromTokens(tokens.slice(i, j)),
                        j < len &&
                          matcherFromTokens((tokens = tokens.slice(j))),
                        j < len && toSelector(tokens)
                      );
                    }
                    matchers.push(matcher);
                  }
                }

                return elementMatcher(matchers);
              }

              function matcherFromGroupMatchers(elementMatchers, setMatchers) {
                var bySet = setMatchers.length > 0,
                  byElement = elementMatchers.length > 0,
                  superMatcher = function (
                    seed,
                    context,
                    xml,
                    results,
                    outermost
                  ) {
                    var elem,
                      j,
                      matcher,
                      matchedCount = 0,
                      i = "0",
                      unmatched = seed && [],
                      setMatched = [],
                      contextBackup = outermostContext,
                      // We must always have either seed elements or outermost context
                      elems =
                        seed || (byElement && Expr.find["TAG"]("*", outermost)),
                      // Use integer dirruns iff this is the outermost matcher
                      dirrunsUnique = (dirruns +=
                        contextBackup == null ? 1 : Math.random() || 0.1),
                      len = elems.length;

                    if (outermost) {
                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      // eslint-disable-next-line eqeqeq
                      outermostContext =
                        context == document || context || outermost;
                    }

                    // Add elements passing elementMatchers directly to results
                    // Support: IE<9, Safari
                    // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                    for (; i !== len && (elem = elems[i]) != null; i++) {
                      if (byElement && elem) {
                        j = 0;

                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                          setDocument(elem);
                          xml = !documentIsHTML;
                        }
                        while ((matcher = elementMatchers[j++])) {
                          if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                          }
                        }
                        if (outermost) {
                          dirruns = dirrunsUnique;
                        }
                      }

                      // Track unmatched elements for set filters
                      if (bySet) {
                        // They will have gone through all possible matchers
                        if ((elem = !matcher && elem)) {
                          matchedCount--;
                        }

                        // Lengthen the array for every element, matched or not
                        if (seed) {
                          unmatched.push(elem);
                        }
                      }
                    }

                    // `i` is now the count of elements visited above, and adding it to `matchedCount`
                    // makes the latter nonnegative.
                    matchedCount += i;

                    // Apply set filters to unmatched elements
                    // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                    // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                    // no element matchers and no seed.
                    // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                    // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                    // numerically zero.
                    if (bySet && i !== matchedCount) {
                      j = 0;
                      while ((matcher = setMatchers[j++])) {
                        matcher(unmatched, setMatched, context, xml);
                      }

                      if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                          while (i--) {
                            if (!(unmatched[i] || setMatched[i])) {
                              setMatched[i] = pop.call(results);
                            }
                          }
                        }

                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                      }

                      // Add matches to results
                      push.apply(results, setMatched);

                      // Seedless set matches succeeding multiple successful matchers stipulate sorting
                      if (
                        outermost &&
                        !seed &&
                        setMatched.length > 0 &&
                        matchedCount + setMatchers.length > 1
                      ) {
                        Sizzle.uniqueSort(results);
                      }
                    }

                    // Override manipulation of globals by nested matchers
                    if (outermost) {
                      dirruns = dirrunsUnique;
                      outermostContext = contextBackup;
                    }

                    return unmatched;
                  };

                return bySet ? markFunction(superMatcher) : superMatcher;
              }

              compile = Sizzle.compile = function (
                selector,
                match /* Internal Use Only */
              ) {
                var i,
                  setMatchers = [],
                  elementMatchers = [],
                  cached = compilerCache[selector + " "];

                if (!cached) {
                  // Generate a function of recursive functions that can be used to check each element
                  if (!match) {
                    match = tokenize(selector);
                  }
                  i = match.length;
                  while (i--) {
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) {
                      setMatchers.push(cached);
                    } else {
                      elementMatchers.push(cached);
                    }
                  }

                  // Cache the compiled function
                  cached = compilerCache(
                    selector,
                    matcherFromGroupMatchers(elementMatchers, setMatchers)
                  );

                  // Save selector and tokenization
                  cached.selector = selector;
                }
                return cached;
              };

              /**
               * A low-level selection function that works with Sizzle's compiled
               *  selector functions
               * @param {String|Function} selector A selector or a pre-compiled
               *  selector function built with Sizzle.compile
               * @param {Element} context
               * @param {Array} [results]
               * @param {Array} [seed] A set of elements to match against
               */
              select = Sizzle.select = function (
                selector,
                context,
                results,
                seed
              ) {
                var i,
                  tokens,
                  token,
                  type,
                  find,
                  compiled = typeof selector === "function" && selector,
                  match =
                    !seed &&
                    tokenize((selector = compiled.selector || selector));

                results = results || [];

                // Try to minimize operations if there is only one selector in the list and no seed
                // (the latter of which guarantees us context)
                if (match.length === 1) {
                  // Reduce context if the leading compound selector is an ID
                  tokens = match[0] = match[0].slice(0);
                  if (
                    tokens.length > 2 &&
                    (token = tokens[0]).type === "ID" &&
                    context.nodeType === 9 &&
                    documentIsHTML &&
                    Expr.relative[tokens[1].type]
                  ) {
                    context = (Expr.find["ID"](
                      token.matches[0].replace(runescape, funescape),
                      context
                    ) || [])[0];
                    if (!context) {
                      return results;

                      // Precompiled matchers will still verify ancestry, so step up a level
                    } else if (compiled) {
                      context = context.parentNode;
                    }

                    selector = selector.slice(tokens.shift().value.length);
                  }

                  // Fetch a seed set for right-to-left matching
                  i = matchExpr["needsContext"].test(selector)
                    ? 0
                    : tokens.length;
                  while (i--) {
                    token = tokens[i];

                    // Abort if we hit a combinator
                    if (Expr.relative[(type = token.type)]) {
                      break;
                    }
                    if ((find = Expr.find[type])) {
                      // Search, expanding context for leading sibling combinators
                      if (
                        (seed = find(
                          token.matches[0].replace(runescape, funescape),
                          (rsibling.test(tokens[0].type) &&
                            testContext(context.parentNode)) ||
                            context
                        ))
                      ) {
                        // If seed is empty or no tokens remain, we can return early
                        tokens.splice(i, 1);
                        selector = seed.length && toSelector(tokens);
                        if (!selector) {
                          push.apply(results, seed);
                          return results;
                        }

                        break;
                      }
                    }
                  }
                }

                // Compile and execute a filtering function if one is not provided
                // Provide `match` to avoid retokenization if we modified the selector above
                (compiled || compile(selector, match))(
                  seed,
                  context,
                  !documentIsHTML,
                  results,
                  !context ||
                    (rsibling.test(selector) &&
                      testContext(context.parentNode)) ||
                    context
                );
                return results;
              };

              // One-time assignments

              // Sort stability
              support.sortStable =
                expando.split("").sort(sortOrder).join("") === expando;

              // Support: Chrome 14-35+
              // Always assume duplicates if they aren't passed to the comparison function
              support.detectDuplicates = !!hasDuplicate;

              // Initialize against the default document
              setDocument();

              // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
              // Detached nodes confoundingly follow *each other*
              support.sortDetached = assert(function (el) {
                // Should return 1, but returns 4 (following)
                return (
                  el.compareDocumentPosition(
                    document.createElement("fieldset")
                  ) & 1
                );
              });

              // Support: IE<8
              // Prevent attribute/property "interpolation"
              // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
              if (
                !assert(function (el) {
                  el.innerHTML = "<a href='#'></a>";
                  return el.firstChild.getAttribute("href") === "#";
                })
              ) {
                addHandle(
                  "type|href|height|width",
                  function (elem, name, isXML) {
                    if (!isXML) {
                      return elem.getAttribute(
                        name,
                        name.toLowerCase() === "type" ? 1 : 2
                      );
                    }
                  }
                );
              }

              // Support: IE<9
              // Use defaultValue in place of getAttribute("value")
              if (
                !support.attributes ||
                !assert(function (el) {
                  el.innerHTML = "<input/>";
                  el.firstChild.setAttribute("value", "");
                  return el.firstChild.getAttribute("value") === "";
                })
              ) {
                addHandle("value", function (elem, _name, isXML) {
                  if (!isXML && elem.nodeName.toLowerCase() === "input") {
                    return elem.defaultValue;
                  }
                });
              }

              // Support: IE<9
              // Use getAttributeNode to fetch booleans when getAttribute lies
              if (
                !assert(function (el) {
                  return el.getAttribute("disabled") == null;
                })
              ) {
                addHandle(booleans, function (elem, name, isXML) {
                  var val;
                  if (!isXML) {
                    return elem[name] === true
                      ? name.toLowerCase()
                      : (val = elem.getAttributeNode(name)) && val.specified
                      ? val.value
                      : null;
                  }
                });
              }

              return Sizzle;
            })(window);

          jQuery.find = Sizzle;
          jQuery.expr = Sizzle.selectors;

          // Deprecated
          jQuery.expr[":"] = jQuery.expr.pseudos;
          jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
          jQuery.text = Sizzle.getText;
          jQuery.isXMLDoc = Sizzle.isXML;
          jQuery.contains = Sizzle.contains;
          jQuery.escapeSelector = Sizzle.escape;

          var dir = function (elem, dir, until) {
            var matched = [],
              truncate = until !== undefined;

            while ((elem = elem[dir]) && elem.nodeType !== 9) {
              if (elem.nodeType === 1) {
                if (truncate && jQuery(elem).is(until)) {
                  break;
                }
                matched.push(elem);
              }
            }
            return matched;
          };

          var siblings = function (n, elem) {
            var matched = [];

            for (; n; n = n.nextSibling) {
              if (n.nodeType === 1 && n !== elem) {
                matched.push(n);
              }
            }

            return matched;
          };

          var rneedsContext = jQuery.expr.match.needsContext;

          function nodeName(elem, name) {
            return (
              elem.nodeName &&
              elem.nodeName.toLowerCase() === name.toLowerCase()
            );
          }
          var rsingleTag =
            /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

          // Implement the identical functionality for filter and not
          function winnow(elements, qualifier, not) {
            if (isFunction(qualifier)) {
              return jQuery.grep(elements, function (elem, i) {
                return !!qualifier.call(elem, i, elem) !== not;
              });
            }

            // Single element
            if (qualifier.nodeType) {
              return jQuery.grep(elements, function (elem) {
                return (elem === qualifier) !== not;
              });
            }

            // Arraylike of elements (jQuery, arguments, Array)
            if (typeof qualifier !== "string") {
              return jQuery.grep(elements, function (elem) {
                return indexOf.call(qualifier, elem) > -1 !== not;
              });
            }

            // Filtered directly for both simple and complex selectors
            return jQuery.filter(qualifier, elements, not);
          }

          jQuery.filter = function (expr, elems, not) {
            var elem = elems[0];

            if (not) {
              expr = ":not(" + expr + ")";
            }

            if (elems.length === 1 && elem.nodeType === 1) {
              return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
            }

            return jQuery.find.matches(
              expr,
              jQuery.grep(elems, function (elem) {
                return elem.nodeType === 1;
              })
            );
          };

          jQuery.fn.extend({
            find: function (selector) {
              var i,
                ret,
                len = this.length,
                self = this;

              if (typeof selector !== "string") {
                return this.pushStack(
                  jQuery(selector).filter(function () {
                    for (i = 0; i < len; i++) {
                      if (jQuery.contains(self[i], this)) {
                        return true;
                      }
                    }
                  })
                );
              }

              ret = this.pushStack([]);

              for (i = 0; i < len; i++) {
                jQuery.find(selector, self[i], ret);
              }

              return len > 1 ? jQuery.uniqueSort(ret) : ret;
            },
            filter: function (selector) {
              return this.pushStack(winnow(this, selector || [], false));
            },
            not: function (selector) {
              return this.pushStack(winnow(this, selector || [], true));
            },
            is: function (selector) {
              return !!winnow(
                this,

                // If this is a positional/relative selector, check membership in the returned set
                // so $("p:first").is("p:last") won't return true for a doc with two "p".
                typeof selector === "string" && rneedsContext.test(selector)
                  ? jQuery(selector)
                  : selector || [],
                false
              ).length;
            },
          });

          // Initialize a jQuery object

          // A central reference to the root jQuery(document)
          var rootjQuery,
            // A simple way to check for HTML strings
            // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
            // Strict HTML recognition (#11290: must start with <)
            // Shortcut simple #id case for speed
            rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
            init = (jQuery.fn.init = function (selector, context, root) {
              var match, elem;

              // HANDLE: $(""), $(null), $(undefined), $(false)
              if (!selector) {
                return this;
              }

              // Method init() accepts an alternate rootjQuery
              // so migrate can support jQuery.sub (gh-2101)
              root = root || rootjQuery;

              // Handle HTML strings
              if (typeof selector === "string") {
                if (
                  selector[0] === "<" &&
                  selector[selector.length - 1] === ">" &&
                  selector.length >= 3
                ) {
                  // Assume that strings that start and end with <> are HTML and skip the regex check
                  match = [null, selector, null];
                } else {
                  match = rquickExpr.exec(selector);
                }

                // Match html or make sure no context is specified for #id
                if (match && (match[1] || !context)) {
                  // HANDLE: $(html) -> $(array)
                  if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;

                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(
                      this,
                      jQuery.parseHTML(
                        match[1],
                        context && context.nodeType
                          ? context.ownerDocument || context
                          : document,
                        true
                      )
                    );

                    // HANDLE: $(html, props)
                    if (
                      rsingleTag.test(match[1]) &&
                      jQuery.isPlainObject(context)
                    ) {
                      for (match in context) {
                        // Properties of context are called as methods if possible
                        if (isFunction(this[match])) {
                          this[match](context[match]);

                          // ...and otherwise set as attributes
                        } else {
                          this.attr(match, context[match]);
                        }
                      }
                    }

                    return this;

                    // HANDLE: $(#id)
                  } else {
                    elem = document.getElementById(match[2]);

                    if (elem) {
                      // Inject the element directly into the jQuery object
                      this[0] = elem;
                      this.length = 1;
                    }
                    return this;
                  }

                  // HANDLE: $(expr, $(...))
                } else if (!context || context.jquery) {
                  return (context || root).find(selector);

                  // HANDLE: $(expr, context)
                  // (which is just equivalent to: $(context).find(expr)
                } else {
                  return this.constructor(context).find(selector);
                }

                // HANDLE: $(DOMElement)
              } else if (selector.nodeType) {
                this[0] = selector;
                this.length = 1;
                return this;

                // HANDLE: $(function)
                // Shortcut for document ready
              } else if (isFunction(selector)) {
                return root.ready !== undefined
                  ? root.ready(selector)
                  : // Execute immediately if ready is not present
                    selector(jQuery);
              }

              return jQuery.makeArray(selector, this);
            });

          // Give the init function the jQuery prototype for later instantiation
          init.prototype = jQuery.fn;

          // Initialize central reference
          rootjQuery = jQuery(document);

          var rparentsprev = /^(?:parents|prev(?:Until|All))/,
            // Methods guaranteed to produce a unique set when starting from a unique set
            guaranteedUnique = {
              children: true,
              contents: true,
              next: true,
              prev: true,
            };

          jQuery.fn.extend({
            has: function (target) {
              var targets = jQuery(target, this),
                l = targets.length;

              return this.filter(function () {
                var i = 0;
                for (; i < l; i++) {
                  if (jQuery.contains(this, targets[i])) {
                    return true;
                  }
                }
              });
            },

            closest: function (selectors, context) {
              var cur,
                i = 0,
                l = this.length,
                matched = [],
                targets = typeof selectors !== "string" && jQuery(selectors);

              // Positional selectors never match, since there's no _selection_ context
              if (!rneedsContext.test(selectors)) {
                for (; i < l; i++) {
                  for (
                    cur = this[i];
                    cur && cur !== context;
                    cur = cur.parentNode
                  ) {
                    // Always skip document fragments
                    if (
                      cur.nodeType < 11 &&
                      (targets
                        ? targets.index(cur) > -1
                        : // Don't pass non-elements to Sizzle
                          cur.nodeType === 1 &&
                          jQuery.find.matchesSelector(cur, selectors))
                    ) {
                      matched.push(cur);
                      break;
                    }
                  }
                }
              }

              return this.pushStack(
                matched.length > 1 ? jQuery.uniqueSort(matched) : matched
              );
            },

            // Determine the position of an element within the set
            index: function (elem) {
              // No argument, return index in parent
              if (!elem) {
                return this[0] && this[0].parentNode
                  ? this.first().prevAll().length
                  : -1;
              }

              // Index in selector
              if (typeof elem === "string") {
                return indexOf.call(jQuery(elem), this[0]);
              }

              // Locate the position of the desired element
              return indexOf.call(
                this,

                // If it receives a jQuery object, the first element is used
                elem.jquery ? elem[0] : elem
              );
            },

            add: function (selector, context) {
              return this.pushStack(
                jQuery.uniqueSort(
                  jQuery.merge(this.get(), jQuery(selector, context))
                )
              );
            },

            addBack: function (selector) {
              return this.add(
                selector == null
                  ? this.prevObject
                  : this.prevObject.filter(selector)
              );
            },
          });

          function sibling(cur, dir) {
            while ((cur = cur[dir]) && cur.nodeType !== 1) {}
            return cur;
          }

          jQuery.each(
            {
              parent: function (elem) {
                var parent = elem.parentNode;
                return parent && parent.nodeType !== 11 ? parent : null;
              },
              parents: function (elem) {
                return dir(elem, "parentNode");
              },
              parentsUntil: function (elem, _i, until) {
                return dir(elem, "parentNode", until);
              },
              next: function (elem) {
                return sibling(elem, "nextSibling");
              },
              prev: function (elem) {
                return sibling(elem, "previousSibling");
              },
              nextAll: function (elem) {
                return dir(elem, "nextSibling");
              },
              prevAll: function (elem) {
                return dir(elem, "previousSibling");
              },
              nextUntil: function (elem, _i, until) {
                return dir(elem, "nextSibling", until);
              },
              prevUntil: function (elem, _i, until) {
                return dir(elem, "previousSibling", until);
              },
              siblings: function (elem) {
                return siblings((elem.parentNode || {}).firstChild, elem);
              },
              children: function (elem) {
                return siblings(elem.firstChild);
              },
              contents: function (elem) {
                if (
                  elem.contentDocument != null &&
                  // Support: IE 11+
                  // <object> elements with no `data` attribute has an object
                  // `contentDocument` with a `null` prototype.
                  getProto(elem.contentDocument)
                ) {
                  return elem.contentDocument;
                }

                // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
                // Treat the template element as a regular one in browsers that
                // don't support it.
                if (nodeName(elem, "template")) {
                  elem = elem.content || elem;
                }

                return jQuery.merge([], elem.childNodes);
              },
            },
            function (name, fn) {
              jQuery.fn[name] = function (until, selector) {
                var matched = jQuery.map(this, fn, until);

                if (name.slice(-5) !== "Until") {
                  selector = until;
                }

                if (selector && typeof selector === "string") {
                  matched = jQuery.filter(selector, matched);
                }

                if (this.length > 1) {
                  // Remove duplicates
                  if (!guaranteedUnique[name]) {
                    jQuery.uniqueSort(matched);
                  }

                  // Reverse order for parents* and prev-derivatives
                  if (rparentsprev.test(name)) {
                    matched.reverse();
                  }
                }

                return this.pushStack(matched);
              };
            }
          );
          var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

          // Convert String-formatted options into Object-formatted ones
          function createOptions(options) {
            var object = {};
            jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
              object[flag] = true;
            });
            return object;
          }

          /*
           * Create a callback list using the following parameters:
           *
           *	options: an optional list of space-separated options that will change how
           *			the callback list behaves or a more traditional option object
           *
           * By default a callback list will act like an event callback list and can be
           * "fired" multiple times.
           *
           * Possible options:
           *
           *	once:			will ensure the callback list can only be fired once (like a Deferred)
           *
           *	memory:			will keep track of previous values and will call any callback added
           *					after the list has been fired right away with the latest "memorized"
           *					values (like a Deferred)
           *
           *	unique:			will ensure a callback can only be added once (no duplicate in the list)
           *
           *	stopOnFalse:	interrupt callings when a callback returns false
           *
           */
          jQuery.Callbacks = function (options) {
            // Convert options from String-formatted to Object-formatted if needed
            // (we check in cache first)
            options =
              typeof options === "string"
                ? createOptions(options)
                : jQuery.extend({}, options);

            var // Flag to know if list is currently firing
              firing,
              // Last fire value for non-forgettable lists
              memory,
              // Flag to know if list was already fired
              fired,
              // Flag to prevent firing
              locked,
              // Actual callback list
              list = [],
              // Queue of execution data for repeatable lists
              queue = [],
              // Index of currently firing callback (modified by add/remove as needed)
              firingIndex = -1,
              // Fire callbacks
              fire = function () {
                // Enforce single-firing
                locked = locked || options.once;

                // Execute callbacks for all pending executions,
                // respecting firingIndex overrides and runtime changes
                fired = firing = true;
                for (; queue.length; firingIndex = -1) {
                  memory = queue.shift();
                  while (++firingIndex < list.length) {
                    // Run callback and check for early termination
                    if (
                      list[firingIndex].apply(memory[0], memory[1]) === false &&
                      options.stopOnFalse
                    ) {
                      // Jump to end and forget the data so .add doesn't re-fire
                      firingIndex = list.length;
                      memory = false;
                    }
                  }
                }

                // Forget the data if we're done with it
                if (!options.memory) {
                  memory = false;
                }

                firing = false;

                // Clean up if we're done firing for good
                if (locked) {
                  // Keep an empty list if we have data for future add calls
                  if (memory) {
                    list = [];

                    // Otherwise, this object is spent
                  } else {
                    list = "";
                  }
                }
              },
              // Actual Callbacks object
              self = {
                // Add a callback or a collection of callbacks to the list
                add: function () {
                  if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                      firingIndex = list.length - 1;
                      queue.push(memory);
                    }

                    (function add(args) {
                      jQuery.each(args, function (_, arg) {
                        if (isFunction(arg)) {
                          if (!options.unique || !self.has(arg)) {
                            list.push(arg);
                          }
                        } else if (
                          arg &&
                          arg.length &&
                          toType(arg) !== "string"
                        ) {
                          // Inspect recursively
                          add(arg);
                        }
                      });
                    })(arguments);

                    if (memory && !firing) {
                      fire();
                    }
                  }
                  return this;
                },

                // Remove a callback from the list
                remove: function () {
                  jQuery.each(arguments, function (_, arg) {
                    var index;
                    while ((index = jQuery.inArray(arg, list, index)) > -1) {
                      list.splice(index, 1);

                      // Handle firing indexes
                      if (index <= firingIndex) {
                        firingIndex--;
                      }
                    }
                  });
                  return this;
                },

                // Check if a given callback is in the list.
                // If no argument is given, return whether or not list has callbacks attached.
                has: function (fn) {
                  return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
                },

                // Remove all callbacks from the list
                empty: function () {
                  if (list) {
                    list = [];
                  }
                  return this;
                },

                // Disable .fire and .add
                // Abort any current/pending executions
                // Clear all callbacks and values
                disable: function () {
                  locked = queue = [];
                  list = memory = "";
                  return this;
                },
                disabled: function () {
                  return !list;
                },

                // Disable .fire
                // Also disable .add unless we have memory (since it would have no effect)
                // Abort any pending executions
                lock: function () {
                  locked = queue = [];
                  if (!memory && !firing) {
                    list = memory = "";
                  }
                  return this;
                },
                locked: function () {
                  return !!locked;
                },

                // Call all callbacks with the given context and arguments
                fireWith: function (context, args) {
                  if (!locked) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    queue.push(args);
                    if (!firing) {
                      fire();
                    }
                  }
                  return this;
                },

                // Call all the callbacks with the given arguments
                fire: function () {
                  self.fireWith(this, arguments);
                  return this;
                },

                // To know if the callbacks have already been called at least once
                fired: function () {
                  return !!fired;
                },
              };

            return self;
          };

          function Identity(v) {
            return v;
          }
          function Thrower(ex) {
            throw ex;
          }

          function adoptValue(value, resolve, reject, noValue) {
            var method;

            try {
              // Check for promise aspect first to privilege synchronous behavior
              if (value && isFunction((method = value.promise))) {
                method.call(value).done(resolve).fail(reject);

                // Other thenables
              } else if (value && isFunction((method = value.then))) {
                method.call(value, resolve, reject);

                // Other non-thenables
              } else {
                // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
                // * false: [ value ].slice( 0 ) => resolve( value )
                // * true: [ value ].slice( 1 ) => resolve()
                resolve.apply(undefined, [value].slice(noValue));
              }

              // For Promises/A+, convert exceptions into rejections
              // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
              // Deferred#then to conditionally suppress rejection.
            } catch (value) {
              // Support: Android 4.0 only
              // Strict mode functions invoked without .call/.apply get global-object context
              reject.apply(undefined, [value]);
            }
          }

          jQuery.extend({
            Deferred: function (func) {
              var tuples = [
                  // action, add listener, callbacks,
                  // ... .then handlers, argument index, [final state]
                  [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2,
                  ],
                  [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved",
                  ],
                  [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected",
                  ],
                ],
                state = "pending",
                promise = {
                  state: function () {
                    return state;
                  },
                  always: function () {
                    deferred.done(arguments).fail(arguments);
                    return this;
                  },
                  catch: function (fn) {
                    return promise.then(null, fn);
                  },

                  // Keep pipe for back-compat
                  pipe: function (/* fnDone, fnFail, fnProgress */) {
                    var fns = arguments;

                    return jQuery
                      .Deferred(function (newDefer) {
                        jQuery.each(tuples, function (_i, tuple) {
                          // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                          var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

                          // deferred.progress(function() { bind to newDefer or newDefer.notify })
                          // deferred.done(function() { bind to newDefer or newDefer.resolve })
                          // deferred.fail(function() { bind to newDefer or newDefer.reject })
                          deferred[tuple[1]](function () {
                            var returned = fn && fn.apply(this, arguments);
                            if (returned && isFunction(returned.promise)) {
                              returned
                                .promise()
                                .progress(newDefer.notify)
                                .done(newDefer.resolve)
                                .fail(newDefer.reject);
                            } else {
                              newDefer[tuple[0] + "With"](
                                this,
                                fn ? [returned] : arguments
                              );
                            }
                          });
                        });
                        fns = null;
                      })
                      .promise();
                  },
                  then: function (onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                      return function () {
                        var that = this,
                          args = arguments,
                          mightThrow = function () {
                            var returned, then;

                            // Support: Promises/A+ section 2.3.3.3.3
                            // https://promisesaplus.com/#point-59
                            // Ignore double-resolution attempts
                            if (depth < maxDepth) {
                              return;
                            }

                            returned = handler.apply(that, args);

                            // Support: Promises/A+ section 2.3.1
                            // https://promisesaplus.com/#point-48
                            if (returned === deferred.promise()) {
                              throw new TypeError("Thenable self-resolution");
                            }

                            // Support: Promises/A+ sections 2.3.3.1, 3.5
                            // https://promisesaplus.com/#point-54
                            // https://promisesaplus.com/#point-75
                            // Retrieve `then` only once
                            then =
                              returned &&
                              // Support: Promises/A+ section 2.3.4
                              // https://promisesaplus.com/#point-64
                              // Only check objects and functions for thenability
                              (typeof returned === "object" ||
                                typeof returned === "function") &&
                              returned.then;

                            // Handle a returned thenable
                            if (isFunction(then)) {
                              // Special processors (notify) just wait for resolution
                              if (special) {
                                then.call(
                                  returned,
                                  resolve(
                                    maxDepth,
                                    deferred,
                                    Identity,
                                    special
                                  ),
                                  resolve(maxDepth, deferred, Thrower, special)
                                );

                                // Normal processors (resolve) also hook into progress
                              } else {
                                // ...and disregard older resolution values
                                maxDepth++;

                                then.call(
                                  returned,
                                  resolve(
                                    maxDepth,
                                    deferred,
                                    Identity,
                                    special
                                  ),
                                  resolve(maxDepth, deferred, Thrower, special),
                                  resolve(
                                    maxDepth,
                                    deferred,
                                    Identity,
                                    deferred.notifyWith
                                  )
                                );
                              }

                              // Handle all other returned values
                            } else {
                              // Only substitute handlers pass on context
                              // and multiple values (non-spec behavior)
                              if (handler !== Identity) {
                                that = undefined;
                                args = [returned];
                              }

                              // Process the value(s)
                              // Default process is resolve
                              (special || deferred.resolveWith)(that, args);
                            }
                          },
                          // Only normal processors (resolve) catch and reject exceptions
                          process = special
                            ? mightThrow
                            : function () {
                                try {
                                  mightThrow();
                                } catch (e) {
                                  if (jQuery.Deferred.exceptionHook) {
                                    jQuery.Deferred.exceptionHook(
                                      e,
                                      process.stackTrace
                                    );
                                  }

                                  // Support: Promises/A+ section 2.3.3.3.4.1
                                  // https://promisesaplus.com/#point-61
                                  // Ignore post-resolution exceptions
                                  if (depth + 1 >= maxDepth) {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Thrower) {
                                      that = undefined;
                                      args = [e];
                                    }

                                    deferred.rejectWith(that, args);
                                  }
                                }
                              };

                        // Support: Promises/A+ section 2.3.3.3.1
                        // https://promisesaplus.com/#point-57
                        // Re-resolve promises immediately to dodge false rejection from
                        // subsequent errors
                        if (depth) {
                          process();
                        } else {
                          // Call an optional hook to record the stack, in case of exception
                          // since it's otherwise lost when execution goes async
                          if (jQuery.Deferred.getStackHook) {
                            process.stackTrace = jQuery.Deferred.getStackHook();
                          }
                          window.setTimeout(process);
                        }
                      };
                    }

                    return jQuery
                      .Deferred(function (newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(
                          resolve(
                            0,
                            newDefer,
                            isFunction(onProgress) ? onProgress : Identity,
                            newDefer.notifyWith
                          )
                        );

                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(
                          resolve(
                            0,
                            newDefer,
                            isFunction(onFulfilled) ? onFulfilled : Identity
                          )
                        );

                        // rejected_handlers.add( ... )
                        tuples[2][3].add(
                          resolve(
                            0,
                            newDefer,
                            isFunction(onRejected) ? onRejected : Thrower
                          )
                        );
                      })
                      .promise();
                  },

                  // Get a promise for this deferred
                  // If obj is provided, the promise aspect is added to the object
                  promise: function (obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                  },
                },
                deferred = {};

              // Add list-specific methods
              jQuery.each(tuples, function (i, tuple) {
                var list = tuple[2],
                  stateString = tuple[5];

                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;

                // Handle state
                if (stateString) {
                  list.add(
                    function () {
                      // state = "resolved" (i.e., fulfilled)
                      // state = "rejected"
                      state = stateString;
                    },

                    // rejected_callbacks.disable
                    // fulfilled_callbacks.disable
                    tuples[3 - i][2].disable,

                    // rejected_handlers.disable
                    // fulfilled_handlers.disable
                    tuples[3 - i][3].disable,

                    // progress_callbacks.lock
                    tuples[0][2].lock,

                    // progress_handlers.lock
                    tuples[0][3].lock
                  );
                }

                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);

                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function () {
                  deferred[tuple[0] + "With"](
                    this === deferred ? undefined : this,
                    arguments
                  );
                  return this;
                };

                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
              });

              // Make the deferred a promise
              promise.promise(deferred);

              // Call given func if any
              if (func) {
                func.call(deferred, deferred);
              }

              // All done!
              return deferred;
            },

            // Deferred helper
            when: function (singleValue) {
              var // count of uncompleted subordinates
                remaining = arguments.length,
                // count of unprocessed arguments
                i = remaining,
                // subordinate fulfillment data
                resolveContexts = Array(i),
                resolveValues = slice.call(arguments),
                // the primary Deferred
                primary = jQuery.Deferred(),
                // subordinate callback factory
                updateFunc = function (i) {
                  return function (value) {
                    resolveContexts[i] = this;
                    resolveValues[i] =
                      arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) {
                      primary.resolveWith(resolveContexts, resolveValues);
                    }
                  };
                };

              // Single- and empty arguments are adopted like Promise.resolve
              if (remaining <= 1) {
                adoptValue(
                  singleValue,
                  primary.done(updateFunc(i)).resolve,
                  primary.reject,
                  !remaining
                );

                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (
                  primary.state() === "pending" ||
                  isFunction(resolveValues[i] && resolveValues[i].then)
                ) {
                  return primary.then();
                }
              }

              // Multiple arguments are aggregated like Promise.all array elements
              while (i--) {
                adoptValue(resolveValues[i], updateFunc(i), primary.reject);
              }

              return primary.promise();
            },
          });

          // These usually indicate a programmer mistake during development,
          // warn about them ASAP rather than swallowing them by default.
          var rerrorNames =
            /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

          jQuery.Deferred.exceptionHook = function (error, stack) {
            // Support: IE 8 - 9 only
            // Console exists when dev tools are open, which can happen at any time
            if (
              window.console &&
              window.console.warn &&
              error &&
              rerrorNames.test(error.name)
            ) {
              window.console.warn(
                "jQuery.Deferred exception: " + error.message,
                error.stack,
                stack
              );
            }
          };

          jQuery.readyException = function (error) {
            window.setTimeout(function () {
              throw error;
            });
          };

          // The deferred used on DOM ready
          var readyList = jQuery.Deferred();

          jQuery.fn.ready = function (fn) {
            readyList
              .then(fn)

              // Wrap jQuery.readyException in a function so that the lookup
              // happens at the time of error handling instead of callback
              // registration.
              .catch(function (error) {
                jQuery.readyException(error);
              });

            return this;
          };

          jQuery.extend({
            // Is the DOM ready to be used? Set to true once it occurs.
            isReady: false,

            // A counter to track how many items to wait for before
            // the ready event fires. See #6781
            readyWait: 1,

            // Handle when the DOM is ready
            ready: function (wait) {
              // Abort if there are pending holds or we're already ready
              if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
                return;
              }

              // Remember that the DOM is ready
              jQuery.isReady = true;

              // If a normal DOM Ready event fired, decrement, and wait if need be
              if (wait !== true && --jQuery.readyWait > 0) {
                return;
              }

              // If there are functions bound, to execute
              readyList.resolveWith(document, [jQuery]);
            },
          });

          jQuery.ready.then = readyList.then;

          // The ready event handler and self cleanup method
          function completed() {
            document.removeEventListener("DOMContentLoaded", completed);
            window.removeEventListener("load", completed);
            jQuery.ready();
          }

          // Catch cases where $(document).ready() is called
          // after the browser event has already occurred.
          // Support: IE <=9 - 10 only
          // Older IE sometimes signals "interactive" too soon
          if (
            document.readyState === "complete" ||
            (document.readyState !== "loading" &&
              !document.documentElement.doScroll)
          ) {
            // Handle it asynchronously to allow scripts the opportunity to delay ready
            window.setTimeout(jQuery.ready);
          } else {
            // Use the handy event callback
            document.addEventListener("DOMContentLoaded", completed);

            // A fallback to window.onload, that will always work
            window.addEventListener("load", completed);
          }

          // Multifunctional method to get and set values of a collection
          // The value/s can optionally be executed if it's a function
          var access = function (
            elems,
            fn,
            key,
            value,
            chainable,
            emptyGet,
            raw
          ) {
            var i = 0,
              len = elems.length,
              bulk = key == null;

            // Sets many values
            if (toType(key) === "object") {
              chainable = true;
              for (i in key) {
                access(elems, fn, i, key[i], true, emptyGet, raw);
              }

              // Sets one value
            } else if (value !== undefined) {
              chainable = true;

              if (!isFunction(value)) {
                raw = true;
              }

              if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                  fn.call(elems, value);
                  fn = null;

                  // ...except when executing function values
                } else {
                  bulk = fn;
                  fn = function (elem, _key, value) {
                    return bulk.call(jQuery(elem), value);
                  };
                }
              }

              if (fn) {
                for (; i < len; i++) {
                  fn(
                    elems[i],
                    key,
                    raw ? value : value.call(elems[i], i, fn(elems[i], key))
                  );
                }
              }
            }

            if (chainable) {
              return elems;
            }

            // Gets
            if (bulk) {
              return fn.call(elems);
            }

            return len ? fn(elems[0], key) : emptyGet;
          };

          // Matches dashed string for camelizing
          var rmsPrefix = /^-ms-/,
            rdashAlpha = /-([a-z])/g;

          // Used by camelCase as callback to replace()
          function fcamelCase(_all, letter) {
            return letter.toUpperCase();
          }

          // Convert dashed to camelCase; used by the css and data modules
          // Support: IE <=9 - 11, Edge 12 - 15
          // Microsoft forgot to hump their vendor prefix (#9572)
          function camelCase(string) {
            return string
              .replace(rmsPrefix, "ms-")
              .replace(rdashAlpha, fcamelCase);
          }
          var acceptData = function (owner) {
            // Accepts only:
            //  - Node
            //    - Node.ELEMENT_NODE
            //    - Node.DOCUMENT_NODE
            //  - Object
            //    - Any
            return (
              owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType
            );
          };

          function Data() {
            this.expando = jQuery.expando + Data.uid++;
          }

          Data.uid = 1;

          Data.prototype = {
            cache: function (owner) {
              // Check if the owner object already has a cache
              var value = owner[this.expando];

              // If not, create one
              if (!value) {
                value = {};

                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see #8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                  // If it is a node unlikely to be stringify-ed or looped over
                  // use plain assignment
                  if (owner.nodeType) {
                    owner[this.expando] = value;

                    // Otherwise secure it in a non-enumerable property
                    // configurable must be true to allow the property to be
                    // deleted when data is removed
                  } else {
                    Object.defineProperty(owner, this.expando, {
                      value: value,
                      configurable: true,
                    });
                  }
                }
              }

              return value;
            },
            set: function (owner, data, value) {
              var prop,
                cache = this.cache(owner);

              // Handle: [ owner, key, value ] args
              // Always use camelCase key (gh-2257)
              if (typeof data === "string") {
                cache[camelCase(data)] = value;

                // Handle: [ owner, { properties } ] args
              } else {
                // Copy the properties one-by-one to the cache object
                for (prop in data) {
                  cache[camelCase(prop)] = data[prop];
                }
              }
              return cache;
            },
            get: function (owner, key) {
              return key === undefined
                ? this.cache(owner)
                : // Always use camelCase key (gh-2257)
                  owner[this.expando] && owner[this.expando][camelCase(key)];
            },
            access: function (owner, key, value) {
              // In cases where either:
              //
              //   1. No key was specified
              //   2. A string key was specified, but no value provided
              //
              // Take the "read" path and allow the get method to determine
              // which value to return, respectively either:
              //
              //   1. The entire cache object
              //   2. The data stored at the key
              //
              if (
                key === undefined ||
                (key && typeof key === "string" && value === undefined)
              ) {
                return this.get(owner, key);
              }

              // When the key is not a string, or both a key and value
              // are specified, set or extend (existing objects) with either:
              //
              //   1. An object of properties
              //   2. A key and value
              //
              this.set(owner, key, value);

              // Since the "set" path can have two possible entry points
              // return the expected data based on which path was taken[*]
              return value !== undefined ? value : key;
            },
            remove: function (owner, key) {
              var i,
                cache = owner[this.expando];

              if (cache === undefined) {
                return;
              }

              if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) {
                  // If key is an array of keys...
                  // We always set camelCase keys, so remove that.
                  key = key.map(camelCase);
                } else {
                  key = camelCase(key);

                  // If a key with the spaces exists, use it.
                  // Otherwise, create an array by matching non-whitespace
                  key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
                }

                i = key.length;

                while (i--) {
                  delete cache[key[i]];
                }
              }

              // Remove the expando if there's no more data
              if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) {
                  owner[this.expando] = undefined;
                } else {
                  delete owner[this.expando];
                }
              }
            },
            hasData: function (owner) {
              var cache = owner[this.expando];
              return cache !== undefined && !jQuery.isEmptyObject(cache);
            },
          };
          var dataPriv = new Data();

          var dataUser = new Data();

          //	Implementation Summary
          //
          //	1. Enforce API surface and semantic compatibility with 1.9.x branch
          //	2. Improve the module's maintainability by reducing the storage
          //		paths to a single mechanism.
          //	3. Use the same single mechanism to support "private" and "user" data.
          //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
          //	5. Avoid exposing implementation details on user objects (eg. expando properties)
          //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

          var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            rmultiDash = /[A-Z]/g;

          function getData(data) {
            if (data === "true") {
              return true;
            }

            if (data === "false") {
              return false;
            }

            if (data === "null") {
              return null;
            }

            // Only convert to a number if it doesn't change the string
            if (data === +data + "") {
              return +data;
            }

            if (rbrace.test(data)) {
              return JSON.parse(data);
            }

            return data;
          }

          function dataAttr(elem, key, data) {
            var name;

            // If nothing was found internally, try to fetch any
            // data from the HTML5 data-* attribute
            if (data === undefined && elem.nodeType === 1) {
              name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
              data = elem.getAttribute(name);

              if (typeof data === "string") {
                try {
                  data = getData(data);
                } catch (e) {}

                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
              } else {
                data = undefined;
              }
            }
            return data;
          }

          jQuery.extend({
            hasData: function (elem) {
              return dataUser.hasData(elem) || dataPriv.hasData(elem);
            },

            data: function (elem, name, data) {
              return dataUser.access(elem, name, data);
            },

            removeData: function (elem, name) {
              dataUser.remove(elem, name);
            },

            // TODO: Now that all calls to _data and _removeData have been replaced
            // with direct calls to dataPriv methods, these can be deprecated.
            _data: function (elem, name, data) {
              return dataPriv.access(elem, name, data);
            },

            _removeData: function (elem, name) {
              dataPriv.remove(elem, name);
            },
          });

          jQuery.fn.extend({
            data: function (key, value) {
              var i,
                name,
                data,
                elem = this[0],
                attrs = elem && elem.attributes;

              // Gets all values
              if (key === undefined) {
                if (this.length) {
                  data = dataUser.get(elem);

                  if (
                    elem.nodeType === 1 &&
                    !dataPriv.get(elem, "hasDataAttrs")
                  ) {
                    i = attrs.length;
                    while (i--) {
                      // Support: IE 11 only
                      // The attrs elements can be null (#14894)
                      if (attrs[i]) {
                        name = attrs[i].name;
                        if (name.indexOf("data-") === 0) {
                          name = camelCase(name.slice(5));
                          dataAttr(elem, name, data[name]);
                        }
                      }
                    }
                    dataPriv.set(elem, "hasDataAttrs", true);
                  }
                }

                return data;
              }

              // Sets multiple values
              if (typeof key === "object") {
                return this.each(function () {
                  dataUser.set(this, key);
                });
              }

              return access(
                this,
                function (value) {
                  var data;

                  // The calling jQuery object (element matches) is not empty
                  // (and therefore has an element appears at this[ 0 ]) and the
                  // `value` parameter was not undefined. An empty jQuery object
                  // will result in `undefined` for elem = this[ 0 ] which will
                  // throw an exception if an attempt to read a data cache is made.
                  if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) {
                      return data;
                    }

                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) {
                      return data;
                    }

                    // We tried really hard, but the data doesn't exist.
                    return;
                  }

                  // Set the data...
                  this.each(function () {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                  });
                },
                null,
                value,
                arguments.length > 1,
                null,
                true
              );
            },

            removeData: function (key) {
              return this.each(function () {
                dataUser.remove(this, key);
              });
            },
          });

          jQuery.extend({
            queue: function (elem, type, data) {
              var queue;

              if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);

                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                  if (!queue || Array.isArray(data)) {
                    queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                  } else {
                    queue.push(data);
                  }
                }
                return queue || [];
              }
            },

            dequeue: function (elem, type) {
              type = type || "fx";

              var queue = jQuery.queue(elem, type),
                startLength = queue.length,
                fn = queue.shift(),
                hooks = jQuery._queueHooks(elem, type),
                next = function () {
                  jQuery.dequeue(elem, type);
                };

              // If the fx queue is dequeued, always remove the progress sentinel
              if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
              }

              if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") {
                  queue.unshift("inprogress");
                }

                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
              }

              if (!startLength && hooks) {
                hooks.empty.fire();
              }
            },

            // Not public - generate a queueHooks object, or return the current one
            _queueHooks: function (elem, type) {
              var key = type + "queueHooks";
              return (
                dataPriv.get(elem, key) ||
                dataPriv.access(elem, key, {
                  empty: jQuery.Callbacks("once memory").add(function () {
                    dataPriv.remove(elem, [type + "queue", key]);
                  }),
                })
              );
            },
          });

          jQuery.fn.extend({
            queue: function (type, data) {
              var setter = 2;

              if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
              }

              if (arguments.length < setter) {
                return jQuery.queue(this[0], type);
              }

              return data === undefined
                ? this
                : this.each(function () {
                    var queue = jQuery.queue(this, type, data);

                    // Ensure a hooks for this queue
                    jQuery._queueHooks(this, type);

                    if (type === "fx" && queue[0] !== "inprogress") {
                      jQuery.dequeue(this, type);
                    }
                  });
            },
            dequeue: function (type) {
              return this.each(function () {
                jQuery.dequeue(this, type);
              });
            },
            clearQueue: function (type) {
              return this.queue(type || "fx", []);
            },

            // Get a promise resolved when queues of a certain type
            // are emptied (fx is the type by default)
            promise: function (type, obj) {
              var tmp,
                count = 1,
                defer = jQuery.Deferred(),
                elements = this,
                i = this.length,
                resolve = function () {
                  if (!--count) {
                    defer.resolveWith(elements, [elements]);
                  }
                };

              if (typeof type !== "string") {
                obj = type;
                type = undefined;
              }
              type = type || "fx";

              while (i--) {
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                  count++;
                  tmp.empty.add(resolve);
                }
              }
              resolve();
              return defer.promise(obj);
            },
          });
          var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;

          var rcssNum = new RegExp(
            "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$",
            "i"
          );

          var cssExpand = ["Top", "Right", "Bottom", "Left"];

          var documentElement = document.documentElement;

          var isAttached = function (elem) {
              return jQuery.contains(elem.ownerDocument, elem);
            },
            composed = { composed: true };

          // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
          // Check attachment across shadow DOM boundaries when possible (gh-3504)
          // Support: iOS 10.0-10.2 only
          // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
          // leading to errors. We need to check for `getRootNode`.
          if (documentElement.getRootNode) {
            isAttached = function (elem) {
              return (
                jQuery.contains(elem.ownerDocument, elem) ||
                elem.getRootNode(composed) === elem.ownerDocument
              );
            };
          }
          var isHiddenWithinTree = function (elem, el) {
            // isHiddenWithinTree might be called from jQuery#filter function;
            // in that case, element will be second argument
            elem = el || elem;

            // Inline style trumps all
            return (
              elem.style.display === "none" ||
              (elem.style.display === "" &&
                // Otherwise, check computed style
                // Support: Firefox <=43 - 45
                // Disconnected elements can have computed display: none, so first confirm that elem is
                // in the document.
                isAttached(elem) &&
                jQuery.css(elem, "display") === "none")
            );
          };

          function adjustCSS(elem, prop, valueParts, tween) {
            var adjusted,
              scale,
              maxIterations = 20,
              currentValue = tween
                ? function () {
                    return tween.cur();
                  }
                : function () {
                    return jQuery.css(elem, prop, "");
                  },
              initial = currentValue(),
              unit =
                (valueParts && valueParts[3]) ||
                (jQuery.cssNumber[prop] ? "" : "px"),
              // Starting value computation is required for potential unit mismatches
              initialInUnit =
                elem.nodeType &&
                (jQuery.cssNumber[prop] || (unit !== "px" && +initial)) &&
                rcssNum.exec(jQuery.css(elem, prop));

            if (initialInUnit && initialInUnit[3] !== unit) {
              // Support: Firefox <=54
              // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
              initial = initial / 2;

              // Trust units reported by jQuery.css
              unit = unit || initialInUnit[3];

              // Iteratively approximate from a nonzero starting point
              initialInUnit = +initial || 1;

              while (maxIterations--) {
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if (
                  (1 - scale) *
                    (1 - (scale = currentValue() / initial || 0.5)) <=
                  0
                ) {
                  maxIterations = 0;
                }
                initialInUnit = initialInUnit / scale;
              }

              initialInUnit = initialInUnit * 2;
              jQuery.style(elem, prop, initialInUnit + unit);

              // Make sure we update the tween properties later on
              valueParts = valueParts || [];
            }

            if (valueParts) {
              initialInUnit = +initialInUnit || +initial || 0;

              // Apply relative offset (+=/-=) if specified
              adjusted = valueParts[1]
                ? initialInUnit + (valueParts[1] + 1) * valueParts[2]
                : +valueParts[2];
              if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
              }
            }
            return adjusted;
          }

          var defaultDisplayMap = {};

          function getDefaultDisplay(elem) {
            var temp,
              doc = elem.ownerDocument,
              nodeName = elem.nodeName,
              display = defaultDisplayMap[nodeName];

            if (display) {
              return display;
            }

            temp = doc.body.appendChild(doc.createElement(nodeName));
            display = jQuery.css(temp, "display");

            temp.parentNode.removeChild(temp);

            if (display === "none") {
              display = "block";
            }
            defaultDisplayMap[nodeName] = display;

            return display;
          }

          function showHide(elements, show) {
            var display,
              elem,
              values = [],
              index = 0,
              length = elements.length;

            // Determine new display value for elements that need to change
            for (; index < length; index++) {
              elem = elements[index];
              if (!elem.style) {
                continue;
              }

              display = elem.style.display;
              if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                  values[index] = dataPriv.get(elem, "display") || null;
                  if (!values[index]) {
                    elem.style.display = "";
                  }
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) {
                  values[index] = getDefaultDisplay(elem);
                }
              } else {
                if (display !== "none") {
                  values[index] = "none";

                  // Remember what we're overwriting
                  dataPriv.set(elem, "display", display);
                }
              }
            }

            // Set the display of the elements in a second loop to avoid constant reflow
            for (index = 0; index < length; index++) {
              if (values[index] != null) {
                elements[index].style.display = values[index];
              }
            }

            return elements;
          }

          jQuery.fn.extend({
            show: function () {
              return showHide(this, true);
            },
            hide: function () {
              return showHide(this);
            },
            toggle: function (state) {
              if (typeof state === "boolean") {
                return state ? this.show() : this.hide();
              }

              return this.each(function () {
                if (isHiddenWithinTree(this)) {
                  jQuery(this).show();
                } else {
                  jQuery(this).hide();
                }
              });
            },
          });
          var rcheckableType = /^(?:checkbox|radio)$/i;

          var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;

          var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

          (function () {
            var fragment = document.createDocumentFragment(),
              div = fragment.appendChild(document.createElement("div")),
              input = document.createElement("input");

            // Support: Android 4.0 - 4.3 only
            // Check state lost if the name is set (#11217)
            // Support: Windows Web Apps (WWA)
            // `name` and `type` must use .setAttribute for WWA (#14901)
            input.setAttribute("type", "radio");
            input.setAttribute("checked", "checked");
            input.setAttribute("name", "t");

            div.appendChild(input);

            // Support: Android <=4.1 only
            // Older WebKit doesn't clone checked state correctly in fragments
            support.checkClone = div
              .cloneNode(true)
              .cloneNode(true).lastChild.checked;

            // Support: IE <=11 only
            // Make sure textarea (and checkbox) defaultValue is properly cloned
            div.innerHTML = "<textarea>x</textarea>";
            support.noCloneChecked =
              !!div.cloneNode(true).lastChild.defaultValue;

            // Support: IE <=9 only
            // IE <=9 replaces <option> tags with their contents when inserted outside of
            // the select element.
            div.innerHTML = "<option></option>";
            support.option = !!div.lastChild;
          })();

          // We have to close these tags to support XHTML (#13200)
          var wrapMap = {
            // XHTML parsers do not magically insert elements in the
            // same way that tag soup parsers do. So we cannot shorten
            // this by omitting <tbody> or other required elements.
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

            _default: [0, "", ""],
          };

          wrapMap.tbody =
            wrapMap.tfoot =
            wrapMap.colgroup =
            wrapMap.caption =
              wrapMap.thead;
          wrapMap.th = wrapMap.td;

          // Support: IE <=9 only
          if (!support.option) {
            wrapMap.optgroup = wrapMap.option = [
              1,
              "<select multiple='multiple'>",
              "</select>",
            ];
          }

          function getAll(context, tag) {
            // Support: IE <=9 - 11 only
            // Use typeof to avoid zero-argument method invocation on host objects (#15151)
            var ret;

            if (typeof context.getElementsByTagName !== "undefined") {
              ret = context.getElementsByTagName(tag || "*");
            } else if (typeof context.querySelectorAll !== "undefined") {
              ret = context.querySelectorAll(tag || "*");
            } else {
              ret = [];
            }

            if (tag === undefined || (tag && nodeName(context, tag))) {
              return jQuery.merge([context], ret);
            }

            return ret;
          }

          // Mark scripts as having already been evaluated
          function setGlobalEval(elems, refElements) {
            var i = 0,
              l = elems.length;

            for (; i < l; i++) {
              dataPriv.set(
                elems[i],
                "globalEval",
                !refElements || dataPriv.get(refElements[i], "globalEval")
              );
            }
          }

          var rhtml = /<|&#?\w+;/;

          function buildFragment(elems, context, scripts, selection, ignored) {
            var elem,
              tmp,
              tag,
              wrap,
              attached,
              j,
              fragment = context.createDocumentFragment(),
              nodes = [],
              i = 0,
              l = elems.length;

            for (; i < l; i++) {
              elem = elems[i];

              if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") {
                  // Support: Android <=4.0 only, PhantomJS 1 only
                  // push.apply(_, arraylike) throws on ancient WebKit
                  jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

                  // Convert non-html into a text node
                } else if (!rhtml.test(elem)) {
                  nodes.push(context.createTextNode(elem));

                  // Convert html into DOM nodes
                } else {
                  tmp =
                    tmp || fragment.appendChild(context.createElement("div"));

                  // Deserialize a standard representation
                  tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
                  wrap = wrapMap[tag] || wrapMap._default;
                  tmp.innerHTML =
                    wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

                  // Descend through wrappers to the right content
                  j = wrap[0];
                  while (j--) {
                    tmp = tmp.lastChild;
                  }

                  // Support: Android <=4.0 only, PhantomJS 1 only
                  // push.apply(_, arraylike) throws on ancient WebKit
                  jQuery.merge(nodes, tmp.childNodes);

                  // Remember the top-level container
                  tmp = fragment.firstChild;

                  // Ensure the created nodes are orphaned (#12392)
                  tmp.textContent = "";
                }
              }
            }

            // Remove wrapper from fragment
            fragment.textContent = "";

            i = 0;
            while ((elem = nodes[i++])) {
              // Skip elements already in the context collection (trac-4087)
              if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) {
                  ignored.push(elem);
                }
                continue;
              }

              attached = isAttached(elem);

              // Append to fragment
              tmp = getAll(fragment.appendChild(elem), "script");

              // Preserve script evaluation history
              if (attached) {
                setGlobalEval(tmp);
              }

              // Capture executables
              if (scripts) {
                j = 0;
                while ((elem = tmp[j++])) {
                  if (rscriptType.test(elem.type || "")) {
                    scripts.push(elem);
                  }
                }
              }
            }

            return fragment;
          }

          var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

          function returnTrue() {
            return true;
          }

          function returnFalse() {
            return false;
          }

          // Support: IE <=9 - 11+
          // focus() and blur() are asynchronous, except when they are no-op.
          // So expect focus to be synchronous when the element is already active,
          // and blur to be synchronous when the element is not already active.
          // (focus and blur are always synchronous in other supported browsers,
          // this just defines when we can count on it).
          function expectSync(elem, type) {
            return (elem === safeActiveElement()) === (type === "focus");
          }

          // Support: IE <=9 only
          // Accessing document.activeElement can throw unexpectedly
          // https://bugs.jquery.com/ticket/13393
          function safeActiveElement() {
            try {
              return document.activeElement;
            } catch (err) {}
          }

          function on(elem, types, selector, data, fn, one) {
            var origFn, type;

            // Types can be a map of types/handlers
            if (typeof types === "object") {
              // ( types-Object, selector, data )
              if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
              }
              for (type in types) {
                on(elem, type, selector, data, types[type], one);
              }
              return elem;
            }

            if (data == null && fn == null) {
              // ( types, fn )
              fn = selector;
              data = selector = undefined;
            } else if (fn == null) {
              if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
              } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
              }
            }
            if (fn === false) {
              fn = returnFalse;
            } else if (!fn) {
              return elem;
            }

            if (one === 1) {
              origFn = fn;
              fn = function (event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
              };

              // Use same guid so caller can remove using origFn
              fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
            }
            return elem.each(function () {
              jQuery.event.add(this, types, fn, data, selector);
            });
          }

          /*
           * Helper functions for managing events -- not part of the public interface.
           * Props to Dean Edwards' addEvent library for many of the ideas.
           */
          jQuery.event = {
            global: {},

            add: function (elem, types, handler, data, selector) {
              var handleObjIn,
                eventHandle,
                tmp,
                events,
                t,
                handleObj,
                special,
                handlers,
                type,
                namespaces,
                origType,
                elemData = dataPriv.get(elem);

              // Only attach events to objects that accept data
              if (!acceptData(elem)) {
                return;
              }

              // Caller can pass in an object of custom data in lieu of the handler
              if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
              }

              // Ensure that invalid selectors throw exceptions at attach time
              // Evaluate against documentElement in case elem is a non-element node (e.g., document)
              if (selector) {
                jQuery.find.matchesSelector(documentElement, selector);
              }

              // Make sure that the handler has a unique ID, used to find/remove it later
              if (!handler.guid) {
                handler.guid = jQuery.guid++;
              }

              // Init the element's event structure and main handler, if this is the first
              if (!(events = elemData.events)) {
                events = elemData.events = Object.create(null);
              }
              if (!(eventHandle = elemData.handle)) {
                eventHandle = elemData.handle = function (e) {
                  // Discard the second event of a jQuery.event.trigger() and
                  // when an event is called after a page has unloaded
                  return typeof jQuery !== "undefined" &&
                    jQuery.event.triggered !== e.type
                    ? jQuery.event.dispatch.apply(elem, arguments)
                    : undefined;
                };
              }

              // Handle multiple events separated by a space
              types = (types || "").match(rnothtmlwhite) || [""];
              t = types.length;
              while (t--) {
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();

                // There *must* be a type, no attaching namespace-only handlers
                if (!type) {
                  continue;
                }

                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};

                // If selector defined, determine special event api type, otherwise given type
                type =
                  (selector ? special.delegateType : special.bindType) || type;

                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};

                // handleObj is passed to all event handlers
                handleObj = jQuery.extend(
                  {
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext:
                      selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join("."),
                  },
                  handleObjIn
                );

                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                  handlers = events[type] = [];
                  handlers.delegateCount = 0;

                  // Only use addEventListener if the special events handler returns false
                  if (
                    !special.setup ||
                    special.setup.call(elem, data, namespaces, eventHandle) ===
                      false
                  ) {
                    if (elem.addEventListener) {
                      elem.addEventListener(type, eventHandle);
                    }
                  }
                }

                if (special.add) {
                  special.add.call(elem, handleObj);

                  if (!handleObj.handler.guid) {
                    handleObj.handler.guid = handler.guid;
                  }
                }

                // Add to the element's handler list, delegates in front
                if (selector) {
                  handlers.splice(handlers.delegateCount++, 0, handleObj);
                } else {
                  handlers.push(handleObj);
                }

                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
              }
            },

            // Detach an event or set of events from an element
            remove: function (elem, types, handler, selector, mappedTypes) {
              var j,
                origCount,
                tmp,
                events,
                t,
                handleObj,
                special,
                handlers,
                type,
                namespaces,
                origType,
                elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

              if (!elemData || !(events = elemData.events)) {
                return;
              }

              // Once for each type.namespace in types; type may be omitted
              types = (types || "").match(rnothtmlwhite) || [""];
              t = types.length;
              while (t--) {
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();

                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                  for (type in events) {
                    jQuery.event.remove(
                      elem,
                      type + types[t],
                      handler,
                      selector,
                      true
                    );
                  }
                  continue;
                }

                special = jQuery.event.special[type] || {};
                type =
                  (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp =
                  tmp[2] &&
                  new RegExp(
                    "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"
                  );

                // Remove matching events
                origCount = j = handlers.length;
                while (j--) {
                  handleObj = handlers[j];

                  if (
                    (mappedTypes || origType === handleObj.origType) &&
                    (!handler || handler.guid === handleObj.guid) &&
                    (!tmp || tmp.test(handleObj.namespace)) &&
                    (!selector ||
                      selector === handleObj.selector ||
                      (selector === "**" && handleObj.selector))
                  ) {
                    handlers.splice(j, 1);

                    if (handleObj.selector) {
                      handlers.delegateCount--;
                    }
                    if (special.remove) {
                      special.remove.call(elem, handleObj);
                    }
                  }
                }

                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                  if (
                    !special.teardown ||
                    special.teardown.call(elem, namespaces, elemData.handle) ===
                      false
                  ) {
                    jQuery.removeEvent(elem, type, elemData.handle);
                  }

                  delete events[type];
                }
              }

              // Remove data and the expando if it's no longer used
              if (jQuery.isEmptyObject(events)) {
                dataPriv.remove(elem, "handle events");
              }
            },

            dispatch: function (nativeEvent) {
              var i,
                j,
                ret,
                matched,
                handleObj,
                handlerQueue,
                args = new Array(arguments.length),
                // Make a writable jQuery.Event from the native event object
                event = jQuery.event.fix(nativeEvent),
                handlers =
                  (dataPriv.get(this, "events") || Object.create(null))[
                    event.type
                  ] || [],
                special = jQuery.event.special[event.type] || {};

              // Use the fix-ed jQuery.Event rather than the (read-only) native event
              args[0] = event;

              for (i = 1; i < arguments.length; i++) {
                args[i] = arguments[i];
              }

              event.delegateTarget = this;

              // Call the preDispatch hook for the mapped type, and let it bail if desired
              if (
                special.preDispatch &&
                special.preDispatch.call(this, event) === false
              ) {
                return;
              }

              // Determine handlers
              handlerQueue = jQuery.event.handlers.call(this, event, handlers);

              // Run delegates first; they may want to stop propagation beneath us
              i = 0;
              while (
                (matched = handlerQueue[i++]) &&
                !event.isPropagationStopped()
              ) {
                event.currentTarget = matched.elem;

                j = 0;
                while (
                  (handleObj = matched.handlers[j++]) &&
                  !event.isImmediatePropagationStopped()
                ) {
                  // If the event is namespaced, then each handler is only invoked if it is
                  // specially universal or its namespaces are a superset of the event's.
                  if (
                    !event.rnamespace ||
                    handleObj.namespace === false ||
                    event.rnamespace.test(handleObj.namespace)
                  ) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;

                    ret = (
                      (jQuery.event.special[handleObj.origType] || {}).handle ||
                      handleObj.handler
                    ).apply(matched.elem, args);

                    if (ret !== undefined) {
                      if ((event.result = ret) === false) {
                        event.preventDefault();
                        event.stopPropagation();
                      }
                    }
                  }
                }
              }

              // Call the postDispatch hook for the mapped type
              if (special.postDispatch) {
                special.postDispatch.call(this, event);
              }

              return event.result;
            },

            handlers: function (event, handlers) {
              var i,
                handleObj,
                sel,
                matchedHandlers,
                matchedSelectors,
                handlerQueue = [],
                delegateCount = handlers.delegateCount,
                cur = event.target;

              // Find delegate handlers
              if (
                delegateCount &&
                // Support: IE <=9
                // Black-hole SVG <use> instance trees (trac-13180)
                cur.nodeType &&
                // Support: Firefox <=42
                // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
                // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
                // Support: IE 11 only
                // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
                !(event.type === "click" && event.button >= 1)
              ) {
                for (; cur !== this; cur = cur.parentNode || this) {
                  // Don't check non-elements (#13208)
                  // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                  if (
                    cur.nodeType === 1 &&
                    !(event.type === "click" && cur.disabled === true)
                  ) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for (i = 0; i < delegateCount; i++) {
                      handleObj = handlers[i];

                      // Don't conflict with Object.prototype properties (#13203)
                      sel = handleObj.selector + " ";

                      if (matchedSelectors[sel] === undefined) {
                        matchedSelectors[sel] = handleObj.needsContext
                          ? jQuery(sel, this).index(cur) > -1
                          : jQuery.find(sel, this, null, [cur]).length;
                      }
                      if (matchedSelectors[sel]) {
                        matchedHandlers.push(handleObj);
                      }
                    }
                    if (matchedHandlers.length) {
                      handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers,
                      });
                    }
                  }
                }
              }

              // Add the remaining (directly-bound) handlers
              cur = this;
              if (delegateCount < handlers.length) {
                handlerQueue.push({
                  elem: cur,
                  handlers: handlers.slice(delegateCount),
                });
              }

              return handlerQueue;
            },

            addProp: function (name, hook) {
              Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,

                get: isFunction(hook)
                  ? function () {
                      if (this.originalEvent) {
                        return hook(this.originalEvent);
                      }
                    }
                  : function () {
                      if (this.originalEvent) {
                        return this.originalEvent[name];
                      }
                    },

                set: function (value) {
                  Object.defineProperty(this, name, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: value,
                  });
                },
              });
            },

            fix: function (originalEvent) {
              return originalEvent[jQuery.expando]
                ? originalEvent
                : new jQuery.Event(originalEvent);
            },

            special: {
              load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true,
              },
              click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function (data) {
                  // For mutual compressibility with _default, replace `this` access with a local var.
                  // `|| data` is dead code meant only to preserve the variable through minification.
                  var el = this || data;

                  // Claim the first handler
                  if (
                    rcheckableType.test(el.type) &&
                    el.click &&
                    nodeName(el, "input")
                  ) {
                    // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                  }

                  // Return false to allow normal processing in the caller
                  return false;
                },
                trigger: function (data) {
                  // For mutual compressibility with _default, replace `this` access with a local var.
                  // `|| data` is dead code meant only to preserve the variable through minification.
                  var el = this || data;

                  // Force setup before triggering a click
                  if (
                    rcheckableType.test(el.type) &&
                    el.click &&
                    nodeName(el, "input")
                  ) {
                    leverageNative(el, "click");
                  }

                  // Return non-false to allow normal event-path propagation
                  return true;
                },

                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function (event) {
                  var target = event.target;
                  return (
                    (rcheckableType.test(target.type) &&
                      target.click &&
                      nodeName(target, "input") &&
                      dataPriv.get(target, "click")) ||
                    nodeName(target, "a")
                  );
                },
              },

              beforeunload: {
                postDispatch: function (event) {
                  // Support: Firefox 20+
                  // Firefox doesn't alert if the returnValue field is not set.
                  if (event.result !== undefined && event.originalEvent) {
                    event.originalEvent.returnValue = event.result;
                  }
                },
              },
            },
          };

          // Ensure the presence of an event listener that handles manually-triggered
          // synthetic events by interrupting progress until reinvoked in response to
          // *native* events that it fires directly, ensuring that state changes have
          // already occurred before other listeners are invoked.
          function leverageNative(el, type, expectSync) {
            // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
            if (!expectSync) {
              if (dataPriv.get(el, type) === undefined) {
                jQuery.event.add(el, type, returnTrue);
              }
              return;
            }

            // Register the controller as a special universal handler for all event namespaces
            dataPriv.set(el, type, false);
            jQuery.event.add(el, type, {
              namespace: false,
              handler: function (event) {
                var notAsync,
                  result,
                  saved = dataPriv.get(this, type);

                if (event.isTrigger & 1 && this[type]) {
                  // Interrupt processing of the outer synthetic .trigger()ed event
                  // Saved data should be false in such cases, but might be a leftover capture object
                  // from an async native handler (gh-4350)
                  if (!saved.length) {
                    // Store arguments for use when handling the inner native event
                    // There will always be at least one argument (an event object), so this array
                    // will not be confused with a leftover capture object.
                    saved = slice.call(arguments);
                    dataPriv.set(this, type, saved);

                    // Trigger the native event and capture its result
                    // Support: IE <=9 - 11+
                    // focus() and blur() are asynchronous
                    notAsync = expectSync(this, type);
                    this[type]();
                    result = dataPriv.get(this, type);
                    if (saved !== result || notAsync) {
                      dataPriv.set(this, type, false);
                    } else {
                      result = {};
                    }
                    if (saved !== result) {
                      // Cancel the outer synthetic event
                      event.stopImmediatePropagation();
                      event.preventDefault();

                      // Support: Chrome 86+
                      // In Chrome, if an element having a focusout handler is blurred by
                      // clicking outside of it, it invokes the handler synchronously. If
                      // that handler calls `.remove()` on the element, the data is cleared,
                      // leaving `result` undefined. We need to guard against this.
                      return result && result.value;
                    }

                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                  } else if ((jQuery.event.special[type] || {}).delegateType) {
                    event.stopPropagation();
                  }

                  // If this is a native event triggered above, everything is now in order
                  // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {
                  // ...and capture the result
                  dataPriv.set(this, type, {
                    value: jQuery.event.trigger(
                      // Support: IE <=9 - 11+
                      // Extend with the prototype to reset the above stopImmediatePropagation()
                      jQuery.extend(saved[0], jQuery.Event.prototype),
                      saved.slice(1),
                      this
                    ),
                  });

                  // Abort handling of the native event
                  event.stopImmediatePropagation();
                }
              },
            });
          }

          jQuery.removeEvent = function (elem, type, handle) {
            // This "if" is needed for plain objects
            if (elem.removeEventListener) {
              elem.removeEventListener(type, handle);
            }
          };

          jQuery.Event = function (src, props) {
            // Allow instantiation without the 'new' keyword
            if (!(this instanceof jQuery.Event)) {
              return new jQuery.Event(src, props);
            }

            // Event object
            if (src && src.type) {
              this.originalEvent = src;
              this.type = src.type;

              // Events bubbling up the document may have been marked as prevented
              // by a handler lower down the tree; reflect the correct value.
              this.isDefaultPrevented =
                src.defaultPrevented ||
                (src.defaultPrevented === undefined &&
                  // Support: Android <=2.3 only
                  src.returnValue === false)
                  ? returnTrue
                  : returnFalse;

              // Create target properties
              // Support: Safari <=6 - 7 only
              // Target should not be a text node (#504, #13143)
              this.target =
                src.target && src.target.nodeType === 3
                  ? src.target.parentNode
                  : src.target;

              this.currentTarget = src.currentTarget;
              this.relatedTarget = src.relatedTarget;

              // Event type
            } else {
              this.type = src;
            }

            // Put explicitly provided properties onto the event object
            if (props) {
              jQuery.extend(this, props);
            }

            // Create a timestamp if incoming event doesn't have one
            this.timeStamp = (src && src.timeStamp) || Date.now();

            // Mark it as fixed
            this[jQuery.expando] = true;
          };

          // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
          // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
          jQuery.Event.prototype = {
            constructor: jQuery.Event,
            isDefaultPrevented: returnFalse,
            isPropagationStopped: returnFalse,
            isImmediatePropagationStopped: returnFalse,
            isSimulated: false,

            preventDefault: function () {
              var e = this.originalEvent;

              this.isDefaultPrevented = returnTrue;

              if (e && !this.isSimulated) {
                e.preventDefault();
              }
            },
            stopPropagation: function () {
              var e = this.originalEvent;

              this.isPropagationStopped = returnTrue;

              if (e && !this.isSimulated) {
                e.stopPropagation();
              }
            },
            stopImmediatePropagation: function () {
              var e = this.originalEvent;

              this.isImmediatePropagationStopped = returnTrue;

              if (e && !this.isSimulated) {
                e.stopImmediatePropagation();
              }

              this.stopPropagation();
            },
          };

          // Includes all common event props including KeyEvent and MouseEvent specific props
          jQuery.each(
            {
              altKey: true,
              bubbles: true,
              cancelable: true,
              changedTouches: true,
              ctrlKey: true,
              detail: true,
              eventPhase: true,
              metaKey: true,
              pageX: true,
              pageY: true,
              shiftKey: true,
              view: true,
              char: true,
              code: true,
              charCode: true,
              key: true,
              keyCode: true,
              button: true,
              buttons: true,
              clientX: true,
              clientY: true,
              offsetX: true,
              offsetY: true,
              pointerId: true,
              pointerType: true,
              screenX: true,
              screenY: true,
              targetTouches: true,
              toElement: true,
              touches: true,
              which: true,
            },
            jQuery.event.addProp
          );

          jQuery.each(
            { focus: "focusin", blur: "focusout" },
            function (type, delegateType) {
              jQuery.event.special[type] = {
                // Utilize native event if possible so blur/focus sequence is correct
                setup: function () {
                  // Claim the first handler
                  // dataPriv.set( this, "focus", ... )
                  // dataPriv.set( this, "blur", ... )
                  leverageNative(this, type, expectSync);

                  // Return false to allow normal processing in the caller
                  return false;
                },
                trigger: function () {
                  // Force setup before trigger
                  leverageNative(this, type);

                  // Return non-false to allow normal event-path propagation
                  return true;
                },

                // Suppress native focus or blur as it's already being fired
                // in leverageNative.
                _default: function () {
                  return true;
                },

                delegateType: delegateType,
              };
            }
          );

          // Create mouseenter/leave events using mouseover/out and event-time checks
          // so that event delegation works in jQuery.
          // Do the same for pointerenter/pointerleave and pointerover/pointerout
          //
          // Support: Safari 7 only
          // Safari sends mouseenter too often; see:
          // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
          // for the description of the bug (it existed in older Chrome versions as well).
          jQuery.each(
            {
              mouseenter: "mouseover",
              mouseleave: "mouseout",
              pointerenter: "pointerover",
              pointerleave: "pointerout",
            },
            function (orig, fix) {
              jQuery.event.special[orig] = {
                delegateType: fix,
                bindType: fix,

                handle: function (event) {
                  var ret,
                    target = this,
                    related = event.relatedTarget,
                    handleObj = event.handleObj;

                  // For mouseenter/leave call the handler if related is outside the target.
                  // NB: No relatedTarget if the mouse left/entered the browser window
                  if (
                    !related ||
                    (related !== target && !jQuery.contains(target, related))
                  ) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                  }
                  return ret;
                },
              };
            }
          );

          jQuery.fn.extend({
            on: function (types, selector, data, fn) {
              return on(this, types, selector, data, fn);
            },
            one: function (types, selector, data, fn) {
              return on(this, types, selector, data, fn, 1);
            },
            off: function (types, selector, fn) {
              var handleObj, type;
              if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(
                  handleObj.namespace
                    ? handleObj.origType + "." + handleObj.namespace
                    : handleObj.origType,
                  handleObj.selector,
                  handleObj.handler
                );
                return this;
              }
              if (typeof types === "object") {
                // ( types-object [, selector] )
                for (type in types) {
                  this.off(type, selector, types[type]);
                }
                return this;
              }
              if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
              }
              if (fn === false) {
                fn = returnFalse;
              }
              return this.each(function () {
                jQuery.event.remove(this, types, fn, selector);
              });
            },
          });

          var // Support: IE <=10 - 11, Edge 12 - 13 only
            // In IE/Edge using regex groups here causes severe slowdowns.
            // See https://connect.microsoft.com/IE/feedback/details/1736512/
            rnoInnerhtml = /<script|<style|<link/i,
            // checked="checked" or checked
            rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
            rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

          // Prefer a tbody over its parent table for containing new rows
          function manipulationTarget(elem, content) {
            if (
              nodeName(elem, "table") &&
              nodeName(
                content.nodeType !== 11 ? content : content.firstChild,
                "tr"
              )
            ) {
              return jQuery(elem).children("tbody")[0] || elem;
            }

            return elem;
          }

          // Replace/restore the type attribute of script elements for safe DOM manipulation
          function disableScript(elem) {
            elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
            return elem;
          }
          function restoreScript(elem) {
            if ((elem.type || "").slice(0, 5) === "true/") {
              elem.type = elem.type.slice(5);
            } else {
              elem.removeAttribute("type");
            }

            return elem;
          }

          function cloneCopyEvent(src, dest) {
            var i, l, type, pdataOld, udataOld, udataCur, events;

            if (dest.nodeType !== 1) {
              return;
            }

            // 1. Copy private data: events, handlers, etc.
            if (dataPriv.hasData(src)) {
              pdataOld = dataPriv.get(src);
              events = pdataOld.events;

              if (events) {
                dataPriv.remove(dest, "handle events");

                for (type in events) {
                  for (i = 0, l = events[type].length; i < l; i++) {
                    jQuery.event.add(dest, type, events[type][i]);
                  }
                }
              }
            }

            // 2. Copy user data
            if (dataUser.hasData(src)) {
              udataOld = dataUser.access(src);
              udataCur = jQuery.extend({}, udataOld);

              dataUser.set(dest, udataCur);
            }
          }

          // Fix IE bugs, see support tests
          function fixInput(src, dest) {
            var nodeName = dest.nodeName.toLowerCase();

            // Fails to persist the checked state of a cloned checkbox or radio button.
            if (nodeName === "input" && rcheckableType.test(src.type)) {
              dest.checked = src.checked;

              // Fails to return the selected option to the default selected state when cloning options
            } else if (nodeName === "input" || nodeName === "textarea") {
              dest.defaultValue = src.defaultValue;
            }
          }

          function domManip(collection, args, callback, ignored) {
            // Flatten any nested arrays
            args = flat(args);

            var fragment,
              first,
              scripts,
              hasScripts,
              node,
              doc,
              i = 0,
              l = collection.length,
              iNoClone = l - 1,
              value = args[0],
              valueIsFunction = isFunction(value);

            // We can't cloneNode fragments that contain checked, in WebKit
            if (
              valueIsFunction ||
              (l > 1 &&
                typeof value === "string" &&
                !support.checkClone &&
                rchecked.test(value))
            ) {
              return collection.each(function (index) {
                var self = collection.eq(index);
                if (valueIsFunction) {
                  args[0] = value.call(this, index, self.html());
                }
                domManip(self, args, callback, ignored);
              });
            }

            if (l) {
              fragment = buildFragment(
                args,
                collection[0].ownerDocument,
                false,
                collection,
                ignored
              );
              first = fragment.firstChild;

              if (fragment.childNodes.length === 1) {
                fragment = first;
              }

              // Require either new content or an interest in ignored elements to invoke the callback
              if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;

                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (#8070).
                for (; i < l; i++) {
                  node = fragment;

                  if (i !== iNoClone) {
                    node = jQuery.clone(node, true, true);

                    // Keep references to cloned scripts for later restoration
                    if (hasScripts) {
                      // Support: Android <=4.0 only, PhantomJS 1 only
                      // push.apply(_, arraylike) throws on ancient WebKit
                      jQuery.merge(scripts, getAll(node, "script"));
                    }
                  }

                  callback.call(collection[i], node, i);
                }

                if (hasScripts) {
                  doc = scripts[scripts.length - 1].ownerDocument;

                  // Reenable scripts
                  jQuery.map(scripts, restoreScript);

                  // Evaluate executable scripts on first document insertion
                  for (i = 0; i < hasScripts; i++) {
                    node = scripts[i];
                    if (
                      rscriptType.test(node.type || "") &&
                      !dataPriv.access(node, "globalEval") &&
                      jQuery.contains(doc, node)
                    ) {
                      if (
                        node.src &&
                        (node.type || "").toLowerCase() !== "module"
                      ) {
                        // Optional AJAX dependency, but won't run scripts if not present
                        if (jQuery._evalUrl && !node.noModule) {
                          jQuery._evalUrl(
                            node.src,
                            {
                              nonce: node.nonce || node.getAttribute("nonce"),
                            },
                            doc
                          );
                        }
                      } else {
                        DOMEval(
                          node.textContent.replace(rcleanScript, ""),
                          node,
                          doc
                        );
                      }
                    }
                  }
                }
              }
            }

            return collection;
          }

          function remove(elem, selector, keepData) {
            var node,
              nodes = selector ? jQuery.filter(selector, elem) : elem,
              i = 0;

            for (; (node = nodes[i]) != null; i++) {
              if (!keepData && node.nodeType === 1) {
                jQuery.cleanData(getAll(node));
              }

              if (node.parentNode) {
                if (keepData && isAttached(node)) {
                  setGlobalEval(getAll(node, "script"));
                }
                node.parentNode.removeChild(node);
              }
            }

            return elem;
          }

          jQuery.extend({
            htmlPrefilter: function (html) {
              return html;
            },

            clone: function (elem, dataAndEvents, deepDataAndEvents) {
              var i,
                l,
                srcElements,
                destElements,
                clone = elem.cloneNode(true),
                inPage = isAttached(elem);

              // Fix IE cloning issues
              if (
                !support.noCloneChecked &&
                (elem.nodeType === 1 || elem.nodeType === 11) &&
                !jQuery.isXMLDoc(elem)
              ) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);

                for (i = 0, l = srcElements.length; i < l; i++) {
                  fixInput(srcElements[i], destElements[i]);
                }
              }

              // Copy the events from the original to the clone
              if (dataAndEvents) {
                if (deepDataAndEvents) {
                  srcElements = srcElements || getAll(elem);
                  destElements = destElements || getAll(clone);

                  for (i = 0, l = srcElements.length; i < l; i++) {
                    cloneCopyEvent(srcElements[i], destElements[i]);
                  }
                } else {
                  cloneCopyEvent(elem, clone);
                }
              }

              // Preserve script evaluation history
              destElements = getAll(clone, "script");
              if (destElements.length > 0) {
                setGlobalEval(destElements, !inPage && getAll(elem, "script"));
              }

              // Return the cloned set
              return clone;
            },

            cleanData: function (elems) {
              var data,
                elem,
                type,
                special = jQuery.event.special,
                i = 0;

              for (; (elem = elems[i]) !== undefined; i++) {
                if (acceptData(elem)) {
                  if ((data = elem[dataPriv.expando])) {
                    if (data.events) {
                      for (type in data.events) {
                        if (special[type]) {
                          jQuery.event.remove(elem, type);

                          // This is a shortcut to avoid jQuery.event.remove's overhead
                        } else {
                          jQuery.removeEvent(elem, type, data.handle);
                        }
                      }
                    }

                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                  }
                  if (elem[dataUser.expando]) {
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataUser.expando] = undefined;
                  }
                }
              }
            },
          });

          jQuery.fn.extend({
            detach: function (selector) {
              return remove(this, selector, true);
            },

            remove: function (selector) {
              return remove(this, selector);
            },

            text: function (value) {
              return access(
                this,
                function (value) {
                  return value === undefined
                    ? jQuery.text(this)
                    : this.empty().each(function () {
                        if (
                          this.nodeType === 1 ||
                          this.nodeType === 11 ||
                          this.nodeType === 9
                        ) {
                          this.textContent = value;
                        }
                      });
                },
                null,
                value,
                arguments.length
              );
            },

            append: function () {
              return domManip(this, arguments, function (elem) {
                if (
                  this.nodeType === 1 ||
                  this.nodeType === 11 ||
                  this.nodeType === 9
                ) {
                  var target = manipulationTarget(this, elem);
                  target.appendChild(elem);
                }
              });
            },

            prepend: function () {
              return domManip(this, arguments, function (elem) {
                if (
                  this.nodeType === 1 ||
                  this.nodeType === 11 ||
                  this.nodeType === 9
                ) {
                  var target = manipulationTarget(this, elem);
                  target.insertBefore(elem, target.firstChild);
                }
              });
            },

            before: function () {
              return domManip(this, arguments, function (elem) {
                if (this.parentNode) {
                  this.parentNode.insertBefore(elem, this);
                }
              });
            },

            after: function () {
              return domManip(this, arguments, function (elem) {
                if (this.parentNode) {
                  this.parentNode.insertBefore(elem, this.nextSibling);
                }
              });
            },

            empty: function () {
              var elem,
                i = 0;

              for (; (elem = this[i]) != null; i++) {
                if (elem.nodeType === 1) {
                  // Prevent memory leaks
                  jQuery.cleanData(getAll(elem, false));

                  // Remove any remaining nodes
                  elem.textContent = "";
                }
              }

              return this;
            },

            clone: function (dataAndEvents, deepDataAndEvents) {
              dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
              deepDataAndEvents =
                deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

              return this.map(function () {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
              });
            },

            html: function (value) {
              return access(
                this,
                function (value) {
                  var elem = this[0] || {},
                    i = 0,
                    l = this.length;

                  if (value === undefined && elem.nodeType === 1) {
                    return elem.innerHTML;
                  }

                  // See if we can take a shortcut and just use innerHTML
                  if (
                    typeof value === "string" &&
                    !rnoInnerhtml.test(value) &&
                    !wrapMap[
                      (rtagName.exec(value) || ["", ""])[1].toLowerCase()
                    ]
                  ) {
                    value = jQuery.htmlPrefilter(value);

                    try {
                      for (; i < l; i++) {
                        elem = this[i] || {};

                        // Remove element nodes and prevent memory leaks
                        if (elem.nodeType === 1) {
                          jQuery.cleanData(getAll(elem, false));
                          elem.innerHTML = value;
                        }
                      }

                      elem = 0;

                      // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                  }

                  if (elem) {
                    this.empty().append(value);
                  }
                },
                null,
                value,
                arguments.length
              );
            },

            replaceWith: function () {
              var ignored = [];

              // Make the changes, replacing each non-ignored context element with the new content
              return domManip(
                this,
                arguments,
                function (elem) {
                  var parent = this.parentNode;

                  if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) {
                      parent.replaceChild(elem, this);
                    }
                  }

                  // Force callback invocation
                },
                ignored
              );
            },
          });

          jQuery.each(
            {
              appendTo: "append",
              prependTo: "prepend",
              insertBefore: "before",
              insertAfter: "after",
              replaceAll: "replaceWith",
            },
            function (name, original) {
              jQuery.fn[name] = function (selector) {
                var elems,
                  ret = [],
                  insert = jQuery(selector),
                  last = insert.length - 1,
                  i = 0;

                for (; i <= last; i++) {
                  elems = i === last ? this : this.clone(true);
                  jQuery(insert[i])[original](elems);

                  // Support: Android <=4.0 only, PhantomJS 1 only
                  // .get() because push.apply(_, arraylike) throws on ancient WebKit
                  push.apply(ret, elems.get());
                }

                return this.pushStack(ret);
              };
            }
          );
          var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

          var getStyles = function (elem) {
            // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
            // IE throws on elements created in popups
            // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
            var view = elem.ownerDocument.defaultView;

            if (!view || !view.opener) {
              view = window;
            }

            return view.getComputedStyle(elem);
          };

          var swap = function (elem, options, callback) {
            var ret,
              name,
              old = {};

            // Remember the old values, and insert the new ones
            for (name in options) {
              old[name] = elem.style[name];
              elem.style[name] = options[name];
            }

            ret = callback.call(elem);

            // Revert the old values
            for (name in options) {
              elem.style[name] = old[name];
            }

            return ret;
          };

          var rboxStyle = new RegExp(cssExpand.join("|"), "i");

          (function () {
            // Executing both pixelPosition & boxSizingReliable tests require only one layout
            // so they're executed at the same time to save the second computation.
            function computeStyleTests() {
              // This is a singleton, we need to execute it only once
              if (!div) {
                return;
              }

              container.style.cssText =
                "position:absolute;left:-11111px;width:60px;" +
                "margin-top:1px;padding:0;border:0";
              div.style.cssText =
                "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
                "margin:auto;border:1px;padding:1px;" +
                "width:60%;top:1%";
              documentElement.appendChild(container).appendChild(div);

              var divStyle = window.getComputedStyle(div);
              pixelPositionVal = divStyle.top !== "1%";

              // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
              reliableMarginLeftVal =
                roundPixelMeasures(divStyle.marginLeft) === 12;

              // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
              // Some styles come back with percentage values, even though they shouldn't
              div.style.right = "60%";
              pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

              // Support: IE 9 - 11 only
              // Detect misreporting of content dimensions for box-sizing:border-box elements
              boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

              // Support: IE 9 only
              // Detect overflow:scroll screwiness (gh-3699)
              // Support: Chrome <=64
              // Don't get tricked when zoom affects offsetWidth (gh-4029)
              div.style.position = "absolute";
              scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;

              documentElement.removeChild(container);

              // Nullify the div so it wouldn't be stored in the memory and
              // it will also be a sign that checks already performed
              div = null;
            }

            function roundPixelMeasures(measure) {
              return Math.round(parseFloat(measure));
            }

            var pixelPositionVal,
              boxSizingReliableVal,
              scrollboxSizeVal,
              pixelBoxStylesVal,
              reliableTrDimensionsVal,
              reliableMarginLeftVal,
              container = document.createElement("div"),
              div = document.createElement("div");

            // Finish early in limited (non-browser) environments
            if (!div.style) {
              return;
            }

            // Support: IE <=9 - 11 only
            // Style of cloned element affects source element cloned (#8908)
            div.style.backgroundClip = "content-box";
            div.cloneNode(true).style.backgroundClip = "";
            support.clearCloneStyle =
              div.style.backgroundClip === "content-box";

            jQuery.extend(support, {
              boxSizingReliable: function () {
                computeStyleTests();
                return boxSizingReliableVal;
              },
              pixelBoxStyles: function () {
                computeStyleTests();
                return pixelBoxStylesVal;
              },
              pixelPosition: function () {
                computeStyleTests();
                return pixelPositionVal;
              },
              reliableMarginLeft: function () {
                computeStyleTests();
                return reliableMarginLeftVal;
              },
              scrollboxSize: function () {
                computeStyleTests();
                return scrollboxSizeVal;
              },

              // Support: IE 9 - 11+, Edge 15 - 18+
              // IE/Edge misreport `getComputedStyle` of table rows with width/height
              // set in CSS while `offset*` properties report correct values.
              // Behavior in IE 9 is more subtle than in newer versions & it passes
              // some versions of this test; make sure not to make it pass there!
              //
              // Support: Firefox 70+
              // Only Firefox includes border widths
              // in computed dimensions. (gh-4529)
              reliableTrDimensions: function () {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                  table = document.createElement("table");
                  tr = document.createElement("tr");
                  trChild = document.createElement("div");

                  table.style.cssText =
                    "position:absolute;left:-11111px;border-collapse:separate";
                  tr.style.cssText = "border:1px solid";

                  // Support: Chrome 86+
                  // Height set through cssText does not get applied.
                  // Computed height then comes back as 0.
                  tr.style.height = "1px";
                  trChild.style.height = "9px";

                  // Support: Android 8 Chrome 86+
                  // In our bodyBackground.html iframe,
                  // display for all div elements is set to "inline",
                  // which causes a problem only in Android 8 Chrome 86.
                  // Ensuring the div is display: block
                  // gets around this issue.
                  trChild.style.display = "block";

                  documentElement
                    .appendChild(table)
                    .appendChild(tr)
                    .appendChild(trChild);

                  trStyle = window.getComputedStyle(tr);
                  reliableTrDimensionsVal =
                    parseInt(trStyle.height, 10) +
                      parseInt(trStyle.borderTopWidth, 10) +
                      parseInt(trStyle.borderBottomWidth, 10) ===
                    tr.offsetHeight;

                  documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
              },
            });
          })();

          function curCSS(elem, name, computed) {
            var width,
              minWidth,
              maxWidth,
              ret,
              // Support: Firefox 51+
              // Retrieving style before computed somehow
              // fixes an issue with getting wrong values
              // on detached elements
              style = elem.style;

            computed = computed || getStyles(elem);

            // getPropertyValue is needed for:
            //   .css('filter') (IE 9 only, #12537)
            //   .css('--customProperty) (#3144)
            if (computed) {
              ret = computed.getPropertyValue(name) || computed[name];

              if (ret === "" && !isAttached(elem)) {
                ret = jQuery.style(elem, name);
              }

              // A tribute to the "awesome hack by Dean Edwards"
              // Android Browser returns percentage for some values,
              // but width seems to be reliably pixels.
              // This is against the CSSOM draft spec:
              // https://drafts.csswg.org/cssom/#resolved-values
              if (
                !support.pixelBoxStyles() &&
                rnumnonpx.test(ret) &&
                rboxStyle.test(name)
              ) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;

                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;

                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
              }
            }

            return ret !== undefined
              ? // Support: IE <=9 - 11 only
                // IE returns zIndex value as an integer.
                ret + ""
              : ret;
          }

          function addGetHookIf(conditionFn, hookFn) {
            // Define the hook, we'll check on the first run if it's really needed.
            return {
              get: function () {
                if (conditionFn()) {
                  // Hook not needed (or it's not possible to use it due
                  // to missing dependency), remove it.
                  delete this.get;
                  return;
                }

                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
              },
            };
          }

          var cssPrefixes = ["Webkit", "Moz", "ms"],
            emptyStyle = document.createElement("div").style,
            vendorProps = {};

          // Return a vendor-prefixed property or undefined
          function vendorPropName(name) {
            // Check for vendor prefixed names
            var capName = name[0].toUpperCase() + name.slice(1),
              i = cssPrefixes.length;

            while (i--) {
              name = cssPrefixes[i] + capName;
              if (name in emptyStyle) {
                return name;
              }
            }
          }

          // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
          function finalPropName(name) {
            var final = jQuery.cssProps[name] || vendorProps[name];

            if (final) {
              return final;
            }
            if (name in emptyStyle) {
              return name;
            }
            return (vendorProps[name] = vendorPropName(name) || name);
          }

          var // Swappable if display is none or starts with table
            // except "table", "table-cell", or "table-caption"
            // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
            rdisplayswap = /^(none|table(?!-c[ea]).+)/,
            rcustomProp = /^--/,
            cssShow = {
              position: "absolute",
              visibility: "hidden",
              display: "block",
            },
            cssNormalTransform = {
              letterSpacing: "0",
              fontWeight: "400",
            };

          function setPositiveNumber(_elem, value, subtract) {
            // Any relative (+/-) values have already been
            // normalized at this point
            var matches = rcssNum.exec(value);
            return matches
              ? // Guard against undefined "subtract", e.g., when used as in cssHooks
                Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px")
              : value;
          }

          function boxModelAdjustment(
            elem,
            dimension,
            box,
            isBorderBox,
            styles,
            computedVal
          ) {
            var i = dimension === "width" ? 1 : 0,
              extra = 0,
              delta = 0;

            // Adjustment may not be necessary
            if (box === (isBorderBox ? "border" : "content")) {
              return 0;
            }

            for (; i < 4; i += 2) {
              // Both box models exclude margin
              if (box === "margin") {
                delta += jQuery.css(elem, box + cssExpand[i], true, styles);
              }

              // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
              if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(
                  elem,
                  "padding" + cssExpand[i],
                  true,
                  styles
                );

                // For "border" or "margin", add border
                if (box !== "padding") {
                  delta += jQuery.css(
                    elem,
                    "border" + cssExpand[i] + "Width",
                    true,
                    styles
                  );

                  // But still keep track of it otherwise
                } else {
                  extra += jQuery.css(
                    elem,
                    "border" + cssExpand[i] + "Width",
                    true,
                    styles
                  );
                }

                // If we get here with a border-box (content + padding + border), we're seeking "content" or
                // "padding" or "margin"
              } else {
                // For "content", subtract padding
                if (box === "content") {
                  delta -= jQuery.css(
                    elem,
                    "padding" + cssExpand[i],
                    true,
                    styles
                  );
                }

                // For "content" or "padding", subtract border
                if (box !== "margin") {
                  delta -= jQuery.css(
                    elem,
                    "border" + cssExpand[i] + "Width",
                    true,
                    styles
                  );
                }
              }
            }

            // Account for positive content-box scroll gutter when requested by providing computedVal
            if (!isBorderBox && computedVal >= 0) {
              // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
              // Assuming integer scroll gutter, subtract the rest and round down
              delta +=
                Math.max(
                  0,
                  Math.ceil(
                    elem[
                      "offset" + dimension[0].toUpperCase() + dimension.slice(1)
                    ] -
                      computedVal -
                      delta -
                      extra -
                      0.5

                    // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
                    // Use an explicit zero to avoid NaN (gh-3964)
                  )
                ) || 0;
            }

            return delta;
          }

          function getWidthOrHeight(elem, dimension, extra) {
            // Start with computed style
            var styles = getStyles(elem),
              // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
              // Fake content-box until we know it's needed to know the true value.
              boxSizingNeeded = !support.boxSizingReliable() || extra,
              isBorderBox =
                boxSizingNeeded &&
                jQuery.css(elem, "boxSizing", false, styles) === "border-box",
              valueIsBorderBox = isBorderBox,
              val = curCSS(elem, dimension, styles),
              offsetProp =
                "offset" + dimension[0].toUpperCase() + dimension.slice(1);

            // Support: Firefox <=54
            // Return a confounding non-pixel value or feign ignorance, as appropriate.
            if (rnumnonpx.test(val)) {
              if (!extra) {
                return val;
              }
              val = "auto";
            }

            // Support: IE 9 - 11 only
            // Use offsetWidth/offsetHeight for when box sizing is unreliable.
            // In those cases, the computed value can be trusted to be border-box.
            if (
              ((!support.boxSizingReliable() && isBorderBox) ||
                // Support: IE 10 - 11+, Edge 15 - 18+
                // IE/Edge misreport `getComputedStyle` of table rows with width/height
                // set in CSS while `offset*` properties report correct values.
                // Interestingly, in some cases IE 9 doesn't suffer from this issue.
                (!support.reliableTrDimensions() && nodeName(elem, "tr")) ||
                // Fall back to offsetWidth/offsetHeight when value is "auto"
                // This happens for inline elements with no explicit setting (gh-3571)
                val === "auto" ||
                // Support: Android <=4.1 - 4.3 only
                // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
                (!parseFloat(val) &&
                  jQuery.css(elem, "display", false, styles) === "inline")) &&
              // Make sure the element is visible & connected
              elem.getClientRects().length
            ) {
              isBorderBox =
                jQuery.css(elem, "boxSizing", false, styles) === "border-box";

              // Where available, offsetWidth/offsetHeight approximate border box dimensions.
              // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
              // retrieved value as a content box dimension.
              valueIsBorderBox = offsetProp in elem;
              if (valueIsBorderBox) {
                val = elem[offsetProp];
              }
            }

            // Normalize "" and auto
            val = parseFloat(val) || 0;

            // Adjust for the element's box model
            return (
              val +
              boxModelAdjustment(
                elem,
                dimension,
                extra || (isBorderBox ? "border" : "content"),
                valueIsBorderBox,
                styles,

                // Provide the current computed size to request scroll gutter calculation (gh-3589)
                val
              ) +
              "px"
            );
          }

          jQuery.extend({
            // Add in style property hooks for overriding the default
            // behavior of getting and setting a style property
            cssHooks: {
              opacity: {
                get: function (elem, computed) {
                  if (computed) {
                    // We should always get a number back from opacity
                    var ret = curCSS(elem, "opacity");
                    return ret === "" ? "1" : ret;
                  }
                },
              },
            },

            // Don't automatically add "px" to these possibly-unitless properties
            cssNumber: {
              animationIterationCount: true,
              columnCount: true,
              fillOpacity: true,
              flexGrow: true,
              flexShrink: true,
              fontWeight: true,
              gridArea: true,
              gridColumn: true,
              gridColumnEnd: true,
              gridColumnStart: true,
              gridRow: true,
              gridRowEnd: true,
              gridRowStart: true,
              lineHeight: true,
              opacity: true,
              order: true,
              orphans: true,
              widows: true,
              zIndex: true,
              zoom: true,
            },

            // Add in properties whose names you wish to fix before
            // setting or getting the value
            cssProps: {},

            // Get and set the style property on a DOM Node
            style: function (elem, name, value, extra) {
              // Don't set styles on text and comment nodes
              if (
                !elem ||
                elem.nodeType === 3 ||
                elem.nodeType === 8 ||
                !elem.style
              ) {
                return;
              }

              // Make sure that we're working with the right name
              var ret,
                type,
                hooks,
                origName = camelCase(name),
                isCustomProp = rcustomProp.test(name),
                style = elem.style;

              // Make sure that we're working with the right name. We don't
              // want to query the value if it is a CSS custom property
              // since they are user-defined.
              if (!isCustomProp) {
                name = finalPropName(origName);
              }

              // Gets hook for the prefixed version, then unprefixed version
              hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

              // Check if we're setting a value
              if (value !== undefined) {
                type = typeof value;

                // Convert "+=" or "-=" to relative numbers (#7345)
                if (
                  type === "string" &&
                  (ret = rcssNum.exec(value)) &&
                  ret[1]
                ) {
                  value = adjustCSS(elem, name, ret);

                  // Fixes bug #9237
                  type = "number";
                }

                // Make sure that null and NaN values aren't set (#7116)
                if (value == null || value !== value) {
                  return;
                }

                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) {
                  value +=
                    (ret && ret[3]) || (jQuery.cssNumber[origName] ? "" : "px");
                }

                // background-* props affect original clone's values
                if (
                  !support.clearCloneStyle &&
                  value === "" &&
                  name.indexOf("background") === 0
                ) {
                  style[name] = "inherit";
                }

                // If a hook was provided, use that value, otherwise just set the specified value
                if (
                  !hooks ||
                  !("set" in hooks) ||
                  (value = hooks.set(elem, value, extra)) !== undefined
                ) {
                  if (isCustomProp) {
                    style.setProperty(name, value);
                  } else {
                    style[name] = value;
                  }
                }
              } else {
                // If a hook was provided get the non-computed value from there
                if (
                  hooks &&
                  "get" in hooks &&
                  (ret = hooks.get(elem, false, extra)) !== undefined
                ) {
                  return ret;
                }

                // Otherwise just get the value from the style object
                return style[name];
              }
            },

            css: function (elem, name, extra, styles) {
              var val,
                num,
                hooks,
                origName = camelCase(name),
                isCustomProp = rcustomProp.test(name);

              // Make sure that we're working with the right name. We don't
              // want to modify the value if it is a CSS custom property
              // since they are user-defined.
              if (!isCustomProp) {
                name = finalPropName(origName);
              }

              // Try prefixed name followed by the unprefixed name
              hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

              // If a hook was provided get the computed value from there
              if (hooks && "get" in hooks) {
                val = hooks.get(elem, true, extra);
              }

              // Otherwise, if a way to get the computed value exists, use that
              if (val === undefined) {
                val = curCSS(elem, name, styles);
              }

              // Convert "normal" to computed value
              if (val === "normal" && name in cssNormalTransform) {
                val = cssNormalTransform[name];
              }

              // Make numeric if forced or a qualifier was provided and val looks numeric
              if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
              }

              return val;
            },
          });

          jQuery.each(["height", "width"], function (_i, dimension) {
            jQuery.cssHooks[dimension] = {
              get: function (elem, computed, extra) {
                if (computed) {
                  // Certain elements can have dimension info if we invisibly show them
                  // but it must have a current display style that would benefit
                  return rdisplayswap.test(jQuery.css(elem, "display")) &&
                    // Support: Safari 8+
                    // Table columns in Safari have non-zero offsetWidth & zero
                    // getBoundingClientRect().width unless display is changed.
                    // Support: IE <=11 only
                    // Running getBoundingClientRect on a disconnected node
                    // in IE throws an error.
                    (!elem.getClientRects().length ||
                      !elem.getBoundingClientRect().width)
                    ? swap(elem, cssShow, function () {
                        return getWidthOrHeight(elem, dimension, extra);
                      })
                    : getWidthOrHeight(elem, dimension, extra);
                }
              },

              set: function (elem, value, extra) {
                var matches,
                  styles = getStyles(elem),
                  // Only read styles.position if the test has a chance to fail
                  // to avoid forcing a reflow.
                  scrollboxSizeBuggy =
                    !support.scrollboxSize() && styles.position === "absolute",
                  // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                  boxSizingNeeded = scrollboxSizeBuggy || extra,
                  isBorderBox =
                    boxSizingNeeded &&
                    jQuery.css(elem, "boxSizing", false, styles) ===
                      "border-box",
                  subtract = extra
                    ? boxModelAdjustment(
                        elem,
                        dimension,
                        extra,
                        isBorderBox,
                        styles
                      )
                    : 0;

                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) {
                  subtract -= Math.ceil(
                    elem[
                      "offset" + dimension[0].toUpperCase() + dimension.slice(1)
                    ] -
                      parseFloat(styles[dimension]) -
                      boxModelAdjustment(
                        elem,
                        dimension,
                        "border",
                        false,
                        styles
                      ) -
                      0.5
                  );
                }

                // Convert to pixels if value adjustment is needed
                if (
                  subtract &&
                  (matches = rcssNum.exec(value)) &&
                  (matches[3] || "px") !== "px"
                ) {
                  elem.style[dimension] = value;
                  value = jQuery.css(elem, dimension);
                }

                return setPositiveNumber(elem, value, subtract);
              },
            };
          });

          jQuery.cssHooks.marginLeft = addGetHookIf(
            support.reliableMarginLeft,
            function (elem, computed) {
              if (computed) {
                return (
                  (parseFloat(curCSS(elem, "marginLeft")) ||
                    elem.getBoundingClientRect().left -
                      swap(elem, { marginLeft: 0 }, function () {
                        return elem.getBoundingClientRect().left;
                      })) + "px"
                );
              }
            }
          );

          // These hooks are used by animate to expand properties
          jQuery.each(
            {
              margin: "",
              padding: "",
              border: "Width",
            },
            function (prefix, suffix) {
              jQuery.cssHooks[prefix + suffix] = {
                expand: function (value) {
                  var i = 0,
                    expanded = {},
                    // Assumes a single number if not a string
                    parts =
                      typeof value === "string" ? value.split(" ") : [value];

                  for (; i < 4; i++) {
                    expanded[prefix + cssExpand[i] + suffix] =
                      parts[i] || parts[i - 2] || parts[0];
                  }

                  return expanded;
                },
              };

              if (prefix !== "margin") {
                jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
              }
            }
          );

          jQuery.fn.extend({
            css: function (name, value) {
              return access(
                this,
                function (elem, name, value) {
                  var styles,
                    len,
                    map = {},
                    i = 0;

                  if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;

                    for (; i < len; i++) {
                      map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    }

                    return map;
                  }

                  return value !== undefined
                    ? jQuery.style(elem, name, value)
                    : jQuery.css(elem, name);
                },
                name,
                value,
                arguments.length > 1
              );
            },
          });

          function Tween(elem, options, prop, end, easing) {
            return new Tween.prototype.init(elem, options, prop, end, easing);
          }
          jQuery.Tween = Tween;

          Tween.prototype = {
            constructor: Tween,
            init: function (elem, options, prop, end, easing, unit) {
              this.elem = elem;
              this.prop = prop;
              this.easing = easing || jQuery.easing._default;
              this.options = options;
              this.start = this.now = this.cur();
              this.end = end;
              this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
            },
            cur: function () {
              var hooks = Tween.propHooks[this.prop];

              return hooks && hooks.get
                ? hooks.get(this)
                : Tween.propHooks._default.get(this);
            },
            run: function (percent) {
              var eased,
                hooks = Tween.propHooks[this.prop];

              if (this.options.duration) {
                this.pos = eased = jQuery.easing[this.easing](
                  percent,
                  this.options.duration * percent,
                  0,
                  1,
                  this.options.duration
                );
              } else {
                this.pos = eased = percent;
              }
              this.now = (this.end - this.start) * eased + this.start;

              if (this.options.step) {
                this.options.step.call(this.elem, this.now, this);
              }

              if (hooks && hooks.set) {
                hooks.set(this);
              } else {
                Tween.propHooks._default.set(this);
              }
              return this;
            },
          };

          Tween.prototype.init.prototype = Tween.prototype;

          Tween.propHooks = {
            _default: {
              get: function (tween) {
                var result;

                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (
                  tween.elem.nodeType !== 1 ||
                  (tween.elem[tween.prop] != null &&
                    tween.elem.style[tween.prop] == null)
                ) {
                  return tween.elem[tween.prop];
                }

                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");

                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
              },
              set: function (tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) {
                  jQuery.fx.step[tween.prop](tween);
                } else if (
                  tween.elem.nodeType === 1 &&
                  (jQuery.cssHooks[tween.prop] ||
                    tween.elem.style[finalPropName(tween.prop)] != null)
                ) {
                  jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                } else {
                  tween.elem[tween.prop] = tween.now;
                }
              },
            },
          };

          // Support: IE <=9 only
          // Panic based approach to setting things on disconnected nodes
          Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
            set: function (tween) {
              if (tween.elem.nodeType && tween.elem.parentNode) {
                tween.elem[tween.prop] = tween.now;
              }
            },
          };

          jQuery.easing = {
            linear: function (p) {
              return p;
            },
            swing: function (p) {
              return 0.5 - Math.cos(p * Math.PI) / 2;
            },
            _default: "swing",
          };

          jQuery.fx = Tween.prototype.init;

          // Back compat <1.8 extension point
          jQuery.fx.step = {};

          var fxNow,
            inProgress,
            rfxtypes = /^(?:toggle|show|hide)$/,
            rrun = /queueHooks$/;

          function schedule() {
            if (inProgress) {
              if (document.hidden === false && window.requestAnimationFrame) {
                window.requestAnimationFrame(schedule);
              } else {
                window.setTimeout(schedule, jQuery.fx.interval);
              }

              jQuery.fx.tick();
            }
          }

          // Animations created synchronously will run synchronously
          function createFxNow() {
            window.setTimeout(function () {
              fxNow = undefined;
            });
            return (fxNow = Date.now());
          }

          // Generate parameters to create a standard animation
          function genFx(type, includeWidth) {
            var which,
              i = 0,
              attrs = { height: type };

            // If we include width, step value is 1 to do all cssExpand values,
            // otherwise step value is 2 to skip over Left and Right
            includeWidth = includeWidth ? 1 : 0;
            for (; i < 4; i += 2 - includeWidth) {
              which = cssExpand[i];
              attrs["margin" + which] = attrs["padding" + which] = type;
            }

            if (includeWidth) {
              attrs.opacity = attrs.width = type;
            }

            return attrs;
          }

          function createTween(value, prop, animation) {
            var tween,
              collection = (Animation.tweeners[prop] || []).concat(
                Animation.tweeners["*"]
              ),
              index = 0,
              length = collection.length;
            for (; index < length; index++) {
              if ((tween = collection[index].call(animation, prop, value))) {
                // We're done with this property
                return tween;
              }
            }
          }

          function defaultPrefilter(elem, props, opts) {
            var prop,
              value,
              toggle,
              hooks,
              oldfire,
              propTween,
              restoreDisplay,
              display,
              isBox = "width" in props || "height" in props,
              anim = this,
              orig = {},
              style = elem.style,
              hidden = elem.nodeType && isHiddenWithinTree(elem),
              dataShow = dataPriv.get(elem, "fxshow");

            // Queue-skipping animations hijack the fx hooks
            if (!opts.queue) {
              hooks = jQuery._queueHooks(elem, "fx");
              if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function () {
                  if (!hooks.unqueued) {
                    oldfire();
                  }
                };
              }
              hooks.unqueued++;

              anim.always(function () {
                // Ensure the complete handler is called before this completes
                anim.always(function () {
                  hooks.unqueued--;
                  if (!jQuery.queue(elem, "fx").length) {
                    hooks.empty.fire();
                  }
                });
              });
            }

            // Detect show/hide animations
            for (prop in props) {
              value = props[prop];
              if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                  // Pretend to be hidden if this is a "show" and
                  // there is still data from a stopped show/hide
                  if (
                    value === "show" &&
                    dataShow &&
                    dataShow[prop] !== undefined
                  ) {
                    hidden = true;

                    // Ignore all other no-op show/hide data
                  } else {
                    continue;
                  }
                }
                orig[prop] =
                  (dataShow && dataShow[prop]) || jQuery.style(elem, prop);
              }
            }

            // Bail out if this is a no-op like .hide().hide()
            propTween = !jQuery.isEmptyObject(props);
            if (!propTween && jQuery.isEmptyObject(orig)) {
              return;
            }

            // Restrict "overflow" and "display" styles during box animations
            if (isBox && elem.nodeType === 1) {
              // Support: IE <=9 - 11, Edge 12 - 15
              // Record all 3 overflow attributes because IE does not infer the shorthand
              // from identically-valued overflowX and overflowY and Edge just mirrors
              // the overflowX value there.
              opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY,
              ];

              // Identify a display type, preferring old show/hide data over the CSS cascade
              restoreDisplay = dataShow && dataShow.display;
              if (restoreDisplay == null) {
                restoreDisplay = dataPriv.get(elem, "display");
              }
              display = jQuery.css(elem, "display");
              if (display === "none") {
                if (restoreDisplay) {
                  display = restoreDisplay;
                } else {
                  // Get nonempty value(s) by temporarily forcing visibility
                  showHide([elem], true);
                  restoreDisplay = elem.style.display || restoreDisplay;
                  display = jQuery.css(elem, "display");
                  showHide([elem]);
                }
              }

              // Animate inline elements as inline-block
              if (
                display === "inline" ||
                (display === "inline-block" && restoreDisplay != null)
              ) {
                if (jQuery.css(elem, "float") === "none") {
                  // Restore the original display value at the end of pure show/hide animations
                  if (!propTween) {
                    anim.done(function () {
                      style.display = restoreDisplay;
                    });
                    if (restoreDisplay == null) {
                      display = style.display;
                      restoreDisplay = display === "none" ? "" : display;
                    }
                  }
                  style.display = "inline-block";
                }
              }
            }

            if (opts.overflow) {
              style.overflow = "hidden";
              anim.always(function () {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
              });
            }

            // Implement show/hide animations
            propTween = false;
            for (prop in orig) {
              // General show/hide setup for this element animation
              if (!propTween) {
                if (dataShow) {
                  if ("hidden" in dataShow) {
                    hidden = dataShow.hidden;
                  }
                } else {
                  dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay,
                  });
                }

                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) {
                  dataShow.hidden = !hidden;
                }

                // Show elements before animating them
                if (hidden) {
                  showHide([elem], true);
                }

                /* eslint-disable no-loop-func */

                anim.done(function () {
                  /* eslint-enable no-loop-func */

                  // The final step of a "hide" animation is actually hiding the element
                  if (!hidden) {
                    showHide([elem]);
                  }
                  dataPriv.remove(elem, "fxshow");
                  for (prop in orig) {
                    jQuery.style(elem, prop, orig[prop]);
                  }
                });
              }

              // Per-property setup
              propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
              if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                  propTween.end = propTween.start;
                  propTween.start = 0;
                }
              }
            }
          }

          function propFilter(props, specialEasing) {
            var index, name, easing, value, hooks;

            // camelCase, specialEasing and expand cssHook pass
            for (index in props) {
              name = camelCase(index);
              easing = specialEasing[name];
              value = props[index];
              if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
              }

              if (index !== name) {
                props[name] = value;
                delete props[index];
              }

              hooks = jQuery.cssHooks[name];
              if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];

                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for (index in value) {
                  if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                  }
                }
              } else {
                specialEasing[name] = easing;
              }
            }
          }

          function Animation(elem, properties, options) {
            var result,
              stopped,
              index = 0,
              length = Animation.prefilters.length,
              deferred = jQuery.Deferred().always(function () {
                // Don't match elem in the :animated selector
                delete tick.elem;
              }),
              tick = function () {
                if (stopped) {
                  return false;
                }
                var currentTime = fxNow || createFxNow(),
                  remaining = Math.max(
                    0,
                    animation.startTime + animation.duration - currentTime
                  ),
                  // Support: Android 2.3 only
                  // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
                  temp = remaining / animation.duration || 0,
                  percent = 1 - temp,
                  index = 0,
                  length = animation.tweens.length;

                for (; index < length; index++) {
                  animation.tweens[index].run(percent);
                }

                deferred.notifyWith(elem, [animation, percent, remaining]);

                // If there's more to do, yield
                if (percent < 1 && length) {
                  return remaining;
                }

                // If this was an empty animation, synthesize a final progress notification
                if (!length) {
                  deferred.notifyWith(elem, [animation, 1, 0]);
                }

                // Resolve the animation and report its conclusion
                deferred.resolveWith(elem, [animation]);
                return false;
              },
              animation = deferred.promise({
                elem: elem,
                props: jQuery.extend({}, properties),
                opts: jQuery.extend(
                  true,
                  {
                    specialEasing: {},
                    easing: jQuery.easing._default,
                  },
                  options
                ),
                originalProperties: properties,
                originalOptions: options,
                startTime: fxNow || createFxNow(),
                duration: options.duration,
                tweens: [],
                createTween: function (prop, end) {
                  var tween = jQuery.Tween(
                    elem,
                    animation.opts,
                    prop,
                    end,
                    animation.opts.specialEasing[prop] || animation.opts.easing
                  );
                  animation.tweens.push(tween);
                  return tween;
                },
                stop: function (gotoEnd) {
                  var index = 0,
                    // If we are going to the end, we want to run all the tweens
                    // otherwise we skip this part
                    length = gotoEnd ? animation.tweens.length : 0;
                  if (stopped) {
                    return this;
                  }
                  stopped = true;
                  for (; index < length; index++) {
                    animation.tweens[index].run(1);
                  }

                  // Resolve when we played the last frame; otherwise, reject
                  if (gotoEnd) {
                    deferred.notifyWith(elem, [animation, 1, 0]);
                    deferred.resolveWith(elem, [animation, gotoEnd]);
                  } else {
                    deferred.rejectWith(elem, [animation, gotoEnd]);
                  }
                  return this;
                },
              }),
              props = animation.props;

            propFilter(props, animation.opts.specialEasing);

            for (; index < length; index++) {
              result = Animation.prefilters[index].call(
                animation,
                elem,
                props,
                animation.opts
              );
              if (result) {
                if (isFunction(result.stop)) {
                  jQuery._queueHooks(
                    animation.elem,
                    animation.opts.queue
                  ).stop = result.stop.bind(result);
                }
                return result;
              }
            }

            jQuery.map(props, createTween, animation);

            if (isFunction(animation.opts.start)) {
              animation.opts.start.call(elem, animation);
            }

            // Attach callbacks from options
            animation
              .progress(animation.opts.progress)
              .done(animation.opts.done, animation.opts.complete)
              .fail(animation.opts.fail)
              .always(animation.opts.always);

            jQuery.fx.timer(
              jQuery.extend(tick, {
                elem: elem,
                anim: animation,
                queue: animation.opts.queue,
              })
            );

            return animation;
          }

          jQuery.Animation = jQuery.extend(Animation, {
            tweeners: {
              "*": [
                function (prop, value) {
                  var tween = this.createTween(prop, value);
                  adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                  return tween;
                },
              ],
            },

            tweener: function (props, callback) {
              if (isFunction(props)) {
                callback = props;
                props = ["*"];
              } else {
                props = props.match(rnothtmlwhite);
              }

              var prop,
                index = 0,
                length = props.length;

              for (; index < length; index++) {
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
              }
            },

            prefilters: [defaultPrefilter],

            prefilter: function (callback, prepend) {
              if (prepend) {
                Animation.prefilters.unshift(callback);
              } else {
                Animation.prefilters.push(callback);
              }
            },
          });

          jQuery.speed = function (speed, easing, fn) {
            var opt =
              speed && typeof speed === "object"
                ? jQuery.extend({}, speed)
                : {
                    complete:
                      fn || (!fn && easing) || (isFunction(speed) && speed),
                    duration: speed,
                    easing:
                      (fn && easing) ||
                      (easing && !isFunction(easing) && easing),
                  };

            // Go to the end state if fx are off
            if (jQuery.fx.off) {
              opt.duration = 0;
            } else {
              if (typeof opt.duration !== "number") {
                if (opt.duration in jQuery.fx.speeds) {
                  opt.duration = jQuery.fx.speeds[opt.duration];
                } else {
                  opt.duration = jQuery.fx.speeds._default;
                }
              }
            }

            // Normalize opt.queue - true/undefined/null -> "fx"
            if (opt.queue == null || opt.queue === true) {
              opt.queue = "fx";
            }

            // Queueing
            opt.old = opt.complete;

            opt.complete = function () {
              if (isFunction(opt.old)) {
                opt.old.call(this);
              }

              if (opt.queue) {
                jQuery.dequeue(this, opt.queue);
              }
            };

            return opt;
          };

          jQuery.fn.extend({
            fadeTo: function (speed, to, easing, callback) {
              // Show any hidden elements after setting opacity to 0
              return (
                this.filter(isHiddenWithinTree)
                  .css("opacity", 0)
                  .show()

                  // Animate to the value specified
                  .end()
                  .animate({ opacity: to }, speed, easing, callback)
              );
            },
            animate: function (prop, speed, easing, callback) {
              var empty = jQuery.isEmptyObject(prop),
                optall = jQuery.speed(speed, easing, callback),
                doAnimation = function () {
                  // Operate on a copy of prop so per-property easing won't be lost
                  var anim = Animation(this, jQuery.extend({}, prop), optall);

                  // Empty animations, or finishing resolves immediately
                  if (empty || dataPriv.get(this, "finish")) {
                    anim.stop(true);
                  }
                };

              doAnimation.finish = doAnimation;

              return empty || optall.queue === false
                ? this.each(doAnimation)
                : this.queue(optall.queue, doAnimation);
            },
            stop: function (type, clearQueue, gotoEnd) {
              var stopQueue = function (hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
              };

              if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
              }
              if (clearQueue) {
                this.queue(type || "fx", []);
              }

              return this.each(function () {
                var dequeue = true,
                  index = type != null && type + "queueHooks",
                  timers = jQuery.timers,
                  data = dataPriv.get(this);

                if (index) {
                  if (data[index] && data[index].stop) {
                    stopQueue(data[index]);
                  }
                } else {
                  for (index in data) {
                    if (data[index] && data[index].stop && rrun.test(index)) {
                      stopQueue(data[index]);
                    }
                  }
                }

                for (index = timers.length; index--; ) {
                  if (
                    timers[index].elem === this &&
                    (type == null || timers[index].queue === type)
                  ) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                  }
                }

                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) {
                  jQuery.dequeue(this, type);
                }
              });
            },
            finish: function (type) {
              if (type !== false) {
                type = type || "fx";
              }
              return this.each(function () {
                var index,
                  data = dataPriv.get(this),
                  queue = data[type + "queue"],
                  hooks = data[type + "queueHooks"],
                  timers = jQuery.timers,
                  length = queue ? queue.length : 0;

                // Enable finishing flag on private data
                data.finish = true;

                // Empty the queue first
                jQuery.queue(this, type, []);

                if (hooks && hooks.stop) {
                  hooks.stop.call(this, true);
                }

                // Look for any active animations, and finish them
                for (index = timers.length; index--; ) {
                  if (
                    timers[index].elem === this &&
                    timers[index].queue === type
                  ) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                  }
                }

                // Look for any animations in the old queue and finish them
                for (index = 0; index < length; index++) {
                  if (queue[index] && queue[index].finish) {
                    queue[index].finish.call(this);
                  }
                }

                // Turn off finishing flag
                delete data.finish;
              });
            },
          });

          jQuery.each(["toggle", "show", "hide"], function (_i, name) {
            var cssFn = jQuery.fn[name];
            jQuery.fn[name] = function (speed, easing, callback) {
              return speed == null || typeof speed === "boolean"
                ? cssFn.apply(this, arguments)
                : this.animate(genFx(name, true), speed, easing, callback);
            };
          });

          // Generate shortcuts for custom animations
          jQuery.each(
            {
              slideDown: genFx("show"),
              slideUp: genFx("hide"),
              slideToggle: genFx("toggle"),
              fadeIn: { opacity: "show" },
              fadeOut: { opacity: "hide" },
              fadeToggle: { opacity: "toggle" },
            },
            function (name, props) {
              jQuery.fn[name] = function (speed, easing, callback) {
                return this.animate(props, speed, easing, callback);
              };
            }
          );

          jQuery.timers = [];
          jQuery.fx.tick = function () {
            var timer,
              i = 0,
              timers = jQuery.timers;

            fxNow = Date.now();

            for (; i < timers.length; i++) {
              timer = timers[i];

              // Run the timer and safely remove it when done (allowing for external removal)
              if (!timer() && timers[i] === timer) {
                timers.splice(i--, 1);
              }
            }

            if (!timers.length) {
              jQuery.fx.stop();
            }
            fxNow = undefined;
          };

          jQuery.fx.timer = function (timer) {
            jQuery.timers.push(timer);
            jQuery.fx.start();
          };

          jQuery.fx.interval = 13;
          jQuery.fx.start = function () {
            if (inProgress) {
              return;
            }

            inProgress = true;
            schedule();
          };

          jQuery.fx.stop = function () {
            inProgress = null;
          };

          jQuery.fx.speeds = {
            slow: 600,
            fast: 200,

            // Default speed
            _default: 400,
          };

          // Based off of the plugin by Clint Helfers, with permission.
          // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
          jQuery.fn.delay = function (time, type) {
            time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
            type = type || "fx";

            return this.queue(type, function (next, hooks) {
              var timeout = window.setTimeout(next, time);
              hooks.stop = function () {
                window.clearTimeout(timeout);
              };
            });
          };

          (function () {
            var input = document.createElement("input"),
              select = document.createElement("select"),
              opt = select.appendChild(document.createElement("option"));

            input.type = "checkbox";

            // Support: Android <=4.3 only
            // Default value for a checkbox should be "on"
            support.checkOn = input.value !== "";

            // Support: IE <=11 only
            // Must access selectedIndex to make default options select
            support.optSelected = opt.selected;

            // Support: IE <=11 only
            // An input loses its value after becoming a radio
            input = document.createElement("input");
            input.value = "t";
            input.type = "radio";
            support.radioValue = input.value === "t";
          })();

          var boolHook,
            attrHandle = jQuery.expr.attrHandle;

          jQuery.fn.extend({
            attr: function (name, value) {
              return access(
                this,
                jQuery.attr,
                name,
                value,
                arguments.length > 1
              );
            },

            removeAttr: function (name) {
              return this.each(function () {
                jQuery.removeAttr(this, name);
              });
            },
          });

          jQuery.extend({
            attr: function (elem, name, value) {
              var ret,
                hooks,
                nType = elem.nodeType;

              // Don't get/set attributes on text, comment and attribute nodes
              if (nType === 3 || nType === 8 || nType === 2) {
                return;
              }

              // Fallback to prop when attributes are not supported
              if (typeof elem.getAttribute === "undefined") {
                return jQuery.prop(elem, name, value);
              }

              // Attribute hooks are determined by the lowercase version
              // Grab necessary hook if one is defined
              if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                hooks =
                  jQuery.attrHooks[name.toLowerCase()] ||
                  (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
              }

              if (value !== undefined) {
                if (value === null) {
                  jQuery.removeAttr(elem, name);
                  return;
                }

                if (
                  hooks &&
                  "set" in hooks &&
                  (ret = hooks.set(elem, value, name)) !== undefined
                ) {
                  return ret;
                }

                elem.setAttribute(name, value + "");
                return value;
              }

              if (
                hooks &&
                "get" in hooks &&
                (ret = hooks.get(elem, name)) !== null
              ) {
                return ret;
              }

              ret = jQuery.find.attr(elem, name);

              // Non-existent attributes return null, we normalize to undefined
              return ret == null ? undefined : ret;
            },

            attrHooks: {
              type: {
                set: function (elem, value) {
                  if (
                    !support.radioValue &&
                    value === "radio" &&
                    nodeName(elem, "input")
                  ) {
                    var val = elem.value;
                    elem.setAttribute("type", value);
                    if (val) {
                      elem.value = val;
                    }
                    return value;
                  }
                },
              },
            },

            removeAttr: function (elem, value) {
              var name,
                i = 0,
                // Attribute names can contain non-HTML whitespace characters
                // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
                attrNames = value && value.match(rnothtmlwhite);

              if (attrNames && elem.nodeType === 1) {
                while ((name = attrNames[i++])) {
                  elem.removeAttribute(name);
                }
              }
            },
          });

          // Hooks for boolean attributes
          boolHook = {
            set: function (elem, value, name) {
              if (value === false) {
                // Remove boolean attributes when set to false
                jQuery.removeAttr(elem, name);
              } else {
                elem.setAttribute(name, name);
              }
              return name;
            },
          };

          jQuery.each(
            jQuery.expr.match.bool.source.match(/\w+/g),
            function (_i, name) {
              var getter = attrHandle[name] || jQuery.find.attr;

              attrHandle[name] = function (elem, name, isXML) {
                var ret,
                  handle,
                  lowercaseName = name.toLowerCase();

                if (!isXML) {
                  // Avoid an infinite loop by temporarily removing this function from the getter
                  handle = attrHandle[lowercaseName];
                  attrHandle[lowercaseName] = ret;
                  ret =
                    getter(elem, name, isXML) != null ? lowercaseName : null;
                  attrHandle[lowercaseName] = handle;
                }
                return ret;
              };
            }
          );

          var rfocusable = /^(?:input|select|textarea|button)$/i,
            rclickable = /^(?:a|area)$/i;

          jQuery.fn.extend({
            prop: function (name, value) {
              return access(
                this,
                jQuery.prop,
                name,
                value,
                arguments.length > 1
              );
            },

            removeProp: function (name) {
              return this.each(function () {
                delete this[jQuery.propFix[name] || name];
              });
            },
          });

          jQuery.extend({
            prop: function (elem, name, value) {
              var ret,
                hooks,
                nType = elem.nodeType;

              // Don't get/set properties on text, comment and attribute nodes
              if (nType === 3 || nType === 8 || nType === 2) {
                return;
              }

              if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
              }

              if (value !== undefined) {
                if (
                  hooks &&
                  "set" in hooks &&
                  (ret = hooks.set(elem, value, name)) !== undefined
                ) {
                  return ret;
                }

                return (elem[name] = value);
              }

              if (
                hooks &&
                "get" in hooks &&
                (ret = hooks.get(elem, name)) !== null
              ) {
                return ret;
              }

              return elem[name];
            },

            propHooks: {
              tabIndex: {
                get: function (elem) {
                  // Support: IE <=9 - 11 only
                  // elem.tabIndex doesn't always return the
                  // correct value when it hasn't been explicitly set
                  // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                  // Use proper attribute retrieval(#12072)
                  var tabindex = jQuery.find.attr(elem, "tabindex");

                  if (tabindex) {
                    return parseInt(tabindex, 10);
                  }

                  if (
                    rfocusable.test(elem.nodeName) ||
                    (rclickable.test(elem.nodeName) && elem.href)
                  ) {
                    return 0;
                  }

                  return -1;
                },
              },
            },

            propFix: {
              for: "htmlFor",
              class: "className",
            },
          });

          // Support: IE <=11 only
          // Accessing the selectedIndex property
          // forces the browser to respect setting selected
          // on the option
          // The getter ensures a default option is selected
          // when in an optgroup
          // eslint rule "no-unused-expressions" is disabled for this code
          // since it considers such accessions noop
          if (!support.optSelected) {
            jQuery.propHooks.selected = {
              get: function (elem) {
                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if (parent && parent.parentNode) {
                  parent.parentNode.selectedIndex;
                }
                return null;
              },
              set: function (elem) {
                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if (parent) {
                  parent.selectedIndex;

                  if (parent.parentNode) {
                    parent.parentNode.selectedIndex;
                  }
                }
              },
            };
          }

          jQuery.each(
            [
              "tabIndex",
              "readOnly",
              "maxLength",
              "cellSpacing",
              "cellPadding",
              "rowSpan",
              "colSpan",
              "useMap",
              "frameBorder",
              "contentEditable",
            ],
            function () {
              jQuery.propFix[this.toLowerCase()] = this;
            }
          );

          // Strip and collapse whitespace according to HTML spec
          // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
          function stripAndCollapse(value) {
            var tokens = value.match(rnothtmlwhite) || [];
            return tokens.join(" ");
          }

          function getClass(elem) {
            return (elem.getAttribute && elem.getAttribute("class")) || "";
          }

          function classesToArray(value) {
            if (Array.isArray(value)) {
              return value;
            }
            if (typeof value === "string") {
              return value.match(rnothtmlwhite) || [];
            }
            return [];
          }

          jQuery.fn.extend({
            addClass: function (value) {
              var classes,
                elem,
                cur,
                curValue,
                clazz,
                j,
                finalValue,
                i = 0;

              if (isFunction(value)) {
                return this.each(function (j) {
                  jQuery(this).addClass(value.call(this, j, getClass(this)));
                });
              }

              classes = classesToArray(value);

              if (classes.length) {
                while ((elem = this[i++])) {
                  curValue = getClass(elem);
                  cur =
                    elem.nodeType === 1 &&
                    " " + stripAndCollapse(curValue) + " ";

                  if (cur) {
                    j = 0;
                    while ((clazz = classes[j++])) {
                      if (cur.indexOf(" " + clazz + " ") < 0) {
                        cur += clazz + " ";
                      }
                    }

                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) {
                      elem.setAttribute("class", finalValue);
                    }
                  }
                }
              }

              return this;
            },

            removeClass: function (value) {
              var classes,
                elem,
                cur,
                curValue,
                clazz,
                j,
                finalValue,
                i = 0;

              if (isFunction(value)) {
                return this.each(function (j) {
                  jQuery(this).removeClass(value.call(this, j, getClass(this)));
                });
              }

              if (!arguments.length) {
                return this.attr("class", "");
              }

              classes = classesToArray(value);

              if (classes.length) {
                while ((elem = this[i++])) {
                  curValue = getClass(elem);

                  // This expression is here for better compressibility (see addClass)
                  cur =
                    elem.nodeType === 1 &&
                    " " + stripAndCollapse(curValue) + " ";

                  if (cur) {
                    j = 0;
                    while ((clazz = classes[j++])) {
                      // Remove *all* instances
                      while (cur.indexOf(" " + clazz + " ") > -1) {
                        cur = cur.replace(" " + clazz + " ", " ");
                      }
                    }

                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) {
                      elem.setAttribute("class", finalValue);
                    }
                  }
                }
              }

              return this;
            },

            toggleClass: function (value, stateVal) {
              var type = typeof value,
                isValidValue = type === "string" || Array.isArray(value);

              if (typeof stateVal === "boolean" && isValidValue) {
                return stateVal
                  ? this.addClass(value)
                  : this.removeClass(value);
              }

              if (isFunction(value)) {
                return this.each(function (i) {
                  jQuery(this).toggleClass(
                    value.call(this, i, getClass(this), stateVal),
                    stateVal
                  );
                });
              }

              return this.each(function () {
                var className, i, self, classNames;

                if (isValidValue) {
                  // Toggle individual class names
                  i = 0;
                  self = jQuery(this);
                  classNames = classesToArray(value);

                  while ((className = classNames[i++])) {
                    // Check each className given, space separated list
                    if (self.hasClass(className)) {
                      self.removeClass(className);
                    } else {
                      self.addClass(className);
                    }
                  }

                  // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                  className = getClass(this);
                  if (className) {
                    // Store className if set
                    dataPriv.set(this, "__className__", className);
                  }

                  // If the element has a class name or if we're passed `false`,
                  // then remove the whole classname (if there was one, the above saved it).
                  // Otherwise bring back whatever was previously saved (if anything),
                  // falling back to the empty string if nothing was stored.
                  if (this.setAttribute) {
                    this.setAttribute(
                      "class",
                      className || value === false
                        ? ""
                        : dataPriv.get(this, "__className__") || ""
                    );
                  }
                }
              });
            },

            hasClass: function (selector) {
              var className,
                elem,
                i = 0;

              className = " " + selector + " ";
              while ((elem = this[i++])) {
                if (
                  elem.nodeType === 1 &&
                  (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(
                    className
                  ) > -1
                ) {
                  return true;
                }
              }

              return false;
            },
          });

          var rreturn = /\r/g;

          jQuery.fn.extend({
            val: function (value) {
              var hooks,
                ret,
                valueIsFunction,
                elem = this[0];

              if (!arguments.length) {
                if (elem) {
                  hooks =
                    jQuery.valHooks[elem.type] ||
                    jQuery.valHooks[elem.nodeName.toLowerCase()];

                  if (
                    hooks &&
                    "get" in hooks &&
                    (ret = hooks.get(elem, "value")) !== undefined
                  ) {
                    return ret;
                  }

                  ret = elem.value;

                  // Handle most common string cases
                  if (typeof ret === "string") {
                    return ret.replace(rreturn, "");
                  }

                  // Handle cases where value is null/undef or number
                  return ret == null ? "" : ret;
                }

                return;
              }

              valueIsFunction = isFunction(value);

              return this.each(function (i) {
                var val;

                if (this.nodeType !== 1) {
                  return;
                }

                if (valueIsFunction) {
                  val = value.call(this, i, jQuery(this).val());
                } else {
                  val = value;
                }

                // Treat null/undefined as ""; convert numbers to string
                if (val == null) {
                  val = "";
                } else if (typeof val === "number") {
                  val += "";
                } else if (Array.isArray(val)) {
                  val = jQuery.map(val, function (value) {
                    return value == null ? "" : value + "";
                  });
                }

                hooks =
                  jQuery.valHooks[this.type] ||
                  jQuery.valHooks[this.nodeName.toLowerCase()];

                // If set returns undefined, fall back to normal setting
                if (
                  !hooks ||
                  !("set" in hooks) ||
                  hooks.set(this, val, "value") === undefined
                ) {
                  this.value = val;
                }
              });
            },
          });

          jQuery.extend({
            valHooks: {
              option: {
                get: function (elem) {
                  var val = jQuery.find.attr(elem, "value");
                  return val != null
                    ? val
                    : // Support: IE <=10 - 11 only
                      // option.text throws exceptions (#14686, #14858)
                      // Strip and collapse whitespace
                      // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                      stripAndCollapse(jQuery.text(elem));
                },
              },
              select: {
                get: function (elem) {
                  var value,
                    option,
                    i,
                    options = elem.options,
                    index = elem.selectedIndex,
                    one = elem.type === "select-one",
                    values = one ? null : [],
                    max = one ? index + 1 : options.length;

                  if (index < 0) {
                    i = max;
                  } else {
                    i = one ? index : 0;
                  }

                  // Loop through all the selected options
                  for (; i < max; i++) {
                    option = options[i];

                    // Support: IE <=9 only
                    // IE8-9 doesn't update selected after form reset (#2551)
                    if (
                      (option.selected || i === index) &&
                      // Don't return options that are disabled or in a disabled optgroup
                      !option.disabled &&
                      (!option.parentNode.disabled ||
                        !nodeName(option.parentNode, "optgroup"))
                    ) {
                      // Get the specific value for the option
                      value = jQuery(option).val();

                      // We don't need an array for one selects
                      if (one) {
                        return value;
                      }

                      // Multi-Selects return an array
                      values.push(value);
                    }
                  }

                  return values;
                },

                set: function (elem, value) {
                  var optionSet,
                    option,
                    options = elem.options,
                    values = jQuery.makeArray(value),
                    i = options.length;

                  while (i--) {
                    option = options[i];

                    /* eslint-disable no-cond-assign */

                    if (
                      (option.selected =
                        jQuery.inArray(
                          jQuery.valHooks.option.get(option),
                          values
                        ) > -1)
                    ) {
                      optionSet = true;
                    }

                    /* eslint-enable no-cond-assign */
                  }

                  // Force browsers to behave consistently when non-matching value is set
                  if (!optionSet) {
                    elem.selectedIndex = -1;
                  }
                  return values;
                },
              },
            },
          });

          // Radios and checkboxes getter/setter
          jQuery.each(["radio", "checkbox"], function () {
            jQuery.valHooks[this] = {
              set: function (elem, value) {
                if (Array.isArray(value)) {
                  return (elem.checked =
                    jQuery.inArray(jQuery(elem).val(), value) > -1);
                }
              },
            };
            if (!support.checkOn) {
              jQuery.valHooks[this].get = function (elem) {
                return elem.getAttribute("value") === null ? "on" : elem.value;
              };
            }
          });

          // Return jQuery for attributes-only inclusion

          support.focusin = "onfocusin" in window;

          var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
            stopPropagationCallback = function (e) {
              e.stopPropagation();
            };

          jQuery.extend(jQuery.event, {
            trigger: function (event, data, elem, onlyHandlers) {
              var i,
                cur,
                tmp,
                bubbleType,
                ontype,
                handle,
                special,
                lastElement,
                eventPath = [elem || document],
                type = hasOwn.call(event, "type") ? event.type : event,
                namespaces = hasOwn.call(event, "namespace")
                  ? event.namespace.split(".")
                  : [];

              cur = lastElement = tmp = elem = elem || document;

              // Don't do events on text and comment nodes
              if (elem.nodeType === 3 || elem.nodeType === 8) {
                return;
              }

              // focus/blur morphs to focusin/out; ensure we're not firing them right now
              if (rfocusMorph.test(type + jQuery.event.triggered)) {
                return;
              }

              if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
              }
              ontype = type.indexOf(":") < 0 && "on" + type;

              // Caller can pass in a jQuery.Event object, Object, or just an event type string
              event = event[jQuery.expando]
                ? event
                : new jQuery.Event(type, typeof event === "object" && event);

              // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
              event.isTrigger = onlyHandlers ? 2 : 3;
              event.namespace = namespaces.join(".");
              event.rnamespace = event.namespace
                ? new RegExp(
                    "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"
                  )
                : null;

              // Clean up the event in case it is being reused
              event.result = undefined;
              if (!event.target) {
                event.target = elem;
              }

              // Clone any incoming data and prepend the event, creating the handler arg list
              data = data == null ? [event] : jQuery.makeArray(data, [event]);

              // Allow special events to draw outside the lines
              special = jQuery.event.special[type] || {};
              if (
                !onlyHandlers &&
                special.trigger &&
                special.trigger.apply(elem, data) === false
              ) {
                return;
              }

              // Determine event propagation path in advance, per W3C events spec (#9951)
              // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
              if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) {
                  cur = cur.parentNode;
                }
                for (; cur; cur = cur.parentNode) {
                  eventPath.push(cur);
                  tmp = cur;
                }

                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) {
                  eventPath.push(tmp.defaultView || tmp.parentWindow || window);
                }
              }

              // Fire handlers on the event path
              i = 0;
              while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;

                // jQuery handler
                handle =
                  (dataPriv.get(cur, "events") || Object.create(null))[
                    event.type
                  ] && dataPriv.get(cur, "handle");
                if (handle) {
                  handle.apply(cur, data);
                }

                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                  event.result = handle.apply(cur, data);
                  if (event.result === false) {
                    event.preventDefault();
                  }
                }
              }
              event.type = type;

              // If nobody prevented the default action, do it now
              if (!onlyHandlers && !event.isDefaultPrevented()) {
                if (
                  (!special._default ||
                    special._default.apply(eventPath.pop(), data) === false) &&
                  acceptData(elem)
                ) {
                  // Call a native DOM method on the target with the same name as the event.
                  // Don't do default actions on window, that's where global variables be (#6170)
                  if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                    // Don't re-trigger an onFOO event when we call its FOO() method
                    tmp = elem[ontype];

                    if (tmp) {
                      elem[ontype] = null;
                    }

                    // Prevent re-triggering of the same event, since we already bubbled it above
                    jQuery.event.triggered = type;

                    if (event.isPropagationStopped()) {
                      lastElement.addEventListener(
                        type,
                        stopPropagationCallback
                      );
                    }

                    elem[type]();

                    if (event.isPropagationStopped()) {
                      lastElement.removeEventListener(
                        type,
                        stopPropagationCallback
                      );
                    }

                    jQuery.event.triggered = undefined;

                    if (tmp) {
                      elem[ontype] = tmp;
                    }
                  }
                }
              }

              return event.result;
            },

            // Piggyback on a donor event to simulate a different one
            // Used only for `focus(in | out)` events
            simulate: function (type, elem, event) {
              var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true,
              });

              jQuery.event.trigger(e, null, elem);
            },
          });

          jQuery.fn.extend({
            trigger: function (type, data) {
              return this.each(function () {
                jQuery.event.trigger(type, data, this);
              });
            },
            triggerHandler: function (type, data) {
              var elem = this[0];
              if (elem) {
                return jQuery.event.trigger(type, data, elem, true);
              }
            },
          });

          // Support: Firefox <=44
          // Firefox doesn't have focus(in | out) events
          // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
          //
          // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
          // focus(in | out) events fire after focus & blur events,
          // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
          // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
          if (!support.focusin) {
            jQuery.each(
              { focus: "focusin", blur: "focusout" },
              function (orig, fix) {
                // Attach a single capturing handler on the document while someone wants focusin/focusout
                var handler = function (event) {
                  jQuery.event.simulate(
                    fix,
                    event.target,
                    jQuery.event.fix(event)
                  );
                };

                jQuery.event.special[fix] = {
                  setup: function () {
                    // Handle: regular nodes (via `this.ownerDocument`), window
                    // (via `this.document`) & document (via `this`).
                    var doc = this.ownerDocument || this.document || this,
                      attaches = dataPriv.access(doc, fix);

                    if (!attaches) {
                      doc.addEventListener(orig, handler, true);
                    }
                    dataPriv.access(doc, fix, (attaches || 0) + 1);
                  },
                  teardown: function () {
                    var doc = this.ownerDocument || this.document || this,
                      attaches = dataPriv.access(doc, fix) - 1;

                    if (!attaches) {
                      doc.removeEventListener(orig, handler, true);
                      dataPriv.remove(doc, fix);
                    } else {
                      dataPriv.access(doc, fix, attaches);
                    }
                  },
                };
              }
            );
          }
          var location = window.location;

          var nonce = { guid: Date.now() };

          var rquery = /\?/;

          // Cross-browser xml parsing
          jQuery.parseXML = function (data) {
            var xml, parserErrorElem;
            if (!data || typeof data !== "string") {
              return null;
            }

            // Support: IE 9 - 11 only
            // IE throws on parseFromString with invalid input.
            try {
              xml = new window.DOMParser().parseFromString(data, "text/xml");
            } catch (e) {}

            parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
            if (!xml || parserErrorElem) {
              jQuery.error(
                "Invalid XML: " +
                  (parserErrorElem
                    ? jQuery
                        .map(parserErrorElem.childNodes, function (el) {
                          return el.textContent;
                        })
                        .join("\n")
                    : data)
              );
            }
            return xml;
          };

          var rbracket = /\[\]$/,
            rCRLF = /\r?\n/g,
            rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
            rsubmittable = /^(?:input|select|textarea|keygen)/i;

          function buildParams(prefix, obj, traditional, add) {
            var name;

            if (Array.isArray(obj)) {
              // Serialize array item.
              jQuery.each(obj, function (i, v) {
                if (traditional || rbracket.test(prefix)) {
                  // Treat each array item as a scalar.
                  add(prefix, v);
                } else {
                  // Item is non-scalar (array or object), encode its numeric index.
                  buildParams(
                    prefix +
                      "[" +
                      (typeof v === "object" && v != null ? i : "") +
                      "]",
                    v,
                    traditional,
                    add
                  );
                }
              });
            } else if (!traditional && toType(obj) === "object") {
              // Serialize object item.
              for (name in obj) {
                buildParams(
                  prefix + "[" + name + "]",
                  obj[name],
                  traditional,
                  add
                );
              }
            } else {
              // Serialize scalar item.
              add(prefix, obj);
            }
          }

          // Serialize an array of form elements or a set of
          // key/values into a query string
          jQuery.param = function (a, traditional) {
            var prefix,
              s = [],
              add = function (key, valueOrFunction) {
                // If value is a function, invoke it and use its return value
                var value = isFunction(valueOrFunction)
                  ? valueOrFunction()
                  : valueOrFunction;

                s[s.length] =
                  encodeURIComponent(key) +
                  "=" +
                  encodeURIComponent(value == null ? "" : value);
              };

            if (a == null) {
              return "";
            }

            // If an array was passed in, assume that it is an array of form elements.
            if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {
              // Serialize the form elements
              jQuery.each(a, function () {
                add(this.name, this.value);
              });
            } else {
              // If traditional, encode the "old" way (the way 1.3.2 or older
              // did it), otherwise encode params recursively.
              for (prefix in a) {
                buildParams(prefix, a[prefix], traditional, add);
              }
            }

            // Return the resulting serialization
            return s.join("&");
          };

          jQuery.fn.extend({
            serialize: function () {
              return jQuery.param(this.serializeArray());
            },
            serializeArray: function () {
              return this.map(function () {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
              })
                .filter(function () {
                  var type = this.type;

                  // Use .is( ":disabled" ) so that fieldset[disabled] works
                  return (
                    this.name &&
                    !jQuery(this).is(":disabled") &&
                    rsubmittable.test(this.nodeName) &&
                    !rsubmitterTypes.test(type) &&
                    (this.checked || !rcheckableType.test(type))
                  );
                })
                .map(function (_i, elem) {
                  var val = jQuery(this).val();

                  if (val == null) {
                    return null;
                  }

                  if (Array.isArray(val)) {
                    return jQuery.map(val, function (val) {
                      return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n"),
                      };
                    });
                  }

                  return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
                })
                .get();
            },
          });

          var r20 = /%20/g,
            rhash = /#.*$/,
            rantiCache = /([?&])_=[^&]*/,
            rheaders = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            // #7653, #8125, #8152: local protocol detection
            rlocalProtocol =
              /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
            rnoContent = /^(?:GET|HEAD)$/,
            rprotocol = /^\/\//,
            /* Prefilters
             * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
             * 2) These are called:
             *    - BEFORE asking for a transport
             *    - AFTER param serialization (s.data is a string if s.processData is true)
             * 3) key is the dataType
             * 4) the catchall symbol "*" can be used
             * 5) execution will start with transport dataType and THEN continue down to "*" if needed
             */
            prefilters = {},
            /* Transports bindings
             * 1) key is the dataType
             * 2) the catchall symbol "*" can be used
             * 3) selection will start with transport dataType and THEN go to "*" if needed
             */
            transports = {},
            // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
            allTypes = "*/".concat("*"),
            // Anchor tag for parsing the document origin
            originAnchor = document.createElement("a");

          originAnchor.href = location.href;

          // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
          function addToPrefiltersOrTransports(structure) {
            // dataTypeExpression is optional and defaults to "*"
            return function (dataTypeExpression, func) {
              if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
              }

              var dataType,
                i = 0,
                dataTypes =
                  dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

              if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while ((dataType = dataTypes[i++])) {
                  // Prepend if requested
                  if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(
                      func
                    );

                    // Otherwise append
                  } else {
                    (structure[dataType] = structure[dataType] || []).push(
                      func
                    );
                  }
                }
              }
            };
          }

          // Base inspection function for prefilters and transports
          function inspectPrefiltersOrTransports(
            structure,
            options,
            originalOptions,
            jqXHR
          ) {
            var inspected = {},
              seekingTransport = structure === transports;

            function inspect(dataType) {
              var selected;
              inspected[dataType] = true;
              jQuery.each(
                structure[dataType] || [],
                function (_, prefilterOrFactory) {
                  var dataTypeOrTransport = prefilterOrFactory(
                    options,
                    originalOptions,
                    jqXHR
                  );
                  if (
                    typeof dataTypeOrTransport === "string" &&
                    !seekingTransport &&
                    !inspected[dataTypeOrTransport]
                  ) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                  } else if (seekingTransport) {
                    return !(selected = dataTypeOrTransport);
                  }
                }
              );
              return selected;
            }

            return (
              inspect(options.dataTypes[0]) || (!inspected["*"] && inspect("*"))
            );
          }

          // A special extend for ajax options
          // that takes "flat" options (not to be deep extended)
          // Fixes #9887
          function ajaxExtend(target, src) {
            var key,
              deep,
              flatOptions = jQuery.ajaxSettings.flatOptions || {};

            for (key in src) {
              if (src[key] !== undefined) {
                (flatOptions[key] ? target : deep || (deep = {}))[key] =
                  src[key];
              }
            }
            if (deep) {
              jQuery.extend(true, target, deep);
            }

            return target;
          }

          /* Handles responses to an ajax request:
           * - finds the right dataType (mediates between content-type and expected dataType)
           * - returns the corresponding response
           */
          function ajaxHandleResponses(s, jqXHR, responses) {
            var ct,
              type,
              finalDataType,
              firstDataType,
              contents = s.contents,
              dataTypes = s.dataTypes;

            // Remove auto dataType and get content-type in the process
            while (dataTypes[0] === "*") {
              dataTypes.shift();
              if (ct === undefined) {
                ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
              }
            }

            // Check if we're dealing with a known content-type
            if (ct) {
              for (type in contents) {
                if (contents[type] && contents[type].test(ct)) {
                  dataTypes.unshift(type);
                  break;
                }
              }
            }

            // Check to see if we have a response for the expected dataType
            if (dataTypes[0] in responses) {
              finalDataType = dataTypes[0];
            } else {
              // Try convertible dataTypes
              for (type in responses) {
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                  finalDataType = type;
                  break;
                }
                if (!firstDataType) {
                  firstDataType = type;
                }
              }

              // Or just use first one
              finalDataType = finalDataType || firstDataType;
            }

            // If we found a dataType
            // We add the dataType to the list if needed
            // and return the corresponding response
            if (finalDataType) {
              if (finalDataType !== dataTypes[0]) {
                dataTypes.unshift(finalDataType);
              }
              return responses[finalDataType];
            }
          }

          /* Chain conversions given the request and the original response
           * Also sets the responseXXX fields on the jqXHR instance
           */
          function ajaxConvert(s, response, jqXHR, isSuccess) {
            var conv2,
              current,
              conv,
              tmp,
              prev,
              converters = {},
              // Work with a copy of dataTypes in case we need to modify it for conversion
              dataTypes = s.dataTypes.slice();

            // Create converters map with lowercased keys
            if (dataTypes[1]) {
              for (conv in s.converters) {
                converters[conv.toLowerCase()] = s.converters[conv];
              }
            }

            current = dataTypes.shift();

            // Convert to each sequential dataType
            while (current) {
              if (s.responseFields[current]) {
                jqXHR[s.responseFields[current]] = response;
              }

              // Apply the dataFilter if provided
              if (!prev && isSuccess && s.dataFilter) {
                response = s.dataFilter(response, s.dataType);
              }

              prev = current;
              current = dataTypes.shift();

              if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") {
                  current = prev;

                  // Convert response if prev dataType is non-auto and differs from current
                } else if (prev !== "*" && prev !== current) {
                  // Seek a direct converter
                  conv =
                    converters[prev + " " + current] ||
                    converters["* " + current];

                  // If none found, seek a pair
                  if (!conv) {
                    for (conv2 in converters) {
                      // If conv2 outputs current
                      tmp = conv2.split(" ");
                      if (tmp[1] === current) {
                        // If prev can be converted to accepted input
                        conv =
                          converters[prev + " " + tmp[0]] ||
                          converters["* " + tmp[0]];
                        if (conv) {
                          // Condense equivalence converters
                          if (conv === true) {
                            conv = converters[conv2];

                            // Otherwise, insert the intermediate dataType
                          } else if (converters[conv2] !== true) {
                            current = tmp[0];
                            dataTypes.unshift(tmp[1]);
                          }
                          break;
                        }
                      }
                    }
                  }

                  // Apply converter (if not an equivalence)
                  if (conv !== true) {
                    // Unless errors are allowed to bubble, catch and return them
                    if (conv && s.throws) {
                      response = conv(response);
                    } else {
                      try {
                        response = conv(response);
                      } catch (e) {
                        return {
                          state: "parsererror",
                          error: conv
                            ? e
                            : "No conversion from " + prev + " to " + current,
                        };
                      }
                    }
                  }
                }
              }
            }

            return { state: "success", data: response };
          }

          jQuery.extend({
            // Counter for holding the number of active queries
            active: 0,

            // Last-Modified header cache for next request
            lastModified: {},
            etag: {},

            ajaxSettings: {
              url: location.href,
              type: "GET",
              isLocal: rlocalProtocol.test(location.protocol),
              global: true,
              processData: true,
              async: true,
              contentType: "application/x-www-form-urlencoded; charset=UTF-8",

              /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

              accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript",
              },

              contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/,
              },

              responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON",
              },

              // Data converters
              // Keys separate source (or catchall "*") and destination types with a single space
              converters: {
                // Convert anything to text
                "* text": String,

                // Text to html (true = no transformation)
                "text html": true,

                // Evaluate text as a json expression
                "text json": JSON.parse,

                // Parse text as xml
                "text xml": jQuery.parseXML,
              },

              // For options that shouldn't be deep extended:
              // you can add your own custom options here if
              // and when you create one that shouldn't be
              // deep extended (see ajaxExtend)
              flatOptions: {
                url: true,
                context: true,
              },
            },

            // Creates a full fledged settings object into target
            // with both ajaxSettings and settings fields.
            // If target is omitted, writes into ajaxSettings.
            ajaxSetup: function (target, settings) {
              return settings
                ? // Building a settings object
                  ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings)
                : // Extending ajaxSettings
                  ajaxExtend(jQuery.ajaxSettings, target);
            },

            ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
            ajaxTransport: addToPrefiltersOrTransports(transports),

            // Main method
            ajax: function (url, options) {
              // If url is an object, simulate pre-1.5 signature
              if (typeof url === "object") {
                options = url;
                url = undefined;
              }

              // Force options to be an object
              options = options || {};

              var transport,
                // URL without anti-cache param
                cacheURL,
                // Response headers
                responseHeadersString,
                responseHeaders,
                // timeout handle
                timeoutTimer,
                // Url cleanup var
                urlAnchor,
                // Request state (becomes false upon send and true upon completion)
                completed,
                // To know if global events are to be dispatched
                fireGlobals,
                // Loop variable
                i,
                // uncached part of the url
                uncached,
                // Create the final options object
                s = jQuery.ajaxSetup({}, options),
                // Callbacks context
                callbackContext = s.context || s,
                // Context for global events is callbackContext if it is a DOM node or jQuery collection
                globalEventContext =
                  s.context &&
                  (callbackContext.nodeType || callbackContext.jquery)
                    ? jQuery(callbackContext)
                    : jQuery.event,
                // Deferreds
                deferred = jQuery.Deferred(),
                completeDeferred = jQuery.Callbacks("once memory"),
                // Status-dependent callbacks
                statusCode = s.statusCode || {},
                // Headers (they are sent all at once)
                requestHeaders = {},
                requestHeadersNames = {},
                // Default abort message
                strAbort = "canceled",
                // Fake xhr
                jqXHR = {
                  readyState: 0,

                  // Builds headers hashtable if needed
                  getResponseHeader: function (key) {
                    var match;
                    if (completed) {
                      if (!responseHeaders) {
                        responseHeaders = {};
                        while ((match = rheaders.exec(responseHeadersString))) {
                          responseHeaders[match[1].toLowerCase() + " "] = (
                            responseHeaders[match[1].toLowerCase() + " "] || []
                          ).concat(match[2]);
                        }
                      }
                      match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                  },

                  // Raw string
                  getAllResponseHeaders: function () {
                    return completed ? responseHeadersString : null;
                  },

                  // Caches the header
                  setRequestHeader: function (name, value) {
                    if (completed == null) {
                      name = requestHeadersNames[name.toLowerCase()] =
                        requestHeadersNames[name.toLowerCase()] || name;
                      requestHeaders[name] = value;
                    }
                    return this;
                  },

                  // Overrides response content-type header
                  overrideMimeType: function (type) {
                    if (completed == null) {
                      s.mimeType = type;
                    }
                    return this;
                  },

                  // Status-dependent callbacks
                  statusCode: function (map) {
                    var code;
                    if (map) {
                      if (completed) {
                        // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                      } else {
                        // Lazy-add the new callbacks in a way that preserves old ones
                        for (code in map) {
                          statusCode[code] = [statusCode[code], map[code]];
                        }
                      }
                    }
                    return this;
                  },

                  // Cancel the request
                  abort: function (statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) {
                      transport.abort(finalText);
                    }
                    done(0, finalText);
                    return this;
                  },
                };

              // Attach deferreds
              deferred.promise(jqXHR);

              // Add protocol if not provided (prefilters might expect it)
              // Handle falsy url in the settings object (#10093: consistency with old signature)
              // We also use the url parameter if available
              s.url = ((url || s.url || location.href) + "").replace(
                rprotocol,
                location.protocol + "//"
              );

              // Alias method option to type as per ticket #12004
              s.type = options.method || options.type || s.method || s.type;

              // Extract dataTypes list
              s.dataTypes = (s.dataType || "*")
                .toLowerCase()
                .match(rnothtmlwhite) || [""];

              // A cross-domain request is in order when the origin doesn't match the current origin.
              if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");

                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                  urlAnchor.href = s.url;

                  // Support: IE <=8 - 11 only
                  // Anchor's host property isn't correctly set when s.url is relative
                  urlAnchor.href = urlAnchor.href;
                  s.crossDomain =
                    originAnchor.protocol + "//" + originAnchor.host !==
                    urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                  // If there is an error parsing the URL, assume it is crossDomain,
                  // it can be rejected by the transport if it is invalid
                  s.crossDomain = true;
                }
              }

              // Convert data if not already a string
              if (s.data && s.processData && typeof s.data !== "string") {
                s.data = jQuery.param(s.data, s.traditional);
              }

              // Apply prefilters
              inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

              // If request was aborted inside a prefilter, stop there
              if (completed) {
                return jqXHR;
              }

              // We can fire global events as of now if asked to
              // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
              fireGlobals = jQuery.event && s.global;

              // Watch for a new set of requests
              if (fireGlobals && jQuery.active++ === 0) {
                jQuery.event.trigger("ajaxStart");
              }

              // Uppercase the type
              s.type = s.type.toUpperCase();

              // Determine if request has content
              s.hasContent = !rnoContent.test(s.type);

              // Save the URL in case we're toying with the If-Modified-Since
              // and/or If-None-Match header later on
              // Remove hash to simplify url manipulation
              cacheURL = s.url.replace(rhash, "");

              // More options handling for requests with no content
              if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);

                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                  cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

                  // #9682: remove data so that it's not used in an eventual retry
                  delete s.data;
                }

                // Add or update anti-cache param if needed
                if (s.cache === false) {
                  cacheURL = cacheURL.replace(rantiCache, "$1");
                  uncached =
                    (rquery.test(cacheURL) ? "&" : "?") +
                    "_=" +
                    nonce.guid++ +
                    uncached;
                }

                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;

                // Change '%20' to '+' if this is encoded form body content (gh-2658)
              } else if (
                s.data &&
                s.processData &&
                (s.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) === 0
              ) {
                s.data = s.data.replace(r20, "+");
              }

              // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
              if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) {
                  jqXHR.setRequestHeader(
                    "If-Modified-Since",
                    jQuery.lastModified[cacheURL]
                  );
                }
                if (jQuery.etag[cacheURL]) {
                  jqXHR.setRequestHeader(
                    "If-None-Match",
                    jQuery.etag[cacheURL]
                  );
                }
              }

              // Set the correct header, if data is being sent
              if (
                (s.data && s.hasContent && s.contentType !== false) ||
                options.contentType
              ) {
                jqXHR.setRequestHeader("Content-Type", s.contentType);
              }

              // Set the Accepts header for the server, depending on the dataType
              jqXHR.setRequestHeader(
                "Accept",
                s.dataTypes[0] && s.accepts[s.dataTypes[0]]
                  ? s.accepts[s.dataTypes[0]] +
                      (s.dataTypes[0] !== "*"
                        ? ", " + allTypes + "; q=0.01"
                        : "")
                  : s.accepts["*"]
              );

              // Check for headers option
              for (i in s.headers) {
                jqXHR.setRequestHeader(i, s.headers[i]);
              }

              // Allow custom headers/mimetypes and early abort
              if (
                s.beforeSend &&
                (s.beforeSend.call(callbackContext, jqXHR, s) === false ||
                  completed)
              ) {
                // Abort if not done already and return
                return jqXHR.abort();
              }

              // Aborting is no longer a cancellation
              strAbort = "abort";

              // Install callbacks on deferreds
              completeDeferred.add(s.complete);
              jqXHR.done(s.success);
              jqXHR.fail(s.error);

              // Get transport
              transport = inspectPrefiltersOrTransports(
                transports,
                s,
                options,
                jqXHR
              );

              // If no transport, we auto-abort
              if (!transport) {
                done(-1, "No Transport");
              } else {
                jqXHR.readyState = 1;

                // Send global event
                if (fireGlobals) {
                  globalEventContext.trigger("ajaxSend", [jqXHR, s]);
                }

                // If request was aborted inside ajaxSend, stop there
                if (completed) {
                  return jqXHR;
                }

                // Timeout
                if (s.async && s.timeout > 0) {
                  timeoutTimer = window.setTimeout(function () {
                    jqXHR.abort("timeout");
                  }, s.timeout);
                }

                try {
                  completed = false;
                  transport.send(requestHeaders, done);
                } catch (e) {
                  // Rethrow post-completion exceptions
                  if (completed) {
                    throw e;
                  }

                  // Propagate others as results
                  done(-1, e);
                }
              }

              // Callback for when everything is done
              function done(status, nativeStatusText, responses, headers) {
                var isSuccess,
                  success,
                  error,
                  response,
                  modified,
                  statusText = nativeStatusText;

                // Ignore repeat invocations
                if (completed) {
                  return;
                }

                completed = true;

                // Clear timeout if it exists
                if (timeoutTimer) {
                  window.clearTimeout(timeoutTimer);
                }

                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;

                // Cache response headers
                responseHeadersString = headers || "";

                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;

                // Determine if successful
                isSuccess = (status >= 200 && status < 300) || status === 304;

                // Get response data
                if (responses) {
                  response = ajaxHandleResponses(s, jqXHR, responses);
                }

                // Use a noop converter for missing script but not if jsonp
                if (
                  !isSuccess &&
                  jQuery.inArray("script", s.dataTypes) > -1 &&
                  jQuery.inArray("json", s.dataTypes) < 0
                ) {
                  s.converters["text script"] = function () {};
                }

                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);

                // If successful, handle type chaining
                if (isSuccess) {
                  // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                  if (s.ifModified) {
                    modified = jqXHR.getResponseHeader("Last-Modified");
                    if (modified) {
                      jQuery.lastModified[cacheURL] = modified;
                    }
                    modified = jqXHR.getResponseHeader("etag");
                    if (modified) {
                      jQuery.etag[cacheURL] = modified;
                    }
                  }

                  // if no content
                  if (status === 204 || s.type === "HEAD") {
                    statusText = "nocontent";

                    // if not modified
                  } else if (status === 304) {
                    statusText = "notmodified";

                    // If we have data, let's convert it
                  } else {
                    statusText = response.state;
                    success = response.data;
                    error = response.error;
                    isSuccess = !error;
                  }
                } else {
                  // Extract error from statusText and normalize for non-aborts
                  error = statusText;
                  if (status || !statusText) {
                    statusText = "error";
                    if (status < 0) {
                      status = 0;
                    }
                  }
                }

                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";

                // Success/Error
                if (isSuccess) {
                  deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR,
                  ]);
                } else {
                  deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error,
                  ]);
                }

                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;

                if (fireGlobals) {
                  globalEventContext.trigger(
                    isSuccess ? "ajaxSuccess" : "ajaxError",
                    [jqXHR, s, isSuccess ? success : error]
                  );
                }

                // Complete
                completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

                if (fireGlobals) {
                  globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

                  // Handle the global AJAX counter
                  if (!--jQuery.active) {
                    jQuery.event.trigger("ajaxStop");
                  }
                }
              }

              return jqXHR;
            },

            getJSON: function (url, data, callback) {
              return jQuery.get(url, data, callback, "json");
            },

            getScript: function (url, callback) {
              return jQuery.get(url, undefined, callback, "script");
            },
          });

          jQuery.each(["get", "post"], function (_i, method) {
            jQuery[method] = function (url, data, callback, type) {
              // Shift arguments if data argument was omitted
              if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
              }

              // The url can be an options object (which then must have .url)
              return jQuery.ajax(
                jQuery.extend(
                  {
                    url: url,
                    type: method,
                    dataType: type,
                    data: data,
                    success: callback,
                  },
                  jQuery.isPlainObject(url) && url
                )
              );
            };
          });

          jQuery.ajaxPrefilter(function (s) {
            var i;
            for (i in s.headers) {
              if (i.toLowerCase() === "content-type") {
                s.contentType = s.headers[i] || "";
              }
            }
          });

          jQuery._evalUrl = function (url, options, doc) {
            return jQuery.ajax({
              url: url,

              // Make this explicit, since user can override this through ajaxSetup (#11264)
              type: "GET",
              dataType: "script",
              cache: true,
              async: false,
              global: false,

              // Only evaluate the response if it is successful (gh-4126)
              // dataFilter is not invoked for failure responses, so using it instead
              // of the default converter is kludgy but it works.
              converters: {
                "text script": function () {},
              },
              dataFilter: function (response) {
                jQuery.globalEval(response, options, doc);
              },
            });
          };

          jQuery.fn.extend({
            wrapAll: function (html) {
              var wrap;

              if (this[0]) {
                if (isFunction(html)) {
                  html = html.call(this[0]);
                }

                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

                if (this[0].parentNode) {
                  wrap.insertBefore(this[0]);
                }

                wrap
                  .map(function () {
                    var elem = this;

                    while (elem.firstElementChild) {
                      elem = elem.firstElementChild;
                    }

                    return elem;
                  })
                  .append(this);
              }

              return this;
            },

            wrapInner: function (html) {
              if (isFunction(html)) {
                return this.each(function (i) {
                  jQuery(this).wrapInner(html.call(this, i));
                });
              }

              return this.each(function () {
                var self = jQuery(this),
                  contents = self.contents();

                if (contents.length) {
                  contents.wrapAll(html);
                } else {
                  self.append(html);
                }
              });
            },

            wrap: function (html) {
              var htmlIsFunction = isFunction(html);

              return this.each(function (i) {
                jQuery(this).wrapAll(
                  htmlIsFunction ? html.call(this, i) : html
                );
              });
            },

            unwrap: function (selector) {
              this.parent(selector)
                .not("body")
                .each(function () {
                  jQuery(this).replaceWith(this.childNodes);
                });
              return this;
            },
          });

          jQuery.expr.pseudos.hidden = function (elem) {
            return !jQuery.expr.pseudos.visible(elem);
          };
          jQuery.expr.pseudos.visible = function (elem) {
            return !!(
              elem.offsetWidth ||
              elem.offsetHeight ||
              elem.getClientRects().length
            );
          };

          jQuery.ajaxSettings.xhr = function () {
            try {
              return new window.XMLHttpRequest();
            } catch (e) {}
          };

          var xhrSuccessStatus = {
              // File protocol always yields status code 0, assume 200
              0: 200,

              // Support: IE <=9 only
              // #1450: sometimes IE returns 1223 when it should be 204
              1223: 204,
            },
            xhrSupported = jQuery.ajaxSettings.xhr();

          support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
          support.ajax = xhrSupported = !!xhrSupported;

          jQuery.ajaxTransport(function (options) {
            var callback, errorCallback;

            // Cross domain only allowed if supported through XMLHttpRequest
            if (support.cors || (xhrSupported && !options.crossDomain)) {
              return {
                send: function (headers, complete) {
                  var i,
                    xhr = options.xhr();

                  xhr.open(
                    options.type,
                    options.url,
                    options.async,
                    options.username,
                    options.password
                  );

                  // Apply custom fields if provided
                  if (options.xhrFields) {
                    for (i in options.xhrFields) {
                      xhr[i] = options.xhrFields[i];
                    }
                  }

                  // Override mime type if needed
                  if (options.mimeType && xhr.overrideMimeType) {
                    xhr.overrideMimeType(options.mimeType);
                  }

                  // X-Requested-With header
                  // For cross-domain requests, seeing as conditions for a preflight are
                  // akin to a jigsaw puzzle, we simply never set it to be sure.
                  // (it can always be set on a per-request basis or even using ajaxSetup)
                  // For same-domain requests, won't change header if already provided.
                  if (!options.crossDomain && !headers["X-Requested-With"]) {
                    headers["X-Requested-With"] = "XMLHttpRequest";
                  }

                  // Set headers
                  for (i in headers) {
                    xhr.setRequestHeader(i, headers[i]);
                  }

                  // Callback
                  callback = function (type) {
                    return function () {
                      if (callback) {
                        callback =
                          errorCallback =
                          xhr.onload =
                          xhr.onerror =
                          xhr.onabort =
                          xhr.ontimeout =
                          xhr.onreadystatechange =
                            null;

                        if (type === "abort") {
                          xhr.abort();
                        } else if (type === "error") {
                          // Support: IE <=9 only
                          // On a manual native abort, IE9 throws
                          // errors on any property access that is not readyState
                          if (typeof xhr.status !== "number") {
                            complete(0, "error");
                          } else {
                            complete(
                              // File: protocol always yields status 0; see #8605, #14207
                              xhr.status,
                              xhr.statusText
                            );
                          }
                        } else {
                          complete(
                            xhrSuccessStatus[xhr.status] || xhr.status,
                            xhr.statusText,

                            // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" ||
                              typeof xhr.responseText !== "string"
                              ? { binary: xhr.response }
                              : { text: xhr.responseText },
                            xhr.getAllResponseHeaders()
                          );
                        }
                      }
                    };
                  };

                  // Listen to events
                  xhr.onload = callback();
                  errorCallback =
                    xhr.onerror =
                    xhr.ontimeout =
                      callback("error");

                  // Support: IE 9 only
                  // Use onreadystatechange to replace onabort
                  // to handle uncaught aborts
                  if (xhr.onabort !== undefined) {
                    xhr.onabort = errorCallback;
                  } else {
                    xhr.onreadystatechange = function () {
                      // Check readyState before timeout as it changes
                      if (xhr.readyState === 4) {
                        // Allow onerror to be called first,
                        // but that will not handle a native abort
                        // Also, save errorCallback to a variable
                        // as xhr.onerror cannot be accessed
                        window.setTimeout(function () {
                          if (callback) {
                            errorCallback();
                          }
                        });
                      }
                    };
                  }

                  // Create the abort callback
                  callback = callback("abort");

                  try {
                    // Do send the request (this may raise an exception)
                    xhr.send((options.hasContent && options.data) || null);
                  } catch (e) {
                    // #14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) {
                      throw e;
                    }
                  }
                },

                abort: function () {
                  if (callback) {
                    callback();
                  }
                },
              };
            }
          });

          // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
          jQuery.ajaxPrefilter(function (s) {
            if (s.crossDomain) {
              s.contents.script = false;
            }
          });

          // Install script dataType
          jQuery.ajaxSetup({
            accepts: {
              script:
                "text/javascript, application/javascript, " +
                "application/ecmascript, application/x-ecmascript",
            },
            contents: {
              script: /\b(?:java|ecma)script\b/,
            },
            converters: {
              "text script": function (text) {
                jQuery.globalEval(text);
                return text;
              },
            },
          });

          // Handle cache's special case and crossDomain
          jQuery.ajaxPrefilter("script", function (s) {
            if (s.cache === undefined) {
              s.cache = false;
            }
            if (s.crossDomain) {
              s.type = "GET";
            }
          });

          // Bind script tag hack transport
          jQuery.ajaxTransport("script", function (s) {
            // This transport only deals with cross domain or forced-by-attrs requests
            if (s.crossDomain || s.scriptAttrs) {
              var script, callback;
              return {
                send: function (_, complete) {
                  script = jQuery("<script>")
                    .attr(s.scriptAttrs || {})
                    .prop({ charset: s.scriptCharset, src: s.url })
                    .on(
                      "load error",
                      (callback = function (evt) {
                        script.remove();
                        callback = null;
                        if (evt) {
                          complete(evt.type === "error" ? 404 : 200, evt.type);
                        }
                      })
                    );

                  // Use native DOM manipulation to avoid our domManip AJAX trickery
                  document.head.appendChild(script[0]);
                },
                abort: function () {
                  if (callback) {
                    callback();
                  }
                },
              };
            }
          });

          var oldCallbacks = [],
            rjsonp = /(=)\?(?=&|$)|\?\?/;

          // Default jsonp settings
          jQuery.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
              var callback =
                oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
              this[callback] = true;
              return callback;
            },
          });

          // Detect, normalize options and install callbacks for jsonp requests
          jQuery.ajaxPrefilter(
            "json jsonp",
            function (s, originalSettings, jqXHR) {
              var callbackName,
                overwritten,
                responseContainer,
                jsonProp =
                  s.jsonp !== false &&
                  (rjsonp.test(s.url)
                    ? "url"
                    : typeof s.data === "string" &&
                      (s.contentType || "").indexOf(
                        "application/x-www-form-urlencoded"
                      ) === 0 &&
                      rjsonp.test(s.data) &&
                      "data");

              // Handle iff the expected data type is "jsonp" or we have a parameter to set
              if (jsonProp || s.dataTypes[0] === "jsonp") {
                // Get callback name, remembering preexisting value associated with it
                callbackName = s.jsonpCallback = isFunction(s.jsonpCallback)
                  ? s.jsonpCallback()
                  : s.jsonpCallback;

                // Insert callback into url or form data
                if (jsonProp) {
                  s[jsonProp] = s[jsonProp].replace(
                    rjsonp,
                    "$1" + callbackName
                  );
                } else if (s.jsonp !== false) {
                  s.url +=
                    (rquery.test(s.url) ? "&" : "?") +
                    s.jsonp +
                    "=" +
                    callbackName;
                }

                // Use data converter to retrieve json after script execution
                s.converters["script json"] = function () {
                  if (!responseContainer) {
                    jQuery.error(callbackName + " was not called");
                  }
                  return responseContainer[0];
                };

                // Force json dataType
                s.dataTypes[0] = "json";

                // Install callback
                overwritten = window[callbackName];
                window[callbackName] = function () {
                  responseContainer = arguments;
                };

                // Clean-up function (fires after converters)
                jqXHR.always(function () {
                  // If previous value didn't exist - remove it
                  if (overwritten === undefined) {
                    jQuery(window).removeProp(callbackName);

                    // Otherwise restore preexisting value
                  } else {
                    window[callbackName] = overwritten;
                  }

                  // Save back as free
                  if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;

                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                  }

                  // Call if it was a function and we have a response
                  if (responseContainer && isFunction(overwritten)) {
                    overwritten(responseContainer[0]);
                  }

                  responseContainer = overwritten = undefined;
                });

                // Delegate to script
                return "script";
              }
            }
          );

          // Support: Safari 8 only
          // In Safari 8 documents created via document.implementation.createHTMLDocument
          // collapse sibling forms: the second one becomes a child of the first one.
          // Because of that, this security measure has to be disabled in Safari 8.
          // https://bugs.webkit.org/show_bug.cgi?id=137337
          support.createHTMLDocument = (function () {
            var body = document.implementation.createHTMLDocument("").body;
            body.innerHTML = "<form></form><form></form>";
            return body.childNodes.length === 2;
          })();

          // Argument "data" should be string of html
          // context (optional): If specified, the fragment will be created in this context,
          // defaults to document
          // keepScripts (optional): If true, will include scripts passed in the html string
          jQuery.parseHTML = function (data, context, keepScripts) {
            if (typeof data !== "string") {
              return [];
            }
            if (typeof context === "boolean") {
              keepScripts = context;
              context = false;
            }

            var base, parsed, scripts;

            if (!context) {
              // Stop scripts or inline event handlers from being executed immediately
              // by using document.implementation
              if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");

                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
              } else {
                context = document;
              }
            }

            parsed = rsingleTag.exec(data);
            scripts = !keepScripts && [];

            // Single tag
            if (parsed) {
              return [context.createElement(parsed[1])];
            }

            parsed = buildFragment([data], context, scripts);

            if (scripts && scripts.length) {
              jQuery(scripts).remove();
            }

            return jQuery.merge([], parsed.childNodes);
          };

          /**
           * Load a url into a page
           */
          jQuery.fn.load = function (url, params, callback) {
            var selector,
              type,
              response,
              self = this,
              off = url.indexOf(" ");

            if (off > -1) {
              selector = stripAndCollapse(url.slice(off));
              url = url.slice(0, off);
            }

            // If it's a function
            if (isFunction(params)) {
              // We assume that it's the callback
              callback = params;
              params = undefined;

              // Otherwise, build a param string
            } else if (params && typeof params === "object") {
              type = "POST";
            }

            // If we have elements to modify, make the request
            if (self.length > 0) {
              jQuery
                .ajax({
                  url: url,

                  // If "type" variable is undefined, then "GET" method will be used.
                  // Make value of this field explicit since
                  // user can override it through ajaxSetup method
                  type: type || "GET",
                  dataType: "html",
                  data: params,
                })
                .done(function (responseText) {
                  // Save response for use in complete callback
                  response = arguments;

                  self.html(
                    selector
                      ? // If a selector was specified, locate the right elements in a dummy div
                        // Exclude scripts to avoid IE 'Permission Denied' errors
                        jQuery("<div>")
                          .append(jQuery.parseHTML(responseText))
                          .find(selector)
                      : // Otherwise use the full result
                        responseText
                  );

                  // If the request succeeds, this function gets "data", "status", "jqXHR"
                  // but they are ignored because response was set above.
                  // If it fails, this function gets "jqXHR", "status", "error"
                })
                .always(
                  callback &&
                    function (jqXHR, status) {
                      self.each(function () {
                        callback.apply(
                          this,
                          response || [jqXHR.responseText, status, jqXHR]
                        );
                      });
                    }
                );
            }

            return this;
          };

          jQuery.expr.pseudos.animated = function (elem) {
            return jQuery.grep(jQuery.timers, function (fn) {
              return elem === fn.elem;
            }).length;
          };

          jQuery.offset = {
            setOffset: function (elem, options, i) {
              var curPosition,
                curLeft,
                curCSSTop,
                curTop,
                curOffset,
                curCSSLeft,
                calculatePosition,
                position = jQuery.css(elem, "position"),
                curElem = jQuery(elem),
                props = {};

              // Set position first, in-case top/left are set even on static elem
              if (position === "static") {
                elem.style.position = "relative";
              }

              curOffset = curElem.offset();
              curCSSTop = jQuery.css(elem, "top");
              curCSSLeft = jQuery.css(elem, "left");
              calculatePosition =
                (position === "absolute" || position === "fixed") &&
                (curCSSTop + curCSSLeft).indexOf("auto") > -1;

              // Need to be able to calculate position if either
              // top or left is auto and position is either absolute or fixed
              if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
              } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
              }

              if (isFunction(options)) {
                // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
                options = options.call(elem, i, jQuery.extend({}, curOffset));
              }

              if (options.top != null) {
                props.top = options.top - curOffset.top + curTop;
              }
              if (options.left != null) {
                props.left = options.left - curOffset.left + curLeft;
              }

              if ("using" in options) {
                options.using.call(elem, props);
              } else {
                curElem.css(props);
              }
            },
          };

          jQuery.fn.extend({
            // offset() relates an element's border box to the document origin
            offset: function (options) {
              // Preserve chaining for setter
              if (arguments.length) {
                return options === undefined
                  ? this
                  : this.each(function (i) {
                      jQuery.offset.setOffset(this, options, i);
                    });
              }

              var rect,
                win,
                elem = this[0];

              if (!elem) {
                return;
              }

              // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
              // Support: IE <=11 only
              // Running getBoundingClientRect on a
              // disconnected node in IE throws an error
              if (!elem.getClientRects().length) {
                return { top: 0, left: 0 };
              }

              // Get document-relative position by adding viewport scroll to viewport-relative gBCR
              rect = elem.getBoundingClientRect();
              win = elem.ownerDocument.defaultView;
              return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset,
              };
            },

            // position() relates an element's margin box to its offset parent's padding box
            // This corresponds to the behavior of CSS absolute positioning
            position: function () {
              if (!this[0]) {
                return;
              }

              var offsetParent,
                offset,
                doc,
                elem = this[0],
                parentOffset = { top: 0, left: 0 };

              // position:fixed elements are offset from the viewport, which itself always has zero offset
              if (jQuery.css(elem, "position") === "fixed") {
                // Assume position:fixed implies availability of getBoundingClientRect
                offset = elem.getBoundingClientRect();
              } else {
                offset = this.offset();

                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while (
                  offsetParent &&
                  (offsetParent === doc.body ||
                    offsetParent === doc.documentElement) &&
                  jQuery.css(offsetParent, "position") === "static"
                ) {
                  offsetParent = offsetParent.parentNode;
                }
                if (
                  offsetParent &&
                  offsetParent !== elem &&
                  offsetParent.nodeType === 1
                ) {
                  // Incorporate borders into its offset, since they are outside its content origin
                  parentOffset = jQuery(offsetParent).offset();
                  parentOffset.top += jQuery.css(
                    offsetParent,
                    "borderTopWidth",
                    true
                  );
                  parentOffset.left += jQuery.css(
                    offsetParent,
                    "borderLeftWidth",
                    true
                  );
                }
              }

              // Subtract parent offsets and element margins
              return {
                top:
                  offset.top -
                  parentOffset.top -
                  jQuery.css(elem, "marginTop", true),
                left:
                  offset.left -
                  parentOffset.left -
                  jQuery.css(elem, "marginLeft", true),
              };
            },

            // This method will return documentElement in the following cases:
            // 1) For the element inside the iframe without offsetParent, this method will return
            //    documentElement of the parent window
            // 2) For the hidden or detached element
            // 3) For body or html element, i.e. in case of the html node - it will return itself
            //
            // but those exceptions were never presented as a real life use-cases
            // and might be considered as more preferable results.
            //
            // This logic, however, is not guaranteed and can change at any point in the future
            offsetParent: function () {
              return this.map(function () {
                var offsetParent = this.offsetParent;

                while (
                  offsetParent &&
                  jQuery.css(offsetParent, "position") === "static"
                ) {
                  offsetParent = offsetParent.offsetParent;
                }

                return offsetParent || documentElement;
              });
            },
          });

          // Create scrollLeft and scrollTop methods
          jQuery.each(
            { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
            function (method, prop) {
              var top = "pageYOffset" === prop;

              jQuery.fn[method] = function (val) {
                return access(
                  this,
                  function (elem, method, val) {
                    // Coalesce documents and windows
                    var win;
                    if (isWindow(elem)) {
                      win = elem;
                    } else if (elem.nodeType === 9) {
                      win = elem.defaultView;
                    }

                    if (val === undefined) {
                      return win ? win[prop] : elem[method];
                    }

                    if (win) {
                      win.scrollTo(
                        !top ? val : win.pageXOffset,
                        top ? val : win.pageYOffset
                      );
                    } else {
                      elem[method] = val;
                    }
                  },
                  method,
                  val,
                  arguments.length
                );
              };
            }
          );

          // Support: Safari <=7 - 9.1, Chrome <=37 - 49
          // Add the top/left cssHooks using jQuery.fn.position
          // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
          // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
          // getComputedStyle returns percent when specified for top/left/bottom/right;
          // rather than make the css module depend on the offset module, just check for it here
          jQuery.each(["top", "left"], function (_i, prop) {
            jQuery.cssHooks[prop] = addGetHookIf(
              support.pixelPosition,
              function (elem, computed) {
                if (computed) {
                  computed = curCSS(elem, prop);

                  // If curCSS returns percentage, fallback to offset
                  return rnumnonpx.test(computed)
                    ? jQuery(elem).position()[prop] + "px"
                    : computed;
                }
              }
            );
          });

          // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
          jQuery.each(
            { Height: "height", Width: "width" },
            function (name, type) {
              jQuery.each(
                {
                  padding: "inner" + name,
                  content: type,
                  "": "outer" + name,
                },
                function (defaultExtra, funcName) {
                  // Margin is only for outerHeight, outerWidth
                  jQuery.fn[funcName] = function (margin, value) {
                    var chainable =
                        arguments.length &&
                        (defaultExtra || typeof margin !== "boolean"),
                      extra =
                        defaultExtra ||
                        (margin === true || value === true
                          ? "margin"
                          : "border");

                    return access(
                      this,
                      function (elem, type, value) {
                        var doc;

                        if (isWindow(elem)) {
                          // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                          return funcName.indexOf("outer") === 0
                            ? elem["inner" + name]
                            : elem.document.documentElement["client" + name];
                        }

                        // Get document width or height
                        if (elem.nodeType === 9) {
                          doc = elem.documentElement;

                          // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                          // whichever is greatest
                          return Math.max(
                            elem.body["scroll" + name],
                            doc["scroll" + name],
                            elem.body["offset" + name],
                            doc["offset" + name],
                            doc["client" + name]
                          );
                        }

                        return value === undefined
                          ? // Get width or height on the element, requesting but not forcing parseFloat
                            jQuery.css(elem, type, extra)
                          : // Set width or height on the element
                            jQuery.style(elem, type, value, extra);
                      },
                      type,
                      chainable ? margin : undefined,
                      chainable
                    );
                  };
                }
              );
            }
          );

          jQuery.each(
            [
              "ajaxStart",
              "ajaxStop",
              "ajaxComplete",
              "ajaxError",
              "ajaxSuccess",
              "ajaxSend",
            ],
            function (_i, type) {
              jQuery.fn[type] = function (fn) {
                return this.on(type, fn);
              };
            }
          );

          jQuery.fn.extend({
            bind: function (types, data, fn) {
              return this.on(types, null, data, fn);
            },
            unbind: function (types, fn) {
              return this.off(types, null, fn);
            },

            delegate: function (selector, types, data, fn) {
              return this.on(types, selector, data, fn);
            },
            undelegate: function (selector, types, fn) {
              // ( namespace ) or ( selector, types [, fn] )
              return arguments.length === 1
                ? this.off(selector, "**")
                : this.off(types, selector || "**", fn);
            },

            hover: function (fnOver, fnOut) {
              return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
            },
          });

          jQuery.each(
            (
              "blur focus focusin focusout resize scroll click dblclick " +
              "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
              "change select submit keydown keypress keyup contextmenu"
            ).split(" "),
            function (_i, name) {
              // Handle event binding
              jQuery.fn[name] = function (data, fn) {
                return arguments.length > 0
                  ? this.on(name, null, data, fn)
                  : this.trigger(name);
              };
            }
          );

          // Support: Android <=4.0 only
          // Make sure we trim BOM and NBSP
          var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

          // Bind a function to a context, optionally partially applying any
          // arguments.
          // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
          // However, it is not slated for removal any time soon
          jQuery.proxy = function (fn, context) {
            var tmp, args, proxy;

            if (typeof context === "string") {
              tmp = fn[context];
              context = fn;
              fn = tmp;
            }

            // Quick check to determine if target is callable, in the spec
            // this throws a TypeError, but we will just return undefined.
            if (!isFunction(fn)) {
              return undefined;
            }

            // Simulated bind
            args = slice.call(arguments, 2);
            proxy = function () {
              return fn.apply(
                context || this,
                args.concat(slice.call(arguments))
              );
            };

            // Set the guid of unique handler to the same of original handler, so it can be removed
            proxy.guid = fn.guid = fn.guid || jQuery.guid++;

            return proxy;
          };

          jQuery.holdReady = function (hold) {
            if (hold) {
              jQuery.readyWait++;
            } else {
              jQuery.ready(true);
            }
          };
          jQuery.isArray = Array.isArray;
          jQuery.parseJSON = JSON.parse;
          jQuery.nodeName = nodeName;
          jQuery.isFunction = isFunction;
          jQuery.isWindow = isWindow;
          jQuery.camelCase = camelCase;
          jQuery.type = toType;

          jQuery.now = Date.now;

          jQuery.isNumeric = function (obj) {
            // As of jQuery 3.0, isNumeric is limited to
            // strings and numbers (primitives or objects)
            // that can be coerced to finite numbers (gh-2662)
            var type = jQuery.type(obj);
            return (
              (type === "number" || type === "string") &&
              // parseFloat NaNs numeric-cast false positives ("")
              // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
              // subtraction forces infinities to NaN
              !isNaN(obj - parseFloat(obj))
            );
          };

          jQuery.trim = function (text) {
            return text == null ? "" : (text + "").replace(rtrim, "");
          };

          // Register as a named AMD module, since jQuery can be concatenated with other
          // files that may use define, but not via a proper concatenation script that
          // understands anonymous AMD modules. A named AMD is safest and most robust
          // way to register. Lowercase jquery is used because AMD module names are
          // derived from file names, and jQuery is normally delivered in a lowercase
          // file name. Do this after creating the global so that if an AMD module wants
          // to call noConflict to hide this version of jQuery, it will work.

          // Note that for maximum portability, libraries that are not jQuery should
          // declare themselves as anonymous modules, and avoid setting a global if an
          // AMD loader is present. jQuery is a special case. For more information, see
          // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

          if (true) {
            !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
            (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return jQuery;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
              (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          }

          var // Map over jQuery in case of overwrite
            _jQuery = window.jQuery,
            // Map over the $ in case of overwrite
            _$ = window.$;

          jQuery.noConflict = function (deep) {
            if (window.$ === jQuery) {
              window.$ = _$;
            }

            if (deep && window.jQuery === jQuery) {
              window.jQuery = _jQuery;
            }

            return jQuery;
          };

          // Expose jQuery and $ identifiers, even in AMD
          // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
          // and CommonJS for browser emulators (#13566)
          if (typeof noGlobal === "undefined") {
            window.jQuery = window.$ = jQuery;
          }

          return jQuery;
        }
      );

      /***/
    },

    /***/ 933: /***/ (
      module,
      __unused_webpack_exports,
      __webpack_require__
    ) => {
      "use strict";

      /**
       * Module dependencies
       */
      var decouple = __webpack_require__(816);
      var Emitter = __webpack_require__(626);

      /**
       * Privates
       */
      var scrollTimeout;
      var scrolling = false;
      var doc = window.document;
      var html = doc.documentElement;
      var msPointerSupported = window.navigator.msPointerEnabled;
      var touch = {
        start: msPointerSupported ? "MSPointerDown" : "touchstart",
        move: msPointerSupported ? "MSPointerMove" : "touchmove",
        end: msPointerSupported ? "MSPointerUp" : "touchend",
      };
      var prefix = (function prefix() {
        var regex = /^(Webkit|Khtml|Moz|ms|O)(?=[A-Z])/;
        var styleDeclaration = doc.getElementsByTagName("script")[0].style;
        for (var prop in styleDeclaration) {
          if (regex.test(prop)) {
            return "-" + prop.match(regex)[0].toLowerCase() + "-";
          }
        }
        // Nothing found so far? Webkit does not enumerate over the CSS properties of the style object.
        // However (prop in style) returns the correct value, so we'll have to test for
        // the precence of a specific property
        if ("WebkitOpacity" in styleDeclaration) {
          return "-webkit-";
        }
        if ("KhtmlOpacity" in styleDeclaration) {
          return "-khtml-";
        }
        return "";
      })();
      function extend(destination, from) {
        for (var prop in from) {
          if (from[prop]) {
            destination[prop] = from[prop];
          }
        }
        return destination;
      }
      function inherits(child, uber) {
        child.prototype = extend(child.prototype || {}, uber.prototype);
      }
      function hasIgnoredElements(el) {
        while (el.parentNode) {
          if (el.getAttribute("data-slideout-ignore") !== null) {
            return el;
          }
          el = el.parentNode;
        }
        return null;
      }

      /**
       * Slideout constructor
       */
      function Slideout(options) {
        options = options || {};

        // Sets default values
        this._startOffsetX = 0;
        this._currentOffsetX = 0;
        this._opening = false;
        this._moved = false;
        this._opened = false;
        this._preventOpen = false;
        this._touch =
          options.touch === undefined ? true : options.touch && true;
        this._side = options.side || "left";

        // Sets panel
        this.panel = options.panel;
        this.menu = options.menu;

        // Sets  classnames
        if (!this.panel.classList.contains("slideout-panel")) {
          this.panel.classList.add("slideout-panel");
        }
        if (!this.panel.classList.contains("slideout-panel-" + this._side)) {
          this.panel.classList.add("slideout-panel-" + this._side);
        }
        if (!this.menu.classList.contains("slideout-menu")) {
          this.menu.classList.add("slideout-menu");
        }
        if (!this.menu.classList.contains("slideout-menu-" + this._side)) {
          this.menu.classList.add("slideout-menu-" + this._side);
        }

        // Sets options
        this._fx = options.fx || "ease";
        this._duration = parseInt(options.duration, 10) || 300;
        this._tolerance = parseInt(options.tolerance, 10) || 70;
        this._padding = this._translateTo =
          parseInt(options.padding, 10) || 256;
        this._orientation = this._side === "right" ? -1 : 1;
        this._translateTo *= this._orientation;

        // Init touch events
        if (this._touch) {
          this._initTouchEvents();
        }
      }

      /**
       * Inherits from Emitter
       */
      inherits(Slideout, Emitter);

      /**
       * Opens the slideout menu.
       */
      Slideout.prototype.open = function () {
        var self = this;
        this.emit("beforeopen");
        if (!html.classList.contains("slideout-open")) {
          html.classList.add("slideout-open");
        }
        this._setTransition();
        this._translateXTo(this._translateTo);
        this._opened = true;
        setTimeout(function () {
          self.panel.style.transition = self.panel.style["-webkit-transition"] =
            "";
          self.emit("open");
        }, this._duration + 50);
        return this;
      };

      /**
       * Closes slideout menu.
       */
      Slideout.prototype.close = function () {
        var self = this;
        if (!this.isOpen() && !this._opening) {
          return this;
        }
        this.emit("beforeclose");
        this._setTransition();
        this._translateXTo(0);
        this._opened = false;
        setTimeout(function () {
          html.classList.remove("slideout-open");
          self.panel.style.transition =
            self.panel.style["-webkit-transition"] =
            self.panel.style[prefix + "transform"] =
            self.panel.style.transform =
              "";
          self.emit("close");
        }, this._duration + 50);
        return this;
      };

      /**
       * Toggles (open/close) slideout menu.
       */
      Slideout.prototype.toggle = function () {
        return this.isOpen() ? this.close() : this.open();
      };

      /**
       * Returns true if the slideout is currently open, and false if it is closed.
       */
      Slideout.prototype.isOpen = function () {
        return this._opened;
      };

      /**
       * Translates panel and updates currentOffset with a given X point
       */
      Slideout.prototype._translateXTo = function (translateX) {
        this._currentOffsetX = translateX;
        this.panel.style[prefix + "transform"] = this.panel.style.transform =
          "translateX(" + translateX + "px)";
        return this;
      };

      /**
       * Set transition properties
       */
      Slideout.prototype._setTransition = function () {
        this.panel.style[prefix + "transition"] = this.panel.style.transition =
          prefix + "transform " + this._duration + "ms " + this._fx;
        return this;
      };

      /**
       * Initializes touch event
       */
      Slideout.prototype._initTouchEvents = function () {
        var self = this;

        /**
         * Decouple scroll event
         */
        this._onScrollFn = decouple(doc, "scroll", function () {
          if (!self._moved) {
            clearTimeout(scrollTimeout);
            scrolling = true;
            scrollTimeout = setTimeout(function () {
              scrolling = false;
            }, 250);
          }
        });

        /**
         * Prevents touchmove event if slideout is moving
         */
        this._preventMove = function (eve) {
          if (self._moved) {
            eve.preventDefault();
          }
        };

        doc.addEventListener(touch.move, this._preventMove);

        /**
         * Resets values on touchstart
         */
        this._resetTouchFn = function (eve) {
          if (typeof eve.touches === "undefined") {
            return;
          }

          self._moved = false;
          self._opening = false;
          self._startOffsetX = eve.touches[0].pageX;
          self._preventOpen =
            !self._touch || (!self.isOpen() && self.menu.clientWidth !== 0);
        };

        this.panel.addEventListener(touch.start, this._resetTouchFn);

        /**
         * Resets values on touchcancel
         */
        this._onTouchCancelFn = function () {
          self._moved = false;
          self._opening = false;
        };

        this.panel.addEventListener("touchcancel", this._onTouchCancelFn);

        /**
         * Toggles slideout on touchend
         */
        this._onTouchEndFn = function () {
          if (self._moved) {
            self.emit("translateend");
            self._opening && Math.abs(self._currentOffsetX) > self._tolerance
              ? self.open()
              : self.close();
          }
          self._moved = false;
        };

        this.panel.addEventListener(touch.end, this._onTouchEndFn);

        /**
         * Translates panel on touchmove
         */
        this._onTouchMoveFn = function (eve) {
          if (
            scrolling ||
            self._preventOpen ||
            typeof eve.touches === "undefined" ||
            hasIgnoredElements(eve.target)
          ) {
            return;
          }

          var dif_x = eve.touches[0].clientX - self._startOffsetX;
          var translateX = (self._currentOffsetX = dif_x);

          if (Math.abs(translateX) > self._padding) {
            return;
          }

          if (Math.abs(dif_x) > 20) {
            self._opening = true;

            var oriented_dif_x = dif_x * self._orientation;

            if (
              (self._opened && oriented_dif_x > 0) ||
              (!self._opened && oriented_dif_x < 0)
            ) {
              return;
            }

            if (!self._moved) {
              self.emit("translatestart");
            }

            if (oriented_dif_x <= 0) {
              translateX = dif_x + self._padding * self._orientation;
              self._opening = false;
            }

            if (!(self._moved && html.classList.contains("slideout-open"))) {
              html.classList.add("slideout-open");
            }

            self.panel.style[prefix + "transform"] =
              self.panel.style.transform = "translateX(" + translateX + "px)";
            self.emit("translate", translateX);
            self._moved = true;
          }
        };

        this.panel.addEventListener(touch.move, this._onTouchMoveFn);

        return this;
      };

      /**
       * Enable opening the slideout via touch events.
       */
      Slideout.prototype.enableTouch = function () {
        this._touch = true;
        return this;
      };

      /**
       * Disable opening the slideout via touch events.
       */
      Slideout.prototype.disableTouch = function () {
        this._touch = false;
        return this;
      };

      /**
       * Destroy an instance of slideout.
       */
      Slideout.prototype.destroy = function () {
        // Close before clean
        this.close();

        // Remove event listeners
        doc.removeEventListener(touch.move, this._preventMove);
        this.panel.removeEventListener(touch.start, this._resetTouchFn);
        this.panel.removeEventListener("touchcancel", this._onTouchCancelFn);
        this.panel.removeEventListener(touch.end, this._onTouchEndFn);
        this.panel.removeEventListener(touch.move, this._onTouchMoveFn);
        doc.removeEventListener("scroll", this._onScrollFn);

        // Remove methods
        this.open = this.close = function () {};

        // Return the instance so it can be easily dereferenced
        return this;
      };

      /**
       * Expose Slideout
       */
      module.exports = Slideout;

      /***/
    },

    /***/ 630: /***/ function (module, exports) {
      var __WEBPACK_AMD_DEFINE_FACTORY__,
        __WEBPACK_AMD_DEFINE_ARRAY__,
        __WEBPACK_AMD_DEFINE_RESULT__;
      (function (global, factory) {
        if (true) {
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports]),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
                  exports,
                  __WEBPACK_AMD_DEFINE_ARRAY__
                )
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
          var mod;
        }
      })(this, function (module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _class, _temp;

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        })();

        function isIn(needle, haystack) {
          return haystack.indexOf(needle) >= 0;
        }

        function extend(custom, defaults) {
          for (var key in defaults) {
            if (custom[key] == null) {
              var value = defaults[key];
              custom[key] = value;
            }
          }
          return custom;
        }

        function isMobile(agent) {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            agent
          );
        }

        function createEvent(event) {
          var bubble =
            arguments.length <= 1 || arguments[1] === undefined
              ? false
              : arguments[1];
          var cancel =
            arguments.length <= 2 || arguments[2] === undefined
              ? false
              : arguments[2];
          var detail =
            arguments.length <= 3 || arguments[3] === undefined
              ? null
              : arguments[3];

          var customEvent = void 0;
          if (document.createEvent != null) {
            // W3C DOM
            customEvent = document.createEvent("CustomEvent");
            customEvent.initCustomEvent(event, bubble, cancel, detail);
          } else if (document.createEventObject != null) {
            // IE DOM < 9
            customEvent = document.createEventObject();
            customEvent.eventType = event;
          } else {
            customEvent.eventName = event;
          }

          return customEvent;
        }

        function emitEvent(elem, event) {
          if (elem.dispatchEvent != null) {
            // W3C DOM
            elem.dispatchEvent(event);
          } else if (event in (elem != null)) {
            elem[event]();
          } else if ("on" + event in (elem != null)) {
            elem["on" + event]();
          }
        }

        function addEvent(elem, event, fn) {
          if (elem.addEventListener != null) {
            // W3C DOM
            elem.addEventListener(event, fn, false);
          } else if (elem.attachEvent != null) {
            // IE DOM
            elem.attachEvent("on" + event, fn);
          } else {
            // fallback
            elem[event] = fn;
          }
        }

        function removeEvent(elem, event, fn) {
          if (elem.removeEventListener != null) {
            // W3C DOM
            elem.removeEventListener(event, fn, false);
          } else if (elem.detachEvent != null) {
            // IE DOM
            elem.detachEvent("on" + event, fn);
          } else {
            // fallback
            delete elem[event];
          }
        }

        function getInnerHeight() {
          if ("innerHeight" in window) {
            return window.innerHeight;
          }

          return document.documentElement.clientHeight;
        }

        // Minimalistic WeakMap shim, just in case.
        var WeakMap =
          window.WeakMap ||
          window.MozWeakMap ||
          (function () {
            function WeakMap() {
              _classCallCheck(this, WeakMap);

              this.keys = [];
              this.values = [];
            }

            _createClass(WeakMap, [
              {
                key: "get",
                value: function get(key) {
                  for (var i = 0; i < this.keys.length; i++) {
                    var item = this.keys[i];
                    if (item === key) {
                      return this.values[i];
                    }
                  }
                  return undefined;
                },
              },
              {
                key: "set",
                value: function set(key, value) {
                  for (var i = 0; i < this.keys.length; i++) {
                    var item = this.keys[i];
                    if (item === key) {
                      this.values[i] = value;
                      return this;
                    }
                  }
                  this.keys.push(key);
                  this.values.push(value);
                  return this;
                },
              },
            ]);

            return WeakMap;
          })();

        // Dummy MutationObserver, to avoid raising exceptions.
        var MutationObserver =
          window.MutationObserver ||
          window.WebkitMutationObserver ||
          window.MozMutationObserver ||
          ((_temp = _class =
            (function () {
              function MutationObserver() {
                _classCallCheck(this, MutationObserver);

                if (typeof console !== "undefined" && console !== null) {
                  console.warn(
                    "MutationObserver is not supported by your browser."
                  );
                  console.warn(
                    "WOW.js cannot detect dom mutations, please call .sync() after loading new content."
                  );
                }
              }

              _createClass(MutationObserver, [
                {
                  key: "observe",
                  value: function observe() {},
                },
              ]);

              return MutationObserver;
            })()),
          (_class.notSupported = true),
          _temp);

        // getComputedStyle shim, from http://stackoverflow.com/a/21797294
        var getComputedStyle =
          window.getComputedStyle ||
          function getComputedStyle(el) {
            var getComputedStyleRX = /(\-([a-z]){1})/g;
            return {
              getPropertyValue: function getPropertyValue(prop) {
                if (prop === "float") {
                  prop = "styleFloat";
                }
                if (getComputedStyleRX.test(prop)) {
                  prop.replace(getComputedStyleRX, function (_, _char) {
                    return _char.toUpperCase();
                  });
                }
                var currentStyle = el.currentStyle;

                return (
                  (currentStyle != null ? currentStyle[prop] : void 0) || null
                );
              },
            };
          };

        var WOW = (function () {
          function WOW() {
            var options =
              arguments.length <= 0 || arguments[0] === undefined
                ? {}
                : arguments[0];

            _classCallCheck(this, WOW);

            this.defaults = {
              boxClass: "wow",
              animateClass: "animated",
              offset: 0,
              mobile: true,
              live: true,
              callback: null,
              scrollContainer: null,
            };

            this.animate = (function animateFactory() {
              if ("requestAnimationFrame" in window) {
                return function (callback) {
                  return window.requestAnimationFrame(callback);
                };
              }
              return function (callback) {
                return callback();
              };
            })();

            this.vendors = ["moz", "webkit"];

            this.start = this.start.bind(this);
            this.resetAnimation = this.resetAnimation.bind(this);
            this.scrollHandler = this.scrollHandler.bind(this);
            this.scrollCallback = this.scrollCallback.bind(this);
            this.scrolled = true;
            this.config = extend(options, this.defaults);
            if (options.scrollContainer != null) {
              this.config.scrollContainer = document.querySelector(
                options.scrollContainer
              );
            }
            // Map of elements to animation names:
            this.animationNameCache = new WeakMap();
            this.wowEvent = createEvent(this.config.boxClass);
          }

          _createClass(WOW, [
            {
              key: "init",
              value: function init() {
                this.element = window.document.documentElement;
                if (isIn(document.readyState, ["interactive", "complete"])) {
                  this.start();
                } else {
                  addEvent(document, "DOMContentLoaded", this.start);
                }
                this.finished = [];
              },
            },
            {
              key: "start",
              value: function start() {
                var _this = this;

                this.stopped = false;
                this.boxes = [].slice.call(
                  this.element.querySelectorAll("." + this.config.boxClass)
                );
                this.all = this.boxes.slice(0);
                if (this.boxes.length) {
                  if (this.disabled()) {
                    this.resetStyle();
                  } else {
                    for (var i = 0; i < this.boxes.length; i++) {
                      var box = this.boxes[i];
                      this.applyStyle(box, true);
                    }
                  }
                }
                if (!this.disabled()) {
                  addEvent(
                    this.config.scrollContainer || window,
                    "scroll",
                    this.scrollHandler
                  );
                  addEvent(window, "resize", this.scrollHandler);
                  this.interval = setInterval(this.scrollCallback, 50);
                }
                if (this.config.live) {
                  var mut = new MutationObserver(function (records) {
                    for (var j = 0; j < records.length; j++) {
                      var record = records[j];
                      for (var k = 0; k < record.addedNodes.length; k++) {
                        var node = record.addedNodes[k];
                        _this.doSync(node);
                      }
                    }
                    return undefined;
                  });
                  mut.observe(document.body, {
                    childList: true,
                    subtree: true,
                  });
                }
              },
            },
            {
              key: "stop",
              value: function stop() {
                this.stopped = true;
                removeEvent(
                  this.config.scrollContainer || window,
                  "scroll",
                  this.scrollHandler
                );
                removeEvent(window, "resize", this.scrollHandler);
                if (this.interval != null) {
                  clearInterval(this.interval);
                }
              },
            },
            {
              key: "sync",
              value: function sync() {
                if (MutationObserver.notSupported) {
                  this.doSync(this.element);
                }
              },
            },
            {
              key: "doSync",
              value: function doSync(element) {
                if (typeof element === "undefined" || element === null) {
                  element = this.element;
                }
                if (element.nodeType !== 1) {
                  return;
                }
                element = element.parentNode || element;
                var iterable = element.querySelectorAll(
                  "." + this.config.boxClass
                );
                for (var i = 0; i < iterable.length; i++) {
                  var box = iterable[i];
                  if (!isIn(box, this.all)) {
                    this.boxes.push(box);
                    this.all.push(box);
                    if (this.stopped || this.disabled()) {
                      this.resetStyle();
                    } else {
                      this.applyStyle(box, true);
                    }
                    this.scrolled = true;
                  }
                }
              },
            },
            {
              key: "show",
              value: function show(box) {
                this.applyStyle(box);
                box.className = box.className + " " + this.config.animateClass;
                if (this.config.callback != null) {
                  this.config.callback(box);
                }
                emitEvent(box, this.wowEvent);

                addEvent(box, "animationend", this.resetAnimation);
                addEvent(box, "oanimationend", this.resetAnimation);
                addEvent(box, "webkitAnimationEnd", this.resetAnimation);
                addEvent(box, "MSAnimationEnd", this.resetAnimation);

                return box;
              },
            },
            {
              key: "applyStyle",
              value: function applyStyle(box, hidden) {
                var _this2 = this;

                var duration = box.getAttribute("data-wow-duration");
                var delay = box.getAttribute("data-wow-delay");
                var iteration = box.getAttribute("data-wow-iteration");

                return this.animate(function () {
                  return _this2.customStyle(
                    box,
                    hidden,
                    duration,
                    delay,
                    iteration
                  );
                });
              },
            },
            {
              key: "resetStyle",
              value: function resetStyle() {
                for (var i = 0; i < this.boxes.length; i++) {
                  var box = this.boxes[i];
                  box.style.visibility = "visible";
                }
                return undefined;
              },
            },
            {
              key: "resetAnimation",
              value: function resetAnimation(event) {
                if (event.type.toLowerCase().indexOf("animationend") >= 0) {
                  var target = event.target || event.srcElement;
                  target.className = target.className
                    .replace(this.config.animateClass, "")
                    .trim();
                }
              },
            },
            {
              key: "customStyle",
              value: function customStyle(
                box,
                hidden,
                duration,
                delay,
                iteration
              ) {
                if (hidden) {
                  this.cacheAnimationName(box);
                }
                box.style.visibility = hidden ? "hidden" : "visible";

                if (duration) {
                  this.vendorSet(box.style, { animationDuration: duration });
                }
                if (delay) {
                  this.vendorSet(box.style, { animationDelay: delay });
                }
                if (iteration) {
                  this.vendorSet(box.style, {
                    animationIterationCount: iteration,
                  });
                }
                this.vendorSet(box.style, {
                  animationName: hidden
                    ? "none"
                    : this.cachedAnimationName(box),
                });

                return box;
              },
            },
            {
              key: "vendorSet",
              value: function vendorSet(elem, properties) {
                for (var name in properties) {
                  if (properties.hasOwnProperty(name)) {
                    var value = properties[name];
                    elem["" + name] = value;
                    for (var i = 0; i < this.vendors.length; i++) {
                      var vendor = this.vendors[i];
                      elem[
                        "" +
                          vendor +
                          name.charAt(0).toUpperCase() +
                          name.substr(1)
                      ] = value;
                    }
                  }
                }
              },
            },
            {
              key: "vendorCSS",
              value: function vendorCSS(elem, property) {
                var style = getComputedStyle(elem);
                var result = style.getPropertyCSSValue(property);
                for (var i = 0; i < this.vendors.length; i++) {
                  var vendor = this.vendors[i];
                  result =
                    result ||
                    style.getPropertyCSSValue("-" + vendor + "-" + property);
                }
                return result;
              },
            },
            {
              key: "animationName",
              value: function animationName(box) {
                var aName = void 0;
                try {
                  aName = this.vendorCSS(box, "animation-name").cssText;
                } catch (error) {
                  // Opera, fall back to plain property value
                  aName =
                    getComputedStyle(box).getPropertyValue("animation-name");
                }

                if (aName === "none") {
                  return ""; // SVG/Firefox, unable to get animation name?
                }

                return aName;
              },
            },
            {
              key: "cacheAnimationName",
              value: function cacheAnimationName(box) {
                // https://bugzilla.mozilla.org/show_bug.cgi?id=921834
                // box.dataset is not supported for SVG elements in Firefox
                return this.animationNameCache.set(
                  box,
                  this.animationName(box)
                );
              },
            },
            {
              key: "cachedAnimationName",
              value: function cachedAnimationName(box) {
                return this.animationNameCache.get(box);
              },
            },
            {
              key: "scrollHandler",
              value: function scrollHandler() {
                this.scrolled = true;
              },
            },
            {
              key: "scrollCallback",
              value: function scrollCallback() {
                if (this.scrolled) {
                  this.scrolled = false;
                  var results = [];
                  for (var i = 0; i < this.boxes.length; i++) {
                    var box = this.boxes[i];
                    if (box) {
                      if (this.isVisible(box)) {
                        this.show(box);
                        continue;
                      }
                      results.push(box);
                    }
                  }
                  this.boxes = results;
                  if (!this.boxes.length && !this.config.live) {
                    this.stop();
                  }
                }
              },
            },
            {
              key: "offsetTop",
              value: function offsetTop(element) {
                // SVG elements don't have an offsetTop in Firefox.
                // This will use their nearest parent that has an offsetTop.
                // Also, using ('offsetTop' of element) causes an exception in Firefox.
                while (element.offsetTop === undefined) {
                  element = element.parentNode;
                }
                var top = element.offsetTop;
                while (element.offsetParent) {
                  element = element.offsetParent;
                  top += element.offsetTop;
                }
                return top;
              },
            },
            {
              key: "isVisible",
              value: function isVisible(box) {
                var offset =
                  box.getAttribute("data-wow-offset") || this.config.offset;
                var viewTop =
                  (this.config.scrollContainer &&
                    this.config.scrollContainer.scrollTop) ||
                  window.pageYOffset;
                var viewBottom =
                  viewTop +
                  Math.min(this.element.clientHeight, getInnerHeight()) -
                  offset;
                var top = this.offsetTop(box);
                var bottom = top + box.clientHeight;

                return top <= viewBottom && bottom >= viewTop;
              },
            },
            {
              key: "disabled",
              value: function disabled() {
                return !this.config.mobile && isMobile(navigator.userAgent);
              },
            },
          ]);

          return WOW;
        })();

        exports.default = WOW;
        module.exports = exports["default"];
      });

      /***/
    },

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId].call(
      module.exports,
      module,
      module.exports,
      __webpack_require__
    );
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/compat get default export */
  /******/ (() => {
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ __webpack_require__.n = (module) => {
      /******/ var getter =
        module && module.__esModule
          ? /******/ () => module["default"]
          : /******/ () => module;
      /******/ __webpack_require__.d(getter, { a: getter });
      /******/ return getter;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/ (() => {
    /******/ // define getter functions for harmony exports
    /******/ __webpack_require__.d = (exports, definition) => {
      /******/ for (var key in definition) {
        /******/ if (
          __webpack_require__.o(definition, key) &&
          !__webpack_require__.o(exports, key)
        ) {
          /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key],
          });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/global */
  /******/ (() => {
    /******/ __webpack_require__.g = (function () {
      /******/ if (typeof globalThis === "object") return globalThis;
      /******/ try {
        /******/ return this || new Function("return this")();
        /******/
      } catch (e) {
        /******/ if (typeof window === "object") return window;
        /******/
      }
      /******/
    })();
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/ (() => {
    /******/ __webpack_require__.o = (obj, prop) =>
      Object.prototype.hasOwnProperty.call(obj, prop);
    /******/
  })();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be in strict mode.
  (() => {
    "use strict";

    // EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
    var jquery = __webpack_require__(755);
    var jquery_default = /*#__PURE__*/ __webpack_require__.n(jquery);
    // EXTERNAL MODULE: ./node_modules/wow.js/dist/wow.js
    var wow = __webpack_require__(630);
    var wow_default = /*#__PURE__*/ __webpack_require__.n(wow); // CONCATENATED MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
    /*!
     * Vue.js v2.6.14
     * (c) 2014-2021 Evan You
     * Released under the MIT License.
     */
    /*  */

    var emptyObject = Object.freeze({});

    // These helpers produce better VM code in JS engines due to their
    // explicitness and function inlining.
    function isUndef(v) {
      return v === undefined || v === null;
    }

    function isDef(v) {
      return v !== undefined && v !== null;
    }

    function isTrue(v) {
      return v === true;
    }

    function isFalse(v) {
      return v === false;
    }

    /**
     * Check if value is primitive.
     */
    function isPrimitive(value) {
      return (
        typeof value === "string" ||
        typeof value === "number" ||
        // $flow-disable-line
        typeof value === "symbol" ||
        typeof value === "boolean"
      );
    }

    /**
     * Quick object check - this is primarily used to tell
     * Objects from primitive values when we know the value
     * is a JSON-compliant type.
     */
    function isObject(obj) {
      return obj !== null && typeof obj === "object";
    }

    /**
     * Get the raw type string of a value, e.g., [object Object].
     */
    var _toString = Object.prototype.toString;

    function toRawType(value) {
      return _toString.call(value).slice(8, -1);
    }

    /**
     * Strict object type check. Only returns true
     * for plain JavaScript objects.
     */
    function isPlainObject(obj) {
      return _toString.call(obj) === "[object Object]";
    }

    function isRegExp(v) {
      return _toString.call(v) === "[object RegExp]";
    }

    /**
     * Check if val is a valid array index.
     */
    function isValidArrayIndex(val) {
      var n = parseFloat(String(val));
      return n >= 0 && Math.floor(n) === n && isFinite(val);
    }

    function isPromise(val) {
      return (
        isDef(val) &&
        typeof val.then === "function" &&
        typeof val.catch === "function"
      );
    }

    /**
     * Convert a value to a string that is actually rendered.
     */
    function vue_runtime_esm_toString(val) {
      return val == null
        ? ""
        : Array.isArray(val) ||
          (isPlainObject(val) && val.toString === _toString)
        ? JSON.stringify(val, null, 2)
        : String(val);
    }

    /**
     * Convert an input value to a number for persistence.
     * If the conversion fails, return original string.
     */
    function toNumber(val) {
      var n = parseFloat(val);
      return isNaN(n) ? val : n;
    }

    /**
     * Make a map and return a function for checking if a key
     * is in that map.
     */
    function makeMap(str, expectsLowerCase) {
      var map = Object.create(null);
      var list = str.split(",");
      for (var i = 0; i < list.length; i++) {
        map[list[i]] = true;
      }
      return expectsLowerCase
        ? function (val) {
            return map[val.toLowerCase()];
          }
        : function (val) {
            return map[val];
          };
    }

    /**
     * Check if a tag is a built-in tag.
     */
    var isBuiltInTag = makeMap("slot,component", true);

    /**
     * Check if an attribute is a reserved attribute.
     */
    var isReservedAttribute = makeMap("key,ref,slot,slot-scope,is");

    /**
     * Remove an item from an array.
     */
    function remove(arr, item) {
      if (arr.length) {
        var index = arr.indexOf(item);
        if (index > -1) {
          return arr.splice(index, 1);
        }
      }
    }

    /**
     * Check whether an object has the property.
     */
    var vue_runtime_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
    function hasOwn(obj, key) {
      return vue_runtime_esm_hasOwnProperty.call(obj, key);
    }

    /**
     * Create a cached version of a pure function.
     */
    function cached(fn) {
      var cache = Object.create(null);
      return function cachedFn(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
      };
    }

    /**
     * Camelize a hyphen-delimited string.
     */
    var camelizeRE = /-(\w)/g;
    var camelize = cached(function (str) {
      return str.replace(camelizeRE, function (_, c) {
        return c ? c.toUpperCase() : "";
      });
    });

    /**
     * Capitalize a string.
     */
    var capitalize = cached(function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    });

    /**
     * Hyphenate a camelCase string.
     */
    var hyphenateRE = /\B([A-Z])/g;
    var hyphenate = cached(function (str) {
      return str.replace(hyphenateRE, "-$1").toLowerCase();
    });

    /**
     * Simple bind polyfill for environments that do not support it,
     * e.g., PhantomJS 1.x. Technically, we don't need this anymore
     * since native bind is now performant enough in most browsers.
     * But removing it would mean breaking code that was able to run in
     * PhantomJS 1.x, so this must be kept for backward compatibility.
     */

    /* istanbul ignore next */
    function polyfillBind(fn, ctx) {
      function boundFn(a) {
        var l = arguments.length;
        return l
          ? l > 1
            ? fn.apply(ctx, arguments)
            : fn.call(ctx, a)
          : fn.call(ctx);
      }

      boundFn._length = fn.length;
      return boundFn;
    }

    function nativeBind(fn, ctx) {
      return fn.bind(ctx);
    }

    var bind = Function.prototype.bind ? nativeBind : polyfillBind;

    /**
     * Convert an Array-like object to a real Array.
     */
    function toArray(list, start) {
      start = start || 0;
      var i = list.length - start;
      var ret = new Array(i);
      while (i--) {
        ret[i] = list[i + start];
      }
      return ret;
    }

    /**
     * Mix properties into target object.
     */
    function extend(to, _from) {
      for (var key in _from) {
        to[key] = _from[key];
      }
      return to;
    }

    /**
     * Merge an Array of Objects into a single Object.
     */
    function toObject(arr) {
      var res = {};
      for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
          extend(res, arr[i]);
        }
      }
      return res;
    }

    /* eslint-disable no-unused-vars */

    /**
     * Perform no operation.
     * Stubbing args to make Flow happy without leaving useless transpiled code
     * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
     */
    function noop(a, b, c) {}

    /**
     * Always return false.
     */
    var no = function (a, b, c) {
      return false;
    };

    /* eslint-enable no-unused-vars */

    /**
     * Return the same value.
     */
    var identity = function (_) {
      return _;
    };

    /**
     * Check if two values are loosely equal - that is,
     * if they are plain objects, do they have the same shape?
     */
    function looseEqual(a, b) {
      if (a === b) {
        return true;
      }
      var isObjectA = isObject(a);
      var isObjectB = isObject(b);
      if (isObjectA && isObjectB) {
        try {
          var isArrayA = Array.isArray(a);
          var isArrayB = Array.isArray(b);
          if (isArrayA && isArrayB) {
            return (
              a.length === b.length &&
              a.every(function (e, i) {
                return looseEqual(e, b[i]);
              })
            );
          } else if (a instanceof Date && b instanceof Date) {
            return a.getTime() === b.getTime();
          } else if (!isArrayA && !isArrayB) {
            var keysA = Object.keys(a);
            var keysB = Object.keys(b);
            return (
              keysA.length === keysB.length &&
              keysA.every(function (key) {
                return looseEqual(a[key], b[key]);
              })
            );
          } else {
            /* istanbul ignore next */
            return false;
          }
        } catch (e) {
          /* istanbul ignore next */
          return false;
        }
      } else if (!isObjectA && !isObjectB) {
        return String(a) === String(b);
      } else {
        return false;
      }
    }

    /**
     * Return the first index at which a loosely equal value can be
     * found in the array (if value is a plain object, the array must
     * contain an object of the same shape), or -1 if it is not present.
     */
    function looseIndexOf(arr, val) {
      for (var i = 0; i < arr.length; i++) {
        if (looseEqual(arr[i], val)) {
          return i;
        }
      }
      return -1;
    }

    /**
     * Ensure a function is called only once.
     */
    function once(fn) {
      var called = false;
      return function () {
        if (!called) {
          called = true;
          fn.apply(this, arguments);
        }
      };
    }

    var SSR_ATTR = "data-server-rendered";

    var ASSET_TYPES = ["component", "directive", "filter"];

    var LIFECYCLE_HOOKS = [
      "beforeCreate",
      "created",
      "beforeMount",
      "mounted",
      "beforeUpdate",
      "updated",
      "beforeDestroy",
      "destroyed",
      "activated",
      "deactivated",
      "errorCaptured",
      "serverPrefetch",
    ];

    /*  */

    var config = {
      /**
       * Option merge strategies (used in core/util/options)
       */
      // $flow-disable-line
      optionMergeStrategies: Object.create(null),

      /**
       * Whether to suppress warnings.
       */
      silent: false,

      /**
       * Show production mode tip message on boot?
       */
      productionTip: "production" !== "production",

      /**
       * Whether to enable devtools
       */
      devtools: "production" !== "production",

      /**
       * Whether to record perf
       */
      performance: false,

      /**
       * Error handler for watcher errors
       */
      errorHandler: null,

      /**
       * Warn handler for watcher warns
       */
      warnHandler: null,

      /**
       * Ignore certain custom elements
       */
      ignoredElements: [],

      /**
       * Custom user key aliases for v-on
       */
      // $flow-disable-line
      keyCodes: Object.create(null),

      /**
       * Check if a tag is reserved so that it cannot be registered as a
       * component. This is platform-dependent and may be overwritten.
       */
      isReservedTag: no,

      /**
       * Check if an attribute is reserved so that it cannot be used as a component
       * prop. This is platform-dependent and may be overwritten.
       */
      isReservedAttr: no,

      /**
       * Check if a tag is an unknown element.
       * Platform-dependent.
       */
      isUnknownElement: no,

      /**
       * Get the namespace of an element
       */
      getTagNamespace: noop,

      /**
       * Parse the real tag name for the specific platform.
       */
      parsePlatformTagName: identity,

      /**
       * Check if an attribute must be bound using property, e.g. value
       * Platform-dependent.
       */
      mustUseProp: no,

      /**
       * Perform updates asynchronously. Intended to be used by Vue Test Utils
       * This will significantly reduce performance if set to false.
       */
      async: true,

      /**
       * Exposed for legacy reasons
       */
      _lifecycleHooks: LIFECYCLE_HOOKS,
    };

    /*  */

    /**
     * unicode letters used for parsing html tags, component names and property paths.
     * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
     * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
     */
    var unicodeRegExp =
      /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

    /**
     * Check if a string starts with $ or _
     */
    function isReserved(str) {
      var c = (str + "").charCodeAt(0);
      return c === 0x24 || c === 0x5f;
    }

    /**
     * Define a property.
     */
    function def(obj, key, val, enumerable) {
      Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true,
      });
    }

    /**
     * Parse simple path.
     */
    var bailRE = new RegExp("[^" + unicodeRegExp.source + ".$_\\d]");
    function parsePath(path) {
      if (bailRE.test(path)) {
        return;
      }
      var segments = path.split(".");
      return function (obj) {
        for (var i = 0; i < segments.length; i++) {
          if (!obj) {
            return;
          }
          obj = obj[segments[i]];
        }
        return obj;
      };
    }

    /*  */

    // can we use __proto__?
    var hasProto = "__proto__" in {};

    // Browser environment sniffing
    var inBrowser = typeof window !== "undefined";
    var inWeex =
      typeof WXEnvironment !== "undefined" && !!WXEnvironment.platform;
    var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
    var UA = inBrowser && window.navigator.userAgent.toLowerCase();
    var isIE = UA && /msie|trident/.test(UA);
    var isIE9 = UA && UA.indexOf("msie 9.0") > 0;
    var isEdge = UA && UA.indexOf("edge/") > 0;
    var isAndroid =
      (UA && UA.indexOf("android") > 0) || weexPlatform === "android";
    var isIOS =
      (UA && /iphone|ipad|ipod|ios/.test(UA)) || weexPlatform === "ios";
    var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
    var isPhantomJS = UA && /phantomjs/.test(UA);
    var isFF = UA && UA.match(/firefox\/(\d+)/);

    // Firefox has a "watch" function on Object.prototype...
    var nativeWatch = {}.watch;

    var supportsPassive = false;
    if (inBrowser) {
      try {
        var opts = {};
        Object.defineProperty(opts, "passive", {
          get: function get() {
            /* istanbul ignore next */
            supportsPassive = true;
          },
        }); // https://github.com/facebook/flow/issues/285
        window.addEventListener("test-passive", null, opts);
      } catch (e) {}
    }

    // this needs to be lazy-evaled because vue may be required before
    // vue-server-renderer can set VUE_ENV
    var _isServer;
    var isServerRendering = function () {
      if (_isServer === undefined) {
        /* istanbul ignore if */
        if (
          !inBrowser &&
          !inWeex &&
          typeof __webpack_require__.g !== "undefined"
        ) {
          // detect presence of vue-server-renderer and avoid
          // Webpack shimming the process
          _isServer =
            __webpack_require__.g["process"] &&
            __webpack_require__.g["process"].env.VUE_ENV === "server";
        } else {
          _isServer = false;
        }
      }
      return _isServer;
    };

    // detect devtools
    var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

    /* istanbul ignore next */
    function isNative(Ctor) {
      return typeof Ctor === "function" && /native code/.test(Ctor.toString());
    }

    var hasSymbol =
      typeof Symbol !== "undefined" &&
      isNative(Symbol) &&
      typeof Reflect !== "undefined" &&
      isNative(Reflect.ownKeys);

    var _Set;
    /* istanbul ignore if */ // $flow-disable-line
    if (typeof Set !== "undefined" && isNative(Set)) {
      // use native Set when available.
      _Set = Set;
    } else {
      // a non-standard Set polyfill that only works with primitive keys.
      _Set = /*@__PURE__*/ (function () {
        function Set() {
          this.set = Object.create(null);
        }
        Set.prototype.has = function has(key) {
          return this.set[key] === true;
        };
        Set.prototype.add = function add(key) {
          this.set[key] = true;
        };
        Set.prototype.clear = function clear() {
          this.set = Object.create(null);
        };

        return Set;
      })();
    }

    /*  */

    var warn = noop;
    var tip = /* unused pure expression or super */ null && noop;
    var generateComponentTrace =
      /* unused pure expression or super */ null && noop; // work around flow check
    var formatComponentName =
      /* unused pure expression or super */ null && noop;

    if (false) {
      var repeat, classify, classifyRE, hasConsole;
    }

    /*  */

    var uid = 0;

    /**
     * A dep is an observable that can have multiple
     * directives subscribing to it.
     */
    var Dep = function Dep() {
      this.id = uid++;
      this.subs = [];
    };

    Dep.prototype.addSub = function addSub(sub) {
      this.subs.push(sub);
    };

    Dep.prototype.removeSub = function removeSub(sub) {
      remove(this.subs, sub);
    };

    Dep.prototype.depend = function depend() {
      if (Dep.target) {
        Dep.target.addDep(this);
      }
    };

    Dep.prototype.notify = function notify() {
      // stabilize the subscriber list first
      var subs = this.subs.slice();
      if (false) {
      }
      for (var i = 0, l = subs.length; i < l; i++) {
        subs[i].update();
      }
    };

    // The current target watcher being evaluated.
    // This is globally unique because only one watcher
    // can be evaluated at a time.
    Dep.target = null;
    var targetStack = [];

    function pushTarget(target) {
      targetStack.push(target);
      Dep.target = target;
    }

    function popTarget() {
      targetStack.pop();
      Dep.target = targetStack[targetStack.length - 1];
    }

    /*  */

    var VNode = function VNode(
      tag,
      data,
      children,
      text,
      elm,
      context,
      componentOptions,
      asyncFactory
    ) {
      this.tag = tag;
      this.data = data;
      this.children = children;
      this.text = text;
      this.elm = elm;
      this.ns = undefined;
      this.context = context;
      this.fnContext = undefined;
      this.fnOptions = undefined;
      this.fnScopeId = undefined;
      this.key = data && data.key;
      this.componentOptions = componentOptions;
      this.componentInstance = undefined;
      this.parent = undefined;
      this.raw = false;
      this.isStatic = false;
      this.isRootInsert = true;
      this.isComment = false;
      this.isCloned = false;
      this.isOnce = false;
      this.asyncFactory = asyncFactory;
      this.asyncMeta = undefined;
      this.isAsyncPlaceholder = false;
    };

    var prototypeAccessors = { child: { configurable: true } };

    // DEPRECATED: alias for componentInstance for backwards compat.
    /* istanbul ignore next */
    prototypeAccessors.child.get = function () {
      return this.componentInstance;
    };

    Object.defineProperties(VNode.prototype, prototypeAccessors);

    var createEmptyVNode = function (text) {
      if (text === void 0) text = "";

      var node = new VNode();
      node.text = text;
      node.isComment = true;
      return node;
    };

    function createTextVNode(val) {
      return new VNode(undefined, undefined, undefined, String(val));
    }

    // optimized shallow clone
    // used for static nodes and slot nodes because they may be reused across
    // multiple renders, cloning them avoids errors when DOM manipulations rely
    // on their elm reference.
    function cloneVNode(vnode) {
      var cloned = new VNode(
        vnode.tag,
        vnode.data,
        // #7975
        // clone children array to avoid mutating original in case of cloning
        // a child.
        vnode.children && vnode.children.slice(),
        vnode.text,
        vnode.elm,
        vnode.context,
        vnode.componentOptions,
        vnode.asyncFactory
      );
      cloned.ns = vnode.ns;
      cloned.isStatic = vnode.isStatic;
      cloned.key = vnode.key;
      cloned.isComment = vnode.isComment;
      cloned.fnContext = vnode.fnContext;
      cloned.fnOptions = vnode.fnOptions;
      cloned.fnScopeId = vnode.fnScopeId;
      cloned.asyncMeta = vnode.asyncMeta;
      cloned.isCloned = true;
      return cloned;
    }

    /*
     * not type checking this file because flow doesn't play well with
     * dynamically accessing methods on Array prototype
     */

    var arrayProto = Array.prototype;
    var arrayMethods = Object.create(arrayProto);

    var methodsToPatch = [
      "push",
      "pop",
      "shift",
      "unshift",
      "splice",
      "sort",
      "reverse",
    ];

    /**
     * Intercept mutating methods and emit events
     */
    methodsToPatch.forEach(function (method) {
      // cache original method
      var original = arrayProto[method];
      def(arrayMethods, method, function mutator() {
        var args = [],
          len = arguments.length;
        while (len--) args[len] = arguments[len];

        var result = original.apply(this, args);
        var ob = this.__ob__;
        var inserted;
        switch (method) {
          case "push":
          case "unshift":
            inserted = args;
            break;
          case "splice":
            inserted = args.slice(2);
            break;
        }
        if (inserted) {
          ob.observeArray(inserted);
        }
        // notify change
        ob.dep.notify();
        return result;
      });
    });

    /*  */

    var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

    /**
     * In some cases we may want to disable observation inside a component's
     * update computation.
     */
    var shouldObserve = true;

    function toggleObserving(value) {
      shouldObserve = value;
    }

    /**
     * Observer class that is attached to each observed
     * object. Once attached, the observer converts the target
     * object's property keys into getter/setters that
     * collect dependencies and dispatch updates.
     */
    var Observer = function Observer(value) {
      this.value = value;
      this.dep = new Dep();
      this.vmCount = 0;
      def(value, "__ob__", this);
      if (Array.isArray(value)) {
        if (hasProto) {
          protoAugment(value, arrayMethods);
        } else {
          copyAugment(value, arrayMethods, arrayKeys);
        }
        this.observeArray(value);
      } else {
        this.walk(value);
      }
    };

    /**
     * Walk through all properties and convert them into
     * getter/setters. This method should only be called when
     * value type is Object.
     */
    Observer.prototype.walk = function walk(obj) {
      var keys = Object.keys(obj);
      for (var i = 0; i < keys.length; i++) {
        defineReactive$$1(obj, keys[i]);
      }
    };

    /**
     * Observe a list of Array items.
     */
    Observer.prototype.observeArray = function observeArray(items) {
      for (var i = 0, l = items.length; i < l; i++) {
        observe(items[i]);
      }
    };

    // helpers

    /**
     * Augment a target Object or Array by intercepting
     * the prototype chain using __proto__
     */
    function protoAugment(target, src) {
      /* eslint-disable no-proto */
      target.__proto__ = src;
      /* eslint-enable no-proto */
    }

    /**
     * Augment a target Object or Array by defining
     * hidden properties.
     */
    /* istanbul ignore next */
    function copyAugment(target, src, keys) {
      for (var i = 0, l = keys.length; i < l; i++) {
        var key = keys[i];
        def(target, key, src[key]);
      }
    }

    /**
     * Attempt to create an observer instance for a value,
     * returns the new observer if successfully observed,
     * or the existing observer if the value already has one.
     */
    function observe(value, asRootData) {
      if (!isObject(value) || value instanceof VNode) {
        return;
      }
      var ob;
      if (hasOwn(value, "__ob__") && value.__ob__ instanceof Observer) {
        ob = value.__ob__;
      } else if (
        shouldObserve &&
        !isServerRendering() &&
        (Array.isArray(value) || isPlainObject(value)) &&
        Object.isExtensible(value) &&
        !value._isVue
      ) {
        ob = new Observer(value);
      }
      if (asRootData && ob) {
        ob.vmCount++;
      }
      return ob;
    }

    /**
     * Define a reactive property on an Object.
     */
    function defineReactive$$1(obj, key, val, customSetter, shallow) {
      var dep = new Dep();

      var property = Object.getOwnPropertyDescriptor(obj, key);
      if (property && property.configurable === false) {
        return;
      }

      // cater for pre-defined getter/setters
      var getter = property && property.get;
      var setter = property && property.set;
      if ((!getter || setter) && arguments.length === 2) {
        val = obj[key];
      }

      var childOb = !shallow && observe(val);
      Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: function reactiveGetter() {
          var value = getter ? getter.call(obj) : val;
          if (Dep.target) {
            dep.depend();
            if (childOb) {
              childOb.dep.depend();
              if (Array.isArray(value)) {
                dependArray(value);
              }
            }
          }
          return value;
        },
        set: function reactiveSetter(newVal) {
          var value = getter ? getter.call(obj) : val;
          /* eslint-disable no-self-compare */
          if (newVal === value || (newVal !== newVal && value !== value)) {
            return;
          }
          /* eslint-enable no-self-compare */
          if (false) {
          }
          // #7981: for accessor properties without setter
          if (getter && !setter) {
            return;
          }
          if (setter) {
            setter.call(obj, newVal);
          } else {
            val = newVal;
          }
          childOb = !shallow && observe(newVal);
          dep.notify();
        },
      });
    }

    /**
     * Set a property on an object. Adds the new property and
     * triggers change notification if the property doesn't
     * already exist.
     */
    function set(target, key, val) {
      if (false) {
      }
      if (Array.isArray(target) && isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
      }
      if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
      }
      var ob = target.__ob__;
      if (target._isVue || (ob && ob.vmCount)) {
        false && 0;
        return val;
      }
      if (!ob) {
        target[key] = val;
        return val;
      }
      defineReactive$$1(ob.value, key, val);
      ob.dep.notify();
      return val;
    }

    /**
     * Delete a property and trigger change if necessary.
     */
    function del(target, key) {
      if (false) {
      }
      if (Array.isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
      }
      var ob = target.__ob__;
      if (target._isVue || (ob && ob.vmCount)) {
        false && 0;
        return;
      }
      if (!hasOwn(target, key)) {
        return;
      }
      delete target[key];
      if (!ob) {
        return;
      }
      ob.dep.notify();
    }

    /**
     * Collect dependencies on array elements when the array is touched, since
     * we cannot intercept array element access like property getters.
     */
    function dependArray(value) {
      for (var e = void 0, i = 0, l = value.length; i < l; i++) {
        e = value[i];
        e && e.__ob__ && e.__ob__.dep.depend();
        if (Array.isArray(e)) {
          dependArray(e);
        }
      }
    }

    /*  */

    /**
     * Option overwriting strategies are functions that handle
     * how to merge a parent option value and a child option
     * value into the final value.
     */
    var strats = config.optionMergeStrategies;

    /**
     * Options with restrictions
     */
    if (false) {
    }

    /**
     * Helper that recursively merges two data objects together.
     */
    function mergeData(to, from) {
      if (!from) {
        return to;
      }
      var key, toVal, fromVal;

      var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);

      for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === "__ob__") {
          continue;
        }
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
          set(to, key, fromVal);
        } else if (
          toVal !== fromVal &&
          isPlainObject(toVal) &&
          isPlainObject(fromVal)
        ) {
          mergeData(toVal, fromVal);
        }
      }
      return to;
    }

    /**
     * Data
     */
    function mergeDataOrFn(parentVal, childVal, vm) {
      if (!vm) {
        // in a Vue.extend merge, both should be functions
        if (!childVal) {
          return parentVal;
        }
        if (!parentVal) {
          return childVal;
        }
        // when parentVal & childVal are both present,
        // we need to return a function that returns the
        // merged result of both functions... no need to
        // check if parentVal is a function here because
        // it has to be a function to pass previous merges.
        return function mergedDataFn() {
          return mergeData(
            typeof childVal === "function"
              ? childVal.call(this, this)
              : childVal,
            typeof parentVal === "function"
              ? parentVal.call(this, this)
              : parentVal
          );
        };
      } else {
        return function mergedInstanceDataFn() {
          // instance merge
          var instanceData =
            typeof childVal === "function" ? childVal.call(vm, vm) : childVal;
          var defaultData =
            typeof parentVal === "function"
              ? parentVal.call(vm, vm)
              : parentVal;
          if (instanceData) {
            return mergeData(instanceData, defaultData);
          } else {
            return defaultData;
          }
        };
      }
    }

    strats.data = function (parentVal, childVal, vm) {
      if (!vm) {
        if (childVal && typeof childVal !== "function") {
          false && 0;

          return parentVal;
        }
        return mergeDataOrFn(parentVal, childVal);
      }

      return mergeDataOrFn(parentVal, childVal, vm);
    };

    /**
     * Hooks and props are merged as arrays.
     */
    function mergeHook(parentVal, childVal) {
      var res = childVal
        ? parentVal
          ? parentVal.concat(childVal)
          : Array.isArray(childVal)
          ? childVal
          : [childVal]
        : parentVal;
      return res ? dedupeHooks(res) : res;
    }

    function dedupeHooks(hooks) {
      var res = [];
      for (var i = 0; i < hooks.length; i++) {
        if (res.indexOf(hooks[i]) === -1) {
          res.push(hooks[i]);
        }
      }
      return res;
    }

    LIFECYCLE_HOOKS.forEach(function (hook) {
      strats[hook] = mergeHook;
    });

    /**
     * Assets
     *
     * When a vm is present (instance creation), we need to do
     * a three-way merge between constructor options, instance
     * options and parent options.
     */
    function mergeAssets(parentVal, childVal, vm, key) {
      var res = Object.create(parentVal || null);
      if (childVal) {
        false && 0;
        return extend(res, childVal);
      } else {
        return res;
      }
    }

    ASSET_TYPES.forEach(function (type) {
      strats[type + "s"] = mergeAssets;
    });

    /**
     * Watchers.
     *
     * Watchers hashes should not overwrite one
     * another, so we merge them as arrays.
     */
    strats.watch = function (parentVal, childVal, vm, key) {
      // work around Firefox's Object.prototype.watch...
      if (parentVal === nativeWatch) {
        parentVal = undefined;
      }
      if (childVal === nativeWatch) {
        childVal = undefined;
      }
      /* istanbul ignore if */
      if (!childVal) {
        return Object.create(parentVal || null);
      }
      if (false) {
      }
      if (!parentVal) {
        return childVal;
      }
      var ret = {};
      extend(ret, parentVal);
      for (var key$1 in childVal) {
        var parent = ret[key$1];
        var child = childVal[key$1];
        if (parent && !Array.isArray(parent)) {
          parent = [parent];
        }
        ret[key$1] = parent
          ? parent.concat(child)
          : Array.isArray(child)
          ? child
          : [child];
      }
      return ret;
    };

    /**
     * Other object hashes.
     */
    strats.props =
      strats.methods =
      strats.inject =
      strats.computed =
        function (parentVal, childVal, vm, key) {
          if (childVal && "production" !== "production") {
            assertObjectType(key, childVal, vm);
          }
          if (!parentVal) {
            return childVal;
          }
          var ret = Object.create(null);
          extend(ret, parentVal);
          if (childVal) {
            extend(ret, childVal);
          }
          return ret;
        };
    strats.provide = mergeDataOrFn;

    /**
     * Default strategy.
     */
    var defaultStrat = function (parentVal, childVal) {
      return childVal === undefined ? parentVal : childVal;
    };

    /**
     * Validate component names
     */
    function checkComponents(options) {
      for (var key in options.components) {
        validateComponentName(key);
      }
    }

    function validateComponentName(name) {
      if (
        !new RegExp("^[a-zA-Z][\\-\\.0-9_" + unicodeRegExp.source + "]*$").test(
          name
        )
      ) {
        warn(
          'Invalid component name: "' +
            name +
            '". Component names ' +
            "should conform to valid custom element name in html5 specification."
        );
      }
      if (isBuiltInTag(name) || config.isReservedTag(name)) {
        warn(
          "Do not use built-in or reserved HTML elements as component " +
            "id: " +
            name
        );
      }
    }

    /**
     * Ensure all props option syntax are normalized into the
     * Object-based format.
     */
    function normalizeProps(options, vm) {
      var props = options.props;
      if (!props) {
        return;
      }
      var res = {};
      var i, val, name;
      if (Array.isArray(props)) {
        i = props.length;
        while (i--) {
          val = props[i];
          if (typeof val === "string") {
            name = camelize(val);
            res[name] = { type: null };
          } else if (false) {
          }
        }
      } else if (isPlainObject(props)) {
        for (var key in props) {
          val = props[key];
          name = camelize(key);
          res[name] = isPlainObject(val) ? val : { type: val };
        }
      } else if (false) {
      }
      options.props = res;
    }

    /**
     * Normalize all injections into Object-based format
     */
    function normalizeInject(options, vm) {
      var inject = options.inject;
      if (!inject) {
        return;
      }
      var normalized = (options.inject = {});
      if (Array.isArray(inject)) {
        for (var i = 0; i < inject.length; i++) {
          normalized[inject[i]] = { from: inject[i] };
        }
      } else if (isPlainObject(inject)) {
        for (var key in inject) {
          var val = inject[key];
          normalized[key] = isPlainObject(val)
            ? extend({ from: key }, val)
            : { from: val };
        }
      } else if (false) {
      }
    }

    /**
     * Normalize raw function directives into object format.
     */
    function normalizeDirectives(options) {
      var dirs = options.directives;
      if (dirs) {
        for (var key in dirs) {
          var def$$1 = dirs[key];
          if (typeof def$$1 === "function") {
            dirs[key] = { bind: def$$1, update: def$$1 };
          }
        }
      }
    }

    function assertObjectType(name, value, vm) {
      if (!isPlainObject(value)) {
        warn(
          'Invalid value for option "' +
            name +
            '": expected an Object, ' +
            "but got " +
            toRawType(value) +
            ".",
          vm
        );
      }
    }

    /**
     * Merge two option objects into a new one.
     * Core utility used in both instantiation and inheritance.
     */
    function mergeOptions(parent, child, vm) {
      if (false) {
      }

      if (typeof child === "function") {
        child = child.options;
      }

      normalizeProps(child, vm);
      normalizeInject(child, vm);
      normalizeDirectives(child);

      // Apply extends and mixins on the child options,
      // but only if it is a raw options object that isn't
      // the result of another mergeOptions call.
      // Only merged options has the _base property.
      if (!child._base) {
        if (child.extends) {
          parent = mergeOptions(parent, child.extends, vm);
        }
        if (child.mixins) {
          for (var i = 0, l = child.mixins.length; i < l; i++) {
            parent = mergeOptions(parent, child.mixins[i], vm);
          }
        }
      }

      var options = {};
      var key;
      for (key in parent) {
        mergeField(key);
      }
      for (key in child) {
        if (!hasOwn(parent, key)) {
          mergeField(key);
        }
      }
      function mergeField(key) {
        var strat = strats[key] || defaultStrat;
        options[key] = strat(parent[key], child[key], vm, key);
      }
      return options;
    }

    /**
     * Resolve an asset.
     * This function is used because child instances need access
     * to assets defined in its ancestor chain.
     */
    function resolveAsset(options, type, id, warnMissing) {
      /* istanbul ignore if */
      if (typeof id !== "string") {
        return;
      }
      var assets = options[type];
      // check local registration variations first
      if (hasOwn(assets, id)) {
        return assets[id];
      }
      var camelizedId = camelize(id);
      if (hasOwn(assets, camelizedId)) {
        return assets[camelizedId];
      }
      var PascalCaseId = capitalize(camelizedId);
      if (hasOwn(assets, PascalCaseId)) {
        return assets[PascalCaseId];
      }
      // fallback to prototype chain
      var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
      if (false) {
      }
      return res;
    }

    /*  */

    function validateProp(key, propOptions, propsData, vm) {
      var prop = propOptions[key];
      var absent = !hasOwn(propsData, key);
      var value = propsData[key];
      // boolean casting
      var booleanIndex = getTypeIndex(Boolean, prop.type);
      if (booleanIndex > -1) {
        if (absent && !hasOwn(prop, "default")) {
          value = false;
        } else if (value === "" || value === hyphenate(key)) {
          // only cast empty string / same name to boolean if
          // boolean has higher priority
          var stringIndex = getTypeIndex(String, prop.type);
          if (stringIndex < 0 || booleanIndex < stringIndex) {
            value = true;
          }
        }
      }
      // check default value
      if (value === undefined) {
        value = getPropDefaultValue(vm, prop, key);
        // since the default value is a fresh copy,
        // make sure to observe it.
        var prevShouldObserve = shouldObserve;
        toggleObserving(true);
        observe(value);
        toggleObserving(prevShouldObserve);
      }
      if (false) {
      }
      return value;
    }

    /**
     * Get the default value of a prop.
     */
    function getPropDefaultValue(vm, prop, key) {
      // no default, return undefined
      if (!hasOwn(prop, "default")) {
        return undefined;
      }
      var def = prop.default;
      // warn against non-factory defaults for Object & Array
      if (false) {
      }
      // the raw prop value was also undefined from previous render,
      // return previous default value to avoid unnecessary watcher trigger
      if (
        vm &&
        vm.$options.propsData &&
        vm.$options.propsData[key] === undefined &&
        vm._props[key] !== undefined
      ) {
        return vm._props[key];
      }
      // call factory function for non-Function types
      // a value is Function if its prototype is function even across different execution context
      return typeof def === "function" && getType(prop.type) !== "Function"
        ? def.call(vm)
        : def;
    }

    /**
     * Assert whether a prop is valid.
     */
    function assertProp(prop, name, value, vm, absent) {
      if (prop.required && absent) {
        warn('Missing required prop: "' + name + '"', vm);
        return;
      }
      if (value == null && !prop.required) {
        return;
      }
      var type = prop.type;
      var valid = !type || type === true;
      var expectedTypes = [];
      if (type) {
        if (!Array.isArray(type)) {
          type = [type];
        }
        for (var i = 0; i < type.length && !valid; i++) {
          var assertedType = assertType(value, type[i], vm);
          expectedTypes.push(assertedType.expectedType || "");
          valid = assertedType.valid;
        }
      }

      var haveExpectedTypes = expectedTypes.some(function (t) {
        return t;
      });
      if (!valid && haveExpectedTypes) {
        warn(getInvalidTypeMessage(name, value, expectedTypes), vm);
        return;
      }
      var validator = prop.validator;
      if (validator) {
        if (!validator(value)) {
          warn(
            'Invalid prop: custom validator check failed for prop "' +
              name +
              '".',
            vm
          );
        }
      }
    }

    var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

    function assertType(value, type, vm) {
      var valid;
      var expectedType = getType(type);
      if (simpleCheckRE.test(expectedType)) {
        var t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === "object") {
          valid = value instanceof type;
        }
      } else if (expectedType === "Object") {
        valid = isPlainObject(value);
      } else if (expectedType === "Array") {
        valid = Array.isArray(value);
      } else {
        try {
          valid = value instanceof type;
        } catch (e) {
          warn(
            'Invalid prop type: "' + String(type) + '" is not a constructor',
            vm
          );
          valid = false;
        }
      }
      return {
        valid: valid,
        expectedType: expectedType,
      };
    }

    var functionTypeCheckRE = /^\s*function (\w+)/;

    /**
     * Use function string name to check built-in types,
     * because a simple equality check will fail when running
     * across different vms / iframes.
     */
    function getType(fn) {
      var match = fn && fn.toString().match(functionTypeCheckRE);
      return match ? match[1] : "";
    }

    function isSameType(a, b) {
      return getType(a) === getType(b);
    }

    function getTypeIndex(type, expectedTypes) {
      if (!Array.isArray(expectedTypes)) {
        return isSameType(expectedTypes, type) ? 0 : -1;
      }
      for (var i = 0, len = expectedTypes.length; i < len; i++) {
        if (isSameType(expectedTypes[i], type)) {
          return i;
        }
      }
      return -1;
    }

    function getInvalidTypeMessage(name, value, expectedTypes) {
      var message =
        'Invalid prop: type check failed for prop "' +
        name +
        '".' +
        " Expected " +
        expectedTypes.map(capitalize).join(", ");
      var expectedType = expectedTypes[0];
      var receivedType = toRawType(value);
      // check if we need to specify expected value
      if (
        expectedTypes.length === 1 &&
        isExplicable(expectedType) &&
        isExplicable(typeof value) &&
        !isBoolean(expectedType, receivedType)
      ) {
        message += " with value " + styleValue(value, expectedType);
      }
      message += ", got " + receivedType + " ";
      // check if we need to specify received value
      if (isExplicable(receivedType)) {
        message += "with value " + styleValue(value, receivedType) + ".";
      }
      return message;
    }

    function styleValue(value, type) {
      if (type === "String") {
        return '"' + value + '"';
      } else if (type === "Number") {
        return "" + Number(value);
      } else {
        return "" + value;
      }
    }

    var EXPLICABLE_TYPES = /* unused pure expression or super */ null && [
      "string",
      "number",
      "boolean",
    ];
    function isExplicable(value) {
      return EXPLICABLE_TYPES.some(function (elem) {
        return value.toLowerCase() === elem;
      });
    }

    function isBoolean() {
      var args = [],
        len = arguments.length;
      while (len--) args[len] = arguments[len];

      return args.some(function (elem) {
        return elem.toLowerCase() === "boolean";
      });
    }

    /*  */

    function handleError(err, vm, info) {
      // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
      // See: https://github.com/vuejs/vuex/issues/1505
      pushTarget();
      try {
        if (vm) {
          var cur = vm;
          while ((cur = cur.$parent)) {
            var hooks = cur.$options.errorCaptured;
            if (hooks) {
              for (var i = 0; i < hooks.length; i++) {
                try {
                  var capture = hooks[i].call(cur, err, vm, info) === false;
                  if (capture) {
                    return;
                  }
                } catch (e) {
                  globalHandleError(e, cur, "errorCaptured hook");
                }
              }
            }
          }
        }
        globalHandleError(err, vm, info);
      } finally {
        popTarget();
      }
    }

    function invokeWithErrorHandling(handler, context, args, vm, info) {
      var res;
      try {
        res = args ? handler.apply(context, args) : handler.call(context);
        if (res && !res._isVue && isPromise(res) && !res._handled) {
          res.catch(function (e) {
            return handleError(e, vm, info + " (Promise/async)");
          });
          // issue #9511
          // avoid catch triggering multiple times when nested calls
          res._handled = true;
        }
      } catch (e) {
        handleError(e, vm, info);
      }
      return res;
    }

    function globalHandleError(err, vm, info) {
      if (config.errorHandler) {
        try {
          return config.errorHandler.call(null, err, vm, info);
        } catch (e) {
          // if the user intentionally throws the original error in the handler,
          // do not log it twice
          if (e !== err) {
            logError(e, null, "config.errorHandler");
          }
        }
      }
      logError(err, vm, info);
    }

    function logError(err, vm, info) {
      if (false) {
      }
      /* istanbul ignore else */
      if ((inBrowser || inWeex) && typeof console !== "undefined") {
        console.error(err);
      } else {
        throw err;
      }
    }

    /*  */

    var isUsingMicroTask = false;

    var callbacks = [];
    var pending = false;

    function flushCallbacks() {
      pending = false;
      var copies = callbacks.slice(0);
      callbacks.length = 0;
      for (var i = 0; i < copies.length; i++) {
        copies[i]();
      }
    }

    // Here we have async deferring wrappers using microtasks.
    // In 2.5 we used (macro) tasks (in combination with microtasks).
    // However, it has subtle problems when state is changed right before repaint
    // (e.g. #6813, out-in transitions).
    // Also, using (macro) tasks in event handler would cause some weird behaviors
    // that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
    // So we now use microtasks everywhere, again.
    // A major drawback of this tradeoff is that there are some scenarios
    // where microtasks have too high a priority and fire in between supposedly
    // sequential events (e.g. #4521, #6690, which have workarounds)
    // or even between bubbling of the same event (#6566).
    var timerFunc;

    // The nextTick behavior leverages the microtask queue, which can be accessed
    // via either native Promise.then or MutationObserver.
    // MutationObserver has wider support, however it is seriously bugged in
    // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
    // completely stops working after triggering a few times... so, if native
    // Promise is available, we will use it:
    /* istanbul ignore next, $flow-disable-line */
    if (typeof Promise !== "undefined" && isNative(Promise)) {
      var p = Promise.resolve();
      timerFunc = function () {
        p.then(flushCallbacks);
        // In problematic UIWebViews, Promise.then doesn't completely break, but
        // it can get stuck in a weird state where callbacks are pushed into the
        // microtask queue but the queue isn't being flushed, until the browser
        // needs to do some other work, e.g. handle a timer. Therefore we can
        // "force" the microtask queue to be flushed by adding an empty timer.
        if (isIOS) {
          setTimeout(noop);
        }
      };
      isUsingMicroTask = true;
    } else if (
      !isIE &&
      typeof MutationObserver !== "undefined" &&
      (isNative(MutationObserver) ||
        // PhantomJS and iOS 7.x
        MutationObserver.toString() === "[object MutationObserverConstructor]")
    ) {
      // Use MutationObserver where native Promise is not available,
      // e.g. PhantomJS, iOS7, Android 4.4
      // (#6466 MutationObserver is unreliable in IE11)
      var counter = 1;
      var observer = new MutationObserver(flushCallbacks);
      var textNode = document.createTextNode(String(counter));
      observer.observe(textNode, {
        characterData: true,
      });
      timerFunc = function () {
        counter = (counter + 1) % 2;
        textNode.data = String(counter);
      };
      isUsingMicroTask = true;
    } else if (typeof setImmediate !== "undefined" && isNative(setImmediate)) {
      // Fallback to setImmediate.
      // Technically it leverages the (macro) task queue,
      // but it is still a better choice than setTimeout.
      timerFunc = function () {
        setImmediate(flushCallbacks);
      };
    } else {
      // Fallback to setTimeout.
      timerFunc = function () {
        setTimeout(flushCallbacks, 0);
      };
    }

    function nextTick(cb, ctx) {
      var _resolve;
      callbacks.push(function () {
        if (cb) {
          try {
            cb.call(ctx);
          } catch (e) {
            handleError(e, ctx, "nextTick");
          }
        } else if (_resolve) {
          _resolve(ctx);
        }
      });
      if (!pending) {
        pending = true;
        timerFunc();
      }
      // $flow-disable-line
      if (!cb && typeof Promise !== "undefined") {
        return new Promise(function (resolve) {
          _resolve = resolve;
        });
      }
    }

    /*  */

    /* not type checking this file because flow doesn't play well with Proxy */

    var initProxy;

    if (false) {
      var getHandler,
        hasHandler,
        isBuiltInModifier,
        hasProxy,
        warnReservedPrefix,
        warnNonPresent,
        allowedGlobals;
    }

    /*  */

    var seenObjects = new _Set();

    /**
     * Recursively traverse an object to evoke all converted
     * getters, so that every nested property inside the object
     * is collected as a "deep" dependency.
     */
    function traverse(val) {
      _traverse(val, seenObjects);
      seenObjects.clear();
    }

    function _traverse(val, seen) {
      var i, keys;
      var isA = Array.isArray(val);
      if (
        (!isA && !isObject(val)) ||
        Object.isFrozen(val) ||
        val instanceof VNode
      ) {
        return;
      }
      if (val.__ob__) {
        var depId = val.__ob__.dep.id;
        if (seen.has(depId)) {
          return;
        }
        seen.add(depId);
      }
      if (isA) {
        i = val.length;
        while (i--) {
          _traverse(val[i], seen);
        }
      } else {
        keys = Object.keys(val);
        i = keys.length;
        while (i--) {
          _traverse(val[keys[i]], seen);
        }
      }
    }

    var mark;
    var measure;

    if (false) {
      var perf;
    }

    /*  */

    var normalizeEvent = cached(function (name) {
      var passive = name.charAt(0) === "&";
      name = passive ? name.slice(1) : name;
      var once$$1 = name.charAt(0) === "~"; // Prefixed last, checked first
      name = once$$1 ? name.slice(1) : name;
      var capture = name.charAt(0) === "!";
      name = capture ? name.slice(1) : name;
      return {
        name: name,
        once: once$$1,
        capture: capture,
        passive: passive,
      };
    });

    function createFnInvoker(fns, vm) {
      function invoker() {
        var arguments$1 = arguments;

        var fns = invoker.fns;
        if (Array.isArray(fns)) {
          var cloned = fns.slice();
          for (var i = 0; i < cloned.length; i++) {
            invokeWithErrorHandling(
              cloned[i],
              null,
              arguments$1,
              vm,
              "v-on handler"
            );
          }
        } else {
          // return handler return value for single handlers
          return invokeWithErrorHandling(
            fns,
            null,
            arguments,
            vm,
            "v-on handler"
          );
        }
      }
      invoker.fns = fns;
      return invoker;
    }

    function updateListeners(on, oldOn, add, remove$$1, createOnceHandler, vm) {
      var name, def$$1, cur, old, event;
      for (name in on) {
        def$$1 = cur = on[name];
        old = oldOn[name];
        event = normalizeEvent(name);
        if (isUndef(cur)) {
          false && 0;
        } else if (isUndef(old)) {
          if (isUndef(cur.fns)) {
            cur = on[name] = createFnInvoker(cur, vm);
          }
          if (isTrue(event.once)) {
            cur = on[name] = createOnceHandler(event.name, cur, event.capture);
          }
          add(event.name, cur, event.capture, event.passive, event.params);
        } else if (cur !== old) {
          old.fns = cur;
          on[name] = old;
        }
      }
      for (name in oldOn) {
        if (isUndef(on[name])) {
          event = normalizeEvent(name);
          remove$$1(event.name, oldOn[name], event.capture);
        }
      }
    }

    /*  */

    function mergeVNodeHook(def, hookKey, hook) {
      if (def instanceof VNode) {
        def = def.data.hook || (def.data.hook = {});
      }
      var invoker;
      var oldHook = def[hookKey];

      function wrappedHook() {
        hook.apply(this, arguments);
        // important: remove merged hook to ensure it's called only once
        // and prevent memory leak
        remove(invoker.fns, wrappedHook);
      }

      if (isUndef(oldHook)) {
        // no existing hook
        invoker = createFnInvoker([wrappedHook]);
      } else {
        /* istanbul ignore if */
        if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
          // already a merged invoker
          invoker = oldHook;
          invoker.fns.push(wrappedHook);
        } else {
          // existing plain hook
          invoker = createFnInvoker([oldHook, wrappedHook]);
        }
      }

      invoker.merged = true;
      def[hookKey] = invoker;
    }

    /*  */

    function extractPropsFromVNodeData(data, Ctor, tag) {
      // we are only extracting raw values here.
      // validation and default values are handled in the child
      // component itself.
      var propOptions = Ctor.options.props;
      if (isUndef(propOptions)) {
        return;
      }
      var res = {};
      var attrs = data.attrs;
      var props = data.props;
      if (isDef(attrs) || isDef(props)) {
        for (var key in propOptions) {
          var altKey = hyphenate(key);
          if (false) {
            var keyInLowerCase;
          }
          checkProp(res, props, key, altKey, true) ||
            checkProp(res, attrs, key, altKey, false);
        }
      }
      return res;
    }

    function checkProp(res, hash, key, altKey, preserve) {
      if (isDef(hash)) {
        if (hasOwn(hash, key)) {
          res[key] = hash[key];
          if (!preserve) {
            delete hash[key];
          }
          return true;
        } else if (hasOwn(hash, altKey)) {
          res[key] = hash[altKey];
          if (!preserve) {
            delete hash[altKey];
          }
          return true;
        }
      }
      return false;
    }

    /*  */

    // The template compiler attempts to minimize the need for normalization by
    // statically analyzing the template at compile time.
    //
    // For plain HTML markup, normalization can be completely skipped because the
    // generated render function is guaranteed to return Array<VNode>. There are
    // two cases where extra normalization is needed:

    // 1. When the children contains components - because a functional component
    // may return an Array instead of a single root. In this case, just a simple
    // normalization is needed - if any child is an Array, we flatten the whole
    // thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
    // because functional components already normalize their own children.
    function simpleNormalizeChildren(children) {
      for (var i = 0; i < children.length; i++) {
        if (Array.isArray(children[i])) {
          return Array.prototype.concat.apply([], children);
        }
      }
      return children;
    }

    // 2. When the children contains constructs that always generated nested Arrays,
    // e.g. <template>, <slot>, v-for, or when the children is provided by user
    // with hand-written render functions / JSX. In such cases a full normalization
    // is needed to cater to all possible types of children values.
    function normalizeChildren(children) {
      return isPrimitive(children)
        ? [createTextVNode(children)]
        : Array.isArray(children)
        ? normalizeArrayChildren(children)
        : undefined;
    }

    function isTextNode(node) {
      return isDef(node) && isDef(node.text) && isFalse(node.isComment);
    }

    function normalizeArrayChildren(children, nestedIndex) {
      var res = [];
      var i, c, lastIndex, last;
      for (i = 0; i < children.length; i++) {
        c = children[i];
        if (isUndef(c) || typeof c === "boolean") {
          continue;
        }
        lastIndex = res.length - 1;
        last = res[lastIndex];
        //  nested
        if (Array.isArray(c)) {
          if (c.length > 0) {
            c = normalizeArrayChildren(c, (nestedIndex || "") + "_" + i);
            // merge adjacent text nodes
            if (isTextNode(c[0]) && isTextNode(last)) {
              res[lastIndex] = createTextVNode(last.text + c[0].text);
              c.shift();
            }
            res.push.apply(res, c);
          }
        } else if (isPrimitive(c)) {
          if (isTextNode(last)) {
            // merge adjacent text nodes
            // this is necessary for SSR hydration because text nodes are
            // essentially merged when rendered to HTML strings
            res[lastIndex] = createTextVNode(last.text + c);
          } else if (c !== "") {
            // convert primitive to vnode
            res.push(createTextVNode(c));
          }
        } else {
          if (isTextNode(c) && isTextNode(last)) {
            // merge adjacent text nodes
            res[lastIndex] = createTextVNode(last.text + c.text);
          } else {
            // default key for nested array children (likely generated by v-for)
            if (
              isTrue(children._isVList) &&
              isDef(c.tag) &&
              isUndef(c.key) &&
              isDef(nestedIndex)
            ) {
              c.key = "__vlist" + nestedIndex + "_" + i + "__";
            }
            res.push(c);
          }
        }
      }
      return res;
    }

    /*  */

    function initProvide(vm) {
      var provide = vm.$options.provide;
      if (provide) {
        vm._provided =
          typeof provide === "function" ? provide.call(vm) : provide;
      }
    }

    function initInjections(vm) {
      var result = resolveInject(vm.$options.inject, vm);
      if (result) {
        toggleObserving(false);
        Object.keys(result).forEach(function (key) {
          /* istanbul ignore else */
          if (false) {
          } else {
            defineReactive$$1(vm, key, result[key]);
          }
        });
        toggleObserving(true);
      }
    }

    function resolveInject(inject, vm) {
      if (inject) {
        // inject is :any because flow is not smart enough to figure out cached
        var result = Object.create(null);
        var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);

        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          // #6574 in case the inject object is observed...
          if (key === "__ob__") {
            continue;
          }
          var provideKey = inject[key].from;
          var source = vm;
          while (source) {
            if (source._provided && hasOwn(source._provided, provideKey)) {
              result[key] = source._provided[provideKey];
              break;
            }
            source = source.$parent;
          }
          if (!source) {
            if ("default" in inject[key]) {
              var provideDefault = inject[key].default;
              result[key] =
                typeof provideDefault === "function"
                  ? provideDefault.call(vm)
                  : provideDefault;
            } else if (false) {
            }
          }
        }
        return result;
      }
    }

    /*  */

    /**
     * Runtime helper for resolving raw children VNodes into a slot object.
     */
    function resolveSlots(children, context) {
      if (!children || !children.length) {
        return {};
      }
      var slots = {};
      for (var i = 0, l = children.length; i < l; i++) {
        var child = children[i];
        var data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) {
          delete data.attrs.slot;
        }
        // named slots should only be respected if the vnode was rendered in the
        // same context.
        if (
          (child.context === context || child.fnContext === context) &&
          data &&
          data.slot != null
        ) {
          var name = data.slot;
          var slot = slots[name] || (slots[name] = []);
          if (child.tag === "template") {
            slot.push.apply(slot, child.children || []);
          } else {
            slot.push(child);
          }
        } else {
          (slots.default || (slots.default = [])).push(child);
        }
      }
      // ignore slots that contains only whitespace
      for (var name$1 in slots) {
        if (slots[name$1].every(isWhitespace)) {
          delete slots[name$1];
        }
      }
      return slots;
    }

    function isWhitespace(node) {
      return (node.isComment && !node.asyncFactory) || node.text === " ";
    }

    /*  */

    function isAsyncPlaceholder(node) {
      return node.isComment && node.asyncFactory;
    }

    /*  */

    function normalizeScopedSlots(slots, normalSlots, prevSlots) {
      var res;
      var hasNormalSlots = Object.keys(normalSlots).length > 0;
      var isStable = slots ? !!slots.$stable : !hasNormalSlots;
      var key = slots && slots.$key;
      if (!slots) {
        res = {};
      } else if (slots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return slots._normalized;
      } else if (
        isStable &&
        prevSlots &&
        prevSlots !== emptyObject &&
        key === prevSlots.$key &&
        !hasNormalSlots &&
        !prevSlots.$hasNormal
      ) {
        // fast path 2: stable scoped slots w/ no normal slots to proxy,
        // only need to normalize once
        return prevSlots;
      } else {
        res = {};
        for (var key$1 in slots) {
          if (slots[key$1] && key$1[0] !== "$") {
            res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
          }
        }
      }
      // expose normal slots on scopedSlots
      for (var key$2 in normalSlots) {
        if (!(key$2 in res)) {
          res[key$2] = proxyNormalSlot(normalSlots, key$2);
        }
      }
      // avoriaz seems to mock a non-extensible $scopedSlots object
      // and when that is passed down this would cause an error
      if (slots && Object.isExtensible(slots)) {
        slots._normalized = res;
      }
      def(res, "$stable", isStable);
      def(res, "$key", key);
      def(res, "$hasNormal", hasNormalSlots);
      return res;
    }

    function normalizeScopedSlot(normalSlots, key, fn) {
      var normalized = function () {
        var res = arguments.length ? fn.apply(null, arguments) : fn({});
        res =
          res && typeof res === "object" && !Array.isArray(res)
            ? [res] // single vnode
            : normalizeChildren(res);
        var vnode = res && res[0];
        return res &&
          (!vnode ||
            (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode))) // #9658, #10391
          ? undefined
          : res;
      };
      // this is a slot using the new v-slot syntax without scope. although it is
      // compiled as a scoped slot, render fn users would expect it to be present
      // on this.$slots because the usage is semantically a normal slot.
      if (fn.proxy) {
        Object.defineProperty(normalSlots, key, {
          get: normalized,
          enumerable: true,
          configurable: true,
        });
      }
      return normalized;
    }

    function proxyNormalSlot(slots, key) {
      return function () {
        return slots[key];
      };
    }

    /*  */

    /**
     * Runtime helper for rendering v-for lists.
     */
    function renderList(val, render) {
      var ret, i, l, keys, key;
      if (Array.isArray(val) || typeof val === "string") {
        ret = new Array(val.length);
        for (i = 0, l = val.length; i < l; i++) {
          ret[i] = render(val[i], i);
        }
      } else if (typeof val === "number") {
        ret = new Array(val);
        for (i = 0; i < val; i++) {
          ret[i] = render(i + 1, i);
        }
      } else if (isObject(val)) {
        if (hasSymbol && val[Symbol.iterator]) {
          ret = [];
          var iterator = val[Symbol.iterator]();
          var result = iterator.next();
          while (!result.done) {
            ret.push(render(result.value, ret.length));
            result = iterator.next();
          }
        } else {
          keys = Object.keys(val);
          ret = new Array(keys.length);
          for (i = 0, l = keys.length; i < l; i++) {
            key = keys[i];
            ret[i] = render(val[key], key, i);
          }
        }
      }
      if (!isDef(ret)) {
        ret = [];
      }
      ret._isVList = true;
      return ret;
    }

    /*  */

    /**
     * Runtime helper for rendering <slot>
     */
    function renderSlot(name, fallbackRender, props, bindObject) {
      var scopedSlotFn = this.$scopedSlots[name];
      var nodes;
      if (scopedSlotFn) {
        // scoped slot
        props = props || {};
        if (bindObject) {
          if (false) {
          }
          props = extend(extend({}, bindObject), props);
        }
        nodes =
          scopedSlotFn(props) ||
          (typeof fallbackRender === "function"
            ? fallbackRender()
            : fallbackRender);
      } else {
        nodes =
          this.$slots[name] ||
          (typeof fallbackRender === "function"
            ? fallbackRender()
            : fallbackRender);
      }

      var target = props && props.slot;
      if (target) {
        return this.$createElement("template", { slot: target }, nodes);
      } else {
        return nodes;
      }
    }

    /*  */

    /**
     * Runtime helper for resolving filters
     */
    function resolveFilter(id) {
      return resolveAsset(this.$options, "filters", id, true) || identity;
    }

    /*  */

    function isKeyNotMatch(expect, actual) {
      if (Array.isArray(expect)) {
        return expect.indexOf(actual) === -1;
      } else {
        return expect !== actual;
      }
    }

    /**
     * Runtime helper for checking keyCodes from config.
     * exposed as Vue.prototype._k
     * passing in eventKeyName as last argument separately for backwards compat
     */
    function checkKeyCodes(
      eventKeyCode,
      key,
      builtInKeyCode,
      eventKeyName,
      builtInKeyName
    ) {
      var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
      if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
        return isKeyNotMatch(builtInKeyName, eventKeyName);
      } else if (mappedKeyCode) {
        return isKeyNotMatch(mappedKeyCode, eventKeyCode);
      } else if (eventKeyName) {
        return hyphenate(eventKeyName) !== key;
      }
      return eventKeyCode === undefined;
    }

    /*  */

    /**
     * Runtime helper for merging v-bind="object" into a VNode's data.
     */
    function bindObjectProps(data, tag, value, asProp, isSync) {
      if (value) {
        if (!isObject(value)) {
          false && 0;
        } else {
          if (Array.isArray(value)) {
            value = toObject(value);
          }
          var hash;
          var loop = function (key) {
            if (
              key === "class" ||
              key === "style" ||
              isReservedAttribute(key)
            ) {
              hash = data;
            } else {
              var type = data.attrs && data.attrs.type;
              hash =
                asProp || config.mustUseProp(tag, type, key)
                  ? data.domProps || (data.domProps = {})
                  : data.attrs || (data.attrs = {});
            }
            var camelizedKey = camelize(key);
            var hyphenatedKey = hyphenate(key);
            if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
              hash[key] = value[key];

              if (isSync) {
                var on = data.on || (data.on = {});
                on["update:" + key] = function ($event) {
                  value[key] = $event;
                };
              }
            }
          };

          for (var key in value) loop(key);
        }
      }
      return data;
    }

    /*  */

    /**
     * Runtime helper for rendering static trees.
     */
    function renderStatic(index, isInFor) {
      var cached = this._staticTrees || (this._staticTrees = []);
      var tree = cached[index];
      // if has already-rendered static tree and not inside v-for,
      // we can reuse the same tree.
      if (tree && !isInFor) {
        return tree;
      }
      // otherwise, render a fresh tree.
      tree = cached[index] = this.$options.staticRenderFns[index].call(
        this._renderProxy,
        null,
        this // for render fns generated for functional component templates
      );
      markStatic(tree, "__static__" + index, false);
      return tree;
    }

    /**
     * Runtime helper for v-once.
     * Effectively it means marking the node as static with a unique key.
     */
    function markOnce(tree, index, key) {
      markStatic(tree, "__once__" + index + (key ? "_" + key : ""), true);
      return tree;
    }

    function markStatic(tree, key, isOnce) {
      if (Array.isArray(tree)) {
        for (var i = 0; i < tree.length; i++) {
          if (tree[i] && typeof tree[i] !== "string") {
            markStaticNode(tree[i], key + "_" + i, isOnce);
          }
        }
      } else {
        markStaticNode(tree, key, isOnce);
      }
    }

    function markStaticNode(node, key, isOnce) {
      node.isStatic = true;
      node.key = key;
      node.isOnce = isOnce;
    }

    /*  */

    function bindObjectListeners(data, value) {
      if (value) {
        if (!isPlainObject(value)) {
          false && 0;
        } else {
          var on = (data.on = data.on ? extend({}, data.on) : {});
          for (var key in value) {
            var existing = on[key];
            var ours = value[key];
            on[key] = existing ? [].concat(existing, ours) : ours;
          }
        }
      }
      return data;
    }

    /*  */

    function resolveScopedSlots(
      fns, // see flow/vnode
      res,
      // the following are added in 2.6
      hasDynamicKeys,
      contentHashKey
    ) {
      res = res || { $stable: !hasDynamicKeys };
      for (var i = 0; i < fns.length; i++) {
        var slot = fns[i];
        if (Array.isArray(slot)) {
          resolveScopedSlots(slot, res, hasDynamicKeys);
        } else if (slot) {
          // marker for reverse proxying v-slot without scope on this.$slots
          if (slot.proxy) {
            slot.fn.proxy = true;
          }
          res[slot.key] = slot.fn;
        }
      }
      if (contentHashKey) {
        res.$key = contentHashKey;
      }
      return res;
    }

    /*  */

    function bindDynamicKeys(baseObj, values) {
      for (var i = 0; i < values.length; i += 2) {
        var key = values[i];
        if (typeof key === "string" && key) {
          baseObj[values[i]] = values[i + 1];
        } else if (false) {
        }
      }
      return baseObj;
    }

    // helper to dynamically append modifier runtime markers to event names.
    // ensure only append when value is already string, otherwise it will be cast
    // to string and cause the type check to miss.
    function prependModifier(value, symbol) {
      return typeof value === "string" ? symbol + value : value;
    }

    /*  */

    function installRenderHelpers(target) {
      target._o = markOnce;
      target._n = toNumber;
      target._s = vue_runtime_esm_toString;
      target._l = renderList;
      target._t = renderSlot;
      target._q = looseEqual;
      target._i = looseIndexOf;
      target._m = renderStatic;
      target._f = resolveFilter;
      target._k = checkKeyCodes;
      target._b = bindObjectProps;
      target._v = createTextVNode;
      target._e = createEmptyVNode;
      target._u = resolveScopedSlots;
      target._g = bindObjectListeners;
      target._d = bindDynamicKeys;
      target._p = prependModifier;
    }

    /*  */

    function FunctionalRenderContext(data, props, children, parent, Ctor) {
      var this$1 = this;

      var options = Ctor.options;
      // ensure the createElement function in functional components
      // gets a unique context - this is necessary for correct named slot check
      var contextVm;
      if (hasOwn(parent, "_uid")) {
        contextVm = Object.create(parent);
        // $flow-disable-line
        contextVm._original = parent;
      } else {
        // the context vm passed in is a functional context as well.
        // in this case we want to make sure we are able to get a hold to the
        // real context instance.
        contextVm = parent;
        // $flow-disable-line
        parent = parent._original;
      }
      var isCompiled = isTrue(options._compiled);
      var needNormalization = !isCompiled;

      this.data = data;
      this.props = props;
      this.children = children;
      this.parent = parent;
      this.listeners = data.on || emptyObject;
      this.injections = resolveInject(options.inject, parent);
      this.slots = function () {
        if (!this$1.$slots) {
          normalizeScopedSlots(
            data.scopedSlots,
            (this$1.$slots = resolveSlots(children, parent))
          );
        }
        return this$1.$slots;
      };

      Object.defineProperty(this, "scopedSlots", {
        enumerable: true,
        get: function get() {
          return normalizeScopedSlots(data.scopedSlots, this.slots());
        },
      });

      // support for compiled functional template
      if (isCompiled) {
        // exposing $options for renderStatic()
        this.$options = options;
        // pre-resolve slots for renderSlot()
        this.$slots = this.slots();
        this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
      }

      if (options._scopeId) {
        this._c = function (a, b, c, d) {
          var vnode = createElement(contextVm, a, b, c, d, needNormalization);
          if (vnode && !Array.isArray(vnode)) {
            vnode.fnScopeId = options._scopeId;
            vnode.fnContext = parent;
          }
          return vnode;
        };
      } else {
        this._c = function (a, b, c, d) {
          return createElement(contextVm, a, b, c, d, needNormalization);
        };
      }
    }

    installRenderHelpers(FunctionalRenderContext.prototype);

    function createFunctionalComponent(
      Ctor,
      propsData,
      data,
      contextVm,
      children
    ) {
      var options = Ctor.options;
      var props = {};
      var propOptions = options.props;
      if (isDef(propOptions)) {
        for (var key in propOptions) {
          props[key] = validateProp(key, propOptions, propsData || emptyObject);
        }
      } else {
        if (isDef(data.attrs)) {
          mergeProps(props, data.attrs);
        }
        if (isDef(data.props)) {
          mergeProps(props, data.props);
        }
      }

      var renderContext = new FunctionalRenderContext(
        data,
        props,
        children,
        contextVm,
        Ctor
      );

      var vnode = options.render.call(null, renderContext._c, renderContext);

      if (vnode instanceof VNode) {
        return cloneAndMarkFunctionalResult(
          vnode,
          data,
          renderContext.parent,
          options,
          renderContext
        );
      } else if (Array.isArray(vnode)) {
        var vnodes = normalizeChildren(vnode) || [];
        var res = new Array(vnodes.length);
        for (var i = 0; i < vnodes.length; i++) {
          res[i] = cloneAndMarkFunctionalResult(
            vnodes[i],
            data,
            renderContext.parent,
            options,
            renderContext
          );
        }
        return res;
      }
    }

    function cloneAndMarkFunctionalResult(
      vnode,
      data,
      contextVm,
      options,
      renderContext
    ) {
      // #7817 clone node before setting fnContext, otherwise if the node is reused
      // (e.g. it was from a cached normal slot) the fnContext causes named slots
      // that should not be matched to match.
      var clone = cloneVNode(vnode);
      clone.fnContext = contextVm;
      clone.fnOptions = options;
      if (false) {
      }
      if (data.slot) {
        (clone.data || (clone.data = {})).slot = data.slot;
      }
      return clone;
    }

    function mergeProps(to, from) {
      for (var key in from) {
        to[camelize(key)] = from[key];
      }
    }

    /*  */

    /*  */

    /*  */

    /*  */

    // inline hooks to be invoked on component VNodes during patch
    var componentVNodeHooks = {
      init: function init(vnode, hydrating) {
        if (
          vnode.componentInstance &&
          !vnode.componentInstance._isDestroyed &&
          vnode.data.keepAlive
        ) {
          // kept-alive components, treat as a patch
          var mountedNode = vnode; // work around flow
          componentVNodeHooks.prepatch(mountedNode, mountedNode);
        } else {
          var child = (vnode.componentInstance =
            createComponentInstanceForVnode(vnode, activeInstance));
          child.$mount(hydrating ? vnode.elm : undefined, hydrating);
        }
      },

      prepatch: function prepatch(oldVnode, vnode) {
        var options = vnode.componentOptions;
        var child = (vnode.componentInstance = oldVnode.componentInstance);
        updateChildComponent(
          child,
          options.propsData, // updated props
          options.listeners, // updated listeners
          vnode, // new parent vnode
          options.children // new children
        );
      },

      insert: function insert(vnode) {
        var context = vnode.context;
        var componentInstance = vnode.componentInstance;
        if (!componentInstance._isMounted) {
          componentInstance._isMounted = true;
          callHook(componentInstance, "mounted");
        }
        if (vnode.data.keepAlive) {
          if (context._isMounted) {
            // vue-router#1212
            // During updates, a kept-alive component's child components may
            // change, so directly walking the tree here may call activated hooks
            // on incorrect children. Instead we push them into a queue which will
            // be processed after the whole patch process ended.
            queueActivatedComponent(componentInstance);
          } else {
            activateChildComponent(componentInstance, true /* direct */);
          }
        }
      },

      destroy: function destroy(vnode) {
        var componentInstance = vnode.componentInstance;
        if (!componentInstance._isDestroyed) {
          if (!vnode.data.keepAlive) {
            componentInstance.$destroy();
          } else {
            deactivateChildComponent(componentInstance, true /* direct */);
          }
        }
      },
    };

    var hooksToMerge = Object.keys(componentVNodeHooks);

    function createComponent(Ctor, data, context, children, tag) {
      if (isUndef(Ctor)) {
        return;
      }

      var baseCtor = context.$options._base;

      // plain options object: turn it into a constructor
      if (isObject(Ctor)) {
        Ctor = baseCtor.extend(Ctor);
      }

      // if at this stage it's not a constructor or an async component factory,
      // reject.
      if (typeof Ctor !== "function") {
        if (false) {
        }
        return;
      }

      // async component
      var asyncFactory;
      if (isUndef(Ctor.cid)) {
        asyncFactory = Ctor;
        Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
        if (Ctor === undefined) {
          // return a placeholder node for async component, which is rendered
          // as a comment node but preserves all the raw information for the node.
          // the information will be used for async server-rendering and hydration.
          return createAsyncPlaceholder(
            asyncFactory,
            data,
            context,
            children,
            tag
          );
        }
      }

      data = data || {};

      // resolve constructor options in case global mixins are applied after
      // component constructor creation
      resolveConstructorOptions(Ctor);

      // transform component v-model data into props & events
      if (isDef(data.model)) {
        transformModel(Ctor.options, data);
      }

      // extract props
      var propsData = extractPropsFromVNodeData(data, Ctor, tag);

      // functional component
      if (isTrue(Ctor.options.functional)) {
        return createFunctionalComponent(
          Ctor,
          propsData,
          data,
          context,
          children
        );
      }

      // extract listeners, since these needs to be treated as
      // child component listeners instead of DOM listeners
      var listeners = data.on;
      // replace with listeners with .native modifier
      // so it gets processed during parent component patch.
      data.on = data.nativeOn;

      if (isTrue(Ctor.options.abstract)) {
        // abstract components do not keep anything
        // other than props & listeners & slot

        // work around flow
        var slot = data.slot;
        data = {};
        if (slot) {
          data.slot = slot;
        }
      }

      // install component management hooks onto the placeholder node
      installComponentHooks(data);

      // return a placeholder vnode
      var name = Ctor.options.name || tag;
      var vnode = new VNode(
        "vue-component-" + Ctor.cid + (name ? "-" + name : ""),
        data,
        undefined,
        undefined,
        undefined,
        context,
        {
          Ctor: Ctor,
          propsData: propsData,
          listeners: listeners,
          tag: tag,
          children: children,
        },
        asyncFactory
      );

      return vnode;
    }

    function createComponentInstanceForVnode(
      // we know it's MountedComponentVNode but flow doesn't
      vnode,
      // activeInstance in lifecycle state
      parent
    ) {
      var options = {
        _isComponent: true,
        _parentVnode: vnode,
        parent: parent,
      };
      // check inline-template render functions
      var inlineTemplate = vnode.data.inlineTemplate;
      if (isDef(inlineTemplate)) {
        options.render = inlineTemplate.render;
        options.staticRenderFns = inlineTemplate.staticRenderFns;
      }
      return new vnode.componentOptions.Ctor(options);
    }

    function installComponentHooks(data) {
      var hooks = data.hook || (data.hook = {});
      for (var i = 0; i < hooksToMerge.length; i++) {
        var key = hooksToMerge[i];
        var existing = hooks[key];
        var toMerge = componentVNodeHooks[key];
        if (existing !== toMerge && !(existing && existing._merged)) {
          hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
        }
      }
    }

    function mergeHook$1(f1, f2) {
      var merged = function (a, b) {
        // flow complains about extra args which is why we use any
        f1(a, b);
        f2(a, b);
      };
      merged._merged = true;
      return merged;
    }

    // transform component v-model info (value and callback) into
    // prop and event handler respectively.
    function transformModel(options, data) {
      var prop = (options.model && options.model.prop) || "value";
      var event = (options.model && options.model.event) || "input";
      (data.attrs || (data.attrs = {}))[prop] = data.model.value;
      var on = data.on || (data.on = {});
      var existing = on[event];
      var callback = data.model.callback;
      if (isDef(existing)) {
        if (
          Array.isArray(existing)
            ? existing.indexOf(callback) === -1
            : existing !== callback
        ) {
          on[event] = [callback].concat(existing);
        }
      } else {
        on[event] = callback;
      }
    }

    /*  */

    var SIMPLE_NORMALIZE = 1;
    var ALWAYS_NORMALIZE = 2;

    // wrapper function for providing a more flexible interface
    // without getting yelled at by flow
    function createElement(
      context,
      tag,
      data,
      children,
      normalizationType,
      alwaysNormalize
    ) {
      if (Array.isArray(data) || isPrimitive(data)) {
        normalizationType = children;
        children = data;
        data = undefined;
      }
      if (isTrue(alwaysNormalize)) {
        normalizationType = ALWAYS_NORMALIZE;
      }
      return _createElement(context, tag, data, children, normalizationType);
    }

    function _createElement(context, tag, data, children, normalizationType) {
      if (isDef(data) && isDef(data.__ob__)) {
        false && 0;
        return createEmptyVNode();
      }
      // object syntax in v-bind
      if (isDef(data) && isDef(data.is)) {
        tag = data.is;
      }
      if (!tag) {
        // in case of component :is set to falsy value
        return createEmptyVNode();
      }
      // warn against non-primitive key
      if (false) {
      }
      // support single function children as default scoped slot
      if (Array.isArray(children) && typeof children[0] === "function") {
        data = data || {};
        data.scopedSlots = { default: children[0] };
        children.length = 0;
      }
      if (normalizationType === ALWAYS_NORMALIZE) {
        children = normalizeChildren(children);
      } else if (normalizationType === SIMPLE_NORMALIZE) {
        children = simpleNormalizeChildren(children);
      }
      var vnode, ns;
      if (typeof tag === "string") {
        var Ctor;
        ns =
          (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
        if (config.isReservedTag(tag)) {
          // platform built-in elements
          if (false) {
          }
          vnode = new VNode(
            config.parsePlatformTagName(tag),
            data,
            children,
            undefined,
            undefined,
            context
          );
        } else if (
          (!data || !data.pre) &&
          isDef((Ctor = resolveAsset(context.$options, "components", tag)))
        ) {
          // component
          vnode = createComponent(Ctor, data, context, children, tag);
        } else {
          // unknown or unlisted namespaced elements
          // check at runtime because it may get assigned a namespace when its
          // parent normalizes children
          vnode = new VNode(tag, data, children, undefined, undefined, context);
        }
      } else {
        // direct component options / constructor
        vnode = createComponent(tag, data, context, children);
      }
      if (Array.isArray(vnode)) {
        return vnode;
      } else if (isDef(vnode)) {
        if (isDef(ns)) {
          applyNS(vnode, ns);
        }
        if (isDef(data)) {
          registerDeepBindings(data);
        }
        return vnode;
      } else {
        return createEmptyVNode();
      }
    }

    function applyNS(vnode, ns, force) {
      vnode.ns = ns;
      if (vnode.tag === "foreignObject") {
        // use default namespace inside foreignObject
        ns = undefined;
        force = true;
      }
      if (isDef(vnode.children)) {
        for (var i = 0, l = vnode.children.length; i < l; i++) {
          var child = vnode.children[i];
          if (
            isDef(child.tag) &&
            (isUndef(child.ns) || (isTrue(force) && child.tag !== "svg"))
          ) {
            applyNS(child, ns, force);
          }
        }
      }
    }

    // ref #5318
    // necessary to ensure parent re-render when deep bindings like :style and
    // :class are used on slot nodes
    function registerDeepBindings(data) {
      if (isObject(data.style)) {
        traverse(data.style);
      }
      if (isObject(data.class)) {
        traverse(data.class);
      }
    }

    /*  */

    function initRender(vm) {
      vm._vnode = null; // the root of the child tree
      vm._staticTrees = null; // v-once cached trees
      var options = vm.$options;
      var parentVnode = (vm.$vnode = options._parentVnode); // the placeholder node in parent tree
      var renderContext = parentVnode && parentVnode.context;
      vm.$slots = resolveSlots(options._renderChildren, renderContext);
      vm.$scopedSlots = emptyObject;
      // bind the createElement fn to this instance
      // so that we get proper render context inside it.
      // args order: tag, data, children, normalizationType, alwaysNormalize
      // internal version is used by render functions compiled from templates
      vm._c = function (a, b, c, d) {
        return createElement(vm, a, b, c, d, false);
      };
      // normalization is always applied for the public version, used in
      // user-written render functions.
      vm.$createElement = function (a, b, c, d) {
        return createElement(vm, a, b, c, d, true);
      };

      // $attrs & $listeners are exposed for easier HOC creation.
      // they need to be reactive so that HOCs using them are always updated
      var parentData = parentVnode && parentVnode.data;

      /* istanbul ignore else */
      if (false) {
      } else {
        defineReactive$$1(
          vm,
          "$attrs",
          (parentData && parentData.attrs) || emptyObject,
          null,
          true
        );
        defineReactive$$1(
          vm,
          "$listeners",
          options._parentListeners || emptyObject,
          null,
          true
        );
      }
    }

    var currentRenderingInstance = null;

    function renderMixin(Vue) {
      // install runtime convenience helpers
      installRenderHelpers(Vue.prototype);

      Vue.prototype.$nextTick = function (fn) {
        return nextTick(fn, this);
      };

      Vue.prototype._render = function () {
        var vm = this;
        var ref = vm.$options;
        var render = ref.render;
        var _parentVnode = ref._parentVnode;

        if (_parentVnode) {
          vm.$scopedSlots = normalizeScopedSlots(
            _parentVnode.data.scopedSlots,
            vm.$slots,
            vm.$scopedSlots
          );
        }

        // set parent vnode. this allows render functions to have access
        // to the data on the placeholder node.
        vm.$vnode = _parentVnode;
        // render self
        var vnode;
        try {
          // There's no need to maintain a stack because all render fns are called
          // separately from one another. Nested component's render fns are called
          // when parent component is patched.
          currentRenderingInstance = vm;
          vnode = render.call(vm._renderProxy, vm.$createElement);
        } catch (e) {
          handleError(e, vm, "render");
          // return error render result,
          // or previous vnode to prevent render error causing blank component
          /* istanbul ignore else */
          if (false) {
          } else {
            vnode = vm._vnode;
          }
        } finally {
          currentRenderingInstance = null;
        }
        // if the returned array contains only a single node, allow it
        if (Array.isArray(vnode) && vnode.length === 1) {
          vnode = vnode[0];
        }
        // return empty vnode in case the render function errored out
        if (!(vnode instanceof VNode)) {
          if (false) {
          }
          vnode = createEmptyVNode();
        }
        // set parent
        vnode.parent = _parentVnode;
        return vnode;
      };
    }

    /*  */

    function ensureCtor(comp, base) {
      if (
        comp.__esModule ||
        (hasSymbol && comp[Symbol.toStringTag] === "Module")
      ) {
        comp = comp.default;
      }
      return isObject(comp) ? base.extend(comp) : comp;
    }

    function createAsyncPlaceholder(factory, data, context, children, tag) {
      var node = createEmptyVNode();
      node.asyncFactory = factory;
      node.asyncMeta = {
        data: data,
        context: context,
        children: children,
        tag: tag,
      };
      return node;
    }

    function resolveAsyncComponent(factory, baseCtor) {
      if (isTrue(factory.error) && isDef(factory.errorComp)) {
        return factory.errorComp;
      }

      if (isDef(factory.resolved)) {
        return factory.resolved;
      }

      var owner = currentRenderingInstance;
      if (
        owner &&
        isDef(factory.owners) &&
        factory.owners.indexOf(owner) === -1
      ) {
        // already pending
        factory.owners.push(owner);
      }

      if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
        return factory.loadingComp;
      }

      if (owner && !isDef(factory.owners)) {
        var owners = (factory.owners = [owner]);
        var sync = true;
        var timerLoading = null;
        var timerTimeout = null;

        owner.$on("hook:destroyed", function () {
          return remove(owners, owner);
        });

        var forceRender = function (renderCompleted) {
          for (var i = 0, l = owners.length; i < l; i++) {
            owners[i].$forceUpdate();
          }

          if (renderCompleted) {
            owners.length = 0;
            if (timerLoading !== null) {
              clearTimeout(timerLoading);
              timerLoading = null;
            }
            if (timerTimeout !== null) {
              clearTimeout(timerTimeout);
              timerTimeout = null;
            }
          }
        };

        var resolve = once(function (res) {
          // cache resolved
          factory.resolved = ensureCtor(res, baseCtor);
          // invoke callbacks only if this is not a synchronous resolve
          // (async resolves are shimmed as synchronous during SSR)
          if (!sync) {
            forceRender(true);
          } else {
            owners.length = 0;
          }
        });

        var reject = once(function (reason) {
          false && 0;
          if (isDef(factory.errorComp)) {
            factory.error = true;
            forceRender(true);
          }
        });

        var res = factory(resolve, reject);

        if (isObject(res)) {
          if (isPromise(res)) {
            // () => Promise
            if (isUndef(factory.resolved)) {
              res.then(resolve, reject);
            }
          } else if (isPromise(res.component)) {
            res.component.then(resolve, reject);

            if (isDef(res.error)) {
              factory.errorComp = ensureCtor(res.error, baseCtor);
            }

            if (isDef(res.loading)) {
              factory.loadingComp = ensureCtor(res.loading, baseCtor);
              if (res.delay === 0) {
                factory.loading = true;
              } else {
                timerLoading = setTimeout(function () {
                  timerLoading = null;
                  if (isUndef(factory.resolved) && isUndef(factory.error)) {
                    factory.loading = true;
                    forceRender(false);
                  }
                }, res.delay || 200);
              }
            }

            if (isDef(res.timeout)) {
              timerTimeout = setTimeout(function () {
                timerTimeout = null;
                if (isUndef(factory.resolved)) {
                  reject(false ? 0 : null);
                }
              }, res.timeout);
            }
          }
        }

        sync = false;
        // return in case resolved synchronously
        return factory.loading ? factory.loadingComp : factory.resolved;
      }
    }

    /*  */

    function getFirstComponentChild(children) {
      if (Array.isArray(children)) {
        for (var i = 0; i < children.length; i++) {
          var c = children[i];
          if (
            isDef(c) &&
            (isDef(c.componentOptions) || isAsyncPlaceholder(c))
          ) {
            return c;
          }
        }
      }
    }

    /*  */

    /*  */

    function initEvents(vm) {
      vm._events = Object.create(null);
      vm._hasHookEvent = false;
      // init parent attached events
      var listeners = vm.$options._parentListeners;
      if (listeners) {
        updateComponentListeners(vm, listeners);
      }
    }

    var target;

    function add(event, fn) {
      target.$on(event, fn);
    }

    function remove$1(event, fn) {
      target.$off(event, fn);
    }

    function createOnceHandler(event, fn) {
      var _target = target;
      return function onceHandler() {
        var res = fn.apply(null, arguments);
        if (res !== null) {
          _target.$off(event, onceHandler);
        }
      };
    }

    function updateComponentListeners(vm, listeners, oldListeners) {
      target = vm;
      updateListeners(
        listeners,
        oldListeners || {},
        add,
        remove$1,
        createOnceHandler,
        vm
      );
      target = undefined;
    }

    function eventsMixin(Vue) {
      var hookRE = /^hook:/;
      Vue.prototype.$on = function (event, fn) {
        var vm = this;
        if (Array.isArray(event)) {
          for (var i = 0, l = event.length; i < l; i++) {
            vm.$on(event[i], fn);
          }
        } else {
          (vm._events[event] || (vm._events[event] = [])).push(fn);
          // optimize hook:event cost by using a boolean flag marked at registration
          // instead of a hash lookup
          if (hookRE.test(event)) {
            vm._hasHookEvent = true;
          }
        }
        return vm;
      };

      Vue.prototype.$once = function (event, fn) {
        var vm = this;
        function on() {
          vm.$off(event, on);
          fn.apply(vm, arguments);
        }
        on.fn = fn;
        vm.$on(event, on);
        return vm;
      };

      Vue.prototype.$off = function (event, fn) {
        var vm = this;
        // all
        if (!arguments.length) {
          vm._events = Object.create(null);
          return vm;
        }
        // array of events
        if (Array.isArray(event)) {
          for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
            vm.$off(event[i$1], fn);
          }
          return vm;
        }
        // specific event
        var cbs = vm._events[event];
        if (!cbs) {
          return vm;
        }
        if (!fn) {
          vm._events[event] = null;
          return vm;
        }
        // specific handler
        var cb;
        var i = cbs.length;
        while (i--) {
          cb = cbs[i];
          if (cb === fn || cb.fn === fn) {
            cbs.splice(i, 1);
            break;
          }
        }
        return vm;
      };

      Vue.prototype.$emit = function (event) {
        var vm = this;
        if (false) {
          var lowerCaseEvent;
        }
        var cbs = vm._events[event];
        if (cbs) {
          cbs = cbs.length > 1 ? toArray(cbs) : cbs;
          var args = toArray(arguments, 1);
          var info = 'event handler for "' + event + '"';
          for (var i = 0, l = cbs.length; i < l; i++) {
            invokeWithErrorHandling(cbs[i], vm, args, vm, info);
          }
        }
        return vm;
      };
    }

    /*  */

    var activeInstance = null;
    var isUpdatingChildComponent = false;

    function setActiveInstance(vm) {
      var prevActiveInstance = activeInstance;
      activeInstance = vm;
      return function () {
        activeInstance = prevActiveInstance;
      };
    }

    function initLifecycle(vm) {
      var options = vm.$options;

      // locate first non-abstract parent
      var parent = options.parent;
      if (parent && !options.abstract) {
        while (parent.$options.abstract && parent.$parent) {
          parent = parent.$parent;
        }
        parent.$children.push(vm);
      }

      vm.$parent = parent;
      vm.$root = parent ? parent.$root : vm;

      vm.$children = [];
      vm.$refs = {};

      vm._watcher = null;
      vm._inactive = null;
      vm._directInactive = false;
      vm._isMounted = false;
      vm._isDestroyed = false;
      vm._isBeingDestroyed = false;
    }

    function lifecycleMixin(Vue) {
      Vue.prototype._update = function (vnode, hydrating) {
        var vm = this;
        var prevEl = vm.$el;
        var prevVnode = vm._vnode;
        var restoreActiveInstance = setActiveInstance(vm);
        vm._vnode = vnode;
        // Vue.prototype.__patch__ is injected in entry points
        // based on the rendering backend used.
        if (!prevVnode) {
          // initial render
          vm.$el = vm.__patch__(
            vm.$el,
            vnode,
            hydrating,
            false /* removeOnly */
          );
        } else {
          // updates
          vm.$el = vm.__patch__(prevVnode, vnode);
        }
        restoreActiveInstance();
        // update __vue__ reference
        if (prevEl) {
          prevEl.__vue__ = null;
        }
        if (vm.$el) {
          vm.$el.__vue__ = vm;
        }
        // if parent is an HOC, update its $el as well
        if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
          vm.$parent.$el = vm.$el;
        }
        // updated hook is called by the scheduler to ensure that children are
        // updated in a parent's updated hook.
      };

      Vue.prototype.$forceUpdate = function () {
        var vm = this;
        if (vm._watcher) {
          vm._watcher.update();
        }
      };

      Vue.prototype.$destroy = function () {
        var vm = this;
        if (vm._isBeingDestroyed) {
          return;
        }
        callHook(vm, "beforeDestroy");
        vm._isBeingDestroyed = true;
        // remove self from parent
        var parent = vm.$parent;
        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
          remove(parent.$children, vm);
        }
        // teardown watchers
        if (vm._watcher) {
          vm._watcher.teardown();
        }
        var i = vm._watchers.length;
        while (i--) {
          vm._watchers[i].teardown();
        }
        // remove reference from data ob
        // frozen object may not have observer.
        if (vm._data.__ob__) {
          vm._data.__ob__.vmCount--;
        }
        // call the last hook...
        vm._isDestroyed = true;
        // invoke destroy hooks on current rendered tree
        vm.__patch__(vm._vnode, null);
        // fire destroyed hook
        callHook(vm, "destroyed");
        // turn off all instance listeners.
        vm.$off();
        // remove __vue__ reference
        if (vm.$el) {
          vm.$el.__vue__ = null;
        }
        // release circular reference (#6759)
        if (vm.$vnode) {
          vm.$vnode.parent = null;
        }
      };
    }

    function mountComponent(vm, el, hydrating) {
      vm.$el = el;
      if (!vm.$options.render) {
        vm.$options.render = createEmptyVNode;
        if (false) {
        }
      }
      callHook(vm, "beforeMount");

      var updateComponent;
      /* istanbul ignore if */
      if (false) {
      } else {
        updateComponent = function () {
          vm._update(vm._render(), hydrating);
        };
      }

      // we set this to vm._watcher inside the watcher's constructor
      // since the watcher's initial patch may call $forceUpdate (e.g. inside child
      // component's mounted hook), which relies on vm._watcher being already defined
      new Watcher(
        vm,
        updateComponent,
        noop,
        {
          before: function before() {
            if (vm._isMounted && !vm._isDestroyed) {
              callHook(vm, "beforeUpdate");
            }
          },
        },
        true /* isRenderWatcher */
      );
      hydrating = false;

      // manually mounted instance, call mounted on self
      // mounted is called for render-created child components in its inserted hook
      if (vm.$vnode == null) {
        vm._isMounted = true;
        callHook(vm, "mounted");
      }
      return vm;
    }

    function updateChildComponent(
      vm,
      propsData,
      listeners,
      parentVnode,
      renderChildren
    ) {
      if (false) {
      }

      // determine whether component has slot children
      // we need to do this before overwriting $options._renderChildren.

      // check if there are dynamic scopedSlots (hand-written or compiled but with
      // dynamic slot names). Static scoped slots compiled from template has the
      // "$stable" marker.
      var newScopedSlots = parentVnode.data.scopedSlots;
      var oldScopedSlots = vm.$scopedSlots;
      var hasDynamicScopedSlot = !!(
        (newScopedSlots && !newScopedSlots.$stable) ||
        (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
        (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
        (!newScopedSlots && vm.$scopedSlots.$key)
      );

      // Any static slot children from the parent may have changed during parent's
      // update. Dynamic scoped slots may also have changed. In such cases, a forced
      // update is necessary to ensure correctness.
      var needsForceUpdate = !!(
        renderChildren || // has new static slots
        vm.$options._renderChildren || // has old static slots
        hasDynamicScopedSlot
      );

      vm.$options._parentVnode = parentVnode;
      vm.$vnode = parentVnode; // update vm's placeholder node without re-render

      if (vm._vnode) {
        // update child tree's parent
        vm._vnode.parent = parentVnode;
      }
      vm.$options._renderChildren = renderChildren;

      // update $attrs and $listeners hash
      // these are also reactive so they may trigger child update if the child
      // used them during render
      vm.$attrs = parentVnode.data.attrs || emptyObject;
      vm.$listeners = listeners || emptyObject;

      // update props
      if (propsData && vm.$options.props) {
        toggleObserving(false);
        var props = vm._props;
        var propKeys = vm.$options._propKeys || [];
        for (var i = 0; i < propKeys.length; i++) {
          var key = propKeys[i];
          var propOptions = vm.$options.props; // wtf flow?
          props[key] = validateProp(key, propOptions, propsData, vm);
        }
        toggleObserving(true);
        // keep a copy of raw propsData
        vm.$options.propsData = propsData;
      }

      // update listeners
      listeners = listeners || emptyObject;
      var oldListeners = vm.$options._parentListeners;
      vm.$options._parentListeners = listeners;
      updateComponentListeners(vm, listeners, oldListeners);

      // resolve slots + force update if has children
      if (needsForceUpdate) {
        vm.$slots = resolveSlots(renderChildren, parentVnode.context);
        vm.$forceUpdate();
      }

      if (false) {
      }
    }

    function isInInactiveTree(vm) {
      while (vm && (vm = vm.$parent)) {
        if (vm._inactive) {
          return true;
        }
      }
      return false;
    }

    function activateChildComponent(vm, direct) {
      if (direct) {
        vm._directInactive = false;
        if (isInInactiveTree(vm)) {
          return;
        }
      } else if (vm._directInactive) {
        return;
      }
      if (vm._inactive || vm._inactive === null) {
        vm._inactive = false;
        for (var i = 0; i < vm.$children.length; i++) {
          activateChildComponent(vm.$children[i]);
        }
        callHook(vm, "activated");
      }
    }

    function deactivateChildComponent(vm, direct) {
      if (direct) {
        vm._directInactive = true;
        if (isInInactiveTree(vm)) {
          return;
        }
      }
      if (!vm._inactive) {
        vm._inactive = true;
        for (var i = 0; i < vm.$children.length; i++) {
          deactivateChildComponent(vm.$children[i]);
        }
        callHook(vm, "deactivated");
      }
    }

    function callHook(vm, hook) {
      // #7573 disable dep collection when invoking lifecycle hooks
      pushTarget();
      var handlers = vm.$options[hook];
      var info = hook + " hook";
      if (handlers) {
        for (var i = 0, j = handlers.length; i < j; i++) {
          invokeWithErrorHandling(handlers[i], vm, null, vm, info);
        }
      }
      if (vm._hasHookEvent) {
        vm.$emit("hook:" + hook);
      }
      popTarget();
    }

    /*  */

    var MAX_UPDATE_COUNT = 100;

    var queue = [];
    var activatedChildren = [];
    var has = {};
    var circular = {};
    var waiting = false;
    var flushing = false;
    var index = 0;

    /**
     * Reset the scheduler's state.
     */
    function resetSchedulerState() {
      index = queue.length = activatedChildren.length = 0;
      has = {};
      if (false) {
      }
      waiting = flushing = false;
    }

    // Async edge case #6566 requires saving the timestamp when event listeners are
    // attached. However, calling performance.now() has a perf overhead especially
    // if the page has thousands of event listeners. Instead, we take a timestamp
    // every time the scheduler flushes and use that for all event listeners
    // attached during that flush.
    var currentFlushTimestamp = 0;

    // Async edge case fix requires storing an event listener's attach timestamp.
    var getNow = Date.now;

    // Determine what event timestamp the browser is using. Annoyingly, the
    // timestamp can either be hi-res (relative to page load) or low-res
    // (relative to UNIX epoch), so in order to compare time we have to use the
    // same timestamp type when saving the flush timestamp.
    // All IE versions use low-res event timestamps, and have problematic clock
    // implementations (#9632)
    if (inBrowser && !isIE) {
      var performance = window.performance;
      if (
        performance &&
        typeof performance.now === "function" &&
        getNow() > document.createEvent("Event").timeStamp
      ) {
        // if the event timestamp, although evaluated AFTER the Date.now(), is
        // smaller than it, it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listener timestamps as
        // well.
        getNow = function () {
          return performance.now();
        };
      }
    }

    /**
     * Flush both queues and run the watchers.
     */
    function flushSchedulerQueue() {
      currentFlushTimestamp = getNow();
      flushing = true;
      var watcher, id;

      // Sort queue before flush.
      // This ensures that:
      // 1. Components are updated from parent to child. (because parent is always
      //    created before the child)
      // 2. A component's user watchers are run before its render watcher (because
      //    user watchers are created before the render watcher)
      // 3. If a component is destroyed during a parent component's watcher run,
      //    its watchers can be skipped.
      queue.sort(function (a, b) {
        return a.id - b.id;
      });

      // do not cache length because more watchers might be pushed
      // as we run existing watchers
      for (index = 0; index < queue.length; index++) {
        watcher = queue[index];
        if (watcher.before) {
          watcher.before();
        }
        id = watcher.id;
        has[id] = null;
        watcher.run();
        // in dev build, check and stop circular updates.
        if (false) {
        }
      }

      // keep copies of post queues before resetting state
      var activatedQueue = activatedChildren.slice();
      var updatedQueue = queue.slice();

      resetSchedulerState();

      // call component updated and activated hooks
      callActivatedHooks(activatedQueue);
      callUpdatedHooks(updatedQueue);

      // devtool hook
      /* istanbul ignore if */
      if (devtools && config.devtools) {
        devtools.emit("flush");
      }
    }

    function callUpdatedHooks(queue) {
      var i = queue.length;
      while (i--) {
        var watcher = queue[i];
        var vm = watcher.vm;
        if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
          callHook(vm, "updated");
        }
      }
    }

    /**
     * Queue a kept-alive component that was activated during patch.
     * The queue will be processed after the entire tree has been patched.
     */
    function queueActivatedComponent(vm) {
      // setting _inactive to false here so that a render function can
      // rely on checking whether it's in an inactive tree (e.g. router-view)
      vm._inactive = false;
      activatedChildren.push(vm);
    }

    function callActivatedHooks(queue) {
      for (var i = 0; i < queue.length; i++) {
        queue[i]._inactive = true;
        activateChildComponent(queue[i], true /* true */);
      }
    }

    /**
     * Push a watcher into the watcher queue.
     * Jobs with duplicate IDs will be skipped unless it's
     * pushed when the queue is being flushed.
     */
    function queueWatcher(watcher) {
      var id = watcher.id;
      if (has[id] == null) {
        has[id] = true;
        if (!flushing) {
          queue.push(watcher);
        } else {
          // if already flushing, splice the watcher based on its id
          // if already past its id, it will be run next immediately.
          var i = queue.length - 1;
          while (i > index && queue[i].id > watcher.id) {
            i--;
          }
          queue.splice(i + 1, 0, watcher);
        }
        // queue the flush
        if (!waiting) {
          waiting = true;

          if (false) {
          }
          nextTick(flushSchedulerQueue);
        }
      }
    }

    /*  */

    var uid$2 = 0;

    /**
     * A watcher parses an expression, collects dependencies,
     * and fires callback when the expression value changes.
     * This is used for both the $watch() api and directives.
     */
    var Watcher = function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
      this.vm = vm;
      if (isRenderWatcher) {
        vm._watcher = this;
      }
      vm._watchers.push(this);
      // options
      if (options) {
        this.deep = !!options.deep;
        this.user = !!options.user;
        this.lazy = !!options.lazy;
        this.sync = !!options.sync;
        this.before = options.before;
      } else {
        this.deep = this.user = this.lazy = this.sync = false;
      }
      this.cb = cb;
      this.id = ++uid$2; // uid for batching
      this.active = true;
      this.dirty = this.lazy; // for lazy watchers
      this.deps = [];
      this.newDeps = [];
      this.depIds = new _Set();
      this.newDepIds = new _Set();
      this.expression = false ? 0 : "";
      // parse expression for getter
      if (typeof expOrFn === "function") {
        this.getter = expOrFn;
      } else {
        this.getter = parsePath(expOrFn);
        if (!this.getter) {
          this.getter = noop;
          false && 0;
        }
      }
      this.value = this.lazy ? undefined : this.get();
    };

    /**
     * Evaluate the getter, and re-collect dependencies.
     */
    Watcher.prototype.get = function get() {
      pushTarget(this);
      var value;
      var vm = this.vm;
      try {
        value = this.getter.call(vm, vm);
      } catch (e) {
        if (this.user) {
          handleError(e, vm, 'getter for watcher "' + this.expression + '"');
        } else {
          throw e;
        }
      } finally {
        // "touch" every property so they are all tracked as
        // dependencies for deep watching
        if (this.deep) {
          traverse(value);
        }
        popTarget();
        this.cleanupDeps();
      }
      return value;
    };

    /**
     * Add a dependency to this directive.
     */
    Watcher.prototype.addDep = function addDep(dep) {
      var id = dep.id;
      if (!this.newDepIds.has(id)) {
        this.newDepIds.add(id);
        this.newDeps.push(dep);
        if (!this.depIds.has(id)) {
          dep.addSub(this);
        }
      }
    };

    /**
     * Clean up for dependency collection.
     */
    Watcher.prototype.cleanupDeps = function cleanupDeps() {
      var i = this.deps.length;
      while (i--) {
        var dep = this.deps[i];
        if (!this.newDepIds.has(dep.id)) {
          dep.removeSub(this);
        }
      }
      var tmp = this.depIds;
      this.depIds = this.newDepIds;
      this.newDepIds = tmp;
      this.newDepIds.clear();
      tmp = this.deps;
      this.deps = this.newDeps;
      this.newDeps = tmp;
      this.newDeps.length = 0;
    };

    /**
     * Subscriber interface.
     * Will be called when a dependency changes.
     */
    Watcher.prototype.update = function update() {
      /* istanbul ignore else */
      if (this.lazy) {
        this.dirty = true;
      } else if (this.sync) {
        this.run();
      } else {
        queueWatcher(this);
      }
    };

    /**
     * Scheduler job interface.
     * Will be called by the scheduler.
     */
    Watcher.prototype.run = function run() {
      if (this.active) {
        var value = this.get();
        if (
          value !== this.value ||
          // Deep watchers and watchers on Object/Arrays should fire even
          // when the value is the same, because the value may
          // have mutated.
          isObject(value) ||
          this.deep
        ) {
          // set new value
          var oldValue = this.value;
          this.value = value;
          if (this.user) {
            var info = 'callback for watcher "' + this.expression + '"';
            invokeWithErrorHandling(
              this.cb,
              this.vm,
              [value, oldValue],
              this.vm,
              info
            );
          } else {
            this.cb.call(this.vm, value, oldValue);
          }
        }
      }
    };

    /**
     * Evaluate the value of the watcher.
     * This only gets called for lazy watchers.
     */
    Watcher.prototype.evaluate = function evaluate() {
      this.value = this.get();
      this.dirty = false;
    };

    /**
     * Depend on all deps collected by this watcher.
     */
    Watcher.prototype.depend = function depend() {
      var i = this.deps.length;
      while (i--) {
        this.deps[i].depend();
      }
    };

    /**
     * Remove self from all dependencies' subscriber list.
     */
    Watcher.prototype.teardown = function teardown() {
      if (this.active) {
        // remove self from vm's watcher list
        // this is a somewhat expensive operation so we skip it
        // if the vm is being destroyed.
        if (!this.vm._isBeingDestroyed) {
          remove(this.vm._watchers, this);
        }
        var i = this.deps.length;
        while (i--) {
          this.deps[i].removeSub(this);
        }
        this.active = false;
      }
    };

    /*  */

    var sharedPropertyDefinition = {
      enumerable: true,
      configurable: true,
      get: noop,
      set: noop,
    };

    function proxy(target, sourceKey, key) {
      sharedPropertyDefinition.get = function proxyGetter() {
        return this[sourceKey][key];
      };
      sharedPropertyDefinition.set = function proxySetter(val) {
        this[sourceKey][key] = val;
      };
      Object.defineProperty(target, key, sharedPropertyDefinition);
    }

    function initState(vm) {
      vm._watchers = [];
      var opts = vm.$options;
      if (opts.props) {
        initProps(vm, opts.props);
      }
      if (opts.methods) {
        initMethods(vm, opts.methods);
      }
      if (opts.data) {
        initData(vm);
      } else {
        observe((vm._data = {}), true /* asRootData */);
      }
      if (opts.computed) {
        initComputed(vm, opts.computed);
      }
      if (opts.watch && opts.watch !== nativeWatch) {
        initWatch(vm, opts.watch);
      }
    }

    function initProps(vm, propsOptions) {
      var propsData = vm.$options.propsData || {};
      var props = (vm._props = {});
      // cache prop keys so that future props updates can iterate using Array
      // instead of dynamic object key enumeration.
      var keys = (vm.$options._propKeys = []);
      var isRoot = !vm.$parent;
      // root instance props should be converted
      if (!isRoot) {
        toggleObserving(false);
      }
      var loop = function (key) {
        keys.push(key);
        var value = validateProp(key, propsOptions, propsData, vm);
        /* istanbul ignore else */
        if (false) {
          var hyphenatedKey;
        } else {
          defineReactive$$1(props, key, value);
        }
        // static props are already proxied on the component's prototype
        // during Vue.extend(). We only need to proxy props defined at
        // instantiation here.
        if (!(key in vm)) {
          proxy(vm, "_props", key);
        }
      };

      for (var key in propsOptions) loop(key);
      toggleObserving(true);
    }

    function initData(vm) {
      var data = vm.$options.data;
      data = vm._data =
        typeof data === "function" ? getData(data, vm) : data || {};
      if (!isPlainObject(data)) {
        data = {};
        false && 0;
      }
      // proxy data on instance
      var keys = Object.keys(data);
      var props = vm.$options.props;
      var methods = vm.$options.methods;
      var i = keys.length;
      while (i--) {
        var key = keys[i];
        if (false) {
        }
        if (props && hasOwn(props, key)) {
          false && 0;
        } else if (!isReserved(key)) {
          proxy(vm, "_data", key);
        }
      }
      // observe data
      observe(data, true /* asRootData */);
    }

    function getData(data, vm) {
      // #7573 disable dep collection when invoking data getters
      pushTarget();
      try {
        return data.call(vm, vm);
      } catch (e) {
        handleError(e, vm, "data()");
        return {};
      } finally {
        popTarget();
      }
    }

    var computedWatcherOptions = { lazy: true };

    function initComputed(vm, computed) {
      // $flow-disable-line
      var watchers = (vm._computedWatchers = Object.create(null));
      // computed properties are just getters during SSR
      var isSSR = isServerRendering();

      for (var key in computed) {
        var userDef = computed[key];
        var getter = typeof userDef === "function" ? userDef : userDef.get;
        if (false) {
        }

        if (!isSSR) {
          // create internal watcher for the computed property.
          watchers[key] = new Watcher(
            vm,
            getter || noop,
            noop,
            computedWatcherOptions
          );
        }

        // component-defined computed properties are already defined on the
        // component prototype. We only need to define computed properties defined
        // at instantiation here.
        if (!(key in vm)) {
          defineComputed(vm, key, userDef);
        } else if (false) {
        }
      }
    }

    function defineComputed(target, key, userDef) {
      var shouldCache = !isServerRendering();
      if (typeof userDef === "function") {
        sharedPropertyDefinition.get = shouldCache
          ? createComputedGetter(key)
          : createGetterInvoker(userDef);
        sharedPropertyDefinition.set = noop;
      } else {
        sharedPropertyDefinition.get = userDef.get
          ? shouldCache && userDef.cache !== false
            ? createComputedGetter(key)
            : createGetterInvoker(userDef.get)
          : noop;
        sharedPropertyDefinition.set = userDef.set || noop;
      }
      if (false) {
      }
      Object.defineProperty(target, key, sharedPropertyDefinition);
    }

    function createComputedGetter(key) {
      return function computedGetter() {
        var watcher = this._computedWatchers && this._computedWatchers[key];
        if (watcher) {
          if (watcher.dirty) {
            watcher.evaluate();
          }
          if (Dep.target) {
            watcher.depend();
          }
          return watcher.value;
        }
      };
    }

    function createGetterInvoker(fn) {
      return function computedGetter() {
        return fn.call(this, this);
      };
    }

    function initMethods(vm, methods) {
      var props = vm.$options.props;
      for (var key in methods) {
        if (false) {
        }
        vm[key] =
          typeof methods[key] !== "function" ? noop : bind(methods[key], vm);
      }
    }

    function initWatch(vm, watch) {
      for (var key in watch) {
        var handler = watch[key];
        if (Array.isArray(handler)) {
          for (var i = 0; i < handler.length; i++) {
            createWatcher(vm, key, handler[i]);
          }
        } else {
          createWatcher(vm, key, handler);
        }
      }
    }

    function createWatcher(vm, expOrFn, handler, options) {
      if (isPlainObject(handler)) {
        options = handler;
        handler = handler.handler;
      }
      if (typeof handler === "string") {
        handler = vm[handler];
      }
      return vm.$watch(expOrFn, handler, options);
    }

    function stateMixin(Vue) {
      // flow somehow has problems with directly declared definition object
      // when using Object.defineProperty, so we have to procedurally build up
      // the object here.
      var dataDef = {};
      dataDef.get = function () {
        return this._data;
      };
      var propsDef = {};
      propsDef.get = function () {
        return this._props;
      };
      if (false) {
      }
      Object.defineProperty(Vue.prototype, "$data", dataDef);
      Object.defineProperty(Vue.prototype, "$props", propsDef);

      Vue.prototype.$set = set;
      Vue.prototype.$delete = del;

      Vue.prototype.$watch = function (expOrFn, cb, options) {
        var vm = this;
        if (isPlainObject(cb)) {
          return createWatcher(vm, expOrFn, cb, options);
        }
        options = options || {};
        options.user = true;
        var watcher = new Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
          var info =
            'callback for immediate watcher "' + watcher.expression + '"';
          pushTarget();
          invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
          popTarget();
        }
        return function unwatchFn() {
          watcher.teardown();
        };
      };
    }

    /*  */

    var uid$3 = 0;

    function initMixin(Vue) {
      Vue.prototype._init = function (options) {
        var vm = this;
        // a uid
        vm._uid = uid$3++;

        var startTag, endTag;
        /* istanbul ignore if */
        if (false) {
        }

        // a flag to avoid this being observed
        vm._isVue = true;
        // merge options
        if (options && options._isComponent) {
          // optimize internal component instantiation
          // since dynamic options merging is pretty slow, and none of the
          // internal component options needs special treatment.
          initInternalComponent(vm, options);
        } else {
          vm.$options = mergeOptions(
            resolveConstructorOptions(vm.constructor),
            options || {},
            vm
          );
        }
        /* istanbul ignore else */
        if (false) {
        } else {
          vm._renderProxy = vm;
        }
        // expose real self
        vm._self = vm;
        initLifecycle(vm);
        initEvents(vm);
        initRender(vm);
        callHook(vm, "beforeCreate");
        initInjections(vm); // resolve injections before data/props
        initState(vm);
        initProvide(vm); // resolve provide after data/props
        callHook(vm, "created");

        /* istanbul ignore if */
        if (false) {
        }

        if (vm.$options.el) {
          vm.$mount(vm.$options.el);
        }
      };
    }

    function initInternalComponent(vm, options) {
      var opts = (vm.$options = Object.create(vm.constructor.options));
      // doing this because it's faster than dynamic enumeration.
      var parentVnode = options._parentVnode;
      opts.parent = options.parent;
      opts._parentVnode = parentVnode;

      var vnodeComponentOptions = parentVnode.componentOptions;
      opts.propsData = vnodeComponentOptions.propsData;
      opts._parentListeners = vnodeComponentOptions.listeners;
      opts._renderChildren = vnodeComponentOptions.children;
      opts._componentTag = vnodeComponentOptions.tag;

      if (options.render) {
        opts.render = options.render;
        opts.staticRenderFns = options.staticRenderFns;
      }
    }

    function resolveConstructorOptions(Ctor) {
      var options = Ctor.options;
      if (Ctor.super) {
        var superOptions = resolveConstructorOptions(Ctor.super);
        var cachedSuperOptions = Ctor.superOptions;
        if (superOptions !== cachedSuperOptions) {
          // super option changed,
          // need to resolve new options.
          Ctor.superOptions = superOptions;
          // check if there are any late-modified/attached options (#4976)
          var modifiedOptions = resolveModifiedOptions(Ctor);
          // update base extend options
          if (modifiedOptions) {
            extend(Ctor.extendOptions, modifiedOptions);
          }
          options = Ctor.options = mergeOptions(
            superOptions,
            Ctor.extendOptions
          );
          if (options.name) {
            options.components[options.name] = Ctor;
          }
        }
      }
      return options;
    }

    function resolveModifiedOptions(Ctor) {
      var modified;
      var latest = Ctor.options;
      var sealed = Ctor.sealedOptions;
      for (var key in latest) {
        if (latest[key] !== sealed[key]) {
          if (!modified) {
            modified = {};
          }
          modified[key] = latest[key];
        }
      }
      return modified;
    }

    function Vue(options) {
      if (false) {
      }
      this._init(options);
    }

    initMixin(Vue);
    stateMixin(Vue);
    eventsMixin(Vue);
    lifecycleMixin(Vue);
    renderMixin(Vue);

    /*  */

    function initUse(Vue) {
      Vue.use = function (plugin) {
        var installedPlugins =
          this._installedPlugins || (this._installedPlugins = []);
        if (installedPlugins.indexOf(plugin) > -1) {
          return this;
        }

        // additional parameters
        var args = toArray(arguments, 1);
        args.unshift(this);
        if (typeof plugin.install === "function") {
          plugin.install.apply(plugin, args);
        } else if (typeof plugin === "function") {
          plugin.apply(null, args);
        }
        installedPlugins.push(plugin);
        return this;
      };
    }

    /*  */

    function initMixin$1(Vue) {
      Vue.mixin = function (mixin) {
        this.options = mergeOptions(this.options, mixin);
        return this;
      };
    }

    /*  */

    function initExtend(Vue) {
      /**
       * Each instance constructor, including Vue, has a unique
       * cid. This enables us to create wrapped "child
       * constructors" for prototypal inheritance and cache them.
       */
      Vue.cid = 0;
      var cid = 1;

      /**
       * Class inheritance
       */
      Vue.extend = function (extendOptions) {
        extendOptions = extendOptions || {};
        var Super = this;
        var SuperId = Super.cid;
        var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
        if (cachedCtors[SuperId]) {
          return cachedCtors[SuperId];
        }

        var name = extendOptions.name || Super.options.name;
        if (false) {
        }

        var Sub = function VueComponent(options) {
          this._init(options);
        };
        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.cid = cid++;
        Sub.options = mergeOptions(Super.options, extendOptions);
        Sub["super"] = Super;

        // For props and computed properties, we define the proxy getters on
        // the Vue instances at extension time, on the extended prototype. This
        // avoids Object.defineProperty calls for each instance created.
        if (Sub.options.props) {
          initProps$1(Sub);
        }
        if (Sub.options.computed) {
          initComputed$1(Sub);
        }

        // allow further extension/mixin/plugin usage
        Sub.extend = Super.extend;
        Sub.mixin = Super.mixin;
        Sub.use = Super.use;

        // create asset registers, so extended classes
        // can have their private assets too.
        ASSET_TYPES.forEach(function (type) {
          Sub[type] = Super[type];
        });
        // enable recursive self-lookup
        if (name) {
          Sub.options.components[name] = Sub;
        }

        // keep a reference to the super options at extension time.
        // later at instantiation we can check if Super's options have
        // been updated.
        Sub.superOptions = Super.options;
        Sub.extendOptions = extendOptions;
        Sub.sealedOptions = extend({}, Sub.options);

        // cache constructor
        cachedCtors[SuperId] = Sub;
        return Sub;
      };
    }

    function initProps$1(Comp) {
      var props = Comp.options.props;
      for (var key in props) {
        proxy(Comp.prototype, "_props", key);
      }
    }

    function initComputed$1(Comp) {
      var computed = Comp.options.computed;
      for (var key in computed) {
        defineComputed(Comp.prototype, key, computed[key]);
      }
    }

    /*  */

    function initAssetRegisters(Vue) {
      /**
       * Create asset registration methods.
       */
      ASSET_TYPES.forEach(function (type) {
        Vue[type] = function (id, definition) {
          if (!definition) {
            return this.options[type + "s"][id];
          } else {
            /* istanbul ignore if */
            if (false) {
            }
            if (type === "component" && isPlainObject(definition)) {
              definition.name = definition.name || id;
              definition = this.options._base.extend(definition);
            }
            if (type === "directive" && typeof definition === "function") {
              definition = { bind: definition, update: definition };
            }
            this.options[type + "s"][id] = definition;
            return definition;
          }
        };
      });
    }

    /*  */

    function getComponentName(opts) {
      return opts && (opts.Ctor.options.name || opts.tag);
    }

    function matches(pattern, name) {
      if (Array.isArray(pattern)) {
        return pattern.indexOf(name) > -1;
      } else if (typeof pattern === "string") {
        return pattern.split(",").indexOf(name) > -1;
      } else if (isRegExp(pattern)) {
        return pattern.test(name);
      }
      /* istanbul ignore next */
      return false;
    }

    function pruneCache(keepAliveInstance, filter) {
      var cache = keepAliveInstance.cache;
      var keys = keepAliveInstance.keys;
      var _vnode = keepAliveInstance._vnode;
      for (var key in cache) {
        var entry = cache[key];
        if (entry) {
          var name = entry.name;
          if (name && !filter(name)) {
            pruneCacheEntry(cache, key, keys, _vnode);
          }
        }
      }
    }

    function pruneCacheEntry(cache, key, keys, current) {
      var entry = cache[key];
      if (entry && (!current || entry.tag !== current.tag)) {
        entry.componentInstance.$destroy();
      }
      cache[key] = null;
      remove(keys, key);
    }

    var patternTypes = [String, RegExp, Array];

    var KeepAlive = {
      name: "keep-alive",
      abstract: true,

      props: {
        include: patternTypes,
        exclude: patternTypes,
        max: [String, Number],
      },

      methods: {
        cacheVNode: function cacheVNode() {
          var ref = this;
          var cache = ref.cache;
          var keys = ref.keys;
          var vnodeToCache = ref.vnodeToCache;
          var keyToCache = ref.keyToCache;
          if (vnodeToCache) {
            var tag = vnodeToCache.tag;
            var componentInstance = vnodeToCache.componentInstance;
            var componentOptions = vnodeToCache.componentOptions;
            cache[keyToCache] = {
              name: getComponentName(componentOptions),
              tag: tag,
              componentInstance: componentInstance,
            };
            keys.push(keyToCache);
            // prune oldest entry
            if (this.max && keys.length > parseInt(this.max)) {
              pruneCacheEntry(cache, keys[0], keys, this._vnode);
            }
            this.vnodeToCache = null;
          }
        },
      },

      created: function created() {
        this.cache = Object.create(null);
        this.keys = [];
      },

      destroyed: function destroyed() {
        for (var key in this.cache) {
          pruneCacheEntry(this.cache, key, this.keys);
        }
      },

      mounted: function mounted() {
        var this$1 = this;

        this.cacheVNode();
        this.$watch("include", function (val) {
          pruneCache(this$1, function (name) {
            return matches(val, name);
          });
        });
        this.$watch("exclude", function (val) {
          pruneCache(this$1, function (name) {
            return !matches(val, name);
          });
        });
      },

      updated: function updated() {
        this.cacheVNode();
      },

      render: function render() {
        var slot = this.$slots.default;
        var vnode = getFirstComponentChild(slot);
        var componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
          // check pattern
          var name = getComponentName(componentOptions);
          var ref = this;
          var include = ref.include;
          var exclude = ref.exclude;
          if (
            // not included
            (include && (!name || !matches(include, name))) ||
            // excluded
            (exclude && name && matches(exclude, name))
          ) {
            return vnode;
          }

          var ref$1 = this;
          var cache = ref$1.cache;
          var keys = ref$1.keys;
          var key =
            vnode.key == null
              ? // same constructor may get registered as different local components
                // so cid alone is not enough (#3269)
                componentOptions.Ctor.cid +
                (componentOptions.tag ? "::" + componentOptions.tag : "")
              : vnode.key;
          if (cache[key]) {
            vnode.componentInstance = cache[key].componentInstance;
            // make current key freshest
            remove(keys, key);
            keys.push(key);
          } else {
            // delay setting the cache until update
            this.vnodeToCache = vnode;
            this.keyToCache = key;
          }

          vnode.data.keepAlive = true;
        }
        return vnode || (slot && slot[0]);
      },
    };

    var builtInComponents = {
      KeepAlive: KeepAlive,
    };

    /*  */

    function initGlobalAPI(Vue) {
      // config
      var configDef = {};
      configDef.get = function () {
        return config;
      };
      if (false) {
      }
      Object.defineProperty(Vue, "config", configDef);

      // exposed util methods.
      // NOTE: these are not considered part of the public API - avoid relying on
      // them unless you are aware of the risk.
      Vue.util = {
        warn: warn,
        extend: extend,
        mergeOptions: mergeOptions,
        defineReactive: defineReactive$$1,
      };

      Vue.set = set;
      Vue.delete = del;
      Vue.nextTick = nextTick;

      // 2.6 explicit observable API
      Vue.observable = function (obj) {
        observe(obj);
        return obj;
      };

      Vue.options = Object.create(null);
      ASSET_TYPES.forEach(function (type) {
        Vue.options[type + "s"] = Object.create(null);
      });

      // this is used to identify the "base" constructor to extend all plain-object
      // components with in Weex's multi-instance scenarios.
      Vue.options._base = Vue;

      extend(Vue.options.components, builtInComponents);

      initUse(Vue);
      initMixin$1(Vue);
      initExtend(Vue);
      initAssetRegisters(Vue);
    }

    initGlobalAPI(Vue);

    Object.defineProperty(Vue.prototype, "$isServer", {
      get: isServerRendering,
    });

    Object.defineProperty(Vue.prototype, "$ssrContext", {
      get: function get() {
        /* istanbul ignore next */
        return this.$vnode && this.$vnode.ssrContext;
      },
    });

    // expose FunctionalRenderContext for ssr runtime helper installation
    Object.defineProperty(Vue, "FunctionalRenderContext", {
      value: FunctionalRenderContext,
    });

    Vue.version = "2.6.14";

    /*  */

    // these are reserved for web because they are directly compiled away
    // during template compilation
    var isReservedAttr = makeMap("style,class");

    // attributes that should be using props for binding
    var acceptValue = makeMap("input,textarea,option,select,progress");
    var mustUseProp = function (tag, type, attr) {
      return (
        (attr === "value" && acceptValue(tag) && type !== "button") ||
        (attr === "selected" && tag === "option") ||
        (attr === "checked" && tag === "input") ||
        (attr === "muted" && tag === "video")
      );
    };

    var isEnumeratedAttr = makeMap("contenteditable,draggable,spellcheck");

    var isValidContentEditableValue = makeMap(
      "events,caret,typing,plaintext-only"
    );

    var convertEnumeratedValue = function (key, value) {
      return isFalsyAttrValue(value) || value === "false"
        ? "false"
        : // allow arbitrary string value for contenteditable
        key === "contenteditable" && isValidContentEditableValue(value)
        ? value
        : "true";
    };

    var isBooleanAttr = makeMap(
      "allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare," +
        "default,defaultchecked,defaultmuted,defaultselected,defer,disabled," +
        "enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple," +
        "muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly," +
        "required,reversed,scoped,seamless,selected,sortable," +
        "truespeed,typemustmatch,visible"
    );

    var xlinkNS = "http://www.w3.org/1999/xlink";

    var isXlink = function (name) {
      return name.charAt(5) === ":" && name.slice(0, 5) === "xlink";
    };

    var getXlinkProp = function (name) {
      return isXlink(name) ? name.slice(6, name.length) : "";
    };

    var isFalsyAttrValue = function (val) {
      return val == null || val === false;
    };

    /*  */

    function genClassForVnode(vnode) {
      var data = vnode.data;
      var parentNode = vnode;
      var childNode = vnode;
      while (isDef(childNode.componentInstance)) {
        childNode = childNode.componentInstance._vnode;
        if (childNode && childNode.data) {
          data = mergeClassData(childNode.data, data);
        }
      }
      while (isDef((parentNode = parentNode.parent))) {
        if (parentNode && parentNode.data) {
          data = mergeClassData(data, parentNode.data);
        }
      }
      return renderClass(data.staticClass, data.class);
    }

    function mergeClassData(child, parent) {
      return {
        staticClass: concat(child.staticClass, parent.staticClass),
        class: isDef(child.class) ? [child.class, parent.class] : parent.class,
      };
    }

    function renderClass(staticClass, dynamicClass) {
      if (isDef(staticClass) || isDef(dynamicClass)) {
        return concat(staticClass, stringifyClass(dynamicClass));
      }
      /* istanbul ignore next */
      return "";
    }

    function concat(a, b) {
      return a ? (b ? a + " " + b : a) : b || "";
    }

    function stringifyClass(value) {
      if (Array.isArray(value)) {
        return stringifyArray(value);
      }
      if (isObject(value)) {
        return stringifyObject(value);
      }
      if (typeof value === "string") {
        return value;
      }
      /* istanbul ignore next */
      return "";
    }

    function stringifyArray(value) {
      var res = "";
      var stringified;
      for (var i = 0, l = value.length; i < l; i++) {
        if (
          isDef((stringified = stringifyClass(value[i]))) &&
          stringified !== ""
        ) {
          if (res) {
            res += " ";
          }
          res += stringified;
        }
      }
      return res;
    }

    function stringifyObject(value) {
      var res = "";
      for (var key in value) {
        if (value[key]) {
          if (res) {
            res += " ";
          }
          res += key;
        }
      }
      return res;
    }

    /*  */

    var namespaceMap = {
      svg: "http://www.w3.org/2000/svg",
      math: "http://www.w3.org/1998/Math/MathML",
    };

    var isHTMLTag = makeMap(
      "html,body,base,head,link,meta,style,title," +
        "address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section," +
        "div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul," +
        "a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby," +
        "s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video," +
        "embed,object,param,source,canvas,script,noscript,del,ins," +
        "caption,col,colgroup,table,thead,tbody,td,th,tr," +
        "button,datalist,fieldset,form,input,label,legend,meter,optgroup,option," +
        "output,progress,select,textarea," +
        "details,dialog,menu,menuitem,summary," +
        "content,element,shadow,template,blockquote,iframe,tfoot"
    );

    // this map is intentionally selective, only covering SVG elements that may
    // contain child elements.
    var isSVG = makeMap(
      "svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face," +
        "foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern," +
        "polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",
      true
    );

    var isReservedTag = function (tag) {
      return isHTMLTag(tag) || isSVG(tag);
    };

    function getTagNamespace(tag) {
      if (isSVG(tag)) {
        return "svg";
      }
      // basic support for MathML
      // note it doesn't support other MathML elements being component roots
      if (tag === "math") {
        return "math";
      }
    }

    var unknownElementCache = Object.create(null);
    function isUnknownElement(tag) {
      /* istanbul ignore if */
      if (!inBrowser) {
        return true;
      }
      if (isReservedTag(tag)) {
        return false;
      }
      tag = tag.toLowerCase();
      /* istanbul ignore if */
      if (unknownElementCache[tag] != null) {
        return unknownElementCache[tag];
      }
      var el = document.createElement(tag);
      if (tag.indexOf("-") > -1) {
        // http://stackoverflow.com/a/28210364/1070244
        return (unknownElementCache[tag] =
          el.constructor === window.HTMLUnknownElement ||
          el.constructor === window.HTMLElement);
      } else {
        return (unknownElementCache[tag] = /HTMLUnknownElement/.test(
          el.toString()
        ));
      }
    }

    var isTextInputType = makeMap("text,number,password,search,email,tel,url");

    /*  */

    /**
     * Query an element selector if it's not an element already.
     */
    function query(el) {
      if (typeof el === "string") {
        var selected = document.querySelector(el);
        if (!selected) {
          false && 0;
          return document.createElement("div");
        }
        return selected;
      } else {
        return el;
      }
    }

    /*  */

    function createElement$1(tagName, vnode) {
      var elm = document.createElement(tagName);
      if (tagName !== "select") {
        return elm;
      }
      // false or null will remove the attribute but undefined will not
      if (
        vnode.data &&
        vnode.data.attrs &&
        vnode.data.attrs.multiple !== undefined
      ) {
        elm.setAttribute("multiple", "multiple");
      }
      return elm;
    }

    function createElementNS(namespace, tagName) {
      return document.createElementNS(namespaceMap[namespace], tagName);
    }

    function createTextNode(text) {
      return document.createTextNode(text);
    }

    function createComment(text) {
      return document.createComment(text);
    }

    function insertBefore(parentNode, newNode, referenceNode) {
      parentNode.insertBefore(newNode, referenceNode);
    }

    function removeChild(node, child) {
      node.removeChild(child);
    }

    function appendChild(node, child) {
      node.appendChild(child);
    }

    function parentNode(node) {
      return node.parentNode;
    }

    function nextSibling(node) {
      return node.nextSibling;
    }

    function tagName(node) {
      return node.tagName;
    }

    function setTextContent(node, text) {
      node.textContent = text;
    }

    function setStyleScope(node, scopeId) {
      node.setAttribute(scopeId, "");
    }

    var nodeOps = /*#__PURE__*/ Object.freeze({
      createElement: createElement$1,
      createElementNS: createElementNS,
      createTextNode: createTextNode,
      createComment: createComment,
      insertBefore: insertBefore,
      removeChild: removeChild,
      appendChild: appendChild,
      parentNode: parentNode,
      nextSibling: nextSibling,
      tagName: tagName,
      setTextContent: setTextContent,
      setStyleScope: setStyleScope,
    });

    /*  */

    var ref = {
      create: function create(_, vnode) {
        registerRef(vnode);
      },
      update: function update(oldVnode, vnode) {
        if (oldVnode.data.ref !== vnode.data.ref) {
          registerRef(oldVnode, true);
          registerRef(vnode);
        }
      },
      destroy: function destroy(vnode) {
        registerRef(vnode, true);
      },
    };

    function registerRef(vnode, isRemoval) {
      var key = vnode.data.ref;
      if (!isDef(key)) {
        return;
      }

      var vm = vnode.context;
      var ref = vnode.componentInstance || vnode.elm;
      var refs = vm.$refs;
      if (isRemoval) {
        if (Array.isArray(refs[key])) {
          remove(refs[key], ref);
        } else if (refs[key] === ref) {
          refs[key] = undefined;
        }
      } else {
        if (vnode.data.refInFor) {
          if (!Array.isArray(refs[key])) {
            refs[key] = [ref];
          } else if (refs[key].indexOf(ref) < 0) {
            // $flow-disable-line
            refs[key].push(ref);
          }
        } else {
          refs[key] = ref;
        }
      }
    }

    /**
     * Virtual DOM patching algorithm based on Snabbdom by
     * Simon Friis Vindum (@paldepind)
     * Licensed under the MIT License
     * https://github.com/paldepind/snabbdom/blob/master/LICENSE
     *
     * modified by Evan You (@yyx990803)
     *
     * Not type-checking this because this file is perf-critical and the cost
     * of making flow understand it is not worth it.
     */

    var emptyNode = new VNode("", {}, []);

    var hooks = ["create", "activate", "update", "remove", "destroy"];

    function sameVnode(a, b) {
      return (
        a.key === b.key &&
        a.asyncFactory === b.asyncFactory &&
        ((a.tag === b.tag &&
          a.isComment === b.isComment &&
          isDef(a.data) === isDef(b.data) &&
          sameInputType(a, b)) ||
          (isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error)))
      );
    }

    function sameInputType(a, b) {
      if (a.tag !== "input") {
        return true;
      }
      var i;
      var typeA = isDef((i = a.data)) && isDef((i = i.attrs)) && i.type;
      var typeB = isDef((i = b.data)) && isDef((i = i.attrs)) && i.type;
      return (
        typeA === typeB || (isTextInputType(typeA) && isTextInputType(typeB))
      );
    }

    function createKeyToOldIdx(children, beginIdx, endIdx) {
      var i, key;
      var map = {};
      for (i = beginIdx; i <= endIdx; ++i) {
        key = children[i].key;
        if (isDef(key)) {
          map[key] = i;
        }
      }
      return map;
    }

    function createPatchFunction(backend) {
      var i, j;
      var cbs = {};

      var modules = backend.modules;
      var nodeOps = backend.nodeOps;

      for (i = 0; i < hooks.length; ++i) {
        cbs[hooks[i]] = [];
        for (j = 0; j < modules.length; ++j) {
          if (isDef(modules[j][hooks[i]])) {
            cbs[hooks[i]].push(modules[j][hooks[i]]);
          }
        }
      }

      function emptyNodeAt(elm) {
        return new VNode(
          nodeOps.tagName(elm).toLowerCase(),
          {},
          [],
          undefined,
          elm
        );
      }

      function createRmCb(childElm, listeners) {
        function remove$$1() {
          if (--remove$$1.listeners === 0) {
            removeNode(childElm);
          }
        }
        remove$$1.listeners = listeners;
        return remove$$1;
      }

      function removeNode(el) {
        var parent = nodeOps.parentNode(el);
        // element may have already been removed due to v-html / v-text
        if (isDef(parent)) {
          nodeOps.removeChild(parent, el);
        }
      }

      function isUnknownElement$$1(vnode, inVPre) {
        return (
          !inVPre &&
          !vnode.ns &&
          !(
            config.ignoredElements.length &&
            config.ignoredElements.some(function (ignore) {
              return isRegExp(ignore)
                ? ignore.test(vnode.tag)
                : ignore === vnode.tag;
            })
          ) &&
          config.isUnknownElement(vnode.tag)
        );
      }

      var creatingElmInVPre = 0;

      function createElm(
        vnode,
        insertedVnodeQueue,
        parentElm,
        refElm,
        nested,
        ownerArray,
        index
      ) {
        if (isDef(vnode.elm) && isDef(ownerArray)) {
          // This vnode was used in a previous render!
          // now it's used as a new node, overwriting its elm would cause
          // potential patch errors down the road when it's used as an insertion
          // reference node. Instead, we clone the node on-demand before creating
          // associated DOM element for it.
          vnode = ownerArray[index] = cloneVNode(vnode);
        }

        vnode.isRootInsert = !nested; // for transition enter check
        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
          return;
        }

        var data = vnode.data;
        var children = vnode.children;
        var tag = vnode.tag;
        if (isDef(tag)) {
          if (false) {
          }

          vnode.elm = vnode.ns
            ? nodeOps.createElementNS(vnode.ns, tag)
            : nodeOps.createElement(tag, vnode);
          setScope(vnode);

          /* istanbul ignore if */
          {
            createChildren(vnode, children, insertedVnodeQueue);
            if (isDef(data)) {
              invokeCreateHooks(vnode, insertedVnodeQueue);
            }
            insert(parentElm, vnode.elm, refElm);
          }

          if (false) {
          }
        } else if (isTrue(vnode.isComment)) {
          vnode.elm = nodeOps.createComment(vnode.text);
          insert(parentElm, vnode.elm, refElm);
        } else {
          vnode.elm = nodeOps.createTextNode(vnode.text);
          insert(parentElm, vnode.elm, refElm);
        }
      }

      function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i = vnode.data;
        if (isDef(i)) {
          var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
          if (isDef((i = i.hook)) && isDef((i = i.init))) {
            i(vnode, false /* hydrating */);
          }
          // after calling the init hook, if the vnode is a child component
          // it should've created a child instance and mounted it. the child
          // component also has set the placeholder vnode's elm.
          // in that case we can just return the element and be done.
          if (isDef(vnode.componentInstance)) {
            initComponent(vnode, insertedVnodeQueue);
            insert(parentElm, vnode.elm, refElm);
            if (isTrue(isReactivated)) {
              reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
            }
            return true;
          }
        }
      }

      function initComponent(vnode, insertedVnodeQueue) {
        if (isDef(vnode.data.pendingInsert)) {
          insertedVnodeQueue.push.apply(
            insertedVnodeQueue,
            vnode.data.pendingInsert
          );
          vnode.data.pendingInsert = null;
        }
        vnode.elm = vnode.componentInstance.$el;
        if (isPatchable(vnode)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
          setScope(vnode);
        } else {
          // empty component root.
          // skip all element-related modules except for ref (#3455)
          registerRef(vnode);
          // make sure to invoke the insert hook
          insertedVnodeQueue.push(vnode);
        }
      }

      function reactivateComponent(
        vnode,
        insertedVnodeQueue,
        parentElm,
        refElm
      ) {
        var i;
        // hack for #4339: a reactivated component with inner transition
        // does not trigger because the inner node's created hooks are not called
        // again. It's not ideal to involve module-specific logic in here but
        // there doesn't seem to be a better way to do it.
        var innerNode = vnode;
        while (innerNode.componentInstance) {
          innerNode = innerNode.componentInstance._vnode;
          if (isDef((i = innerNode.data)) && isDef((i = i.transition))) {
            for (i = 0; i < cbs.activate.length; ++i) {
              cbs.activate[i](emptyNode, innerNode);
            }
            insertedVnodeQueue.push(innerNode);
            break;
          }
        }
        // unlike a newly created component,
        // a reactivated keep-alive component doesn't insert itself
        insert(parentElm, vnode.elm, refElm);
      }

      function insert(parent, elm, ref$$1) {
        if (isDef(parent)) {
          if (isDef(ref$$1)) {
            if (nodeOps.parentNode(ref$$1) === parent) {
              nodeOps.insertBefore(parent, elm, ref$$1);
            }
          } else {
            nodeOps.appendChild(parent, elm);
          }
        }
      }

      function createChildren(vnode, children, insertedVnodeQueue) {
        if (Array.isArray(children)) {
          if (false) {
          }
          for (var i = 0; i < children.length; ++i) {
            createElm(
              children[i],
              insertedVnodeQueue,
              vnode.elm,
              null,
              true,
              children,
              i
            );
          }
        } else if (isPrimitive(vnode.text)) {
          nodeOps.appendChild(
            vnode.elm,
            nodeOps.createTextNode(String(vnode.text))
          );
        }
      }

      function isPatchable(vnode) {
        while (vnode.componentInstance) {
          vnode = vnode.componentInstance._vnode;
        }
        return isDef(vnode.tag);
      }

      function invokeCreateHooks(vnode, insertedVnodeQueue) {
        for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
          cbs.create[i$1](emptyNode, vnode);
        }
        i = vnode.data.hook; // Reuse variable
        if (isDef(i)) {
          if (isDef(i.create)) {
            i.create(emptyNode, vnode);
          }
          if (isDef(i.insert)) {
            insertedVnodeQueue.push(vnode);
          }
        }
      }

      // set scope id attribute for scoped CSS.
      // this is implemented as a special case to avoid the overhead
      // of going through the normal attribute patching process.
      function setScope(vnode) {
        var i;
        if (isDef((i = vnode.fnScopeId))) {
          nodeOps.setStyleScope(vnode.elm, i);
        } else {
          var ancestor = vnode;
          while (ancestor) {
            if (
              isDef((i = ancestor.context)) &&
              isDef((i = i.$options._scopeId))
            ) {
              nodeOps.setStyleScope(vnode.elm, i);
            }
            ancestor = ancestor.parent;
          }
        }
        // for slot content they should also get the scopeId from the host instance.
        if (
          isDef((i = activeInstance)) &&
          i !== vnode.context &&
          i !== vnode.fnContext &&
          isDef((i = i.$options._scopeId))
        ) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
      }

      function addVnodes(
        parentElm,
        refElm,
        vnodes,
        startIdx,
        endIdx,
        insertedVnodeQueue
      ) {
        for (; startIdx <= endIdx; ++startIdx) {
          createElm(
            vnodes[startIdx],
            insertedVnodeQueue,
            parentElm,
            refElm,
            false,
            vnodes,
            startIdx
          );
        }
      }

      function invokeDestroyHook(vnode) {
        var i, j;
        var data = vnode.data;
        if (isDef(data)) {
          if (isDef((i = data.hook)) && isDef((i = i.destroy))) {
            i(vnode);
          }
          for (i = 0; i < cbs.destroy.length; ++i) {
            cbs.destroy[i](vnode);
          }
        }
        if (isDef((i = vnode.children))) {
          for (j = 0; j < vnode.children.length; ++j) {
            invokeDestroyHook(vnode.children[j]);
          }
        }
      }

      function removeVnodes(vnodes, startIdx, endIdx) {
        for (; startIdx <= endIdx; ++startIdx) {
          var ch = vnodes[startIdx];
          if (isDef(ch)) {
            if (isDef(ch.tag)) {
              removeAndInvokeRemoveHook(ch);
              invokeDestroyHook(ch);
            } else {
              // Text node
              removeNode(ch.elm);
            }
          }
        }
      }

      function removeAndInvokeRemoveHook(vnode, rm) {
        if (isDef(rm) || isDef(vnode.data)) {
          var i;
          var listeners = cbs.remove.length + 1;
          if (isDef(rm)) {
            // we have a recursively passed down rm callback
            // increase the listeners count
            rm.listeners += listeners;
          } else {
            // directly removing
            rm = createRmCb(vnode.elm, listeners);
          }
          // recursively invoke hooks on child component root node
          if (
            isDef((i = vnode.componentInstance)) &&
            isDef((i = i._vnode)) &&
            isDef(i.data)
          ) {
            removeAndInvokeRemoveHook(i, rm);
          }
          for (i = 0; i < cbs.remove.length; ++i) {
            cbs.remove[i](vnode, rm);
          }
          if (isDef((i = vnode.data.hook)) && isDef((i = i.remove))) {
            i(vnode, rm);
          } else {
            rm();
          }
        } else {
          removeNode(vnode.elm);
        }
      }

      function updateChildren(
        parentElm,
        oldCh,
        newCh,
        insertedVnodeQueue,
        removeOnly
      ) {
        var oldStartIdx = 0;
        var newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

        // removeOnly is a special flag used only by <transition-group>
        // to ensure removed elements stay in correct relative positions
        // during leaving transitions
        var canMove = !removeOnly;

        if (false) {
        }

        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
          if (isUndef(oldStartVnode)) {
            oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
          } else if (isUndef(oldEndVnode)) {
            oldEndVnode = oldCh[--oldEndIdx];
          } else if (sameVnode(oldStartVnode, newStartVnode)) {
            patchVnode(
              oldStartVnode,
              newStartVnode,
              insertedVnodeQueue,
              newCh,
              newStartIdx
            );
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
          } else if (sameVnode(oldEndVnode, newEndVnode)) {
            patchVnode(
              oldEndVnode,
              newEndVnode,
              insertedVnodeQueue,
              newCh,
              newEndIdx
            );
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
          } else if (sameVnode(oldStartVnode, newEndVnode)) {
            // Vnode moved right
            patchVnode(
              oldStartVnode,
              newEndVnode,
              insertedVnodeQueue,
              newCh,
              newEndIdx
            );
            canMove &&
              nodeOps.insertBefore(
                parentElm,
                oldStartVnode.elm,
                nodeOps.nextSibling(oldEndVnode.elm)
              );
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
          } else if (sameVnode(oldEndVnode, newStartVnode)) {
            // Vnode moved left
            patchVnode(
              oldEndVnode,
              newStartVnode,
              insertedVnodeQueue,
              newCh,
              newStartIdx
            );
            canMove &&
              nodeOps.insertBefore(
                parentElm,
                oldEndVnode.elm,
                oldStartVnode.elm
              );
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
          } else {
            if (isUndef(oldKeyToIdx)) {
              oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            }
            idxInOld = isDef(newStartVnode.key)
              ? oldKeyToIdx[newStartVnode.key]
              : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
            if (isUndef(idxInOld)) {
              // New element
              createElm(
                newStartVnode,
                insertedVnodeQueue,
                parentElm,
                oldStartVnode.elm,
                false,
                newCh,
                newStartIdx
              );
            } else {
              vnodeToMove = oldCh[idxInOld];
              if (sameVnode(vnodeToMove, newStartVnode)) {
                patchVnode(
                  vnodeToMove,
                  newStartVnode,
                  insertedVnodeQueue,
                  newCh,
                  newStartIdx
                );
                oldCh[idxInOld] = undefined;
                canMove &&
                  nodeOps.insertBefore(
                    parentElm,
                    vnodeToMove.elm,
                    oldStartVnode.elm
                  );
              } else {
                // same key but different element. treat as new element
                createElm(
                  newStartVnode,
                  insertedVnodeQueue,
                  parentElm,
                  oldStartVnode.elm,
                  false,
                  newCh,
                  newStartIdx
                );
              }
            }
            newStartVnode = newCh[++newStartIdx];
          }
        }
        if (oldStartIdx > oldEndIdx) {
          refElm = isUndef(newCh[newEndIdx + 1])
            ? null
            : newCh[newEndIdx + 1].elm;
          addVnodes(
            parentElm,
            refElm,
            newCh,
            newStartIdx,
            newEndIdx,
            insertedVnodeQueue
          );
        } else if (newStartIdx > newEndIdx) {
          removeVnodes(oldCh, oldStartIdx, oldEndIdx);
        }
      }

      function checkDuplicateKeys(children) {
        var seenKeys = {};
        for (var i = 0; i < children.length; i++) {
          var vnode = children[i];
          var key = vnode.key;
          if (isDef(key)) {
            if (seenKeys[key]) {
              warn(
                "Duplicate keys detected: '" +
                  key +
                  "'. This may cause an update error.",
                vnode.context
              );
            } else {
              seenKeys[key] = true;
            }
          }
        }
      }

      function findIdxInOld(node, oldCh, start, end) {
        for (var i = start; i < end; i++) {
          var c = oldCh[i];
          if (isDef(c) && sameVnode(node, c)) {
            return i;
          }
        }
      }

      function patchVnode(
        oldVnode,
        vnode,
        insertedVnodeQueue,
        ownerArray,
        index,
        removeOnly
      ) {
        if (oldVnode === vnode) {
          return;
        }

        if (isDef(vnode.elm) && isDef(ownerArray)) {
          // clone reused vnode
          vnode = ownerArray[index] = cloneVNode(vnode);
        }

        var elm = (vnode.elm = oldVnode.elm);

        if (isTrue(oldVnode.isAsyncPlaceholder)) {
          if (isDef(vnode.asyncFactory.resolved)) {
            hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
          } else {
            vnode.isAsyncPlaceholder = true;
          }
          return;
        }

        // reuse element for static trees.
        // note we only do this if the vnode is cloned -
        // if the new node is not cloned it means the render functions have been
        // reset by the hot-reload-api and we need to do a proper re-render.
        if (
          isTrue(vnode.isStatic) &&
          isTrue(oldVnode.isStatic) &&
          vnode.key === oldVnode.key &&
          (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
        ) {
          vnode.componentInstance = oldVnode.componentInstance;
          return;
        }

        var i;
        var data = vnode.data;
        if (isDef(data) && isDef((i = data.hook)) && isDef((i = i.prepatch))) {
          i(oldVnode, vnode);
        }

        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (isDef(data) && isPatchable(vnode)) {
          for (i = 0; i < cbs.update.length; ++i) {
            cbs.update[i](oldVnode, vnode);
          }
          if (isDef((i = data.hook)) && isDef((i = i.update))) {
            i(oldVnode, vnode);
          }
        }
        if (isUndef(vnode.text)) {
          if (isDef(oldCh) && isDef(ch)) {
            if (oldCh !== ch) {
              updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
            }
          } else if (isDef(ch)) {
            if (false) {
            }
            if (isDef(oldVnode.text)) {
              nodeOps.setTextContent(elm, "");
            }
            addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
          } else if (isDef(oldCh)) {
            removeVnodes(oldCh, 0, oldCh.length - 1);
          } else if (isDef(oldVnode.text)) {
            nodeOps.setTextContent(elm, "");
          }
        } else if (oldVnode.text !== vnode.text) {
          nodeOps.setTextContent(elm, vnode.text);
        }
        if (isDef(data)) {
          if (isDef((i = data.hook)) && isDef((i = i.postpatch))) {
            i(oldVnode, vnode);
          }
        }
      }

      function invokeInsertHook(vnode, queue, initial) {
        // delay insert hooks for component root nodes, invoke them after the
        // element is really inserted
        if (isTrue(initial) && isDef(vnode.parent)) {
          vnode.parent.data.pendingInsert = queue;
        } else {
          for (var i = 0; i < queue.length; ++i) {
            queue[i].data.hook.insert(queue[i]);
          }
        }
      }

      var hydrationBailed = false;
      // list of modules that can skip create hook during hydration because they
      // are already rendered on the client or has no need for initialization
      // Note: style is excluded because it relies on initial clone for future
      // deep updates (#7063).
      var isRenderedModule = makeMap("attrs,class,staticClass,staticStyle,key");

      // Note: this is a browser-only function so we can assume elms are DOM nodes.
      function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
        var i;
        var tag = vnode.tag;
        var data = vnode.data;
        var children = vnode.children;
        inVPre = inVPre || (data && data.pre);
        vnode.elm = elm;

        if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
          vnode.isAsyncPlaceholder = true;
          return true;
        }
        // assert node match
        if (false) {
        }
        if (isDef(data)) {
          if (isDef((i = data.hook)) && isDef((i = i.init))) {
            i(vnode, true /* hydrating */);
          }
          if (isDef((i = vnode.componentInstance))) {
            // child component. it should have hydrated its own tree.
            initComponent(vnode, insertedVnodeQueue);
            return true;
          }
        }
        if (isDef(tag)) {
          if (isDef(children)) {
            // empty element, allow client to pick up and populate children
            if (!elm.hasChildNodes()) {
              createChildren(vnode, children, insertedVnodeQueue);
            } else {
              // v-html and domProps: innerHTML
              if (
                isDef((i = data)) &&
                isDef((i = i.domProps)) &&
                isDef((i = i.innerHTML))
              ) {
                if (i !== elm.innerHTML) {
                  /* istanbul ignore if */
                  if (false) {
                  }
                  return false;
                }
              } else {
                // iterate and compare children lists
                var childrenMatch = true;
                var childNode = elm.firstChild;
                for (var i$1 = 0; i$1 < children.length; i$1++) {
                  if (
                    !childNode ||
                    !hydrate(
                      childNode,
                      children[i$1],
                      insertedVnodeQueue,
                      inVPre
                    )
                  ) {
                    childrenMatch = false;
                    break;
                  }
                  childNode = childNode.nextSibling;
                }
                // if childNode is not null, it means the actual childNodes list is
                // longer than the virtual children list.
                if (!childrenMatch || childNode) {
                  /* istanbul ignore if */
                  if (false) {
                  }
                  return false;
                }
              }
            }
          }
          if (isDef(data)) {
            var fullInvoke = false;
            for (var key in data) {
              if (!isRenderedModule(key)) {
                fullInvoke = true;
                invokeCreateHooks(vnode, insertedVnodeQueue);
                break;
              }
            }
            if (!fullInvoke && data["class"]) {
              // ensure collecting deps for deep class bindings for future updates
              traverse(data["class"]);
            }
          }
        } else if (elm.data !== vnode.text) {
          elm.data = vnode.text;
        }
        return true;
      }

      function assertNodeMatch(node, vnode, inVPre) {
        if (isDef(vnode.tag)) {
          return (
            vnode.tag.indexOf("vue-component") === 0 ||
            (!isUnknownElement$$1(vnode, inVPre) &&
              vnode.tag.toLowerCase() ===
                (node.tagName && node.tagName.toLowerCase()))
          );
        } else {
          return node.nodeType === (vnode.isComment ? 8 : 3);
        }
      }

      return function patch(oldVnode, vnode, hydrating, removeOnly) {
        if (isUndef(vnode)) {
          if (isDef(oldVnode)) {
            invokeDestroyHook(oldVnode);
          }
          return;
        }

        var isInitialPatch = false;
        var insertedVnodeQueue = [];

        if (isUndef(oldVnode)) {
          // empty mount (likely as component), create new root element
          isInitialPatch = true;
          createElm(vnode, insertedVnodeQueue);
        } else {
          var isRealElement = isDef(oldVnode.nodeType);
          if (!isRealElement && sameVnode(oldVnode, vnode)) {
            // patch existing root node
            patchVnode(
              oldVnode,
              vnode,
              insertedVnodeQueue,
              null,
              null,
              removeOnly
            );
          } else {
            if (isRealElement) {
              // mounting to a real element
              // check if this is server-rendered content and if we can perform
              // a successful hydration.
              if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                oldVnode.removeAttribute(SSR_ATTR);
                hydrating = true;
              }
              if (isTrue(hydrating)) {
                if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                  invokeInsertHook(vnode, insertedVnodeQueue, true);
                  return oldVnode;
                } else if (false) {
                }
              }
              // either not server-rendered, or hydration failed.
              // create an empty node and replace it
              oldVnode = emptyNodeAt(oldVnode);
            }

            // replacing existing element
            var oldElm = oldVnode.elm;
            var parentElm = nodeOps.parentNode(oldElm);

            // create new node
            createElm(
              vnode,
              insertedVnodeQueue,
              // extremely rare edge case: do not insert if old element is in a
              // leaving transition. Only happens when combining transition +
              // keep-alive + HOCs. (#4590)
              oldElm._leaveCb ? null : parentElm,
              nodeOps.nextSibling(oldElm)
            );

            // update parent placeholder node element, recursively
            if (isDef(vnode.parent)) {
              var ancestor = vnode.parent;
              var patchable = isPatchable(vnode);
              while (ancestor) {
                for (var i = 0; i < cbs.destroy.length; ++i) {
                  cbs.destroy[i](ancestor);
                }
                ancestor.elm = vnode.elm;
                if (patchable) {
                  for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                    cbs.create[i$1](emptyNode, ancestor);
                  }
                  // #6513
                  // invoke insert hooks that may have been merged by create hooks.
                  // e.g. for directives that uses the "inserted" hook.
                  var insert = ancestor.data.hook.insert;
                  if (insert.merged) {
                    // start at index 1 to avoid re-invoking component mounted hook
                    for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                      insert.fns[i$2]();
                    }
                  }
                } else {
                  registerRef(ancestor);
                }
                ancestor = ancestor.parent;
              }
            }

            // destroy old node
            if (isDef(parentElm)) {
              removeVnodes([oldVnode], 0, 0);
            } else if (isDef(oldVnode.tag)) {
              invokeDestroyHook(oldVnode);
            }
          }
        }

        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
        return vnode.elm;
      };
    }

    /*  */

    var directives = {
      create: updateDirectives,
      update: updateDirectives,
      destroy: function unbindDirectives(vnode) {
        updateDirectives(vnode, emptyNode);
      },
    };

    function updateDirectives(oldVnode, vnode) {
      if (oldVnode.data.directives || vnode.data.directives) {
        _update(oldVnode, vnode);
      }
    }

    function _update(oldVnode, vnode) {
      var isCreate = oldVnode === emptyNode;
      var isDestroy = vnode === emptyNode;
      var oldDirs = normalizeDirectives$1(
        oldVnode.data.directives,
        oldVnode.context
      );
      var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

      var dirsWithInsert = [];
      var dirsWithPostpatch = [];

      var key, oldDir, dir;
      for (key in newDirs) {
        oldDir = oldDirs[key];
        dir = newDirs[key];
        if (!oldDir) {
          // new directive, bind
          callHook$1(dir, "bind", vnode, oldVnode);
          if (dir.def && dir.def.inserted) {
            dirsWithInsert.push(dir);
          }
        } else {
          // existing directive, update
          dir.oldValue = oldDir.value;
          dir.oldArg = oldDir.arg;
          callHook$1(dir, "update", vnode, oldVnode);
          if (dir.def && dir.def.componentUpdated) {
            dirsWithPostpatch.push(dir);
          }
        }
      }

      if (dirsWithInsert.length) {
        var callInsert = function () {
          for (var i = 0; i < dirsWithInsert.length; i++) {
            callHook$1(dirsWithInsert[i], "inserted", vnode, oldVnode);
          }
        };
        if (isCreate) {
          mergeVNodeHook(vnode, "insert", callInsert);
        } else {
          callInsert();
        }
      }

      if (dirsWithPostpatch.length) {
        mergeVNodeHook(vnode, "postpatch", function () {
          for (var i = 0; i < dirsWithPostpatch.length; i++) {
            callHook$1(
              dirsWithPostpatch[i],
              "componentUpdated",
              vnode,
              oldVnode
            );
          }
        });
      }

      if (!isCreate) {
        for (key in oldDirs) {
          if (!newDirs[key]) {
            // no longer present, unbind
            callHook$1(oldDirs[key], "unbind", oldVnode, oldVnode, isDestroy);
          }
        }
      }
    }

    var emptyModifiers = Object.create(null);

    function normalizeDirectives$1(dirs, vm) {
      var res = Object.create(null);
      if (!dirs) {
        // $flow-disable-line
        return res;
      }
      var i, dir;
      for (i = 0; i < dirs.length; i++) {
        dir = dirs[i];
        if (!dir.modifiers) {
          // $flow-disable-line
          dir.modifiers = emptyModifiers;
        }
        res[getRawDirName(dir)] = dir;
        dir.def = resolveAsset(vm.$options, "directives", dir.name, true);
      }
      // $flow-disable-line
      return res;
    }

    function getRawDirName(dir) {
      return (
        dir.rawName ||
        dir.name + "." + Object.keys(dir.modifiers || {}).join(".")
      );
    }

    function callHook$1(dir, hook, vnode, oldVnode, isDestroy) {
      var fn = dir.def && dir.def[hook];
      if (fn) {
        try {
          fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
        } catch (e) {
          handleError(
            e,
            vnode.context,
            "directive " + dir.name + " " + hook + " hook"
          );
        }
      }
    }

    var baseModules = [ref, directives];

    /*  */

    function updateAttrs(oldVnode, vnode) {
      var opts = vnode.componentOptions;
      if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
        return;
      }
      if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
        return;
      }
      var key, cur, old;
      var elm = vnode.elm;
      var oldAttrs = oldVnode.data.attrs || {};
      var attrs = vnode.data.attrs || {};
      // clone observed objects, as the user probably wants to mutate it
      if (isDef(attrs.__ob__)) {
        attrs = vnode.data.attrs = extend({}, attrs);
      }

      for (key in attrs) {
        cur = attrs[key];
        old = oldAttrs[key];
        if (old !== cur) {
          setAttr(elm, key, cur, vnode.data.pre);
        }
      }
      // #4391: in IE9, setting type can reset value for input[type=radio]
      // #6666: IE/Edge forces progress value down to 1 before setting a max
      /* istanbul ignore if */
      if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
        setAttr(elm, "value", attrs.value);
      }
      for (key in oldAttrs) {
        if (isUndef(attrs[key])) {
          if (isXlink(key)) {
            elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
          } else if (!isEnumeratedAttr(key)) {
            elm.removeAttribute(key);
          }
        }
      }
    }

    function setAttr(el, key, value, isInPre) {
      if (isInPre || el.tagName.indexOf("-") > -1) {
        baseSetAttr(el, key, value);
      } else if (isBooleanAttr(key)) {
        // set attribute for blank value
        // e.g. <option disabled>Select one</option>
        if (isFalsyAttrValue(value)) {
          el.removeAttribute(key);
        } else {
          // technically allowfullscreen is a boolean attribute for <iframe>,
          // but Flash expects a value of "true" when used on <embed> tag
          value =
            key === "allowfullscreen" && el.tagName === "EMBED" ? "true" : key;
          el.setAttribute(key, value);
        }
      } else if (isEnumeratedAttr(key)) {
        el.setAttribute(key, convertEnumeratedValue(key, value));
      } else if (isXlink(key)) {
        if (isFalsyAttrValue(value)) {
          el.removeAttributeNS(xlinkNS, getXlinkProp(key));
        } else {
          el.setAttributeNS(xlinkNS, key, value);
        }
      } else {
        baseSetAttr(el, key, value);
      }
    }

    function baseSetAttr(el, key, value) {
      if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
      } else {
        // #7138: IE10 & 11 fires input event when setting placeholder on
        // <textarea>... block the first input event and remove the blocker
        // immediately.
        /* istanbul ignore if */
        if (
          isIE &&
          !isIE9 &&
          el.tagName === "TEXTAREA" &&
          key === "placeholder" &&
          value !== "" &&
          !el.__ieph
        ) {
          var blocker = function (e) {
            e.stopImmediatePropagation();
            el.removeEventListener("input", blocker);
          };
          el.addEventListener("input", blocker);
          // $flow-disable-line
          el.__ieph = true; /* IE placeholder patched */
        }
        el.setAttribute(key, value);
      }
    }

    var attrs = {
      create: updateAttrs,
      update: updateAttrs,
    };

    /*  */

    function updateClass(oldVnode, vnode) {
      var el = vnode.elm;
      var data = vnode.data;
      var oldData = oldVnode.data;
      if (
        isUndef(data.staticClass) &&
        isUndef(data.class) &&
        (isUndef(oldData) ||
          (isUndef(oldData.staticClass) && isUndef(oldData.class)))
      ) {
        return;
      }

      var cls = genClassForVnode(vnode);

      // handle transition classes
      var transitionClass = el._transitionClasses;
      if (isDef(transitionClass)) {
        cls = concat(cls, stringifyClass(transitionClass));
      }

      // set the class
      if (cls !== el._prevClass) {
        el.setAttribute("class", cls);
        el._prevClass = cls;
      }
    }

    var klass = {
      create: updateClass,
      update: updateClass,
    };

    /*  */

    /*  */

    /*  */

    /*  */

    // in some cases, the event used has to be determined at runtime
    // so we used some reserved tokens during compile.
    var RANGE_TOKEN = "__r";
    var CHECKBOX_RADIO_TOKEN = "__c";

    /*  */

    // normalize v-model event tokens that can only be determined at runtime.
    // it's important to place the event as the first in the array because
    // the whole point is ensuring the v-model callback gets called before
    // user-attached handlers.
    function normalizeEvents(on) {
      /* istanbul ignore if */
      if (isDef(on[RANGE_TOKEN])) {
        // IE input[type=range] only supports `change` event
        var event = isIE ? "change" : "input";
        on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
        delete on[RANGE_TOKEN];
      }
      // This was originally intended to fix #4521 but no longer necessary
      // after 2.5. Keeping it for backwards compat with generated code from < 2.4
      /* istanbul ignore if */
      if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
        on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
        delete on[CHECKBOX_RADIO_TOKEN];
      }
    }

    var target$1;

    function createOnceHandler$1(event, handler, capture) {
      var _target = target$1; // save current target element in closure
      return function onceHandler() {
        var res = handler.apply(null, arguments);
        if (res !== null) {
          remove$2(event, onceHandler, capture, _target);
        }
      };
    }

    // #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
    // implementation and does not fire microtasks in between event propagation, so
    // safe to exclude.
    var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

    function add$1(name, handler, capture, passive) {
      // async edge case #6566: inner click event triggers patch, event handler
      // attached to outer element during patch, and triggered again. This
      // happens because browsers fire microtask ticks between event propagation.
      // the solution is simple: we save the timestamp when a handler is attached,
      // and the handler would only fire if the event passed to it was fired
      // AFTER it was attached.
      if (useMicrotaskFix) {
        var attachedTimestamp = currentFlushTimestamp;
        var original = handler;
        handler = original._wrapper = function (e) {
          if (
            // no bubbling, should always fire.
            // this is just a safety net in case event.timeStamp is unreliable in
            // certain weird environments...
            e.target === e.currentTarget ||
            // event is fired after handler attachment
            e.timeStamp >= attachedTimestamp ||
            // bail for environments that have buggy event.timeStamp implementations
            // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
            // #9681 QtWebEngine event.timeStamp is negative value
            e.timeStamp <= 0 ||
            // #9448 bail if event is fired in another document in a multi-page
            // electron/nw.js app, since event.timeStamp will be using a different
            // starting reference
            e.target.ownerDocument !== document
          ) {
            return original.apply(this, arguments);
          }
        };
      }
      target$1.addEventListener(
        name,
        handler,
        supportsPassive ? { capture: capture, passive: passive } : capture
      );
    }

    function remove$2(name, handler, capture, _target) {
      (_target || target$1).removeEventListener(
        name,
        handler._wrapper || handler,
        capture
      );
    }

    function updateDOMListeners(oldVnode, vnode) {
      if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
        return;
      }
      var on = vnode.data.on || {};
      var oldOn = oldVnode.data.on || {};
      target$1 = vnode.elm;
      normalizeEvents(on);
      updateListeners(
        on,
        oldOn,
        add$1,
        remove$2,
        createOnceHandler$1,
        vnode.context
      );
      target$1 = undefined;
    }

    var events = {
      create: updateDOMListeners,
      update: updateDOMListeners,
    };

    /*  */

    var svgContainer;

    function updateDOMProps(oldVnode, vnode) {
      if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
        return;
      }
      var key, cur;
      var elm = vnode.elm;
      var oldProps = oldVnode.data.domProps || {};
      var props = vnode.data.domProps || {};
      // clone observed objects, as the user probably wants to mutate it
      if (isDef(props.__ob__)) {
        props = vnode.data.domProps = extend({}, props);
      }

      for (key in oldProps) {
        if (!(key in props)) {
          elm[key] = "";
        }
      }

      for (key in props) {
        cur = props[key];
        // ignore children if the node has textContent or innerHTML,
        // as these will throw away existing DOM nodes and cause removal errors
        // on subsequent patches (#3360)
        if (key === "textContent" || key === "innerHTML") {
          if (vnode.children) {
            vnode.children.length = 0;
          }
          if (cur === oldProps[key]) {
            continue;
          }
          // #6601 work around Chrome version <= 55 bug where single textNode
          // replaced by innerHTML/textContent retains its parentNode property
          if (elm.childNodes.length === 1) {
            elm.removeChild(elm.childNodes[0]);
          }
        }

        if (key === "value" && elm.tagName !== "PROGRESS") {
          // store value as _value as well since
          // non-string values will be stringified
          elm._value = cur;
          // avoid resetting cursor position when value is the same
          var strCur = isUndef(cur) ? "" : String(cur);
          if (shouldUpdateValue(elm, strCur)) {
            elm.value = strCur;
          }
        } else if (
          key === "innerHTML" &&
          isSVG(elm.tagName) &&
          isUndef(elm.innerHTML)
        ) {
          // IE doesn't support innerHTML for SVG elements
          svgContainer = svgContainer || document.createElement("div");
          svgContainer.innerHTML = "<svg>" + cur + "</svg>";
          var svg = svgContainer.firstChild;
          while (elm.firstChild) {
            elm.removeChild(elm.firstChild);
          }
          while (svg.firstChild) {
            elm.appendChild(svg.firstChild);
          }
        } else if (
          // skip the update if old and new VDOM state is the same.
          // `value` is handled separately because the DOM value may be temporarily
          // out of sync with VDOM state due to focus, composition and modifiers.
          // This  #4521 by skipping the unnecessary `checked` update.
          cur !== oldProps[key]
        ) {
          // some property updates can throw
          // e.g. `value` on <progress> w/ non-finite value
          try {
            elm[key] = cur;
          } catch (e) {}
        }
      }
    }

    // check platforms/web/util/attrs.js acceptValue

    function shouldUpdateValue(elm, checkVal) {
      return (
        !elm.composing &&
        (elm.tagName === "OPTION" ||
          isNotInFocusAndDirty(elm, checkVal) ||
          isDirtyWithModifiers(elm, checkVal))
      );
    }

    function isNotInFocusAndDirty(elm, checkVal) {
      // return true when textbox (.number and .trim) loses focus and its value is
      // not equal to the updated value
      var notInFocus = true;
      // #6157
      // work around IE bug when accessing document.activeElement in an iframe
      try {
        notInFocus = document.activeElement !== elm;
      } catch (e) {}
      return notInFocus && elm.value !== checkVal;
    }

    function isDirtyWithModifiers(elm, newVal) {
      var value = elm.value;
      var modifiers = elm._vModifiers; // injected by v-model runtime
      if (isDef(modifiers)) {
        if (modifiers.number) {
          return toNumber(value) !== toNumber(newVal);
        }
        if (modifiers.trim) {
          return value.trim() !== newVal.trim();
        }
      }
      return value !== newVal;
    }

    var domProps = {
      create: updateDOMProps,
      update: updateDOMProps,
    };

    /*  */

    var parseStyleText = cached(function (cssText) {
      var res = {};
      var listDelimiter = /;(?![^(]*\))/g;
      var propertyDelimiter = /:(.+)/;
      cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
          var tmp = item.split(propertyDelimiter);
          tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
      });
      return res;
    });

    // merge static and dynamic style data on the same vnode
    function normalizeStyleData(data) {
      var style = normalizeStyleBinding(data.style);
      // static style is pre-processed into an object during compilation
      // and is always a fresh object, so it's safe to merge into it
      return data.staticStyle ? extend(data.staticStyle, style) : style;
    }

    // normalize possible array / string values into Object
    function normalizeStyleBinding(bindingStyle) {
      if (Array.isArray(bindingStyle)) {
        return toObject(bindingStyle);
      }
      if (typeof bindingStyle === "string") {
        return parseStyleText(bindingStyle);
      }
      return bindingStyle;
    }

    /**
     * parent component style should be after child's
     * so that parent component's style could override it
     */
    function getStyle(vnode, checkChild) {
      var res = {};
      var styleData;

      if (checkChild) {
        var childNode = vnode;
        while (childNode.componentInstance) {
          childNode = childNode.componentInstance._vnode;
          if (
            childNode &&
            childNode.data &&
            (styleData = normalizeStyleData(childNode.data))
          ) {
            extend(res, styleData);
          }
        }
      }

      if ((styleData = normalizeStyleData(vnode.data))) {
        extend(res, styleData);
      }

      var parentNode = vnode;
      while ((parentNode = parentNode.parent)) {
        if (
          parentNode.data &&
          (styleData = normalizeStyleData(parentNode.data))
        ) {
          extend(res, styleData);
        }
      }
      return res;
    }

    /*  */

    var cssVarRE = /^--/;
    var importantRE = /\s*!important$/;
    var setProp = function (el, name, val) {
      /* istanbul ignore if */
      if (cssVarRE.test(name)) {
        el.style.setProperty(name, val);
      } else if (importantRE.test(val)) {
        el.style.setProperty(
          hyphenate(name),
          val.replace(importantRE, ""),
          "important"
        );
      } else {
        var normalizedName = normalize(name);
        if (Array.isArray(val)) {
          // Support values array created by autoprefixer, e.g.
          // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
          // Set them one by one, and the browser will only set those it can recognize
          for (var i = 0, len = val.length; i < len; i++) {
            el.style[normalizedName] = val[i];
          }
        } else {
          el.style[normalizedName] = val;
        }
      }
    };

    var vendorNames = ["Webkit", "Moz", "ms"];

    var emptyStyle;
    var normalize = cached(function (prop) {
      emptyStyle = emptyStyle || document.createElement("div").style;
      prop = camelize(prop);
      if (prop !== "filter" && prop in emptyStyle) {
        return prop;
      }
      var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
      for (var i = 0; i < vendorNames.length; i++) {
        var name = vendorNames[i] + capName;
        if (name in emptyStyle) {
          return name;
        }
      }
    });

    function updateStyle(oldVnode, vnode) {
      var data = vnode.data;
      var oldData = oldVnode.data;

      if (
        isUndef(data.staticStyle) &&
        isUndef(data.style) &&
        isUndef(oldData.staticStyle) &&
        isUndef(oldData.style)
      ) {
        return;
      }

      var cur, name;
      var el = vnode.elm;
      var oldStaticStyle = oldData.staticStyle;
      var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

      // if static style exists, stylebinding already merged into it when doing normalizeStyleData
      var oldStyle = oldStaticStyle || oldStyleBinding;

      var style = normalizeStyleBinding(vnode.data.style) || {};

      // store normalized style under a different key for next diff
      // make sure to clone it if it's reactive, since the user likely wants
      // to mutate it.
      vnode.data.normalizedStyle = isDef(style.__ob__)
        ? extend({}, style)
        : style;

      var newStyle = getStyle(vnode, true);

      for (name in oldStyle) {
        if (isUndef(newStyle[name])) {
          setProp(el, name, "");
        }
      }
      for (name in newStyle) {
        cur = newStyle[name];
        if (cur !== oldStyle[name]) {
          // ie9 setting to null has no effect, must use empty string
          setProp(el, name, cur == null ? "" : cur);
        }
      }
    }

    var style = {
      create: updateStyle,
      update: updateStyle,
    };

    /*  */

    var whitespaceRE = /\s+/;

    /**
     * Add class with compatibility for SVG since classList is not supported on
     * SVG elements in IE
     */
    function addClass(el, cls) {
      /* istanbul ignore if */
      if (!cls || !(cls = cls.trim())) {
        return;
      }

      /* istanbul ignore else */
      if (el.classList) {
        if (cls.indexOf(" ") > -1) {
          cls.split(whitespaceRE).forEach(function (c) {
            return el.classList.add(c);
          });
        } else {
          el.classList.add(cls);
        }
      } else {
        var cur = " " + (el.getAttribute("class") || "") + " ";
        if (cur.indexOf(" " + cls + " ") < 0) {
          el.setAttribute("class", (cur + cls).trim());
        }
      }
    }

    /**
     * Remove class with compatibility for SVG since classList is not supported on
     * SVG elements in IE
     */
    function removeClass(el, cls) {
      /* istanbul ignore if */
      if (!cls || !(cls = cls.trim())) {
        return;
      }

      /* istanbul ignore else */
      if (el.classList) {
        if (cls.indexOf(" ") > -1) {
          cls.split(whitespaceRE).forEach(function (c) {
            return el.classList.remove(c);
          });
        } else {
          el.classList.remove(cls);
        }
        if (!el.classList.length) {
          el.removeAttribute("class");
        }
      } else {
        var cur = " " + (el.getAttribute("class") || "") + " ";
        var tar = " " + cls + " ";
        while (cur.indexOf(tar) >= 0) {
          cur = cur.replace(tar, " ");
        }
        cur = cur.trim();
        if (cur) {
          el.setAttribute("class", cur);
        } else {
          el.removeAttribute("class");
        }
      }
    }

    /*  */

    function resolveTransition(def$$1) {
      if (!def$$1) {
        return;
      }
      /* istanbul ignore else */
      if (typeof def$$1 === "object") {
        var res = {};
        if (def$$1.css !== false) {
          extend(res, autoCssTransition(def$$1.name || "v"));
        }
        extend(res, def$$1);
        return res;
      } else if (typeof def$$1 === "string") {
        return autoCssTransition(def$$1);
      }
    }

    var autoCssTransition = cached(function (name) {
      return {
        enterClass: name + "-enter",
        enterToClass: name + "-enter-to",
        enterActiveClass: name + "-enter-active",
        leaveClass: name + "-leave",
        leaveToClass: name + "-leave-to",
        leaveActiveClass: name + "-leave-active",
      };
    });

    var hasTransition = inBrowser && !isIE9;
    var TRANSITION = "transition";
    var ANIMATION = "animation";

    // Transition property/event sniffing
    var transitionProp = "transition";
    var transitionEndEvent = "transitionend";
    var animationProp = "animation";
    var animationEndEvent = "animationend";
    if (hasTransition) {
      /* istanbul ignore if */
      if (
        window.ontransitionend === undefined &&
        window.onwebkittransitionend !== undefined
      ) {
        transitionProp = "WebkitTransition";
        transitionEndEvent = "webkitTransitionEnd";
      }
      if (
        window.onanimationend === undefined &&
        window.onwebkitanimationend !== undefined
      ) {
        animationProp = "WebkitAnimation";
        animationEndEvent = "webkitAnimationEnd";
      }
    }

    // binding to window is necessary to make hot reload work in IE in strict mode
    var raf = inBrowser
      ? window.requestAnimationFrame
        ? window.requestAnimationFrame.bind(window)
        : setTimeout
      : /* istanbul ignore next */ function (fn) {
          return fn();
        };

    function nextFrame(fn) {
      raf(function () {
        raf(fn);
      });
    }

    function addTransitionClass(el, cls) {
      var transitionClasses =
        el._transitionClasses || (el._transitionClasses = []);
      if (transitionClasses.indexOf(cls) < 0) {
        transitionClasses.push(cls);
        addClass(el, cls);
      }
    }

    function removeTransitionClass(el, cls) {
      if (el._transitionClasses) {
        remove(el._transitionClasses, cls);
      }
      removeClass(el, cls);
    }

    function whenTransitionEnds(el, expectedType, cb) {
      var ref = getTransitionInfo(el, expectedType);
      var type = ref.type;
      var timeout = ref.timeout;
      var propCount = ref.propCount;
      if (!type) {
        return cb();
      }
      var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
      var ended = 0;
      var end = function () {
        el.removeEventListener(event, onEnd);
        cb();
      };
      var onEnd = function (e) {
        if (e.target === el) {
          if (++ended >= propCount) {
            end();
          }
        }
      };
      setTimeout(function () {
        if (ended < propCount) {
          end();
        }
      }, timeout + 1);
      el.addEventListener(event, onEnd);
    }

    var transformRE = /\b(transform|all)(,|$)/;

    function getTransitionInfo(el, expectedType) {
      var styles = window.getComputedStyle(el);
      // JSDOM may return undefined for transition properties
      var transitionDelays = (styles[transitionProp + "Delay"] || "").split(
        ", "
      );
      var transitionDurations = (
        styles[transitionProp + "Duration"] || ""
      ).split(", ");
      var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
      var animationDelays = (styles[animationProp + "Delay"] || "").split(", ");
      var animationDurations = (styles[animationProp + "Duration"] || "").split(
        ", "
      );
      var animationTimeout = getTimeout(animationDelays, animationDurations);

      var type;
      var timeout = 0;
      var propCount = 0;
      /* istanbul ignore if */
      if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
          type = TRANSITION;
          timeout = transitionTimeout;
          propCount = transitionDurations.length;
        }
      } else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
          type = ANIMATION;
          timeout = animationTimeout;
          propCount = animationDurations.length;
        }
      } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type =
          timeout > 0
            ? transitionTimeout > animationTimeout
              ? TRANSITION
              : ANIMATION
            : null;
        propCount = type
          ? type === TRANSITION
            ? transitionDurations.length
            : animationDurations.length
          : 0;
      }
      var hasTransform =
        type === TRANSITION &&
        transformRE.test(styles[transitionProp + "Property"]);
      return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform,
      };
    }

    function getTimeout(delays, durations) {
      /* istanbul ignore next */
      while (delays.length < durations.length) {
        delays = delays.concat(delays);
      }

      return Math.max.apply(
        null,
        durations.map(function (d, i) {
          return toMs(d) + toMs(delays[i]);
        })
      );
    }

    // Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
    // in a locale-dependent way, using a comma instead of a dot.
    // If comma is not replaced with a dot, the input will be rounded down (i.e. acting
    // as a floor function) causing unexpected behaviors
    function toMs(s) {
      return Number(s.slice(0, -1).replace(",", ".")) * 1000;
    }

    /*  */

    function enter(vnode, toggleDisplay) {
      var el = vnode.elm;

      // call leave callback now
      if (isDef(el._leaveCb)) {
        el._leaveCb.cancelled = true;
        el._leaveCb();
      }

      var data = resolveTransition(vnode.data.transition);
      if (isUndef(data)) {
        return;
      }

      /* istanbul ignore if */
      if (isDef(el._enterCb) || el.nodeType !== 1) {
        return;
      }

      var css = data.css;
      var type = data.type;
      var enterClass = data.enterClass;
      var enterToClass = data.enterToClass;
      var enterActiveClass = data.enterActiveClass;
      var appearClass = data.appearClass;
      var appearToClass = data.appearToClass;
      var appearActiveClass = data.appearActiveClass;
      var beforeEnter = data.beforeEnter;
      var enter = data.enter;
      var afterEnter = data.afterEnter;
      var enterCancelled = data.enterCancelled;
      var beforeAppear = data.beforeAppear;
      var appear = data.appear;
      var afterAppear = data.afterAppear;
      var appearCancelled = data.appearCancelled;
      var duration = data.duration;

      // activeInstance will always be the <transition> component managing this
      // transition. One edge case to check is when the <transition> is placed
      // as the root node of a child component. In that case we need to check
      // <transition>'s parent for appear check.
      var context = activeInstance;
      var transitionNode = activeInstance.$vnode;
      while (transitionNode && transitionNode.parent) {
        context = transitionNode.context;
        transitionNode = transitionNode.parent;
      }

      var isAppear = !context._isMounted || !vnode.isRootInsert;

      if (isAppear && !appear && appear !== "") {
        return;
      }

      var startClass = isAppear && appearClass ? appearClass : enterClass;
      var activeClass =
        isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
      var toClass = isAppear && appearToClass ? appearToClass : enterToClass;

      var beforeEnterHook = isAppear
        ? beforeAppear || beforeEnter
        : beforeEnter;
      var enterHook = isAppear
        ? typeof appear === "function"
          ? appear
          : enter
        : enter;
      var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
      var enterCancelledHook = isAppear
        ? appearCancelled || enterCancelled
        : enterCancelled;

      var explicitEnterDuration = toNumber(
        isObject(duration) ? duration.enter : duration
      );

      if (false) {
      }

      var expectsCSS = css !== false && !isIE9;
      var userWantsControl = getHookArgumentsLength(enterHook);

      var cb = (el._enterCb = once(function () {
        if (expectsCSS) {
          removeTransitionClass(el, toClass);
          removeTransitionClass(el, activeClass);
        }
        if (cb.cancelled) {
          if (expectsCSS) {
            removeTransitionClass(el, startClass);
          }
          enterCancelledHook && enterCancelledHook(el);
        } else {
          afterEnterHook && afterEnterHook(el);
        }
        el._enterCb = null;
      }));

      if (!vnode.data.show) {
        // remove pending leave element on enter by injecting an insert hook
        mergeVNodeHook(vnode, "insert", function () {
          var parent = el.parentNode;
          var pendingNode =
            parent && parent._pending && parent._pending[vnode.key];
          if (
            pendingNode &&
            pendingNode.tag === vnode.tag &&
            pendingNode.elm._leaveCb
          ) {
            pendingNode.elm._leaveCb();
          }
          enterHook && enterHook(el, cb);
        });
      }

      // start enter transition
      beforeEnterHook && beforeEnterHook(el);
      if (expectsCSS) {
        addTransitionClass(el, startClass);
        addTransitionClass(el, activeClass);
        nextFrame(function () {
          removeTransitionClass(el, startClass);
          if (!cb.cancelled) {
            addTransitionClass(el, toClass);
            if (!userWantsControl) {
              if (isValidDuration(explicitEnterDuration)) {
                setTimeout(cb, explicitEnterDuration);
              } else {
                whenTransitionEnds(el, type, cb);
              }
            }
          }
        });
      }

      if (vnode.data.show) {
        toggleDisplay && toggleDisplay();
        enterHook && enterHook(el, cb);
      }

      if (!expectsCSS && !userWantsControl) {
        cb();
      }
    }

    function leave(vnode, rm) {
      var el = vnode.elm;

      // call enter callback now
      if (isDef(el._enterCb)) {
        el._enterCb.cancelled = true;
        el._enterCb();
      }

      var data = resolveTransition(vnode.data.transition);
      if (isUndef(data) || el.nodeType !== 1) {
        return rm();
      }

      /* istanbul ignore if */
      if (isDef(el._leaveCb)) {
        return;
      }

      var css = data.css;
      var type = data.type;
      var leaveClass = data.leaveClass;
      var leaveToClass = data.leaveToClass;
      var leaveActiveClass = data.leaveActiveClass;
      var beforeLeave = data.beforeLeave;
      var leave = data.leave;
      var afterLeave = data.afterLeave;
      var leaveCancelled = data.leaveCancelled;
      var delayLeave = data.delayLeave;
      var duration = data.duration;

      var expectsCSS = css !== false && !isIE9;
      var userWantsControl = getHookArgumentsLength(leave);

      var explicitLeaveDuration = toNumber(
        isObject(duration) ? duration.leave : duration
      );

      if (false) {
      }

      var cb = (el._leaveCb = once(function () {
        if (el.parentNode && el.parentNode._pending) {
          el.parentNode._pending[vnode.key] = null;
        }
        if (expectsCSS) {
          removeTransitionClass(el, leaveToClass);
          removeTransitionClass(el, leaveActiveClass);
        }
        if (cb.cancelled) {
          if (expectsCSS) {
            removeTransitionClass(el, leaveClass);
          }
          leaveCancelled && leaveCancelled(el);
        } else {
          rm();
          afterLeave && afterLeave(el);
        }
        el._leaveCb = null;
      }));

      if (delayLeave) {
        delayLeave(performLeave);
      } else {
        performLeave();
      }

      function performLeave() {
        // the delayed leave may have already been cancelled
        if (cb.cancelled) {
          return;
        }
        // record leaving element
        if (!vnode.data.show && el.parentNode) {
          (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] =
            vnode;
        }
        beforeLeave && beforeLeave(el);
        if (expectsCSS) {
          addTransitionClass(el, leaveClass);
          addTransitionClass(el, leaveActiveClass);
          nextFrame(function () {
            removeTransitionClass(el, leaveClass);
            if (!cb.cancelled) {
              addTransitionClass(el, leaveToClass);
              if (!userWantsControl) {
                if (isValidDuration(explicitLeaveDuration)) {
                  setTimeout(cb, explicitLeaveDuration);
                } else {
                  whenTransitionEnds(el, type, cb);
                }
              }
            }
          });
        }
        leave && leave(el, cb);
        if (!expectsCSS && !userWantsControl) {
          cb();
        }
      }
    }

    // only used in dev mode
    function checkDuration(val, name, vnode) {
      if (typeof val !== "number") {
        warn(
          "<transition> explicit " +
            name +
            " duration is not a valid number - " +
            "got " +
            JSON.stringify(val) +
            ".",
          vnode.context
        );
      } else if (isNaN(val)) {
        warn(
          "<transition> explicit " +
            name +
            " duration is NaN - " +
            "the duration expression might be incorrect.",
          vnode.context
        );
      }
    }

    function isValidDuration(val) {
      return typeof val === "number" && !isNaN(val);
    }

    /**
     * Normalize a transition hook's argument length. The hook may be:
     * - a merged hook (invoker) with the original in .fns
     * - a wrapped component method (check ._length)
     * - a plain function (.length)
     */
    function getHookArgumentsLength(fn) {
      if (isUndef(fn)) {
        return false;
      }
      var invokerFns = fn.fns;
      if (isDef(invokerFns)) {
        // invoker
        return getHookArgumentsLength(
          Array.isArray(invokerFns) ? invokerFns[0] : invokerFns
        );
      } else {
        return (fn._length || fn.length) > 1;
      }
    }

    function _enter(_, vnode) {
      if (vnode.data.show !== true) {
        enter(vnode);
      }
    }

    var transition = inBrowser
      ? {
          create: _enter,
          activate: _enter,
          remove: function remove$$1(vnode, rm) {
            /* istanbul ignore else */
            if (vnode.data.show !== true) {
              leave(vnode, rm);
            } else {
              rm();
            }
          },
        }
      : {};

    var platformModules = [attrs, klass, events, domProps, style, transition];

    /*  */

    // the directive module should be applied last, after all
    // built-in modules have been applied.
    var modules = platformModules.concat(baseModules);

    var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

    /**
     * Not type checking this file because flow doesn't like attaching
     * properties to Elements.
     */

    /* istanbul ignore if */
    if (isIE9) {
      // http://www.matts411.com/post/internet-explorer-9-oninput/
      document.addEventListener("selectionchange", function () {
        var el = document.activeElement;
        if (el && el.vmodel) {
          trigger(el, "input");
        }
      });
    }

    var directive = {
      inserted: function inserted(el, binding, vnode, oldVnode) {
        if (vnode.tag === "select") {
          // #6903
          if (oldVnode.elm && !oldVnode.elm._vOptions) {
            mergeVNodeHook(vnode, "postpatch", function () {
              directive.componentUpdated(el, binding, vnode);
            });
          } else {
            setSelected(el, binding, vnode.context);
          }
          el._vOptions = [].map.call(el.options, getValue);
        } else if (vnode.tag === "textarea" || isTextInputType(el.type)) {
          el._vModifiers = binding.modifiers;
          if (!binding.modifiers.lazy) {
            el.addEventListener("compositionstart", onCompositionStart);
            el.addEventListener("compositionend", onCompositionEnd);
            // Safari < 10.2 & UIWebView doesn't fire compositionend when
            // switching focus before confirming composition choice
            // this also fixes the issue where some browsers e.g. iOS Chrome
            // fires "change" instead of "input" on autocomplete.
            el.addEventListener("change", onCompositionEnd);
            /* istanbul ignore if */
            if (isIE9) {
              el.vmodel = true;
            }
          }
        }
      },

      componentUpdated: function componentUpdated(el, binding, vnode) {
        if (vnode.tag === "select") {
          setSelected(el, binding, vnode.context);
          // in case the options rendered by v-for have changed,
          // it's possible that the value is out-of-sync with the rendered options.
          // detect such cases and filter out values that no longer has a matching
          // option in the DOM.
          var prevOptions = el._vOptions;
          var curOptions = (el._vOptions = [].map.call(el.options, getValue));
          if (
            curOptions.some(function (o, i) {
              return !looseEqual(o, prevOptions[i]);
            })
          ) {
            // trigger change event if
            // no matching option found for at least one value
            var needReset = el.multiple
              ? binding.value.some(function (v) {
                  return hasNoMatchingOption(v, curOptions);
                })
              : binding.value !== binding.oldValue &&
                hasNoMatchingOption(binding.value, curOptions);
            if (needReset) {
              trigger(el, "change");
            }
          }
        }
      },
    };

    function setSelected(el, binding, vm) {
      actuallySetSelected(el, binding, vm);
      /* istanbul ignore if */
      if (isIE || isEdge) {
        setTimeout(function () {
          actuallySetSelected(el, binding, vm);
        }, 0);
      }
    }

    function actuallySetSelected(el, binding, vm) {
      var value = binding.value;
      var isMultiple = el.multiple;
      if (isMultiple && !Array.isArray(value)) {
        false && 0;
        return;
      }
      var selected, option;
      for (var i = 0, l = el.options.length; i < l; i++) {
        option = el.options[i];
        if (isMultiple) {
          selected = looseIndexOf(value, getValue(option)) > -1;
          if (option.selected !== selected) {
            option.selected = selected;
          }
        } else {
          if (looseEqual(getValue(option), value)) {
            if (el.selectedIndex !== i) {
              el.selectedIndex = i;
            }
            return;
          }
        }
      }
      if (!isMultiple) {
        el.selectedIndex = -1;
      }
    }

    function hasNoMatchingOption(value, options) {
      return options.every(function (o) {
        return !looseEqual(o, value);
      });
    }

    function getValue(option) {
      return "_value" in option ? option._value : option.value;
    }

    function onCompositionStart(e) {
      e.target.composing = true;
    }

    function onCompositionEnd(e) {
      // prevent triggering an input event for no reason
      if (!e.target.composing) {
        return;
      }
      e.target.composing = false;
      trigger(e.target, "input");
    }

    function trigger(el, type) {
      var e = document.createEvent("HTMLEvents");
      e.initEvent(type, true, true);
      el.dispatchEvent(e);
    }

    /*  */

    // recursively search for possible transition defined inside the component root
    function locateNode(vnode) {
      return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
        ? locateNode(vnode.componentInstance._vnode)
        : vnode;
    }

    var show = {
      bind: function bind(el, ref, vnode) {
        var value = ref.value;

        vnode = locateNode(vnode);
        var transition$$1 = vnode.data && vnode.data.transition;
        var originalDisplay = (el.__vOriginalDisplay =
          el.style.display === "none" ? "" : el.style.display);
        if (value && transition$$1) {
          vnode.data.show = true;
          enter(vnode, function () {
            el.style.display = originalDisplay;
          });
        } else {
          el.style.display = value ? originalDisplay : "none";
        }
      },

      update: function update(el, ref, vnode) {
        var value = ref.value;
        var oldValue = ref.oldValue;

        /* istanbul ignore if */
        if (!value === !oldValue) {
          return;
        }
        vnode = locateNode(vnode);
        var transition$$1 = vnode.data && vnode.data.transition;
        if (transition$$1) {
          vnode.data.show = true;
          if (value) {
            enter(vnode, function () {
              el.style.display = el.__vOriginalDisplay;
            });
          } else {
            leave(vnode, function () {
              el.style.display = "none";
            });
          }
        } else {
          el.style.display = value ? el.__vOriginalDisplay : "none";
        }
      },

      unbind: function unbind(el, binding, vnode, oldVnode, isDestroy) {
        if (!isDestroy) {
          el.style.display = el.__vOriginalDisplay;
        }
      },
    };

    var platformDirectives = {
      model: directive,
      show: show,
    };

    /*  */

    var transitionProps = {
      name: String,
      appear: Boolean,
      css: Boolean,
      mode: String,
      type: String,
      enterClass: String,
      leaveClass: String,
      enterToClass: String,
      leaveToClass: String,
      enterActiveClass: String,
      leaveActiveClass: String,
      appearClass: String,
      appearActiveClass: String,
      appearToClass: String,
      duration: [Number, String, Object],
    };

    // in case the child is also an abstract component, e.g. <keep-alive>
    // we want to recursively retrieve the real component to be rendered
    function getRealChild(vnode) {
      var compOptions = vnode && vnode.componentOptions;
      if (compOptions && compOptions.Ctor.options.abstract) {
        return getRealChild(getFirstComponentChild(compOptions.children));
      } else {
        return vnode;
      }
    }

    function extractTransitionData(comp) {
      var data = {};
      var options = comp.$options;
      // props
      for (var key in options.propsData) {
        data[key] = comp[key];
      }
      // events.
      // extract listeners and pass them directly to the transition methods
      var listeners = options._parentListeners;
      for (var key$1 in listeners) {
        data[camelize(key$1)] = listeners[key$1];
      }
      return data;
    }

    function placeholder(h, rawChild) {
      if (/\d-keep-alive$/.test(rawChild.tag)) {
        return h("keep-alive", {
          props: rawChild.componentOptions.propsData,
        });
      }
    }

    function hasParentTransition(vnode) {
      while ((vnode = vnode.parent)) {
        if (vnode.data.transition) {
          return true;
        }
      }
    }

    function isSameChild(child, oldChild) {
      return oldChild.key === child.key && oldChild.tag === child.tag;
    }

    var isNotTextNode = function (c) {
      return c.tag || isAsyncPlaceholder(c);
    };

    var isVShowDirective = function (d) {
      return d.name === "show";
    };

    var Transition = {
      name: "transition",
      props: transitionProps,
      abstract: true,

      render: function render(h) {
        var this$1 = this;

        var children = this.$slots.default;
        if (!children) {
          return;
        }

        // filter out text nodes (possible whitespaces)
        children = children.filter(isNotTextNode);
        /* istanbul ignore if */
        if (!children.length) {
          return;
        }

        // warn multiple elements
        if (false) {
        }

        var mode = this.mode;

        // warn invalid mode
        if (false) {
        }

        var rawChild = children[0];

        // if this is a component root node and the component's
        // parent container node also has transition, skip.
        if (hasParentTransition(this.$vnode)) {
          return rawChild;
        }

        // apply transition data to child
        // use getRealChild() to ignore abstract components e.g. keep-alive
        var child = getRealChild(rawChild);
        /* istanbul ignore if */
        if (!child) {
          return rawChild;
        }

        if (this._leaving) {
          return placeholder(h, rawChild);
        }

        // ensure a key that is unique to the vnode type and to this transition
        // component instance. This key will be used to remove pending leaving nodes
        // during entering.
        var id = "__transition-" + this._uid + "-";
        child.key =
          child.key == null
            ? child.isComment
              ? id + "comment"
              : id + child.tag
            : isPrimitive(child.key)
            ? String(child.key).indexOf(id) === 0
              ? child.key
              : id + child.key
            : child.key;

        var data = ((child.data || (child.data = {})).transition =
          extractTransitionData(this));
        var oldRawChild = this._vnode;
        var oldChild = getRealChild(oldRawChild);

        // mark v-show
        // so that the transition module can hand over the control to the directive
        if (
          child.data.directives &&
          child.data.directives.some(isVShowDirective)
        ) {
          child.data.show = true;
        }

        if (
          oldChild &&
          oldChild.data &&
          !isSameChild(child, oldChild) &&
          !isAsyncPlaceholder(oldChild) &&
          // #6687 component root is a comment node
          !(
            oldChild.componentInstance &&
            oldChild.componentInstance._vnode.isComment
          )
        ) {
          // replace old child transition data with fresh one
          // important for dynamic transitions!
          var oldData = (oldChild.data.transition = extend({}, data));
          // handle transition mode
          if (mode === "out-in") {
            // return placeholder node and queue update when leave finishes
            this._leaving = true;
            mergeVNodeHook(oldData, "afterLeave", function () {
              this$1._leaving = false;
              this$1.$forceUpdate();
            });
            return placeholder(h, rawChild);
          } else if (mode === "in-out") {
            if (isAsyncPlaceholder(child)) {
              return oldRawChild;
            }
            var delayedLeave;
            var performLeave = function () {
              delayedLeave();
            };
            mergeVNodeHook(data, "afterEnter", performLeave);
            mergeVNodeHook(data, "enterCancelled", performLeave);
            mergeVNodeHook(oldData, "delayLeave", function (leave) {
              delayedLeave = leave;
            });
          }
        }

        return rawChild;
      },
    };

    /*  */

    var props = extend(
      {
        tag: String,
        moveClass: String,
      },
      transitionProps
    );

    delete props.mode;

    var TransitionGroup = {
      props: props,

      beforeMount: function beforeMount() {
        var this$1 = this;

        var update = this._update;
        this._update = function (vnode, hydrating) {
          var restoreActiveInstance = setActiveInstance(this$1);
          // force removing pass
          this$1.__patch__(
            this$1._vnode,
            this$1.kept,
            false, // hydrating
            true // removeOnly (!important, avoids unnecessary moves)
          );
          this$1._vnode = this$1.kept;
          restoreActiveInstance();
          update.call(this$1, vnode, hydrating);
        };
      },

      render: function render(h) {
        var tag = this.tag || this.$vnode.data.tag || "span";
        var map = Object.create(null);
        var prevChildren = (this.prevChildren = this.children);
        var rawChildren = this.$slots.default || [];
        var children = (this.children = []);
        var transitionData = extractTransitionData(this);

        for (var i = 0; i < rawChildren.length; i++) {
          var c = rawChildren[i];
          if (c.tag) {
            if (c.key != null && String(c.key).indexOf("__vlist") !== 0) {
              children.push(c);
              map[c.key] = c;
              (c.data || (c.data = {})).transition = transitionData;
            } else if (false) {
              var name, opts;
            }
          }
        }

        if (prevChildren) {
          var kept = [];
          var removed = [];
          for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
            var c$1 = prevChildren[i$1];
            c$1.data.transition = transitionData;
            c$1.data.pos = c$1.elm.getBoundingClientRect();
            if (map[c$1.key]) {
              kept.push(c$1);
            } else {
              removed.push(c$1);
            }
          }
          this.kept = h(tag, null, kept);
          this.removed = removed;
        }

        return h(tag, null, children);
      },

      updated: function updated() {
        var children = this.prevChildren;
        var moveClass = this.moveClass || (this.name || "v") + "-move";
        if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
          return;
        }

        // we divide the work into three loops to avoid mixing DOM reads and writes
        // in each iteration - which helps prevent layout thrashing.
        children.forEach(callPendingCbs);
        children.forEach(recordPosition);
        children.forEach(applyTranslation);

        // force reflow to put everything in position
        // assign to this to avoid being removed in tree-shaking
        // $flow-disable-line
        this._reflow = document.body.offsetHeight;

        children.forEach(function (c) {
          if (c.data.moved) {
            var el = c.elm;
            var s = el.style;
            addTransitionClass(el, moveClass);
            s.transform = s.WebkitTransform = s.transitionDuration = "";
            el.addEventListener(
              transitionEndEvent,
              (el._moveCb = function cb(e) {
                if (e && e.target !== el) {
                  return;
                }
                if (!e || /transform$/.test(e.propertyName)) {
                  el.removeEventListener(transitionEndEvent, cb);
                  el._moveCb = null;
                  removeTransitionClass(el, moveClass);
                }
              })
            );
          }
        });
      },

      methods: {
        hasMove: function hasMove(el, moveClass) {
          /* istanbul ignore if */
          if (!hasTransition) {
            return false;
          }
          /* istanbul ignore if */
          if (this._hasMove) {
            return this._hasMove;
          }
          // Detect whether an element with the move class applied has
          // CSS transitions. Since the element may be inside an entering
          // transition at this very moment, we make a clone of it and remove
          // all other transition classes applied to ensure only the move class
          // is applied.
          var clone = el.cloneNode();
          if (el._transitionClasses) {
            el._transitionClasses.forEach(function (cls) {
              removeClass(clone, cls);
            });
          }
          addClass(clone, moveClass);
          clone.style.display = "none";
          this.$el.appendChild(clone);
          var info = getTransitionInfo(clone);
          this.$el.removeChild(clone);
          return (this._hasMove = info.hasTransform);
        },
      },
    };

    function callPendingCbs(c) {
      /* istanbul ignore if */
      if (c.elm._moveCb) {
        c.elm._moveCb();
      }
      /* istanbul ignore if */
      if (c.elm._enterCb) {
        c.elm._enterCb();
      }
    }

    function recordPosition(c) {
      c.data.newPos = c.elm.getBoundingClientRect();
    }

    function applyTranslation(c) {
      var oldPos = c.data.pos;
      var newPos = c.data.newPos;
      var dx = oldPos.left - newPos.left;
      var dy = oldPos.top - newPos.top;
      if (dx || dy) {
        c.data.moved = true;
        var s = c.elm.style;
        s.transform = s.WebkitTransform =
          "translate(" + dx + "px," + dy + "px)";
        s.transitionDuration = "0s";
      }
    }

    var platformComponents = {
      Transition: Transition,
      TransitionGroup: TransitionGroup,
    };

    /*  */

    // install platform specific utils
    Vue.config.mustUseProp = mustUseProp;
    Vue.config.isReservedTag = isReservedTag;
    Vue.config.isReservedAttr = isReservedAttr;
    Vue.config.getTagNamespace = getTagNamespace;
    Vue.config.isUnknownElement = isUnknownElement;

    // install platform runtime directives & components
    extend(Vue.options.directives, platformDirectives);
    extend(Vue.options.components, platformComponents);

    // install platform patch function
    Vue.prototype.__patch__ = inBrowser ? patch : noop;

    // public mount method
    Vue.prototype.$mount = function (el, hydrating) {
      el = el && inBrowser ? query(el) : undefined;
      return mountComponent(this, el, hydrating);
    };

    // devtools global hook
    /* istanbul ignore next */
    if (inBrowser) {
      setTimeout(function () {
        if (config.devtools) {
          if (devtools) {
            devtools.emit("init", Vue);
          } else if (false) {
          }
        }
        if (false) {
        }
      }, 0);
    }

    /*  */

    /* harmony default export */ const vue_runtime_esm = Vue;

    // EXTERNAL MODULE: ./node_modules/feather-icons/dist/feather.js
    var feather = __webpack_require__(508);
    var feather_default = /*#__PURE__*/ __webpack_require__.n(feather); // CONCATENATED MODULE: ./src/javascripts/constants.js
    /**
     * @typedef {Object} Breakpoint
     * @param {number} min
     * @param {number} max
     * @param {string} name
     * @param {number} order
     */

    /** @enum {Breakpoint} */
    const Breakpoints = {
      xs: {
        min: 0,
        max: 575,
        name: "xs",
        order: 1,
      },
      // Extra small devices (portrait phones, less than 576px)
      sm: {
        min: 576,
        max: 767,
        name: "sm",
        order: 2,
      },
      // Small devices (landscape phones, 576px and up)
      md: {
        min: 768,
        max: 991,
        name: "md",
        order: 3,
      },
      // Medium devices (tablets, 768px and up)
      lg: {
        min: 992,
        max: 1199,
        name: "lg",
        order: 4,
      },
      // Large devices (desktops, 992px and up)
      xl: {
        min: 1200,
        max: Number.POSITIVE_INFINITY,
        name: "xl",
        order: 5,
      }, // Extra large devices (large desktops, 1200px and up)
    }; // CONCATENATED MODULE: ./src/javascripts/ThemeBase.js
    class ThemeBase {
      constructor() {
        this.$ = void 0;
        this.translations = void 0;
        this.moneyFormat = void 0;
        this.breakpoint = void 0;

        this.formatMoney = (cents, format) => {
          var moneyFormat = this.moneyFormat;

          if (typeof cents === "string") {
            cents = cents.replace(".", "");
          }

          var value = "";
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          var formatString = format || moneyFormat;

          function formatWithDelimiters(number, precision, thousands, decimal) {
            if (precision === null || precision === undefined) {
              precision = 2;
            }

            thousands = thousands || ",";
            decimal = decimal || ".";

            if (isNaN(number) || number == null) {
              return 0;
            }

            number = (number / 100.0).toFixed(precision);
            var parts = number.split(".");
            var dollarsAmount = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              "$1" + thousands
            );
            var centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
          }

          switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
              value = formatWithDelimiters(cents, 2);
              break;

            case "amount_no_decimals":
              value = formatWithDelimiters(cents, 0);
              break;

            case "amount_with_comma_separator":
              value = formatWithDelimiters(cents, 2, ".", ",");
              break;

            case "amount_no_decimals_with_comma_separator":
              value = formatWithDelimiters(cents, 0, ".", ",");
              break;

            case "amount_no_decimals_with_space_separator":
              value = formatWithDelimiters(cents, 0, " ");
              break;
          }

          return (
            `<span class="money"><span class="sr-only">${this.translations.cart_title} ${this.translations.cart_subtotal}</span>` +
            formatString.replace(placeholderRegex, value) +
            "</span>"
          );
        };

        this.getWindowWidth = () => {
          return Math.max(
            document.documentElement.clientWidth,
            window.innerWidth || 0
          );
        };

        this.getBreakpoint = (width = undefined) => {
          const w =
            width === null || width === undefined
              ? this.getWindowWidth()
              : width;
          let breakpoint;
          Object.values(Breakpoints).forEach((b) => {
            if (w >= b.min && w <= b.max) {
              breakpoint = b;
            }
          });
          return breakpoint;
        };

        this.loadIcons = (element = null) => {};

        this.loadDrawers = () => {};

        this.updateCartDrawer = (cart) => {};

        this.loadYoutubeApi = () => {
          return;
        };

        this.loadVimeoApi = () => {
          return;
        };

        this.createScript = (id, src) => {
          return;
        };

        this.registerComponent = (component) => {};
      }
    } // CONCATENATED MODULE: ./src/javascripts/Component.js
    class Component {
      /**
       * Generic component, inherited class will be called to receive things like resize events.
       *
       * @param {import('./ThemeBase').default} theme
       * @param {HTMLElement} element
       */
      constructor(theme, element) {
        this.onWindowResizeRaw = ({ width }) => {};

        this.onWindowResize = ({ width, oldWidth, breakpoint }) => {};

        this.onWindowResizeBreakpoint = ({
          width,
          breakpoint,
          oldBreakpoint,
        }) => {};

        this.theme = theme;
        this.element = element;
        theme.registerComponent(this);
      }
      /**
       * This will be called immediatelly when client window resizes.
       *
       * NOTE: prefer using onWindowResize as it's already debounced.
       *
       * @param {Object} params
       * @param {number} params.width Width of the window
       */
    } // CONCATENATED MODULE: ./src/javascripts/Section.js
    /**
     * Base class for all the section components
     *
     * All components should inherit this class and implement what method they need
     */

    class Section extends Component {
      /**
       *
       * @param {import("./ThemeBase").default} theme Global theme object
       * @param {HTMLElement} element Toplevel element for the section
       * @param {boolean} pageLoad True on initial page load, False when this section reloads
       */
      constructor(theme, element, pageLoad) {
        super(theme, element);

        this.onSectionSelect = ({ element, sectionId, load }) => {};

        this.onSectionDeselect = ({ element, sectionId }) => {};

        this.onSectionReorder = ({ element, sectionId }) => {};

        this.onBlockSelect = ({ element, sectionId, blockId, load }) => {};

        this.onBlockDeselect = ({ element, sectionId, blockId }) => {};

        this.destroy = ({ element }) => {};

        this.theme = theme;
        this.element = element;
      }
      /**
       * This will be called when section gets selected in Shopify Theme Editor
       *
       * @param {Object} params
       * @param {HTMLElement} params.element Toplevel element for the section
       * @param {string} params.sectionId Identification of the section
       * @param {boolean} params.load True if block was loaded, False if user just openeded previously selected block
       * */
    } // CONCATENATED MODULE: ./src/javascripts/global/Popup.js
    class Popup extends Component {
      constructor(theme, element) {
        super(theme, element);
        this.STORAGE_KEY = "wetheme-popup";

        this.load = () => {
          if (this.testMode) {
            // popup is in test mode - will show immediately in editor and on live site
            this.show();
          } else if (this.isExpiredOrNotSet()) {
            // popup item in localStorage is expired or was not set, show popup this time
            setTimeout(() => {
              this.setExpiry(this.popupSkipDays);
              this.show();
            }, 1000 * this.popupDelay);
          }

          jquery_default()(".popup--close-btn").on("click", this.hide);
        };

        this.isExpiredOrNotSet = () => {
          let expired = true;
          if (!this.isLocalStorageSupported(() => localStorage)) return expired;
          const popupInfo = window.localStorage.getItem(this.STORAGE_KEY);

          if (popupInfo) {
            try {
              const expiry = Date.parse(JSON.parse(popupInfo).expiry);

              if (expiry > Date.now()) {
                expired = false;
              }
            } catch (e) {
              console.warn("Unable to read popup expiry date", e);
            }
          }

          return expired;
        };

        this.setExpiry = (days) => {
          const expiry = new Date(Date.now() + days * 24 * 60 * 60 * 1000);

          try {
            localStorage.setItem(
              this.STORAGE_KEY,
              JSON.stringify({
                expiry: expiry.toISOString(),
              })
            );
          } catch (e) {
            console.warn("Unable to set popup expiry:", e);
          }
        };

        this.isLocalStorageSupported = (getStorage) => {
          try {
            const key = "__random_key_name___e__";
            getStorage().setItem(key, key);
            getStorage().removeItem(key);
            return true;
          } catch (e) {
            return false;
          }
        };

        this.show = () => {
          this.element.classList.add("visible");
          this.lastFocus = document.activeElement;
          setTimeout(this.trapFocus, 1000);
        };

        this.hide = () => {
          this.element.classList.remove("visible");
        };

        this.trapFocus = () => {
          var inputs = this.element.querySelectorAll(
            "input:not([type=hidden]), button, a"
          );
          var firstInput = inputs[0];
          var lastInput = inputs[inputs.length - 1];
          var self = this; // If newsletter is there, focus on input

          if (this.element.querySelector(".popup__newsletter-form")) {
            this.element.querySelector("#newsletter_text").focus();
          } else {
            this.element.querySelector(".popup--close-btn").focus();
          } // Redirect last tab to first input

          lastInput.addEventListener("keydown", function (e) {
            if (e.keyCode === 9 && !e.shiftKey) {
              e.preventDefault();
              firstInput.focus();
            }
          }); // Redirect first shift+tab to last input

          firstInput.addEventListener("keydown", function (e) {
            // First input is the close icon, so allow closing via enter key.
            if (e.keyCode == 13) {
              e.preventDefault();
              self.hide();
              self.focusable[0].focus();
            }

            if (e.keyCode === 9 && e.shiftKey) {
              e.preventDefault();
              lastInput.focus();
            }
          });
        };

        this.popupWrapper = this.element.querySelector(".popup-container");
        this.popupSkipDays = parseInt(this.element.dataset.popupTime, 10);
        this.popupDelay = parseInt(this.element.dataset.popupDelay, 10);
        this.testMode = this.element.dataset.popupTestMode === "true";
        this.lastFocus = document.activeElement;
        this.focusable = document.body.querySelectorAll("ul.nav li a");
        this.load();
      }
    } // CONCATENATED MODULE: ./src/javascripts/global/CartTerms.js
    class CartTerms {
      constructor(theme, element) {
        this.checkTerms = (event) => {
          const $form = jquery_default()(event.currentTarget).closest("form");

          if (this.agree && !this.agree.checked) {
            alert(this.agree.dataset.termsAgree);
            $form.find(".cart-button-checkout-text").removeClass("hide");
            $form.find(".cart-button-checkout-spinner").addClass("hide");
            event.preventDefault();
            return false;
          }
        };

        this.theme = theme;
        this.element = element;
        this.agree = this.element.querySelector("#agree");
      }
    } // CONCATENATED MODULE: ./src/javascripts/global/CartDrawer.js
    class CartDrawer extends Component {
      // ms
      constructor(theme, element) {
        var _this;

        super(theme, element);
        _this = this;
        this.FADE_OUT_ANIMATION_DURATION = 800;

        this.isUpdatingCart = false;

        this.updateCartDrawer = async function (cart) {
          let setIdentityNumber = null;
          let setTitle = '';
          jquery_default()(".cart-error-box").text("");

          if (cart.items.length === 0) {
            jquery_default()(".cart-empty-box").removeClass("hide");
            jquery_default()(".ajax-cart--bottom-wrapper").addClass("hide");
          } else {
            jquery_default()(".cart-empty-box").addClass("hide");
            jquery_default()(".ajax-cart--bottom-wrapper").removeClass("hide");
          }

          var template = jquery_default()("#cart-item-template").html();
          var $cart_items = jquery_default()(".cart-items");
          $cart_items.empty();
          var self = _this;
          var $cart_drawer_status = jquery_default()(".js-cart-drawer-status");
          var cart_title = jquery_default()(".cart-drawer--title").text();

          var updateStatus = () => {
            $cart_drawer_status
              .html(
                `<span>${self.theme.translations.cart_item} ${
                  self.status_string
                } ${cart_title}, ${_this.theme.formatMoney(
                  cart.total_price
                )}</span>`
              )
              .appendTo(".cart-drawer__top");
          };

          let cartData;

          try {
            const languageUrl =
              jquery_default()(".cart-drawer-form").data("language-url");
            const languageParam =
              !languageUrl || languageUrl == "/" ? "" : languageUrl;
            const response = await fetch(`${languageParam}/cart?view=compare`);
            cartData = await response.json();
          } catch (e) {
            console.error("Cart fetch failed", e);
          }

          var removeId = localStorage.getItem("removeItemId");
          if (removeId != 0 && removeId != undefined && removeId != null) {
            setTimeout(() => {
              var rid = jquery_default()(
                ".cart-item[data-update=" + removeId + "]"
              ).attr("data-line");
              jquery_default()(
                ".cart-item[data-update=" + removeId + "]"
              ).addClass("fadeOut animated slow");
              if (rid != undefined) {
                jquery_default().ajax({
                  type: "POST",
                  url: "/cart/change.js",
                  dataType: "json",
                  data: "quantity=0&id=" + rid,
                  success: function (data) {
                    setTimeout(() => {
                      _this.updateCartDrawer(data);
                      localStorage.setItem("removeItemId", 0);
                    }, 1000);
                  },
                });
              }
            }, 1000);
          }
          // comment this if not needed after tests
          // setTimeout(() => {
          //   jquery_default().ajax({
          //     type: "GET",
          //     url: "/cart.js",
          //     dataType: "json",
          //     success: function (data) {
          //       var count = parseInt(
          //         $(".cart-item-count-header--quantity").first().text()
          //       );
          //       var dataCount = data.item_count;
          //       console.log(count);
          //       console.log(dataCount);
          //       // if (count != dataCount) {
          //       //   _this.updateCartDrawer(data);
          //       // }
          //     },
          //   });
          // }, 500);

          cart.items.forEach((item, index) => {
            var $cart_item = jquery_default()(template);
            $cart_item.find(".cart-item").attr({
              //'data-update':item.properties.identity,
              "data-update": item.id,
              "data-line": item.key,
            });

            if (item.properties != null && item.properties.identity != null){
              $cart_item.find(".cart-item").attr("data-set-identity", item.properties.identity);
            }
            if (item.properties != null && item.properties['Product Name'] != null) {
              $cart_item.find(".cart-item").attr("data-set-gift-product-name", item.properties['Product Name']);
            }

            if (item.image) {
              $cart_item.find(".cart-item-image").attr({
                src: item.image,
                alt: item.title,
              });
            } else {
              $cart_item.find(".cart-item-image").css("display", "none");
            }

            $cart_item.find(".cart-item-link").attr({
              href: item.url,
            });
            $cart_item
              .find(".cart-item-product-title")
              .text(item.product_title);

            if (item.variant_title) {
              $cart_item
                .find(".cart-item-variant-title")
                .removeClass("hide")
                .text(item.variant_title);
            }

            $cart_item
              .find(".cart-item-price")
              .html(_this.theme.formatMoney(item.final_line_price));

            if (item.unit_price_measurement) {
              $cart_item
                .find(".cart-item-price-per-unit")
                .html(
                  '<span class="price">(' +
                    _this.theme.formatMoney(item.unit_price) +
                    " / " +
                    (item.unit_price_measurement.reference_value != 1
                      ? item.unit_price_measurement.reference_value
                      : "") +
                    " " +
                    item.unit_price_measurement.reference_unit +
                    ")"
                );
            } else {
              $cart_item.find(".cart-item-price-per-unit").text("");
            }

            var selling_plan_name = item.selling_plan_allocation
              ? item.selling_plan_allocation.selling_plan.name
              : null;

            if (selling_plan_name) {
              $cart_item
                .find(".cart-item-selling-plan")
                .removeClass("hide")
                .html(item.selling_plan_allocation.selling_plan.name);
            }

            var $original_price = $cart_item.find(".cart-item-price-original");

            if (item.original_line_price > item.final_line_price) {
              $original_price
                .html(_this.theme.formatMoney(item.original_line_price))
                .show();
            } else {
              $original_price.hide();
            }

            var quantity = $cart_item.find(".cart-item-quantity");
            var quantity_wrapper = quantity.closest(
              ".cart-item--quantity-wrapper"
            );
            var quantity_parent = quantity_wrapper.parent();
            var stockCount = parseInt(cartData.items[index].stock_count);
            var stockPolicy = cartData.items[index].stock_policy;
            var stockManagement = cartData.items[index].inventory_management;
            quantity_wrapper.attr("data-stock-count", stockCount);
            quantity_wrapper.attr("data-inventory-policy", stockPolicy);
            quantity_wrapper.attr("data-inventory-management", stockManagement);

            var update_quantity = (quantity, forceDelay = 0) => {
              // Check if an update is already in progress
              if (this.isUpdatingCart) {
                return;
              }

              this.isUpdatingCart = true; // Set the flag to indicate update is in progress
              quantity_wrapper.addClass("cart-item-quantity-active");
              var fade = quantity <= 0;
              var delay = fade ? this.FADE_OUT_ANIMATION_DURATION : 0;
              if (forceDelay > 0) delay = forceDelay;

              this.cartSetQuantity(delay).always(() => {
                quantity_wrapper.removeClass("cart-item-quantity-active");

                if (fade) {
                  $cart_item.addClass("fadeOut animated fast");
                  setTimeout(function () {
                    $cart_item.remove();
                  }, this.FADE_OUT_ANIMATION_DURATION);
                }
                this.isUpdatingCart = false; // Reset the flag once update is complete
              });
            };

            quantity.on("change", function () {
              let new_q = parseInt(jquery_default()(this).val().toString(), 10);
              let getQuantity = parseInt(
                jquery_default()(this).parent().data("stock-count"),
                10
              );
              let inventoryPolicy = jquery_default()(this)
                .parent()
                .data("inventory-policy");
              let inventoryManagement = jquery_default()(this)
                .parent()
                .data("inventory-management");

              if (
                new_q <= getQuantity ||
                inventoryPolicy == "continue" ||
                inventoryManagement != "shopify"
              ) {
                quantity.val(item.quantity);
                update_quantity(new_q);
                quantity_parent.next(".errors").addClass("hide");
              } else {
                quantity.val(getQuantity);
                update_quantity(getQuantity, 3000);
                quantity_parent
                  .next(".errors")
                  .removeClass("hide")
                  .text("You can't add more of this item to the cart");
              }
            });
            quantity.val(item.quantity);
            quantity.attr("name", "updates[]");
            $cart_item
              .find(".cart-item-quantity-button")
              .on("click", function () {
                document.querySelector(".cart__overlay").style.display =
                  "block";
                let current = parseInt(quantity.val().toString(), 10);
                let change = parseInt(this.dataset.amount, 10);
                let new_q = current + change;
                let getQuantity = parseInt(
                  jquery_default()(this).parent().data("stock-count"),
                  10
                );
                let inventoryPolicy = jquery_default()(this)
                  .parent()
                  .data("inventory-policy");
                let inventoryManagement = jquery_default()(this)
                  .parent()
                  .data("inventory-management");
                self.status_string =
                  change > 0
                    ? self.theme.translations.added_to_cart
                    : self.theme.translations.removed_from_cart;

                let identity = jquery_default()(this)
                  .parents(".cart-item")
                  .attr("data-update");

                if (new_q == 0) {
                  // localStorage.setItem("removeItemId",identity);
                  setTitle = item.product_title;
                  document.querySelector('.cart-items').setAttribute('data-set-title', setTitle);
                  if (item.properties != null && item.properties.identity != null) {
                    setIdentityNumber = item.properties.identity;
                    document.querySelector('.cart-items').setAttribute('data-set-identity', setIdentityNumber);
                  }
                } else {
                  localStorage.setItem("removeItemId", 0);
                }

                if (
                  new_q <= getQuantity ||
                  inventoryPolicy == "continue" ||
                  inventoryManagement != "shopify"
                ) {
                  quantity.val(new_q);
                  update_quantity(new_q);
                  quantity_parent.next(".errors").addClass("hide");
                } else {
                  quantity.val(getQuantity);
                  update_quantity(getQuantity, 3000);
                  quantity_parent
                    .next(".errors")
                    .removeClass("hide")
                    .text("You can't add more of this item to the cart");
                }
                document.querySelector(".cart__overlay").style.display = "none";
              });
            $cart_item
              .find("#cart-item-remove-button")
              .on("click", function () {
                self.status_string = self.theme.translations.removed_from_cart;
                let identity = jquery_default()(this)
                  .parents(".cart-item")
                  .find(".cart-item-link")
                  .attr("data-update");
                var new_q = 0;
                quantity.val(new_q);
                update_quantity(new_q);
              });
            var $discounts = $cart_item
              .find(".order-discount--cart-list")
              .empty();
            item.line_level_discount_allocations.forEach(function (
              discount_allocation
            ) {
              var $item = jquery_default()(
                '<li class="order-discount--item"></li>'
              );
              jquery_default()(
                '<span class="order-discount--item-title"></span>'
              )
                .text(discount_allocation.discount_application.title)
                .appendTo($item);
              jquery_default()(
                '<span class="order-discount--cart-amount"></span>'
              )
                .html(
                  '<span class="sr-only">' +
                    self.theme.translations.saving +
                    "</span> (-" +
                    self.theme.formatMoney(discount_allocation.amount) +
                    ")"
                )
                .appendTo($item);
              $discounts.append($item);
            });
            $cart_item.appendTo($cart_items);
          });
          if (self.status_string) updateStatus();
          jquery_default()(
            ".cart-item-count, .cart-item-count-header--quantity"
          ).text(cart.item_count);
          jquery_default()(
            ".cart-total-price, .cart-item-count-header--total"
          ).html(_this.theme.formatMoney(cart.total_price));
          var $original_price = jquery_default()(
            ".cart-item-original-total-price"
          );

          if (cart.original_total_price > cart.total_price) {
            $original_price
              .html(_this.theme.formatMoney(cart.original_total_price))
              .show();
          } else {
            $original_price.hide();
          }

          var $cart_discount = jquery_default()(
            ".ajax-cart-discount-wrapper"
          ).empty();
          cart.cart_level_discount_applications.forEach(function (
            discount_application
          ) {
            var $item = jquery_default()(
              '<div class="cart--order-discount-wrapper--indiv"></div>'
            );
            jquery_default()('<span class="order-discount"></span>')
              .html(
                "-" +
                  self.theme.formatMoney(
                    discount_application.total_allocated_amount
                  )
              )
              .appendTo($item);
            jquery_default()('<span class="order-discount--cart-title"></span>')
              .text("(" + discount_application.title + ")")
              .appendTo($item);
            $cart_discount.append($item);
          });

          setIdentityNumber = document.querySelector('.cart-items').dataset.setIdentity;
          setTitle = document.querySelector('.cart-items').dataset.setTitle;
          console.info(setTitle);
          if (setTitle != '' || setTitle != undefined) {
            let allSetGiftWrappers = document.querySelector('.cart-items').querySelectorAll(`.cart-item[data-set-gift-product-name="${setTitle}"]`)
            console.info(allSetGiftWrappers);
            allSetGiftWrappers.forEach(giftwrapper => {
              giftwrapper.querySelector('#cart-item-remove-button').click();
            });
            document.querySelector('.cart-items').removeAttribute('data-set-setTitle');
            setTitle = '';
          }
          setTimeout(() => {
            if (setIdentityNumber != null || setIdentityNumber != undefined) {
              let allSetItems = document.querySelector('.cart-items').querySelectorAll(`.cart-item[data-set-identity="${setIdentityNumber}"]`);
              allSetItems.forEach((setItem, index) => {
                let quantity = setItem.querySelector('.cart-item-quantity').value;
                console.info(quantity);
                if (quantity == 1){
                  setItem.querySelector('.cart-item-decrease').click();
                } else {
                  setItem.querySelector('.cart-item-quantity').value = 1;
                  setItem.querySelector('.cart-item-decrease').click();
                }
              });
              document.querySelector('.cart-items').removeAttribute('data-set-identity');
              setIdentityNumber = null;
            }
          }, (this.FADE_OUT_ANIMATION_DURATION * 2.5));
        };

        this.cartSetQuantity = (delay) => {
          var deferred = jquery_default().Deferred();
          jquery_default()(".cart-error-box").text("");
          jquery_default()
            .ajax({
              type: "POST",
              url: "/cart/update.js",
              dataType: "json",
              data: jquery_default()(".cart-drawer-form").serialize(),
            })
            .then((data) => {
              deferred.resolve();
              setTimeout(() => {
                let $cart_items = jquery_default()(".cart-items");
                $cart_items.empty();
                this.updateCartDrawer(data);
              }, delay);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
              deferred.reject();
              console.error("Cart error", textStatus, jqXHR, errorThrown);
              jquery_default()(".cart-error-box")
                .empty()
                .text("Unable to update item quantity");
            });
          return deferred;
        };

        this.status_string = "";
        const initial = document.querySelector("#initial-cart");

        if (!initial) {
          return;
        }

        const _data = JSON.parse(initial.textContent);

        this.updateCartDrawer(_data);
        this.cartTerms = new CartTerms(this.theme, this.element);
        jquery_default()(".cart-button-checkout").on("click", (event) => {
          const $el = jquery_default()(event.currentTarget);
          $el.find(".cart-button-checkout-text").addClass("hide");
          $el.find(".cart-button-checkout-spinner").removeClass("hide");
          this.cartTerms.checkTerms(event);
        });
      }
      /** @param {Cart} cart */
    }
    // EXTERNAL MODULE: ./node_modules/slideout/index.js
    var node_modules_slideout = __webpack_require__(933);
    var slideout_default = /*#__PURE__*/ __webpack_require__.n(
      node_modules_slideout
    ); // CONCATENATED MODULE: ./src/javascripts/modules/slideoutFocusTrap.js
    /* provided dependency */ var $ = __webpack_require__(755);
    function trapFocus(slideout_id, is_initial_open) {
      var idString = `#${slideout_id}`;
      var menu = document.getElementById(slideout_id);
      var inputs = menu.querySelectorAll(
        `${idString} input:not([type=hidden]), ${idString} button:not([tabindex="-1"]), ${idString} a:not([tabindex="-1"]), ${idString} textarea`
      );
      var firstInput = inputs[0];
      var lastInput = inputs[inputs.length - 1];
      if (is_initial_open) $(firstInput).focus(); // Redirect last tab to first input

      lastInput.addEventListener("keydown", function (e) {
        if (e.keyCode === 9 && !e.shiftKey) {
          e.preventDefault();
          firstInput.focus();
        }
      }); // Redirect first shift+tab to last input

      firstInput.addEventListener("keydown", function (e) {
        if (e.keyCode === 9 && e.shiftKey) {
          e.preventDefault();
          lastInput.focus();
        }
      });
    } // CONCATENATED MODULE: ./src/javascripts/global/Drawer.js
    class Drawer extends Component {
      constructor(theme, element) {
        super(theme, element);
        this.MOBILE_DRAWER_SIZE = 300;
        this.DESKTOP_DRAWER_SIZE = 390;
        this.MOBILE_BREAKPOINT = Breakpoints.sm;
        this.DESKTOP_BREAKPOINT = Breakpoints.sm;

        this.load = () => {
          // Close sliders if they're open
          if (this.slideouts && this.slideouts.left) {
            this.slideouts.left.close();
          }

          if (this.slideouts && this.slideouts.right) {
            this.slideouts.right.close();
          }
          /* Move mobile menu out of section to document body because the slideout
           needs to put it to the sidebar, but it can't be in the body from the beginning
           because it needs section config */

          var body_menu = jquery_default()("body > #theme-menu");
          var main_body_menu = jquery_default()("#main-body #theme-menu");

          if (main_body_menu.length > 0) {
            body_menu.remove();
            jquery_default()("body").append(main_body_menu);
          }

          var main_body = document.querySelector("#main-body");
          var left_menu = document.querySelector("#theme-menu");
          var right_menu = document.querySelector("#cartSlideoutWrapper");
          var overlay = document.querySelector("#slideout-overlay");
          var slideoutID;
          var self = this;
          var isInitialOpen = true;
          var slideoutLeft = this.createDrawer(
            "left",
            main_body,
            left_menu,
            right_menu,
            overlay
          );
          /* Mobile Menu */

          jquery_default()(".slide-menu-mobile")
            .off("click")
            .on("click", function () {
              slideoutID = self.slideouts.left.menu.id;
              slideoutLeft.toggle();
              trapFocus(slideoutID, isInitialOpen);
            });
          jquery_default()(".mobile-menu-close")
            .off("click")
            .on("click", function () {
              slideoutLeft.close();
            }); // Disable mobile drawer on desktop

          if (this.theme.breakpoint.order <= this.MOBILE_BREAKPOINT.order) {
            slideoutLeft.disableTouch();
          } // Add events for sidebar manipulation from outside

          jquery_default()(left_menu)
            .on("mobile:toggle", slideoutLeft.toggle.bind(slideoutLeft))
            .on("mobile:open", slideoutLeft.open.bind(slideoutLeft))
            .on("mobile:close", slideoutLeft.close.bind(slideoutLeft));
          /* Cart */

          if (!right_menu) {
            // Cart drawer is disabled in the settings
            return;
          }

          var slideoutRight = this.createDrawer(
            "right",
            main_body,
            right_menu,
            left_menu,
            overlay
          ); // Toggle button

          jquery_default()(".slide-menu-cart")
            .off("click")
            .on("click", function (e) {
              slideoutID = self.slideouts.right.menu.id;
              slideoutRight.toggle();
              trapFocus(slideoutID, isInitialOpen); // prevent non-ajax basket

              e.preventDefault();
              return false;
            });
          jquery_default()(".cart-menu-close").on("click", function (e) {
            slideoutRight.close();
          }); // Add events for sidebar manipulation from outside

          jquery_default()(right_menu)
            .on("cart:toggle", slideoutRight.toggle.bind(slideoutRight))
            .on("cart:open", slideoutRight.open.bind(slideoutRight))
            .on("cart:close", slideoutRight.close.bind(slideoutRight));
        };

        this.onWindowResizeBreakpoint = ({ breakpoint, oldBreakpoint }) => {
          const wasMobile = this.isMobile;
          this.isMobile = breakpoint.order <= this.MOBILE_BREAKPOINT.order;
          this.isDesktop =
            window.innerWidth > Breakpoints.md.max ? true : false; // Close mobile menu if we resize to desktop.

          if (this.isDesktop) {
            this.slideouts.left.close();
          }

          if (this.isMobile === wasMobile) {
            // mobile <=> desktop was not changed
            return;
          }

          if (this.isMobile) {
            this.slideouts.left.disableTouch();
          } else {
            this.slideouts.left.enableTouch();
          }

          if (!this.slideouts.right) {
            // cart slider is disabled
            return;
          } // Resize right drawer based on window width

          const slideout = this.slideouts.right;
          const padding = this.isMobile
            ? this.MOBILE_DRAWER_SIZE
            : this.DESKTOP_DRAWER_SIZE;
          slideout._translateTo = slideout._padding =
            padding * slideout._orientation;

          if (slideout._opened) {
            var transform =
              "translateX(" + padding * slideout._orientation + "px)";
            slideout.panel.style.webkitTransform = transform;
            slideout.panel.style.transform = transform;
          }
        };

        this.createDrawer = (side, panel, menu, hidden_menu, overlay) => {
          var padding = this.MOBILE_DRAWER_SIZE;

          if (side === "right" && !this.isMobile) {
            padding = this.DESKTOP_DRAWER_SIZE;
          }

          var slideout = new (slideout_default())({
            panel: panel,
            menu: menu,
            padding: padding,
            tolerance: 70,
            side: side,
            touch: false,
          });
          var dir = side === "right" ? -1 : 1;
          this.slideouts[side] = slideout;
          menu.classList.add("slideout-panel-hidden");
          var $overlay = jquery_default()(overlay);
          overlay.addEventListener("click", slideout.close.bind(slideout)); // Handle slide to close

          var touch_start = null;
          overlay.addEventListener(
            "touchstart",
            function (event) {
              if (!slideout.isOpen()) {
                return;
              }

              event.preventDefault();
              touch_start = event.touches[0].pageX;
            },
            {
              passive: true,
            }
          );
          overlay.addEventListener(
            "touchmove",
            function (event) {
              if (!slideout.isOpen()) {
                return;
              }

              var offset = touch_start - event.touches[0].pageX;
              var translate = dir * padding - offset;

              if (Math.abs(translate) > padding) {
                translate = dir * padding;
              }

              panel.style.webkitTransform = "translateX(" + translate + "px)";
              panel.style.transform = "translateX(" + translate + "px)";
            },
            {
              passive: true,
            }
          );
          overlay.addEventListener("touchend", function (event) {
            if (!slideout.isOpen()) {
              return;
            }

            var offset = touch_start - event.changedTouches[0].pageX;

            if (offset === 0 || Math.abs(offset) > 70) {
              slideout.close();
            } else {
              panel.style.webkitTransform =
                "translateX(" + dir * padding + "px)";
              panel.style.transform = "translateX(" + dir * padding + "px)";
            }
          });
          slideout.on("beforeopen", function () {
            menu.classList.remove("slideout-panel-hidden");

            if (hidden_menu) {
              hidden_menu.classList.add("slideout-panel-hidden");
            }

            $overlay.fadeIn();
            var $cart_close = jquery_default()(".cart-menu-close");
            var $menu_close = jquery_default()(".menu-close-icon");
            if ($cart_close.length > 0) $cart_close.focus();
            if ($menu_close.length > 0) $menu_close.focus(); // document.body.style.overflowY = 'hidden';

            var marginTop = jquery_default()(window).scrollTop() + "px";
            panel.style.position = "fixed";
            panel.style.marginTop = "-" + marginTop; // Apply opposite effect to the sticky header

            jquery_default()(".sticky-header-wrapper.sticky").css({
              "margin-top": marginTop,
              transform: "translateY(0)",
            });
          });
          slideout.on("beforeclose", function () {
            $overlay.fadeOut();
            jquery_default()(".js-cart-drawer-status").text("");
            var scrollTop = -parseInt(panel.style.marginTop);
            panel.style.position = "";
            panel.style.marginTop = "";
            jquery_default()(window).scrollTop(scrollTop);
          });
          var $cart = jquery_default()("#purchase");
          slideout.on("close", function () {
            jquery_default()(".sticky-header-wrapper").css({
              "margin-top": 0,
              transform: "",
            });
            menu.classList.add("slideout-panel-hidden");
          });
          slideout.on("translate", function (translated) {
            var hidden = false;

            if (translated === 0) {
              hidden = true;
            } else if (side === "left") {
              hidden = translated <= 0;
            } else if (side === "right") {
              hidden = translated >= 0;
            }

            menu.classList.toggle("slideout-panel-hidden", hidden);

            if (hidden_menu) {
              hidden_menu.classList.toggle("slideout-panel-hidden", !hidden);
            }
          });
          return slideout;
        };

        this.slideouts = {};
        this.isMobile =
          this.theme.breakpoint.order <= this.MOBILE_BREAKPOINT.order;
        this.isDesktop = window.innerWidth >= Breakpoints.lg.min ? true : false;
        this.lastFocus = document.activeElement;
        this.load();
      }
    } // CONCATENATED MODULE: ./src/javascripts/global/AgeChecker.js
    class AgeChecker extends Component {
      constructor(theme, element) {
        super(theme, element);
        this.STORAGE_KEY = "wetheme-age-check";

        this.load = () => {
          function trapFocus() {
            setTimeout(function () {
              if (document.querySelector(".verification-popup-container")) {
                var inputs = jquery_default()(".verification-popup-container")
                  .find("button, a")
                  .filter(":visible");
                var firstInput = inputs.first();
                var lastInput = inputs.last();
                /*set focus on first input*/

                jquery_default()(".verification-popup-container").focus();
                /*redirect last tab to first input*/

                lastInput.on("keydown", function (e) {
                  if (e.which === 9 && !e.shiftKey) {
                    e.preventDefault();
                    firstInput.focus();
                  }
                });
                /*redirect first shift+tab to last input*/

                firstInput.on("keydown", function (e) {
                  if (e.which === 9 && e.shiftKey) {
                    e.preventDefault();
                    lastInput.focus();
                  }
                });
              }
            }, 1000);
          }

          if (this.ageTestMode) {
            // age checker is in test mode - will show immediately in editor and on live site
            jquery_default()(".verification-popup-container").css(
              "display",
              "block"
            );
            trapFocus();
          }

          const enterButton = document.getElementById("button__enter");
          const exitButton = document.getElementById("button__exit");
          const returnButton = document.getElementById("button__return");
          const closeButton = document.querySelector(
            ".verification-popup__close-button"
          );
          const modalLinks = document.querySelector(
            ".modal-content__wrapper a"
          );

          if (modalLinks) {
            modalLinks.setAttribute("tabindex", "1");
          }

          function readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(";");

            for (var i = 0; i < ca.length; i++) {
              var c = ca[i];

              while (c.charAt(0) == " ") c = c.substring(1, c.length);

              if (c.indexOf(nameEQ) == 0)
                return c.substring(nameEQ.length, c.length);
            }

            return null;
          }

          var isAnAdult = readCookie("isAnAdult");

          if (!isAnAdult) {
            jquery_default()(".verification-popup-container").css(
              "display",
              "block"
            );
            trapFocus();
          }

          if (enterButton) {
            enterButton.addEventListener("click", function () {
              document.write(
                "<style> #prompt__background { display: none; }</style>"
              );
              document.cookie = "isAnAdult=true; expires=0; path=/";
              location.reload();
            });
          }

          if (exitButton) {
            exitButton.addEventListener("click", function () {
              jquery_default()("#verification__prompt").scrollTop(0);
              jquery_default()(".verification-popup__close-button").css(
                "display",
                "block"
              );
              const changeContent = document.querySelector(
                ".modal-deny-content"
              );
              const hideInitial = document.querySelector(
                ".modal-initial-content"
              );
              changeContent.classList.remove("hidden");
              hideInitial.classList.add("hidden");
              trapFocus();
            });
          }

          if (returnButton) {
            returnButton.addEventListener("click", function () {
              jquery_default()("#verification__prompt").scrollTop(0);
              jquery_default()(".verification-popup__close-button").css(
                "display",
                "none"
              );
              const changeContent = document.querySelector(
                ".modal-deny-content"
              );
              const hideInitial = document.querySelector(
                ".modal-initial-content"
              );
              changeContent.classList.add("hidden");
              hideInitial.classList.remove("hidden");
              trapFocus();
            });
          }

          if (closeButton) {
            closeButton.addEventListener("click", function () {
              jquery_default()("#verification__prompt").scrollTop(0);
              jquery_default()(".verification-popup__close-button").css(
                "display",
                "none"
              );
              const changeContent = document.querySelector(
                ".modal-deny-content"
              );
              const hideInitial = document.querySelector(
                ".modal-initial-content"
              );
              changeContent.classList.add("hidden");
              hideInitial.classList.remove("hidden");
              trapFocus();
            });
          }
        };

        this.ageSkipDays = parseInt(this.element.dataset.ageTime, 10);
        this.ageDelay = 0;
        this.ageTestMode = this.element.dataset.ageTestMode === "true";
        this.load();
      }
    } // CONCATENATED MODULE: ./src/javascripts/pages/LoginPage.js
    class LoginPage {
      constructor(theme) {
        this.loadPasswordRecover = () => {
          var $recover = jquery_default()(".recover-form");

          if ($recover.length === 0) {
            return;
          }

          $recover.removeClass("no-js");

          if (window.location.hash !== "#recover") {
            $recover.addClass("hide");
          }

          jquery_default()(".show-password-form").on("click", function (e) {
            $recover.toggleClass("hide");
          });
          jquery_default()(".show-password-form").keypress(function (e) {
            if (e.which == 13) {
              $recover.toggleClass("hide");
              return false;
            }
          });
        };

        this.theme = theme;
        this.loadPasswordRecover();
        jquery_default()("#forgot-password-box").on("click", function () {
          jquery_default()("#customer-login").hide();
          jquery_default()("#recover-password").show();
        });
        jquery_default()("#login-box-link").on("click", function () {
          jquery_default()("#customer-login").show();
          jquery_default()("#recover-password").hide();
        });

        if (document.querySelector(".resetSuccessful")) {
          jquery_default()("#resetSuccess").show();
        }
      }
    } // CONCATENATED MODULE: ./src/javascripts/pages/SearchPage.js
    class SearchPage {
      constructor(theme, element) {
        this.loadSearchPage = () => {
          // Remove trailing '*' character from search input.
          const removeStar = this.searchInput.value.replace(/\*$/, "");
          this.searchInput.value = removeStar;
        };

        this.theme = theme;
        this.element = element;
        this.predictiveSearch = new PredictiveSearch(theme, element);
        this.searchForm = this.element.querySelector("#search-page-form");
        this.searchInput = this.element.querySelector("#search_text");
        this.loadSearchPage();
      }
    } // CONCATENATED MODULE: ./src/javascripts/pages/AddressPage.js
    class AddressPage {
      constructor(theme, element) {
        this.element = element;
        this.addressTables = this.element.querySelectorAll(".address_table");
        Array.prototype.forEach.call(this.addressTables, (address) => {
          address.addEventListener("click", (e) => {
            if (e.target.classList.contains("action_edit")) {
              e.target.setAttribute("aria-expanded", "true");
            }

            if (e.target.classList.contains("action_cancel")) {
              address
                .querySelector(".action_edit")
                .setAttribute("aria-expanded", "false");
            }
          });
        });
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/TextAdverts.js
    class TextAdverts extends Section {
      constructor(theme, _element, pageLoad) {
        super(theme, _element, pageLoad);

        this.MOBILE_BREAKPOINT = Breakpoints.sm;
        this.$element = jquery_default()(_element);
        this.$mobileSlider = this.$element.find(".mobile-homepage-text-adverts");
        this.mobileSliderFlexslider = null;

        // Wait for images to load before initializing
        window.addEventListener('load', () => {
          const isMobile = this.theme.getBreakpoint().order <= this.MOBILE_BREAKPOINT.order;
          if (isMobile) {
            setTimeout(() => {
              this.loadMobileSlider();
            }, 100);
          }
        });

        this.theme.loadIcons();
      }

      onBlockSelect({ element }) {
        if (this.mobileSliderFlexslider) {
          var index = Array.prototype.indexOf.call(
            element.parentElement.children,
            event.target
          );
          this.mobileSliderFlexslider.flexAnimate(index, true);
        }
      }

      onBlockDeselect() {
        if (this.mobileSliderFlexslider) {
          this.mobileSliderFlexslider.play();
        }
      }

      onWindowResizeBreakpoint({ breakpoint, oldBreakpoint }) {
        const newIsMobile = breakpoint.order <= this.MOBILE_BREAKPOINT.order;
        const oldWasMobile = oldBreakpoint.order <= this.MOBILE_BREAKPOINT.order;

        if (newIsMobile !== oldWasMobile) {
          if (newIsMobile) {
            // Destroy existing slider if it exists
            if (this.mobileSliderFlexslider) {
              this.mobileSliderFlexslider.destroy();
              this.mobileSliderFlexslider = null;
            }
            // Reinitialize slider
            setTimeout(() => {
              this.loadMobileSlider();
            }, 100);
          } else {
            // Destroy slider when switching to desktop
            if (this.mobileSliderFlexslider) {
              this.mobileSliderFlexslider.destroy();
              this.mobileSliderFlexslider = null;
            }
          }
        }
      }

      loadMobileSlider() {
        if (!this.$mobileSlider || !this.$mobileSlider.length) {
          console.warn('Mobile slider elements not found');
          return;
        }

        try {
          // Reset any existing styles
          this.$mobileSlider.find(".slides li").removeAttr('style');

          // Force a reflow
          void this.element.offsetWidth;

          // Set new width
          const width = this.element.clientWidth;
          this.$mobileSlider.find(".slides li").css("width", width);

          // Initialize FlexSlider
          this.mobileSliderFlexslider = this.$mobileSlider
            .flexslider({
              controlNav: false,
              directionNav: false,
              animation: "slide",
              animationLoop: true,
              slideshow: true,
              smoothHeight: true,
              start: function(slider) {
                slider.resize();
              }
            })
            .data("flexslider");

        } catch (err) {
          console.error('LINE 29190: Error initializing mobile slider:', err);
        }
      }

      // Add a method to destroy the slider
      destroy() {
        if (this.mobileSliderFlexslider) {
          this.mobileSliderFlexslider.destroy();
          this.mobileSliderFlexslider = null;
        }
      }
    } // CONCATENATED MODULE: ./src/javascripts/global/MobileMenu.js
    /** Mobile menu hierarchy handling */

    class MobileMenu {
      constructor(theme, element) {
        this.menuHandle = (link, handle) => {
          return link.hasClass("sub-topbar")
            ? this.menuStructureTopbar[handle]
            : this.menuStructure[handle];
        };

        this.removeAllMenuTabindex = () => {
          jquery_default()(".mobile-menu")
            .find(".mobile-menu-link")
            .attr("tabindex", "-1");
        };

        this.setTabindex = (el, val) => {
          el.attr("tabindex", val);
          return;
        };

        this.makeLinksTabbable = ($activeMenu, trapFocus) => {
          this.removeAllMenuTabindex();
          if (this.menuHasBackButton($activeMenu))
            this.setTabindex($activeMenu.children(".mobile-menu-back"), "0");
          if (this.menuIsUl($activeMenu))
            this.setTabindex(
              $activeMenu.children("li").children(".mobile-menu-link"),
              "0"
            );
          if (this.menuHasUlChild($activeMenu))
            this.setTabindex(
              $activeMenu
                .children("ul")
                .children("li")
                .children(".mobile-menu-link"),
              "0"
            );
          if (this.menuHasFieldsetChild($activeMenu))
            this.setTabindex(
              $activeMenu
                .children(".mobile-menu__fieldset")
                .children(".mobile-menu-link"),
              "0"
            );
          trapFocus(this.themeMenuID);
        };

        this.menuIsUl = ($el) => {
          return $el.is("ul");
        };

        this.menuHasUlChild = ($el) => {
          return $el.children("ul").length;
        };

        this.menuHasBackButton = ($el) => {
          return $el.children(".mobile-menu-back");
        };

        this.menuHasFieldsetChild = ($el) => {
          return $el.children(".mobile-menu__fieldset").length;
        };

        this.menuClick = ($target, $menu) => {
          this.$lastClickedItem = $target;
          jquery_default()(".mobile-menu.active").scrollTop(0);
          jquery_default()(".mobile-menu").removeClass("active");
          var $menu_wrapper = $menu.closest(".mobile-menu");
          var handle = $target.data("link");
          $target.attr("aria-expanded", "true");
          this.clearSubmenus($menu);

          if (
            handle === "mobile-menu-currency" ||
            handle === "mobile-menu-locale"
          ) {
            $menu_wrapper = jquery_default()(`#${handle}`);
            $menu_wrapper.removeClass("mobile-menu-hidden").addClass("active");
            this.makeLinksTabbable($menu_wrapper, trapFocus);
            return;
          }

          $menu_wrapper.addClass("active");
          var thisMenuHandle = this.menuHandle($target, handle);
          const isTopBar = $target.hasClass("sub-topbar");
          thisMenuHandle.links.forEach((link) => {
            var menu = this.menuHandle($target, link);
            var $li = jquery_default()("<li></li>");

            if (menu.links.length > 0) {
              var $btn = jquery_default()(
                `<button class="alt-focus mobile-menu-sub mobile-menu-link">${menu.title}<i data-feather="chevron-right" aria-hidden="true"></i></button>`
              )
                .attr("aria-expanded", "false")
                .data("link", link)
                .on("click", (e) => {
                  this.menuClick(
                    jquery_default()(e.currentTarget),
                    this.$submenu
                  );
                });
              if (isTopBar) $btn.addClass("sub-topbar");
              $li.append($btn);
            } else {
              var $a = jquery_default()(
                '<a class="alt-focus mobile-menu-link"></a>'
              )
                .attr("href", menu.url)
                .html(menu.title);
              $li.append($a);
            }

            $menu.append($li);
          });
          $menu
            .find(".top-link")
            .text(thisMenuHandle.title)
            .attr("href", thisMenuHandle.url);
          var self = this;

          var insertChildNav = function insertChildNav() {
            var dfd = new (jquery_default().Deferred)();
            setTimeout(function () {
              $menu_wrapper
                .insertAfter($target)
                .find(".mobile-menu-back")
                .off("click")
                .on("click", (e) =>
                  self.backClick(jquery_default()(e.currentTarget), $target)
                );
              dfd.resolve();
            }, 100);
            return dfd.promise();
          };

          insertChildNav().then(function () {
            self.makeLinksTabbable($menu_wrapper, trapFocus);
            $menu_wrapper.removeClass("mobile-menu-hidden");
          });
          this.theme.loadIcons();
        };

        this.clearSubmenus = ($menu) => {
          $menu.find("> li:not(:first)").remove();
        };

        this.backClick = ($back_link, $parent_link) => {
          jquery_default()(".mobile-menu").removeClass("active");
          $back_link.closest(".mobile-menu").addClass("mobile-menu-hidden");
          $parent_link.closest(".mobile-menu").addClass("active");
          $parent_link.attr("aria-expanded", false);
          this.makeLinksTabbable(
            $parent_link.closest(".mobile-menu"),
            trapFocus
          );
          this.$lastClickedItem.focus();
        };

        this.theme = theme;
        this.element = element;
        this.$element = jquery_default()(element);
        this.menuStructure = JSON.parse(
          document.querySelector("#mobile-menu-data").textContent
        );
        this.menuStructureTopbar = JSON.parse(
          document.querySelector("#mobile-menu-data-topbar").textContent
        );
        this.themeMenuID = "theme-menu";
        this.$topmenu = this.$element.find("#mobile-menu--main-menu");
        this.$menu = this.$element.find("#mobile-menu");
        this.$submenu = this.$element.find("#mobile-submenu");
        this.$element
          .find(".mobile-menu-sub")
          .off("click")
          .on("click", (e) =>
            this.menuClick(jquery_default()(e.currentTarget), this.$menu)
          );
        this.$element
          .find(".mobile-menu-back ")
          .off("click")
          .on("click", (e) =>
            this.backClick(
              jquery_default()(e.currentTarget),
              this.$topmenu.children("li").children(".mobile-menu-link")
            )
          );
        this.$lastClickedItem = null;
      }
    } // CONCATENATED MODULE: ./src/javascripts/global/PredictiveSearch.js
    /* provided dependency */ var PredictiveSearch_$ = __webpack_require__(755);

    class PredictiveSearch {
      constructor(theme, element) {
        var _this = this;

        this.loadSearch = () => {
          const self = this;
          document.querySelectorAll('.search-show').forEach(button => {
            button.addEventListener("click", this.searchOpen)
          });

          for (const clear of this.searchClear) {
            clear.addEventListener("click", this.searchClose);
            clear.addEventListener("keyup", function (e) {
              if (e.keyCode === 13) {
                self.searchClose();
              }
            });
          }

          this.searchForm.addEventListener("submit", this.searchSubmit);
          this.searchWrapper.addEventListener(
            "click",
            this.backgroundSearchClose
          );
          this.searchInput.addEventListener("keyup", this.searchChanged);
          document.addEventListener("click", function (e) {
            if (
              e.target &&
              e.target.classList.contains("search-results__meta-clear")
            ) {
              self.searchResultsNum = 0;
              self.searchHasResults = false;
              self.searchResultsPanel.innerHTML = "";
              self.searchInput.value = "";
              self.searchInput.focus();
              self.searchWrapper.classList.remove("has-results");
            }
          });
        };

        this.searchSubmit = (e) => {
          // Search has been submitted, by a keypress or clicking the icon.
          // We need to send the search term so that the search page's
          // results match the predictive results. E.g. appending '*' so
          // the search page does a 'starts with' search.
          e.preventDefault();
          window.location.href = this.getSearchPageUrlWithQuery();
        };

        this.searchOpen = (e) => {
          e.preventDefault();
          this.lockScrolling();
          this.searchToggler = PredictiveSearch_$(e.target).closest(
            ".search-show"
          );
          this.searchToggler.attr("aria-expanded", "true");
          this.searchWrapper.classList.add("expanded");
          this.searchInput.setAttribute("tabindex", "0");
          this.SearchSubmitBtn.setAttribute("tabindex", "0");
          this.searchClearBtn.setAttribute("tabindex", "0");
          this.searchInput.setAttribute("aria-hidden", "false");
          this.SearchSubmitBtn.setAttribute("aria-hidden", "false");
          this.searchClearBtn.setAttribute("aria-hidden", "false");
          this.moveCursorToEnd(this.searchInput);
          this.lastFocus = document.activeElement;
          setTimeout(this.trapFocus, 500);
          return false;
        };

        this.searchClose = (e) => {
          this.unlockScrolling();
          this.searchToggler.attr("aria-expanded", "false");
          this.searchWrapper.classList.remove("expanded");
          this.searchInput.setAttribute("tabindex", "-1");
          this.SearchSubmitBtn.setAttribute("tabindex", "-1");
          this.searchClearBtn.setAttribute("tabindex", "-1");
          this.searchInput.setAttribute("aria-hidden", "false");
          this.SearchSubmitBtn.setAttribute("aria-hidden", "false");
          this.searchClearBtn.setAttribute("aria-hidden", "false");
          this.searchInput.blur();
          return false;
        };

        this.handleLastInputKeydown = (e, firstInput) => {
          // Redirect last tab to first input
          if (e.keyCode === 9 && !e.shiftKey) {
            e.preventDefault();
            firstInput.focus();
          }
        };

        this.handleFirstInputKeydown = (e, lastInput) => {
          // First input is the close icon, so allow closing via enter key.
          if (e.keyCode == 13) {
            e.preventDefault();
            self.hide();
            this.lastFocus.focus();
          } // Redirect first shift+tab to last input

          if (e.keyCode === 9 && e.shiftKey) {
            e.preventDefault();
            lastInput.focus();
          }
        };

        this.resetCloseBtnKeydown = (e, nextElement) => {
          if (e.keyCode === 9 && !e.shiftKey) {
            nextElement.focus();
          }
        };

        this.trapFocus = () => {
          var inputs = this.element.querySelectorAll(
            `${this.searchWrapperID} input:not([type=hidden]), ${this.searchWrapperID} button, ${this.searchWrapperID} a, ${this.searchWrapperID} .search-clear`
          );
          var inputsArr = Array.from(inputs);
          var closeBtnIndex = inputsArr.indexOf(
            inputsArr.find((el) => el.id == "search-bar--clear")
          );
          var firstInput = inputs[0];
          var lastInput = inputs[inputs.length - 1];
          var self = this; // If search box is there, focus on input

          if (
            this.element.querySelector(this.searchWrapperID) &&
            this.initialLoad
          ) {
            this.element.querySelector("#search_text").focus();
          } // If the last input is not the close btn then reset the keydown handler
          // n.b. this is a workaround as could not get removeEventListener to work

          if (lastInput.id != "search-bar--clear") {
            this.searchClearBtn.addEventListener("keydown", function (e) {
              self.resetCloseBtnKeydown(e, inputs[closeBtnIndex + 1]);
            });
          }

          lastInput.addEventListener("keydown", function (e) {
            self.handleLastInputKeydown(e, firstInput);
          });
          firstInput.addEventListener("keydown", function (e) {
            self.handleFirstInputKeydown(e, lastInput);
          });
          this.initialLoad = false;
        };

        this.backgroundSearchClose = (e) => {
          if (e.target !== e.currentTarget) return;
          this.searchClose();
        };

        this.moveCursorToEnd = (el) => {
          el.focus();

          if (typeof el.selectionStart == "number") {
            el.selectionStart = el.selectionEnd = el.value.length;
          } else if (typeof el.createTextRange != "undefined") {
            var range = el.createTextRange();
            range.collapse(false);
            range.select();
          }
        };

        this.searchChanged = (e) => {
          var inputText = e.target.value;

          if (this.isSearchPredictive) {
            if (inputText > "") {
              if (this.searchChangeTimer) {
                window.clearTimeout(this.searchChangeTimer);
              }

              this.searchChangeTimer = window.setTimeout(() => {
                this.performSearch();
                this.searchChangeTimer = null;
              }, 250);
            } else {
              this.searchResultsNum = 0;
              this.searchHasResults = false;
              this.searchWrapper.classList.remove("has-results");
              this.searchResultsPanel.innerHTML = "";
            }
          }
        };

        this.hideLoading = () => {
          this.loadingIcon.classList.add("hide");
        };

        this.showLoading = () => {
          this.displayResults(false);
          this.loadingIcon.classList.remove("hide");
        };

        this.getSearchQuery = () => {
          return `/search/suggest.json?q=${this.searchInput.value}&resources[type]=${this.searchTypes}`;
        };

        this.getSearchPageUrlWithQuery = () => {
          return `/search?type=${this.searchTypes}&q=${encodeURIComponent(
            this.searchInput.value
          )}*`;
        };

        this.lockScrolling = () => {
          const scrollY = window.scrollY;
          document.body.style.position = "fixed";

          if (scrollY > 300) {
            document.body.style.top = `-${scrollY}px`;
          }
        };

        this.unlockScrolling = () => {
          const scrollY = document.body.style.top;
          document.body.style.position = "";
          document.body.style.top = "";
          window.scrollTo(0, parseInt(scrollY || "0") * -1);
        };

        this.performSearch = async function () {
          _this.showLoading();

          _this.searchHasResults = false;
          _this.searchResultsNum = 0;

          _this.searchWrapper.classList.remove("has-results");

          var searchUrlWithQuery = _this.getSearchQuery();

          let data;

          try {
            const response = await fetch(searchUrlWithQuery);

            if (!response.ok) {
              console.error("Search failed", response);
              window.location.href = _this.getSearchPageUrlWithQuery();
              return;
            }

            data = await response.json();
          } catch (e) {
            console.error("Search failed", e); // We'll redirect the user to /search page when ajax search fails.

            window.location.href = _this.getSearchPageUrlWithQuery();
          }

          const resultGroups = new Map(); // Loop over groups e.g. Products / Pages / Articles / Collections

          Object.keys(data.resources.results).forEach((resultType) => {
            let group = resultGroups.get(resultType);
            let result = data.resources.results[resultType];

            if (!group) {
              group = {
                name: {
                  articles: _this.theme.translations.articles,
                  pages: _this.theme.translations.pages,
                  products: _this.theme.translations.products,
                  collections: _this.theme.translations.collections,
                }[resultType],
                results: [],
              };
              resultGroups.set(resultType, group);
            } // Format price.

            let resultWithPrice = result.map((item) => {
              var temp = Object.assign({}, item);

              if (temp.price) {
                temp.price = _this.theme.formatMoney(temp.price);
              }

              return temp;
            }); // If there is more than 1 search type/group, restrict results to sensible amount.

            let groupMax = 1;
            if (_this.searchTypesNum == 1) groupMax = 4;
            else if (_this.searchTypesNum == 2) groupMax = 3;
            else if (_this.searchTypesNum == 3) groupMax = 2; // Give products a little more precedence.

            if (resultType == "product" && groupMax < 4) groupMax = groupMax++;
            group.results = resultWithPrice.slice(0, groupMax);

            if (group.results && group.results.length > 0) {
              _this.searchResultsNum += result.length;
              _this.searchHasResults = true;
            }
          });

          if (!_this.searchHasResults && _this.searchInput.value > "") {
            // UX: Hide the empty-state drop-down when there are no product suggestions
            // that match the query. The lack of feedback from predictive search should
            // encourage customers to continue their search from the results page.
            // Display 'no results found for XYZ' text.
            // this.searchSummary.innerHTML = this.theme.translations.no_results_html.replace('{{ terms }}', this.searchInput.value);
            // Display no feedback.
            _this.searchSummary.innerHTML = "";
          }

          const searchGroups = Array.from(resultGroups.values());

          _this.hideLoading();

          _this.displayResults(searchGroups, _this.trapFocus);
        };

        this.displayResults = (results, searchTrapFocus) => {
          if (!results || this.searchInput.value == "") {
            this.searchResultsPanel.innerHTML = "";
            this.searchWrapper.classList.remove("has-results");
            return;
          }

          let self = this;
          let resultsHtml = "";
          const soldOut = this.theme.translations.soldOut;
          let searchPageUrlWithQuery = this.getSearchPageUrlWithQuery();
          const resultPluralize =
            this.searchResultsNum == 1
              ? this.theme.translations.search_result
              : this.theme.translations.search_result_plural;
          const noneFound =
            this.searchResultsNum == 0
              ? this.theme.translations.none_found
              : "";

          if (this.searchInput.value > "" || this.searchResultsNum > 0) {
            resultsHtml = resultsHtml.concat(
              `<div class="search-results__meta top">`
            );
          }

          if (this.searchInput.value > "") {
            resultsHtml = resultsHtml.concat(`
              <button type="button" class="search-results__meta-clear" tabindex="0">${this.theme.translations.clear}</button>
          `);
          }

          resultsHtml = resultsHtml.concat(`
          <div class="search-results__status ${
            noneFound ? "" : "sr-only"
          }" role="status">${noneFound} ${resultPluralize} ${
            this.theme.translations.search_found
          }.</div>
      `);

          if (this.searchResultsNum > 0) {
            resultsHtml = resultsHtml.concat(`
              <div class="search-results__meta-view-all"><a href="${searchPageUrlWithQuery}">${this.theme.translations.view_all}</a></div>
          `);
          }

          if (this.searchInput.value > "" || this.searchResultsNum > 0) {
            resultsHtml = resultsHtml.concat(`</div>`);
          }

          Object.keys(results).forEach(function (groupKey) {
            const group = results[groupKey];
            const groupResults = group.results;

            if (groupResults.length > 0) {
              resultsHtml = resultsHtml.concat(
                `<div class="predictive-search-group">`
              );
              resultsHtml = resultsHtml.concat(
                `  <h2 class="type-subheading type-subheading--1">${group.name}</h2>`
              );
              resultsHtml = resultsHtml.concat(
                `  <div class="search--result-group">`
              );
              Object.keys(groupResults).forEach(function (resultKey) {
                const result = groupResults[resultKey];
                let infoColClass = "col-12";
                resultsHtml = resultsHtml.concat(`<article class="row">`);

                if (result.featured_image && result.featured_image.url > "") {
                  resultsHtml = resultsHtml.concat(`<div class="col-3">`);
                  resultsHtml = resultsHtml.concat(
                    `<a href="${result.url}"><img src="${result.featured_image.url}" alt="${result.featured_image.alt}" /></a>`
                  );
                  resultsHtml = resultsHtml.concat(`</div>`);
                  infoColClass = "col-9";
                }

                resultsHtml = resultsHtml.concat(
                  `<div class="${infoColClass}">`
                );

                if (self.showVendor && result.vendor) {
                  resultsHtml = resultsHtml.concat(
                    `<div class="search-vendor">${result.vendor}</div>`
                  );
                }

                resultsHtml = resultsHtml.concat(
                  ` <h5><a href="${result.url}">${result.title}</a></h5>`
                );

                if (!result.available && group.name == "Products") {
                  resultsHtml = resultsHtml.concat(`<div>${soldOut}</div>`);
                }

                if (self.showPrices && result.price) {
                  resultsHtml = resultsHtml.concat(
                    ` <div class="search-price">${result.price}</div>`
                  );
                }

                resultsHtml = resultsHtml.concat(`</div></article>`);
                resultsHtml = resultsHtml.concat(
                  `<span class="search-result-separator"><hr /></span>`
                );
              });
              resultsHtml = resultsHtml.concat(`  </div>`);
              resultsHtml = resultsHtml.concat(`</div>`);
            }
          });

          if (this.searchResultsNum > 0) {
            resultsHtml = resultsHtml.concat(`
                <div class="search-results__meta bottom">
                  <div class="search-results__meta-view-all"><a href="${searchPageUrlWithQuery}">${this.theme.translations.view_all}</a></div>
                </div>
            `);
          }

          if (this.searchInput.value > "") {
            this.searchWrapper.classList.add("has-results");
          } else {
            this.searchWrapper.classList.remove("has-results");
          }

          this.searchResultsPanel.innerHTML = resultsHtml;
          searchTrapFocus();
        };

        this.theme = theme;
        this.element = element;
        this.searchForm = document.querySelector("#search-page-form");
        this.searchWrapperID = "#top-search-wrapper";
        this.searchWrapper = document.querySelector(this.searchWrapperID);
        this.searchIcons = document.querySelectorAll(".search-show");
        this.searchClear = document.querySelectorAll(".search-clear");
        this.searchInput = document.querySelector("#search_text");
        this.SearchSubmitBtn = document.querySelector("#search_submit");
        this.searchClearBtn = document.querySelector("#search-bar--clear");
        this.loadingIcon = document.querySelector(".predictive-loading");
        this.searchSummary = document.querySelector(".search-summary");
        this.searchResultsPanel = document.querySelector(
          ".search-results-panel"
        );
        this.searchResultsStatus = document.querySelector(".search-status");
        this.searchChangeTimer = null;
        this.searchToggler = null;
        this.lastFocus = document.activeElement;
        this.searchResultsNum = 0;
        this.searchHasResults = false;
        this.searchTypes = false;
        this.searchTypesNum = 0;
        this.isSearchPredictive = false;
        this.showPrices = false;
        this.showVendor = false;
        this.initialLoad = true;

        if (this.searchInput) {
          this.searchTypes = this.searchInput.dataset.searchTypes.replace(
            /,$/,
            ""
          );
          this.searchTypesNum = this.searchTypes.split(",").length;
          this.isSearchPredictive =
            this.searchInput.classList.contains("is-predictive");
          this.showPrices = this.searchInput.dataset.showPrices == "true";
          this.showVendor = this.searchInput.dataset.showVendor == "true";
          this.loadSearch();
        }
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/Header.js
    class Header extends Section {
      constructor(theme, _element, pageLoad) {
        super(theme, _element, pageLoad);

        this.onSectionSelect = ({ element, sectionId, load }) => {
          this.theme.loadDrawers();
        };

        this.onBlockSelect = ({ element }) => {
          // Enable hover to use proper menu colors
          this.element.classList.add("touch-hover"); // Open megamenu which is being edited (both normal menu and sticky menu)

          if (element.dataset.megaMenuBlockId) {
            // Open normal header (not sticky one) as Shopify will scroll to it automatically
            const $element = jquery_default()(
              `.header-menu-wrapper [data-mega-menu-block-id="${element.dataset.megaMenuBlockId}"]`
            );
            const $menu = $element.closest(
              "li.dropdown > .mega-menu--dropdown-wrapper"
            );
            const $handler = $menu.find(".dropdown-envy-toggle");
            this.openMenu($menu, $handler, true);
          }
        };

        this.onBlockDeselect = () => {
          // Disable hover
          this.element.classList.remove("touch-hover"); // Close opened megamenus

          var $open_menus = jquery_default()(
            ".mega-menu--dropdown-wrapper.force-open"
          );
          $open_menus
            .children('a[aria-expanded="true"]')
            .attr("aria-expanded", "false");
          $open_menus.removeClass("force-open");
        };

        this.updateStickyHeader = () => {
          // How many pixel below the menu should the sticky menu appear
          const menu_breakpoint_offset = 50; // breakpoint is where the sticky menu should appear = menu bottom + 50px

          const menu_breakpoint =
            this.element.clientTop +
            this.element.clientHeight +
            menu_breakpoint_offset;
          const scrollTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          const is_sticky = scrollTop > menu_breakpoint;
          this.$sticky.toggleClass("sticky", is_sticky);

          if (is_sticky) {
            this.$sticky.parent().removeClass("unstuck");
            this.$sticky.parent().addClass("stuck");
          } else {
            this.$sticky.parent().removeClass("stuck");
            this.$sticky.parent().addClass("unstuck");
          }
        };

        this.loadStickyHeader = () => {
          this.$sticky = this.$element.find(".sticky-header-wrapper");

          if (this.$sticky.length === 0) {
            return;
          }

          var $menu_wrapper = this.$sticky.find(".sticky-header-menu");
          var $icon_wrapper = this.$sticky.find(".sticky-header-icons"); // If main menu, clone into sticky header, otherwise if top bar menu, clone into sticky header

          const $main_menu = jquery_default()("#main-navigation-wrapper");
          const $top_bar_menu =
            jquery_default()(".header-wrapper.js").find(".nav-bar__top-nav");
          const hasMainMenu = $main_menu.length;
          const hasTopBarMenu = $top_bar_menu.length;

          if (hasMainMenu) {
            $main_menu.clone().appendTo($menu_wrapper);
          } else if (hasTopBarMenu) {
            $top_bar_menu.clone().appendTo($menu_wrapper);
          } // copy menu icons (cart, search, ...)

          jquery_default()(".cart-link li button, .cart-link li a").each(
            function () {
              jquery_default()('<div class="sticky-header-icon"></div>')
                .append(jquery_default()(this).clone())
                .appendTo($icon_wrapper);
            }
          ); // copy mobile menu

          var $mobile_menu = jquery_default()(".mobile-header--wrapper")
            .clone()
            .appendTo(this.$sticky.find(".sticky-mobile-header"));
          $mobile_menu
            .find(".slide-menu-mobile")
            .off("click")
            .on("click", function () {
              jquery_default()("#theme-menu").trigger("mobile:toggle");
            });
          window.addEventListener("scroll", this.updateStickyHeader);
          this.updateStickyHeader(); // bind cart open to the cart icon

          this.$sticky
            .find(".slide-menu-cart")
            .off("click")
            .on("click", function (e) {
              jquery_default()("#cartSlideoutWrapper").trigger("cart:toggle"); // prevent non-ajax basket

              e.preventDefault();
              return false;
            });
        };

        this.loadDropdownHover = () => {
          this.dropdownTimeout = null;
          this.touchHoverTimeout = null;
          this.dropdownHandle();
        };

        this.handleExternalLinks = () => {
          var links = this.element.querySelectorAll("a");

          for (let i = 0, linksLength = links.length; i < linksLength; i++) {
            if (links[i].hostname !== window.location.hostname) {
              links[i].target = "_blank";
              links[i].rel = "noreferrer noopener";
            }
          }
        };

        this.openMenu = ($menu, $handler, force = false) => {
          if (!$handler.is(".dropdown-envy-toggle")) return;
          this.closeAllDropdowns(); // Align submenu with bottom of the menu

          let offset = $menu[0].offsetHeight + $menu[0].offsetTop;
          $menu
            .find("> .dropdown-menu--standard")
            .css("margin-top", offset + "px"); // Align standard dropdown menu with bottom of the header

          $menu
            .find("> .dropdown-menu--mega")
            .css("margin-top", offset - 1 + "px"); // Align megamenu with bottom of the header
          // Align megamenu with bottom of the header

          var $el = jquery_default()(".header-wrapper");

          if (jquery_default()(".sticky").length > 0) {
            $el = jquery_default()(".sticky-header-wrapper");
          } // Place megamenus at the bottom of the header, rather than under their parent menu link.

          let megaOffset = $el.position().top + $el.outerHeight() - 1;

          if (
            $el.is(".header-wrapper--overlay.unstuck") &&
            jquery_default()(".notification-bar").length
          ) {
            megaOffset =
              megaOffset - jquery_default()(".notification-bar").outerHeight();
          }

          if ($handler.is("a") && $handler.next("ul").length) {
            $handler.attr("aria-expanded", "true");
          }

          $menu.addClass(force ? "force-open" : "open");
          $menu.attr("aria-expanded", "true");
          this.selectMenuDirection($menu);
        };

        this.closeMenu = ($menu) => {
          $menu.find('a[aria-expanded="true"]').attr("aria-expanded", "false");
          $menu.removeClass("open");
        };

        this.getMenuFromHandler = ($handler) => {
          return $handler.is(".dropdown-envy-toggle")
            ? $handler.parent()
            : $handler;
        };

        this.handleTouchend = (e, $menu) => {
          if (e.type !== "touchend") return;

          if (this.touchHoverTimeout) {
            clearTimeout(this.touchHoverTimeout);
            this.touchHoverTimeout = null;
          }

          this.element.classList.add("touch-hover");

          if (
            $menu.is(".dropdown-submenu,.mega-menu--dropdown-wrapper") &&
            !$menu.hasClass("open")
          ) {
            // Prevent click on link when dropdown menu is touched and not yet open
            e.preventDefault();
          }
        };

        this.clearDropdownTimeout = () => {
          if (this.dropdownTimeout) {
            clearTimeout(this.dropdownTimeout);
          }
        };

        this.handleToggleOnEvents = (e) => {
          e.stopPropagation();
          const $handler = jquery_default()(e.currentTarget);
          let $menu = this.getMenuFromHandler($handler); // Get the <li> not the <a>

          if ($menu.hasClass("dropdown-submenu__link")) {
            $menu.attr("aria-expanded", "true");
            $menu = $menu.parent();
            $menu.addClass("open");
          }

          this.handleTouchend(e, $menu); // Find neighbours and close them

          var $neighboring_menu = $menu
            .closest(".mega-menu--dropdown-wrapper")
            .find(".open")
            .not($menu.closest(".dropdown-submenu"));
          $neighboring_menu
            .children('a[aria-expanded="true"]')
            .attr("aria-expanded", "false");
          $neighboring_menu.removeClass("open"); // wait for some time before opening the menu

          this.clearDropdownTimeout();
          this.dropdownTimeout = setTimeout(this.openMenu, 10, $menu, $handler);
        };

        this.handleToggleOffEvents = (e) => {
          // if has children visible, then leave open
          const $handler = jquery_default()(e.currentTarget);
          const $menu = this.getMenuFromHandler($handler);

          if ($menu.hasClass("dropdown-envy-toggle")) {
            $menu.removeClass("open");
          }

          if (!$menu.hasClass("open")) {
            // Wait a bit then close
            this.clearDropdownTimeout();
            this.dropdownTimeout = setTimeout(this.closeMenu, 1500, $menu);
          }
        };

        this.dropdownHandle = () => {
          // open menu/submenu on mousehover
          var $dropdown_toggles = this.$element.find(
            ".dropdown-envy-toggle, .dropdown-menu > li, .dropdown-menu--mega, a.dropdown-submenu__link"
          );
          $dropdown_toggles.off("mouseenter touchend focus").on(
            "mouseenter touchend focus",
            (
              /** @type Event */
              e
            ) => {
              this.handleToggleOnEvents(e);
            }
          ); // handle closing menu when hover ends

          $dropdown_toggles
            .off("mouseleave blur")
            .on("mouseleave blur", (e) => {
              this.handleToggleOffEvents(e);
            });
          jquery_default()(".nav-pills")
            .off("mouseleave")
            .on("mouseleave", this.navigatedFromMenu); // hide menu when touched anywhere else then the menu

          jquery_default()("body").on("touchstart", this.navigatedFromMenu);
        };

        this.headerLinkHandle = () => {
          var $header_links = this.$element
            .find(".header-link")
            .not(".dropdown-envy-toggle");
          $header_links.off("mouseenter touchend focus").on(
            "mouseenter touchend focus",
            (
              /** @type Event */
              e
            ) => {
              this.closeAllDropdowns();
            }
          );
        };

        this.navigatedFromMenu = (e) => {
          if (this.touchHoverTimeout) {
            clearTimeout(this.touchHoverTimeout);
          }

          this.touchHoverTimeout = setTimeout(() => {
            this.touchHoverTimeout = null;
            this.element.classList.remove("touch-hover");
          }, 50); // don't hide menu if we touched "inside" the menu

          if (
            e.type === "mouseleave" ||
            jquery_default()(e.target).parents(
              ".mega-menu--dropdown-wrapper.open, .dropdown-submenu.open"
            ).length === 0
          ) {
            this.closeAllDropdowns();
          }
        };

        this.closeAllDropdowns = () => {
          var $open_menus = jquery_default()(
            ".mega-menu--dropdown-wrapper.open,.dropdown-submenu.open"
          );
          $open_menus
            .find('a[aria-expanded="true"]')
            .attr("aria-expanded", "false");
          $open_menus.removeClass("open");
        };

        this.selectMenuDirection = ($menu) => {
          // Fix submenu opening outside of viewport by showing it to the left of menu
          var children_widths = $menu
            .find(".dropdown-menu .dropdown-menu")
            .map(function () {
              var $this = jquery_default()(this);
              var width = $this
                .css({
                  display: "block",
                  visibility: "hidden",
                })
                .outerWidth();
              $this.css({
                display: "",
                visibility: "",
              });
              return width;
            });
          var max_width = Math.max.apply(null, children_widths);
          var $submenu = $menu.find("> .dropdown-menu");

          if ($submenu.length === 0) {
            return;
          }

          var left = $submenu.offset().left;
          var right = left + $submenu.outerWidth() + max_width;
          var switch_to_left =
            right > jquery_default()("body").width() && left - max_width > 0;
          $submenu.toggleClass("dropdown-submenu-left", switch_to_left);
        };

        this.fixHeaderHeight = () => {
          var announcementBar = jquery_default()(
            "#shopify-section-announcement-bar"
          ).height();
          var header = jquery_default()("#shopify-section-header").height();
          var textAdverts = jquery_default()(
            "#shopify-section-text-adverts"
          ).height();
          var headerHeight = announcementBar + header + textAdverts;
          var nonOverlayHeight = announcementBar + textAdverts; // Only apply if the slideshow is set to full screen size.

          if (jquery_default()(".slideshow--full-screen").length) {
            // Don't apply the height if the header is overlaid on the slideshow.
            if (jquery_default()(".header-wrapper--overlay").length === 0) {
              jquery_default()(".slideshow--full-screen").css(
                "height",
                "calc(100vh - " + headerHeight + "px)"
              );
              jquery_default()(".slideshow--full-screen ul.slides li").css(
                "height",
                "calc(100vh - " + headerHeight + "px)"
              );
            } else {
              jquery_default()(".slideshow--full-screen").css(
                "height",
                "calc(100vh - " + nonOverlayHeight + "px)"
              );
              jquery_default()(".slideshow--full-screen ul.slides li").css(
                "height",
                "calc(100vh - " + nonOverlayHeight + "px)"
              );
            }
          }
        };

        this.$element = jquery_default()(_element);
        this.loadStickyHeader();
        this.mobileMenu = new MobileMenu(
          theme,
          document.querySelector(".mobile-menu-wrapper")
        );
        this.predictiveSearch = new PredictiveSearch(theme, _element);
        this.loadDropdownHover();
        this.headerLinkHandle();
        this.fixHeaderHeight();
        this.theme.loadIcons();
        this.handleExternalLinks();
      }
    }
    // EXTERNAL MODULE: ./node_modules/flexslider/jquery.flexslider.js
    var jquery_flexslider = __webpack_require__(65); // CONCATENATED MODULE: ./src/javascripts/global/Slider.js
    const SLIDER_REENABLE_INTERVAL = 6000;
    class Slider {
      /**
       * Create new slider instance
       *
       * @param {import('../ThemeBase').default} theme
       * @param {HTMLElement} element
       */
      constructor(theme, element) {
        this.initPlaypause = () => {
          this.playpause.btn_index = this.$allFocusableEls.index(
            this.playpause.$btn
          );
          this.playpause.$nextFocusableEl =
            this.$allFocusableEls[this.playpause.btn_index + 1];
          this.playpause.$prevFocusableEl =
            this.$allFocusableEls[this.playpause.btn_index - 1];
          this.playpause.$btn.attr("role", "button");
          this.playpause.$btn.attr("aria-label", this.playpause.btn_label);
          this.playpause.$btn.attr("aria-pressed", this.playpause.is_pressed);
        };

        this.playpauseHandleKeydown = (e) => {
          var isTabKey = e.keyCode == 9 ? true : false;
          var isEnterKey = e.keyCode == 13 ? true : false;

          if (isTabKey) {
            if (e.shiftKey) {
              this.playpause.$prevFocusableEl.focus();
            } else {
              this.playpause.$nextFocusableEl.focus();
            }
          } else if (isEnterKey) {
            jquery_default()(e.target).trigger("click");
          } else {
            return;
          }
        };

        this.setAriaPressed = (target) => {
          this.playpause.is_pressed = target.hasClass("flex-pause")
            ? "false"
            : "true"; // target.attr('aria-label', this.playpause.is_pressed);

          target.attr("aria-pressed", this.playpause.is_pressed);
        };

        this.getSpeed = () => {
          return parseInt(this.$element.data("sliderSlideTime"));
        };

        this.getId = () => {
          return this.$element.data("sliderId");
        };

        this.getSmoothHeightState = () => {
          return jquery_default()(window).width() < 767;
        };

        this.getAnimation = () => {
          return this.$element.data("sliderAnimation");
        };

        this.getDots = () => {
          return this.$element.data("sliderDots");
        };

        this.getArrows = () => {
          return this.$element.data("sliderArrows");
        };

        this.getControls = () => {
          return this.$element.data("sliderControls");
        };

        this.currentSlide = () => {
          return this.$element.find(".flex-active-slide").data("slide-index");
        };

        this.showSlide = (index) => {
          if (this.getSpeed() > 0) {
            this.flexslider.pause();
            this.forcePause = true;
          }

          if (this.currentSlide() !== index) {
            // Change slide without animation
            this.flexslider.flexAnimate(index); //this.flexslider.wrapup($(window).width());
          }
        };

        this.startAnimation = () => {
          // Don't start animation when autorotate is disabled
          this.forcePause = false;

          if (this.getSpeed() > 0) {
            this.flexslider.play();
          }
        };

        this.onSlideChange = (slider) => {
          var speed = this.getSpeed();
          this.$element.find(".slides li a").attr("tabindex", "0");
          this.$element
            .find(".slides li:not(.flex-active-slide) a")
            .attr("tabindex", "-1");

          if (!this.forcePause && !slider.playing && speed > 0) {
            // restart autoscroll after given interval since last interaction
            clearTimeout(this.restartTimer);
            this.restartTimer = setTimeout(function () {
              slider.play();
            }, Math.max(0, SLIDER_REENABLE_INTERVAL - speed));
          }
        };

        this.configure = (options) => {
          if (jquery_default()(window).width() === 0) {
            // the app is not yet loaded in the admin, retry later
            setTimeout(this.configure.bind(this), 200);
            return;
          }

          var speed = this.getSpeed();
          var id = this.getId();
          var numSlides = this.$element.find("ul.slides li").length;
          var opts = jquery_default().extend(
            {
              pausePlay: numSlides > 1 && this.getControls(),
              pauseText: "",
              playText: "",
              directionNav: numSlides > 1 ? this.getArrows() : "",
              controlNav: numSlides > 1 ? this.getDots() : "",
              startAt: 0,
              slideshowSpeed: speed,
              animation: this.getAnimation(),
              controlsContainer: jquery_default()(
                ".slider-pagination-container.slider--" + id
              ),
              customDirectionNav: jquery_default()(
                ".flex-direction-nav.slider--" + id + " button"
              ),
              slideshow: speed > 0 && numSlides > 1,
              touch: numSlides > 1,
              pauseOnAction: true,
              after: this.onSlideChange.bind(this),
            },
            options
          );

          if (
            jquery_default()(".slider-pagination-container.slider--" + id)
              .length === 0
          ) {
            options.controlNav = false;
          } else {
            options.controlNav = true;
          }

          if (
            jquery_default()(".flex-direction-nav.slider--" + id + " a")
              .length === 0
          ) {
            options.directionNav = false;
          } else {
            options.directionNav = true;
          }

          this.$element.find("ul.slides").width("auto");
          return this.$element.flexslider(opts).data("flexslider");
        };

        this.theme = theme;
        this.element = element;
        this.$element = jquery_default()(element);
        this.restartTimer = null;
        this.forcePause = false; // Prevent flickering in the flexslider by setting fixed width of the slides

        this.$element.find(".slides li").css("width", this.$element.width());
        this.flexslider = this.configure({}); // flexslider stops the animation when the page is not focused, this breaks when the section is
        // changed in theme admin because it triggers 'blur' event when another iframe is selected

        jquery_default()(window).off("blur"); // Do not focus on any links outside the active slide.

        this.$element
          .find(".slides li:not(.flex-active-slide) a")
          .attr("tabindex", "-1");
        var dotLinks = jquery_default()(
          ".slider-pagination-container.slider--" + this.getId()
        ).find("a");
        var self = this;
        dotLinks.each(function () {
          jquery_default()(this).attr(
            "aria-label",
            `${self.theme.translations.slide} ${jquery_default()(this).text()}`
          );
        });
        this.$allFocusableEls = jquery_default()(
          "a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]"
        ).not('[tabindex=-1], [disabled], :hidden, [aria-hidden="true"]');
        this.playpause = {
          btn_label: self.theme.translations.pause,
          $btn: jquery_default()(".flex-pauseplay a"),
          is_pressed: "false",
        };
        this.initPlaypause();
        this.playpause.$btn.on("click", function (e) {
          self.setAriaPressed(jquery_default()(e.target));
        });
        this.playpause.$btn.on("keydown", function (e) {
          e.preventDefault();
          self.playpauseHandleKeydown(e);
        });
        this.$element;
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/Slideshow.js
    class Slideshow extends Section {
      constructor(theme, _element, pageLoad) {
        super(theme, _element, pageLoad);

        this.onBlockSelect = ({ element }) => {
          const index = parseInt(element.dataset.slideIndex, 10);
          this.slider.showSlide(index);
        };

        this.onBlockDeselect = () => {
          this.slider.startAnimation();
        };

        this.sliderElement = _element.querySelector(".flexslider-homepage");
        this.slider = new Slider(theme, this.sliderElement);
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/Testimonial.js
    class Testimonial extends Section {
      constructor(theme, _element, pageLoad) {
        super(theme, _element, pageLoad);

        this.onBlockSelect = ({ element }) => {
          const index = parseInt(element.dataset.slideIndex, 10);
          this.slider.showSlide(index);
        };

        this.onBlockDeselect = () => {
          this.slider.startAnimation();
        };

        this.sliderElement = _element.querySelector(
          ".flexslider-homepage-testimonial"
        );
        this.slider = new Slider(theme, this.sliderElement);
        theme.testimonials = theme.testimonials || {};
        theme.testimonials[_element.dataset.sliderId] = this.slider;
      }
    } // CONCATENATED MODULE: ./node_modules/ssr-window/dist/ssr-window.esm.js
    /**
     * SSR Window 2.0.0
     * Better handling for window object in SSR environment
     * https://github.com/nolimits4web/ssr-window
     *
     * Copyright 2020, Vladimir Kharlampidi
     *
     * Licensed under MIT
     *
     * Released on: May 12, 2020
     */
    /* eslint-disable no-param-reassign */
    function ssr_window_esm_isObject(obj) {
      return (
        obj !== null &&
        typeof obj === "object" &&
        "constructor" in obj &&
        obj.constructor === Object
      );
    }
    function ssr_window_esm_extend(target, src) {
      if (target === void 0) {
        target = {};
      }
      if (src === void 0) {
        src = {};
      }
      Object.keys(src).forEach(function (key) {
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if (
          ssr_window_esm_isObject(src[key]) &&
          ssr_window_esm_isObject(target[key]) &&
          Object.keys(src[key]).length > 0
        ) {
          ssr_window_esm_extend(target[key], src[key]);
        }
      });
    }

    var doc = typeof document !== "undefined" ? document : {};
    var ssrDocument = {
      body: {},
      addEventListener: function () {},
      removeEventListener: function () {},
      activeElement: {
        blur: function () {},
        nodeName: "",
      },
      querySelector: function () {
        return null;
      },
      querySelectorAll: function () {
        return [];
      },
      getElementById: function () {
        return null;
      },
      createEvent: function () {
        return {
          initEvent: function () {},
        };
      },
      createElement: function () {
        return {
          children: [],
          childNodes: [],
          style: {},
          setAttribute: function () {},
          getElementsByTagName: function () {
            return [];
          },
        };
      },
      createElementNS: function () {
        return {};
      },
      importNode: function () {
        return null;
      },
      location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: "",
      },
    };
    ssr_window_esm_extend(doc, ssrDocument);

    var win = typeof window !== "undefined" ? window : {};
    var ssrWindow = {
      document: ssrDocument,
      navigator: {
        userAgent: "",
      },
      location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: "",
      },
      history: {
        replaceState: function () {},
        pushState: function () {},
        go: function () {},
        back: function () {},
      },
      CustomEvent: function CustomEvent() {
        return this;
      },
      addEventListener: function () {},
      removeEventListener: function () {},
      getComputedStyle: function () {
        return {
          getPropertyValue: function () {
            return "";
          },
        };
      },
      Image: function () {},
      Date: function () {},
      screen: {},
      setTimeout: function () {},
      clearTimeout: function () {},
      matchMedia: function () {
        return {};
      },
    };
    ssr_window_esm_extend(win, ssrWindow); // CONCATENATED MODULE: ./node_modules/dom7/dist/dom7.modular.js

    /**
     * Dom7 2.1.5
     * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
     * http://framework7.io/docs/dom.html
     *
     * Copyright 2020, Vladimir Kharlampidi
     * The iDangero.us
     * http://www.idangero.us/
     *
     * Licensed under MIT
     *
     * Released on: May 15, 2020
     */

    class Dom7 {
      constructor(arr) {
        const self = this;
        // Create array-like object
        for (let i = 0; i < arr.length; i += 1) {
          self[i] = arr[i];
        }
        self.length = arr.length;
        // Return collection with methods
        return this;
      }
    }

    function dom7_modular_$(selector, context) {
      const arr = [];
      let i = 0;
      if (selector && !context) {
        if (selector instanceof Dom7) {
          return selector;
        }
      }
      if (selector) {
        // String
        if (typeof selector === "string") {
          let els;
          let tempParent;
          const html = selector.trim();
          if (html.indexOf("<") >= 0 && html.indexOf(">") >= 0) {
            let toCreate = "div";
            if (html.indexOf("<li") === 0) toCreate = "ul";
            if (html.indexOf("<tr") === 0) toCreate = "tbody";
            if (html.indexOf("<td") === 0 || html.indexOf("<th") === 0)
              toCreate = "tr";
            if (html.indexOf("<tbody") === 0) toCreate = "table";
            if (html.indexOf("<option") === 0) toCreate = "select";
            tempParent = doc.createElement(toCreate);
            tempParent.innerHTML = html;
            for (i = 0; i < tempParent.childNodes.length; i += 1) {
              arr.push(tempParent.childNodes[i]);
            }
          } else {
            if (
              !context &&
              selector[0] === "#" &&
              !selector.match(/[ .<>:~]/)
            ) {
              // Pure ID selector
              els = [doc.getElementById(selector.trim().split("#")[1])];
            } else {
              // Other selectors
              els = (context || doc).querySelectorAll(selector.trim());
            }
            for (i = 0; i < els.length; i += 1) {
              if (els[i]) arr.push(els[i]);
            }
          }
        } else if (selector.nodeType || selector === win || selector === doc) {
          // Node/element
          arr.push(selector);
        } else if (selector.length > 0 && selector[0].nodeType) {
          // Array of elements or instance of Dom
          for (i = 0; i < selector.length; i += 1) {
            arr.push(selector[i]);
          }
        }
      }
      return new Dom7(arr);
    }

    dom7_modular_$.fn = Dom7.prototype;
    dom7_modular_$.Class = Dom7;
    dom7_modular_$.Dom7 = Dom7;

    function unique(arr) {
      const uniqueArray = [];
      for (let i = 0; i < arr.length; i += 1) {
        if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
      }
      return uniqueArray;
    }
    function toCamelCase(string) {
      return string
        .toLowerCase()
        .replace(/-(.)/g, (match, group1) => group1.toUpperCase());
    }

    function dom7_modular_requestAnimationFrame(callback) {
      if (window.requestAnimationFrame)
        return window.requestAnimationFrame(callback);
      else if (window.webkitRequestAnimationFrame)
        return window.webkitRequestAnimationFrame(callback);
      return window.setTimeout(callback, 1000 / 60);
    }
    function cancelAnimationFrame(id) {
      if (window.cancelAnimationFrame) return window.cancelAnimationFrame(id);
      else if (window.webkitCancelAnimationFrame)
        return window.webkitCancelAnimationFrame(id);
      return window.clearTimeout(id);
    }

    // Classes and attributes
    function dom7_modular_addClass(className) {
      if (typeof className === "undefined") {
        return this;
      }
      const classes = className.split(" ");
      for (let i = 0; i < classes.length; i += 1) {
        for (let j = 0; j < this.length; j += 1) {
          if (
            typeof this[j] !== "undefined" &&
            typeof this[j].classList !== "undefined"
          )
            this[j].classList.add(classes[i]);
        }
      }
      return this;
    }
    function dom7_modular_removeClass(className) {
      const classes = className.split(" ");
      for (let i = 0; i < classes.length; i += 1) {
        for (let j = 0; j < this.length; j += 1) {
          if (
            typeof this[j] !== "undefined" &&
            typeof this[j].classList !== "undefined"
          )
            this[j].classList.remove(classes[i]);
        }
      }
      return this;
    }
    function hasClass(className) {
      if (!this[0]) return false;
      return this[0].classList.contains(className);
    }
    function toggleClass(className) {
      const classes = className.split(" ");
      for (let i = 0; i < classes.length; i += 1) {
        for (let j = 0; j < this.length; j += 1) {
          if (
            typeof this[j] !== "undefined" &&
            typeof this[j].classList !== "undefined"
          )
            this[j].classList.toggle(classes[i]);
        }
      }
      return this;
    }
    function attr(attrs, value) {
      if (arguments.length === 1 && typeof attrs === "string") {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
      }

      // Set attrs
      for (let i = 0; i < this.length; i += 1) {
        if (arguments.length === 2) {
          // String
          this[i].setAttribute(attrs, value);
        } else {
          // Object
          // eslint-disable-next-line
          for (const attrName in attrs) {
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
          }
        }
      }
      return this;
    }
    // eslint-disable-next-line
    function removeAttr(attr) {
      for (let i = 0; i < this.length; i += 1) {
        this[i].removeAttribute(attr);
      }
      return this;
    }
    // eslint-disable-next-line
    function prop(props, value) {
      if (arguments.length === 1 && typeof props === "string") {
        // Get prop
        if (this[0]) return this[0][props];
      } else {
        // Set props
        for (let i = 0; i < this.length; i += 1) {
          if (arguments.length === 2) {
            // String
            this[i][props] = value;
          } else {
            // Object
            // eslint-disable-next-line
            for (const propName in props) {
              this[i][propName] = props[propName];
            }
          }
        }
        return this;
      }
    }
    function data(key, value) {
      let el;
      if (typeof value === "undefined") {
        el = this[0];
        // Get value
        if (el) {
          if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
            return el.dom7ElementDataStorage[key];
          }

          const dataKey = el.getAttribute(`data-${key}`);
          if (dataKey) {
            return dataKey;
          }
          return undefined;
        }
        return undefined;
      }

      // Set value
      for (let i = 0; i < this.length; i += 1) {
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
      }
      return this;
    }
    function removeData(key) {
      for (let i = 0; i < this.length; i += 1) {
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
          el.dom7ElementDataStorage[key] = null;
          delete el.dom7ElementDataStorage[key];
        }
      }
    }
    function dataset() {
      const el = this[0];
      if (!el) return undefined;
      const dataset = {}; // eslint-disable-line
      if (el.dataset) {
        // eslint-disable-next-line
        for (const dataKey in el.dataset) {
          dataset[dataKey] = el.dataset[dataKey];
        }
      } else {
        for (let i = 0; i < el.attributes.length; i += 1) {
          // eslint-disable-next-line
          const attr = el.attributes[i];
          if (attr.name.indexOf("data-") >= 0) {
            dataset[toCamelCase(attr.name.split("data-")[1])] = attr.value;
          }
        }
      }
      // eslint-disable-next-line
      for (const key in dataset) {
        if (dataset[key] === "false") dataset[key] = false;
        else if (dataset[key] === "true") dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1)
          dataset[key] *= 1;
      }
      return dataset;
    }
    function val(value) {
      const dom = this;
      if (typeof value === "undefined") {
        if (dom[0]) {
          if (dom[0].multiple && dom[0].nodeName.toLowerCase() === "select") {
            const values = [];
            for (let i = 0; i < dom[0].selectedOptions.length; i += 1) {
              values.push(dom[0].selectedOptions[i].value);
            }
            return values;
          }
          return dom[0].value;
        }
        return undefined;
      }

      for (let i = 0; i < dom.length; i += 1) {
        const el = dom[i];
        if (
          Array.isArray(value) &&
          el.multiple &&
          el.nodeName.toLowerCase() === "select"
        ) {
          for (let j = 0; j < el.options.length; j += 1) {
            el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
          }
        } else {
          el.value = value;
        }
      }
      return dom;
    }
    // Transforms
    // eslint-disable-next-line
    function transform(transform) {
      for (let i = 0; i < this.length; i += 1) {
        const elStyle = this[i].style;
        elStyle.webkitTransform = transform;
        elStyle.transform = transform;
      }
      return this;
    }
    function dom7_modular_transition(duration) {
      if (typeof duration !== "string") {
        duration = `${duration}ms`; // eslint-disable-line
      }
      for (let i = 0; i < this.length; i += 1) {
        const elStyle = this[i].style;
        elStyle.webkitTransitionDuration = duration;
        elStyle.transitionDuration = duration;
      }
      return this;
    }
    // Events
    function on(...args) {
      let [eventType, targetSelector, listener, capture] = args;
      if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
      }
      if (!capture) capture = false;

      function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }
        if (dom7_modular_$(target).is(targetSelector))
          listener.apply(target, eventData);
        else {
          const parents = dom7_modular_$(target).parents(); // eslint-disable-line
          for (let k = 0; k < parents.length; k += 1) {
            if (dom7_modular_$(parents[k]).is(targetSelector))
              listener.apply(parents[k], eventData);
          }
        }
      }
      function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }
        listener.apply(this, eventData);
      }
      const events = eventType.split(" ");
      let j;
      for (let i = 0; i < this.length; i += 1) {
        const el = this[i];
        if (!targetSelector) {
          for (j = 0; j < events.length; j += 1) {
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
              listener,
              proxyListener: handleEvent,
            });
            el.addEventListener(event, handleEvent, capture);
          }
        } else {
          // Live events
          for (j = 0; j < events.length; j += 1) {
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
              listener,
              proxyListener: handleLiveEvent,
            });
            el.addEventListener(event, handleLiveEvent, capture);
          }
        }
      }
      return this;
    }
    function off(...args) {
      let [eventType, targetSelector, listener, capture] = args;
      if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
      }
      if (!capture) capture = false;

      const events = eventType.split(" ");
      for (let i = 0; i < events.length; i += 1) {
        const event = events[i];
        for (let j = 0; j < this.length; j += 1) {
          const el = this[j];
          let handlers;
          if (!targetSelector && el.dom7Listeners) {
            handlers = el.dom7Listeners[event];
          } else if (targetSelector && el.dom7LiveListeners) {
            handlers = el.dom7LiveListeners[event];
          }
          if (handlers && handlers.length) {
            for (let k = handlers.length - 1; k >= 0; k -= 1) {
              const handler = handlers[k];
              if (listener && handler.listener === listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (
                listener &&
                handler.listener &&
                handler.listener.dom7proxy &&
                handler.listener.dom7proxy === listener
              ) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (!listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              }
            }
          }
        }
      }
      return this;
    }
    function dom7_modular_once(...args) {
      const dom = this;
      let [eventName, targetSelector, listener, capture] = args;
      if (typeof args[1] === "function") {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
      }
      function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) {
          delete onceHandler.dom7proxy;
        }
      }
      onceHandler.dom7proxy = listener;
      return dom.on(eventName, targetSelector, onceHandler, capture);
    }
    function dom7_modular_trigger(...args) {
      const events = args[0].split(" ");
      const eventData = args[1];
      for (let i = 0; i < events.length; i += 1) {
        const event = events[i];
        for (let j = 0; j < this.length; j += 1) {
          const el = this[j];
          let evt;
          try {
            evt = new win.CustomEvent(event, {
              detail: eventData,
              bubbles: true,
              cancelable: true,
            });
          } catch (e) {
            evt = doc.createEvent("Event");
            evt.initEvent(event, true, true);
            evt.detail = eventData;
          }
          // eslint-disable-next-line
          el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
          el.dispatchEvent(evt);
          el.dom7EventData = [];
          delete el.dom7EventData;
        }
      }
      return this;
    }
    function transitionEnd(callback) {
      const events = ["webkitTransitionEnd", "transitionend"];
      const dom = this;
      let i;
      function fireCallBack(e) {
        /* jshint validthis:true */
        if (e.target !== this) return;
        callback.call(this, e);
        for (i = 0; i < events.length; i += 1) {
          dom.off(events[i], fireCallBack);
        }
      }
      if (callback) {
        for (i = 0; i < events.length; i += 1) {
          dom.on(events[i], fireCallBack);
        }
      }
      return this;
    }
    function animationEnd(callback) {
      const events = ["webkitAnimationEnd", "animationend"];
      const dom = this;
      let i;
      function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        for (i = 0; i < events.length; i += 1) {
          dom.off(events[i], fireCallBack);
        }
      }
      if (callback) {
        for (i = 0; i < events.length; i += 1) {
          dom.on(events[i], fireCallBack);
        }
      }
      return this;
    }
    // Sizing/Styles
    function width() {
      if (this[0] === window) {
        return window.innerWidth;
      }

      if (this.length > 0) {
        return parseFloat(this.css("width"));
      }

      return null;
    }
    function dom7_modular_outerWidth(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          // eslint-disable-next-line
          const styles = this.styles();
          return (
            this[0].offsetWidth +
            parseFloat(styles.getPropertyValue("margin-right")) +
            parseFloat(styles.getPropertyValue("margin-left"))
          );
        }
        return this[0].offsetWidth;
      }
      return null;
    }
    function height() {
      if (this[0] === window) {
        return window.innerHeight;
      }

      if (this.length > 0) {
        return parseFloat(this.css("height"));
      }

      return null;
    }
    function dom7_modular_outerHeight(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          // eslint-disable-next-line
          const styles = this.styles();
          return (
            this[0].offsetHeight +
            parseFloat(styles.getPropertyValue("margin-top")) +
            parseFloat(styles.getPropertyValue("margin-bottom"))
          );
        }
        return this[0].offsetHeight;
      }
      return null;
    }
    function offset() {
      if (this.length > 0) {
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = doc.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === win ? win.scrollY : el.scrollTop;
        const scrollLeft = el === win ? win.scrollX : el.scrollLeft;
        return {
          top: box.top + scrollTop - clientTop,
          left: box.left + scrollLeft - clientLeft,
        };
      }

      return null;
    }
    function hide() {
      for (let i = 0; i < this.length; i += 1) {
        this[i].style.display = "none";
      }
      return this;
    }
    function dom7_modular_show() {
      for (let i = 0; i < this.length; i += 1) {
        const el = this[i];
        if (el.style.display === "none") {
          el.style.display = "";
        }
        if (
          window.getComputedStyle(el, null).getPropertyValue("display") ===
          "none"
        ) {
          // Still not visible
          el.style.display = "block";
        }
      }
      return this;
    }
    function styles() {
      if (this[0]) return win.getComputedStyle(this[0], null);
      return {};
    }
    function css(props, value) {
      let i;
      if (arguments.length === 1) {
        if (typeof props === "string") {
          if (this[0])
            return win.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
          for (i = 0; i < this.length; i += 1) {
            // eslint-disable-next-line
            for (let prop in props) {
              this[i].style[prop] = props[prop];
            }
          }
          return this;
        }
      }
      if (arguments.length === 2 && typeof props === "string") {
        for (i = 0; i < this.length; i += 1) {
          this[i].style[props] = value;
        }
        return this;
      }
      return this;
    }

    // Dom manipulation
    function dom7_modular_toArray() {
      const arr = [];
      for (let i = 0; i < this.length; i += 1) {
        arr.push(this[i]);
      }
      return arr;
    }
    // Iterate over the collection passing elements to `callback`
    function each(callback) {
      // Don't bother continuing without a callback
      if (!callback) return this;
      // Iterate over the current collection
      for (let i = 0; i < this.length; i += 1) {
        // If the callback returns false
        if (callback.call(this[i], i, this[i]) === false) {
          // End the loop early
          return this;
        }
      }
      // Return `this` to allow chained DOM operations
      return this;
    }
    function forEach(callback) {
      // Don't bother continuing without a callback
      if (!callback) return this;
      // Iterate over the current collection
      for (let i = 0; i < this.length; i += 1) {
        // If the callback returns false
        if (callback.call(this[i], this[i], i) === false) {
          // End the loop early
          return this;
        }
      }
      // Return `this` to allow chained DOM operations
      return this;
    }
    function filter(callback) {
      const matchedItems = [];
      const dom = this;
      for (let i = 0; i < dom.length; i += 1) {
        if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
      }
      return new Dom7(matchedItems);
    }
    function map(callback) {
      const modifiedItems = [];
      const dom = this;
      for (let i = 0; i < dom.length; i += 1) {
        modifiedItems.push(callback.call(dom[i], i, dom[i]));
      }
      return new Dom7(modifiedItems);
    }
    // eslint-disable-next-line
    function html(html) {
      if (typeof html === "undefined") {
        return this[0] ? this[0].innerHTML : undefined;
      }

      for (let i = 0; i < this.length; i += 1) {
        this[i].innerHTML = html;
      }
      return this;
    }
    // eslint-disable-next-line
    function dom7_modular_text(text) {
      if (typeof text === "undefined") {
        if (this[0]) {
          return this[0].textContent.trim();
        }
        return null;
      }

      for (let i = 0; i < this.length; i += 1) {
        this[i].textContent = text;
      }
      return this;
    }
    function is(selector) {
      const el = this[0];
      let compareWith;
      let i;
      if (!el || typeof selector === "undefined") return false;
      if (typeof selector === "string") {
        if (el.matches) return el.matches(selector);
        else if (el.webkitMatchesSelector)
          return el.webkitMatchesSelector(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);

        compareWith = dom7_modular_$(selector);
        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) return true;
        }
        return false;
      } else if (selector === doc) return el === doc;
      else if (selector === win) return el === win;

      if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [selector] : selector;
        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) return true;
        }
        return false;
      }
      return false;
    }
    function indexOf(el) {
      for (let i = 0; i < this.length; i += 1) {
        if (this[i] === el) return i;
      }
      return -1;
    }
    function dom7_modular_index() {
      let child = this[0];
      let i;
      if (child) {
        i = 0;
        // eslint-disable-next-line
        while ((child = child.previousSibling) !== null) {
          if (child.nodeType === 1) i += 1;
        }
        return i;
      }
      return undefined;
    }
    // eslint-disable-next-line
    function eq(index) {
      if (typeof index === "undefined") return this;
      const length = this.length;
      let returnIndex;
      if (index > length - 1) {
        return new Dom7([]);
      }
      if (index < 0) {
        returnIndex = length + index;
        if (returnIndex < 0) return new Dom7([]);
        return new Dom7([this[returnIndex]]);
      }
      return new Dom7([this[index]]);
    }
    function append(...args) {
      let newChild;

      for (let k = 0; k < args.length; k += 1) {
        newChild = args[k];
        for (let i = 0; i < this.length; i += 1) {
          if (typeof newChild === "string") {
            const tempDiv = doc.createElement("div");
            tempDiv.innerHTML = newChild;
            while (tempDiv.firstChild) {
              this[i].appendChild(tempDiv.firstChild);
            }
          } else if (newChild instanceof Dom7) {
            for (let j = 0; j < newChild.length; j += 1) {
              this[i].appendChild(newChild[j]);
            }
          } else {
            this[i].appendChild(newChild);
          }
        }
      }

      return this;
    }
    // eslint-disable-next-line
    function appendTo(parent) {
      dom7_modular_$(parent).append(this);
      return this;
    }
    function prepend(newChild) {
      let i;
      let j;
      for (i = 0; i < this.length; i += 1) {
        if (typeof newChild === "string") {
          const tempDiv = doc.createElement("div");
          tempDiv.innerHTML = newChild;
          for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
          }
        } else if (newChild instanceof Dom7) {
          for (j = 0; j < newChild.length; j += 1) {
            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
          }
        } else {
          this[i].insertBefore(newChild, this[i].childNodes[0]);
        }
      }
      return this;
    }
    // eslint-disable-next-line
    function prependTo(parent) {
      dom7_modular_$(parent).prepend(this);
      return this;
    }
    function dom7_modular_insertBefore(selector) {
      const before = dom7_modular_$(selector);
      for (let i = 0; i < this.length; i += 1) {
        if (before.length === 1) {
          before[0].parentNode.insertBefore(this[i], before[0]);
        } else if (before.length > 1) {
          for (let j = 0; j < before.length; j += 1) {
            before[j].parentNode.insertBefore(
              this[i].cloneNode(true),
              before[j]
            );
          }
        }
      }
    }
    function insertAfter(selector) {
      const after = dom7_modular_$(selector);
      for (let i = 0; i < this.length; i += 1) {
        if (after.length === 1) {
          after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        } else if (after.length > 1) {
          for (let j = 0; j < after.length; j += 1) {
            after[j].parentNode.insertBefore(
              this[i].cloneNode(true),
              after[j].nextSibling
            );
          }
        }
      }
    }
    function next(selector) {
      if (this.length > 0) {
        if (selector) {
          if (
            this[0].nextElementSibling &&
            dom7_modular_$(this[0].nextElementSibling).is(selector)
          ) {
            return new Dom7([this[0].nextElementSibling]);
          }
          return new Dom7([]);
        }

        if (this[0].nextElementSibling)
          return new Dom7([this[0].nextElementSibling]);
        return new Dom7([]);
      }
      return new Dom7([]);
    }
    function nextAll(selector) {
      const nextEls = [];
      let el = this[0];
      if (!el) return new Dom7([]);
      while (el.nextElementSibling) {
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
          if (dom7_modular_$(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
      }
      return new Dom7(nextEls);
    }
    function prev(selector) {
      if (this.length > 0) {
        const el = this[0];
        if (selector) {
          if (
            el.previousElementSibling &&
            dom7_modular_$(el.previousElementSibling).is(selector)
          ) {
            return new Dom7([el.previousElementSibling]);
          }
          return new Dom7([]);
        }

        if (el.previousElementSibling)
          return new Dom7([el.previousElementSibling]);
        return new Dom7([]);
      }
      return new Dom7([]);
    }
    function prevAll(selector) {
      const prevEls = [];
      let el = this[0];
      if (!el) return new Dom7([]);
      while (el.previousElementSibling) {
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
          if (dom7_modular_$(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
      }
      return new Dom7(prevEls);
    }
    function siblings(selector) {
      return this.nextAll(selector).add(this.prevAll(selector));
    }
    function dom7_modular_parent(selector) {
      const parents = []; // eslint-disable-line
      for (let i = 0; i < this.length; i += 1) {
        if (this[i].parentNode !== null) {
          if (selector) {
            if (dom7_modular_$(this[i].parentNode).is(selector))
              parents.push(this[i].parentNode);
          } else {
            parents.push(this[i].parentNode);
          }
        }
      }
      return dom7_modular_$(unique(parents));
    }
    function parents(selector) {
      const parents = []; // eslint-disable-line
      for (let i = 0; i < this.length; i += 1) {
        let parent = this[i].parentNode; // eslint-disable-line
        while (parent) {
          if (selector) {
            if (dom7_modular_$(parent).is(selector)) parents.push(parent);
          } else {
            parents.push(parent);
          }
          parent = parent.parentNode;
        }
      }
      return dom7_modular_$(unique(parents));
    }
    function closest(selector) {
      let closest = this; // eslint-disable-line
      if (typeof selector === "undefined") {
        return new Dom7([]);
      }
      if (!closest.is(selector)) {
        closest = closest.parents(selector).eq(0);
      }
      return closest;
    }
    function find(selector) {
      const foundElements = [];
      for (let i = 0; i < this.length; i += 1) {
        const found = this[i].querySelectorAll(selector);
        for (let j = 0; j < found.length; j += 1) {
          foundElements.push(found[j]);
        }
      }
      return new Dom7(foundElements);
    }
    function children(selector) {
      const children = []; // eslint-disable-line
      for (let i = 0; i < this.length; i += 1) {
        const childNodes = this[i].childNodes;

        for (let j = 0; j < childNodes.length; j += 1) {
          if (!selector) {
            if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
          } else if (
            childNodes[j].nodeType === 1 &&
            dom7_modular_$(childNodes[j]).is(selector)
          ) {
            children.push(childNodes[j]);
          }
        }
      }
      return new Dom7(unique(children));
    }
    function dom7_modular_remove() {
      for (let i = 0; i < this.length; i += 1) {
        if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
      }
      return this;
    }
    function detach() {
      return this.remove();
    }
    function dom7_modular_add(...args) {
      const dom = this;
      let i;
      let j;
      for (i = 0; i < args.length; i += 1) {
        const toAdd = dom7_modular_$(args[i]);
        for (j = 0; j < toAdd.length; j += 1) {
          dom[dom.length] = toAdd[j];
          dom.length += 1;
        }
      }
      return dom;
    }
    function empty() {
      for (let i = 0; i < this.length; i += 1) {
        const el = this[i];
        if (el.nodeType === 1) {
          for (let j = 0; j < el.childNodes.length; j += 1) {
            if (el.childNodes[j].parentNode) {
              el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            }
          }
          el.textContent = "";
        }
      }
      return this;
    }

    function scrollTo(...args) {
      let [left, top, duration, easing, callback] = args;
      if (args.length === 4 && typeof easing === "function") {
        callback = easing;
        [left, top, duration, callback, easing] = args;
      }
      if (typeof easing === "undefined") easing = "swing";

      return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === "undefined") {
          easing = "swing";
        }
        if (animateTop) {
          currentTop = el.scrollTop;
          if (!duration) {
            el.scrollTop = top;
          }
        }
        if (animateLeft) {
          currentLeft = el.scrollLeft;
          if (!duration) {
            el.scrollLeft = left;
          }
        }
        if (!duration) return;
        if (animateTop) {
          maxTop = el.scrollHeight - el.offsetHeight;
          newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
          maxLeft = el.scrollWidth - el.offsetWidth;
          newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
          if (startTime === null) {
            startTime = time;
          }
          const progress = Math.max(
            Math.min((time - startTime) / duration, 1),
            0
          );
          const easeProgress =
            easing === "linear"
              ? progress
              : 0.5 - Math.cos(progress * Math.PI) / 2;
          let done;
          if (animateTop)
            scrollTop = currentTop + easeProgress * (newTop - currentTop);
          if (animateLeft)
            scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
          if (animateTop && newTop > currentTop && scrollTop >= newTop) {
            el.scrollTop = newTop;
            done = true;
          }
          if (animateTop && newTop < currentTop && scrollTop <= newTop) {
            el.scrollTop = newTop;
            done = true;
          }
          if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
            el.scrollLeft = newLeft;
            done = true;
          }
          if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
            el.scrollLeft = newLeft;
            done = true;
          }

          if (done) {
            if (callback) callback();
            return;
          }
          if (animateTop) el.scrollTop = scrollTop;
          if (animateLeft) el.scrollLeft = scrollLeft;
          dom7_modular_requestAnimationFrame(render);
        }
        dom7_modular_requestAnimationFrame(render);
      });
    }
    // scrollTop(top, duration, easing, callback) {
    function scrollTop(...args) {
      let [top, duration, easing, callback] = args;
      if (args.length === 3 && typeof easing === "function") {
        [top, duration, callback, easing] = args;
      }
      const dom = this;
      if (typeof top === "undefined") {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
      }
      return dom.scrollTo(undefined, top, duration, easing, callback);
    }
    function scrollLeft(...args) {
      let [left, duration, easing, callback] = args;
      if (args.length === 3 && typeof easing === "function") {
        [left, duration, callback, easing] = args;
      }
      const dom = this;
      if (typeof left === "undefined") {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
      }
      return dom.scrollTo(left, undefined, duration, easing, callback);
    }

    function animate(initialProps, initialParams) {
      const els = this;
      const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign(
          {
            duration: 300,
            easing: "swing", // or 'linear'
            /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */
          },
          initialParams
        ),

        elements: els,
        animating: false,
        que: [],

        easingProgress(easing, progress) {
          if (easing === "swing") {
            return 0.5 - Math.cos(progress * Math.PI) / 2;
          }
          if (typeof easing === "function") {
            return easing(progress);
          }
          return progress;
        },
        stop() {
          if (a.frameId) {
            cancelAnimationFrame(a.frameId);
          }
          a.animating = false;
          a.elements.each((index, el) => {
            const element = el;
            delete element.dom7AnimateInstance;
          });
          a.que = [];
        },
        done(complete) {
          a.animating = false;
          a.elements.each((index, el) => {
            const element = el;
            delete element.dom7AnimateInstance;
          });
          if (complete) complete(els);
          if (a.que.length > 0) {
            const que = a.que.shift();
            a.animate(que[0], que[1]);
          }
        },
        animate(props, params) {
          if (a.animating) {
            a.que.push([props, params]);
            return a;
          }
          const elements = [];

          // Define & Cache Initials & Units
          a.elements.each((index, el) => {
            let initialFullValue;
            let initialValue;
            let unit;
            let finalValue;
            let finalFullValue;

            if (!el.dom7AnimateInstance)
              a.elements[index].dom7AnimateInstance = a;

            elements[index] = {
              container: el,
            };
            Object.keys(props).forEach((prop) => {
              initialFullValue = window
                .getComputedStyle(el, null)
                .getPropertyValue(prop)
                .replace(",", ".");
              initialValue = parseFloat(initialFullValue);
              unit = initialFullValue.replace(initialValue, "");
              finalValue = parseFloat(props[prop]);
              finalFullValue = props[prop] + unit;
              elements[index][prop] = {
                initialFullValue,
                initialValue,
                unit,
                finalValue,
                finalFullValue,
                currentValue: initialValue,
              };
            });
          });

          let startTime = null;
          let time;
          let elementsDone = 0;
          let propsDone = 0;
          let done;
          let began = false;

          a.animating = true;

          function render() {
            time = new Date().getTime();
            let progress;
            let easeProgress;
            // let el;
            if (!began) {
              began = true;
              if (params.begin) params.begin(els);
            }
            if (startTime === null) {
              startTime = time;
            }
            if (params.progress) {
              // eslint-disable-next-line
              params.progress(
                els,
                Math.max(Math.min((time - startTime) / params.duration, 1), 0),
                startTime + params.duration - time < 0
                  ? 0
                  : startTime + params.duration - time,
                startTime
              );
            }

            elements.forEach((element) => {
              const el = element;
              if (done || el.done) return;
              Object.keys(props).forEach((prop) => {
                if (done || el.done) return;
                progress = Math.max(
                  Math.min((time - startTime) / params.duration, 1),
                  0
                );
                easeProgress = a.easingProgress(params.easing, progress);
                const { initialValue, finalValue, unit } = el[prop];
                el[prop].currentValue =
                  initialValue + easeProgress * (finalValue - initialValue);
                const currentValue = el[prop].currentValue;

                if (
                  (finalValue > initialValue && currentValue >= finalValue) ||
                  (finalValue < initialValue && currentValue <= finalValue)
                ) {
                  el.container.style[prop] = finalValue + unit;
                  propsDone += 1;
                  if (propsDone === Object.keys(props).length) {
                    el.done = true;
                    elementsDone += 1;
                  }
                  if (elementsDone === elements.length) {
                    done = true;
                  }
                }
                if (done) {
                  a.done(params.complete);
                  return;
                }
                el.container.style[prop] = currentValue + unit;
              });
            });
            if (done) return;
            // Then call
            a.frameId = dom7_modular_requestAnimationFrame(render);
          }
          a.frameId = dom7_modular_requestAnimationFrame(render);
          return a;
        },
      };

      if (a.elements.length === 0) {
        return els;
      }

      let animateInstance;
      for (let i = 0; i < a.elements.length; i += 1) {
        if (a.elements[i].dom7AnimateInstance) {
          animateInstance = a.elements[i].dom7AnimateInstance;
        } else a.elements[i].dom7AnimateInstance = a;
      }
      if (!animateInstance) {
        animateInstance = a;
      }

      if (initialProps === "stop") {
        animateInstance.stop();
      } else {
        animateInstance.animate(a.props, a.params);
      }

      return els;
    }

    function stop() {
      const els = this;
      for (let i = 0; i < els.length; i += 1) {
        if (els[i].dom7AnimateInstance) {
          els[i].dom7AnimateInstance.stop();
        }
      }
    }

    const noTrigger = "resize scroll".split(" ");
    function eventShortcut(name, ...args) {
      if (typeof args[0] === "undefined") {
        for (let i = 0; i < this.length; i += 1) {
          if (noTrigger.indexOf(name) < 0) {
            if (name in this[i]) this[i][name]();
            else {
              dom7_modular_$(this[i]).trigger(name);
            }
          }
        }
        return this;
      }
      return this.on(name, ...args);
    }

    function click(...args) {
      return eventShortcut.bind(this)("click", ...args);
    }
    function dom7_modular_blur(...args) {
      return eventShortcut.bind(this)("blur", ...args);
    }
    function dom7_modular_focus(...args) {
      return eventShortcut.bind(this)("focus", ...args);
    }
    function focusin(...args) {
      return eventShortcut.bind(this)("focusin", ...args);
    }
    function focusout(...args) {
      return eventShortcut.bind(this)("focusout", ...args);
    }
    function keyup(...args) {
      return eventShortcut.bind(this)("keyup", ...args);
    }
    function keydown(...args) {
      return eventShortcut.bind(this)("keydown", ...args);
    }
    function keypress(...args) {
      return eventShortcut.bind(this)("keypress", ...args);
    }
    function dom7_modular_submit(...args) {
      return eventShortcut.bind(this)("submit", ...args);
    }
    function change(...args) {
      return eventShortcut.bind(this)("change", ...args);
    }
    function mousedown(...args) {
      return eventShortcut.bind(this)("mousedown", ...args);
    }
    function mousemove(...args) {
      return eventShortcut.bind(this)("mousemove", ...args);
    }
    function mouseup(...args) {
      return eventShortcut.bind(this)("mouseup", ...args);
    }
    function mouseenter(...args) {
      return eventShortcut.bind(this)("mouseenter", ...args);
    }
    function mouseleave(...args) {
      return eventShortcut.bind(this)("mouseleave", ...args);
    }
    function mouseout(...args) {
      return eventShortcut.bind(this)("mouseout", ...args);
    }
    function mouseover(...args) {
      return eventShortcut.bind(this)("mouseover", ...args);
    }
    function touchstart(...args) {
      return eventShortcut.bind(this)("touchstart", ...args);
    }
    function touchend(...args) {
      return eventShortcut.bind(this)("touchend", ...args);
    }
    function touchmove(...args) {
      return eventShortcut.bind(this)("touchmove", ...args);
    }
    function resize(...args) {
      return eventShortcut.bind(this)("resize", ...args);
    }
    function dom7_modular_scroll(...args) {
      return eventShortcut.bind(this)("scroll", ...args);
    } // CONCATENATED MODULE: ./node_modules/swiper/js/swiper.esm.bundle.js

    /**
     * Swiper 5.4.5
     * Most modern mobile touch slider and framework with hardware accelerated transitions
     * http://swiperjs.com
     *
     * Copyright 2014-2020 Vladimir Kharlampidi
     *
     * Released under the MIT License
     *
     * Released on: June 16, 2020
     */

    const Methods = {
      addClass: dom7_modular_addClass,
      removeClass: dom7_modular_removeClass,
      hasClass: hasClass,
      toggleClass: toggleClass,
      attr: attr,
      removeAttr: removeAttr,
      data: data,
      transform: transform,
      transition: dom7_modular_transition,
      on: on,
      off: off,
      trigger: dom7_modular_trigger,
      transitionEnd: transitionEnd,
      outerWidth: dom7_modular_outerWidth,
      outerHeight: dom7_modular_outerHeight,
      offset: offset,
      css: css,
      each: each,
      html: html,
      text: dom7_modular_text,
      is: is,
      index: dom7_modular_index,
      eq: eq,
      append: append,
      prepend: prepend,
      next: next,
      nextAll: nextAll,
      prev: prev,
      prevAll: prevAll,
      parent: dom7_modular_parent,
      parents: parents,
      closest: closest,
      find: find,
      children: children,
      filter: filter,
      remove: dom7_modular_remove,
      add: dom7_modular_add,
      styles: styles,
    };

    Object.keys(Methods).forEach((methodName) => {
      dom7_modular_$.fn[methodName] =
        dom7_modular_$.fn[methodName] || Methods[methodName];
    });

    const Utils = {
      deleteProps(obj) {
        const object = obj;
        Object.keys(object).forEach((key) => {
          try {
            object[key] = null;
          } catch (e) {
            // no getter for object
          }
          try {
            delete object[key];
          } catch (e) {
            // something got wrong
          }
        });
      },
      nextTick(callback, delay = 0) {
        return setTimeout(callback, delay);
      },
      now() {
        return Date.now();
      },
      getTranslate(el, axis = "x") {
        let matrix;
        let curTransform;
        let transformMatrix;

        const curStyle = win.getComputedStyle(el, null);

        if (win.WebKitCSSMatrix) {
          curTransform = curStyle.transform || curStyle.webkitTransform;
          if (curTransform.split(",").length > 6) {
            curTransform = curTransform
              .split(", ")
              .map((a) => a.replace(",", "."))
              .join(", ");
          }
          // Some old versions of Webkit choke when 'none' is passed; pass
          // empty string instead in this case
          transformMatrix = new win.WebKitCSSMatrix(
            curTransform === "none" ? "" : curTransform
          );
        } else {
          transformMatrix =
            curStyle.MozTransform ||
            curStyle.OTransform ||
            curStyle.MsTransform ||
            curStyle.msTransform ||
            curStyle.transform ||
            curStyle
              .getPropertyValue("transform")
              .replace("translate(", "matrix(1, 0, 0, 1,");
          matrix = transformMatrix.toString().split(",");
        }

        if (axis === "x") {
          // Latest Chrome and webkits Fix
          if (win.WebKitCSSMatrix) curTransform = transformMatrix.m41;
          // Crazy IE10 Matrix
          else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
          // Normal Browsers
          else curTransform = parseFloat(matrix[4]);
        }
        if (axis === "y") {
          // Latest Chrome and webkits Fix
          if (win.WebKitCSSMatrix) curTransform = transformMatrix.m42;
          // Crazy IE10 Matrix
          else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
          // Normal Browsers
          else curTransform = parseFloat(matrix[5]);
        }
        return curTransform || 0;
      },
      parseUrlQuery(url) {
        const query = {};
        let urlToParse = url || win.location.href;
        let i;
        let params;
        let param;
        let length;
        if (typeof urlToParse === "string" && urlToParse.length) {
          urlToParse =
            urlToParse.indexOf("?") > -1 ? urlToParse.replace(/\S*\?/, "") : "";
          params = urlToParse
            .split("&")
            .filter((paramsPart) => paramsPart !== "");
          length = params.length;

          for (i = 0; i < length; i += 1) {
            param = params[i].replace(/#\S+/g, "").split("=");
            query[decodeURIComponent(param[0])] =
              typeof param[1] === "undefined"
                ? undefined
                : decodeURIComponent(param[1]) || "";
          }
        }
        return query;
      },
      isObject(o) {
        return (
          typeof o === "object" &&
          o !== null &&
          o.constructor &&
          o.constructor === Object
        );
      },
      extend(...args) {
        const to = Object(args[0]);
        for (let i = 1; i < args.length; i += 1) {
          const nextSource = args[i];
          if (nextSource !== undefined && nextSource !== null) {
            const keysArray = Object.keys(Object(nextSource));
            for (
              let nextIndex = 0, len = keysArray.length;
              nextIndex < len;
              nextIndex += 1
            ) {
              const nextKey = keysArray[nextIndex];
              const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
              if (desc !== undefined && desc.enumerable) {
                if (
                  Utils.isObject(to[nextKey]) &&
                  Utils.isObject(nextSource[nextKey])
                ) {
                  Utils.extend(to[nextKey], nextSource[nextKey]);
                } else if (
                  !Utils.isObject(to[nextKey]) &&
                  Utils.isObject(nextSource[nextKey])
                ) {
                  to[nextKey] = {};
                  Utils.extend(to[nextKey], nextSource[nextKey]);
                } else {
                  to[nextKey] = nextSource[nextKey];
                }
              }
            }
          }
        }
        return to;
      },
    };

    const Support = (function Support() {
      return {
        touch: !!(
          "ontouchstart" in win ||
          (win.DocumentTouch && doc instanceof win.DocumentTouch)
        ),

        pointerEvents:
          !!win.PointerEvent &&
          "maxTouchPoints" in win.navigator &&
          win.navigator.maxTouchPoints >= 0,

        observer: (function checkObserver() {
          return "MutationObserver" in win || "WebkitMutationObserver" in win;
        })(),

        passiveListener: (function checkPassiveListener() {
          let supportsPassive = false;
          try {
            const opts = Object.defineProperty({}, "passive", {
              // eslint-disable-next-line
              get() {
                supportsPassive = true;
              },
            });
            win.addEventListener("testPassiveListener", null, opts);
          } catch (e) {
            // No support
          }
          return supportsPassive;
        })(),

        gestures: (function checkGestures() {
          return "ongesturestart" in win;
        })(),
      };
    })();

    class SwiperClass {
      constructor(params = {}) {
        const self = this;
        self.params = params;

        // Events
        self.eventsListeners = {};

        if (self.params && self.params.on) {
          Object.keys(self.params.on).forEach((eventName) => {
            self.on(eventName, self.params.on[eventName]);
          });
        }
      }

      on(events, handler, priority) {
        const self = this;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event) => {
          if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
          self.eventsListeners[event][method](handler);
        });
        return self;
      }

      once(events, handler, priority) {
        const self = this;
        if (typeof handler !== "function") return self;
        function onceHandler(...args) {
          self.off(events, onceHandler);
          if (onceHandler.f7proxy) {
            delete onceHandler.f7proxy;
          }
          handler.apply(self, args);
        }
        onceHandler.f7proxy = handler;
        return self.on(events, onceHandler, priority);
      }

      off(events, handler) {
        const self = this;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event) => {
          if (typeof handler === "undefined") {
            self.eventsListeners[event] = [];
          } else if (
            self.eventsListeners[event] &&
            self.eventsListeners[event].length
          ) {
            self.eventsListeners[event].forEach((eventHandler, index) => {
              if (
                eventHandler === handler ||
                (eventHandler.f7proxy && eventHandler.f7proxy === handler)
              ) {
                self.eventsListeners[event].splice(index, 1);
              }
            });
          }
        });
        return self;
      }

      emit(...args) {
        const self = this;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
          events = args[0];
          data = args.slice(1, args.length);
          context = self;
        } else {
          events = args[0].events;
          data = args[0].data;
          context = args[0].context || self;
        }
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event) => {
          if (self.eventsListeners && self.eventsListeners[event]) {
            const handlers = [];
            self.eventsListeners[event].forEach((eventHandler) => {
              handlers.push(eventHandler);
            });
            handlers.forEach((eventHandler) => {
              eventHandler.apply(context, data);
            });
          }
        });
        return self;
      }

      useModulesParams(instanceParams) {
        const instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach((moduleName) => {
          const module = instance.modules[moduleName];
          // Extend params
          if (module.params) {
            Utils.extend(instanceParams, module.params);
          }
        });
      }

      useModules(modulesParams = {}) {
        const instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach((moduleName) => {
          const module = instance.modules[moduleName];
          const moduleParams = modulesParams[moduleName] || {};
          // Extend instance methods and props
          if (module.instance) {
            Object.keys(module.instance).forEach((modulePropName) => {
              const moduleProp = module.instance[modulePropName];
              if (typeof moduleProp === "function") {
                instance[modulePropName] = moduleProp.bind(instance);
              } else {
                instance[modulePropName] = moduleProp;
              }
            });
          }
          // Add event listeners
          if (module.on && instance.on) {
            Object.keys(module.on).forEach((moduleEventName) => {
              instance.on(moduleEventName, module.on[moduleEventName]);
            });
          }

          // Module create callback
          if (module.create) {
            module.create.bind(instance)(moduleParams);
          }
        });
      }

      static set components(components) {
        const Class = this;
        if (!Class.use) return;
        Class.use(components);
      }

      static installModule(module, ...params) {
        const Class = this;
        if (!Class.prototype.modules) Class.prototype.modules = {};
        const name =
          module.name ||
          `${Object.keys(Class.prototype.modules).length}_${Utils.now()}`;
        Class.prototype.modules[name] = module;
        // Prototype
        if (module.proto) {
          Object.keys(module.proto).forEach((key) => {
            Class.prototype[key] = module.proto[key];
          });
        }
        // Class
        if (module.static) {
          Object.keys(module.static).forEach((key) => {
            Class[key] = module.static[key];
          });
        }
        // Callback
        if (module.install) {
          module.install.apply(Class, params);
        }
        return Class;
      }

      static use(module, ...params) {
        const Class = this;
        if (Array.isArray(module)) {
          module.forEach((m) => Class.installModule(m));
          return Class;
        }
        return Class.installModule(module, ...params);
      }
    }

    function updateSize() {
      const swiper = this;
      let width;
      let height;
      const $el = swiper.$el;
      if (typeof swiper.params.width !== "undefined") {
        width = swiper.params.width;
      } else {
        width = $el[0].clientWidth;
      }
      if (typeof swiper.params.height !== "undefined") {
        height = swiper.params.height;
      } else {
        height = $el[0].clientHeight;
      }
      if (
        (width === 0 && swiper.isHorizontal()) ||
        (height === 0 && swiper.isVertical())
      ) {
        return;
      }

      // Subtract paddings
      width =
        width -
        parseInt($el.css("padding-left"), 10) -
        parseInt($el.css("padding-right"), 10);
      height =
        height -
        parseInt($el.css("padding-top"), 10) -
        parseInt($el.css("padding-bottom"), 10);

      Utils.extend(swiper, {
        width,
        height,
        size: swiper.isHorizontal() ? width : height,
      });
    }

    function updateSlides() {
      const swiper = this;
      const params = swiper.params;

      const {
        $wrapperEl,
        size: swiperSize,
        rtlTranslate: rtl,
        wrongRTL,
      } = swiper;
      const isVirtual = swiper.virtual && params.virtual.enabled;
      const previousSlidesLength = isVirtual
        ? swiper.virtual.slides.length
        : swiper.slides.length;
      const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
      const slidesLength = isVirtual
        ? swiper.virtual.slides.length
        : slides.length;
      let snapGrid = [];
      const slidesGrid = [];
      const slidesSizesGrid = [];

      function slidesForMargin(slideIndex) {
        if (!params.cssMode) return true;
        if (slideIndex === slides.length - 1) {
          return false;
        }
        return true;
      }

      let offsetBefore = params.slidesOffsetBefore;
      if (typeof offsetBefore === "function") {
        offsetBefore = params.slidesOffsetBefore.call(swiper);
      }

      let offsetAfter = params.slidesOffsetAfter;
      if (typeof offsetAfter === "function") {
        offsetAfter = params.slidesOffsetAfter.call(swiper);
      }

      const previousSnapGridLength = swiper.snapGrid.length;
      const previousSlidesGridLength = swiper.snapGrid.length;

      let spaceBetween = params.spaceBetween;
      let slidePosition = -offsetBefore;
      let prevSlideSize = 0;
      let index = 0;
      if (typeof swiperSize === "undefined") {
        return;
      }
      if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
        spaceBetween =
          (parseFloat(spaceBetween.replace("%", "")) / 100) * swiperSize;
      }

      swiper.virtualSize = -spaceBetween;

      // reset margins
      if (rtl) slides.css({ marginLeft: "", marginTop: "" });
      else slides.css({ marginRight: "", marginBottom: "" });

      let slidesNumberEvenToRows;
      if (params.slidesPerColumn > 1) {
        if (
          Math.floor(slidesLength / params.slidesPerColumn) ===
          slidesLength / swiper.params.slidesPerColumn
        ) {
          slidesNumberEvenToRows = slidesLength;
        } else {
          slidesNumberEvenToRows =
            Math.ceil(slidesLength / params.slidesPerColumn) *
            params.slidesPerColumn;
        }
        if (
          params.slidesPerView !== "auto" &&
          params.slidesPerColumnFill === "row"
        ) {
          slidesNumberEvenToRows = Math.max(
            slidesNumberEvenToRows,
            params.slidesPerView * params.slidesPerColumn
          );
        }
      }

      // Calc slides
      let slideSize;
      const slidesPerColumn = params.slidesPerColumn;
      const slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
      const numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
      for (let i = 0; i < slidesLength; i += 1) {
        slideSize = 0;
        const slide = slides.eq(i);
        if (params.slidesPerColumn > 1) {
          // Set slides order
          let newSlideOrderIndex;
          let column;
          let row;
          if (
            params.slidesPerColumnFill === "row" &&
            params.slidesPerGroup > 1
          ) {
            const groupIndex = Math.floor(
              i / (params.slidesPerGroup * params.slidesPerColumn)
            );
            const slideIndexInGroup =
              i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
            const columnsInGroup =
              groupIndex === 0
                ? params.slidesPerGroup
                : Math.min(
                    Math.ceil(
                      (slidesLength -
                        groupIndex * slidesPerColumn * params.slidesPerGroup) /
                        slidesPerColumn
                    ),
                    params.slidesPerGroup
                  );
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column =
              slideIndexInGroup -
              row * columnsInGroup +
              groupIndex * params.slidesPerGroup;

            newSlideOrderIndex =
              column + (row * slidesNumberEvenToRows) / slidesPerColumn;
            slide.css({
              "-webkit-box-ordinal-group": newSlideOrderIndex,
              "-moz-box-ordinal-group": newSlideOrderIndex,
              "-ms-flex-order": newSlideOrderIndex,
              "-webkit-order": newSlideOrderIndex,
              order: newSlideOrderIndex,
            });
          } else if (params.slidesPerColumnFill === "column") {
            column = Math.floor(i / slidesPerColumn);
            row = i - column * slidesPerColumn;
            if (
              column > numFullColumns ||
              (column === numFullColumns && row === slidesPerColumn - 1)
            ) {
              row += 1;
              if (row >= slidesPerColumn) {
                row = 0;
                column += 1;
              }
            }
          } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
          }
          slide.css(
            `margin-${swiper.isHorizontal() ? "top" : "left"}`,
            row !== 0 && params.spaceBetween && `${params.spaceBetween}px`
          );
        }
        if (slide.css("display") === "none") continue; // eslint-disable-line

        if (params.slidesPerView === "auto") {
          const slideStyles = win.getComputedStyle(slide[0], null);
          const currentTransform = slide[0].style.transform;
          const currentWebKitTransform = slide[0].style.webkitTransform;
          if (currentTransform) {
            slide[0].style.transform = "none";
          }
          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = "none";
          }
          if (params.roundLengths) {
            slideSize = swiper.isHorizontal()
              ? slide.outerWidth(true)
              : slide.outerHeight(true);
          } else {
            // eslint-disable-next-line
            if (swiper.isHorizontal()) {
              const width = parseFloat(slideStyles.getPropertyValue("width"));
              const paddingLeft = parseFloat(
                slideStyles.getPropertyValue("padding-left")
              );
              const paddingRight = parseFloat(
                slideStyles.getPropertyValue("padding-right")
              );
              const marginLeft = parseFloat(
                slideStyles.getPropertyValue("margin-left")
              );
              const marginRight = parseFloat(
                slideStyles.getPropertyValue("margin-right")
              );
              const boxSizing = slideStyles.getPropertyValue("box-sizing");
              if (boxSizing && boxSizing === "border-box") {
                slideSize = width + marginLeft + marginRight;
              } else {
                slideSize =
                  width + paddingLeft + paddingRight + marginLeft + marginRight;
              }
            } else {
              const height = parseFloat(slideStyles.getPropertyValue("height"));
              const paddingTop = parseFloat(
                slideStyles.getPropertyValue("padding-top")
              );
              const paddingBottom = parseFloat(
                slideStyles.getPropertyValue("padding-bottom")
              );
              const marginTop = parseFloat(
                slideStyles.getPropertyValue("margin-top")
              );
              const marginBottom = parseFloat(
                slideStyles.getPropertyValue("margin-bottom")
              );
              const boxSizing = slideStyles.getPropertyValue("box-sizing");
              if (boxSizing && boxSizing === "border-box") {
                slideSize = height + marginTop + marginBottom;
              } else {
                slideSize =
                  height +
                  paddingTop +
                  paddingBottom +
                  marginTop +
                  marginBottom;
              }
            }
          }
          if (currentTransform) {
            slide[0].style.transform = currentTransform;
          }
          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = currentWebKitTransform;
          }
          if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
          slideSize =
            (swiperSize - (params.slidesPerView - 1) * spaceBetween) /
            params.slidesPerView;
          if (params.roundLengths) slideSize = Math.floor(slideSize);

          if (slides[i]) {
            if (swiper.isHorizontal()) {
              slides[i].style.width = `${slideSize}px`;
            } else {
              slides[i].style.height = `${slideSize}px`;
            }
          }
        }
        if (slides[i]) {
          slides[i].swiperSlideSize = slideSize;
        }
        slidesSizesGrid.push(slideSize);

        if (params.centeredSlides) {
          slidePosition =
            slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
          if (prevSlideSize === 0 && i !== 0)
            slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          if (i === 0)
            slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
          if (params.roundLengths) slidePosition = Math.floor(slidePosition);
          if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
          slidesGrid.push(slidePosition);
        } else {
          if (params.roundLengths) slidePosition = Math.floor(slidePosition);
          if (
            (index - Math.min(swiper.params.slidesPerGroupSkip, index)) %
              swiper.params.slidesPerGroup ===
            0
          )
            snapGrid.push(slidePosition);
          slidesGrid.push(slidePosition);
          slidePosition = slidePosition + slideSize + spaceBetween;
        }

        swiper.virtualSize += slideSize + spaceBetween;

        prevSlideSize = slideSize;

        index += 1;
      }
      swiper.virtualSize =
        Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
      let newSlidesGrid;

      if (
        rtl &&
        wrongRTL &&
        (params.effect === "slide" || params.effect === "coverflow")
      ) {
        $wrapperEl.css({
          width: `${swiper.virtualSize + params.spaceBetween}px`,
        });
      }
      if (params.setWrapperSize) {
        if (swiper.isHorizontal())
          $wrapperEl.css({
            width: `${swiper.virtualSize + params.spaceBetween}px`,
          });
        else
          $wrapperEl.css({
            height: `${swiper.virtualSize + params.spaceBetween}px`,
          });
      }

      if (params.slidesPerColumn > 1) {
        swiper.virtualSize =
          (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize =
          Math.ceil(swiper.virtualSize / params.slidesPerColumn) -
          params.spaceBetween;
        if (swiper.isHorizontal())
          $wrapperEl.css({
            width: `${swiper.virtualSize + params.spaceBetween}px`,
          });
        else
          $wrapperEl.css({
            height: `${swiper.virtualSize + params.spaceBetween}px`,
          });
        if (params.centeredSlides) {
          newSlidesGrid = [];
          for (let i = 0; i < snapGrid.length; i += 1) {
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths)
              slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] < swiper.virtualSize + snapGrid[0])
              newSlidesGrid.push(slidesGridItem);
          }
          snapGrid = newSlidesGrid;
        }
      }

      // Remove last grid elements depending on width
      if (!params.centeredSlides) {
        newSlidesGrid = [];
        for (let i = 0; i < snapGrid.length; i += 1) {
          let slidesGridItem = snapGrid[i];
          if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
          if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
            newSlidesGrid.push(slidesGridItem);
          }
        }
        snapGrid = newSlidesGrid;
        if (
          Math.floor(swiper.virtualSize - swiperSize) -
            Math.floor(snapGrid[snapGrid.length - 1]) >
          1
        ) {
          snapGrid.push(swiper.virtualSize - swiperSize);
        }
      }
      if (snapGrid.length === 0) snapGrid = [0];

      if (params.spaceBetween !== 0) {
        if (swiper.isHorizontal()) {
          if (rtl)
            slides
              .filter(slidesForMargin)
              .css({ marginLeft: `${spaceBetween}px` });
          else
            slides
              .filter(slidesForMargin)
              .css({ marginRight: `${spaceBetween}px` });
        } else
          slides
            .filter(slidesForMargin)
            .css({ marginBottom: `${spaceBetween}px` });
      }

      if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue) => {
          allSlidesSize +=
            slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap) => {
          if (snap < 0) return -offsetBefore;
          if (snap > maxSnap) return maxSnap + offsetAfter;
          return snap;
        });
      }

      if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue) => {
          allSlidesSize +=
            slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
          const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
          snapGrid.forEach((snap, snapIndex) => {
            snapGrid[snapIndex] = snap - allSlidesOffset;
          });
          slidesGrid.forEach((snap, snapIndex) => {
            slidesGrid[snapIndex] = snap + allSlidesOffset;
          });
        }
      }

      Utils.extend(swiper, {
        slides,
        snapGrid,
        slidesGrid,
        slidesSizesGrid,
      });

      if (slidesLength !== previousSlidesLength) {
        swiper.emit("slidesLengthChange");
      }
      if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
      }
      if (slidesGrid.length !== previousSlidesGridLength) {
        swiper.emit("slidesGridLengthChange");
      }

      if (params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateSlidesOffset();
      }
    }

    function updateAutoHeight(speed) {
      const swiper = this;
      const activeSlides = [];
      let newHeight = 0;
      let i;
      if (typeof speed === "number") {
        swiper.setTransition(speed);
      } else if (speed === true) {
        swiper.setTransition(swiper.params.speed);
      }
      // Find slides currently in view
      if (
        swiper.params.slidesPerView !== "auto" &&
        swiper.params.slidesPerView > 1
      ) {
        if (swiper.params.centeredSlides) {
          swiper.visibleSlides.each((index, slide) => {
            activeSlides.push(slide);
          });
        } else {
          for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length) break;
            activeSlides.push(swiper.slides.eq(index)[0]);
          }
        }
      } else {
        activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
      }

      // Find new height from highest slide in view
      for (i = 0; i < activeSlides.length; i += 1) {
        if (typeof activeSlides[i] !== "undefined") {
          const height = activeSlides[i].offsetHeight;
          newHeight = height > newHeight ? height : newHeight;
        }
      }

      // Update Height
      if (newHeight) swiper.$wrapperEl.css("height", `${newHeight}px`);
    }

    function updateSlidesOffset() {
      const swiper = this;
      const slides = swiper.slides;
      for (let i = 0; i < slides.length; i += 1) {
        slides[i].swiperSlideOffset = swiper.isHorizontal()
          ? slides[i].offsetLeft
          : slides[i].offsetTop;
      }
    }

    function updateSlidesProgress(translate = (this && this.translate) || 0) {
      const swiper = this;
      const params = swiper.params;

      const { slides, rtlTranslate: rtl } = swiper;

      if (slides.length === 0) return;
      if (typeof slides[0].swiperSlideOffset === "undefined")
        swiper.updateSlidesOffset();

      let offsetCenter = -translate;
      if (rtl) offsetCenter = translate;

      // Visible Slides
      slides.removeClass(params.slideVisibleClass);

      swiper.visibleSlidesIndexes = [];
      swiper.visibleSlides = [];

      for (let i = 0; i < slides.length; i += 1) {
        const slide = slides[i];
        const slideProgress =
          (offsetCenter +
            (params.centeredSlides ? swiper.minTranslate() : 0) -
            slide.swiperSlideOffset) /
          (slide.swiperSlideSize + params.spaceBetween);
        if (
          params.watchSlidesVisibility ||
          (params.centeredSlides && params.autoHeight)
        ) {
          const slideBefore = -(offsetCenter - slide.swiperSlideOffset);
          const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
          const isVisible =
            (slideBefore >= 0 && slideBefore < swiper.size - 1) ||
            (slideAfter > 1 && slideAfter <= swiper.size) ||
            (slideBefore <= 0 && slideAfter >= swiper.size);
          if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
          }
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
      }
      swiper.visibleSlides = dom7_modular_$(swiper.visibleSlides);
    }

    function updateProgress(translate) {
      const swiper = this;
      if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate =
          (swiper && swiper.translate && swiper.translate * multiplier) || 0;
      }
      const params = swiper.params;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      let { progress, isBeginning, isEnd } = swiper;
      const wasBeginning = isBeginning;
      const wasEnd = isEnd;
      if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
      } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
      }
      Utils.extend(swiper, {
        progress,
        isBeginning,
        isEnd,
      });

      if (
        params.watchSlidesProgress ||
        params.watchSlidesVisibility ||
        (params.centeredSlides && params.autoHeight)
      )
        swiper.updateSlidesProgress(translate);

      if (isBeginning && !wasBeginning) {
        swiper.emit("reachBeginning toEdge");
      }
      if (isEnd && !wasEnd) {
        swiper.emit("reachEnd toEdge");
      }
      if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
        swiper.emit("fromEdge");
      }

      swiper.emit("progress", progress);
    }

    function updateSlidesClasses() {
      const swiper = this;

      const { slides, params, $wrapperEl, activeIndex, realIndex } = swiper;
      const isVirtual = swiper.virtual && params.virtual.enabled;

      slides.removeClass(
        `${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`
      );

      let activeSlide;
      if (isVirtual) {
        activeSlide = swiper.$wrapperEl.find(
          `.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`
        );
      } else {
        activeSlide = slides.eq(activeIndex);
      }

      // Active classes
      activeSlide.addClass(params.slideActiveClass);

      if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl
            .children(
              `.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`
            )
            .addClass(params.slideDuplicateActiveClass);
        } else {
          $wrapperEl
            .children(
              `.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`
            )
            .addClass(params.slideDuplicateActiveClass);
        }
      }
      // Next Slide
      let nextSlide = activeSlide
        .nextAll(`.${params.slideClass}`)
        .eq(0)
        .addClass(params.slideNextClass);
      if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
      }
      // Prev Slide
      let prevSlide = activeSlide
        .prevAll(`.${params.slideClass}`)
        .eq(0)
        .addClass(params.slidePrevClass);
      if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
      }
      if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl
            .children(
              `.${params.slideClass}:not(.${
                params.slideDuplicateClass
              })[data-swiper-slide-index="${nextSlide.attr(
                "data-swiper-slide-index"
              )}"]`
            )
            .addClass(params.slideDuplicateNextClass);
        } else {
          $wrapperEl
            .children(
              `.${params.slideClass}.${
                params.slideDuplicateClass
              }[data-swiper-slide-index="${nextSlide.attr(
                "data-swiper-slide-index"
              )}"]`
            )
            .addClass(params.slideDuplicateNextClass);
        }
        if (prevSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl
            .children(
              `.${params.slideClass}:not(.${
                params.slideDuplicateClass
              })[data-swiper-slide-index="${prevSlide.attr(
                "data-swiper-slide-index"
              )}"]`
            )
            .addClass(params.slideDuplicatePrevClass);
        } else {
          $wrapperEl
            .children(
              `.${params.slideClass}.${
                params.slideDuplicateClass
              }[data-swiper-slide-index="${prevSlide.attr(
                "data-swiper-slide-index"
              )}"]`
            )
            .addClass(params.slideDuplicatePrevClass);
        }
      }
    }

    function updateActiveIndex(newActiveIndex) {
      const swiper = this;
      const translate = swiper.rtlTranslate
        ? swiper.translate
        : -swiper.translate;
      const {
        slidesGrid,
        snapGrid,
        params,
        activeIndex: previousIndex,
        realIndex: previousRealIndex,
        snapIndex: previousSnapIndex,
      } = swiper;
      let activeIndex = newActiveIndex;
      let snapIndex;
      if (typeof activeIndex === "undefined") {
        for (let i = 0; i < slidesGrid.length; i += 1) {
          if (typeof slidesGrid[i + 1] !== "undefined") {
            if (
              translate >= slidesGrid[i] &&
              translate <
                slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2
            ) {
              activeIndex = i;
            } else if (
              translate >= slidesGrid[i] &&
              translate < slidesGrid[i + 1]
            ) {
              activeIndex = i + 1;
            }
          } else if (translate >= slidesGrid[i]) {
            activeIndex = i;
          }
        }
        // Normalize slideIndex
        if (params.normalizeSlideIndex) {
          if (activeIndex < 0 || typeof activeIndex === "undefined")
            activeIndex = 0;
        }
      }
      if (snapGrid.indexOf(translate) >= 0) {
        snapIndex = snapGrid.indexOf(translate);
      } else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex =
          skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
      }
      if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
      if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
          swiper.snapIndex = snapIndex;
          swiper.emit("snapIndexChange");
        }
        return;
      }

      // Get real index
      const realIndex = parseInt(
        swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") ||
          activeIndex,
        10
      );

      Utils.extend(swiper, {
        snapIndex,
        realIndex,
        previousIndex,
        activeIndex,
      });
      swiper.emit("activeIndexChange");
      swiper.emit("snapIndexChange");
      if (previousRealIndex !== realIndex) {
        swiper.emit("realIndexChange");
      }
      if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        swiper.emit("slideChange");
      }
    }

    function updateClickedSlide(e) {
      const swiper = this;
      const params = swiper.params;
      const slide = dom7_modular_$(e.target).closest(
        `.${params.slideClass}`
      )[0];
      let slideFound = false;
      if (slide) {
        for (let i = 0; i < swiper.slides.length; i += 1) {
          if (swiper.slides[i] === slide) slideFound = true;
        }
      }

      if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) {
          swiper.clickedIndex = parseInt(
            dom7_modular_$(slide).attr("data-swiper-slide-index"),
            10
          );
        } else {
          swiper.clickedIndex = dom7_modular_$(slide).index();
        }
      } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
      }
      if (
        params.slideToClickedSlide &&
        swiper.clickedIndex !== undefined &&
        swiper.clickedIndex !== swiper.activeIndex
      ) {
        swiper.slideToClickedSlide();
      }
    }

    var update = {
      updateSize,
      updateSlides,
      updateAutoHeight,
      updateSlidesOffset,
      updateSlidesProgress,
      updateProgress,
      updateSlidesClasses,
      updateActiveIndex,
      updateClickedSlide,
    };

    function getTranslate(axis = this.isHorizontal() ? "x" : "y") {
      const swiper = this;

      const { params, rtlTranslate: rtl, translate, $wrapperEl } = swiper;

      if (params.virtualTranslate) {
        return rtl ? -translate : translate;
      }
      if (params.cssMode) {
        return translate;
      }

      let currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
      if (rtl) currentTranslate = -currentTranslate;

      return currentTranslate || 0;
    }

    function setTranslate(translate, byController) {
      const swiper = this;
      const {
        rtlTranslate: rtl,
        params,
        $wrapperEl,
        wrapperEl,
        progress,
      } = swiper;
      let x = 0;
      let y = 0;
      const z = 0;

      if (swiper.isHorizontal()) {
        x = rtl ? -translate : translate;
      } else {
        y = translate;
      }

      if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
      }

      if (params.cssMode) {
        wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] =
          swiper.isHorizontal() ? -x : -y;
      } else if (!params.virtualTranslate) {
        $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
      }
      swiper.previousTranslate = swiper.translate;
      swiper.translate = swiper.isHorizontal() ? x : y;

      // Check if we need to update progress
      let newProgress;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress = (translate - swiper.minTranslate()) / translatesDiff;
      }
      if (newProgress !== progress) {
        swiper.updateProgress(translate);
      }

      swiper.emit("setTranslate", swiper.translate, byController);
    }

    function minTranslate() {
      return -this.snapGrid[0];
    }

    function maxTranslate() {
      return -this.snapGrid[this.snapGrid.length - 1];
    }

    function translateTo(
      translate = 0,
      speed = this.params.speed,
      runCallbacks = true,
      translateBounds = true,
      internal
    ) {
      const swiper = this;

      const { params, wrapperEl } = swiper;

      if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
      }

      const minTranslate = swiper.minTranslate();
      const maxTranslate = swiper.maxTranslate();
      let newTranslate;
      if (translateBounds && translate > minTranslate)
        newTranslate = minTranslate;
      else if (translateBounds && translate < maxTranslate)
        newTranslate = maxTranslate;
      else newTranslate = translate;

      // Update progress
      swiper.updateProgress(newTranslate);

      if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        } else {
          // eslint-disable-next-line
          if (wrapperEl.scrollTo) {
            wrapperEl.scrollTo({
              [isH ? "left" : "top"]: -newTranslate,
              behavior: "smooth",
            });
          } else {
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
          }
        }
        return true;
      }

      if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
          swiper.emit("beforeTransitionStart", speed, internal);
          swiper.emit("transitionEnd");
        }
      } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
          swiper.emit("beforeTransitionStart", speed, internal);
          swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
          swiper.animating = true;
          if (!swiper.onTranslateToWrapperTransitionEnd) {
            swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(
              e
            ) {
              if (!swiper || swiper.destroyed) return;
              if (e.target !== this) return;
              swiper.$wrapperEl[0].removeEventListener(
                "transitionend",
                swiper.onTranslateToWrapperTransitionEnd
              );
              swiper.$wrapperEl[0].removeEventListener(
                "webkitTransitionEnd",
                swiper.onTranslateToWrapperTransitionEnd
              );
              swiper.onTranslateToWrapperTransitionEnd = null;
              delete swiper.onTranslateToWrapperTransitionEnd;
              if (runCallbacks) {
                swiper.emit("transitionEnd");
              }
            };
          }
          swiper.$wrapperEl[0].addEventListener(
            "transitionend",
            swiper.onTranslateToWrapperTransitionEnd
          );
          swiper.$wrapperEl[0].addEventListener(
            "webkitTransitionEnd",
            swiper.onTranslateToWrapperTransitionEnd
          );
        }
      }

      return true;
    }

    var translate = {
      getTranslate,
      setTranslate,
      minTranslate,
      maxTranslate,
      translateTo,
    };

    function setTransition(duration, byController) {
      const swiper = this;

      if (!swiper.params.cssMode) {
        swiper.$wrapperEl.transition(duration);
      }

      swiper.emit("setTransition", duration, byController);
    }

    function transitionStart(runCallbacks = true, direction) {
      const swiper = this;
      const { activeIndex, params, previousIndex } = swiper;
      if (params.cssMode) return;
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }

      let dir = direction;
      if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
      }

      swiper.emit("transitionStart");

      if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
          swiper.emit("slideResetTransitionStart");
          return;
        }
        swiper.emit("slideChangeTransitionStart");
        if (dir === "next") {
          swiper.emit("slideNextTransitionStart");
        } else {
          swiper.emit("slidePrevTransitionStart");
        }
      }
    }

    function swiper_esm_bundle_transitionEnd(runCallbacks = true, direction) {
      const swiper = this;
      const { activeIndex, previousIndex, params } = swiper;
      swiper.animating = false;
      if (params.cssMode) return;
      swiper.setTransition(0);

      let dir = direction;
      if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
      }

      swiper.emit("transitionEnd");

      if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
          swiper.emit("slideResetTransitionEnd");
          return;
        }
        swiper.emit("slideChangeTransitionEnd");
        if (dir === "next") {
          swiper.emit("slideNextTransitionEnd");
        } else {
          swiper.emit("slidePrevTransitionEnd");
        }
      }
    }

    var swiper_esm_bundle_transition = {
      setTransition,
      transitionStart,
      transitionEnd: swiper_esm_bundle_transitionEnd,
    };

    function slideTo(
      index = 0,
      speed = this.params.speed,
      runCallbacks = true,
      internal
    ) {
      const swiper = this;
      let slideIndex = index;
      if (slideIndex < 0) slideIndex = 0;

      const {
        params,
        snapGrid,
        slidesGrid,
        previousIndex,
        activeIndex,
        rtlTranslate: rtl,
        wrapperEl,
      } = swiper;
      if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
      }

      const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
      let snapIndex =
        skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
      if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

      if (
        (activeIndex || params.initialSlide || 0) === (previousIndex || 0) &&
        runCallbacks
      ) {
        swiper.emit("beforeSlideChangeStart");
      }

      const translate = -snapGrid[snapIndex];

      // Update progress
      swiper.updateProgress(translate);

      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        for (let i = 0; i < slidesGrid.length; i += 1) {
          if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
            slideIndex = i;
          }
        }
      }
      // Directions locks
      if (swiper.initialized && slideIndex !== activeIndex) {
        if (
          !swiper.allowSlideNext &&
          translate < swiper.translate &&
          translate < swiper.minTranslate()
        ) {
          return false;
        }
        if (
          !swiper.allowSlidePrev &&
          translate > swiper.translate &&
          translate > swiper.maxTranslate()
        ) {
          if ((activeIndex || 0) !== slideIndex) return false;
        }
      }

      let direction;
      if (slideIndex > activeIndex) direction = "next";
      else if (slideIndex < activeIndex) direction = "prev";
      else direction = "reset";

      // Update Index
      if (
        (rtl && -translate === swiper.translate) ||
        (!rtl && translate === swiper.translate)
      ) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") {
          swiper.setTranslate(translate);
        }
        if (direction !== "reset") {
          swiper.transitionStart(runCallbacks, direction);
          swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
      }
      if (params.cssMode) {
        const isH = swiper.isHorizontal();
        let t = -translate;
        if (rtl) {
          t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
        }
        if (speed === 0) {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
        } else {
          // eslint-disable-next-line
          if (wrapperEl.scrollTo) {
            wrapperEl.scrollTo({
              [isH ? "left" : "top"]: t,
              behavior: "smooth",
            });
          } else {
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
          }
        }
        return true;
      }

      if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      } else {
        swiper.setTransition(speed);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        if (!swiper.animating) {
          swiper.animating = true;
          if (!swiper.onSlideToWrapperTransitionEnd) {
            swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
              if (!swiper || swiper.destroyed) return;
              if (e.target !== this) return;
              swiper.$wrapperEl[0].removeEventListener(
                "transitionend",
                swiper.onSlideToWrapperTransitionEnd
              );
              swiper.$wrapperEl[0].removeEventListener(
                "webkitTransitionEnd",
                swiper.onSlideToWrapperTransitionEnd
              );
              swiper.onSlideToWrapperTransitionEnd = null;
              delete swiper.onSlideToWrapperTransitionEnd;
              swiper.transitionEnd(runCallbacks, direction);
            };
          }
          swiper.$wrapperEl[0].addEventListener(
            "transitionend",
            swiper.onSlideToWrapperTransitionEnd
          );
          swiper.$wrapperEl[0].addEventListener(
            "webkitTransitionEnd",
            swiper.onSlideToWrapperTransitionEnd
          );
        }
      }

      return true;
    }

    function slideToLoop(
      index = 0,
      speed = this.params.speed,
      runCallbacks = true,
      internal
    ) {
      const swiper = this;
      let newIndex = index;
      if (swiper.params.loop) {
        newIndex += swiper.loopedSlides;
      }

      return swiper.slideTo(newIndex, speed, runCallbacks, internal);
    }

    /* eslint no-unused-vars: "off" */
    function slideNext(
      speed = this.params.speed,
      runCallbacks = true,
      internal
    ) {
      const swiper = this;
      const { params, animating } = swiper;
      const increment =
        swiper.activeIndex < params.slidesPerGroupSkip
          ? 1
          : params.slidesPerGroup;
      if (params.loop) {
        if (animating) return false;
        swiper.loopFix();
        // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      }
      return swiper.slideTo(
        swiper.activeIndex + increment,
        speed,
        runCallbacks,
        internal
      );
    }

    /* eslint no-unused-vars: "off" */
    function slidePrev(
      speed = this.params.speed,
      runCallbacks = true,
      internal
    ) {
      const swiper = this;
      const { params, animating, snapGrid, slidesGrid, rtlTranslate } = swiper;

      if (params.loop) {
        if (animating) return false;
        swiper.loopFix();
        // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      }
      const translate = rtlTranslate ? swiper.translate : -swiper.translate;
      function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
      }
      const normalizedTranslate = normalize(translate);
      const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
      const normalizedSlidesGrid = slidesGrid.map((val) => normalize(val));

      const currentSnap =
        snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
      let prevSnap =
        snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
      if (typeof prevSnap === "undefined" && params.cssMode) {
        snapGrid.forEach((snap) => {
          if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
        });
      }
      let prevIndex;
      if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
      }
      return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    }

    /* eslint no-unused-vars: "off" */
    function slideReset(
      speed = this.params.speed,
      runCallbacks = true,
      internal
    ) {
      const swiper = this;
      return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
    }

    /* eslint no-unused-vars: "off" */
    function slideToClosest(
      speed = this.params.speed,
      runCallbacks = true,
      internal,
      threshold = 0.5
    ) {
      const swiper = this;
      let index = swiper.activeIndex;
      const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
      const snapIndex =
        skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);

      const translate = swiper.rtlTranslate
        ? swiper.translate
        : -swiper.translate;

      if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
          index += swiper.params.slidesPerGroup;
        }
      } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
          index -= swiper.params.slidesPerGroup;
        }
      }
      index = Math.max(index, 0);
      index = Math.min(index, swiper.slidesGrid.length - 1);

      return swiper.slideTo(index, speed, runCallbacks, internal);
    }

    function slideToClickedSlide() {
      const swiper = this;
      const { params, $wrapperEl } = swiper;

      const slidesPerView =
        params.slidesPerView === "auto"
          ? swiper.slidesPerViewDynamic()
          : params.slidesPerView;
      let slideToIndex = swiper.clickedIndex;
      let realIndex;
      if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(
          dom7_modular_$(swiper.clickedSlide).attr("data-swiper-slide-index"),
          10
        );
        if (params.centeredSlides) {
          if (
            slideToIndex < swiper.loopedSlides - slidesPerView / 2 ||
            slideToIndex >
              swiper.slides.length - swiper.loopedSlides + slidesPerView / 2
          ) {
            swiper.loopFix();
            slideToIndex = $wrapperEl
              .children(
                `.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`
              )
              .eq(0)
              .index();

            Utils.nextTick(() => {
              swiper.slideTo(slideToIndex);
            });
          } else {
            swiper.slideTo(slideToIndex);
          }
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
          swiper.loopFix();
          slideToIndex = $wrapperEl
            .children(
              `.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`
            )
            .eq(0)
            .index();

          Utils.nextTick(() => {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else {
        swiper.slideTo(slideToIndex);
      }
    }

    var slide = {
      slideTo,
      slideToLoop,
      slideNext,
      slidePrev,
      slideReset,
      slideToClosest,
      slideToClickedSlide,
    };

    function loopCreate() {
      const swiper = this;
      const { params, $wrapperEl } = swiper;
      // Remove duplicated slides
      $wrapperEl
        .children(`.${params.slideClass}.${params.slideDuplicateClass}`)
        .remove();

      let slides = $wrapperEl.children(`.${params.slideClass}`);

      if (params.loopFillGroupWithBlank) {
        const blankSlidesNum =
          params.slidesPerGroup - (slides.length % params.slidesPerGroup);
        if (blankSlidesNum !== params.slidesPerGroup) {
          for (let i = 0; i < blankSlidesNum; i += 1) {
            const blankNode = dom7_modular_$(doc.createElement("div")).addClass(
              `${params.slideClass} ${params.slideBlankClass}`
            );
            $wrapperEl.append(blankNode);
          }
          slides = $wrapperEl.children(`.${params.slideClass}`);
        }
      }

      if (params.slidesPerView === "auto" && !params.loopedSlides)
        params.loopedSlides = slides.length;

      swiper.loopedSlides = Math.ceil(
        parseFloat(params.loopedSlides || params.slidesPerView, 10)
      );
      swiper.loopedSlides += params.loopAdditionalSlides;
      if (swiper.loopedSlides > slides.length) {
        swiper.loopedSlides = slides.length;
      }

      const prependSlides = [];
      const appendSlides = [];
      slides.each((index, el) => {
        const slide = dom7_modular_$(el);
        if (index < swiper.loopedSlides) appendSlides.push(el);
        if (
          index < slides.length &&
          index >= slides.length - swiper.loopedSlides
        )
          prependSlides.push(el);
        slide.attr("data-swiper-slide-index", index);
      });
      for (let i = 0; i < appendSlides.length; i += 1) {
        $wrapperEl.append(
          dom7_modular_$(appendSlides[i].cloneNode(true)).addClass(
            params.slideDuplicateClass
          )
        );
      }
      for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
        $wrapperEl.prepend(
          dom7_modular_$(prependSlides[i].cloneNode(true)).addClass(
            params.slideDuplicateClass
          )
        );
      }
    }

    function loopFix() {
      const swiper = this;

      swiper.emit("beforeLoopFix");

      const {
        activeIndex,
        slides,
        loopedSlides,
        allowSlidePrev,
        allowSlideNext,
        snapGrid,
        rtlTranslate: rtl,
      } = swiper;
      let newIndex;
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;

      const snapTranslate = -snapGrid[activeIndex];
      const diff = snapTranslate - swiper.getTranslate();

      // Fix For Negative Oversliding
      if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) {
          swiper.setTranslate(
            (rtl ? -swiper.translate : swiper.translate) - diff
          );
        }
      } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) {
          swiper.setTranslate(
            (rtl ? -swiper.translate : swiper.translate) - diff
          );
        }
      }
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;

      swiper.emit("loopFix");
    }

    function loopDestroy() {
      const swiper = this;
      const { $wrapperEl, params, slides } = swiper;
      $wrapperEl
        .children(
          `.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`
        )
        .remove();
      slides.removeAttr("data-swiper-slide-index");
    }

    var loop = {
      loopCreate,
      loopFix,
      loopDestroy,
    };

    function setGrabCursor(moving) {
      const swiper = this;
      if (
        Support.touch ||
        !swiper.params.simulateTouch ||
        (swiper.params.watchOverflow && swiper.isLocked) ||
        swiper.params.cssMode
      )
        return;
      const el = swiper.el;
      el.style.cursor = "move";
      el.style.cursor = moving ? "-webkit-grabbing" : "-webkit-grab";
      el.style.cursor = moving ? "-moz-grabbin" : "-moz-grab";
      el.style.cursor = moving ? "grabbing" : "grab";
    }

    function unsetGrabCursor() {
      const swiper = this;
      if (
        Support.touch ||
        (swiper.params.watchOverflow && swiper.isLocked) ||
        swiper.params.cssMode
      )
        return;
      swiper.el.style.cursor = "";
    }

    var grabCursor = {
      setGrabCursor,
      unsetGrabCursor,
    };

    function appendSlide(slides) {
      const swiper = this;
      const { $wrapperEl, params } = swiper;
      if (params.loop) {
        swiper.loopDestroy();
      }
      if (typeof slides === "object" && "length" in slides) {
        for (let i = 0; i < slides.length; i += 1) {
          if (slides[i]) $wrapperEl.append(slides[i]);
        }
      } else {
        $wrapperEl.append(slides);
      }
      if (params.loop) {
        swiper.loopCreate();
      }
      if (!(params.observer && Support.observer)) {
        swiper.update();
      }
    }

    function prependSlide(slides) {
      const swiper = this;
      const { params, $wrapperEl, activeIndex } = swiper;

      if (params.loop) {
        swiper.loopDestroy();
      }
      let newActiveIndex = activeIndex + 1;
      if (typeof slides === "object" && "length" in slides) {
        for (let i = 0; i < slides.length; i += 1) {
          if (slides[i]) $wrapperEl.prepend(slides[i]);
        }
        newActiveIndex = activeIndex + slides.length;
      } else {
        $wrapperEl.prepend(slides);
      }
      if (params.loop) {
        swiper.loopCreate();
      }
      if (!(params.observer && Support.observer)) {
        swiper.update();
      }
      swiper.slideTo(newActiveIndex, 0, false);
    }

    function addSlide(index, slides) {
      const swiper = this;
      const { $wrapperEl, params, activeIndex } = swiper;
      let activeIndexBuffer = activeIndex;
      if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
      }
      const baseLength = swiper.slides.length;
      if (index <= 0) {
        swiper.prependSlide(slides);
        return;
      }
      if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
      }
      let newActiveIndex =
        activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

      const slidesBuffer = [];
      for (let i = baseLength - 1; i >= index; i -= 1) {
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
      }

      if (typeof slides === "object" && "length" in slides) {
        for (let i = 0; i < slides.length; i += 1) {
          if (slides[i]) $wrapperEl.append(slides[i]);
        }
        newActiveIndex =
          activeIndexBuffer > index
            ? activeIndexBuffer + slides.length
            : activeIndexBuffer;
      } else {
        $wrapperEl.append(slides);
      }

      for (let i = 0; i < slidesBuffer.length; i += 1) {
        $wrapperEl.append(slidesBuffer[i]);
      }

      if (params.loop) {
        swiper.loopCreate();
      }
      if (!(params.observer && Support.observer)) {
        swiper.update();
      }
      if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
      } else {
        swiper.slideTo(newActiveIndex, 0, false);
      }
    }

    function removeSlide(slidesIndexes) {
      const swiper = this;
      const { params, $wrapperEl, activeIndex } = swiper;

      let activeIndexBuffer = activeIndex;
      if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
      }
      let newActiveIndex = activeIndexBuffer;
      let indexToRemove;

      if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for (let i = 0; i < slidesIndexes.length; i += 1) {
          indexToRemove = slidesIndexes[i];
          if (swiper.slides[indexToRemove])
            swiper.slides.eq(indexToRemove).remove();
          if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
      } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove])
          swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
      }

      if (params.loop) {
        swiper.loopCreate();
      }

      if (!(params.observer && Support.observer)) {
        swiper.update();
      }
      if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
      } else {
        swiper.slideTo(newActiveIndex, 0, false);
      }
    }

    function removeAllSlides() {
      const swiper = this;

      const slidesIndexes = [];
      for (let i = 0; i < swiper.slides.length; i += 1) {
        slidesIndexes.push(i);
      }
      swiper.removeSlide(slidesIndexes);
    }

    var manipulation = {
      appendSlide,
      prependSlide,
      addSlide,
      removeSlide,
      removeAllSlides,
    };

    const Device = (function Device() {
      const platform = win.navigator.platform;
      const ua = win.navigator.userAgent;

      const device = {
        ios: false,
        android: false,
        androidChrome: false,
        desktop: false,
        iphone: false,
        ipod: false,
        ipad: false,
        edge: false,
        ie: false,
        firefox: false,
        macos: false,
        windows: false,
        cordova: !!(win.cordova || win.phonegap),
        phonegap: !!(win.cordova || win.phonegap),
        electron: false,
      };

      const screenWidth = win.screen.width;
      const screenHeight = win.screen.height;

      const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
      const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
      const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
      const ie = ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
      const edge = ua.indexOf("Edge/") >= 0;
      const firefox = ua.indexOf("Gecko/") >= 0 && ua.indexOf("Firefox/") >= 0;
      const windows = platform === "Win32";
      const electron = ua.toLowerCase().indexOf("electron") >= 0;
      let macos = platform === "MacIntel";

      // iPadOs 13 fix
      if (
        !ipad &&
        macos &&
        Support.touch &&
        ((screenWidth === 1024 && screenHeight === 1366) || // Pro 12.9
          (screenWidth === 834 && screenHeight === 1194) || // Pro 11
          (screenWidth === 834 && screenHeight === 1112) || // Pro 10.5
          (screenWidth === 768 && screenHeight === 1024)) // other
      ) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        macos = false;
      }

      device.ie = ie;
      device.edge = edge;
      device.firefox = firefox;

      // Android
      if (android && !windows) {
        device.os = "android";
        device.osVersion = android[2];
        device.android = true;
        device.androidChrome = ua.toLowerCase().indexOf("chrome") >= 0;
      }
      if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
      }
      // iOS
      if (iphone && !ipod) {
        device.osVersion = iphone[2].replace(/_/g, ".");
        device.iphone = true;
      }
      if (ipad) {
        device.osVersion = ipad[2].replace(/_/g, ".");
        device.ipad = true;
      }
      if (ipod) {
        device.osVersion = ipod[3] ? ipod[3].replace(/_/g, ".") : null;
        device.ipod = true;
      }
      // iOS 8+ changed UA
      if (device.ios && device.osVersion && ua.indexOf("Version/") >= 0) {
        if (device.osVersion.split(".")[0] === "10") {
          device.osVersion = ua
            .toLowerCase()
            .split("version/")[1]
            .split(" ")[0];
        }
      }

      // Webview
      device.webView =
        !!(
          (iphone || ipad || ipod) &&
          (ua.match(/.*AppleWebKit(?!.*Safari)/i) || win.navigator.standalone)
        ) ||
        (win.matchMedia &&
          win.matchMedia("(display-mode: standalone)").matches);
      device.webview = device.webView;
      device.standalone = device.webView;

      // Desktop
      device.desktop = !(device.ios || device.android) || electron;
      if (device.desktop) {
        device.electron = electron;
        device.macos = macos;
        device.windows = windows;
        if (device.macos) {
          device.os = "macos";
        }
        if (device.windows) {
          device.os = "windows";
        }
      }

      // Pixel Ratio
      device.pixelRatio = win.devicePixelRatio || 1;

      // Export object
      return device;
    })();

    function onTouchStart(event) {
      const swiper = this;
      const data = swiper.touchEventsData;
      const { params, touches } = swiper;

      if (swiper.animating && params.preventInteractionOnTransition) {
        return;
      }
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      const $targetEl = dom7_modular_$(e.target);

      if (params.touchEventsTarget === "wrapper") {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
      }
      data.isTouchEvent = e.type === "touchstart";
      if (!data.isTouchEvent && "which" in e && e.which === 3) return;
      if (!data.isTouchEvent && "button" in e && e.button > 0) return;
      if (data.isTouched && data.isMoved) return;
      if (
        params.noSwiping &&
        $targetEl.closest(
          params.noSwipingSelector
            ? params.noSwipingSelector
            : `.${params.noSwipingClass}`
        )[0]
      ) {
        swiper.allowClick = true;
        return;
      }
      if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
      }

      touches.currentX =
        e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
      touches.currentY =
        e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
      const startX = touches.currentX;
      const startY = touches.currentY;

      // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

      const edgeSwipeDetection =
        params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
      const edgeSwipeThreshold =
        params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
      if (
        edgeSwipeDetection &&
        (startX <= edgeSwipeThreshold ||
          startX >= win.screen.width - edgeSwipeThreshold)
      ) {
        return;
      }

      Utils.extend(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined,
      });

      touches.startX = startX;
      touches.startY = startY;
      data.touchStartTime = Utils.now();
      swiper.allowClick = true;
      swiper.updateSize();
      swiper.swipeDirection = undefined;
      if (params.threshold > 0) data.allowThresholdMove = false;
      if (e.type !== "touchstart") {
        let preventDefault = true;
        if ($targetEl.is(data.formElements)) preventDefault = false;
        if (
          doc.activeElement &&
          dom7_modular_$(doc.activeElement).is(data.formElements) &&
          doc.activeElement !== $targetEl[0]
        ) {
          doc.activeElement.blur();
        }

        const shouldPreventDefault =
          preventDefault &&
          swiper.allowTouchMove &&
          params.touchStartPreventDefault;
        if (params.touchStartForcePreventDefault || shouldPreventDefault) {
          e.preventDefault();
        }
      }
      swiper.emit("touchStart", e);
    }

    function onTouchMove(event) {
      const swiper = this;
      const data = swiper.touchEventsData;
      const { params, touches, rtlTranslate: rtl } = swiper;
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) {
          swiper.emit("touchMoveOpposite", e);
        }
        return;
      }
      if (data.isTouchEvent && e.type !== "touchmove") return;
      const targetTouch =
        e.type === "touchmove" &&
        e.targetTouches &&
        (e.targetTouches[0] || e.changedTouches[0]);
      const pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
      const pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
      if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
      }
      if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
        if (data.isTouched) {
          Utils.extend(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
          });
          data.touchStartTime = Utils.now();
        }
        return;
      }
      if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) {
          // Vertical
          if (
            (pageY < touches.startY &&
              swiper.translate <= swiper.maxTranslate()) ||
            (pageY > touches.startY &&
              swiper.translate >= swiper.minTranslate())
          ) {
            data.isTouched = false;
            data.isMoved = false;
            return;
          }
        } else if (
          (pageX < touches.startX &&
            swiper.translate <= swiper.maxTranslate()) ||
          (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
        ) {
          return;
        }
      }
      if (data.isTouchEvent && doc.activeElement) {
        if (
          e.target === doc.activeElement &&
          dom7_modular_$(e.target).is(data.formElements)
        ) {
          data.isMoved = true;
          swiper.allowClick = false;
          return;
        }
      }
      if (data.allowTouchCallbacks) {
        swiper.emit("touchMove", e);
      }
      if (e.targetTouches && e.targetTouches.length > 1) return;

      touches.currentX = pageX;
      touches.currentY = pageY;

      const diffX = touches.currentX - touches.startX;
      const diffY = touches.currentY - touches.startY;
      if (
        swiper.params.threshold &&
        Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold
      )
        return;

      if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (
          (swiper.isHorizontal() && touches.currentY === touches.startY) ||
          (swiper.isVertical() && touches.currentX === touches.startX)
        ) {
          data.isScrolling = false;
        } else {
          // eslint-disable-next-line
          if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle =
              (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
            data.isScrolling = swiper.isHorizontal()
              ? touchAngle > params.touchAngle
              : 90 - touchAngle > params.touchAngle;
          }
        }
      }
      if (data.isScrolling) {
        swiper.emit("touchMoveOpposite", e);
      }
      if (typeof data.startMoving === "undefined") {
        if (
          touches.currentX !== touches.startX ||
          touches.currentY !== touches.startY
        ) {
          data.startMoving = true;
        }
      }
      if (data.isScrolling) {
        data.isTouched = false;
        return;
      }
      if (!data.startMoving) {
        return;
      }
      swiper.allowClick = false;
      if (!params.cssMode && e.cancelable) {
        e.preventDefault();
      }
      if (params.touchMoveStopPropagation && !params.nested) {
        e.stopPropagation();
      }

      if (!data.isMoved) {
        if (params.loop) {
          swiper.loopFix();
        }
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
          swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (
          params.grabCursor &&
          (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)
        ) {
          swiper.setGrabCursor(true);
        }
        swiper.emit("sliderFirstMove", e);
      }
      swiper.emit("sliderMove", e);
      data.isMoved = true;

      let diff = swiper.isHorizontal() ? diffX : diffY;
      touches.diff = diff;

      diff *= params.touchRatio;
      if (rtl) diff = -diff;

      swiper.swipeDirection = diff > 0 ? "prev" : "next";
      data.currentTranslate = diff + data.startTranslate;

      let disableParentSwiper = true;
      let resistanceRatio = params.resistanceRatio;
      if (params.touchReleaseOnEdges) {
        resistanceRatio = 0;
      }
      if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance)
          data.currentTranslate =
            swiper.minTranslate() -
            1 +
            (-swiper.minTranslate() + data.startTranslate + diff) **
              resistanceRatio;
      } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance)
          data.currentTranslate =
            swiper.maxTranslate() +
            1 -
            (swiper.maxTranslate() - data.startTranslate - diff) **
              resistanceRatio;
      }

      if (disableParentSwiper) {
        e.preventedByNestedSwiper = true;
      }

      // Directions locks
      if (
        !swiper.allowSlideNext &&
        swiper.swipeDirection === "next" &&
        data.currentTranslate < data.startTranslate
      ) {
        data.currentTranslate = data.startTranslate;
      }
      if (
        !swiper.allowSlidePrev &&
        swiper.swipeDirection === "prev" &&
        data.currentTranslate > data.startTranslate
      ) {
        data.currentTranslate = data.startTranslate;
      }

      // Threshold
      if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
          if (!data.allowThresholdMove) {
            data.allowThresholdMove = true;
            touches.startX = touches.currentX;
            touches.startY = touches.currentY;
            data.currentTranslate = data.startTranslate;
            touches.diff = swiper.isHorizontal()
              ? touches.currentX - touches.startX
              : touches.currentY - touches.startY;
            return;
          }
        } else {
          data.currentTranslate = data.startTranslate;
          return;
        }
      }

      if (!params.followFinger || params.cssMode) return;

      // Update active index in free mode
      if (
        params.freeMode ||
        params.watchSlidesProgress ||
        params.watchSlidesVisibility
      ) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      if (params.freeMode) {
        // Velocity
        if (data.velocities.length === 0) {
          data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime,
          });
        }
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
          time: Utils.now(),
        });
      }
      // Update progress
      swiper.updateProgress(data.currentTranslate);
      // Update translate
      swiper.setTranslate(data.currentTranslate);
    }

    function onTouchEnd(event) {
      const swiper = this;
      const data = swiper.touchEventsData;

      const {
        params,
        touches,
        rtlTranslate: rtl,
        $wrapperEl,
        slidesGrid,
        snapGrid,
      } = swiper;
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      if (data.allowTouchCallbacks) {
        swiper.emit("touchEnd", e);
      }
      data.allowTouchCallbacks = false;
      if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) {
          swiper.setGrabCursor(false);
        }
        data.isMoved = false;
        data.startMoving = false;
        return;
      }
      // Return Grab Cursor
      if (
        params.grabCursor &&
        data.isMoved &&
        data.isTouched &&
        (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)
      ) {
        swiper.setGrabCursor(false);
      }

      // Time diff
      const touchEndTime = Utils.now();
      const timeDiff = touchEndTime - data.touchStartTime;

      // Tap, doubleTap, Click
      if (swiper.allowClick) {
        swiper.updateClickedSlide(e);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
          swiper.emit("doubleTap doubleClick", e);
        }
      }

      data.lastClickTime = Utils.now();
      Utils.nextTick(() => {
        if (!swiper.destroyed) swiper.allowClick = true;
      });

      if (
        !data.isTouched ||
        !data.isMoved ||
        !swiper.swipeDirection ||
        touches.diff === 0 ||
        data.currentTranslate === data.startTranslate
      ) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
      }
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;

      let currentPos;
      if (params.followFinger) {
        currentPos = rtl ? swiper.translate : -swiper.translate;
      } else {
        currentPos = -data.currentTranslate;
      }

      if (params.cssMode) {
        return;
      }

      if (params.freeMode) {
        if (currentPos < -swiper.minTranslate()) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        if (currentPos > -swiper.maxTranslate()) {
          if (swiper.slides.length < snapGrid.length) {
            swiper.slideTo(snapGrid.length - 1);
          } else {
            swiper.slideTo(swiper.slides.length - 1);
          }
          return;
        }

        if (params.freeModeMomentum) {
          if (data.velocities.length > 1) {
            const lastMoveEvent = data.velocities.pop();
            const velocityEvent = data.velocities.pop();

            const distance = lastMoveEvent.position - velocityEvent.position;
            const time = lastMoveEvent.time - velocityEvent.time;
            swiper.velocity = distance / time;
            swiper.velocity /= 2;
            if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
              swiper.velocity = 0;
            }
            // this implies that the user stopped moving a finger then released.
            // There would be no events with distance zero, so the last event is stale.
            if (time > 150 || Utils.now() - lastMoveEvent.time > 300) {
              swiper.velocity = 0;
            }
          } else {
            swiper.velocity = 0;
          }
          swiper.velocity *= params.freeModeMomentumVelocityRatio;

          data.velocities.length = 0;
          let momentumDuration = 1000 * params.freeModeMomentumRatio;
          const momentumDistance = swiper.velocity * momentumDuration;

          let newPosition = swiper.translate + momentumDistance;
          if (rtl) newPosition = -newPosition;

          let doBounce = false;
          let afterBouncePosition;
          const bounceAmount =
            Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
          let needsLoopFix;
          if (newPosition < swiper.maxTranslate()) {
            if (params.freeModeMomentumBounce) {
              if (newPosition + swiper.maxTranslate() < -bounceAmount) {
                newPosition = swiper.maxTranslate() - bounceAmount;
              }
              afterBouncePosition = swiper.maxTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.maxTranslate();
            }
            if (params.loop && params.centeredSlides) needsLoopFix = true;
          } else if (newPosition > swiper.minTranslate()) {
            if (params.freeModeMomentumBounce) {
              if (newPosition - swiper.minTranslate() > bounceAmount) {
                newPosition = swiper.minTranslate() + bounceAmount;
              }
              afterBouncePosition = swiper.minTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.minTranslate();
            }
            if (params.loop && params.centeredSlides) needsLoopFix = true;
          } else if (params.freeModeSticky) {
            let nextSlide;
            for (let j = 0; j < snapGrid.length; j += 1) {
              if (snapGrid[j] > -newPosition) {
                nextSlide = j;
                break;
              }
            }

            if (
              Math.abs(snapGrid[nextSlide] - newPosition) <
                Math.abs(snapGrid[nextSlide - 1] - newPosition) ||
              swiper.swipeDirection === "next"
            ) {
              newPosition = snapGrid[nextSlide];
            } else {
              newPosition = snapGrid[nextSlide - 1];
            }
            newPosition = -newPosition;
          }
          if (needsLoopFix) {
            swiper.once("transitionEnd", () => {
              swiper.loopFix();
            });
          }
          // Fix duration
          if (swiper.velocity !== 0) {
            if (rtl) {
              momentumDuration = Math.abs(
                (-newPosition - swiper.translate) / swiper.velocity
              );
            } else {
              momentumDuration = Math.abs(
                (newPosition - swiper.translate) / swiper.velocity
              );
            }
            if (params.freeModeSticky) {
              // If freeModeSticky is active and the user ends a swipe with a slow-velocity
              // event, then durations can be 20+ seconds to slide one (or zero!) slides.
              // It's easy to see this when simulating touch with mouse events. To fix this,
              // limit single-slide swipes to the default slide duration. This also has the
              // nice side effect of matching slide speed if the user stopped moving before
              // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
              // For faster swipes, also apply limits (albeit higher ones).
              const moveDistance = Math.abs(
                (rtl ? -newPosition : newPosition) - swiper.translate
              );
              const currentSlideSize =
                swiper.slidesSizesGrid[swiper.activeIndex];
              if (moveDistance < currentSlideSize) {
                momentumDuration = params.speed;
              } else if (moveDistance < 2 * currentSlideSize) {
                momentumDuration = params.speed * 1.5;
              } else {
                momentumDuration = params.speed * 2.5;
              }
            }
          } else if (params.freeModeSticky) {
            swiper.slideToClosest();
            return;
          }

          if (params.freeModeMomentumBounce && doBounce) {
            swiper.updateProgress(afterBouncePosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            swiper.animating = true;
            $wrapperEl.transitionEnd(() => {
              if (!swiper || swiper.destroyed || !data.allowMomentumBounce)
                return;
              swiper.emit("momentumBounce");
              swiper.setTransition(params.speed);
              setTimeout(() => {
                swiper.setTranslate(afterBouncePosition);
                $wrapperEl.transitionEnd(() => {
                  if (!swiper || swiper.destroyed) return;
                  swiper.transitionEnd();
                });
              }, 0);
            });
          } else if (swiper.velocity) {
            swiper.updateProgress(newPosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            if (!swiper.animating) {
              swiper.animating = true;
              $wrapperEl.transitionEnd(() => {
                if (!swiper || swiper.destroyed) return;
                swiper.transitionEnd();
              });
            }
          } else {
            swiper.updateProgress(newPosition);
          }

          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
        return;
      }

      // Find current slide
      let stopIndex = 0;
      let groupSize = swiper.slidesSizesGrid[0];
      for (
        let i = 0;
        i < slidesGrid.length;
        i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup
      ) {
        const increment =
          i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
          if (
            currentPos >= slidesGrid[i] &&
            currentPos < slidesGrid[i + increment]
          ) {
            stopIndex = i;
            groupSize = slidesGrid[i + increment] - slidesGrid[i];
          }
        } else if (currentPos >= slidesGrid[i]) {
          stopIndex = i;
          groupSize =
            slidesGrid[slidesGrid.length - 1] -
            slidesGrid[slidesGrid.length - 2];
        }
      }

      // Find current slide size
      const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
      const increment =
        stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

      if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        if (swiper.swipeDirection === "next") {
          if (ratio >= params.longSwipesRatio)
            swiper.slideTo(stopIndex + increment);
          else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
          if (ratio > 1 - params.longSwipesRatio)
            swiper.slideTo(stopIndex + increment);
          else swiper.slideTo(stopIndex);
        }
      } else {
        // Short swipes
        if (!params.shortSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        const isNavButtonTarget =
          swiper.navigation &&
          (e.target === swiper.navigation.nextEl ||
            e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
          if (swiper.swipeDirection === "next") {
            swiper.slideTo(stopIndex + increment);
          }
          if (swiper.swipeDirection === "prev") {
            swiper.slideTo(stopIndex);
          }
        } else if (e.target === swiper.navigation.nextEl) {
          swiper.slideTo(stopIndex + increment);
        } else {
          swiper.slideTo(stopIndex);
        }
      }
    }

    function onResize() {
      const swiper = this;

      const { params, el } = swiper;

      if (el && el.offsetWidth === 0) return;

      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Save locks
      const { allowSlideNext, allowSlidePrev, snapGrid } = swiper;

      // Disable locks on resize
      swiper.allowSlideNext = true;
      swiper.allowSlidePrev = true;

      swiper.updateSize();
      swiper.updateSlides();

      swiper.updateSlidesClasses();
      if (
        (params.slidesPerView === "auto" || params.slidesPerView > 1) &&
        swiper.isEnd &&
        !swiper.isBeginning &&
        !swiper.params.centeredSlides
      ) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (
        swiper.autoplay &&
        swiper.autoplay.running &&
        swiper.autoplay.paused
      ) {
        swiper.autoplay.run();
      }
      // Return locks after resize
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;

      if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
    }

    function onClick(e) {
      const swiper = this;
      if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }
    }

    function onScroll() {
      const swiper = this;
      const { wrapperEl, rtlTranslate } = swiper;
      swiper.previousTranslate = swiper.translate;
      if (swiper.isHorizontal()) {
        if (rtlTranslate) {
          swiper.translate =
            wrapperEl.scrollWidth -
            wrapperEl.offsetWidth -
            wrapperEl.scrollLeft;
        } else {
          swiper.translate = -wrapperEl.scrollLeft;
        }
      } else {
        swiper.translate = -wrapperEl.scrollTop;
      }
      // eslint-disable-next-line
      if (swiper.translate === -0) swiper.translate = 0;

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      let newProgress;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress =
          (swiper.translate - swiper.minTranslate()) / translatesDiff;
      }
      if (newProgress !== swiper.progress) {
        swiper.updateProgress(
          rtlTranslate ? -swiper.translate : swiper.translate
        );
      }

      swiper.emit("setTranslate", swiper.translate, false);
    }

    let dummyEventAttached = false;
    function dummyEventListener() {}

    function attachEvents() {
      const swiper = this;
      const { params, touchEvents, el, wrapperEl } = swiper;

      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
      if (params.cssMode) {
        swiper.onScroll = onScroll.bind(swiper);
      }

      swiper.onClick = onClick.bind(swiper);

      const capture = !!params.nested;

      // Touch Events
      if (!Support.touch && Support.pointerEvents) {
        el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          const passiveListener =
            touchEvents.start === "touchstart" &&
            Support.passiveListener &&
            params.passiveListeners
              ? { passive: true, capture: false }
              : false;
          el.addEventListener(
            touchEvents.start,
            swiper.onTouchStart,
            passiveListener
          );
          el.addEventListener(
            touchEvents.move,
            swiper.onTouchMove,
            Support.passiveListener ? { passive: false, capture } : capture
          );
          el.addEventListener(
            touchEvents.end,
            swiper.onTouchEnd,
            passiveListener
          );
          if (touchEvents.cancel) {
            el.addEventListener(
              touchEvents.cancel,
              swiper.onTouchEnd,
              passiveListener
            );
          }
          if (!dummyEventAttached) {
            doc.addEventListener("touchstart", dummyEventListener);
            dummyEventAttached = true;
          }
        }
        if (
          (params.simulateTouch && !Device.ios && !Device.android) ||
          (params.simulateTouch && !Support.touch && Device.ios)
        ) {
          el.addEventListener("mousedown", swiper.onTouchStart, false);
          doc.addEventListener("mousemove", swiper.onTouchMove, capture);
          doc.addEventListener("mouseup", swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        el.addEventListener("click", swiper.onClick, true);
      }
      if (params.cssMode) {
        wrapperEl.addEventListener("scroll", swiper.onScroll);
      }

      // Resize handler
      if (params.updateOnWindowResize) {
        swiper.on(
          Device.ios || Device.android
            ? "resize orientationchange observerUpdate"
            : "resize observerUpdate",
          onResize,
          true
        );
      } else {
        swiper.on("observerUpdate", onResize, true);
      }
    }

    function detachEvents() {
      const swiper = this;

      const { params, touchEvents, el, wrapperEl } = swiper;

      const capture = !!params.nested;

      // Touch Events
      if (!Support.touch && Support.pointerEvents) {
        el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          const passiveListener =
            touchEvents.start === "onTouchStart" &&
            Support.passiveListener &&
            params.passiveListeners
              ? { passive: true, capture: false }
              : false;
          el.removeEventListener(
            touchEvents.start,
            swiper.onTouchStart,
            passiveListener
          );
          el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
          el.removeEventListener(
            touchEvents.end,
            swiper.onTouchEnd,
            passiveListener
          );
          if (touchEvents.cancel) {
            el.removeEventListener(
              touchEvents.cancel,
              swiper.onTouchEnd,
              passiveListener
            );
          }
        }
        if (
          (params.simulateTouch && !Device.ios && !Device.android) ||
          (params.simulateTouch && !Support.touch && Device.ios)
        ) {
          el.removeEventListener("mousedown", swiper.onTouchStart, false);
          doc.removeEventListener("mousemove", swiper.onTouchMove, capture);
          doc.removeEventListener("mouseup", swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        el.removeEventListener("click", swiper.onClick, true);
      }

      if (params.cssMode) {
        wrapperEl.removeEventListener("scroll", swiper.onScroll);
      }

      // Resize handler
      swiper.off(
        Device.ios || Device.android
          ? "resize orientationchange observerUpdate"
          : "resize observerUpdate",
        onResize
      );
    }

    var swiper_esm_bundle_events = {
      attachEvents,
      detachEvents,
    };

    function setBreakpoint() {
      const swiper = this;
      const {
        activeIndex,
        initialized,
        loopedSlides = 0,
        params,
        $el,
      } = swiper;
      const breakpoints = params.breakpoints;
      if (
        !breakpoints ||
        (breakpoints && Object.keys(breakpoints).length === 0)
      )
        return;

      // Get breakpoint for window width and update parameters
      const breakpoint = swiper.getBreakpoint(breakpoints);

      if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
        const breakpointOnlyParams =
          breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
        if (breakpointOnlyParams) {
          [
            "slidesPerView",
            "spaceBetween",
            "slidesPerGroup",
            "slidesPerGroupSkip",
            "slidesPerColumn",
          ].forEach((param) => {
            const paramValue = breakpointOnlyParams[param];
            if (typeof paramValue === "undefined") return;
            if (
              param === "slidesPerView" &&
              (paramValue === "AUTO" || paramValue === "auto")
            ) {
              breakpointOnlyParams[param] = "auto";
            } else if (param === "slidesPerView") {
              breakpointOnlyParams[param] = parseFloat(paramValue);
            } else {
              breakpointOnlyParams[param] = parseInt(paramValue, 10);
            }
          });
        }

        const breakpointParams = breakpointOnlyParams || swiper.originalParams;
        const wasMultiRow = params.slidesPerColumn > 1;
        const isMultiRow = breakpointParams.slidesPerColumn > 1;
        if (wasMultiRow && !isMultiRow) {
          $el.removeClass(
            `${params.containerModifierClass}multirow ${params.containerModifierClass}multirow-column`
          );
        } else if (!wasMultiRow && isMultiRow) {
          $el.addClass(`${params.containerModifierClass}multirow`);
          if (breakpointParams.slidesPerColumnFill === "column") {
            $el.addClass(`${params.containerModifierClass}multirow-column`);
          }
        }

        const directionChanged =
          breakpointParams.direction &&
          breakpointParams.direction !== params.direction;
        const needsReLoop =
          params.loop &&
          (breakpointParams.slidesPerView !== params.slidesPerView ||
            directionChanged);

        if (directionChanged && initialized) {
          swiper.changeDirection();
        }

        Utils.extend(swiper.params, breakpointParams);

        Utils.extend(swiper, {
          allowTouchMove: swiper.params.allowTouchMove,
          allowSlideNext: swiper.params.allowSlideNext,
          allowSlidePrev: swiper.params.allowSlidePrev,
        });

        swiper.currentBreakpoint = breakpoint;

        if (needsReLoop && initialized) {
          swiper.loopDestroy();
          swiper.loopCreate();
          swiper.updateSlides();
          swiper.slideTo(
            activeIndex - loopedSlides + swiper.loopedSlides,
            0,
            false
          );
        }

        swiper.emit("breakpoint", breakpointParams);
      }
    }

    function getBreakpoint(breakpoints) {
      // Get breakpoint for window width
      if (!breakpoints) return undefined;
      let breakpoint = false;

      const points = Object.keys(breakpoints).map((point) => {
        if (typeof point === "string" && point.indexOf("@") === 0) {
          const minRatio = parseFloat(point.substr(1));
          const value = win.innerHeight * minRatio;
          return { value, point };
        }
        return { value: point, point };
      });

      points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
      for (let i = 0; i < points.length; i += 1) {
        const { point, value } = points[i];
        if (value <= win.innerWidth) {
          breakpoint = point;
        }
      }
      return breakpoint || "max";
    }

    var breakpoints = { setBreakpoint, getBreakpoint };

    function addClasses() {
      const swiper = this;
      const { classNames, params, rtl, $el } = swiper;
      const suffixes = [];

      suffixes.push("initialized");
      suffixes.push(params.direction);

      if (params.freeMode) {
        suffixes.push("free-mode");
      }
      if (params.autoHeight) {
        suffixes.push("autoheight");
      }
      if (rtl) {
        suffixes.push("rtl");
      }
      if (params.slidesPerColumn > 1) {
        suffixes.push("multirow");
        if (params.slidesPerColumnFill === "column") {
          suffixes.push("multirow-column");
        }
      }
      if (Device.android) {
        suffixes.push("android");
      }
      if (Device.ios) {
        suffixes.push("ios");
      }

      if (params.cssMode) {
        suffixes.push("css-mode");
      }

      suffixes.forEach((suffix) => {
        classNames.push(params.containerModifierClass + suffix);
      });

      $el.addClass(classNames.join(" "));
    }

    function removeClasses() {
      const swiper = this;
      const { $el, classNames } = swiper;

      $el.removeClass(classNames.join(" "));
    }

    var classes = { addClasses, removeClasses };

    function loadImage(
      imageEl,
      src,
      srcset,
      sizes,
      checkForComplete,
      callback
    ) {
      let image;
      function onReady() {
        if (callback) callback();
      }
      const isPicture = dom7_modular_$(imageEl).parent("picture")[0];

      if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
          image = new win.Image();
          image.onload = onReady;
          image.onerror = onReady;
          if (sizes) {
            image.sizes = sizes;
          }
          if (srcset) {
            image.srcset = srcset;
          }
          if (src) {
            image.src = src;
          }
        } else {
          onReady();
        }
      } else {
        // image already loaded...
        onReady();
      }
    }

    function preloadImages() {
      const swiper = this;
      swiper.imagesToLoad = swiper.$el.find("img");
      function onReady() {
        if (
          typeof swiper === "undefined" ||
          swiper === null ||
          !swiper ||
          swiper.destroyed
        )
          return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
          if (swiper.params.updateOnImagesReady) swiper.update();
          swiper.emit("imagesReady");
        }
      }
      for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(
          imageEl,
          imageEl.currentSrc || imageEl.getAttribute("src"),
          imageEl.srcset || imageEl.getAttribute("srcset"),
          imageEl.sizes || imageEl.getAttribute("sizes"),
          true,
          onReady
        );
      }
    }

    var swiper_esm_bundle_images = {
      loadImage,
      preloadImages,
    };

    function checkOverflow() {
      const swiper = this;
      const params = swiper.params;
      const wasLocked = swiper.isLocked;
      const lastSlidePosition =
        swiper.slides.length > 0 &&
        params.slidesOffsetBefore +
          params.spaceBetween * (swiper.slides.length - 1) +
          swiper.slides[0].offsetWidth * swiper.slides.length;

      if (
        params.slidesOffsetBefore &&
        params.slidesOffsetAfter &&
        lastSlidePosition
      ) {
        swiper.isLocked = lastSlidePosition <= swiper.size;
      } else {
        swiper.isLocked = swiper.snapGrid.length === 1;
      }

      swiper.allowSlideNext = !swiper.isLocked;
      swiper.allowSlidePrev = !swiper.isLocked;

      // events
      if (wasLocked !== swiper.isLocked)
        swiper.emit(swiper.isLocked ? "lock" : "unlock");

      if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
        if (swiper.navigation) swiper.navigation.update();
      }
    }

    var checkOverflow$1 = { checkOverflow };

    var defaults = {
      init: true,
      direction: "horizontal",
      touchEventsTarget: "container",
      initialSlide: 0,
      speed: 300,
      cssMode: false,
      updateOnWindowResize: true,
      //
      preventInteractionOnTransition: false,

      // To support iOS's swipe-to-go-back gesture (when being used in-app).
      edgeSwipeDetection: false,
      edgeSwipeThreshold: 20,

      // Free mode
      freeMode: false,
      freeModeMomentum: true,
      freeModeMomentumRatio: 1,
      freeModeMomentumBounce: true,
      freeModeMomentumBounceRatio: 1,
      freeModeMomentumVelocityRatio: 1,
      freeModeSticky: false,
      freeModeMinimumVelocity: 0.02,

      // Autoheight
      autoHeight: false,

      // Set wrapper width
      setWrapperSize: false,

      // Virtual Translate
      virtualTranslate: false,

      // Effects
      effect: "slide", // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

      // Breakpoints
      breakpoints: undefined,

      // Slides grid
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerColumn: 1,
      slidesPerColumnFill: "column",
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      centeredSlides: false,
      centeredSlidesBounds: false,
      slidesOffsetBefore: 0, // in px
      slidesOffsetAfter: 0, // in px
      normalizeSlideIndex: true,
      centerInsufficientSlides: false,

      // Disable swiper and hide navigation when container not overflow
      watchOverflow: false,

      // Round length
      roundLengths: false,

      // Touches
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: true,
      allowTouchMove: true,
      threshold: 0,
      touchMoveStopPropagation: false,
      touchStartPreventDefault: true,
      touchStartForcePreventDefault: false,
      touchReleaseOnEdges: false,

      // Unique Navigation Elements
      uniqueNavElements: true,

      // Resistance
      resistance: true,
      resistanceRatio: 0.85,

      // Progress
      watchSlidesProgress: false,
      watchSlidesVisibility: false,

      // Cursor
      grabCursor: false,

      // Clicks
      preventClicks: true,
      preventClicksPropagation: true,
      slideToClickedSlide: false,

      // Images
      preloadImages: true,
      updateOnImagesReady: true,

      // loop
      loop: false,
      loopAdditionalSlides: 0,
      loopedSlides: null,
      loopFillGroupWithBlank: false,

      // Swiping/no swiping
      allowSlidePrev: true,
      allowSlideNext: true,
      swipeHandler: null, // '.swipe-handler',
      noSwiping: true,
      noSwipingClass: "swiper-no-swiping",
      noSwipingSelector: null,

      // Passive Listeners
      passiveListeners: true,

      // NS
      containerModifierClass: "swiper-container-", // NEW
      slideClass: "swiper-slide",
      slideBlankClass: "swiper-slide-invisible-blank",
      slideActiveClass: "swiper-slide-active",
      slideDuplicateActiveClass: "swiper-slide-duplicate-active",
      slideVisibleClass: "swiper-slide-visible",
      slideDuplicateClass: "swiper-slide-duplicate",
      slideNextClass: "swiper-slide-next",
      slideDuplicateNextClass: "swiper-slide-duplicate-next",
      slidePrevClass: "swiper-slide-prev",
      slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
      wrapperClass: "swiper-wrapper",

      // Callbacks
      runCallbacksOnInit: true,
    };

    /* eslint no-param-reassign: "off" */

    const prototypes = {
      update,
      translate,
      transition: swiper_esm_bundle_transition,
      slide,
      loop,
      grabCursor,
      manipulation,
      events: swiper_esm_bundle_events,
      breakpoints,
      checkOverflow: checkOverflow$1,
      classes,
      images: swiper_esm_bundle_images,
    };

    const extendedDefaults = {};

    class Swiper extends SwiperClass {
      constructor(...args) {
        let el;
        let params;
        if (
          args.length === 1 &&
          args[0].constructor &&
          args[0].constructor === Object
        ) {
          params = args[0];
        } else {
          [el, params] = args;
        }
        if (!params) params = {};

        params = Utils.extend({}, params);
        if (el && !params.el) params.el = el;

        super(params);

        Object.keys(prototypes).forEach((prototypeGroup) => {
          Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
            if (!Swiper.prototype[protoMethod]) {
              Swiper.prototype[protoMethod] =
                prototypes[prototypeGroup][protoMethod];
            }
          });
        });

        // Swiper Instance
        const swiper = this;
        if (typeof swiper.modules === "undefined") {
          swiper.modules = {};
        }
        Object.keys(swiper.modules).forEach((moduleName) => {
          const module = swiper.modules[moduleName];
          if (module.params) {
            const moduleParamName = Object.keys(module.params)[0];
            const moduleParams = module.params[moduleParamName];
            if (typeof moduleParams !== "object" || moduleParams === null)
              return;
            if (!(moduleParamName in params && "enabled" in moduleParams))
              return;
            if (params[moduleParamName] === true) {
              params[moduleParamName] = { enabled: true };
            }
            if (
              typeof params[moduleParamName] === "object" &&
              !("enabled" in params[moduleParamName])
            ) {
              params[moduleParamName].enabled = true;
            }
            if (!params[moduleParamName])
              params[moduleParamName] = { enabled: false };
          }
        });

        // Extend defaults with modules params
        const swiperParams = Utils.extend({}, defaults);
        swiper.useModulesParams(swiperParams);

        // Extend defaults with passed params
        swiper.params = Utils.extend(
          {},
          swiperParams,
          extendedDefaults,
          params
        );
        swiper.originalParams = Utils.extend({}, swiper.params);
        swiper.passedParams = Utils.extend({}, params);

        // Save Dom lib
        swiper.$ = dom7_modular_$;

        // Find el
        const $el = dom7_modular_$(swiper.params.el);
        el = $el[0];

        if (!el) {
          return undefined;
        }

        if ($el.length > 1) {
          const swipers = [];
          $el.each((index, containerEl) => {
            const newParams = Utils.extend({}, params, { el: containerEl });
            swipers.push(new Swiper(newParams));
          });
          return swipers;
        }

        el.swiper = swiper;
        $el.data("swiper", swiper);

        // Find Wrapper
        let $wrapperEl;
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
          $wrapperEl = dom7_modular_$(
            el.shadowRoot.querySelector(`.${swiper.params.wrapperClass}`)
          );
          // Children needs to return slot items
          $wrapperEl.children = (options) => $el.children(options);
        } else {
          $wrapperEl = $el.children(`.${swiper.params.wrapperClass}`);
        }
        // Extend Swiper
        Utils.extend(swiper, {
          $el,
          el,
          $wrapperEl,
          wrapperEl: $wrapperEl[0],

          // Classes
          classNames: [],

          // Slides
          slides: dom7_modular_$(),
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],

          // isDirection
          isHorizontal() {
            return swiper.params.direction === "horizontal";
          },
          isVertical() {
            return swiper.params.direction === "vertical";
          },
          // RTL
          rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
          rtlTranslate:
            swiper.params.direction === "horizontal" &&
            (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
          wrongRTL: $wrapperEl.css("display") === "-webkit-box",

          // Indexes
          activeIndex: 0,
          realIndex: 0,

          //
          isBeginning: true,
          isEnd: false,

          // Props
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: false,

          // Locks
          allowSlideNext: swiper.params.allowSlideNext,
          allowSlidePrev: swiper.params.allowSlidePrev,

          // Touch Events
          touchEvents: (function touchEvents() {
            const touch = [
              "touchstart",
              "touchmove",
              "touchend",
              "touchcancel",
            ];
            let desktop = ["mousedown", "mousemove", "mouseup"];
            if (Support.pointerEvents) {
              desktop = ["pointerdown", "pointermove", "pointerup"];
            }
            swiper.touchEventsTouch = {
              start: touch[0],
              move: touch[1],
              end: touch[2],
              cancel: touch[3],
            };
            swiper.touchEventsDesktop = {
              start: desktop[0],
              move: desktop[1],
              end: desktop[2],
            };
            return Support.touch || !swiper.params.simulateTouch
              ? swiper.touchEventsTouch
              : swiper.touchEventsDesktop;
          })(),
          touchEventsData: {
            isTouched: undefined,
            isMoved: undefined,
            allowTouchCallbacks: undefined,
            touchStartTime: undefined,
            isScrolling: undefined,
            currentTranslate: undefined,
            startTranslate: undefined,
            allowThresholdMove: undefined,
            // Form elements to match
            formElements:
              "input, select, option, textarea, button, video, label",
            // Last click time
            lastClickTime: Utils.now(),
            clickTimeout: undefined,
            // Velocities
            velocities: [],
            allowMomentumBounce: undefined,
            isTouchEvent: undefined,
            startMoving: undefined,
          },

          // Clicks
          allowClick: true,

          // Touches
          allowTouchMove: swiper.params.allowTouchMove,

          touches: {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0,
          },

          // Images
          imagesToLoad: [],
          imagesLoaded: 0,
        });

        // Install Modules
        swiper.useModules();

        // Init
        if (swiper.params.init) {
          swiper.init();
        }

        // Return app instance
        return swiper;
      }

      slidesPerViewDynamic() {
        const swiper = this;
        const {
          params,
          slides,
          slidesGrid,
          size: swiperSize,
          activeIndex,
        } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
          let slideSize = slides[activeIndex].swiperSlideSize;
          let breakLoop;
          for (let i = activeIndex + 1; i < slides.length; i += 1) {
            if (slides[i] && !breakLoop) {
              slideSize += slides[i].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }
          for (let i = activeIndex - 1; i >= 0; i -= 1) {
            if (slides[i] && !breakLoop) {
              slideSize += slides[i].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }
        } else {
          for (let i = activeIndex + 1; i < slides.length; i += 1) {
            if (slidesGrid[i] - slidesGrid[activeIndex] < swiperSize) {
              spv += 1;
            }
          }
        }
        return spv;
      }

      update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid, params } = swiper;
        // Breakpoints
        if (params.breakpoints) {
          swiper.setBreakpoint();
        }
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();

        function setTranslate() {
          const translateValue = swiper.rtlTranslate
            ? swiper.translate * -1
            : swiper.translate;
          const newTranslate = Math.min(
            Math.max(translateValue, swiper.maxTranslate()),
            swiper.minTranslate()
          );
          swiper.setTranslate(newTranslate);
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode) {
          setTranslate();
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight();
          }
        } else {
          if (
            (swiper.params.slidesPerView === "auto" ||
              swiper.params.slidesPerView > 1) &&
            swiper.isEnd &&
            !swiper.params.centeredSlides
          ) {
            translated = swiper.slideTo(
              swiper.slides.length - 1,
              0,
              false,
              true
            );
          } else {
            translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
          }
          if (!translated) {
            setTranslate();
          }
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
          swiper.checkOverflow();
        }
        swiper.emit("update");
      }

      changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) {
          // eslint-disable-next-line
          newDirection =
            currentDirection === "horizontal" ? "vertical" : "horizontal";
        }
        if (
          newDirection === currentDirection ||
          (newDirection !== "horizontal" && newDirection !== "vertical")
        ) {
          return swiper;
        }

        swiper.$el
          .removeClass(
            `${swiper.params.containerModifierClass}${currentDirection}`
          )
          .addClass(`${swiper.params.containerModifierClass}${newDirection}`);

        swiper.params.direction = newDirection;

        swiper.slides.each((slideIndex, slideEl) => {
          if (newDirection === "vertical") {
            slideEl.style.width = "";
          } else {
            slideEl.style.height = "";
          }
        });

        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();

        return swiper;
      }

      init() {
        const swiper = this;
        if (swiper.initialized) return;

        swiper.emit("beforeInit");

        // Set breakpoint
        if (swiper.params.breakpoints) {
          swiper.setBreakpoint();
        }

        // Add Classes
        swiper.addClasses();

        // Create loop
        if (swiper.params.loop) {
          swiper.loopCreate();
        }

        // Update size
        swiper.updateSize();

        // Update slides
        swiper.updateSlides();

        if (swiper.params.watchOverflow) {
          swiper.checkOverflow();
        }

        // Set Grab Cursor
        if (swiper.params.grabCursor) {
          swiper.setGrabCursor();
        }

        if (swiper.params.preloadImages) {
          swiper.preloadImages();
        }

        // Slide To Initial Slide
        if (swiper.params.loop) {
          swiper.slideTo(
            swiper.params.initialSlide + swiper.loopedSlides,
            0,
            swiper.params.runCallbacksOnInit
          );
        } else {
          swiper.slideTo(
            swiper.params.initialSlide,
            0,
            swiper.params.runCallbacksOnInit
          );
        }

        // Attach events
        swiper.attachEvents();

        // Init Flag
        swiper.initialized = true;

        // Emit
        swiper.emit("init");
      }

      destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params, $el, $wrapperEl, slides } = swiper;

        if (typeof swiper.params === "undefined" || swiper.destroyed) {
          return null;
        }

        swiper.emit("beforeDestroy");

        // Init Flag
        swiper.initialized = false;

        // Detach events
        swiper.detachEvents();

        // Destroy loop
        if (params.loop) {
          swiper.loopDestroy();
        }

        // Cleanup styles
        if (cleanStyles) {
          swiper.removeClasses();
          $el.removeAttr("style");
          $wrapperEl.removeAttr("style");
          if (slides && slides.length) {
            slides
              .removeClass(
                [
                  params.slideVisibleClass,
                  params.slideActiveClass,
                  params.slideNextClass,
                  params.slidePrevClass,
                ].join(" ")
              )
              .removeAttr("style")
              .removeAttr("data-swiper-slide-index");
          }
        }

        swiper.emit("destroy");

        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName) => {
          swiper.off(eventName);
        });

        if (deleteInstance !== false) {
          swiper.$el[0].swiper = null;
          swiper.$el.data("swiper", null);
          Utils.deleteProps(swiper);
        }
        swiper.destroyed = true;

        return null;
      }

      static extendDefaults(newDefaults) {
        Utils.extend(extendedDefaults, newDefaults);
      }

      static get extendedDefaults() {
        return extendedDefaults;
      }

      static get defaults() {
        return defaults;
      }

      static get Class() {
        return SwiperClass;
      }

      static get $() {
        return dom7_modular_$;
      }
    }

    var Device$1 = {
      name: "device",
      proto: {
        device: Device,
      },
      static: {
        device: Device,
      },
    };

    var Support$1 = {
      name: "support",
      proto: {
        support: Support,
      },
      static: {
        support: Support,
      },
    };

    const Browser = (function Browser() {
      function isSafari() {
        const ua = win.navigator.userAgent.toLowerCase();
        return (
          ua.indexOf("safari") >= 0 &&
          ua.indexOf("chrome") < 0 &&
          ua.indexOf("android") < 0
        );
      }
      return {
        isEdge: !!win.navigator.userAgent.match(/Edge/g),
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
          win.navigator.userAgent
        ),
      };
    })();

    var Browser$1 = {
      name: "browser",
      proto: {
        browser: Browser,
      },
      static: {
        browser: Browser,
      },
    };

    var Resize = {
      name: "resize",
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          resize: {
            resizeHandler() {
              if (!swiper || swiper.destroyed || !swiper.initialized) return;
              swiper.emit("beforeResize");
              swiper.emit("resize");
            },
            orientationChangeHandler() {
              if (!swiper || swiper.destroyed || !swiper.initialized) return;
              swiper.emit("orientationchange");
            },
          },
        });
      },
      on: {
        init() {
          const swiper = this;
          // Emit resize
          win.addEventListener("resize", swiper.resize.resizeHandler);

          // Emit orientationchange
          win.addEventListener(
            "orientationchange",
            swiper.resize.orientationChangeHandler
          );
        },
        destroy() {
          const swiper = this;
          win.removeEventListener("resize", swiper.resize.resizeHandler);
          win.removeEventListener(
            "orientationchange",
            swiper.resize.orientationChangeHandler
          );
        },
      },
    };

    const swiper_esm_bundle_Observer = {
      func: win.MutationObserver || win.WebkitMutationObserver,
      attach(target, options = {}) {
        const swiper = this;

        const ObserverFunc = swiper_esm_bundle_Observer.func;
        const observer = new ObserverFunc((mutations) => {
          // The observerUpdate event should only be triggered
          // once despite the number of mutations.  Additional
          // triggers are redundant and are very costly
          if (mutations.length === 1) {
            swiper.emit("observerUpdate", mutations[0]);
            return;
          }
          const observerUpdate = function observerUpdate() {
            swiper.emit("observerUpdate", mutations[0]);
          };

          if (win.requestAnimationFrame) {
            win.requestAnimationFrame(observerUpdate);
          } else {
            win.setTimeout(observerUpdate, 0);
          }
        });

        observer.observe(target, {
          attributes:
            typeof options.attributes === "undefined"
              ? true
              : options.attributes,
          childList:
            typeof options.childList === "undefined" ? true : options.childList,
          characterData:
            typeof options.characterData === "undefined"
              ? true
              : options.characterData,
        });

        swiper.observer.observers.push(observer);
      },
      init() {
        const swiper = this;
        if (!Support.observer || !swiper.params.observer) return;
        if (swiper.params.observeParents) {
          const containerParents = swiper.$el.parents();
          for (let i = 0; i < containerParents.length; i += 1) {
            swiper.observer.attach(containerParents[i]);
          }
        }
        // Observe container
        swiper.observer.attach(swiper.$el[0], {
          childList: swiper.params.observeSlideChildren,
        });

        // Observe wrapper
        swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
      },
      destroy() {
        const swiper = this;
        swiper.observer.observers.forEach((observer) => {
          observer.disconnect();
        });
        swiper.observer.observers = [];
      },
    };

    var Observer$1 = {
      name: "observer",
      params: {
        observer: false,
        observeParents: false,
        observeSlideChildren: false,
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          observer: {
            init: swiper_esm_bundle_Observer.init.bind(swiper),
            attach: swiper_esm_bundle_Observer.attach.bind(swiper),
            destroy: swiper_esm_bundle_Observer.destroy.bind(swiper),
            observers: [],
          },
        });
      },
      on: {
        init() {
          const swiper = this;
          swiper.observer.init();
        },
        destroy() {
          const swiper = this;
          swiper.observer.destroy();
        },
      },
    };

    const Virtual = {
      update(force) {
        const swiper = this;
        const { slidesPerView, slidesPerGroup, centeredSlides } = swiper.params;
        const { addSlidesBefore, addSlidesAfter } = swiper.params.virtual;
        const {
          from: previousFrom,
          to: previousTo,
          slides,
          slidesGrid: previousSlidesGrid,
          renderSlide,
          offset: previousOffset,
        } = swiper.virtual;
        swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;

        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";

        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
          slidesAfter =
            Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
          slidesBefore =
            Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
        } else {
          slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
          slidesBefore = slidesPerGroup + addSlidesAfter;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min(
          (activeIndex || 0) + slidesAfter,
          slides.length - 1
        );
        const offset =
          (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

        Utils.extend(swiper.virtual, {
          from,
          to,
          offset,
          slidesGrid: swiper.slidesGrid,
        });

        function onRendered() {
          swiper.updateSlides();
          swiper.updateProgress();
          swiper.updateSlidesClasses();
          if (swiper.lazy && swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
        }

        if (previousFrom === from && previousTo === to && !force) {
          if (
            swiper.slidesGrid !== previousSlidesGrid &&
            offset !== previousOffset
          ) {
            swiper.slides.css(offsetProp, `${offset}px`);
          }
          swiper.updateProgress();
          return;
        }
        if (swiper.params.virtual.renderExternal) {
          swiper.params.virtual.renderExternal.call(swiper, {
            offset,
            from,
            to,
            slides: (function getSlides() {
              const slidesToRender = [];
              for (let i = from; i <= to; i += 1) {
                slidesToRender.push(slides[i]);
              }
              return slidesToRender;
            })(),
          });
          onRendered();
          return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) {
          swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        } else {
          for (let i = previousFrom; i <= previousTo; i += 1) {
            if (i < from || i > to) {
              swiper.$wrapperEl
                .find(
                  `.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`
                )
                .remove();
            }
          }
        }
        for (let i = 0; i < slides.length; i += 1) {
          if (i >= from && i <= to) {
            if (typeof previousTo === "undefined" || force) {
              appendIndexes.push(i);
            } else {
              if (i > previousTo) appendIndexes.push(i);
              if (i < previousFrom) prependIndexes.push(i);
            }
          }
        }
        appendIndexes.forEach((index) => {
          swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes
          .sort((a, b) => b - a)
          .forEach((index) => {
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
          });
        swiper.$wrapperEl
          .children(".swiper-slide")
          .css(offsetProp, `${offset}px`);
        onRendered();
      },
      renderSlide(slide, index) {
        const swiper = this;
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) {
          return swiper.virtual.cache[index];
        }
        const $slideEl = params.renderSlide
          ? dom7_modular_$(params.renderSlide.call(swiper, slide, index))
          : dom7_modular_$(
              `<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`
            );
        if (!$slideEl.attr("data-swiper-slide-index"))
          $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
      },
      appendSlide(slides) {
        const swiper = this;
        if (typeof slides === "object" && "length" in slides) {
          for (let i = 0; i < slides.length; i += 1) {
            if (slides[i]) swiper.virtual.slides.push(slides[i]);
          }
        } else {
          swiper.virtual.slides.push(slides);
        }
        swiper.virtual.update(true);
      },
      prependSlide(slides) {
        const swiper = this;
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;

        if (Array.isArray(slides)) {
          for (let i = 0; i < slides.length; i += 1) {
            if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
          }
          newActiveIndex = activeIndex + slides.length;
          numberOfNewSlides = slides.length;
        } else {
          swiper.virtual.slides.unshift(slides);
        }
        if (swiper.params.virtual.cache) {
          const cache = swiper.virtual.cache;
          const newCache = {};
          Object.keys(cache).forEach((cachedIndex) => {
            const $cachedEl = cache[cachedIndex];
            const cachedElIndex = $cachedEl.attr("data-swiper-slide-index");
            if (cachedElIndex) {
              $cachedEl.attr(
                "data-swiper-slide-index",
                parseInt(cachedElIndex, 10) + 1
              );
            }
            newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
          });
          swiper.virtual.cache = newCache;
        }
        swiper.virtual.update(true);
        swiper.slideTo(newActiveIndex, 0);
      },
      removeSlide(slidesIndexes) {
        const swiper = this;
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null)
          return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) {
          for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) {
              delete swiper.virtual.cache[slidesIndexes[i]];
            }
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
          }
        } else {
          swiper.virtual.slides.splice(slidesIndexes, 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes];
          }
          if (slidesIndexes < activeIndex) activeIndex -= 1;
          activeIndex = Math.max(activeIndex, 0);
        }
        swiper.virtual.update(true);
        swiper.slideTo(activeIndex, 0);
      },
      removeAllSlides() {
        const swiper = this;
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) {
          swiper.virtual.cache = {};
        }
        swiper.virtual.update(true);
        swiper.slideTo(0, 0);
      },
    };

    var Virtual$1 = {
      name: "virtual",
      params: {
        virtual: {
          enabled: false,
          slides: [],
          cache: true,
          renderSlide: null,
          renderExternal: null,
          addSlidesBefore: 0,
          addSlidesAfter: 0,
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          virtual: {
            update: Virtual.update.bind(swiper),
            appendSlide: Virtual.appendSlide.bind(swiper),
            prependSlide: Virtual.prependSlide.bind(swiper),
            removeSlide: Virtual.removeSlide.bind(swiper),
            removeAllSlides: Virtual.removeAllSlides.bind(swiper),
            renderSlide: Virtual.renderSlide.bind(swiper),
            slides: swiper.params.virtual.slides,
            cache: {},
          },
        });
      },
      on: {
        beforeInit() {
          const swiper = this;
          if (!swiper.params.virtual.enabled) return;
          swiper.classNames.push(
            `${swiper.params.containerModifierClass}virtual`
          );
          const overwriteParams = {
            watchSlidesProgress: true,
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);

          if (!swiper.params.initialSlide) {
            swiper.virtual.update();
          }
        },
        setTranslate() {
          const swiper = this;
          if (!swiper.params.virtual.enabled) return;
          swiper.virtual.update();
        },
      },
    };

    const Keyboard = {
      handle(event) {
        const swiper = this;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (
          !swiper.allowSlideNext &&
          ((swiper.isHorizontal() && isArrowRight) ||
            (swiper.isVertical() && isArrowDown) ||
            isPageDown)
        ) {
          return false;
        }
        if (
          !swiper.allowSlidePrev &&
          ((swiper.isHorizontal() && isArrowLeft) ||
            (swiper.isVertical() && isArrowUp) ||
            isPageUp)
        ) {
          return false;
        }
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
          return undefined;
        }
        if (
          doc.activeElement &&
          doc.activeElement.nodeName &&
          (doc.activeElement.nodeName.toLowerCase() === "input" ||
            doc.activeElement.nodeName.toLowerCase() === "textarea")
        ) {
          return undefined;
        }
        if (
          swiper.params.keyboard.onlyInViewport &&
          (isPageUp ||
            isPageDown ||
            isArrowLeft ||
            isArrowRight ||
            isArrowUp ||
            isArrowDown)
        ) {
          let inView = false;
          // Check that swiper should be inside of visible area of window
          if (
            swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 &&
            swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length ===
              0
          ) {
            return undefined;
          }
          const windowWidth = win.innerWidth;
          const windowHeight = win.innerHeight;
          const swiperOffset = swiper.$el.offset();
          if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
          const swiperCoord = [
            [swiperOffset.left, swiperOffset.top],
            [swiperOffset.left + swiper.width, swiperOffset.top],
            [swiperOffset.left, swiperOffset.top + swiper.height],
            [
              swiperOffset.left + swiper.width,
              swiperOffset.top + swiper.height,
            ],
          ];
          for (let i = 0; i < swiperCoord.length; i += 1) {
            const point = swiperCoord[i];
            if (
              point[0] >= 0 &&
              point[0] <= windowWidth &&
              point[1] >= 0 &&
              point[1] <= windowHeight
            ) {
              inView = true;
            }
          }
          if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
          if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
          }
          if (
            ((isPageDown || isArrowRight) && !rtl) ||
            ((isPageUp || isArrowLeft) && rtl)
          )
            swiper.slideNext();
          if (
            ((isPageUp || isArrowLeft) && !rtl) ||
            ((isPageDown || isArrowRight) && rtl)
          )
            swiper.slidePrev();
        } else {
          if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
          }
          if (isPageDown || isArrowDown) swiper.slideNext();
          if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        swiper.emit("keyPress", kc);
        return undefined;
      },
      enable() {
        const swiper = this;
        if (swiper.keyboard.enabled) return;
        dom7_modular_$(doc).on("keydown", swiper.keyboard.handle);
        swiper.keyboard.enabled = true;
      },
      disable() {
        const swiper = this;
        if (!swiper.keyboard.enabled) return;
        dom7_modular_$(doc).off("keydown", swiper.keyboard.handle);
        swiper.keyboard.enabled = false;
      },
    };

    var Keyboard$1 = {
      name: "keyboard",
      params: {
        keyboard: {
          enabled: false,
          onlyInViewport: true,
          pageUpDown: true,
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          keyboard: {
            enabled: false,
            enable: Keyboard.enable.bind(swiper),
            disable: Keyboard.disable.bind(swiper),
            handle: Keyboard.handle.bind(swiper),
          },
        });
      },
      on: {
        init() {
          const swiper = this;
          if (swiper.params.keyboard.enabled) {
            swiper.keyboard.enable();
          }
        },
        destroy() {
          const swiper = this;
          if (swiper.keyboard.enabled) {
            swiper.keyboard.disable();
          }
        },
      },
    };

    function isEventSupported() {
      const eventName = "onwheel";
      let isSupported = eventName in doc;

      if (!isSupported) {
        const element = doc.createElement("div");
        element.setAttribute(eventName, "return;");
        isSupported = typeof element[eventName] === "function";
      }

      if (
        !isSupported &&
        doc.implementation &&
        doc.implementation.hasFeature &&
        // always returns true in newer browsers as per the standard.
        // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
        doc.implementation.hasFeature("", "") !== true
      ) {
        // This is the only way to test support for the `wheel` event in IE9+.
        isSupported = doc.implementation.hasFeature("Events.wheel", "3.0");
      }

      return isSupported;
    }
    const Mousewheel = {
      lastScrollTime: Utils.now(),
      lastEventBeforeSnap: undefined,
      recentWheelEvents: [],
      event() {
        if (win.navigator.userAgent.indexOf("firefox") > -1)
          return "DOMMouseScroll";
        return isEventSupported() ? "wheel" : "mousewheel";
      },
      normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;

        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY

        // Legacy
        if ("detail" in e) {
          sY = e.detail;
        }
        if ("wheelDelta" in e) {
          sY = -e.wheelDelta / 120;
        }
        if ("wheelDeltaY" in e) {
          sY = -e.wheelDeltaY / 120;
        }
        if ("wheelDeltaX" in e) {
          sX = -e.wheelDeltaX / 120;
        }

        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
          sX = sY;
          sY = 0;
        }

        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;

        if ("deltaY" in e) {
          pY = e.deltaY;
        }
        if ("deltaX" in e) {
          pX = e.deltaX;
        }

        if (e.shiftKey && !pX) {
          // if user scrolls with shift he wants horizontal scroll
          pX = pY;
          pY = 0;
        }

        if ((pX || pY) && e.deltaMode) {
          if (e.deltaMode === 1) {
            // delta in LINE units
            pX *= LINE_HEIGHT;
            pY *= LINE_HEIGHT;
          } else {
            // delta in PAGE units
            pX *= PAGE_HEIGHT;
            pY *= PAGE_HEIGHT;
          }
        }

        // Fall-back if spin cannot be determined
        if (pX && !sX) {
          sX = pX < 1 ? -1 : 1;
        }
        if (pY && !sY) {
          sY = pY < 1 ? -1 : 1;
        }

        return {
          spinX: sX,
          spinY: sY,
          pixelX: pX,
          pixelY: pY,
        };
      },
      handleMouseEnter() {
        const swiper = this;
        swiper.mouseEntered = true;
      },
      handleMouseLeave() {
        const swiper = this;
        swiper.mouseEntered = false;
      },
      handle(event) {
        let e = event;
        const swiper = this;
        const params = swiper.params.mousewheel;

        if (swiper.params.cssMode) {
          e.preventDefault();
        }

        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarged !== "container") {
          target = dom7_modular_$(swiper.params.mousewheel.eventsTarged);
        }
        if (
          !swiper.mouseEntered &&
          !target[0].contains(e.target) &&
          !params.releaseOnEdges
        )
          return true;

        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;

        const data = Mousewheel.normalize(e);

        if (params.forceToAxis) {
          if (swiper.isHorizontal()) {
            if (Math.abs(data.pixelX) > Math.abs(data.pixelY))
              delta = -data.pixelX * rtlFactor;
            else return true;
          } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX))
            delta = -data.pixelY;
          else return true;
        } else {
          delta =
            Math.abs(data.pixelX) > Math.abs(data.pixelY)
              ? -data.pixelX * rtlFactor
              : -data.pixelY;
        }

        if (delta === 0) return true;

        if (params.invert) delta = -delta;

        if (!swiper.params.freeMode) {
          // Register the new event in a variable which stores the relevant data
          const newEvent = {
            time: Utils.now(),
            delta: Math.abs(delta),
            direction: Math.sign(delta),
            raw: event,
          };

          // Keep the most recent events
          const recentWheelEvents = swiper.mousewheel.recentWheelEvents;
          if (recentWheelEvents.length >= 2) {
            recentWheelEvents.shift(); // only store the last N events
          }
          const prevEvent = recentWheelEvents.length
            ? recentWheelEvents[recentWheelEvents.length - 1]
            : undefined;
          recentWheelEvents.push(newEvent);

          // If there is at least one previous recorded event:
          //   If direction has changed or
          //   if the scroll is quicker than the previous one:
          //     Animate the slider.
          // Else (this is the first time the wheel is moved):
          //     Animate the slider.
          if (prevEvent) {
            if (
              newEvent.direction !== prevEvent.direction ||
              newEvent.delta > prevEvent.delta ||
              newEvent.time > prevEvent.time + 150
            ) {
              swiper.mousewheel.animateSlider(newEvent);
            }
          } else {
            swiper.mousewheel.animateSlider(newEvent);
          }

          // If it's time to release the scroll:
          //   Return now so you don't hit the preventDefault.
          if (swiper.mousewheel.releaseScroll(newEvent)) {
            return true;
          }
        } else {
          // Freemode or scrollContainer:

          // If we recently snapped after a momentum scroll, then ignore wheel events
          // to give time for the deceleration to finish. Stop ignoring after 500 msecs
          // or if it's a new scroll (larger delta or inverse sign as last event before
          // an end-of-momentum snap).
          const newEvent = {
            time: Utils.now(),
            delta: Math.abs(delta),
            direction: Math.sign(delta),
          };
          const { lastEventBeforeSnap } = swiper.mousewheel;
          const ignoreWheelEvents =
            lastEventBeforeSnap &&
            newEvent.time < lastEventBeforeSnap.time + 500 &&
            newEvent.delta <= lastEventBeforeSnap.delta &&
            newEvent.direction === lastEventBeforeSnap.direction;
          if (!ignoreWheelEvents) {
            swiper.mousewheel.lastEventBeforeSnap = undefined;

            if (swiper.params.loop) {
              swiper.loopFix();
            }
            let position = swiper.getTranslate() + delta * params.sensitivity;
            const wasBeginning = swiper.isBeginning;
            const wasEnd = swiper.isEnd;

            if (position >= swiper.minTranslate())
              position = swiper.minTranslate();
            if (position <= swiper.maxTranslate())
              position = swiper.maxTranslate();

            swiper.setTransition(0);
            swiper.setTranslate(position);
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();

            if (
              (!wasBeginning && swiper.isBeginning) ||
              (!wasEnd && swiper.isEnd)
            ) {
              swiper.updateSlidesClasses();
            }

            if (swiper.params.freeModeSticky) {
              // When wheel scrolling starts with sticky (aka snap) enabled, then detect
              // the end of a momentum scroll by storing recent (N=15?) wheel events.
              // 1. do all N events have decreasing or same (absolute value) delta?
              // 2. did all N events arrive in the last M (M=500?) msecs?
              // 3. does the earliest event have an (absolute value) delta that's
              //    at least P (P=1?) larger than the most recent event's delta?
              // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
              // If 1-4 are "yes" then we're near the end of a momuntum scroll deceleration.
              // Snap immediately and ignore remaining wheel events in this scroll.
              // See comment above for "remaining wheel events in this scroll" determination.
              // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
              clearTimeout(swiper.mousewheel.timeout);
              swiper.mousewheel.timeout = undefined;
              const recentWheelEvents = swiper.mousewheel.recentWheelEvents;
              if (recentWheelEvents.length >= 15) {
                recentWheelEvents.shift(); // only store the last N events
              }
              const prevEvent = recentWheelEvents.length
                ? recentWheelEvents[recentWheelEvents.length - 1]
                : undefined;
              const firstEvent = recentWheelEvents[0];
              recentWheelEvents.push(newEvent);
              if (
                prevEvent &&
                (newEvent.delta > prevEvent.delta ||
                  newEvent.direction !== prevEvent.direction)
              ) {
                // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                recentWheelEvents.splice(0);
              } else if (
                recentWheelEvents.length >= 15 &&
                newEvent.time - firstEvent.time < 500 &&
                firstEvent.delta - newEvent.delta >= 1 &&
                newEvent.delta <= 6
              ) {
                // We're at the end of the deceleration of a momentum scroll, so there's no need
                // to wait for more events. Snap ASAP on the next tick.
                // Also, because there's some remaining momentum we'll bias the snap in the
                // direction of the ongoing scroll because it's better UX for the scroll to snap
                // in the same direction as the scroll instead of reversing to snap.  Therefore,
                // if it's already scrolled more than 20% in the current direction, keep going.
                const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                swiper.mousewheel.lastEventBeforeSnap = newEvent;
                recentWheelEvents.splice(0);
                swiper.mousewheel.timeout = Utils.nextTick(() => {
                  swiper.slideToClosest(
                    swiper.params.speed,
                    true,
                    undefined,
                    snapToThreshold
                  );
                }, 0); // no delay; move on next tick
              }
              if (!swiper.mousewheel.timeout) {
                // if we get here, then we haven't detected the end of a momentum scroll, so
                // we'll consider a scroll "complete" when there haven't been any wheel events
                // for 500ms.
                swiper.mousewheel.timeout = Utils.nextTick(() => {
                  const snapToThreshold = 0.5;
                  swiper.mousewheel.lastEventBeforeSnap = newEvent;
                  recentWheelEvents.splice(0);
                  swiper.slideToClosest(
                    swiper.params.speed,
                    true,
                    undefined,
                    snapToThreshold
                  );
                }, 500);
              }
            }

            // Emit event
            if (!ignoreWheelEvents) swiper.emit("scroll", e);

            // Stop autoplay
            if (
              swiper.params.autoplay &&
              swiper.params.autoplayDisableOnInteraction
            )
              swiper.autoplay.stop();
            // Return page scroll on edge positions
            if (
              position === swiper.minTranslate() ||
              position === swiper.maxTranslate()
            )
              return true;
          }
        }

        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
      },
      animateSlider(newEvent) {
        const swiper = this;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (
          newEvent.delta >= 6 &&
          Utils.now() - swiper.mousewheel.lastScrollTime < 60
        ) {
          // Return false as a default
          return true;
        }
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
          if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
            swiper.slideNext();
            swiper.emit("scroll", newEvent.raw);
          }
        } else if (
          (!swiper.isBeginning || swiper.params.loop) &&
          !swiper.animating
        ) {
          swiper.slidePrev();
          swiper.emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        swiper.mousewheel.lastScrollTime = new win.Date().getTime();
        // Return false as a default
        return false;
      },
      releaseScroll(newEvent) {
        const swiper = this;
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
          if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
            // Return true to animate scroll on edges
            return true;
          }
        } else if (
          swiper.isBeginning &&
          !swiper.params.loop &&
          params.releaseOnEdges
        ) {
          // Return true to animate scroll on edges
          return true;
        }
        return false;
      },
      enable() {
        const swiper = this;
        const event = Mousewheel.event();
        if (swiper.params.cssMode) {
          swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
          return true;
        }
        if (!event) return false;
        if (swiper.mousewheel.enabled) return false;
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarged !== "container") {
          target = dom7_modular_$(swiper.params.mousewheel.eventsTarged);
        }
        target.on("mouseenter", swiper.mousewheel.handleMouseEnter);
        target.on("mouseleave", swiper.mousewheel.handleMouseLeave);
        target.on(event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = true;
        return true;
      },
      disable() {
        const swiper = this;
        const event = Mousewheel.event();
        if (swiper.params.cssMode) {
          swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
          return true;
        }
        if (!event) return false;
        if (!swiper.mousewheel.enabled) return false;
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarged !== "container") {
          target = dom7_modular_$(swiper.params.mousewheel.eventsTarged);
        }
        target.off(event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = false;
        return true;
      },
    };

    var Mousewheel$1 = {
      name: "mousewheel",
      params: {
        mousewheel: {
          enabled: false,
          releaseOnEdges: false,
          invert: false,
          forceToAxis: false,
          sensitivity: 1,
          eventsTarged: "container",
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          mousewheel: {
            enabled: false,
            enable: Mousewheel.enable.bind(swiper),
            disable: Mousewheel.disable.bind(swiper),
            handle: Mousewheel.handle.bind(swiper),
            handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
            handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
            animateSlider: Mousewheel.animateSlider.bind(swiper),
            releaseScroll: Mousewheel.releaseScroll.bind(swiper),
            lastScrollTime: Utils.now(),
            lastEventBeforeSnap: undefined,
            recentWheelEvents: [],
          },
        });
      },
      on: {
        init() {
          const swiper = this;
          if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
            swiper.mousewheel.disable();
          }
          if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
        },
        destroy() {
          const swiper = this;
          if (swiper.params.cssMode) {
            swiper.mousewheel.enable();
          }
          if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
        },
      },
    };

    const Navigation = {
      update() {
        // Update Navigation Buttons
        const swiper = this;
        const params = swiper.params.navigation;

        if (swiper.params.loop) return;
        const { $nextEl, $prevEl } = swiper.navigation;

        if ($prevEl && $prevEl.length > 0) {
          if (swiper.isBeginning) {
            $prevEl.addClass(params.disabledClass);
          } else {
            $prevEl.removeClass(params.disabledClass);
          }
          $prevEl[
            swiper.params.watchOverflow && swiper.isLocked
              ? "addClass"
              : "removeClass"
          ](params.lockClass);
        }
        if ($nextEl && $nextEl.length > 0) {
          if (swiper.isEnd) {
            $nextEl.addClass(params.disabledClass);
          } else {
            $nextEl.removeClass(params.disabledClass);
          }
          $nextEl[
            swiper.params.watchOverflow && swiper.isLocked
              ? "addClass"
              : "removeClass"
          ](params.lockClass);
        }
      },
      onPrevClick(e) {
        const swiper = this;
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop) return;
        swiper.slidePrev();
      },
      onNextClick(e) {
        const swiper = this;
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop) return;
        swiper.slideNext();
      },
      init() {
        const swiper = this;
        const params = swiper.params.navigation;
        if (!(params.nextEl || params.prevEl)) return;

        let $nextEl;
        let $prevEl;
        if (params.nextEl) {
          $nextEl = dom7_modular_$(params.nextEl);
          if (
            swiper.params.uniqueNavElements &&
            typeof params.nextEl === "string" &&
            $nextEl.length > 1 &&
            swiper.$el.find(params.nextEl).length === 1
          ) {
            $nextEl = swiper.$el.find(params.nextEl);
          }
        }
        if (params.prevEl) {
          $prevEl = dom7_modular_$(params.prevEl);
          if (
            swiper.params.uniqueNavElements &&
            typeof params.prevEl === "string" &&
            $prevEl.length > 1 &&
            swiper.$el.find(params.prevEl).length === 1
          ) {
            $prevEl = swiper.$el.find(params.prevEl);
          }
        }

        if ($nextEl && $nextEl.length > 0) {
          $nextEl.on("click", swiper.navigation.onNextClick);
        }
        if ($prevEl && $prevEl.length > 0) {
          $prevEl.on("click", swiper.navigation.onPrevClick);
        }

        Utils.extend(swiper.navigation, {
          $nextEl,
          nextEl: $nextEl && $nextEl[0],
          $prevEl,
          prevEl: $prevEl && $prevEl[0],
        });
      },
      destroy() {
        const swiper = this;
        const { $nextEl, $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
          $nextEl.off("click", swiper.navigation.onNextClick);
          $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
          $prevEl.off("click", swiper.navigation.onPrevClick);
          $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
      },
    };

    var Navigation$1 = {
      name: "navigation",
      params: {
        navigation: {
          nextEl: null,
          prevEl: null,

          hideOnClick: false,
          disabledClass: "swiper-button-disabled",
          hiddenClass: "swiper-button-hidden",
          lockClass: "swiper-button-lock",
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          navigation: {
            init: Navigation.init.bind(swiper),
            update: Navigation.update.bind(swiper),
            destroy: Navigation.destroy.bind(swiper),
            onNextClick: Navigation.onNextClick.bind(swiper),
            onPrevClick: Navigation.onPrevClick.bind(swiper),
          },
        });
      },
      on: {
        init() {
          const swiper = this;
          swiper.navigation.init();
          swiper.navigation.update();
        },
        toEdge() {
          const swiper = this;
          swiper.navigation.update();
        },
        fromEdge() {
          const swiper = this;
          swiper.navigation.update();
        },
        destroy() {
          const swiper = this;
          swiper.navigation.destroy();
        },
        click(e) {
          const swiper = this;
          const { $nextEl, $prevEl } = swiper.navigation;
          if (
            swiper.params.navigation.hideOnClick &&
            !dom7_modular_$(e.target).is($prevEl) &&
            !dom7_modular_$(e.target).is($nextEl)
          ) {
            let isHidden;
            if ($nextEl) {
              isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            } else if ($prevEl) {
              isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            }
            if (isHidden === true) {
              swiper.emit("navigationShow", swiper);
            } else {
              swiper.emit("navigationHide", swiper);
            }
            if ($nextEl) {
              $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            }
            if ($prevEl) {
              $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
            }
          }
        },
      },
    };

    const Pagination = {
      update() {
        // Render || Update Pagination bullets/items
        const swiper = this;
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (
          !params.el ||
          !swiper.pagination.el ||
          !swiper.pagination.$el ||
          swiper.pagination.$el.length === 0
        )
          return;
        const slidesLength =
          swiper.virtual && swiper.params.virtual.enabled
            ? swiper.virtual.slides.length
            : swiper.slides.length;
        const $el = swiper.pagination.$el;
        // Current/Total
        let current;
        const total = swiper.params.loop
          ? Math.ceil(
              (slidesLength - swiper.loopedSlides * 2) /
                swiper.params.slidesPerGroup
            )
          : swiper.snapGrid.length;
        if (swiper.params.loop) {
          current = Math.ceil(
            (swiper.activeIndex - swiper.loopedSlides) /
              swiper.params.slidesPerGroup
          );
          if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
            current -= slidesLength - swiper.loopedSlides * 2;
          }
          if (current > total - 1) current -= total;
          if (current < 0 && swiper.params.paginationType !== "bullets")
            current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") {
          current = swiper.snapIndex;
        } else {
          current = swiper.activeIndex || 0;
        }
        // Types
        if (
          params.type === "bullets" &&
          swiper.pagination.bullets &&
          swiper.pagination.bullets.length > 0
        ) {
          const bullets = swiper.pagination.bullets;
          let firstIndex;
          let lastIndex;
          let midIndex;
          if (params.dynamicBullets) {
            swiper.pagination.bulletSize = bullets
              .eq(0)
              [swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
            $el.css(
              swiper.isHorizontal() ? "width" : "height",
              `${
                swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)
              }px`
            );
            if (
              params.dynamicMainBullets > 1 &&
              swiper.previousIndex !== undefined
            ) {
              swiper.pagination.dynamicBulletIndex +=
                current - swiper.previousIndex;
              if (
                swiper.pagination.dynamicBulletIndex >
                params.dynamicMainBullets - 1
              ) {
                swiper.pagination.dynamicBulletIndex =
                  params.dynamicMainBullets - 1;
              } else if (swiper.pagination.dynamicBulletIndex < 0) {
                swiper.pagination.dynamicBulletIndex = 0;
              }
            }
            firstIndex = current - swiper.pagination.dynamicBulletIndex;
            lastIndex =
              firstIndex +
              (Math.min(bullets.length, params.dynamicMainBullets) - 1);
            midIndex = (lastIndex + firstIndex) / 2;
          }
          bullets.removeClass(
            `${params.bulletActiveClass} ${params.bulletActiveClass}-next ${params.bulletActiveClass}-next-next ${params.bulletActiveClass}-prev ${params.bulletActiveClass}-prev-prev ${params.bulletActiveClass}-main`
          );
          if ($el.length > 1) {
            bullets.each((index, bullet) => {
              const $bullet = dom7_modular_$(bullet);
              const bulletIndex = $bullet.index();
              if (bulletIndex === current) {
                $bullet.addClass(params.bulletActiveClass);
              }
              if (params.dynamicBullets) {
                if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                  $bullet.addClass(`${params.bulletActiveClass}-main`);
                }
                if (bulletIndex === firstIndex) {
                  $bullet
                    .prev()
                    .addClass(`${params.bulletActiveClass}-prev`)
                    .prev()
                    .addClass(`${params.bulletActiveClass}-prev-prev`);
                }
                if (bulletIndex === lastIndex) {
                  $bullet
                    .next()
                    .addClass(`${params.bulletActiveClass}-next`)
                    .next()
                    .addClass(`${params.bulletActiveClass}-next-next`);
                }
              }
            });
          } else {
            const $bullet = bullets.eq(current);
            const bulletIndex = $bullet.index();
            $bullet.addClass(params.bulletActiveClass);
            if (params.dynamicBullets) {
              const $firstDisplayedBullet = bullets.eq(firstIndex);
              const $lastDisplayedBullet = bullets.eq(lastIndex);
              for (let i = firstIndex; i <= lastIndex; i += 1) {
                bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
              }
              if (swiper.params.loop) {
                if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                  for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                    bullets
                      .eq(bullets.length - i)
                      .addClass(`${params.bulletActiveClass}-main`);
                  }
                  bullets
                    .eq(bullets.length - params.dynamicMainBullets - 1)
                    .addClass(`${params.bulletActiveClass}-prev`);
                } else {
                  $firstDisplayedBullet
                    .prev()
                    .addClass(`${params.bulletActiveClass}-prev`)
                    .prev()
                    .addClass(`${params.bulletActiveClass}-prev-prev`);
                  $lastDisplayedBullet
                    .next()
                    .addClass(`${params.bulletActiveClass}-next`)
                    .next()
                    .addClass(`${params.bulletActiveClass}-next-next`);
                }
              } else {
                $firstDisplayedBullet
                  .prev()
                  .addClass(`${params.bulletActiveClass}-prev`)
                  .prev()
                  .addClass(`${params.bulletActiveClass}-prev-prev`);
                $lastDisplayedBullet
                  .next()
                  .addClass(`${params.bulletActiveClass}-next`)
                  .next()
                  .addClass(`${params.bulletActiveClass}-next-next`);
              }
            }
          }
          if (params.dynamicBullets) {
            const dynamicBulletsLength = Math.min(
              bullets.length,
              params.dynamicMainBullets + 4
            );
            const bulletsOffset =
              (swiper.pagination.bulletSize * dynamicBulletsLength -
                swiper.pagination.bulletSize) /
                2 -
              midIndex * swiper.pagination.bulletSize;
            const offsetProp = rtl ? "right" : "left";
            bullets.css(
              swiper.isHorizontal() ? offsetProp : "top",
              `${bulletsOffset}px`
            );
          }
        }
        if (params.type === "fraction") {
          $el
            .find(`.${params.currentClass}`)
            .text(params.formatFractionCurrent(current + 1));
          $el
            .find(`.${params.totalClass}`)
            .text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
          let progressbarDirection;
          if (params.progressbarOpposite) {
            progressbarDirection = swiper.isHorizontal()
              ? "vertical"
              : "horizontal";
          } else {
            progressbarDirection = swiper.isHorizontal()
              ? "horizontal"
              : "vertical";
          }
          const scale = (current + 1) / total;
          let scaleX = 1;
          let scaleY = 1;
          if (progressbarDirection === "horizontal") {
            scaleX = scale;
          } else {
            scaleY = scale;
          }
          $el
            .find(`.${params.progressbarFillClass}`)
            .transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`)
            .transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
          $el.html(params.renderCustom(swiper, current + 1, total));
          swiper.emit("paginationRender", swiper, $el[0]);
        } else {
          swiper.emit("paginationUpdate", swiper, $el[0]);
        }
        $el[
          swiper.params.watchOverflow && swiper.isLocked
            ? "addClass"
            : "removeClass"
        ](params.lockClass);
      },
      render() {
        // Render Container
        const swiper = this;
        const params = swiper.params.pagination;
        if (
          !params.el ||
          !swiper.pagination.el ||
          !swiper.pagination.$el ||
          swiper.pagination.$el.length === 0
        )
          return;
        const slidesLength =
          swiper.virtual && swiper.params.virtual.enabled
            ? swiper.virtual.slides.length
            : swiper.slides.length;

        const $el = swiper.pagination.$el;
        let paginationHTML = "";
        if (params.type === "bullets") {
          const numberOfBullets = swiper.params.loop
            ? Math.ceil(
                (slidesLength - swiper.loopedSlides * 2) /
                  swiper.params.slidesPerGroup
              )
            : swiper.snapGrid.length;
          for (let i = 0; i < numberOfBullets; i += 1) {
            if (params.renderBullet) {
              paginationHTML += params.renderBullet.call(
                swiper,
                i,
                params.bulletClass
              );
            } else {
              paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            }
          }
          $el.html(paginationHTML);
          swiper.pagination.bullets = $el.find(`.${params.bulletClass}`);
        }
        if (params.type === "fraction") {
          if (params.renderFraction) {
            paginationHTML = params.renderFraction.call(
              swiper,
              params.currentClass,
              params.totalClass
            );
          } else {
            paginationHTML =
              `<span class="${params.currentClass}"></span>` +
              " / " +
              `<span class="${params.totalClass}"></span>`;
          }
          $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
          if (params.renderProgressbar) {
            paginationHTML = params.renderProgressbar.call(
              swiper,
              params.progressbarFillClass
            );
          } else {
            paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
          }
          $el.html(paginationHTML);
        }
        if (params.type !== "custom") {
          swiper.emit("paginationRender", swiper.pagination.$el[0]);
        }
      },
      init() {
        const swiper = this;
        const params = swiper.params.pagination;
        if (!params.el) return;

        let $el = dom7_modular_$(params.el);
        if ($el.length === 0) return;

        if (
          swiper.params.uniqueNavElements &&
          typeof params.el === "string" &&
          $el.length > 1
        ) {
          $el = swiper.$el.find(params.el);
        }

        if (params.type === "bullets" && params.clickable) {
          $el.addClass(params.clickableClass);
        }

        $el.addClass(params.modifierClass + params.type);

        if (params.type === "bullets" && params.dynamicBullets) {
          $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
          swiper.pagination.dynamicBulletIndex = 0;
          if (params.dynamicMainBullets < 1) {
            params.dynamicMainBullets = 1;
          }
        }
        if (params.type === "progressbar" && params.progressbarOpposite) {
          $el.addClass(params.progressbarOppositeClass);
        }

        if (params.clickable) {
          $el.on("click", `.${params.bulletClass}`, function onClick(e) {
            e.preventDefault();
            let index =
              dom7_modular_$(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
          });
        }

        Utils.extend(swiper.pagination, {
          $el,
          el: $el[0],
        });
      },
      destroy() {
        const swiper = this;
        const params = swiper.params.pagination;
        if (
          !params.el ||
          !swiper.pagination.el ||
          !swiper.pagination.$el ||
          swiper.pagination.$el.length === 0
        )
          return;
        const $el = swiper.pagination.$el;

        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        if (swiper.pagination.bullets)
          swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) {
          $el.off("click", `.${params.bulletClass}`);
        }
      },
    };

    var Pagination$1 = {
      name: "pagination",
      params: {
        pagination: {
          el: null,
          bulletElement: "span",
          clickable: false,
          hideOnClick: false,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: false,
          type: "bullets", // 'bullets' or 'progressbar' or 'fraction' or 'custom'
          dynamicBullets: false,
          dynamicMainBullets: 1,
          formatFractionCurrent: (number) => number,
          formatFractionTotal: (number) => number,
          bulletClass: "swiper-pagination-bullet",
          bulletActiveClass: "swiper-pagination-bullet-active",
          modifierClass: "swiper-pagination-", // NEW
          currentClass: "swiper-pagination-current",
          totalClass: "swiper-pagination-total",
          hiddenClass: "swiper-pagination-hidden",
          progressbarFillClass: "swiper-pagination-progressbar-fill",
          progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
          clickableClass: "swiper-pagination-clickable", // NEW
          lockClass: "swiper-pagination-lock",
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          pagination: {
            init: Pagination.init.bind(swiper),
            render: Pagination.render.bind(swiper),
            update: Pagination.update.bind(swiper),
            destroy: Pagination.destroy.bind(swiper),
            dynamicBulletIndex: 0,
          },
        });
      },
      on: {
        init() {
          const swiper = this;
          swiper.pagination.init();
          swiper.pagination.render();
          swiper.pagination.update();
        },
        activeIndexChange() {
          const swiper = this;
          if (swiper.params.loop) {
            swiper.pagination.update();
          } else if (typeof swiper.snapIndex === "undefined") {
            swiper.pagination.update();
          }
        },
        snapIndexChange() {
          const swiper = this;
          if (!swiper.params.loop) {
            swiper.pagination.update();
          }
        },
        slidesLengthChange() {
          const swiper = this;
          if (swiper.params.loop) {
            swiper.pagination.render();
            swiper.pagination.update();
          }
        },
        snapGridLengthChange() {
          const swiper = this;
          if (!swiper.params.loop) {
            swiper.pagination.render();
            swiper.pagination.update();
          }
        },
        destroy() {
          const swiper = this;
          swiper.pagination.destroy();
        },
        click(e) {
          const swiper = this;
          if (
            swiper.params.pagination.el &&
            swiper.params.pagination.hideOnClick &&
            swiper.pagination.$el.length > 0 &&
            !dom7_modular_$(e.target).hasClass(
              swiper.params.pagination.bulletClass
            )
          ) {
            const isHidden = swiper.pagination.$el.hasClass(
              swiper.params.pagination.hiddenClass
            );
            if (isHidden === true) {
              swiper.emit("paginationShow", swiper);
            } else {
              swiper.emit("paginationHide", swiper);
            }
            swiper.pagination.$el.toggleClass(
              swiper.params.pagination.hiddenClass
            );
          }
        },
      },
    };

    const Scrollbar = {
      setTranslate() {
        const swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar, rtlTranslate: rtl, progress } = swiper;
        const { dragSize, trackSize, $dragEl, $el } = scrollbar;
        const params = swiper.params.scrollbar;

        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
          newPos = -newPos;
          if (newPos > 0) {
            newSize = dragSize - newPos;
            newPos = 0;
          } else if (-newPos + dragSize > trackSize) {
            newSize = trackSize + newPos;
          }
        } else if (newPos < 0) {
          newSize = dragSize + newPos;
          newPos = 0;
        } else if (newPos + dragSize > trackSize) {
          newSize = trackSize - newPos;
        }
        if (swiper.isHorizontal()) {
          $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
          $dragEl[0].style.width = `${newSize}px`;
        } else {
          $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
          $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
          clearTimeout(swiper.scrollbar.timeout);
          $el[0].style.opacity = 1;
          swiper.scrollbar.timeout = setTimeout(() => {
            $el[0].style.opacity = 0;
            $el.transition(400);
          }, 1000);
        }
      },
      setTransition(duration) {
        const swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
      },
      updateSize() {
        const swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;

        const { scrollbar } = swiper;
        const { $dragEl, $el } = scrollbar;

        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        const trackSize = swiper.isHorizontal()
          ? $el[0].offsetWidth
          : $el[0].offsetHeight;

        const divider = swiper.size / swiper.virtualSize;
        const moveDivider = divider * (trackSize / swiper.size);
        let dragSize;
        if (swiper.params.scrollbar.dragSize === "auto") {
          dragSize = trackSize * divider;
        } else {
          dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        }

        if (swiper.isHorizontal()) {
          $dragEl[0].style.width = `${dragSize}px`;
        } else {
          $dragEl[0].style.height = `${dragSize}px`;
        }

        if (divider >= 1) {
          $el[0].style.display = "none";
        } else {
          $el[0].style.display = "";
        }
        if (swiper.params.scrollbar.hide) {
          $el[0].style.opacity = 0;
        }
        Utils.extend(scrollbar, {
          trackSize,
          divider,
          moveDivider,
          dragSize,
        });
        scrollbar.$el[
          swiper.params.watchOverflow && swiper.isLocked
            ? "addClass"
            : "removeClass"
        ](swiper.params.scrollbar.lockClass);
      },
      getPointerPosition(e) {
        const swiper = this;
        if (swiper.isHorizontal()) {
          return e.type === "touchstart" || e.type === "touchmove"
            ? e.targetTouches[0].clientX
            : e.clientX;
        }
        return e.type === "touchstart" || e.type === "touchmove"
          ? e.targetTouches[0].clientY
          : e.clientY;
      },
      setDragPosition(e) {
        const swiper = this;
        const { scrollbar, rtlTranslate: rtl } = swiper;
        const { $el, dragSize, trackSize, dragStartPos } = scrollbar;

        let positionRatio;
        positionRatio =
          (scrollbar.getPointerPosition(e) -
            $el.offset()[swiper.isHorizontal() ? "left" : "top"] -
            (dragStartPos !== null ? dragStartPos : dragSize / 2)) /
          (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) {
          positionRatio = 1 - positionRatio;
        }

        const position =
          swiper.minTranslate() +
          (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;

        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      },
      onDragStart(e) {
        const swiper = this;
        const params = swiper.params.scrollbar;
        const { scrollbar, $wrapperEl } = swiper;
        const { $el, $dragEl } = scrollbar;
        swiper.scrollbar.isTouched = true;
        swiper.scrollbar.dragStartPos =
          e.target === $dragEl[0] || e.target === $dragEl
            ? scrollbar.getPointerPosition(e) -
              e.target.getBoundingClientRect()[
                swiper.isHorizontal() ? "left" : "top"
              ]
            : null;
        e.preventDefault();
        e.stopPropagation();

        $wrapperEl.transition(100);
        $dragEl.transition(100);
        scrollbar.setDragPosition(e);

        clearTimeout(swiper.scrollbar.dragTimeout);

        $el.transition(0);
        if (params.hide) {
          $el.css("opacity", 1);
        }
        if (swiper.params.cssMode) {
          swiper.$wrapperEl.css("scroll-snap-type", "none");
        }
        swiper.emit("scrollbarDragStart", e);
      },
      onDragMove(e) {
        const swiper = this;
        const { scrollbar, $wrapperEl } = swiper;
        const { $el, $dragEl } = scrollbar;

        if (!swiper.scrollbar.isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        scrollbar.setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        swiper.emit("scrollbarDragMove", e);
      },
      onDragEnd(e) {
        const swiper = this;

        const params = swiper.params.scrollbar;
        const { scrollbar, $wrapperEl } = swiper;
        const { $el } = scrollbar;

        if (!swiper.scrollbar.isTouched) return;
        swiper.scrollbar.isTouched = false;
        if (swiper.params.cssMode) {
          swiper.$wrapperEl.css("scroll-snap-type", "");
          $wrapperEl.transition("");
        }
        if (params.hide) {
          clearTimeout(swiper.scrollbar.dragTimeout);
          swiper.scrollbar.dragTimeout = Utils.nextTick(() => {
            $el.css("opacity", 0);
            $el.transition(400);
          }, 1000);
        }
        swiper.emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) {
          swiper.slideToClosest();
        }
      },
      enableDraggable() {
        const swiper = this;
        if (!swiper.params.scrollbar.el) return;
        const { scrollbar, touchEventsTouch, touchEventsDesktop, params } =
          swiper;
        const $el = scrollbar.$el;
        const target = $el[0];
        const activeListener =
          Support.passiveListener && params.passiveListeners
            ? { passive: false, capture: false }
            : false;
        const passiveListener =
          Support.passiveListener && params.passiveListeners
            ? { passive: true, capture: false }
            : false;
        if (!Support.touch) {
          target.addEventListener(
            touchEventsDesktop.start,
            swiper.scrollbar.onDragStart,
            activeListener
          );
          doc.addEventListener(
            touchEventsDesktop.move,
            swiper.scrollbar.onDragMove,
            activeListener
          );
          doc.addEventListener(
            touchEventsDesktop.end,
            swiper.scrollbar.onDragEnd,
            passiveListener
          );
        } else {
          target.addEventListener(
            touchEventsTouch.start,
            swiper.scrollbar.onDragStart,
            activeListener
          );
          target.addEventListener(
            touchEventsTouch.move,
            swiper.scrollbar.onDragMove,
            activeListener
          );
          target.addEventListener(
            touchEventsTouch.end,
            swiper.scrollbar.onDragEnd,
            passiveListener
          );
        }
      },
      disableDraggable() {
        const swiper = this;
        if (!swiper.params.scrollbar.el) return;
        const { scrollbar, touchEventsTouch, touchEventsDesktop, params } =
          swiper;
        const $el = scrollbar.$el;
        const target = $el[0];
        const activeListener =
          Support.passiveListener && params.passiveListeners
            ? { passive: false, capture: false }
            : false;
        const passiveListener =
          Support.passiveListener && params.passiveListeners
            ? { passive: true, capture: false }
            : false;
        if (!Support.touch) {
          target.removeEventListener(
            touchEventsDesktop.start,
            swiper.scrollbar.onDragStart,
            activeListener
          );
          doc.removeEventListener(
            touchEventsDesktop.move,
            swiper.scrollbar.onDragMove,
            activeListener
          );
          doc.removeEventListener(
            touchEventsDesktop.end,
            swiper.scrollbar.onDragEnd,
            passiveListener
          );
        } else {
          target.removeEventListener(
            touchEventsTouch.start,
            swiper.scrollbar.onDragStart,
            activeListener
          );
          target.removeEventListener(
            touchEventsTouch.move,
            swiper.scrollbar.onDragMove,
            activeListener
          );
          target.removeEventListener(
            touchEventsTouch.end,
            swiper.scrollbar.onDragEnd,
            passiveListener
          );
        }
      },
      init() {
        const swiper = this;
        if (!swiper.params.scrollbar.el) return;
        const { scrollbar, $el: $swiperEl } = swiper;
        const params = swiper.params.scrollbar;

        let $el = dom7_modular_$(params.el);
        if (
          swiper.params.uniqueNavElements &&
          typeof params.el === "string" &&
          $el.length > 1 &&
          $swiperEl.find(params.el).length === 1
        ) {
          $el = $swiperEl.find(params.el);
        }

        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
          $dragEl = dom7_modular_$(
            `<div class="${swiper.params.scrollbar.dragClass}"></div>`
          );
          $el.append($dragEl);
        }

        Utils.extend(scrollbar, {
          $el,
          el: $el[0],
          $dragEl,
          dragEl: $dragEl[0],
        });

        if (params.draggable) {
          scrollbar.enableDraggable();
        }
      },
      destroy() {
        const swiper = this;
        swiper.scrollbar.disableDraggable();
      },
    };

    var Scrollbar$1 = {
      name: "scrollbar",
      params: {
        scrollbar: {
          el: null,
          dragSize: "auto",
          hide: false,
          draggable: false,
          snapOnRelease: true,
          lockClass: "swiper-scrollbar-lock",
          dragClass: "swiper-scrollbar-drag",
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          scrollbar: {
            init: Scrollbar.init.bind(swiper),
            destroy: Scrollbar.destroy.bind(swiper),
            updateSize: Scrollbar.updateSize.bind(swiper),
            setTranslate: Scrollbar.setTranslate.bind(swiper),
            setTransition: Scrollbar.setTransition.bind(swiper),
            enableDraggable: Scrollbar.enableDraggable.bind(swiper),
            disableDraggable: Scrollbar.disableDraggable.bind(swiper),
            setDragPosition: Scrollbar.setDragPosition.bind(swiper),
            getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
            onDragStart: Scrollbar.onDragStart.bind(swiper),
            onDragMove: Scrollbar.onDragMove.bind(swiper),
            onDragEnd: Scrollbar.onDragEnd.bind(swiper),
            isTouched: false,
            timeout: null,
            dragTimeout: null,
          },
        });
      },
      on: {
        init() {
          const swiper = this;
          swiper.scrollbar.init();
          swiper.scrollbar.updateSize();
          swiper.scrollbar.setTranslate();
        },
        update() {
          const swiper = this;
          swiper.scrollbar.updateSize();
        },
        resize() {
          const swiper = this;
          swiper.scrollbar.updateSize();
        },
        observerUpdate() {
          const swiper = this;
          swiper.scrollbar.updateSize();
        },
        setTranslate() {
          const swiper = this;
          swiper.scrollbar.setTranslate();
        },
        setTransition(duration) {
          const swiper = this;
          swiper.scrollbar.setTransition(duration);
        },
        destroy() {
          const swiper = this;
          swiper.scrollbar.destroy();
        },
      },
    };

    const Parallax = {
      setTransform(el, progress) {
        const swiper = this;
        const { rtl } = swiper;

        const $el = dom7_modular_$(el);
        const rtlFactor = rtl ? -1 : 1;

        const p = $el.attr("data-swiper-parallax") || "0";
        let x = $el.attr("data-swiper-parallax-x");
        let y = $el.attr("data-swiper-parallax-y");
        const scale = $el.attr("data-swiper-parallax-scale");
        const opacity = $el.attr("data-swiper-parallax-opacity");

        if (x || y) {
          x = x || "0";
          y = y || "0";
        } else if (swiper.isHorizontal()) {
          x = p;
          y = "0";
        } else {
          y = p;
          x = "0";
        }

        if (x.indexOf("%") >= 0) {
          x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        } else {
          x = `${x * progress * rtlFactor}px`;
        }
        if (y.indexOf("%") >= 0) {
          y = `${parseInt(y, 10) * progress}%`;
        } else {
          y = `${y * progress}px`;
        }

        if (typeof opacity !== "undefined" && opacity !== null) {
          const currentOpacity =
            opacity - (opacity - 1) * (1 - Math.abs(progress));
          $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) {
          $el.transform(`translate3d(${x}, ${y}, 0px)`);
        } else {
          const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
          $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
      },
      setTranslate() {
        const swiper = this;
        const { $el, slides, progress, snapGrid } = swiper;
        $el
          .children(
            "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
          )
          .each((index, el) => {
            swiper.parallax.setTransform(el, progress);
          });
        slides.each((slideIndex, slideEl) => {
          let slideProgress = slideEl.progress;
          if (
            swiper.params.slidesPerGroup > 1 &&
            swiper.params.slidesPerView !== "auto"
          ) {
            slideProgress +=
              Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
          }
          slideProgress = Math.min(Math.max(slideProgress, -1), 1);
          dom7_modular_$(slideEl)
            .find(
              "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
            )
            .each((index, el) => {
              swiper.parallax.setTransform(el, slideProgress);
            });
        });
      },
      setTransition(duration = this.params.speed) {
        const swiper = this;
        const { $el } = swiper;
        $el
          .find(
            "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
          )
          .each((index, parallaxEl) => {
            const $parallaxEl = dom7_modular_$(parallaxEl);
            let parallaxDuration =
              parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) ||
              duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
          });
      },
    };

    var Parallax$1 = {
      name: "parallax",
      params: {
        parallax: {
          enabled: false,
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          parallax: {
            setTransform: Parallax.setTransform.bind(swiper),
            setTranslate: Parallax.setTranslate.bind(swiper),
            setTransition: Parallax.setTransition.bind(swiper),
          },
        });
      },
      on: {
        beforeInit() {
          const swiper = this;
          if (!swiper.params.parallax.enabled) return;
          swiper.params.watchSlidesProgress = true;
          swiper.originalParams.watchSlidesProgress = true;
        },
        init() {
          const swiper = this;
          if (!swiper.params.parallax.enabled) return;
          swiper.parallax.setTranslate();
        },
        setTranslate() {
          const swiper = this;
          if (!swiper.params.parallax.enabled) return;
          swiper.parallax.setTranslate();
        },
        setTransition(duration) {
          const swiper = this;
          if (!swiper.params.parallax.enabled) return;
          swiper.parallax.setTransition(duration);
        },
      },
    };

    const Zoom = {
      // Calc Scale From Multi-touches
      getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
      },
      // Events
      onGestureStart(e) {
        const swiper = this;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const { gesture } = zoom;
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
        if (!Support.gestures) {
          if (
            e.type !== "touchstart" ||
            (e.type === "touchstart" && e.targetTouches.length < 2)
          ) {
            return;
          }
          zoom.fakeGestureTouched = true;
          gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
          gesture.$slideEl = dom7_modular_$(e.target).closest(
            `.${swiper.params.slideClass}`
          );
          if (gesture.$slideEl.length === 0)
            gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
          gesture.$imageEl = gesture.$slideEl.find(
            "img, svg, canvas, picture, .swiper-zoom-target"
          );
          gesture.$imageWrapEl = gesture.$imageEl.parent(
            `.${params.containerClass}`
          );
          gesture.maxRatio =
            gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
          if (gesture.$imageWrapEl.length === 0) {
            gesture.$imageEl = undefined;
            return;
          }
        }
        if (gesture.$imageEl) {
          gesture.$imageEl.transition(0);
        }
        swiper.zoom.isScaling = true;
      },
      onGestureChange(e) {
        const swiper = this;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const { gesture } = zoom;
        if (!Support.gestures) {
          if (
            e.type !== "touchmove" ||
            (e.type === "touchmove" && e.targetTouches.length < 2)
          ) {
            return;
          }
          zoom.fakeGestureMoved = true;
          gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (Support.gestures) {
          zoom.scale = e.scale * zoom.currentScale;
        } else {
          zoom.scale =
            (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
        }
        if (zoom.scale > gesture.maxRatio) {
          zoom.scale =
            gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        }
        if (zoom.scale < params.minRatio) {
          zoom.scale =
            params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        }
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
      },
      onGestureEnd(e) {
        const swiper = this;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const { gesture } = zoom;
        if (!Support.gestures) {
          if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
            return;
          }
          if (
            e.type !== "touchend" ||
            (e.type === "touchend" &&
              e.changedTouches.length < 2 &&
              !Device.android)
          ) {
            return;
          }
          zoom.fakeGestureTouched = false;
          zoom.fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(
          Math.min(zoom.scale, gesture.maxRatio),
          params.minRatio
        );
        gesture.$imageEl
          .transition(swiper.params.speed)
          .transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        zoom.currentScale = zoom.scale;
        zoom.isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
      },
      onTouchStart(e) {
        const swiper = this;
        const zoom = swiper.zoom;
        const { gesture, image } = zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (Device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x =
          e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y =
          e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
      },
      onTouchMove(e) {
        const swiper = this;
        const zoom = swiper.zoom;
        const { gesture, image, velocity } = zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;

        if (!image.isMoved) {
          image.width = gesture.$imageEl[0].offsetWidth;
          image.height = gesture.$imageEl[0].offsetHeight;
          image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], "x") || 0;
          image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], "y") || 0;
          gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
          gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
          gesture.$imageWrapEl.transition(0);
          if (swiper.rtl) {
            image.startX = -image.startX;
            image.startY = -image.startY;
          }
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;

        if (
          scaledWidth < gesture.slideWidth &&
          scaledHeight < gesture.slideHeight
        )
          return;

        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;

        image.touchesCurrent.x =
          e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y =
          e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;

        if (!image.isMoved && !zoom.isScaling) {
          if (
            swiper.isHorizontal() &&
            ((Math.floor(image.minX) === Math.floor(image.startX) &&
              image.touchesCurrent.x < image.touchesStart.x) ||
              (Math.floor(image.maxX) === Math.floor(image.startX) &&
                image.touchesCurrent.x > image.touchesStart.x))
          ) {
            image.isTouched = false;
            return;
          }
          if (
            !swiper.isHorizontal() &&
            ((Math.floor(image.minY) === Math.floor(image.startY) &&
              image.touchesCurrent.y < image.touchesStart.y) ||
              (Math.floor(image.maxY) === Math.floor(image.startY) &&
                image.touchesCurrent.y > image.touchesStart.y))
          ) {
            image.isTouched = false;
            return;
          }
        }
        if (e.cancelable) {
          e.preventDefault();
        }
        e.stopPropagation();

        image.isMoved = true;
        image.currentX =
          image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY =
          image.touchesCurrent.y - image.touchesStart.y + image.startY;

        if (image.currentX < image.minX) {
          image.currentX =
            image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        }
        if (image.currentX > image.maxX) {
          image.currentX =
            image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        }

        if (image.currentY < image.minY) {
          image.currentY =
            image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        }
        if (image.currentY > image.maxY) {
          image.currentY =
            image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        }

        // Velocity
        if (!velocity.prevPositionX)
          velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY)
          velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x =
          (image.touchesCurrent.x - velocity.prevPositionX) /
          (Date.now() - velocity.prevTime) /
          2;
        velocity.y =
          (image.touchesCurrent.y - velocity.prevPositionY) /
          (Date.now() - velocity.prevTime) /
          2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2)
          velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2)
          velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();

        gesture.$imageWrapEl.transform(
          `translate3d(${image.currentX}px, ${image.currentY}px,0)`
        );
      },
      onTouchEnd() {
        const swiper = this;
        const zoom = swiper.zoom;
        const { gesture, image, velocity } = zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
          image.isTouched = false;
          image.isMoved = false;
          return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;

        // Fix duration
        if (velocity.x !== 0)
          momentumDurationX = Math.abs(
            (newPositionX - image.currentX) / velocity.x
          );
        if (velocity.y !== 0)
          momentumDurationY = Math.abs(
            (newPositionY - image.currentY) / velocity.y
          );
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);

        image.currentX = newPositionX;
        image.currentY = newPositionY;

        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(
          Math.min(image.currentX, image.maxX),
          image.minX
        );
        image.currentY = Math.max(
          Math.min(image.currentY, image.maxY),
          image.minY
        );

        gesture.$imageWrapEl
          .transition(momentumDuration)
          .transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
      },
      onTransitionEnd() {
        const swiper = this;
        const zoom = swiper.zoom;
        const { gesture } = zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
          if (gesture.$imageEl) {
            gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
          }
          if (gesture.$imageWrapEl) {
            gesture.$imageWrapEl.transform("translate3d(0,0,0)");
          }

          zoom.scale = 1;
          zoom.currentScale = 1;

          gesture.$slideEl = undefined;
          gesture.$imageEl = undefined;
          gesture.$imageWrapEl = undefined;
        }
      },
      // Toggle Zoom
      toggle(e) {
        const swiper = this;
        const zoom = swiper.zoom;

        if (zoom.scale && zoom.scale !== 1) {
          // Zoom Out
          zoom.out();
        } else {
          // Zoom In
          zoom.in(e);
        }
      },
      in(e) {
        const swiper = this;

        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        const { gesture, image } = zoom;

        if (!gesture.$slideEl) {
          if (
            swiper.params.virtual &&
            swiper.params.virtual.enabled &&
            swiper.virtual
          ) {
            gesture.$slideEl = swiper.$wrapperEl.children(
              `.${swiper.params.slideActiveClass}`
            );
          } else {
            gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
          }
          gesture.$imageEl = gesture.$slideEl.find(
            "img, svg, canvas, picture, .swiper-zoom-target"
          );
          gesture.$imageWrapEl = gesture.$imageEl.parent(
            `.${params.containerClass}`
          );
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);

        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;

        if (typeof image.touchesStart.x === "undefined" && e) {
          touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
          touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
          touchX = image.touchesStart.x;
          touchY = image.touchesStart.y;
        }

        zoom.scale =
          gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        zoom.currentScale =
          gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
          slideWidth = gesture.$slideEl[0].offsetWidth;
          slideHeight = gesture.$slideEl[0].offsetHeight;
          offsetX = gesture.$slideEl.offset().left;
          offsetY = gesture.$slideEl.offset().top;
          diffX = offsetX + slideWidth / 2 - touchX;
          diffY = offsetY + slideHeight / 2 - touchY;

          imageWidth = gesture.$imageEl[0].offsetWidth;
          imageHeight = gesture.$imageEl[0].offsetHeight;
          scaledWidth = imageWidth * zoom.scale;
          scaledHeight = imageHeight * zoom.scale;

          translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
          translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
          translateMaxX = -translateMinX;
          translateMaxY = -translateMinY;

          translateX = diffX * zoom.scale;
          translateY = diffY * zoom.scale;

          if (translateX < translateMinX) {
            translateX = translateMinX;
          }
          if (translateX > translateMaxX) {
            translateX = translateMaxX;
          }

          if (translateY < translateMinY) {
            translateY = translateMinY;
          }
          if (translateY > translateMaxY) {
            translateY = translateMaxY;
          }
        } else {
          translateX = 0;
          translateY = 0;
        }
        gesture.$imageWrapEl
          .transition(300)
          .transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl
          .transition(300)
          .transform(`translate3d(0,0,0) scale(${zoom.scale})`);
      },
      out() {
        const swiper = this;

        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        const { gesture } = zoom;

        if (!gesture.$slideEl) {
          if (
            swiper.params.virtual &&
            swiper.params.virtual.enabled &&
            swiper.virtual
          ) {
            gesture.$slideEl = swiper.$wrapperEl.children(
              `.${swiper.params.slideActiveClass}`
            );
          } else {
            gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
          }
          gesture.$imageEl = gesture.$slideEl.find(
            "img, svg, canvas, picture, .swiper-zoom-target"
          );
          gesture.$imageWrapEl = gesture.$imageEl.parent(
            `.${params.containerClass}`
          );
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

        zoom.scale = 1;
        zoom.currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl
          .transition(300)
          .transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
      },
      // Attach/Detach Events
      enable() {
        const swiper = this;
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;

        const passiveListener =
          swiper.touchEvents.start === "touchstart" &&
          Support.passiveListener &&
          swiper.params.passiveListeners
            ? { passive: true, capture: false }
            : false;
        const activeListenerWithCapture = Support.passiveListener
          ? { passive: false, capture: true }
          : true;

        const slideSelector = `.${swiper.params.slideClass}`;

        // Scale image
        if (Support.gestures) {
          swiper.$wrapperEl.on(
            "gesturestart",
            slideSelector,
            zoom.onGestureStart,
            passiveListener
          );
          swiper.$wrapperEl.on(
            "gesturechange",
            slideSelector,
            zoom.onGestureChange,
            passiveListener
          );
          swiper.$wrapperEl.on(
            "gestureend",
            slideSelector,
            zoom.onGestureEnd,
            passiveListener
          );
        } else if (swiper.touchEvents.start === "touchstart") {
          swiper.$wrapperEl.on(
            swiper.touchEvents.start,
            slideSelector,
            zoom.onGestureStart,
            passiveListener
          );
          swiper.$wrapperEl.on(
            swiper.touchEvents.move,
            slideSelector,
            zoom.onGestureChange,
            activeListenerWithCapture
          );
          swiper.$wrapperEl.on(
            swiper.touchEvents.end,
            slideSelector,
            zoom.onGestureEnd,
            passiveListener
          );
          if (swiper.touchEvents.cancel) {
            swiper.$wrapperEl.on(
              swiper.touchEvents.cancel,
              slideSelector,
              zoom.onGestureEnd,
              passiveListener
            );
          }
        }

        // Move image
        swiper.$wrapperEl.on(
          swiper.touchEvents.move,
          `.${swiper.params.zoom.containerClass}`,
          zoom.onTouchMove,
          activeListenerWithCapture
        );
      },
      disable() {
        const swiper = this;
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;

        swiper.zoom.enabled = false;

        const passiveListener =
          swiper.touchEvents.start === "touchstart" &&
          Support.passiveListener &&
          swiper.params.passiveListeners
            ? { passive: true, capture: false }
            : false;
        const activeListenerWithCapture = Support.passiveListener
          ? { passive: false, capture: true }
          : true;

        const slideSelector = `.${swiper.params.slideClass}`;

        // Scale image
        if (Support.gestures) {
          swiper.$wrapperEl.off(
            "gesturestart",
            slideSelector,
            zoom.onGestureStart,
            passiveListener
          );
          swiper.$wrapperEl.off(
            "gesturechange",
            slideSelector,
            zoom.onGestureChange,
            passiveListener
          );
          swiper.$wrapperEl.off(
            "gestureend",
            slideSelector,
            zoom.onGestureEnd,
            passiveListener
          );
        } else if (swiper.touchEvents.start === "touchstart") {
          swiper.$wrapperEl.off(
            swiper.touchEvents.start,
            slideSelector,
            zoom.onGestureStart,
            passiveListener
          );
          swiper.$wrapperEl.off(
            swiper.touchEvents.move,
            slideSelector,
            zoom.onGestureChange,
            activeListenerWithCapture
          );
          swiper.$wrapperEl.off(
            swiper.touchEvents.end,
            slideSelector,
            zoom.onGestureEnd,
            passiveListener
          );
          if (swiper.touchEvents.cancel) {
            swiper.$wrapperEl.off(
              swiper.touchEvents.cancel,
              slideSelector,
              zoom.onGestureEnd,
              passiveListener
            );
          }
        }

        // Move image
        swiper.$wrapperEl.off(
          swiper.touchEvents.move,
          `.${swiper.params.zoom.containerClass}`,
          zoom.onTouchMove,
          activeListenerWithCapture
        );
      },
    };

    var Zoom$1 = {
      name: "zoom",
      params: {
        zoom: {
          enabled: false,
          maxRatio: 3,
          minRatio: 1,
          toggle: true,
          containerClass: "swiper-zoom-container",
          zoomedSlideClass: "swiper-slide-zoomed",
        },
      },
      create() {
        const swiper = this;
        const zoom = {
          enabled: false,
          scale: 1,
          currentScale: 1,
          isScaling: false,
          gesture: {
            $slideEl: undefined,
            slideWidth: undefined,
            slideHeight: undefined,
            $imageEl: undefined,
            $imageWrapEl: undefined,
            maxRatio: 3,
          },
          image: {
            isTouched: undefined,
            isMoved: undefined,
            currentX: undefined,
            currentY: undefined,
            minX: undefined,
            minY: undefined,
            maxX: undefined,
            maxY: undefined,
            width: undefined,
            height: undefined,
            startX: undefined,
            startY: undefined,
            touchesStart: {},
            touchesCurrent: {},
          },
          velocity: {
            x: undefined,
            y: undefined,
            prevPositionX: undefined,
            prevPositionY: undefined,
            prevTime: undefined,
          },
        };

        "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out"
          .split(" ")
          .forEach((methodName) => {
            zoom[methodName] = Zoom[methodName].bind(swiper);
          });
        Utils.extend(swiper, {
          zoom,
        });

        let scale = 1;
        Object.defineProperty(swiper.zoom, "scale", {
          get() {
            return scale;
          },
          set(value) {
            if (scale !== value) {
              const imageEl = swiper.zoom.gesture.$imageEl
                ? swiper.zoom.gesture.$imageEl[0]
                : undefined;
              const slideEl = swiper.zoom.gesture.$slideEl
                ? swiper.zoom.gesture.$slideEl[0]
                : undefined;
              swiper.emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
          },
        });
      },
      on: {
        init() {
          const swiper = this;
          if (swiper.params.zoom.enabled) {
            swiper.zoom.enable();
          }
        },
        destroy() {
          const swiper = this;
          swiper.zoom.disable();
        },
        touchStart(e) {
          const swiper = this;
          if (!swiper.zoom.enabled) return;
          swiper.zoom.onTouchStart(e);
        },
        touchEnd(e) {
          const swiper = this;
          if (!swiper.zoom.enabled) return;
          swiper.zoom.onTouchEnd(e);
        },
        doubleTap(e) {
          const swiper = this;
          if (
            swiper.params.zoom.enabled &&
            swiper.zoom.enabled &&
            swiper.params.zoom.toggle
          ) {
            swiper.zoom.toggle(e);
          }
        },
        transitionEnd() {
          const swiper = this;
          if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
            swiper.zoom.onTransitionEnd();
          }
        },
        slideChange() {
          const swiper = this;
          if (
            swiper.zoom.enabled &&
            swiper.params.zoom.enabled &&
            swiper.params.cssMode
          ) {
            swiper.zoom.onTransitionEnd();
          }
        },
      },
    };

    const Lazy = {
      loadInSlide(index, loadInDuplicate = true) {
        const swiper = this;
        const params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

        const $slideEl = isVirtual
          ? swiper.$wrapperEl.children(
              `.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`
            )
          : swiper.slides.eq(index);

        let $images = $slideEl.find(
          `.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`
        );
        if (
          $slideEl.hasClass(params.elementClass) &&
          !$slideEl.hasClass(params.loadedClass) &&
          !$slideEl.hasClass(params.loadingClass)
        ) {
          $images = $images.add($slideEl[0]);
        }
        if ($images.length === 0) return;

        $images.each((imageIndex, imageEl) => {
          const $imageEl = dom7_modular_$(imageEl);
          $imageEl.addClass(params.loadingClass);

          const background = $imageEl.attr("data-background");
          const src = $imageEl.attr("data-src");
          const srcset = $imageEl.attr("data-srcset");
          const sizes = $imageEl.attr("data-sizes");
          const $pictureEl = $imageEl.parent("picture");

          swiper.loadImage(
            $imageEl[0],
            src || background,
            srcset,
            sizes,
            false,
            () => {
              if (
                typeof swiper === "undefined" ||
                swiper === null ||
                !swiper ||
                (swiper && !swiper.params) ||
                swiper.destroyed
              )
                return;
              if (background) {
                $imageEl.css("background-image", `url("${background}")`);
                $imageEl.removeAttr("data-background");
              } else {
                if (srcset) {
                  $imageEl.attr("srcset", srcset);
                  $imageEl.removeAttr("data-srcset");
                }
                if (sizes) {
                  $imageEl.attr("sizes", sizes);
                  $imageEl.removeAttr("data-sizes");
                }
                if ($pictureEl.length) {
                  $pictureEl
                    .children("source")
                    .each((sourceIndex, sourceEl) => {
                      const $source = dom7_modular_$(sourceEl);

                      if ($source.attr("data-srcset")) {
                        $source.attr("srcset", $source.attr("data-srcset"));
                        $source.removeAttr("data-srcset");
                      }
                    });
                }
                if (src) {
                  $imageEl.attr("src", src);
                  $imageEl.removeAttr("data-src");
                }
              }

              $imageEl
                .addClass(params.loadedClass)
                .removeClass(params.loadingClass);
              $slideEl.find(`.${params.preloaderClass}`).remove();
              if (swiper.params.loop && loadInDuplicate) {
                const slideOriginalIndex = $slideEl.attr(
                  "data-swiper-slide-index"
                );
                if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                  const originalSlide = swiper.$wrapperEl.children(
                    `[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`
                  );
                  swiper.lazy.loadInSlide(originalSlide.index(), false);
                } else {
                  const duplicatedSlide = swiper.$wrapperEl.children(
                    `.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`
                  );
                  swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
                }
              }
              swiper.emit("lazyImageReady", $slideEl[0], $imageEl[0]);
              if (swiper.params.autoHeight) {
                swiper.updateAutoHeight();
              }
            }
          );

          swiper.emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
      },
      load() {
        const swiper = this;
        const {
          $wrapperEl,
          params: swiperParams,
          slides,
          activeIndex,
        } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;

        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") {
          slidesPerView = 0;
        }

        function slideExist(index) {
          if (isVirtual) {
            if (
              $wrapperEl.children(
                `.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`
              ).length
            ) {
              return true;
            }
          } else if (slides[index]) return true;
          return false;
        }

        function slideIndex(slideEl) {
          if (isVirtual) {
            return dom7_modular_$(slideEl).attr("data-swiper-slide-index");
          }
          return dom7_modular_$(slideEl).index();
        }

        if (!swiper.lazy.initialImageLoaded)
          swiper.lazy.initialImageLoaded = true;
        if (swiper.params.watchSlidesVisibility) {
          $wrapperEl
            .children(`.${swiperParams.slideVisibleClass}`)
            .each((elIndex, slideEl) => {
              const index = isVirtual
                ? dom7_modular_$(slideEl).attr("data-swiper-slide-index")
                : dom7_modular_$(slideEl).index();
              swiper.lazy.loadInSlide(index);
            });
        } else if (slidesPerView > 1) {
          for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
            if (slideExist(i)) swiper.lazy.loadInSlide(i);
          }
        } else {
          swiper.lazy.loadInSlide(activeIndex);
        }
        if (params.loadPrevNext) {
          if (
            slidesPerView > 1 ||
            (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)
          ) {
            const amount = params.loadPrevNextAmount;
            const spv = slidesPerView;
            const maxIndex = Math.min(
              activeIndex + spv + Math.max(amount, spv),
              slides.length
            );
            const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
            // Next Slides
            for (let i = activeIndex + slidesPerView; i < maxIndex; i += 1) {
              if (slideExist(i)) swiper.lazy.loadInSlide(i);
            }
            // Prev Slides
            for (let i = minIndex; i < activeIndex; i += 1) {
              if (slideExist(i)) swiper.lazy.loadInSlide(i);
            }
          } else {
            const nextSlide = $wrapperEl.children(
              `.${swiperParams.slideNextClass}`
            );
            if (nextSlide.length > 0)
              swiper.lazy.loadInSlide(slideIndex(nextSlide));

            const prevSlide = $wrapperEl.children(
              `.${swiperParams.slidePrevClass}`
            );
            if (prevSlide.length > 0)
              swiper.lazy.loadInSlide(slideIndex(prevSlide));
          }
        }
      },
    };

    var Lazy$1 = {
      name: "lazy",
      params: {
        lazy: {
          enabled: false,
          loadPrevNext: false,
          loadPrevNextAmount: 1,
          loadOnTransitionStart: false,

          elementClass: "swiper-lazy",
          loadingClass: "swiper-lazy-loading",
          loadedClass: "swiper-lazy-loaded",
          preloaderClass: "swiper-lazy-preloader",
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          lazy: {
            initialImageLoaded: false,
            load: Lazy.load.bind(swiper),
            loadInSlide: Lazy.loadInSlide.bind(swiper),
          },
        });
      },
      on: {
        beforeInit() {
          const swiper = this;
          if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
            swiper.params.preloadImages = false;
          }
        },
        init() {
          const swiper = this;
          if (
            swiper.params.lazy.enabled &&
            !swiper.params.loop &&
            swiper.params.initialSlide === 0
          ) {
            swiper.lazy.load();
          }
        },
        scroll() {
          const swiper = this;
          if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
            swiper.lazy.load();
          }
        },
        resize() {
          const swiper = this;
          if (swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
        },
        scrollbarDragMove() {
          const swiper = this;
          if (swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
        },
        transitionStart() {
          const swiper = this;
          if (swiper.params.lazy.enabled) {
            if (
              swiper.params.lazy.loadOnTransitionStart ||
              (!swiper.params.lazy.loadOnTransitionStart &&
                !swiper.lazy.initialImageLoaded)
            ) {
              swiper.lazy.load();
            }
          }
        },
        transitionEnd() {
          const swiper = this;
          if (
            swiper.params.lazy.enabled &&
            !swiper.params.lazy.loadOnTransitionStart
          ) {
            swiper.lazy.load();
          }
        },
        slideChange() {
          const swiper = this;
          if (swiper.params.lazy.enabled && swiper.params.cssMode) {
            swiper.lazy.load();
          }
        },
      },
    };

    /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

    const Controller = {
      LinearSpline: function LinearSpline(x, y) {
        const binarySearch = (function search() {
          let maxIndex;
          let minIndex;
          let guess;
          return (array, val) => {
            minIndex = -1;
            maxIndex = array.length;
            while (maxIndex - minIndex > 1) {
              guess = (maxIndex + minIndex) >> 1;
              if (array[guess] <= val) {
                minIndex = guess;
              } else {
                maxIndex = guess;
              }
            }
            return maxIndex;
          };
        })();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;

        this.interpolate = function interpolate(x2) {
          if (!x2) return 0;

          // Get the indexes of x1 and x3 (the array indexes before and after given x2):
          i3 = binarySearch(this.x, x2);
          i1 = i3 - 1;

          // We have our indexes i1 & i3, so we can calculate already:
          // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
          return (
            ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) /
              (this.x[i3] - this.x[i1]) +
            this.y[i1]
          );
        };
        return this;
      },
      // xxx: for now i will just save one spline function to to
      getInterpolateFunction(c) {
        const swiper = this;
        if (!swiper.controller.spline) {
          swiper.controller.spline = swiper.params.loop
            ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
            : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
        }
      },
      setTranslate(setTranslate, byController) {
        const swiper = this;
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        function setControlledTranslate(c) {
          // this will create an Interpolate function based on the snapGrids
          // x is the Grid of the scrolled scroller and y will be the controlled scroller
          // it makes sense to create this only once and recall it for the interpolation
          // the function does a lot of value caching for performance
          const translate = swiper.rtlTranslate
            ? -swiper.translate
            : swiper.translate;
          if (swiper.params.controller.by === "slide") {
            swiper.controller.getInterpolateFunction(c);
            // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
            // but it did not work out
            controlledTranslate = -swiper.controller.spline.interpolate(
              -translate
            );
          }

          if (
            !controlledTranslate ||
            swiper.params.controller.by === "container"
          ) {
            multiplier =
              (c.maxTranslate() - c.minTranslate()) /
              (swiper.maxTranslate() - swiper.minTranslate());
            controlledTranslate =
              (translate - swiper.minTranslate()) * multiplier +
              c.minTranslate();
          }

          if (swiper.params.controller.inverse) {
            controlledTranslate = c.maxTranslate() - controlledTranslate;
          }
          c.updateProgress(controlledTranslate);
          c.setTranslate(controlledTranslate, swiper);
          c.updateActiveIndex();
          c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
          for (let i = 0; i < controlled.length; i += 1) {
            if (
              controlled[i] !== byController &&
              controlled[i] instanceof Swiper
            ) {
              setControlledTranslate(controlled[i]);
            }
          }
        } else if (
          controlled instanceof Swiper &&
          byController !== controlled
        ) {
          setControlledTranslate(controlled);
        }
      },
      setTransition(duration, byController) {
        const swiper = this;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
          c.setTransition(duration, swiper);
          if (duration !== 0) {
            c.transitionStart();
            if (c.params.autoHeight) {
              Utils.nextTick(() => {
                c.updateAutoHeight();
              });
            }
            c.$wrapperEl.transitionEnd(() => {
              if (!controlled) return;
              if (c.params.loop && swiper.params.controller.by === "slide") {
                c.loopFix();
              }
              c.transitionEnd();
            });
          }
        }
        if (Array.isArray(controlled)) {
          for (i = 0; i < controlled.length; i += 1) {
            if (
              controlled[i] !== byController &&
              controlled[i] instanceof Swiper
            ) {
              setControlledTransition(controlled[i]);
            }
          }
        } else if (
          controlled instanceof Swiper &&
          byController !== controlled
        ) {
          setControlledTransition(controlled);
        }
      },
    };
    var Controller$1 = {
      name: "controller",
      params: {
        controller: {
          control: undefined,
          inverse: false,
          by: "slide", // or 'container'
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          controller: {
            control: swiper.params.controller.control,
            getInterpolateFunction:
              Controller.getInterpolateFunction.bind(swiper),
            setTranslate: Controller.setTranslate.bind(swiper),
            setTransition: Controller.setTransition.bind(swiper),
          },
        });
      },
      on: {
        update() {
          const swiper = this;
          if (!swiper.controller.control) return;
          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        resize() {
          const swiper = this;
          if (!swiper.controller.control) return;
          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        observerUpdate() {
          const swiper = this;
          if (!swiper.controller.control) return;
          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        setTranslate(translate, byController) {
          const swiper = this;
          if (!swiper.controller.control) return;
          swiper.controller.setTranslate(translate, byController);
        },
        setTransition(duration, byController) {
          const swiper = this;
          if (!swiper.controller.control) return;
          swiper.controller.setTransition(duration, byController);
        },
      },
    };

    const a11y = {
      makeElFocusable($el) {
        $el.attr("tabIndex", "0");
        return $el;
      },
      makeElNotFocusable($el) {
        $el.attr("tabIndex", "-1");
        return $el;
      },
      addElRole($el, role) {
        $el.attr("role", role);
        return $el;
      },
      addElLabel($el, label) {
        $el.attr("aria-label", label);
        return $el;
      },
      disableEl($el) {
        $el.attr("aria-disabled", true);
        return $el;
      },
      enableEl($el) {
        $el.attr("aria-disabled", false);
        return $el;
      },
      onEnterKey(e) {
        const swiper = this;
        const params = swiper.params.a11y;
        if (e.keyCode !== 13) return;
        const $targetEl = dom7_modular_$(e.target);
        if (
          swiper.navigation &&
          swiper.navigation.$nextEl &&
          $targetEl.is(swiper.navigation.$nextEl)
        ) {
          if (!(swiper.isEnd && !swiper.params.loop)) {
            swiper.slideNext();
          }
          if (swiper.isEnd) {
            swiper.a11y.notify(params.lastSlideMessage);
          } else {
            swiper.a11y.notify(params.nextSlideMessage);
          }
        }
        if (
          swiper.navigation &&
          swiper.navigation.$prevEl &&
          $targetEl.is(swiper.navigation.$prevEl)
        ) {
          if (!(swiper.isBeginning && !swiper.params.loop)) {
            swiper.slidePrev();
          }
          if (swiper.isBeginning) {
            swiper.a11y.notify(params.firstSlideMessage);
          } else {
            swiper.a11y.notify(params.prevSlideMessage);
          }
        }
        if (
          swiper.pagination &&
          $targetEl.is(`.${swiper.params.pagination.bulletClass}`)
        ) {
          $targetEl[0].click();
        }
      },
      notify(message) {
        const swiper = this;
        const notification = swiper.a11y.liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
      },
      updateNavigation() {
        const swiper = this;

        if (swiper.params.loop || !swiper.navigation) return;
        const { $nextEl, $prevEl } = swiper.navigation;

        if ($prevEl && $prevEl.length > 0) {
          if (swiper.isBeginning) {
            swiper.a11y.disableEl($prevEl);
            swiper.a11y.makeElNotFocusable($prevEl);
          } else {
            swiper.a11y.enableEl($prevEl);
            swiper.a11y.makeElFocusable($prevEl);
          }
        }
        if ($nextEl && $nextEl.length > 0) {
          if (swiper.isEnd) {
            swiper.a11y.disableEl($nextEl);
            swiper.a11y.makeElNotFocusable($nextEl);
          } else {
            swiper.a11y.enableEl($nextEl);
            swiper.a11y.makeElFocusable($nextEl);
          }
        }
      },
      updatePagination() {
        const swiper = this;
        const params = swiper.params.a11y;
        if (
          swiper.pagination &&
          swiper.params.pagination.clickable &&
          swiper.pagination.bullets &&
          swiper.pagination.bullets.length
        ) {
          swiper.pagination.bullets.each((bulletIndex, bulletEl) => {
            const $bulletEl = dom7_modular_$(bulletEl);
            swiper.a11y.makeElFocusable($bulletEl);
            swiper.a11y.addElRole($bulletEl, "button");
            swiper.a11y.addElLabel(
              $bulletEl,
              params.paginationBulletMessage.replace(
                /\{\{index\}\}/,
                $bulletEl.index() + 1
              )
            );
          });
        }
      },
      init() {
        const swiper = this;

        swiper.$el.append(swiper.a11y.liveRegion);

        // Navigation
        const params = swiper.params.a11y;
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) {
          $nextEl = swiper.navigation.$nextEl;
        }
        if (swiper.navigation && swiper.navigation.$prevEl) {
          $prevEl = swiper.navigation.$prevEl;
        }
        if ($nextEl) {
          swiper.a11y.makeElFocusable($nextEl);
          swiper.a11y.addElRole($nextEl, "button");
          swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
          $nextEl.on("keydown", swiper.a11y.onEnterKey);
        }
        if ($prevEl) {
          swiper.a11y.makeElFocusable($prevEl);
          swiper.a11y.addElRole($prevEl, "button");
          swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
          $prevEl.on("keydown", swiper.a11y.onEnterKey);
        }

        // Pagination
        if (
          swiper.pagination &&
          swiper.params.pagination.clickable &&
          swiper.pagination.bullets &&
          swiper.pagination.bullets.length
        ) {
          swiper.pagination.$el.on(
            "keydown",
            `.${swiper.params.pagination.bulletClass}`,
            swiper.a11y.onEnterKey
          );
        }
      },
      destroy() {
        const swiper = this;
        if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0)
          swiper.a11y.liveRegion.remove();

        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) {
          $nextEl = swiper.navigation.$nextEl;
        }
        if (swiper.navigation && swiper.navigation.$prevEl) {
          $prevEl = swiper.navigation.$prevEl;
        }
        if ($nextEl) {
          $nextEl.off("keydown", swiper.a11y.onEnterKey);
        }
        if ($prevEl) {
          $prevEl.off("keydown", swiper.a11y.onEnterKey);
        }

        // Pagination
        if (
          swiper.pagination &&
          swiper.params.pagination.clickable &&
          swiper.pagination.bullets &&
          swiper.pagination.bullets.length
        ) {
          swiper.pagination.$el.off(
            "keydown",
            `.${swiper.params.pagination.bulletClass}`,
            swiper.a11y.onEnterKey
          );
        }
      },
    };
    var A11y = {
      name: "a11y",
      params: {
        a11y: {
          enabled: true,
          notificationClass: "swiper-notification",
          prevSlideMessage: "Previous slide",
          nextSlideMessage: "Next slide",
          firstSlideMessage: "This is the first slide",
          lastSlideMessage: "This is the last slide",
          paginationBulletMessage: "Go to slide {{index}}",
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          a11y: {
            liveRegion: dom7_modular_$(
              `<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`
            ),
          },
        });
        Object.keys(a11y).forEach((methodName) => {
          swiper.a11y[methodName] = a11y[methodName].bind(swiper);
        });
      },
      on: {
        init() {
          const swiper = this;
          if (!swiper.params.a11y.enabled) return;
          swiper.a11y.init();
          swiper.a11y.updateNavigation();
        },
        toEdge() {
          const swiper = this;
          if (!swiper.params.a11y.enabled) return;
          swiper.a11y.updateNavigation();
        },
        fromEdge() {
          const swiper = this;
          if (!swiper.params.a11y.enabled) return;
          swiper.a11y.updateNavigation();
        },
        paginationUpdate() {
          const swiper = this;
          if (!swiper.params.a11y.enabled) return;
          swiper.a11y.updatePagination();
        },
        destroy() {
          const swiper = this;
          if (!swiper.params.a11y.enabled) return;
          swiper.a11y.destroy();
        },
      },
    };

    const History = {
      init() {
        const swiper = this;
        if (!swiper.params.history) return;
        if (!win.history || !win.history.pushState) {
          swiper.params.history.enabled = false;
          swiper.params.hashNavigation.enabled = true;
          return;
        }
        const history = swiper.history;
        history.initialized = true;
        history.paths = History.getPathValues();
        if (!history.paths.key && !history.paths.value) return;
        history.scrollToSlide(
          0,
          history.paths.value,
          swiper.params.runCallbacksOnInit
        );
        if (!swiper.params.history.replaceState) {
          win.addEventListener("popstate", swiper.history.setHistoryPopState);
        }
      },
      destroy() {
        const swiper = this;
        if (!swiper.params.history.replaceState) {
          win.removeEventListener(
            "popstate",
            swiper.history.setHistoryPopState
          );
        }
      },
      setHistoryPopState() {
        const swiper = this;
        swiper.history.paths = History.getPathValues();
        swiper.history.scrollToSlide(
          swiper.params.speed,
          swiper.history.paths.value,
          false
        );
      },
      getPathValues() {
        const pathArray = win.location.pathname
          .slice(1)
          .split("/")
          .filter((part) => part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return { key, value };
      },
      setHistory(key, index) {
        const swiper = this;
        if (!swiper.history.initialized || !swiper.params.history.enabled)
          return;
        const slide = swiper.slides.eq(index);
        let value = History.slugify(slide.attr("data-history"));
        if (!win.location.pathname.includes(key)) {
          value = `${key}/${value}`;
        }
        const currentState = win.history.state;
        if (currentState && currentState.value === value) {
          return;
        }
        if (swiper.params.history.replaceState) {
          win.history.replaceState({ value }, null, value);
        } else {
          win.history.pushState({ value }, null, value);
        }
      },
      slugify(text) {
        return text
          .toString()
          .replace(/\s+/g, "-")
          .replace(/[^\w-]+/g, "")
          .replace(/--+/g, "-")
          .replace(/^-+/, "")
          .replace(/-+$/, "");
      },
      scrollToSlide(speed, value, runCallbacks) {
        const swiper = this;
        if (value) {
          for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
            const slide = swiper.slides.eq(i);
            const slideHistory = History.slugify(slide.attr("data-history"));
            if (
              slideHistory === value &&
              !slide.hasClass(swiper.params.slideDuplicateClass)
            ) {
              const index = slide.index();
              swiper.slideTo(index, speed, runCallbacks);
            }
          }
        } else {
          swiper.slideTo(0, speed, runCallbacks);
        }
      },
    };

    var History$1 = {
      name: "history",
      params: {
        history: {
          enabled: false,
          replaceState: false,
          key: "slides",
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          history: {
            init: History.init.bind(swiper),
            setHistory: History.setHistory.bind(swiper),
            setHistoryPopState: History.setHistoryPopState.bind(swiper),
            scrollToSlide: History.scrollToSlide.bind(swiper),
            destroy: History.destroy.bind(swiper),
          },
        });
      },
      on: {
        init() {
          const swiper = this;
          if (swiper.params.history.enabled) {
            swiper.history.init();
          }
        },
        destroy() {
          const swiper = this;
          if (swiper.params.history.enabled) {
            swiper.history.destroy();
          }
        },
        transitionEnd() {
          const swiper = this;
          if (swiper.history.initialized) {
            swiper.history.setHistory(
              swiper.params.history.key,
              swiper.activeIndex
            );
          }
        },
        slideChange() {
          const swiper = this;
          if (swiper.history.initialized && swiper.params.cssMode) {
            swiper.history.setHistory(
              swiper.params.history.key,
              swiper.activeIndex
            );
          }
        },
      },
    };

    const HashNavigation = {
      onHashCange() {
        const swiper = this;
        swiper.emit("hashChange");
        const newHash = doc.location.hash.replace("#", "");
        const activeSlideHash = swiper.slides
          .eq(swiper.activeIndex)
          .attr("data-hash");
        if (newHash !== activeSlideHash) {
          const newIndex = swiper.$wrapperEl
            .children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`)
            .index();
          if (typeof newIndex === "undefined") return;
          swiper.slideTo(newIndex);
        }
      },
      setHash() {
        const swiper = this;
        if (
          !swiper.hashNavigation.initialized ||
          !swiper.params.hashNavigation.enabled
        )
          return;
        if (
          swiper.params.hashNavigation.replaceState &&
          win.history &&
          win.history.replaceState
        ) {
          win.history.replaceState(
            null,
            null,
            `#${swiper.slides.eq(swiper.activeIndex).attr("data-hash")}` || ""
          );
          swiper.emit("hashSet");
        } else {
          const slide = swiper.slides.eq(swiper.activeIndex);
          const hash = slide.attr("data-hash") || slide.attr("data-history");
          doc.location.hash = hash || "";
          swiper.emit("hashSet");
        }
      },
      init() {
        const swiper = this;
        if (
          !swiper.params.hashNavigation.enabled ||
          (swiper.params.history && swiper.params.history.enabled)
        )
          return;
        swiper.hashNavigation.initialized = true;
        const hash = doc.location.hash.replace("#", "");
        if (hash) {
          const speed = 0;
          for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
            const slide = swiper.slides.eq(i);
            const slideHash =
              slide.attr("data-hash") || slide.attr("data-history");
            if (
              slideHash === hash &&
              !slide.hasClass(swiper.params.slideDuplicateClass)
            ) {
              const index = slide.index();
              swiper.slideTo(
                index,
                speed,
                swiper.params.runCallbacksOnInit,
                true
              );
            }
          }
        }
        if (swiper.params.hashNavigation.watchState) {
          dom7_modular_$(win).on(
            "hashchange",
            swiper.hashNavigation.onHashCange
          );
        }
      },
      destroy() {
        const swiper = this;
        if (swiper.params.hashNavigation.watchState) {
          dom7_modular_$(win).off(
            "hashchange",
            swiper.hashNavigation.onHashCange
          );
        }
      },
    };
    var HashNavigation$1 = {
      name: "hash-navigation",
      params: {
        hashNavigation: {
          enabled: false,
          replaceState: false,
          watchState: false,
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          hashNavigation: {
            initialized: false,
            init: HashNavigation.init.bind(swiper),
            destroy: HashNavigation.destroy.bind(swiper),
            setHash: HashNavigation.setHash.bind(swiper),
            onHashCange: HashNavigation.onHashCange.bind(swiper),
          },
        });
      },
      on: {
        init() {
          const swiper = this;
          if (swiper.params.hashNavigation.enabled) {
            swiper.hashNavigation.init();
          }
        },
        destroy() {
          const swiper = this;
          if (swiper.params.hashNavigation.enabled) {
            swiper.hashNavigation.destroy();
          }
        },
        transitionEnd() {
          const swiper = this;
          if (swiper.hashNavigation.initialized) {
            swiper.hashNavigation.setHash();
          }
        },
        slideChange() {
          const swiper = this;
          if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
            swiper.hashNavigation.setHash();
          }
        },
      },
    };

    /* eslint no-underscore-dangle: "off" */

    const Autoplay = {
      run() {
        const swiper = this;
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) {
          delay =
            $activeSlideEl.attr("data-swiper-autoplay") ||
            swiper.params.autoplay.delay;
        }
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = Utils.nextTick(() => {
          if (swiper.params.autoplay.reverseDirection) {
            if (swiper.params.loop) {
              swiper.loopFix();
              swiper.slidePrev(swiper.params.speed, true, true);
              swiper.emit("autoplay");
            } else if (!swiper.isBeginning) {
              swiper.slidePrev(swiper.params.speed, true, true);
              swiper.emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
              swiper.slideTo(
                swiper.slides.length - 1,
                swiper.params.speed,
                true,
                true
              );
              swiper.emit("autoplay");
            } else {
              swiper.autoplay.stop();
            }
          } else if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slideNext(swiper.params.speed, true, true);
            swiper.emit("autoplay");
          } else if (!swiper.isEnd) {
            swiper.slideNext(swiper.params.speed, true, true);
            swiper.emit("autoplay");
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(0, swiper.params.speed, true, true);
            swiper.emit("autoplay");
          } else {
            swiper.autoplay.stop();
          }
          if (swiper.params.cssMode && swiper.autoplay.running)
            swiper.autoplay.run();
        }, delay);
      },
      start() {
        const swiper = this;
        if (typeof swiper.autoplay.timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        swiper.emit("autoplayStart");
        swiper.autoplay.run();
        return true;
      },
      stop() {
        const swiper = this;
        if (!swiper.autoplay.running) return false;
        if (typeof swiper.autoplay.timeout === "undefined") return false;

        if (swiper.autoplay.timeout) {
          clearTimeout(swiper.autoplay.timeout);
          swiper.autoplay.timeout = undefined;
        }
        swiper.autoplay.running = false;
        swiper.emit("autoplayStop");
        return true;
      },
      pause(speed) {
        const swiper = this;
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
          swiper.autoplay.paused = false;
          swiper.autoplay.run();
        } else {
          swiper.$wrapperEl[0].addEventListener(
            "transitionend",
            swiper.autoplay.onTransitionEnd
          );
          swiper.$wrapperEl[0].addEventListener(
            "webkitTransitionEnd",
            swiper.autoplay.onTransitionEnd
          );
        }
      },
    };

    var Autoplay$1 = {
      name: "autoplay",
      params: {
        autoplay: {
          enabled: false,
          delay: 3000,
          waitForTransition: true,
          disableOnInteraction: true,
          stopOnLastSlide: false,
          reverseDirection: false,
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          autoplay: {
            running: false,
            paused: false,
            run: Autoplay.run.bind(swiper),
            start: Autoplay.start.bind(swiper),
            stop: Autoplay.stop.bind(swiper),
            pause: Autoplay.pause.bind(swiper),
            onVisibilityChange() {
              if (
                document.visibilityState === "hidden" &&
                swiper.autoplay.running
              ) {
                swiper.autoplay.pause();
              }
              if (
                document.visibilityState === "visible" &&
                swiper.autoplay.paused
              ) {
                swiper.autoplay.run();
                swiper.autoplay.paused = false;
              }
            },
            onTransitionEnd(e) {
              if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
              if (e.target !== this) return;
              swiper.$wrapperEl[0].removeEventListener(
                "transitionend",
                swiper.autoplay.onTransitionEnd
              );
              swiper.$wrapperEl[0].removeEventListener(
                "webkitTransitionEnd",
                swiper.autoplay.onTransitionEnd
              );
              swiper.autoplay.paused = false;
              if (!swiper.autoplay.running) {
                swiper.autoplay.stop();
              } else {
                swiper.autoplay.run();
              }
            },
          },
        });
      },
      on: {
        init() {
          const swiper = this;
          if (swiper.params.autoplay.enabled) {
            swiper.autoplay.start();
            document.addEventListener(
              "visibilitychange",
              swiper.autoplay.onVisibilityChange
            );
          }
        },
        beforeTransitionStart(speed, internal) {
          const swiper = this;
          if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) {
              swiper.autoplay.pause(speed);
            } else {
              swiper.autoplay.stop();
            }
          }
        },
        sliderFirstMove() {
          const swiper = this;
          if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.pause();
            }
          }
        },
        touchEnd() {
          const swiper = this;
          if (
            swiper.params.cssMode &&
            swiper.autoplay.paused &&
            !swiper.params.autoplay.disableOnInteraction
          ) {
            swiper.autoplay.run();
          }
        },
        destroy() {
          const swiper = this;
          if (swiper.autoplay.running) {
            swiper.autoplay.stop();
          }
          document.removeEventListener(
            "visibilitychange",
            swiper.autoplay.onVisibilityChange
          );
        },
      },
    };

    const Fade = {
      setTranslate() {
        const swiper = this;
        const { slides } = swiper;
        for (let i = 0; i < slides.length; i += 1) {
          const $slideEl = swiper.slides.eq(i);
          const offset = $slideEl[0].swiperSlideOffset;
          let tx = -offset;
          if (!swiper.params.virtualTranslate) tx -= swiper.translate;
          let ty = 0;
          if (!swiper.isHorizontal()) {
            ty = tx;
            tx = 0;
          }
          const slideOpacity = swiper.params.fadeEffect.crossFade
            ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
            : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
          $slideEl
            .css({
              opacity: slideOpacity,
            })
            .transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
      },
      setTransition(duration) {
        const swiper = this;
        const { slides, $wrapperEl } = swiper;
        slides.transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
          let eventTriggered = false;
          slides.transitionEnd(() => {
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = ["webkitTransitionEnd", "transitionend"];
            for (let i = 0; i < triggerEvents.length; i += 1) {
              $wrapperEl.trigger(triggerEvents[i]);
            }
          });
        }
      },
    };

    var EffectFade = {
      name: "effect-fade",
      params: {
        fadeEffect: {
          crossFade: false,
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          fadeEffect: {
            setTranslate: Fade.setTranslate.bind(swiper),
            setTransition: Fade.setTransition.bind(swiper),
          },
        });
      },
      on: {
        beforeInit() {
          const swiper = this;
          if (swiper.params.effect !== "fade") return;
          swiper.classNames.push(`${swiper.params.containerModifierClass}fade`);
          const overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: true,
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate() {
          const swiper = this;
          if (swiper.params.effect !== "fade") return;
          swiper.fadeEffect.setTranslate();
        },
        setTransition(duration) {
          const swiper = this;
          if (swiper.params.effect !== "fade") return;
          swiper.fadeEffect.setTransition(duration);
        },
      },
    };

    const Cube = {
      setTranslate() {
        const swiper = this;
        const {
          $el,
          $wrapperEl,
          slides,
          width: swiperWidth,
          height: swiperHeight,
          rtlTranslate: rtl,
          size: swiperSize,
        } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
          if (isHorizontal) {
            $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
            if ($cubeShadowEl.length === 0) {
              $cubeShadowEl = dom7_modular_$(
                '<div class="swiper-cube-shadow"></div>'
              );
              $wrapperEl.append($cubeShadowEl);
            }
            $cubeShadowEl.css({ height: `${swiperWidth}px` });
          } else {
            $cubeShadowEl = $el.find(".swiper-cube-shadow");
            if ($cubeShadowEl.length === 0) {
              $cubeShadowEl = dom7_modular_$(
                '<div class="swiper-cube-shadow"></div>'
              );
              $el.append($cubeShadowEl);
            }
          }
        }
        for (let i = 0; i < slides.length; i += 1) {
          const $slideEl = slides.eq(i);
          let slideIndex = i;
          if (isVirtual) {
            slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
          }
          let slideAngle = slideIndex * 90;
          let round = Math.floor(slideAngle / 360);
          if (rtl) {
            slideAngle = -slideAngle;
            round = Math.floor(-slideAngle / 360);
          }
          const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
          let tx = 0;
          let ty = 0;
          let tz = 0;
          if (slideIndex % 4 === 0) {
            tx = -round * 4 * swiperSize;
            tz = 0;
          } else if ((slideIndex - 1) % 4 === 0) {
            tx = 0;
            tz = -round * 4 * swiperSize;
          } else if ((slideIndex - 2) % 4 === 0) {
            tx = swiperSize + round * 4 * swiperSize;
            tz = swiperSize;
          } else if ((slideIndex - 3) % 4 === 0) {
            tx = -swiperSize;
            tz = 3 * swiperSize + swiperSize * 4 * round;
          }
          if (rtl) {
            tx = -tx;
          }

          if (!isHorizontal) {
            ty = tx;
            tx = 0;
          }

          const transform = `rotateX(${
            isHorizontal ? 0 : -slideAngle
          }deg) rotateY(${
            isHorizontal ? slideAngle : 0
          }deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
          if (progress <= 1 && progress > -1) {
            wrapperRotate = slideIndex * 90 + progress * 90;
            if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
          }
          $slideEl.transform(transform);
          if (params.slideShadows) {
            // Set shadows
            let shadowBefore = isHorizontal
              ? $slideEl.find(".swiper-slide-shadow-left")
              : $slideEl.find(".swiper-slide-shadow-top");
            let shadowAfter = isHorizontal
              ? $slideEl.find(".swiper-slide-shadow-right")
              : $slideEl.find(".swiper-slide-shadow-bottom");
            if (shadowBefore.length === 0) {
              shadowBefore = dom7_modular_$(
                `<div class="swiper-slide-shadow-${
                  isHorizontal ? "left" : "top"
                }"></div>`
              );
              $slideEl.append(shadowBefore);
            }
            if (shadowAfter.length === 0) {
              shadowAfter = dom7_modular_$(
                `<div class="swiper-slide-shadow-${
                  isHorizontal ? "right" : "bottom"
                }"></div>`
              );
              $slideEl.append(shadowAfter);
            }
            if (shadowBefore.length)
              shadowBefore[0].style.opacity = Math.max(-progress, 0);
            if (shadowAfter.length)
              shadowAfter[0].style.opacity = Math.max(progress, 0);
          }
        }
        $wrapperEl.css({
          "-webkit-transform-origin": `50% 50% -${swiperSize / 2}px`,
          "-moz-transform-origin": `50% 50% -${swiperSize / 2}px`,
          "-ms-transform-origin": `50% 50% -${swiperSize / 2}px`,
          "transform-origin": `50% 50% -${swiperSize / 2}px`,
        });

        if (params.shadow) {
          if (isHorizontal) {
            $cubeShadowEl.transform(
              `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${
                -swiperWidth / 2
              }px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`
            );
          } else {
            const shadowAngle =
              Math.abs(wrapperRotate) -
              Math.floor(Math.abs(wrapperRotate) / 90) * 90;
            const multiplier =
              1.5 -
              (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2 +
                Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2);
            const scale1 = params.shadowScale;
            const scale2 = params.shadowScale / multiplier;
            const offset = params.shadowOffset;
            $cubeShadowEl.transform(
              `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${
                swiperHeight / 2 + offset
              }px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`
            );
          }
        }
        const zFactor =
          Browser.isSafari || Browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(
          `translate3d(0px,0,${zFactor}px) rotateX(${
            swiper.isHorizontal() ? 0 : wrapperRotate
          }deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`
        );
      },
      setTransition(duration) {
        const swiper = this;
        const { $el, slides } = swiper;
        slides
          .transition(duration)
          .find(
            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
          )
          .transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
          $el.find(".swiper-cube-shadow").transition(duration);
        }
      },
    };

    var EffectCube = {
      name: "effect-cube",
      params: {
        cubeEffect: {
          slideShadows: true,
          shadow: true,
          shadowOffset: 20,
          shadowScale: 0.94,
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          cubeEffect: {
            setTranslate: Cube.setTranslate.bind(swiper),
            setTransition: Cube.setTransition.bind(swiper),
          },
        });
      },
      on: {
        beforeInit() {
          const swiper = this;
          if (swiper.params.effect !== "cube") return;
          swiper.classNames.push(`${swiper.params.containerModifierClass}cube`);
          swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
          const overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            resistanceRatio: 0,
            spaceBetween: 0,
            centeredSlides: false,
            virtualTranslate: true,
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate() {
          const swiper = this;
          if (swiper.params.effect !== "cube") return;
          swiper.cubeEffect.setTranslate();
        },
        setTransition(duration) {
          const swiper = this;
          if (swiper.params.effect !== "cube") return;
          swiper.cubeEffect.setTransition(duration);
        },
      },
    };

    const Flip = {
      setTranslate() {
        const swiper = this;
        const { slides, rtlTranslate: rtl } = swiper;
        for (let i = 0; i < slides.length; i += 1) {
          const $slideEl = slides.eq(i);
          let progress = $slideEl[0].progress;
          if (swiper.params.flipEffect.limitRotation) {
            progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
          }
          const offset = $slideEl[0].swiperSlideOffset;
          const rotate = -180 * progress;
          let rotateY = rotate;
          let rotateX = 0;
          let tx = -offset;
          let ty = 0;
          if (!swiper.isHorizontal()) {
            ty = tx;
            tx = 0;
            rotateX = -rotateY;
            rotateY = 0;
          } else if (rtl) {
            rotateY = -rotateY;
          }

          $slideEl[0].style.zIndex =
            -Math.abs(Math.round(progress)) + slides.length;

          if (swiper.params.flipEffect.slideShadows) {
            // Set shadows
            let shadowBefore = swiper.isHorizontal()
              ? $slideEl.find(".swiper-slide-shadow-left")
              : $slideEl.find(".swiper-slide-shadow-top");
            let shadowAfter = swiper.isHorizontal()
              ? $slideEl.find(".swiper-slide-shadow-right")
              : $slideEl.find(".swiper-slide-shadow-bottom");
            if (shadowBefore.length === 0) {
              shadowBefore = dom7_modular_$(
                `<div class="swiper-slide-shadow-${
                  swiper.isHorizontal() ? "left" : "top"
                }"></div>`
              );
              $slideEl.append(shadowBefore);
            }
            if (shadowAfter.length === 0) {
              shadowAfter = dom7_modular_$(
                `<div class="swiper-slide-shadow-${
                  swiper.isHorizontal() ? "right" : "bottom"
                }"></div>`
              );
              $slideEl.append(shadowAfter);
            }
            if (shadowBefore.length)
              shadowBefore[0].style.opacity = Math.max(-progress, 0);
            if (shadowAfter.length)
              shadowAfter[0].style.opacity = Math.max(progress, 0);
          }
          $slideEl.transform(
            `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`
          );
        }
      },
      setTransition(duration) {
        const swiper = this;
        const { slides, activeIndex, $wrapperEl } = swiper;
        slides
          .transition(duration)
          .find(
            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
          )
          .transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
          let eventTriggered = false;
          // eslint-disable-next-line
          slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = ["webkitTransitionEnd", "transitionend"];
            for (let i = 0; i < triggerEvents.length; i += 1) {
              $wrapperEl.trigger(triggerEvents[i]);
            }
          });
        }
      },
    };

    var EffectFlip = {
      name: "effect-flip",
      params: {
        flipEffect: {
          slideShadows: true,
          limitRotation: true,
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          flipEffect: {
            setTranslate: Flip.setTranslate.bind(swiper),
            setTransition: Flip.setTransition.bind(swiper),
          },
        });
      },
      on: {
        beforeInit() {
          const swiper = this;
          if (swiper.params.effect !== "flip") return;
          swiper.classNames.push(`${swiper.params.containerModifierClass}flip`);
          swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
          const overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: true,
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate() {
          const swiper = this;
          if (swiper.params.effect !== "flip") return;
          swiper.flipEffect.setTranslate();
        },
        setTransition(duration) {
          const swiper = this;
          if (swiper.params.effect !== "flip") return;
          swiper.flipEffect.setTransition(duration);
        },
      },
    };

    const Coverflow = {
      setTranslate() {
        const swiper = this;
        const {
          width: swiperWidth,
          height: swiperHeight,
          slides,
          $wrapperEl,
          slidesSizesGrid,
        } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal
          ? -transform + swiperWidth / 2
          : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        // Each slide offset from center
        for (let i = 0, length = slides.length; i < length; i += 1) {
          const $slideEl = slides.eq(i);
          const slideSize = slidesSizesGrid[i];
          const slideOffset = $slideEl[0].swiperSlideOffset;
          const offsetMultiplier =
            ((center - slideOffset - slideSize / 2) / slideSize) *
            params.modifier;

          let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
          let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
          // var rotateZ = 0
          let translateZ = -translate * Math.abs(offsetMultiplier);

          let stretch = params.stretch;
          // Allow percentage to make a relative stretch for responsive sliders
          if (typeof stretch === "string" && stretch.indexOf("%") !== -1) {
            stretch = (parseFloat(params.stretch) / 100) * slideSize;
          }
          let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
          let translateX = isHorizontal ? stretch * offsetMultiplier : 0;

          let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);

          // Fix for ultra small values
          if (Math.abs(translateX) < 0.001) translateX = 0;
          if (Math.abs(translateY) < 0.001) translateY = 0;
          if (Math.abs(translateZ) < 0.001) translateZ = 0;
          if (Math.abs(rotateY) < 0.001) rotateY = 0;
          if (Math.abs(rotateX) < 0.001) rotateX = 0;
          if (Math.abs(scale) < 0.001) scale = 0;

          const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;

          $slideEl.transform(slideTransform);
          $slideEl[0].style.zIndex =
            -Math.abs(Math.round(offsetMultiplier)) + 1;
          if (params.slideShadows) {
            // Set shadows
            let $shadowBeforeEl = isHorizontal
              ? $slideEl.find(".swiper-slide-shadow-left")
              : $slideEl.find(".swiper-slide-shadow-top");
            let $shadowAfterEl = isHorizontal
              ? $slideEl.find(".swiper-slide-shadow-right")
              : $slideEl.find(".swiper-slide-shadow-bottom");
            if ($shadowBeforeEl.length === 0) {
              $shadowBeforeEl = dom7_modular_$(
                `<div class="swiper-slide-shadow-${
                  isHorizontal ? "left" : "top"
                }"></div>`
              );
              $slideEl.append($shadowBeforeEl);
            }
            if ($shadowAfterEl.length === 0) {
              $shadowAfterEl = dom7_modular_$(
                `<div class="swiper-slide-shadow-${
                  isHorizontal ? "right" : "bottom"
                }"></div>`
              );
              $slideEl.append($shadowAfterEl);
            }
            if ($shadowBeforeEl.length)
              $shadowBeforeEl[0].style.opacity =
                offsetMultiplier > 0 ? offsetMultiplier : 0;
            if ($shadowAfterEl.length)
              $shadowAfterEl[0].style.opacity =
                -offsetMultiplier > 0 ? -offsetMultiplier : 0;
          }
        }

        // Set correct perspective for IE10
        if (Support.pointerEvents || Support.prefixedPointerEvents) {
          const ws = $wrapperEl[0].style;
          ws.perspectiveOrigin = `${center}px 50%`;
        }
      },
      setTransition(duration) {
        const swiper = this;
        swiper.slides
          .transition(duration)
          .find(
            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
          )
          .transition(duration);
      },
    };

    var EffectCoverflow = {
      name: "effect-coverflow",
      params: {
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          scale: 1,
          modifier: 1,
          slideShadows: true,
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          coverflowEffect: {
            setTranslate: Coverflow.setTranslate.bind(swiper),
            setTransition: Coverflow.setTransition.bind(swiper),
          },
        });
      },
      on: {
        beforeInit() {
          const swiper = this;
          if (swiper.params.effect !== "coverflow") return;

          swiper.classNames.push(
            `${swiper.params.containerModifierClass}coverflow`
          );
          swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);

          swiper.params.watchSlidesProgress = true;
          swiper.originalParams.watchSlidesProgress = true;
        },
        setTranslate() {
          const swiper = this;
          if (swiper.params.effect !== "coverflow") return;
          swiper.coverflowEffect.setTranslate();
        },
        setTransition(duration) {
          const swiper = this;
          if (swiper.params.effect !== "coverflow") return;
          swiper.coverflowEffect.setTransition(duration);
        },
      },
    };

    const Thumbs = {
      init() {
        const swiper = this;
        const { thumbs: thumbsParams } = swiper.params;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
          swiper.thumbs.swiper = thumbsParams.swiper;
          Utils.extend(swiper.thumbs.swiper.originalParams, {
            watchSlidesProgress: true,
            slideToClickedSlide: false,
          });
          Utils.extend(swiper.thumbs.swiper.params, {
            watchSlidesProgress: true,
            slideToClickedSlide: false,
          });
        } else if (Utils.isObject(thumbsParams.swiper)) {
          swiper.thumbs.swiper = new SwiperClass(
            Utils.extend({}, thumbsParams.swiper, {
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
              slideToClickedSlide: false,
            })
          );
          swiper.thumbs.swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(
          swiper.params.thumbs.thumbsContainerClass
        );
        swiper.thumbs.swiper.on("tap", swiper.thumbs.onThumbClick);
      },
      onThumbClick() {
        const swiper = this;
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (
          clickedSlide &&
          dom7_modular_$(clickedSlide).hasClass(
            swiper.params.thumbs.slideThumbActiveClass
          )
        )
          return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null)
          return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) {
          slideToIndex = parseInt(
            dom7_modular_$(thumbsSwiper.clickedSlide).attr(
              "data-swiper-slide-index"
            ),
            10
          );
        } else {
          slideToIndex = clickedIndex;
        }
        if (swiper.params.loop) {
          let currentIndex = swiper.activeIndex;
          if (
            swiper.slides
              .eq(currentIndex)
              .hasClass(swiper.params.slideDuplicateClass)
          ) {
            swiper.loopFix();
            // eslint-disable-next-line
            swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
            currentIndex = swiper.activeIndex;
          }
          const prevIndex = swiper.slides
            .eq(currentIndex)
            .prevAll(`[data-swiper-slide-index="${slideToIndex}"]`)
            .eq(0)
            .index();
          const nextIndex = swiper.slides
            .eq(currentIndex)
            .nextAll(`[data-swiper-slide-index="${slideToIndex}"]`)
            .eq(0)
            .index();
          if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
          else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
          else if (nextIndex - currentIndex < currentIndex - prevIndex)
            slideToIndex = nextIndex;
          else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
      },
      update(initial) {
        const swiper = this;
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;

        const slidesPerView =
          thumbsSwiper.params.slidesPerView === "auto"
            ? thumbsSwiper.slidesPerViewDynamic()
            : thumbsSwiper.params.slidesPerView;

        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
          let currentThumbsIndex = thumbsSwiper.activeIndex;
          let newThumbsIndex;
          let direction;
          if (thumbsSwiper.params.loop) {
            if (
              thumbsSwiper.slides
                .eq(currentThumbsIndex)
                .hasClass(thumbsSwiper.params.slideDuplicateClass)
            ) {
              thumbsSwiper.loopFix();
              // eslint-disable-next-line
              thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
              currentThumbsIndex = thumbsSwiper.activeIndex;
            }
            // Find actual thumbs index to slide to
            const prevThumbsIndex = thumbsSwiper.slides
              .eq(currentThumbsIndex)
              .prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`)
              .eq(0)
              .index();
            const nextThumbsIndex = thumbsSwiper.slides
              .eq(currentThumbsIndex)
              .nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`)
              .eq(0)
              .index();
            if (typeof prevThumbsIndex === "undefined")
              newThumbsIndex = nextThumbsIndex;
            else if (typeof nextThumbsIndex === "undefined")
              newThumbsIndex = prevThumbsIndex;
            else if (
              nextThumbsIndex - currentThumbsIndex ===
              currentThumbsIndex - prevThumbsIndex
            )
              newThumbsIndex = currentThumbsIndex;
            else if (
              nextThumbsIndex - currentThumbsIndex <
              currentThumbsIndex - prevThumbsIndex
            )
              newThumbsIndex = nextThumbsIndex;
            else newThumbsIndex = prevThumbsIndex;
            direction =
              swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
          } else {
            newThumbsIndex = swiper.realIndex;
            direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
          }
          if (useOffset) {
            newThumbsIndex +=
              direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
          }

          if (
            thumbsSwiper.visibleSlidesIndexes &&
            thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0
          ) {
            if (thumbsSwiper.params.centeredSlides) {
              if (newThumbsIndex > currentThumbsIndex) {
                newThumbsIndex =
                  newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
              } else {
                newThumbsIndex =
                  newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
              }
            } else if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - slidesPerView + 1;
            }
            thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
          }
        }

        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
          thumbsToActivate = swiper.params.slidesPerView;
        }

        if (!swiper.params.thumbs.multipleActiveThumbs) {
          thumbsToActivate = 1;
        }

        thumbsToActivate = Math.floor(thumbsToActivate);

        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (
          thumbsSwiper.params.loop ||
          (thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled)
        ) {
          for (let i = 0; i < thumbsToActivate; i += 1) {
            thumbsSwiper.$wrapperEl
              .children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`)
              .addClass(thumbActiveClass);
          }
        } else {
          for (let i = 0; i < thumbsToActivate; i += 1) {
            thumbsSwiper.slides
              .eq(swiper.realIndex + i)
              .addClass(thumbActiveClass);
          }
        }
      },
    };
    var Thumbs$1 = {
      name: "thumbs",
      params: {
        thumbs: {
          swiper: null,
          multipleActiveThumbs: true,
          autoScrollOffset: 0,
          slideThumbActiveClass: "swiper-slide-thumb-active",
          thumbsContainerClass: "swiper-container-thumbs",
        },
      },
      create() {
        const swiper = this;
        Utils.extend(swiper, {
          thumbs: {
            swiper: null,
            init: Thumbs.init.bind(swiper),
            update: Thumbs.update.bind(swiper),
            onThumbClick: Thumbs.onThumbClick.bind(swiper),
          },
        });
      },
      on: {
        beforeInit() {
          const swiper = this;
          const { thumbs } = swiper.params;
          if (!thumbs || !thumbs.swiper) return;
          swiper.thumbs.init();
          swiper.thumbs.update(true);
        },
        slideChange() {
          const swiper = this;
          if (!swiper.thumbs.swiper) return;
          swiper.thumbs.update();
        },
        update() {
          const swiper = this;
          if (!swiper.thumbs.swiper) return;
          swiper.thumbs.update();
        },
        resize() {
          const swiper = this;
          if (!swiper.thumbs.swiper) return;
          swiper.thumbs.update();
        },
        observerUpdate() {
          const swiper = this;
          if (!swiper.thumbs.swiper) return;
          swiper.thumbs.update();
        },
        setTransition(duration) {
          const swiper = this;
          const thumbsSwiper = swiper.thumbs.swiper;
          if (!thumbsSwiper) return;
          thumbsSwiper.setTransition(duration);
        },
        beforeDestroy() {
          const swiper = this;
          const thumbsSwiper = swiper.thumbs.swiper;
          if (!thumbsSwiper) return;
          if (swiper.thumbs.swiperCreated && thumbsSwiper) {
            thumbsSwiper.destroy();
          }
        },
      },
    };

    // Swiper Class

    const components = [
      Device$1,
      Support$1,
      Browser$1,
      Resize,
      Observer$1,
      Virtual$1,
      Keyboard$1,
      Mousewheel$1,
      Navigation$1,
      Pagination$1,
      Scrollbar$1,
      Parallax$1,
      Zoom$1,
      Lazy$1,
      Controller$1,
      A11y,
      History$1,
      HashNavigation$1,
      Autoplay$1,
      EffectFade,
      EffectCube,
      EffectFlip,
      EffectCoverflow,
      Thumbs$1,
    ];

    if (typeof Swiper.use === "undefined") {
      Swiper.use = Swiper.Class.use;
      Swiper.installModule = Swiper.Class.installModule;
    }

    Swiper.use(components);

    /* harmony default export */ const swiper_esm_bundle = Swiper;
    //# sourceMappingURL=swiper.esm.bundle.js.map

    // EXTERNAL MODULE: ./node_modules/jquery-zoom/jquery.zoom.js
    var jquery_zoom = __webpack_require__(357); // CONCATENATED MODULE: ./src/javascripts/global/Zoom.js
    class Zoom_Zoom {
      /**
       * @param {import('../ThemeBase').default} theme
       * @param {HTMLElement} element
       */
      constructor(theme, element) {
        this.DURATION = 120;

        this.onZoomIn = (img) => {
          // Hide zoomed image when it's smaller then parent div,
          // it would just move but there won't be any zoom
          if (this.$element.width() >= jquery_default()(img).width()) {
            this.$element.find(".zoomImg").addClass("hide");
            return;
          } else {
            this.$element.find(".zoomImg").removeClass("hide");
          } // Hide image when zoomed image is hovered - to prevent
          // both images visible when the image is too small

          this.timer = setTimeout(() => {
            this.img.classList.add("product-image-hidden");
            this.timer = null;
          }, this.DURATION);
        };

        this.onZoomOut = () => {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }

          this.img.classList.remove("product-image-hidden");
        };

        this.destroy = () => {
          this.$element.trigger("zoom.destroy");
        };

        this.theme = theme;
        this.element = element;
        this.$element = jquery_default()(element);
        this.img = element.querySelector("img");
        this.timer = null;
        const self = this; // @ts-ignore

        this.$element.zoom({
          url: this.img.dataset.zoomImg || this.img.src,
          touch: false,
          duration: this.DURATION,
          onZoomIn: function () {
            self.onZoomIn(this);
          },
          onZoomOut: this.onZoomOut,
        });
      }
    } // CONCATENATED MODULE: ./src/javascripts/global/Media.js
    /* Polyfil template.content for IE11 */

    const templateContent = (template) => {
      if ("content" in template) {
        return document.importNode(template.content, true);
      } else {
        const fragment = document.createDocumentFragment();
        const children = template.childNodes;

        for (let i = 0; i < children.length; i++) {
          fragment.appendChild(children[i].cloneNode(true));
        }

        return fragment;
      }
    };

    class Media {
      /**
       *
       * @param {ThemeBase} theme
       * @param {HTMLElement} parent
       * @param {HTMLElement} targetElement
       * @param {boolean} autoload
       */
      constructor(theme, parent, targetElement, autoload) {
        this.isMobile = () => {
          return window.matchMedia("screen and (max-width: 767px)").matches;
        };

        this.load = () => {
          return new Promise((resolve) => {
            if (this.loaded) {
              resolve();
              return;
            }

            const template = this.parent.querySelector("template");

            if (!template) {
              this.onLoad();
              resolve();
              return;
            }

            const fragment = templateContent(template);
            const oldMedia = this.targetElement.querySelector(
              '[data-media-id="' + this.media_id + '"]'
            );

            if (oldMedia) {
              try {
                this.targetElement.removeChild(oldMedia);
              } catch (e) {
                console.error(e);
              }
            }

            if (template.parentNode === this.targetElement) {
              this.targetElement.insertBefore(fragment, template);
            } else {
              this.targetElement.appendChild(fragment);
            }

            this.mediaWrapper = this.targetElement.querySelector(
              '[data-media-id="' + this.media_id + '"]'
            );

            if (this.selected) {
              this.mediaWrapper.classList.add(
                "product-single__media--selected"
              );
            }

            switch (this.type) {
              case "model":
                window.Shopify.loadFeatures(
                  [
                    {
                      name: "model-viewer-ui",
                      version: "1.0",
                    },
                  ],
                  () => {
                    this.modelController = new window.Shopify.ModelViewerUI(
                      this.mediaWrapper.querySelector("model-viewer")
                    ); // Don't interact with the rest of the page when model is not disabled

                    this.modelController.viewer.parentElement.addEventListener(
                      "mouseup",
                      (e) => {
                        e.stopPropagation = function () {};
                      },
                      {
                        capture: true,
                      }
                    ); // Prevent activating the viewer right after it was paused when clicked in position of the button

                    this.modelController.elements.controlButton.addEventListener(
                      "click",
                      (e) => {
                        e.stopImmediatePropagation();
                      },
                      {
                        capture: true,
                      }
                    );
                    this.modelController.viewer.addEventListener(
                      "shopify_model_viewer_ui_toggle_pause",
                      this.onPause
                    );
                    this.modelController.viewer.addEventListener(
                      "shopify_model_viewer_ui_toggle_play",
                      this.onPlay
                    );
                    this.onLoad();
                    resolve();
                  }
                );
                break;

              case "video":
                window.Shopify.loadFeatures([
                  {
                    name: "video-ui",
                    version: "1.0",
                    onLoad: () => {
                      const video = this.mediaWrapper.querySelector("video");
                      const loop =
                        video.parentNode.dataset.videoLoop === "true";
                      this.plyrController = new window.Shopify.Plyr(video, {
                        loop: {
                          active: loop,
                        },
                        focusOnPlay: false,
                      });
                      video.addEventListener("play", this.onPlay);
                      video.addEventListener("pause", this.onPause);
                      video.addEventListener("ended", this.onPause);
                      this.onLoad();
                      resolve();
                    },
                  },
                ]);
                break;

              case "external_video":
                this.theme.loadYoutubeApi().then(() => {
                  const iframe = this.mediaWrapper.querySelector("iframe");
                  const loop = iframe.parentNode.dataset.videoLoop === "true";
                  new window.YT.Player(iframe, {
                    events: {
                      onReady: (event) => {
                        this.youtubeController = event.target;
                        this.onLoad();
                        resolve();
                      },
                      onStateChange: (event) => {
                        if (event.data === window.YT.PlayerState.PLAYING) {
                          this.onPlay();
                        } else if (
                          event.data === window.YT.PlayerState.PAUSED
                        ) {
                          this.onPause();
                        } else if (event.data === window.YT.PlayerState.ENDED) {
                          if (loop) {
                            this.youtubeController.playVideo();
                          } else {
                            this.onPause();
                          }
                        }
                      },
                      onError: (event) => {
                        console.warn("Youtube video error", event, event.data);
                        this.onPause();
                      },
                    },
                  });
                });
                break;

              case "image":
                this.mediaWrapper
                  .querySelector(".product-single__media img")
                  .addEventListener("load", () => {
                    if (
                      this.parent.dataset.imageZoomEnable === "true" &&
                      !this.isMobile()
                    ) {
                      new Zoom_Zoom(
                        this.theme,
                        this.mediaWrapper.querySelector(
                          ".product-single__media__image"
                        )
                      );
                    }

                    this.onLoad();
                    resolve();
                  });
                break;

              default:
                this.onLoad();
                resolve();
            }
          });
        };

        this.onLoad = () => {
          if (!this.mediaWrapper.parentNode) return;
          this.loaded = true;
          this.mediaWrapper.parentNode.classList.add(
            "product-single__media--loaded"
          );
          const e = new CustomEvent("media-load", {
            detail: {
              parent: this.parent,
              media: this,
            },
          });
          this.parent.dispatchEvent(e);

          if (window.ShopifyXR && window.ShopifyXR.setupXRElements) {
            window.ShopifyXR.setupXRElements();
          }
        };

        this.play = () => {
          if (!this.loaded) {
            this.load().then(this._play);
          } else {
            this._play();
          }
        };

        this._play = () => {
          switch (this.type) {
            case "model":
              this.modelController.play();
              this.onPlay();
              break;

            case "video":
              this.plyrController.play().then(this.onPlay).catch(console.warn);
              break;

            case "external_video":
              this.youtubeController.playVideo();
              this.onPlay();
              break;
          }
        };

        this.onPlay = () => {
          this.active = true;
          this.mediaWrapper.classList.add("product-single__media--active");

          if (!this.loaded) {
            this.loaded = true;
            this.mediaWrapper.parentNode.classList.add(
              "product-single__media--loaded"
            );
          }

          const e = new CustomEvent("media-play", {
            detail: {
              parent: this.parent,
              media: this,
            },
          });
          this.parent.dispatchEvent(e);

          if (document.activeElement === document.body) {
            // No element has focus, focus this media
            this.focus();
          }
        };

        this.autoplay = () => {
          if (jquery_default()(window).width() > 768) {
            this.play();
          }
        };

        this.pause = () => {
          if (!this.active) {
            return;
          }

          switch (this.type) {
            case "model":
              break;

            case "video":
              this.plyrController.pause();
              break;

            case "external_video":
              this.youtubeController.pauseVideo();
              break;
          }

          this.onPause();
        };

        this.togglePlay = () => {
          if (this.active) {
            this.pause();
          } else {
            this.play();
          }
        };

        this.onPause = () => {
          this.active = false;
          this.mediaWrapper.classList.remove("product-single__media--active");
          const e = new CustomEvent("media-pause", {
            detail: {
              parent: this.parent,
              media: this,
            },
          });
          this.parent.dispatchEvent(e);
        };

        this.select = () => {
          this.selected = true;

          if (this.mediaWrapper) {
            this.mediaWrapper.classList.add("product-single__media--selected");
          }
        };

        this.deselect = () => {
          if (this.selected) {
            this.selected = false;

            if (this.mediaWrapper) {
              this.mediaWrapper.classList.remove(
                "product-single__media--selected"
              );
            }
          }
        };

        this.reattach = (newTarget) => {
          this.targetElement = newTarget;

          if (this.mediaWrapper) {
            newTarget.appendChild(this.mediaWrapper);

            if (this.selected) {
              newTarget.classList.add("product-single__media--selected");
            } else {
              newTarget.classList.remove("product-single__media--selected");
            }
          }
        };

        this.scrollIntoView = (element) => {
          requestAnimationFrame(function () {
            const stickyHeaderHeight =
              jquery_default()(".sticky-header-wrapper").height() || 0;
            const y =
              element.getBoundingClientRect().top +
              window.pageYOffset -
              stickyHeaderHeight;
            window.scrollTo(0, y);
          });
        };

        this.focus = () => {
          switch (this.type) {
            case "video": {
              const plyr = this.mediaWrapper.querySelector(".plyr");

              if (plyr) {
                this.scrollIntoView(plyr);
                plyr.focus();
              }

              break;
            }

            case "model": {
              const viewer = this.mediaWrapper.querySelector("model-viewer");

              if (viewer && viewer.shadowRoot) {
                this.scrollIntoView(viewer);
                viewer.focus();
              } else {
                // Not yet loaded, try later
                setTimeout(this.focus, 1000);
              }

              break;
            }

            case "external_video": {
              const iframe = this.mediaWrapper.querySelector("iframe");
              this.scrollIntoView(iframe);
              iframe.focus();
              iframe.contentWindow.focus();
              break;
            }

            default: {
              if (this.mediaWrapper) {
                this.scrollIntoView(this.mediaWrapper);
                this.mediaWrapper.focus();
              }
            }
          }
        };

        this.destroy = () => {};

        this.theme = theme;
        this.parent = parent;
        this.media_id = parent.dataset.mediaId;
        this.type = parent.dataset.mediaType;
        this.loaded = false;
        this.active = false;
        this.plyrController = null;
        this.modelController = null;
        this.youtubeController = null;
        this.targetElement = targetElement;
        this.mediaWrapper = null;
        this.selected = this.parent.classList.contains(
          "product-single__thumbnail--selected"
        );

        if (this.selected && autoload) {
          this.load();
        }
      }
    } // CONCATENATED MODULE: ./src/javascripts/global/QuantityControls.js
    class QuantityControls {
      constructor(theme, element, updateCart) {
        this.updatePrices = (response) => {
          var items = response.items;
          var subTotal = response.items_subtotal_price;
          var numRows = this.$element.find(".line-item").length;
          var responseNumRows = response.items.length; // Note: We don't currently construct the Cart page's rows dynamically
          //       (like we do in Cart drawer).
          //       If there are any discounts, or if a discount line item no longer applies,
          //       refresh the form to let the existing logic handle it
          //       since we may need to add/remove line items.

          if (response.total_discount > 0 || numRows !== responseNumRows) {
            // Quick fix: submit form (non-ajax)
            jquery_default()("#update_quantities").click();
            return false;
          }

          response.items.forEach((item, index) => {
            var $row = this.$element.find(".id-" + item.id);

            if (response.total_discount === 0) {
              // Remove discount lines / divs
              $row
                .find(".cart-table-price")
                .html('<div class="money">--</div>');
            }

            if ($row.length > 0) {
              // Item singular price.
              $row
                .find(".cart-table-price .money")
                .html(this.theme.formatMoney(item.original_price)); // Line item total.

              $row
                .find(".cart-table-line-price")
                .html(this.theme.formatMoney(item.final_line_price));
            }
          });
          this.$element
            .find("#cart-total-final-price")
            .html(this.theme.formatMoney(response.total_price));
        };

        this.updateCartItem = (num) => {
          this.$wrapper.addClass("cart-item-quantity-active");
          var fade = num <= 0;
          var delay = fade ? this.FADE_OUT_ANIMATION_DURATION : 0; // If number of items is 1, don't do anything. We still want to use the 'remove' link.

          if (num >= 1) {
            this.cartSetQuantity(delay).always(() => {
              this.$wrapper.removeClass("cart-item-quantity-active");
            });
          } else {
            this.$wrapper.removeClass("cart-item-quantity-active");
          }
        };

        this.cartSetQuantity = (delay) => {
          var deferred = jquery_default().Deferred();
          jquery_default()(".cart-error-box").text("");
          jquery_default()
            .ajax({
              type: "POST",
              url: "/cart/update.js",
              dataType: "json",
              data: jquery_default()("#cartform").serialize(),
            })
            .then((data) => {
              deferred.resolve();
              setTimeout(() => {
                this.updatePrices(data);
              }, delay);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
              deferred.reject();
              console.error("Cart error", textStatus, jqXHR, errorThrown);
              jquery_default()(".cart-error-box")
                .empty()
                .text("Unable to update item quantity");
            });
          return deferred;
        };

        this.theme = theme;
        this.element = element;
        this.$element = jquery_default()(this.element);
        this.$wrapper = this.$element.find(".quantity-controls");
        this.FADE_OUT_ANIMATION_DURATION = 800; // ms

        var self = this;
        this.$element
          .find(".quantity-controls button.qty-plus")
          .off()
          .on("click", function (e) {
            e.preventDefault();
            var qtyInput = jquery_default()(this)
              .closest(".quantity-controls")
              .find("input.quantity-selector");
            var stockAmt = jquery_default()(this)
              .closest(".quantity-controls")
              .data("stock-count");
            let inventoryPolicy = jquery_default()(this)
              .closest(".quantity-controls")
              .data("inventory-policy");
            let inventoryManagement = jquery_default()(this)
              .closest(".quantity-controls")
              .data("inventory-management");
            var errorMsg = jquery_default()(this).parent().next();
            const val = parseInt(qtyInput.val().toString(), 10);

            if (stockAmt) {
              if (
                val < stockAmt ||
                inventoryPolicy == "continue" ||
                inventoryManagement != "shopify"
              ) {
                var newVal = val + 1;
              } else {
                errorMsg.removeClass("d-none");
                newVal = stockAmt;
              }
            } else {
              newVal = val + 1;
            }

            qtyInput.val(newVal);

            if (updateCart) {
              self.updateCartItem(newVal);
            }
          });
        this.$element
          .find(".quantity-controls button.qty-minus")
          .off()
          .on("click", function (e) {
            e.preventDefault();
            var qtyInput = jquery_default()(this)
              .closest(".quantity-controls")
              .find("input.quantity-selector");
            const val = parseInt(qtyInput.val().toString(), 10);
            var stockAmt = jquery_default()(this)
              .closest(".quantity-controls")
              .data("stock-count");
            let inventoryPolicy = jquery_default()(this)
              .closest(".quantity-controls")
              .data("inventory-policy");
            let inventoryManagement = jquery_default()(this)
              .closest(".quantity-controls")
              .data("inventory-management");
            var errorMsg = jquery_default()(this).parent().next();
            var newQty = val - 1 < 1 ? 1 : val - 1; // Never go below 1.

            qtyInput.val(newQty);

            if (
              stockAmt &&
              newQty <= stockAmt &&
              (inventoryPolicy == "continue" ||
                inventoryManagement != "shopify")
            ) {
              errorMsg.addClass("d-none");
            }

            if (updateCart) {
              self.updateCartItem(newQty);
            }
          });
        this.$element
          .find("input.quantity-selector")
          .off()
          .on("change", function (e) {
            var qtyInput = jquery_default()(this)
              .closest(".quantity-controls")
              .find("input.quantity-selector");
            var stockAmt = jquery_default()(this)
              .closest(".quantity-controls")
              .data("stock-count");
            let inventoryPolicy = jquery_default()(this)
              .closest(".quantity-controls")
              .data("inventory-policy");
            let inventoryManagement = jquery_default()(this)
              .closest(".quantity-controls")
              .data("inventory-management");
            var errorMsg = jquery_default()(this).parent().next();
            var val = parseInt(e.currentTarget.value.toString(), 10);

            if (
              val > stockAmt &&
              (inventoryPolicy !== "continue" ||
                inventoryManagement == "shopify")
            ) {
              qtyInput.val(stockAmt);
              errorMsg.removeClass("d-none");
            } else {
              qtyInput.val(val);
              errorMsg.addClass("d-none");
            }

            if (updateCart) {
              self.updateCartItem(val);
            }
          });
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/Product.js
    class Product extends Section {
      constructor(theme, _element, pageLoad, isFeaturedProduct = false) {
        super(theme, _element, pageLoad);

        this.initializeSizeGuide = () => {
          // Make all size guide content un-tabbable until it is open.
          this.$sizeGuideFocusable = this.$sizeGuideWrapper.find(
            "button, a, input, select, textarea, iframe, #size-guide__content"
          );
          this.$sizeGuideFocusable.each(function () {
            jquery_default()(this).attr("tabindex", "-1");
          });
          this.$sizeGuideLink.on("click", this.sizeGuideOpen);
          this.$sizeGuideClose.on("click", this.sizeGuideClose);
          this.$sizeGuideClose.on("keydown", this.keySizeGuideClose);
          this.$sizeGuideWrapper.on("click", this.backgroundSizeGuideClose); // Render x feather icon consistently in theme editor

          this.$sizeGuideWrapper.on("rendered", feather_default().replace());
        };

        this.initializeSlider = () => {
          var product = this;
          var container = this.element.querySelector(
            "div[data-swiper-container]"
          );
          var wrapper = this.element.querySelector("div[data-swiper-wrapper]");
          container.classList.add("swiper-container");
          wrapper.classList.add("swiper-wrapper");
          var thumbnails = this.element.querySelector(
            ".product-single__thumbnails"
          );

          if (!thumbnails) {
            return;
          }

          var numItems = this.element.querySelectorAll(
            ".product-single__thumbnail"
          ).length;
          var el = thumbnails.querySelector(".swiper-container");

          if (!el) {
            return;
          } // Do not show arrows or pagination if there is a single media item.

          const pagination = {
            el: el.parentNode.querySelector(".swiper-pagination"),
            type: "bullets",
            clickable: true,
            renderBullet: (index, className) => {
              return (
                '<span class="' +
                className +
                '"><span class="swiper-pagination-bullet-dot"></span></span>'
              );
            },
          };
          var productThumbSlider = new swiper_esm_bundle(el, {
            direction: "horizontal",
            slidesPerView: 1,
            updateOnImagesReady: true,
            spaceBetween: 20,
            threshold: 10,
            navigation: {
              nextEl: ".thumbs-direction-nav--next",
              prevEl: ".thumbs-direction-nav--prev",
            },
            pagination: pagination,
            loop: !thumbnails.classList.contains("no-arrows"),
            autoHeight: true,
            loopedSlides: 1,
            breakpoints: !this.isFeaturedProduct
              ? {
                  768: {
                    slidesPerView: el.dataset.slidesPerView,
                    direction: el.dataset.direction || "horizontal",
                    autoHeight: false,
                  },
                }
              : null,
          });
          productThumbSlider.on("slideChange", function () {
            // Go to first/last slide when prev/next is clicked on first/last slide
            var slidesPerView = this.slidesPerViewDynamic();

            if (slidesPerView === 1) {
              // One element is displayed => make it active
              product.onMediaElementSelect(this.slides[this.activeIndex], {});
            } else {
              // Multiple elements in view, moving to next should animate to first
              if (this.isEnd) {
                this.slideTo(1);
              } else if (this.isBeginning) {
                this.slideTo(this.slides.length - 1 - slidesPerView);
              }
            }

            fixThumbSliderTabindex(this);
          });
          fixThumbSliderTabindex(productThumbSlider);

          if (numItems <= 1) {
            thumbnails
              .querySelector(".swiper-pagination-bullets")
              .classList.add("hide");
          }

          const parent = el.parentNode;

          if (productThumbSlider.slidesPerViewDynamic() > 1) {
            parent.classList.add("product-single__thumbnails--carousel");
          }

          var lastBreakpoint = productThumbSlider.currentBreakpoint;
          productThumbSlider.on("resize", function (e) {
            if (this.slidesPerViewDynamic() > 1) {
              parent.classList.add("product-single__thumbnails--carousel");
            } else {
              parent.classList.remove("product-single__thumbnails--carousel");
            }

            if (this.currentBreakpoint != lastBreakpoint) {
              lastBreakpoint = this.currentBreakpoint;

              if (this.currentBreakpoint === "max") {
                el.classList.add("product-single__thumbnails--mobile");
                product.mediaToMobile();
                productThumbSlider.autoHeight = true;
                thumbnails.classList.toggle("hide", numItems < 1);
              } else {
                el.classList.remove("product-single__thumbnails--mobile");
                product.mediaToDesktop();
                productThumbSlider.autoHeight = false;
                thumbnails.classList.toggle("hide", numItems <= 1);
              }
            }
          });

          if (productThumbSlider.currentBreakpoint === "max") {
            el.classList.add("product-single__thumbnails--mobile");
            thumbnails.classList.toggle("hide", numItems < 1);
          } else if (productThumbSlider.currentBreakpoint !== undefined) {
            thumbnails.classList.toggle("hide", numItems <= 1);
          }

          const paginationEl =
            el.parentNode.querySelector(".swiper-pagination");
          paginationEl.addEventListener(
            "keydown",
            (e) => {
              // Pressing enter on active bullet will active the media and focus it
              if (e.keyCode === 13) {
                if (
                  jquery_default()(e.target).index() ===
                  productThumbSlider.activeIndex - 1
                ) {
                  this.onMediaElementSelect(
                    productThumbSlider.slides[productThumbSlider.activeIndex],
                    {
                      forcePlay: true,
                      focus: true,
                    }
                  );
                }
              }
            },
            {
              capture: true,
            }
          );

          if (productThumbSlider.device.ios) {
            paginationEl.classList.add("swiper-pagination-hide-focus");
          }

          return productThumbSlider;
        };

        this.mediaToDesktop = () => {
          // We've switched to desktop, move medias from thumbnains into separate box
          var parent = this.element.querySelector(".product-single__medias");
          this.mediaById.forEach((media) => {
            media.reattach(parent);

            if (media.loaded) {
              parent.classList.add("product-single__thumbnail--loaded");
            } else if (media.selected) {
              parent.classList.add("product-single__media--selected");
              media.load();
            }
          });
        };

        this.mediaToMobile = () => {
          // We've switched to mobile, move medias from separate box into the thumbnails
          this.mediaById.forEach((media) => {
            var parent = this.element.querySelector(
              '.product-single__thumbnail[data-media-id="' +
                media.media_id +
                '"]'
            );
            media.reattach(parent);
          });
        };

        this.preloadImages = () => {
          jquery_default()("#product-thumbnails img").each((index, el) => {
            if (jquery_default()(el).data("zoom-img")) {
              var thisUrl = "https:" + jquery_default()(el).data("zoom-img");

              try {
                var img = new Image();
                img.src = thisUrl;
              } catch (e) {
                console.error("Unable to preload image:", e);
              }
            }
          });
        };

        this.setVariantOptions = (values) => {
          var matchingVariants = this.product.variants.filter((variant) => {
            for (var i = 0; i < values.length; i++) {
              if (values[i] !== variant.options[i]) {
                return false;
              }
            }

            return true;
          });

          if (matchingVariants.length === 0) {
            this.updateVariant(null);
          } else {
            this.updateVariant(matchingVariants[0]);
          }
        };

        this.onSelectChange = () => {
          var values = this.$selects.map((index, select) => {
            return jquery_default()(select).val();
          });
          this.setVariantOptions(values);
        };

        this.onSwatchChange = () => {
          var values = [];
          this.$addToCartForm.serializeArray().forEach((option) => {
            if (option.name.indexOf("option-") === 0) {
              values[parseInt(option.name.split("-")[1], 10)] = option.value;
            }
          });
          this.setVariantOptions(values);
        };

        this.sizeGuideOpen = (e) => {
          e.preventDefault();
          jquery_default()("#size-guide__prompt").addClass(
            "size-guide--visible"
          );
          jquery_default()(".size-guide__background").addClass(
            "size-guide--visible"
          ); // Lock scrolling

          const scrollY = window.scrollY;
          document.body.style.position = "fixed";
          document.body.style.top = `-${scrollY}px`;
          document.body.style.overflowY = "scroll"; // Prevent horizontal page jump
          // Enable focus and trap focus in modal

          this.$sizeGuideFocusable.each(function () {
            jquery_default()(this).attr("tabindex", "0");
          });
          this.trapFocus();
        };

        this.trapFocus = () => {
          var inputs = jquery_default().makeArray(this.$sizeGuideFocusable);
          var firstInput = inputs[0];
          var lastInput = inputs[inputs.length - 1]; // Focus on content when modal is opened

          this.$sizeGuideContent.focus(); // Redirect last tab to first input

          lastInput.addEventListener("keydown", function (e) {
            if (e.keyCode === 9 && !e.shiftKey) {
              e.preventDefault();
              firstInput.focus();
            }
          }); // Redirect first shift+tab to last input

          firstInput.addEventListener("keydown", function (e) {
            if (e.keyCode === 9 && e.shiftKey) {
              e.preventDefault();
              lastInput.focus();
            }
          });
        };

        this.sizeGuideClose = () => {
          jquery_default()("#size-guide__prompt").removeClass(
            "size-guide--visible"
          );
          jquery_default()(".size-guide__background").removeClass(
            "size-guide--visible"
          ); // Unlock scrolling

          const scrollY = document.body.style.top;
          document.body.style.position = "";
          document.body.style.top = "";
          window.scrollTo(0, parseInt(scrollY || "0") * -1);
          document.body.style.overflowY = ""; // Remove focus

          this.$sizeGuideFocusable.each(function () {
            jquery_default()(this).attr("tabindex", "-1");
          });
          this.$sizeGuideClose.attr("tabindex", "-1");
        };

        this.keySizeGuideClose = (e) => {
          if (e.which === 13) {
            this.sizeGuideClose();
            this.$sizeGuideLink.focus(); // Return focus to size guide link
          }
        };

        this.backgroundSizeGuideClose = (e) => {
          if (e.target == e.currentTarget) {
            this.sizeGuideClose();
          }
        };

        this.onMediaElementSelect = (element, options) => {
          var media = this.mediaById.get(element.dataset.mediaId); // Pause all others

          this.mediaById.forEach((otherMedia) => {
            if (otherMedia.media_id !== media.media_id) {
              otherMedia.pause();
              otherMedia.deselect();
            }
          });
          media.select();

          if (options.togglePlay) {
            media.togglePlay();
          } else if (options.forcePlay) {
            media.play();
          } else if (options.load) {
            media.load().then(function () {
              if (options.focus) {
                media.focus();
              }
            });
          }

          if (options.focus) {
            media.focus();
          }
        };

        this.onVariantSelected = (variant_id) => {
          var matchingVariants = this.product.variants.filter((variant) => {
            return variant.id == variant_id;
          });

          if (matchingVariants.length === 0) {
            this.updateVariant(null);
          } else {
            var variant = matchingVariants[0];
            this.updateVariant(matchingVariants[0]);

            for (var i = 0; i < variant.options.length; i++) {
              const select = this.element.querySelector(
                "#SingleOptionSelector-" + i
              );

              if (!select) {
                continue;
              }

              select.value = variant.options[i];
              const e = new CustomEvent("change");
              select.dispatchEvent(e);
            }
          }
        };

        this.storeAvailability = (variantId, productTitle) => {
          var variantSectionUrl =
            "/variants/" + variantId + "/?section_id=store-availability";
          var storePickupEnabled = this.element.querySelector(
            ".store-pickup-enabled"
          );
          if (!storePickupEnabled) return;
          var availabilityContainer = document.createElement("div");
          availabilityContainer.classList.add(
            "product__store__availability__container"
          );
          var availabilityModal = document.createElement("div");
          availabilityModal.setAttribute(
            "data-store-availability-modal-container",
            ""
          );
          var targetFP = this.element.querySelector(
            ".featured-product--submit-action"
          );
          var targetEl = this.element.querySelector(
            ".product-page--local-pickup"
          );
          if (!availabilityContainer) return;
          availabilityContainer.innerHTML = "";
          fetch(variantSectionUrl)
            .then(function (response) {
              return response.text();
            })
            .then(
              function (storeAvailabilityHTML) {
                if (
                  storeAvailabilityHTML.trim() === "" ||
                  !storeAvailabilityHTML.includes(
                    '"store-availability-information"'
                  )
                ) {
                  return;
                } // Remove existing content.

                const prevContent = this.element.querySelector(
                  ".product__store__availability__container"
                );

                if (prevContent) {
                  prevContent.remove();
                }

                availabilityContainer.innerHTML = storeAvailabilityHTML;
                var stripInnerSection = availabilityContainer.querySelector(
                  ".store-availability-container"
                );
                availabilityContainer.innerHTML = stripInnerSection.innerHTML;

                if (targetFP) {
                  targetFP.after(availabilityContainer);
                  availabilityContainer.after(availabilityModal);
                } else if (targetEl) {
                  targetEl.after(availabilityContainer);
                  availabilityContainer.after(availabilityModal);
                }

                var storeAvailabilityModalOpen = this.element.querySelector(
                  "a[data-store-availability-modal-open]"
                );
                var storeAvailabilityModalProductTitle =
                  this.element.querySelector(
                    "h2[data-store-availability-modal-product-title]"
                  ); // Only create modal if open modal element exists

                if (!storeAvailabilityModalOpen) {
                  return;
                } else {
                  // Open modal
                  storeAvailabilityModalOpen.addEventListener(
                    "click",
                    function () {
                      // Trap focus within modal
                      setTimeout(function () {
                        var focusableEls = availabilityModal.querySelectorAll(
                          'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
                        );
                        var firstFocusableEl = focusableEls[0];
                        var lastFocusableEl =
                          focusableEls[focusableEls.length - 1];
                        var KEYCODE_TAB = 9;
                        availabilityModal.focus();
                        availabilityModal.addEventListener(
                          "keydown",
                          function (e) {
                            var isTabPressed =
                              e.key === "Tab" || e.keyCode === KEYCODE_TAB;

                            if (!isTabPressed) {
                              return;
                            }

                            if (e.shiftKey) {
                              /* shift + tab */
                              if (document.activeElement === firstFocusableEl) {
                                lastFocusableEl.focus();
                                e.preventDefault();
                              }
                            } else {
                              /* tab */
                              if (document.activeElement === lastFocusableEl) {
                                firstFocusableEl.focus();
                                e.preventDefault();
                              }
                            }
                          }
                        );
                      }, 500);
                      var modalContainer = this.element.querySelector(
                        "div[data-store-availability-modal-container]"
                      );
                      var availabilityModal = this.element.querySelector(
                        "#StoreAvailabilityModal"
                      );
                      var htmlBody = document.querySelector("body");
                      htmlBody.classList.add("availability-modal--open");
                      modalContainer.classList.add(
                        "store-availabilities-modal--open"
                      );
                      availabilityModal.classList.add("open");
                      availabilityModal.style = "visibility: visible;";

                      if (
                        htmlBody.classList.contains("availability-modal--open")
                      ) {
                        modalContainer.addEventListener("click", function () {
                          modalContainer.classList.remove(
                            "store-availabilities-modal--open"
                          );
                          htmlBody.classList.remove("availability-modal--open");
                          availabilityModal.classList.remove("open");
                          availabilityModal.style = "visibility: hidden;";
                        });
                      } //Modal close button

                      var availabilityModalCloseButton =
                        this.element.querySelector(
                          ".store-availabilities-modal__close"
                        );

                      if (availabilityModalCloseButton) {
                        availabilityModalCloseButton.addEventListener(
                          "click",
                          function () {
                            modalContainer.classList.remove(
                              "store-availabilities-modal--open"
                            );
                            htmlBody.classList.remove(
                              "availability-modal--open"
                            );
                            availabilityModal.classList.remove("open");
                            availabilityModal.style = "visibility: hidden;";
                          }
                        );
                      }
                    }.bind(this)
                  );
                } // Update product title

                if (!storeAvailabilityModalProductTitle) {
                  return;
                } else {
                  storeAvailabilityModalProductTitle.textContent = productTitle;
                }
              }.bind(this)
            );
        };

        this.handleVariant = (variant) => {
          this.$originalSelect.val(variant.id);
          this.storeAvailability(variant.id, this.product.title);
          var is_sale =
            variant.compare_at_price &&
            variant.compare_at_price > variant.price;
          this.$sale.toggleClass("hide", !is_sale);

          if (variant.sku) {
            this.$sku.text(variant.sku);
          }

          this.$sku.toggleClass("hide", !variant.sku);
          this.$price.html(this.theme.formatMoney(variant.price));
          this.$sale_price.html(
            is_sale ? this.theme.formatMoney(variant.compare_at_price) : ""
          );

          if (
            this.$variantPercentageWrapper.length > 0 &&
            variant.compare_at_price > variant.price
          ) {
            this.$variantPercentageWrapper.removeClass("hide");
            var percentage =
              ((variant.compare_at_price - variant.price) * 100.0) /
              variant.compare_at_price;
            this.$variantPercentageWrapper
              .find(".variant-percentage")
              .text(percentage.toFixed(0) + "%");
          } else {
            this.$variantPercentageWrapper.addClass("hide");
          }

          if (
            this.$variantValueWrapper.length > 0 &&
            variant.compare_at_price > variant.price
          ) {
            this.$variantValueWrapper.removeClass("hide");
            var value = variant.compare_at_price - variant.price;
            this.$variantValueWrapper
              .find(".variant-value")
              .html(this.theme.formatMoney(value));
          } else {
            this.$variantValueWrapper.addClass("hide");
          }

          if (variant.unit_price_measurement) {
            this.$pricePerUnit.html(
              '<span class="price">(' +
                this.theme.formatMoney(variant.unit_price) +
                " / " +
                (variant.unit_price_measurement.reference_value != 1
                  ? variant.unit_price_measurement.reference_value
                  : "") +
                " " +
                variant.unit_price_measurement.reference_unit +
                ")"
            );
          } else {
            this.$pricePerUnit.text("");
          }

          if (!variant.available) {
            this.showVariantOutOfStockForm(this.product.title, variant.title);
            this.$cart.prop("disabled", true);
            this.$spb
              .css({
                opacity: 1,
              })
              .animate({
                opacity: 0,
              })
              .hide();
            if (document.querySelector(".custom-bis-trigger"))
              document.querySelector(".custom-bis-trigger").style.display =
                "block";
            this.$cart.text(this.theme.translations.soldOut); // @ts-ignore

            jquery_default().event.trigger({
              type: "variantUnavailable",
              time: new Date(),
              variant: variant,
            });
          } else {
            this.hideVariantOutOfStockForm();
            this.$cart.prop("disabled", false);
            this.$spb
              .show()
              .css({
                opacity: 1,
              })
              .animate({
                opacity: 1,
              });
            this.$cart.text(this.theme.translations.addToCart); // @ts-ignore

            if (document.querySelector(".custom-bis-trigger"))
              document.querySelector(".custom-bis-trigger").style.display =
                "none";

            jquery_default().event.trigger({
              type: "variantAvailable",
              time: new Date(),
            });
          }

          if (variant.featured_media) {
            const mediaIndex = this.product.media.findIndex(
              (m) => m.id === variant.featured_media.id
            );

            if (mediaIndex >= 0) {
              var $newImageThumb = this.$element.find(
                '.product-single__thumbnail[data-media-id$="' +
                  variant.featured_media.id +
                  '"]'
              );
              this.onMediaElementSelect($newImageThumb[0], {
                load: true,
              });

              if (this.slider.slidesPerViewDynamic() === 1) {
                // Mobile view active
                this.slider.slideToLoop(mediaIndex);
              }
            }
          }

          var is_indiv_product = this.$element
            .closest(".shopify-section")
            .hasClass("homepage-section--indiv-product-wrapper");
          var has_more_variants = this.product.variants.length > 1;

          if (
            window.history.replaceState &&
            !is_indiv_product &&
            has_more_variants
          ) {
            // Change url to include variant if we're not on homepage
            var search = [];

            if (window.location.search.length > 1) {
              // select non-variant query params
              search = window.location.search
                .slice(1)
                .split("&")
                .filter(function (q) {
                  return q.indexOf("variant=") !== 0;
                });
            } // add current variant

            search.push("variant=" + variant.id); // set the url to include the variant

            var newurl =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?" +
              search.join("&");
            window.history.replaceState(
              {
                path: newurl,
              },
              "",
              newurl
            );
          } // Swatches

          if (this.$swatchInputs.length > 0) {
            var section_id = this.$element.data("section-id");
            variant.options.forEach((option, index) => {
              this.$swatchInputs
                .filter(
                  "#section-" +
                    section_id +
                    "-swatch-" +
                    index +
                    "-" +
                    toHandle(option)
                )
                .prop("checked", true);
            });
          }
        };

        this.handleNullVariant = () => {
          var makeASelection =
            this.$selects.filter(function (index, select) {
              return jquery_default()(select).val() === "";
            }).length > 0;

          if (makeASelection) {
            this.$price.text(this.theme.translations.makeASelection);
          } else {
            this.$price.text(this.theme.translations.unavailable);
            this.hideVariantOutOfStockForm();
          }

          this.$cart.prop("disabled", true);
          this.$sale.addClass("hide");
          this.$variantPercentageWrapper.addClass("hide");
          this.$variantValueWrapper.addClass("hide");
          this.$sku.addClass("hide");
        };

        this.updateVariant = (variant) => {
          if (variant) {
            this.handleVariant(variant);
          } else {
            this.handleNullVariant();
          }
        };

        this.CART_LOADING =
          '<div class="lds-dual-ring"></div><span class="sr-only">Loading...</span>';

        this.addToCart = () => {
          this.clearError();
          jquery_default().ajax({
            url: this.config.shopifyAjaxAddUrl,
            dataType: "json",
            type: "post",
            async: false,
            data: this.$addToCartForm.serialize(),
            success: this.addedToCart,
            error: this.addToCartFailed,
          });
        };

        this.disableCartButton = () => {
          if (this.addedTextTimeout) {
            clearTimeout(this.addedTextTimeout);
            this.addedTextTimeout = null;
          }

          this.$cart
            .addClass("disabled")
            .prop("disabled", true)
            .html(this.CART_LOADING);
        };

        this.enableCartButton = () => {
          if (this.addedTextTimeout) {
            clearTimeout(this.addedTextTimeout);
            this.addedTextTimeout = null;
          }

          this.$cart
            .removeClass("disabled")
            .prop("disabled", false)
            .html(this.theme.translations.addToCart);
        };

        this.addedToCart = (itemData) => {
          this.updateCart();
        };

        this.openCartPage = () => {
          window.location.href = this.$addToCartForm
            .find("#cart-link")
            .val()
            .toString();
        };

        this.showCart = () => {
          jquery_default()(".js-cart-drawer-status")
            .text(`Item added to your cart`)
            .appendTo(".cart-drawer__top");
          this.$cartSliderWrapper.trigger("cart:open");
        };

        this.updateCart = () => {
          jquery_default()
            .ajax({
              cache: false,
              url: this.config.shopifyAjaxUrl,
              dataType: "json",
            })
            .then(this.updatedCart)
            .fail(this.updateCartFailed);
        };

        this.updatedCart = (data) => {
          this.theme.updateCartDrawer(data);
          this.enableCartButton();
          var cart_action = this.$cart.data("cart-action");

          if (cart_action === "cart") {
            this.openCartPage();
          } else if (cart_action === "added") {
            this.$cart.html(this.theme.translations.added); // Update cart count.

            this.$cartCount.text(data.item_count);

            if (this.addedTextTimeout) {
              clearTimeout(this.addedTextTimeout);
              this.addedTextTimeout = null;
            }

            this.addedTextTimeout = setTimeout(() => {
              this.$cart.html(this.theme.translations.addToCart);
            }, 2000);
          } else {
            // cart_action === drawer
            this.showCart();
          }
        };

        this.updateCartFailed = (response) => {
          this.enableCartButton();
          console.error("Updating the cart failed: ", response);
        };

        this.addToCartFailed = (response) => {
          this.enableCartButton();
          var errorText = "Unknown error";

          if (response.status == 0) {
            // Unable to connect to server
          } else if (response.responseJSON) {
            // Process JSON error
            if (response.responseJSON.description) {
              errorText = response.responseJSON.description;
            } else {
              errorText = response.responseJSON.message;
            }
          } else if (response.responseText) {
            // Use plain text error
            errorText = response.responseText;
          }

          this.showError(errorText);
        };

        this.showError = (text) => {
          jquery_default()('<div id="cart-error"></div>')
            .addClass("alert alert-danger")
            .text(text)
            .insertAfter(this.$cart);
        };

        this.clearError = () => {
          jquery_default()("#cart-error").remove();
        };

        this.loadTabs = () => {
          jquery_default()("ul.tabs").each(function () {
            const links = jquery_default()(this).find("a");
            let active = links.first().addClass("active");
            let content = jquery_default()(active.attr("href"));
            links.not(":first").each(function () {
              jquery_default()(jquery_default()(this).attr("href")).hide();
            });
            jquery_default()(this)
              .find("a")
              .on("click", function (e) {
                active.removeClass("active");
                content.hide();
                active = jquery_default()(this);
                content = jquery_default()(jquery_default()(this).attr("href"));
                active.addClass("active");
                content.fadeIn();
                return false;
              });
          });
        };

        this.loadSlider = () => {
          this.$element.find(".mobile-product-slider").flexslider({
            animation: "slide",
            directionNav: false,
            controlNav: true,
            startAt: 0,
            slideshow: false,
          });
        };

        this.showVariantOutOfStockForm = (productTitle, variantTitle) => {
          if (
            this.$element
              .find(".product-description-main-wrapper")
              .data("stock-email-enabled")
          ) {
            var $outOfStockEmailBody = this.$element.find(
              '#notify-me-wrapper input[name="contact[body]"]'
            );
            var $emailString = `Please notify me when ${productTitle}, variant: ${variantTitle} becomes available.`;
            var varTitleContainer = document.querySelector("#variant_title");
            var getform = document.querySelector("#sold-out");
            var getSubmitBtn = document.querySelector(
              "#notify-me-wrapper .btn"
            );

            if (!varTitleContainer) {
              return;
            } else {
              varTitleContainer.innerText = "- " + variantTitle;
            }

            getform.addEventListener("submit", function () {
              getSubmitBtn.value = "";
            });
            $outOfStockEmailBody.val($emailString);
            this.$element.find(".variant-out-of-stock").fadeIn();
          }
        };

        this.hideVariantOutOfStockForm = () => {
          if (
            this.$element
              .find(".product-description-main-wrapper")
              .data("stock-email-enabled")
          ) {
            this.$element.find(".variant-out-of-stock").hide();
            this.$element
              .find(".product-page--submit-action")
              .removeClass("hidden");
          }
        };

        this.responsiveTables = () => {
          this.$element
            .find(".product-description-wrapper table")
            .wrap('<div class="rte__table-wrapper"></div>');
        };

        this.isFeaturedProduct = isFeaturedProduct; // Settings

        this.config = {
          shopifyAjaxAddUrl: "/cart/add.js",
          shopifyAjaxUrl: "/cart.js",
        };
        this.$element = jquery_default()(_element);
        this.sectionId = this.element.dataset.sectionId;
        var productScript = this.element.querySelector(".product-json");

        if (!productScript) {
          // Product is not loaded, there is either no product section or the product is not selected
          return;
        }

        this.product = JSON.parse(productScript.textContent);
        this.$selects = this.$element.find(
          ".selector-wrapper select, .product-option-select select"
        );
        this.$selects.on("change", this.onSelectChange);
        this.$originalSelect = this.$element.find(".original-select");
        this.$old_price = this.$element.find(".compare-at-price .money");
        this.$price = this.$element.find("#price-field");
        this.$cart = this.$element.find("#purchase");
        this.$cartCount = jquery_default()(".cart-item-count-header--quantity");
        this.$spb = this.$element.find(".shopify-payment-button");
        this.$sale = this.$element.find(".sale-badge,.compare-at-price");
        this.$sale_price = this.$element.find(".compare-at-price");
        this.$pricePerUnit = this.$element.find(
          ".product-page--pricing--price-per-unit"
        );
        this.$variantPercentageWrapper = this.$element.find(
          ".variant-percentage-wrapper"
        );
        this.$variantValueWrapper = this.$element.find(
          ".variant-value-wrapper"
        );
        this.$variantValue = this.$element.find(".variant-value");
        this.$featuredImageWrapper = this.$element.find(".featured-image-div");
        this.$featuredImage = this.$element.find(".product-main-image");
        this.$addToCartForm = this.$element.find("#add-to-cart-form");
        this.$mobileSlider = this.$element.find(".mobile-product-slider");
        this.$cartSliderWrapper = jquery_default()("#cartSlideoutWrapper");
        this.$thumbnails = this.$element.find(".product-single__thumbnail");
        this.$swatchInputs = this.$element
          .find("#add-to-cart-form")
          .find(".swatch input");
        this.$swatchLabels = this.$element
          .find("#add-to-cart-form")
          .find(".swatch label");
        this.$sku = this.$element.find(".indiv-product-sku-text");
        this.$sizeGuideLink = this.$element.find(".size-guide-link");
        this.$sizeGuideClose = this.$element.find(".size-guide__close-btn");
        this.$sizeGuideWrapper = this.$element.find(".size-guide__background");
        this.$sizeGuidePrompt = this.$element.find("#size-guide__prompt");
        this.$sizeGuideContent = this.$element.find("#size-guide__content");
        this.$sizeGuideFocusable = null;
        this.storeAvailabilityContainer = this.$element.find(
          "[data-store-availability-container]"
        );
        this.zoomSelector = ".zoomImg";
        this.addedTextTimeout = null;
        this.slider = this.initializeSlider(); // Load media

        this.mediaById = new Map();
        var isMobile = window.matchMedia(
          "screen and (max-width: 767px)"
        ).matches;
        var autoload = !isMobile;
        this.mediaTarget = this.element.querySelector(
          ".product-single__medias"
        );
        Array.prototype.forEach.call(
          this.element.querySelectorAll(
            ".product-single__thumbnail:not(.swiper-slide-duplicate)"
          ),
          (media_root) => {
            var media = new Media(
              this.theme,
              media_root,
              isMobile || this.isFeaturedProduct
                ? media_root
                : this.mediaTarget,
              autoload
            );
            this.mediaById.set(media_root.dataset.mediaId, media); // Enable/disable drag to next slide when media is paused/playing

            media_root.addEventListener("media-play", () => {
              this.slider.allowTouchMove = false;
            });
            media_root.addEventListener("media-pause", () => {
              this.slider.allowTouchMove = true;
            });
          }
        );

        if (this.$element.find(".product-single__view-in-space").length > 0) {
          // The "View in your space" button is there => we have a model. Load XR library so
          // it can show/hide the button based on browser/device support
          window.Shopify.loadFeatures([
            {
              name: "shopify-xr",
              version: "1.0",
            },
          ]);
        }

        var self = this;

        if (this.$swatchLabels.length > 0) {
          this.$swatchLabels.each((index, label) => {
            jquery_default()(label).on("keypress", (e) => {
              var key = e.which; // Enter key

              if (key == 13) {
                // Check swatch input.
                const labelFor = jquery_default()(e.target).attr("for");
                jquery_default()("#" + labelFor).prop("checked", true);
                self.onSwatchChange();
              }
            });
          });
        }

        if (this.$swatchInputs.length > 0) {
          // Check swatched based on variant
          this.onSwatchChange();
        } else {
          // Fill variant based on selection
          this.onSelectChange();
        }

        this.$cart.on("click", (e) => {
          e.preventDefault();
          this.disableCartButton();
          this.addToCart();
        }); // Ensure the change event is fired on the form when variants changed (for Shop Pay Installments)

        this.selects = this.element.querySelectorAll(
          ".selector-wrapper select, .product-option-select select"
        );
        this.addToCartForm = this.element.querySelector("#add-to-cart-form");
        this.selects.forEach((select) => {
          select.addEventListener("change", function () {
            const event = new Event("change");
            self.addToCartForm.dispatchEvent(event);
          });
        }); // Handle thumbnail and media click

        this.$thumbnails.off("click keydown").on("click keydown", (e) => {
          if (e.type === "keydown") {
            if (e.keyCode !== 13 && e.keyCode !== 27) {
              return;
            }

            if (
              e.target.classList.contains("shopify-model-viewer-ui__button") ||
              e.target.classList.contains("plyr__control")
            ) {
              return;
            }
          }

          e.preventDefault();

          if (e.target.classList.contains("product-single__view-in-space")) {
            // Don't do anything on "view in your space" click, it's handled by Shopify XR library
            return;
          }

          if (
            e.target.tagName === "MODEL-VIEWER" ||
            e.target.classList.contains(
              "shopify-model-viewer-ui__controls-overlay"
            )
          ) {
            // Don't do anything on 3d model overlay click, it will trigger an event itself
            return;
          }

          if (e.target.classList.contains("plyr__control")) {
            // Don't do anything on plyr button click
            return;
          }

          if (
            e.currentTarget.dataset.mediaType === "image" &&
            this.slider.slidesPerViewDynamic() === 1
          ) {
            // Image is clicked when there are no thumbnails, do nothing
            return;
          }

          const isLoaded = e.currentTarget.classList.contains(
            "product-single__media--loaded"
          );
          const isActive = e.currentTarget.classList.contains(
            "product-single__media--active"
          );

          if (isLoaded && isActive) {
            // Loaded and active media will handle click internally in the component itself
            return;
          }

          this.onMediaElementSelect(e.currentTarget, {
            load: true,
            togglePlay: true,
            focus: true,
          });
        });
        this.$swatchInputs.on("change", this.onSwatchChange);

        if (this.$sizeGuideWrapper.length > 0) {
          this.initializeSizeGuide();
        }

        this.preloadImages();
        this.loadTabs();
        this.loadSlider();
        this.quantityControls = new QuantityControls(this.theme, this.element);
        this.responsiveTables();
      }
    }

    function toHandle(o) {
      return o.toLowerCase().replace(/[()]/g, "").replace(/[\W]/g, "-");
    }

    function fixThumbSliderTabindex(slider) {
      // Only make thumbnails from current view tab-navigatable
      var slidesPerView = slider.slidesPerViewDynamic();
      var activeStart = slider.activeIndex;
      var activeEnd = activeStart + slidesPerView;
      slider.slides.each(function (index, slide) {
        var tabindex = index >= activeStart && index < activeEnd ? "0" : "-1";
        var icon = slide.querySelector(".product-single__media__icon");

        if (icon) {
          icon.setAttribute("tabindex", tabindex);
        }

        jquery_default()(slide)
          .find(
            ".product-single__media__icon, button, model-viewer, input:not([hidden]), .plyr, iframe, a, select, textarea"
          )
          .attr("tabindex", tabindex);
      });
    } // CONCATENATED MODULE: ./src/javascripts/sections/FeaturedProduct.js
    class FeaturedProduct extends Product {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad, true);

        this.loadSlider = () => {
          this.$element
            .find(".homepage-sections--indiv-product-slider")
            .flexslider({
              directionNav: false,
              slideshow: false,
              animation: "slide",
            });
        };
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/ShopTheLook.js
    class ShopTheLook extends Section {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);
        let getDots = this.element.querySelectorAll(".stl__dot--container");

        const setActiveItem = (el) => {
          // Remove the active class from sibling dots and add active class to the currently selected dot
          removeActiveClassFromMultipleEls("stl__dot--active");
          el.parentElement.blur();
          el.parentElement.classList.add("stl__dot--active"); // Fade the inactive products and remove the fade class from the selected product

          addClassToMultipleEls(".stl__products", "stl__product--faded");
          const activeProduct = this.element.querySelector(
            `[data-stl-product-block-id="${el.dataset.stlDotBlockId}"]`
          );
          removeClassFromSingleEl(activeProduct, "stl__product--faded");
          scrollToActiveProduct(activeProduct);
        };

        const deselectActiveItem = (el) => {
          if (!el.hasAttribute("data-index")) {
            removeActiveClassFromMultipleEls("stl__dot--active");
            removeActiveClassFromMultipleEls("stl__product--faded");
          }
        };

        const blockSelectHandler = (e) => {
          const getBlockItem = this.element.querySelector(
            `[data-stl-dot-block-id="${e.detail.blockId}"]`
          );
          setActiveItem(getBlockItem);
        };

        const blockDeselectHandler = () => {
          removeActiveClassFromMultipleEls("stl__dot--active");
          removeActiveClassFromMultipleEls("stl__product--faded");
        };

        const removeActiveClassFromMultipleEls = (activeClass) => {
          const getActiveItems = this.element.querySelectorAll(
            `.${activeClass}`
          );
          getActiveItems.forEach((item) =>
            item.classList.remove(`${activeClass}`)
          );
        };

        const addClassToMultipleEls = (els, classToAdd) => {
          const getEls = this.element.querySelectorAll(`${els}`);
          getEls.forEach((item) => item.classList.add(`${classToAdd}`));
        };

        const removeClassFromSingleEl = (el, classToRemove) =>
          el.classList.remove(`${classToRemove}`);

        const scrollToActiveProduct = (activeProduct) => {
          if (window.innerWidth < 768)
            activeProduct.scrollIntoView({
              behavior: "smooth",
              block: "end",
            });
        };

        if (getDots.length > 0) {
          document.addEventListener("click", (e) =>
            deselectActiveItem(e.target)
          );

          if (window.Shopify.designMode) {
            document.addEventListener(
              "shopify:block:select",
              blockSelectHandler
            );
            document.addEventListener(
              "shopify:block:deselect",
              blockDeselectHandler
            );
          }

          getDots.forEach((dot) => {
            dot.addEventListener("click", (e) => setActiveItem(e.target));
            dot.addEventListener("keypress", (e) => {
              if (e.keyCode === 13) setActiveItem(e.target);
            });
          });
        }
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/ProductRecommendations.js
    /* provided dependency */ var ProductRecommendations_$ =
      __webpack_require__(755);

    class ProductRecommendations extends Section {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);

        this.load = () => {
          // Read product id from data attribute
          var productId = this.element.dataset.productId; // Read limit from data attribute

          var limit = this.element.dataset.limit; // Get section id

          var sectionId = this.element.dataset.wethemeSectionId; // Build request URL

          var requestUrl = `${this.element.dataset.recommendationsUrl}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`; // Create request and submit it using Ajax

          var request = new XMLHttpRequest();
          request.open("GET", requestUrl);

          request.onload = () => this.onLoad(request);

          request.send();
        };

        this.onLoad = (request) => {
          if (request.status >= 200 && request.status < 300) {
            var container = document.createElement("div");
            container.innerHTML = request.response; // FIXME this could overwrite `this`, do we need to address that?

            this.element.parentElement.innerHTML = container.querySelector(
              ".product-recommendations"
            ).innerHTML;
            this.gridSwatches();
          } else {
            console.warn(
              "Recommend products cannot be loaded:",
              request.responseText
            );
          }
        };

        this.gridSwatches = () => {
          ProductRecommendations_$(".indiv-product__swatches")
            .find("input")
            .on("change", function () {
              var updateImage =
                ProductRecommendations_$(this).attr("data-href");
              var targetImage = ProductRecommendations_$(this)
                .closest(".indiv-product")
                .find(".grid__image img");
              targetImage.attr({
                src: updateImage,
              });
              targetImage.attr({
                srcset: updateImage,
              });
              targetImage.data({
                lowsrc: updateImage,
              });
              targetImage.data({
                srcset: updateImage,
              });
            });
        };

        this.load();
      }
    } // CONCATENATED MODULE: ./src/javascripts/global/Parallax.js
    class Parallax_Parallax extends Component {
      constructor(theme, element) {
        super(theme, element);

        this.onWindowResize = () => {
          this.img_height = jquery_default()(this.img).height();
          this.container_height =
            (this.$element.height() > 0
              ? this.$element.height()
              : this.img_height) || 500; // Parallax is disabled on mobile

          this.active = !window.matchMedia("screen and (max-width: 767px)")
            .matches;
          this.update();
        };

        this.update = () => {
          if (!this.active) {
            this.img.style.transform = "";
            return;
          }

          var scrollTop =
            document.body.scrollTop || document.documentElement.scrollTop;
          var parallax_dist = this.img_height - this.container_height;
          var top = this.element.getBoundingClientRect().top + scrollTop;
          var bottom = top + this.container_height;
          var windowHeight = window.innerHeight;
          var windowBottom = scrollTop + windowHeight;
          var percentScrolled =
            (windowBottom - top) / (this.container_height + windowHeight);
          var parallax = parallax_dist * percentScrolled;

          if (bottom > scrollTop && top < scrollTop + windowHeight) {
            this.img.style.transform =
              "translate3D(-50%," + parallax + "px, 0)";
          }
        };

        this.theme = theme;
        this.element = element;
        this.$element = jquery_default()(element);
        this.img = element.querySelector(".img");
        this.active = false; // Wait for image load

        this.$element
          .children(".img")
          .one("load", () => {
            this.onWindowResize();
            this.img.style.display = "block";
          })
          .each(function () {
            if (this.complete || !this.src) {
              jquery_default()(this).trigger("load");
            }
          });
        window.addEventListener("scroll", this.update.bind(this), {
          capture: true,
          passive: true,
        });
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/Image.js
    class Image_Image extends Section {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);
        const parallaxEl = element.querySelector(".parallax");

        if (parallaxEl) {
          this.parallax = new Parallax_Parallax(theme, parallaxEl);
        }
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/ImageWithTextBlock.js
    class ImageWithTextBlock extends Section {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);
        const parallaxEl = element.querySelector(".parallax-enabled");

        if (parallaxEl) {
          this.parallax = new Parallax_Parallax(theme, parallaxEl);
        }
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/ImageWithTextOverlay.js
    class ImageWithTextOverlay extends Section {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);
        const parallaxEl = element.querySelector(".parallax");

        if (parallaxEl) {
          this.parallax = new Parallax_Parallax(theme, parallaxEl);
        }
      }
    } // CONCATENATED MODULE: ./node_modules/ajaxinate/src/ajaxinate.js
    /* @preserve
     * https://github.com/Elkfox/Ajaxinate
     * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
     * MIT License (do not remove above copyright!)
     */

    /* Configurable options;
     *
     * method: scroll or click
     * container: selector of repeating content
     * pagination: selector of pagination container
     * offset: number of pixels before the bottom to start loading more on scroll
     * loadingText: 'Loading', The text shown during when appending new content
     * callback: null, callback function after new content is appended
     *
     * Usage;
     *
     * import {Ajaxinate} from 'ajaxinate';
     *
     * new Ajaxinate({
     *   offset: 5000,
     *   loadingText: 'Loading more...',
     * });
     */

    /* eslint-env browser */
    function Ajaxinate(config) {
      const settings = config || {};

      const defaults = {
        method: "scroll",
        container: "#AjaxinateContainer",
        pagination: "#AjaxinatePagination",
        offset: 0,
        loadingText: "Loading",
        callback: null,
      };

      // Merge custom configs with defaults
      this.settings = Object.assign(defaults, settings);

      // Functions
      this.addScrollListeners = this.addScrollListeners.bind(this);
      this.addClickListener = this.addClickListener.bind(this);
      this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
      this.preventMultipleClicks = this.preventMultipleClicks.bind(this);
      this.removeClickListener = this.removeClickListener.bind(this);
      this.removeScrollListener = this.removeScrollListener.bind(this);
      this.removePaginationElement = this.removePaginationElement.bind(this);
      this.destroy = this.destroy.bind(this);

      // Selectors
      this.containerElement = document.querySelector(this.settings.container);
      this.paginationElement = document.querySelector(this.settings.pagination);
      this.initialize();
    }

    Ajaxinate.prototype.initialize = function initialize() {
      if (!this.containerElement) {
        return;
      }

      const initializers = {
        click: this.addClickListener,
        scroll: this.addScrollListeners,
      };

      initializers[this.settings.method]();
    };

    Ajaxinate.prototype.addScrollListeners = function addScrollListeners() {
      if (!this.paginationElement) {
        return;
      }

      document.addEventListener("scroll", this.checkIfPaginationInView);
      window.addEventListener("resize", this.checkIfPaginationInView);
      window.addEventListener(
        "orientationchange",
        this.checkIfPaginationInView
      );
    };

    Ajaxinate.prototype.addClickListener = function addClickListener() {
      if (!this.paginationElement) {
        return;
      }

      this.nextPageLinkElement = this.paginationElement.querySelector("a");
      this.clickActive = true;

      if (
        typeof this.nextPageLinkElement !== "undefined" &&
        this.nextPageLinkElement !== null
      ) {
        this.nextPageLinkElement.addEventListener(
          "click",
          this.preventMultipleClicks
        );
      }
    };

    Ajaxinate.prototype.preventMultipleClicks = function preventMultipleClicks(
      event
    ) {
      event.preventDefault();

      if (!this.clickActive) {
        return;
      }

      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.clickActive = false;

      this.loadMore();
    };

    Ajaxinate.prototype.checkIfPaginationInView =
      function checkIfPaginationInView() {
        const top =
          this.paginationElement.getBoundingClientRect().top -
          this.settings.offset;
        const bottom =
          this.paginationElement.getBoundingClientRect().bottom +
          this.settings.offset;

        if (top <= window.innerHeight && bottom >= 0) {
          this.nextPageLinkElement = this.paginationElement.querySelector("a");
          this.removeScrollListener();

          if (this.nextPageLinkElement) {
            this.nextPageLinkElement.innerText = this.settings.loadingText;
            this.nextPageUrl = this.nextPageLinkElement.href;

            this.loadMore();
          }
        }
      };

    Ajaxinate.prototype.loadMore = function loadMore() {
      this.request = new XMLHttpRequest();

      this.request.onreadystatechange = function success() {
        if (!this.request.responseXML) {
          return;
        }
        if (!this.request.readyState === 4 || !this.request.status === 200) {
          return;
        }

        const newContainer = this.request.responseXML.querySelectorAll(
          this.settings.container
        )[0];
        const newPagination = this.request.responseXML.querySelectorAll(
          this.settings.pagination
        )[0];

        this.containerElement.insertAdjacentHTML(
          "beforeend",
          newContainer.innerHTML
        );

        if (typeof newPagination === "undefined") {
          this.removePaginationElement();
        } else {
          this.paginationElement.innerHTML = newPagination.innerHTML;

          if (
            this.settings.callback &&
            typeof this.settings.callback === "function"
          ) {
            this.settings.callback(this.request.responseXML);
          }

          this.initialize();
        }
      }.bind(this);

      this.request.open("GET", this.nextPageUrl);
      this.request.responseType = "document";
      this.request.send();
    };

    Ajaxinate.prototype.removeClickListener = function removeClickListener() {
      this.nextPageLinkElement.removeEventListener(
        "click",
        this.preventMultipleClicks
      );
    };

    Ajaxinate.prototype.removePaginationElement =
      function removePaginationElement() {
        this.paginationElement.innerHTML = "";
        this.destroy();
      };

    Ajaxinate.prototype.removeScrollListener = function removeScrollListener() {
      document.removeEventListener("scroll", this.checkIfPaginationInView);
      window.removeEventListener("resize", this.checkIfPaginationInView);
      window.removeEventListener(
        "orientationchange",
        this.checkIfPaginationInView
      );
    };

    Ajaxinate.prototype.destroy = function destroy() {
      const destroyers = {
        click: this.removeClickListener,
        scroll: this.removeScrollListener,
      };

      destroyers[this.settings.method]();

      return this;
    };

    /* harmony default export */ const ajaxinate =
      /* unused pure expression or super */ null && Ajaxinate; // CONCATENATED MODULE: ./src/javascripts/sections/Collection.js

    // Used on Collections for Infinite Scroll & Load More
    // Note:  This function is overriding the version in the npm package, because
    //        that version breaks in the Theme editor.
    //        Github issue reference: https://github.com/Elkfox/Ajaxinate/issues/26

    Ajaxinate.prototype.loadMore =
      function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
        this.request = new XMLHttpRequest();

        this.request.onreadystatechange = function success() {
          var parser = new DOMParser();
          var htmlDoc = parser.parseFromString(
            this.request.responseText,
            "text/html"
          );

          if (this.request.readyState === 4 && this.request.status === 200) {
            var newContainer = htmlDoc.querySelectorAll(
              this.settings.container
            )[0];
            var newPagination = htmlDoc.querySelectorAll(
              this.settings.pagination
            )[0];
            this.containerElement.insertAdjacentHTML(
              "beforeend",
              newContainer.innerHTML
            );
            this.paginationElement.innerHTML = newPagination.innerHTML;

            if (
              this.settings.callback &&
              typeof this.settings.callback === "function"
            ) {
              this.settings.callback(this.request.responseXML);
            }

            this.initialize();
          }
        }.bind(this);

        this.request.open("GET", this.nextPageUrl);
        this.request.overrideMimeType("text/html");
        this.request.send();
      };

    // FIXME: make all the jquery relative to `this.element`

    class Collection extends Section {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);

        this.colorSwatchCheck = () => {
          // Check whether each color in a swatch for a product in the grid is fully sold out.
          // Only mark a color as crossed out if that color is sold out over ALL variants.
          jquery_default()(
            ".indiv-product__swatches.colour label, .indiv-product__swatches.color label"
          ).each(function (index, label) {
            const labelFor = jquery_default()(label).attr("for");
            const thisInputVal = jquery_default()("#" + labelFor).val();
            const productJson = jquery_default()(label)
              .closest(".indiv-product")
              .find(".product-grid-json")
              .get(0);
            if (!productJson) return;
            const productJsonData = JSON.parse(productJson.textContent);
            var matchingVariants = productJsonData.variants.filter(
              (variant) => {
                // If the variant option uses this label value, and the variant is available for sale.
                if (
                  variant.options.indexOf(thisInputVal) > -1 &&
                  variant.available == true
                )
                  return true;
                return false;
              }
            );

            if (matchingVariants.length === 0) {
              jquery_default()(label).addClass("soldout");
            }
          });
        };

        this.loadPaging = () => {
          if (jquery_default()("#AjaxinateInfiniteScrolling").length) {
            new Ajaxinate({
              container: "#AjaxinateContainer",
              pagination: "#AjaxinateInfiniteScrolling",
              method: "scroll",
              loadingText: "Loading",
              offset: 500,
            });
          }

          if (jquery_default()("#AjaxinateLoadMore").length) {
            new Ajaxinate({
              container: "#AjaxinateContainer",
              pagination: "#AjaxinateLoadMore",
              method: "click",
              loadingText: "Loading",
            });
          }
        };

        this.loadTagFilter = () => {
          /* Product Tag Filters - Good for any number of filters on any type of collection pages */
          var collFilters = jquery_default()(".coll-filter");
          collFilters.on("change", function () {
            var newTags = [];
            collFilters.each(function () {
              var val = jquery_default()(this).val();

              if (val) {
                newTags.push(val);
              }
            });

            if (newTags.length) {
              var query = newTags.join("+");
              window.location.href = jquery_default()("#link-to-tag-generic a")
                .attr("href")
                .replace(/\/tag($|\?)/, "/" + query + "$1");
            } else {
              window.location.href = jquery_default()("#link-to-collection")
                .val()
                .toString();
            }
          });
        };

        this.loadSort = () => {
          const queryParams = {};

          if (location.search.length) {
            for (
              var aKeyValue,
                i = 0,
                aCouples = location.search.substr(1).split("&");
              i < aCouples.length;
              i++
            ) {
              aKeyValue = aCouples[i].split("=");

              if (aKeyValue.length > 1) {
                queryParams[decodeURIComponent(aKeyValue[0])] =
                  decodeURIComponent(aKeyValue[1]);
              }
            }
          }

          var sort_by = jquery_default()("#collection-sort-by").val();
          jquery_default()("#sort-by")
            .val(sort_by)
            .on("change", function () {
              queryParams.sort_by = jquery_default()(this).val();
              location.search = jquery_default()
                .param(queryParams)
                .replace(/\+/g, "%20");
            });
        };

        this.loadTagFilter();
        this.loadSort();
        this.colorSwatchCheck();
        this.loadPaging();
        document.addEventListener("paginate", this.loadPaging);
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/CollectionHeader.js
    class CollectionHeader extends Section {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/CollectionFilterSort.js
    /* provided dependency */ var CollectionFilterSort_$ =
      __webpack_require__(755);

    class CollectionFilterSort extends Section {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);

        this.mobileSidebar = () => {
          CollectionFilterSort_$(".collection-sidebar--section h2").on(
            "click",
            function () {
              var $this = CollectionFilterSort_$(this);
              var parent = $this.parent();
              parent.toggleClass("expanded");
            }
          );
        };

        this.mobileSidebar();
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/CollectionsList.js
    class CollectionsList extends Section {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/FeaturedCollection.js
    class FeaturedCollection extends Section {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);
      }
    } // CONCATENATED MODULE: ./src/javascripts/sections/Cart.js
    class Cart extends Section {
      constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);
        this.cartTerms = new CartTerms(theme, element);
        jquery_default()(
          '[name="checkout"], [name="goto_pp"], [name="goto_gc"]'
        ).on("click", this.cartTerms.checkTerms);
        this.quantityControls = new QuantityControls(
          this.theme,
          this.element,
          true
        );
      }
    } // CONCATENATED MODULE: ./src/javascripts/global/Newsletter.js
    class Newsletter {
      constructor(theme) {
        this.onSubmit = (event) => {
          event.preventDefault();
          var self = this;
          const form = event.target;
          const formData = new FormData(form);
          const formSpinner = form.querySelector(".newsletter-spinner");
          const inputWrapper = form.querySelector(
            '#newsletter-wrapper, [id^="newsletter-wrapper"]'
          );
          const successMsg = form.querySelector(".form-success");
          formSpinner.classList.remove("hide");
          if (inputWrapper) inputWrapper.classList.add("hide");
          fetch("/contact", {
            method: "post",
            body: formData,
          })
            .then((response) => {
              if (
                typeof response.url === "string" &&
                response.url.includes("/challenge")
              ) {
                form.removeEventListener("submit", self.onSubmit);
                form.submit();
                return false;
              } else {
                return response;
              }
            })
            .then((data) => {
              if (data !== false) {
                formSpinner.classList.add("hide");
                if (successMsg) successMsg.classList.remove("hide");
              }
            });
        };

        this.showAlert = (content) => {
          const pageAlert = document.createElement("div");
          pageAlert.classList.add("page-alert", "page-alert--hidden");
          pageAlert.append(content.cloneNode(true));
          document.body.append(pageAlert);
          const getPageAlert = document.querySelector(".page-alert");
          document
            .querySelectorAll(".success-msg")
            .forEach((el) => el.classList.remove("hidden"));
          setTimeout(() => {
            getPageAlert.classList.remove("page-alert--hidden");
          }, 1000);
          setTimeout(() => {
            getPageAlert.classList.add("page-alert--hidden");
          }, 8000);
        };

        this.theme = theme; // Use AJAX for submitting the contact form

        this.forms = document.querySelector(".contact-form");
        if (!this.forms) return;
        this.forms.addEventListener("submit", this.onSubmit);
        const success = document.querySelector(".contact-form .form-success");
        const errors = document.querySelector(".contact-form .errors");

        if (errors && errors.length > 0 && errors[0].children.length > 0) {
          this.showAlert(errors[0]);
        } else if (success.length > 0) {
          this.showAlert(success[0]);
        }
      }
    } // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Dropdown.vue?vue&type=template&id=34f8403a&
    var render = function () {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c(
        "div",
        {
          ref: "component",
          staticClass: "wetheme-dropdown",
          class: [
            "fit-" + this.fit,
            _vm.isOpen ? "wetheme-dropdown--open" : "wetheme-dropdown--closed",
            "wetheme-dropdown--" + _vm.direction,
          ],
        },
        [
          _vm.title
            ? _c("label", {
                attrs: { for: _vm.id },
                domProps: { textContent: _vm._s(_vm.title) },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wetheme-dropdown__wrapper" },
            [
              _c(
                "button",
                {
                  ref: "button",
                  staticClass: "alt-focus",
                  attrs: {
                    "aria-haspopup": "listbox",
                    type: "button",
                    readonly: "true",
                    id: _vm.id + "-button",
                    "aria-expanded": _vm.isOpen,
                  },
                  on: {
                    click: _vm.toggleDropdown,
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null;
                        }
                        $event.preventDefault();
                        return _vm.toggleDropdown.apply(null, arguments);
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        ) {
                          return null;
                        }
                        $event.preventDefault();
                        return _vm.toggleDropdown.apply(null, arguments);
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "up", 38, $event.key, [
                            "Up",
                            "ArrowUp",
                          ])
                        ) {
                          return null;
                        }
                        $event.preventDefault();
                        return _vm.moveFocusedIndex(-1);
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "down", 40, $event.key, [
                            "Down",
                            "ArrowDown",
                          ])
                        ) {
                          return null;
                        }
                        $event.preventDefault();
                        return _vm.moveFocusedIndex(1);
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape",
                          ])
                        ) {
                          return null;
                        }
                        $event.preventDefault();
                        return _vm.close.apply(null, arguments);
                      },
                    ],
                  },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.selectedOption.label || "\xa0"),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "wetheme-dropdown-fade" } }, [
                _c(
                  "ul",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isOpen,
                        expression: "isOpen",
                      },
                    ],
                    ref: "ul",
                    attrs: {
                      id: _vm.dropdownId,
                      role: "listbox",
                      "aria-activedescendant": _vm.id + "_" + _vm.focusedOption,
                      tabindex: "0",
                    },
                    on: {
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "up", 38, $event.key, [
                              "Up",
                              "ArrowUp",
                            ])
                          ) {
                            return null;
                          }
                          $event.preventDefault();
                          return _vm.moveFocusedIndex(-1);
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "down", 40, $event.key, [
                              "Down",
                              "ArrowDown",
                            ])
                          ) {
                            return null;
                          }
                          $event.preventDefault();
                          return _vm.moveFocusedIndex(1);
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null;
                          }
                          $event.preventDefault();
                          return _vm.applyFocused(false);
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          ) {
                            return null;
                          }
                          $event.preventDefault();
                          return _vm.applyFocused(false);
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape",
                            ])
                          ) {
                            return null;
                          }
                          $event.preventDefault();
                          return _vm.exitList.apply(null, arguments);
                        },
                      ],
                      blur: _vm.exitList,
                    },
                  },
                  _vm._l(_vm.options, function (option) {
                    return _c("li", {
                      key: option.value,
                      class: { selected: _vm.optionIsSelected(option) },
                      attrs: {
                        role: "option",
                        id: option.value,
                        value: option.value,
                        "aria-selected": _vm.optionIsSelected(option),
                      },
                      domProps: { textContent: _vm._s(option.label) },
                      on: {
                        mousedown: function ($event) {
                          return _vm.optionClicked(option);
                        },
                      },
                    });
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
        ]
      );
    };
    var staticRenderFns = []; // CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3[0].rules[0].use!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Dropdown.vue?vue&type=script&lang=js&

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    const getElementWidth = (el) => {
      var clone = el.cloneNode(true);
      clone.style.cssText =
        "position: fixed; top: 0; left: 0; overflow: auto; visibility: hidden; pointer-events: none; height: unset; max-height: unset";
      document.body.appendChild(clone);
      var width = clone.getBoundingClientRect().width;
      document.body.removeChild(clone);
      return width;
    };

    let dropdown_last_id = 0;
    /* harmony default export */ const Dropdownvue_type_script_lang_js_ =
      vue_runtime_esm.extend({
        props: {
          fit: {
            type: String,
            default: "parent",
            validator: function (value) {
              return ["parent", "current", "longest"].indexOf(value) !== -1;
            },
          },
          direction: {
            type: String,
            default: "down",
            validator: function (value) {
              return ["down", "up"].indexOf(value) !== -1;
            },
          },
        },
        data: function () {
          return {
            theme: null,
            id: "",
            title: "",
            isOpen: false,
            options: [],
            selectedOption: undefined,
            // focusedIndex is index of option that user navigated to using keyboard,
            // it's equal to index of selected option when keyboard was not used
            focusedIndex: 0,
            selectComponent: undefined,
          };
        },

        beforeMount() {
          // Convert a <select> and <label> into options and other properties
          const select = this.$root.$el.querySelector("select");

          if (select.id) {
            this.id = select.id;
          } else {
            dropdown_last_id += 1;
            this.id = "wetheme-dropdown-" + dropdown_last_id;
          }

          const labelEl = this.$root.$el.querySelector("label");
          this.title = labelEl ? labelEl.textContent : undefined;
          const options = [];
          Array.prototype.forEach.call(
            select.querySelectorAll("option"),
            function (option, index) {
              if (option.dataset.placeholder === undefined) {
                options.push({
                  value: option.value,
                  label: option.textContent,
                });
              }

              if (option.defaultSelected) {
                this.selectedOption = option;
                this.focusedIndex = index;
              }
            }.bind(this)
          );
          this.options = options;

          if (!this.selectedOption) {
            this.selectedOption = options[0];
            this.focusedIndex = 0;
          }

          this.selectWidth = getElementWidth(select);
          this.selectComponent = select;
          this.selectComponent.style.display = "none";
          select.addEventListener("input", this.onSelectChange);
          select.addEventListener("change", this.onSelectChange);
        },

        mounted: function () {
          if (this.fit === "longest") {
            const w = this.selectWidth + 20; // 20px for caret

            this.$el.style.width = w + "px";
            this.$refs.ul.style.width = w + "px";
          }

          this.$el.appendChild(this.selectComponent);
        },
        computed: {
          dropdownId: function () {
            return this.id + "-dropdown";
          },
          focusedOption: function () {
            return this.options[this.focusedIndex].value;
          },
        },
        methods: {
          findOptionIndex: function (option) {
            let index;
            this.options.forEach(function (o, i) {
              if (o.value === option.value) {
                index = i;
              }
            });
            return index;
          },
          optionClicked: function (option) {
            this.selectedOption = option;
            this.focusedIndex = this.findOptionIndex(option);
            this.selectComponent.value = option.value;
            this.$nextTick(function () {
              // Emit the event when input value is already changed
              const e = new CustomEvent("change");
              this.selectComponent.dispatchEvent(e);
              this.exitList();
            });
          },
          moveFocusedIndex: function (offset) {
            const focusedIndex = this.focusedIndex + offset;

            if (focusedIndex >= 0 && focusedIndex < this.options.length) {
              this.focusedIndex = focusedIndex;
            } // document.getElementById( this.options[this.focusedIndex].value ).focus();

            if (!this.isOpen) {
              this.applyFocused(true);
            }
          },
          applyFocused: function (force) {
            if (!this.isOpen && !force) {
              this.isOpen = true;
              return;
            }

            this.optionClicked(this.options[this.focusedIndex]);
            this.isOpen = false;
          },
          close: function () {
            this.isOpen = false;
          },
          focusList: function () {
            this.$nextTick(function () {
              this.$refs.ul.focus();
            });
          },
          exitList: function () {
            this.isOpen = false;
            this.$refs.button.focus();
          },
          toggleDropdown: function () {
            this.isOpen = !this.isOpen;

            if (this.isOpen) {
              this.focusList();
            } else {
              this.$refs.button.focus();
            }
          },
          onSelectChange: function (e) {
            const val = this.selectComponent.value;

            if (val !== this.selectedOption.value) {
              let index;
              let option;
              this.options.forEach((o, i) => {
                if (val === o.value) {
                  index = i;
                  option = o;
                }
              });
              this.selectedOption = option;
              this.focusedIndex = index;
            }
          },
          optionIsSelected: function (option) {
            return option.value === this.options[this.focusedIndex].value;
          },
        },
      }); // CONCATENATED MODULE: ./src/javascripts/components/Dropdown.vue?vue&type=script&lang=js&
    /* harmony default export */ const components_Dropdownvue_type_script_lang_js_ =
      Dropdownvue_type_script_lang_js_; // CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(
      scriptExports,
      render,
      staticRenderFns,
      functionalTemplate,
      injectStyles,
      scopeId,
      moduleIdentifier /* server only */,
      shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options =
        typeof scriptExports === "function"
          ? scriptExports.options
          : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = "data-v-" + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function (context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent &&
              this.parent.$vnode &&
              this.parent.$vnode.ssrContext); // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode
          ? function () {
              injectStyles.call(
                this,
                (options.functional ? this.parent : this).$root.$options
                  .shadowRoot
              );
            }
          : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functional component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options,
      };
    } // CONCATENATED MODULE: ./src/javascripts/components/Dropdown.vue

    /* normalize component */
    var component = normalizeComponent(
      components_Dropdownvue_type_script_lang_js_,
      render,
      staticRenderFns,
      false,
      null,
      null,
      null
    );

    /* harmony default export */ const Dropdown = component.exports; // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Video.vue?vue&type=template&id=6b23c01e&
    var Videovue_type_template_id_6b23c01e_render = function () {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", { ref: "video", staticClass: "video" }, [
        _vm.videoType === "mp4"
          ? _c(
              "video",
              {
                ref: "videoMP4",
                staticClass: "hero-video-mp4",
                attrs: { playsinline: "", controls: "" },
              },
              [_c("source", { attrs: { src: _vm.url, type: "video/mp4" } })]
            )
          : _vm._e(),
      ]);
    };
    var Videovue_type_template_id_6b23c01e_staticRenderFns = []; // CONCATENATED MODULE: ./src/javascripts/global/VideoBase.js

    /**
     * @typedef {Object} VideoParams
     * @param {boolean} autoplay
     * @param {boolean} mute
     * @param {boolean} loop
     * @param {boolean} hideControls
     * @param {string} url
     */
    class VideoBase {
      constructor(theme, element) {
        this.getAutoplay = (autoplay) => {
          // Autoplay if Save-Data is not set
          if ("connection" in navigator) {
            if (navigator.connection.saveData) {
              return false;
            }
          } // Autoplay if reduced motion is not set

          if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return false;
          }

          return autoplay;
        };

        this._load = async function () {};

        this.init = (params) => {};

        this.play = () => {};

        this.pause = () => {};

        this.theme = theme;
        this.element = element;
      }
      /**
       * Get autoplay with overrides
       *
       * @param {boolean} autoplay User autoplay preference
       * @return {boolean}
       */
    } // CONCATENATED MODULE: ./src/javascripts/global/Youtube.js
    /** Get ID of a youtube video from URL
     * @param {string} url
     * @return {string} youtube video ID
     */

    const youtubeGetId = (url) => {
      const parts = url
        .replace(/(>|<)/gi, "")
        .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

      if (parts[2] !== undefined) {
        return parts[2].split(/[^0-9a-z_-]/i)[0];
      }

      return url;
    };
    class Youtube extends VideoBase {
      constructor(...args) {
        super(...args);

        this._load = () => {
          return this.theme.loadYoutubeApi();
        };

        this.init = ({
          autoplay,
          hideControls,
          url,
          mute,
          loop,
          onPlay,
          onEnd,
          hero,
        }) => {
          autoplay = this.getAutoplay(autoplay);
          const videoId = youtubeGetId(url);
          return new Promise((resolve) => {
            this._load().then((YT) => {
              this.player = new YT.Player(this.element, {
                videoId: videoId,
                playerVars: {
                  showinfo: 0,
                  modestbranding: 1,
                  rel: 0,
                  autoplay: autoplay ? 1 : 0,
                  controls: hideControls ? 0 : 1,
                  mute: mute || autoplay ? 1 : 0,
                  playlist: videoId,
                  cc_load_policy: 0,
                  fs: 0,
                  iv_load_policy: 3,
                  playsinline: 1,
                  branding: 0,
                  origin: window.location.origin,
                },
                events: {
                  onReady: (event) => {
                    this.player = event.target;

                    if (hero) {
                      // Don't allow tab stops in autoplaying videos. Makes the video jump out of
                      // its container when tabbing through page.
                      const iframeKey = Object.keys(this.player).find(
                        (key) => this.player[key].tagName == "IFRAME"
                      );
                      this.player[iframeKey].tabIndex = -1;
                    }

                    if (mute || autoplay) {
                      this.player.mute();
                    }

                    if (autoplay) {
                      // Force play just in case that the option didn't work
                      this.player.playVideo();
                    }

                    resolve(this.player);
                  },
                  onStateChange: (event) => {
                    if (event.data === YT.PlayerState.PLAYING) {
                      onPlay();
                    }

                    if (event.data === YT.PlayerState.ENDED && loop) {
                      this.player.playVideo();
                      onEnd();
                    }
                  },
                },
              });
            });
          });
        };
      }
    } // CONCATENATED MODULE: ./src/javascripts/global/Vimeo.js
    /** Get ID of a vimeo video from URL
     * @param {string} url
     * @return {string} vimeo video ID
     */

    function vimeoGetId(url) {
      const regex =
        /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/; // eslint-disable-line

      const parts = url.match(regex);

      if (parts && parts[2] !== undefined) {
        var vimeoID = parts[2];

        if (parts[2].includes("/")) {
          var bits = parts[2].split("/");
          vimeoID = bits[0];
        }

        return vimeoID;
      }

      return url;
    }

    class Vimeo extends VideoBase {
      constructor(...args) {
        super(...args);

        this._load = () => {
          return this.theme.loadVimeoApi();
        };

        this.init = ({
          autoplay,
          hideControls,
          url,
          mute,
          loop,
          onPlay,
          onEnd,
          hero,
        }) => {
          autoplay = this.getAutoplay(autoplay);
          const videoId = vimeoGetId(url);
          return new Promise((resolve, reject) => {
            this._load().then((Vimeo) => {
              this.player = new Vimeo.Player(this.element, {
                id: videoId,
                autoplay: autoplay,
                controls: !hideControls,
              });
              this.player.ready().then(() => {
                if (hero) {
                  // Don't allow tab stops in autoplaying videos
                  this.player.element.tabIndex = -1;
                }

                if (mute || autoplay) {
                  this.player.setVolume(0);
                }

                if (loop) {
                  this.player.setLoop(true);
                }

                if (autoplay) {
                  this.player.play();
                }

                resolve(this.player);
              });
              this.player.on("play", () => {
                onPlay();
              });
              this.player.on("ended", () => {
                onEnd();
              });
            });
          });
        };
      }
      /*
      player.ready().then(function(){
          registerVideoPlayButton(element, 'vimeo', player, isVideoHero);
      }).catch(function (e) {
          document.getElementById(element.id).innerText = e;
      });
      */
    } // CONCATENATED MODULE: ./src/javascripts/global/MP4Video.js
    /// <reference path="../window.d.ts" />

    class MP4Video extends VideoBase {
      constructor(...args) {
        super(...args);

        this._load = () => {
          return new Promise((resolve) => {
            window.Shopify.loadFeatures([
              {
                name: "video-ui",
                version: "1.0",
                onLoad: function () {
                  resolve(window.Shopify.Plyr);
                },
              },
            ]);
          });
        };

        this.init = ({
          autoplay,
          hideControls,
          url,
          mute,
          loop,
          onPlay,
          onEnd,
          hero,
        }) => {
          autoplay = this.getAutoplay(autoplay);
          return new Promise((resolve, reject) => {
            this._load().then((Plyr) => {
              this.player = new Plyr(this.element, {
                loop: {
                  active: loop,
                },
                autoplay: autoplay,
                muted: mute,
                fullscreen: {
                  enabled: false,
                },
                focusOnPlay: false,
              });
              this.player.on("ready", (event) => {
                this.player = event.detail.plyr;

                if (hero) {
                  this.player.elements.container.tabIndex = -1;
                }

                if (autoplay) {
                  this.player.play();
                }

                if (hideControls) {
                  // this.player.toggleControls(false);
                  // Prevent hidden controls being keyboard-tab-able.
                  this.player.media
                    .closest(".plyr--video")
                    .querySelector(".plyr__controls")
                    .remove();
                }

                resolve();
              });
              this.player.on("playing", () => {
                onPlay();
              });
              this.player.on("ended", () => {
                onEnd();
              });
            });
          });
        };
      }
    } // CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3[0].rules[0].use!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Video.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //

    /* harmony default export */ const Videovue_type_script_lang_js_ =
      vue_runtime_esm.extend({
        props: {
          theme: ThemeBase,
          hero: Boolean,
          videoType: {
            type: String,
            required: true,
            validator: function (value) {
              return ["youtube", "vimeo", "mp4"].indexOf(value) !== -1;
            },
          },
          url: {
            type: String,
            required: true,
          },
          autoplay: {
            type: Boolean,
            required: true,
          },
          loop: Boolean,
          mute: Boolean,
          hideControls: {
            type: Boolean,
            default: false,
          },
        },

        data() {
          return {
            /** @type {VideoBase} */
            player: null,
          };
        },

        mounted() {
          if (this.videoType === "youtube") {
            this.player = new Youtube(this.theme, this.$refs.video);
          } else if (this.videoType === "vimeo") {
            this.player = new Vimeo(this.theme, this.$refs.video);
          } else if (this.videoType === "mp4") {
            this.player = new MP4Video(this.theme, this.$refs.videoMP4);
          }

          this.player.init({
            autoplay: this.autoplay,
            hideControls: this.hideControls,
            url: this.url,
            mute: this.mute,
            loop: this.loop,
            onPlay: this.onPlay,
            onEnd: this.onEnd,
            hero: this.hero,
          });
        },

        methods: {
          onPlay() {},

          onEnd() {},
        },
      }); // CONCATENATED MODULE: ./src/javascripts/components/Video.vue?vue&type=script&lang=js&
    /* harmony default export */ const components_Videovue_type_script_lang_js_ =
      Videovue_type_script_lang_js_; // CONCATENATED MODULE: ./src/javascripts/components/Video.vue
    /* normalize component */
    var Video_component = normalizeComponent(
      components_Videovue_type_script_lang_js_,
      Videovue_type_template_id_6b23c01e_render,
      Videovue_type_template_id_6b23c01e_staticRenderFns,
      false,
      null,
      null,
      null
    );

    /* harmony default export */ const Video = Video_component.exports; // CONCATENATED MODULE: ./src/javascripts/Theme.js
    /**
     * @typedef {Object} ShopifyEventDetail
     * @property {string} sectionId
     * @property {string} [blockId]
     * @property {boolean} [load]
     */

    /**
     * @typedef {CustomEvent<ShopifyEventDetail>} ShopifyEvent
     */

    class Theme extends ThemeBase {
      constructor() {
        super();
        this.RESIZE_DEBOUNCE_INTERVAL = 400;
        this.SECTIONS = {
          header: Header,
          "collection--featured-collection": FeaturedCollection,
          "image--image": Image_Image,
          "image--slideshow": Slideshow,
          "image--image-with-text-block": ImageWithTextBlock,
          "image--image-with-text-overlay": ImageWithTextOverlay,
          "product--featured-product": FeaturedProduct,
          "product--shop-the-look": ShopTheLook,
          "template--collection": Collection,
          "template--collection-filter-sort": CollectionFilterSort,
          "template--collection-header": CollectionHeader,
          "template--collections-list": CollectionsList,
          "template--product": Product,
          "template--product--recommandations": ProductRecommendations,
          "template--cart": Cart,
          "text--testimonials": Testimonial,
          "text--text-adverts": TextAdverts,
          "video--video": Section,
          "video--video-with-text-overlay": Section,
        };

        this.VUE_COMPONENTS = {
          "wetheme-dropdown": Dropdown,
          "wetheme-video": Video,
        };

        this.loadDrawers = () => {
          if (!document.body.classList.contains("password-page")) {
            this.drawer = new Drawer(this);
            this.cartDrawer = this.drawer.slideouts.right
              ? new CartDrawer(this, this.drawer.slideouts.right.menu)
              : null;
          }
        };

        this._loadCartKey = () => {
          const cerberusKey = "cd4f908b-0400-4e45-b574-a97f4e8c2a77";
          return cerberusKey;
        };

        this.loadGlobal = () => {
          const globalEl = document.querySelector("#wetheme-global");

          if (!globalEl) {
            console.warn(
              "Script #wetheme-global with global definitions not found"
            );
            return;
          }

          let global;

          try {
            global = JSON.parse(globalEl.textContent);
          } catch (e) {
            console.warn("Invalid syntax in #wetheme-global", e);
            return;
          }

          this.translations = global.translations;
          this.moneyFormat = global.moneyFormat;
        };

        this.loadVueComponents = (element) => {
          Object.entries(this.VUE_COMPONENTS).forEach(
            ([tagName, VueComponent]) => {
              this.loadVueComponent(element, tagName, VueComponent);
            }
          );
        };

        this.loadVueComponent = (element, tagName, Component) => {
          Array.prototype.forEach.call(
            element.querySelectorAll(tagName),
            (el) => {
              const attr = {
                theme: this,
              };

              if (el.hasAttributes()) {
                var attrs = el.attributes;

                for (let i = attrs.length - 1; i >= 0; i--) {
                  const { name, value } = attrs[i];

                  if (value === "true") {
                    attr[name] = true;
                  } else if (value === "false") {
                    attr[name] = false;
                  } else {
                    attr[name] = value;
                  }
                }
              }

              const c = new vue_runtime_esm({
                el: el,
                render: (h) => {
                  return h(Component, {
                    attrs: attr,
                  });
                },
              });
              this.vueComponents.push(c);
            }
          );
        };

        this.loadSection = (element, SectionClass, pageLoad) => {
          const c = new SectionClass(this, element, pageLoad);
          this.sectionById.set(element.dataset.wethemeSectionId, c);
          const type = element.dataset.wethemeSectionType;
          let sections = this.sectionsByType.get(type);

          if (!sections) {
            sections = [];
            this.sectionsByType.set(type, sections);
          }

          sections.push(c);
          this.loadVueComponents(element);
        };

        this.loadSectionsByType = (type, SectionClass, pageLoad) => {
          const selector = `[data-wetheme-section-type="${type}"]`;
          Array.prototype.forEach.call(
            document.querySelectorAll(selector),
            (element) => {
              try {
                this.loadSection(element, SectionClass, pageLoad);
              } catch (e) {
                console.error(
                  `Unable to load section ${type} on element`,
                  element,
                  e
                );
              }
            }
          );
        };

        this.onLoadAll = () => {
          this.load();
          Object.entries(this.SECTIONS).forEach(([type, SectionClass]) => {
            this.loadSectionsByType(type, SectionClass, true);
          });
        };

        this.onSectionLoad = (event) => {
          const { sectionId } = event.detail;
          const selector = `[data-wetheme-section-id="${sectionId}"]`;
          const element = document.querySelector(selector);

          if (!element) {
            console.warn(
              `Element with ${selector} not found, section won't be loaded`
            );
            return;
          }

          const type = element.dataset.wethemeSectionType;
          const SectionClass = this.SECTIONS[type];

          if (!SectionClass) {
            console.warn(`Cannot find class with type "${type}"`);
            return;
          }

          this.loadSection(element, SectionClass, false);
        };

        this.onSectionUnload = (event) => {
          const element = event.target;
          const { sectionId } = event.detail;
          const section = this.sectionById.get(sectionId);

          if (!section) {
            console.warn(
              `No section with id ${sectionId}, nothing will be unloaded`
            );
            return;
          }

          section.destroy({
            element,
          });
        };

        this.onSectionSelect = (event) => {
          const element = event.target;
          const { sectionId, load } = event.detail;
          const section = this.sectionById.get(sectionId);

          if (!section) {
            console.warn(
              `No section with id ${sectionId}, nothing will be selected`
            );
            return;
          }

          section.onSectionSelect({
            element,
            sectionId,
            load,
          });
        };

        this.onSectionDeselect = (event) => {
          const element = event.target;
          const { sectionId } = event.detail;
          const section = this.sectionById.get(sectionId);

          if (!section) {
            console.warn(
              `No section with id ${sectionId}, nothing will be deselected`
            );
            return;
          }

          section.onSectionDeselect({
            element,
            sectionId,
          });
        };

        this.onSectionReorder = (event) => {
          const element = event.target;
          const { sectionId } = event.detail;
          const section = this.sectionById.get(sectionId);

          if (!section) {
            console.warn(
              `No section with id ${sectionId}, nothing will be done on reorder`
            );
            return;
          }

          section.onSectionReorder({
            element,
            sectionId,
          });
        };

        this.onBlockSelect = (event) => {
          const element = event.target;
          const { sectionId, blockId, load } = event.detail;
          const section = this.sectionById.get(sectionId);

          if (!section) {
            console.warn(
              `No section with id ${sectionId}, block select will do nothing`
            );
            return;
          }

          section.onBlockSelect({
            element,
            sectionId,
            blockId,
            load,
          });
        };

        this.onBlockDeselect = (event) => {
          const element = event.target;
          const { sectionId, blockId } = event.detail;
          const section = this.sectionById.get(sectionId);

          if (!section) {
            console.warn(
              `No section with id ${sectionId}, block deselect will do nothing`
            );
            return;
          }

          section.onBlockDeselect({
            element,
            sectionId,
            blockId,
          });
        };

        this.onResize = (event) => {
          const width = this.getWindowWidth();
          const oldWidth = this.previousWidth; // Trigger non-debounced event on all components

          this.registeredComponents.forEach((c) =>
            c.onWindowResizeRaw({
              width,
            })
          ); // Trigger debounced event on all sections

          if (this.resizeDebounceTimer) {
            clearTimeout(this.resizeDebounceTimer);
          }

          this.resizeDebounceTimer = setTimeout(() => {
            this.resizeDebounceTimer = null;
            const breakpoint = this.getBreakpoint(width);
            this.registeredComponents.forEach((c) => {
              c.onWindowResize({
                width,
                oldWidth,
                breakpoint,
              });

              if (breakpoint !== this.breakpoint) {
                // Breakpoint has changed, trigger the event
                c.onWindowResizeBreakpoint({
                  breakpoint,
                  oldBreakpoint: this.breakpoint,
                  width,
                });
              }
            });
            this.previousWidth = width;
            this.breakpoint = breakpoint;
          }, this.RESIZE_DEBOUNCE_INTERVAL);
        };

        this.loadIcons = (element = null) => {
          const parent = element || document; // If we use wrong icon, whole feather will crash and no further icons will be loaded
          // this will check if icons are vaild and will remove the feather if not

          var icons = Object.keys(feather_default().icons);
          Array.prototype.forEach.call(
            parent.querySelectorAll("[data-feather]"),
            function (el) {
              var icon = el.dataset.feather;

              if (icons.indexOf(icon) < 0) {
                console.warn(
                  'No such icon "' + icon + '" in feather, element',
                  el
                );
                el.dataset.featherInvalid = icon;
                delete el.dataset.feather;
              }
            }
          );

          try {
            feather_default().replace();
          } catch (e) {
            console.error("Unable to load icons:", e);
          }
        };

        this.handleAccordions = () => {
          let detailsElements = document.querySelectorAll("details"); //@ts-ignore

          for (let item of detailsElements) {
            item.addEventListener("click", (e) => {
              const target = e.currentTarget;
              setTimeout(() => {
                const isExpanded = item.open ? "true" : "false";
                item.firstElementChild.setAttribute(
                  "aria-expanded",
                  isExpanded
                );
              }, 0);
            });
          }
        };

        this.loadYoutubeApi = () => {
          return new Promise((resolve, reject) => {
            if (window.YT) {
              // We already have youtube API loaded, we're done
              resolve(window.YT);
            } else if (!document.querySelector("#youtube_api")) {
              // Resolve once youtube is loaded
              this.youtubeLoadedCallbacks.push({
                resolve,
                reject,
              });
              const embedContainer =
                document.querySelectorAll(".embed-container")[0];
              const editorOpen =
                document.querySelector("#main-body").dataset.editorOpen;

              var isInViewport = function isInViewport(el) {
                const rect = el.getBoundingClientRect();
                return (
                  rect.top >= 101 &&
                  rect.left >= 0 &&
                  rect.right <=
                    (window.innerWidth || document.documentElement.clientWidth)
                );
              };

              var visibleElement = function visibleElement(el) {
                const section = el.offsetTop;
                return section;
              };

              if (embedContainer && editorOpen == "false") {
                let isVisible = visibleElement(embedContainer);
                let isInView = isInViewport(embedContainer); //Check if the video section is visible on initial load

                if (isVisible > 10 && isVisible <= 100) {
                  // Youtube API is not yet loaded, create script that loads it
                  this.createScript(
                    "youtube_api",
                    "https://www.youtube.com/player_api",
                    true
                  );
                } else {
                  document.addEventListener(
                    "scroll",
                    function () {
                      if (isInView) {
                        // Youtube API is not yet loaded, create script that loads it
                        this.createScript(
                          "youtube_api",
                          "https://www.youtube.com/player_api",
                          true
                        );
                      }
                    }.bind(this),
                    {
                      passive: true,
                    }
                  );
                }
              } else {
                // Youtube API is not yet loaded, create script that loads it
                this.createScript(
                  "youtube_api",
                  "https://www.youtube.com/player_api",
                  true
                );
              }
            } else {
              // Script for loading youtube API is there, but youtube is not yet loaded
              this.youtubeLoadedCallbacks.push({
                resolve,
                reject,
              });
            }
          });
        };

        this.onYoutubeLoaded = () => {
          this.youtubeLoadedCallbacks.forEach(({ resolve }) => {
            resolve(window.YT);
          });
          this.youtubeLoadedCallbacks.splice(0);
        };

        this.loadVimeoApi = () => {
          return new Promise((resolve, reject) => {
            if (window.Vimeo) {
              // Already loaded
              resolve(window.Vimeo);
            } else if (!document.querySelector("#vimeo_api")) {
              // Vimeo API is not yet loaded, create script that loads it
              const script = this.createScript(
                "vimeo_api",
                "https://player.vimeo.com/api/player.js"
              );

              script.onload = () => {
                resolve(window.Vimeo);
                this.onVimeoLoaded();
              };
            } else {
              this.vimeoLoadedCallbacks.push({
                resolve,
                reject,
              });
            }
          });
        };

        this.onVimeoLoaded = () => {
          this.vimeoLoadedCallbacks.forEach(({ resolve }) => {
            resolve(window.Vimeo);
          });
          this.vimeoLoadedCallbacks.splice(0);
        };

        this.updateCartDrawer = (cart) => {
          if (!this.cartDrawer) {
            return;
          }

          this.cartDrawer.updateCartDrawer(cart);
        };

        this.createScript = (id, src, async = false) => {
          const tag = document.createElement("script");
          tag.id = id;
          tag.src = src;

          if (async) {
            tag.defer = true;
            tag.async = true;
          }

          const firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          return tag;
        };

        this.registerComponent = (component) => {
          this.registeredComponents.push(component);
        };

        this.makeVideoEmbedsResponsive = () => {
          jquery_default()(
            ".template-page iframe, .template-blog iframe, .template-article iframe"
          ).each(function (index, iframe) {
            var source = jquery_default()(iframe).attr("src");

            if (source != undefined) {
              if (
                source.indexOf("youtube.com") >= 0 ||
                source.indexOf("vimeo.com") >= 0 ||
                source.indexOf("dailymotion.com") >= 0
              ) {
                //create container
                var embedContainer = document.createElement("div");
                jquery_default()(embedContainer).addClass("embed-container"); //clone iframe

                var iframeClone = jquery_default()(iframe).clone(); //put clone in container

                jquery_default()(embedContainer).append(iframeClone); //embed clone with responsive container

                jquery_default()(iframe).replaceWith(embedContainer);
              }
            }
          });
        };

        this.gridSwatches = () => {
          jquery_default()(".indiv-product__swatches")
            .find("input")
            .on("change", function () {
              var updateImage = jquery_default()(this).attr("data-href");
              var targetImage = jquery_default()(this)
                .closest(".indiv-product")
                .find(".grid__image img");
              targetImage.attr({
                src: updateImage,
              });
              targetImage.attr({
                srcset: updateImage,
              });
              targetImage.data({
                lowsrc: updateImage,
              });
              targetImage.data({
                srcset: updateImage,
              });
            });
        };

        this.name = "Envy";
        this.$ = jquery_default();
        /* Section by it's unique ID
         * @type {Map<string, Section>}
         */

        this.sectionById = new Map();
        /** Array of sections by given section type
         * @type {Map<string, Section[]>}
         */

        this.sectionsByType = new Map();
        /** Array of registed components
         * @type {Array<import('./Component').default>}
         */

        this.registeredComponents = [];
        /** Array of initialized vue components
         * @type {Array<Object>}
         */

        this.vueComponents = [];
        /** @type {Array<{ resolve: (YoutubeApi) => void, reject: (string) => void }>} */

        this.youtubeLoadedCallbacks = [];
        /** @type {Array<{ resolve: (VimeoApi) => void, reject: (string) => void }>} */

        this.vimeoLoadedCallbacks = [];
        this.resizeDebounceTimer = null;
        document.addEventListener("shopify:section:load", this.onSectionLoad);
        document.addEventListener(
          "shopify:section:unload",
          this.onSectionUnload
        );
        document.addEventListener(
          "shopify:section:select",
          this.onSectionSelect
        );
        document.addEventListener(
          "shopify:section:deselect",
          this.onSectionDeselect
        );
        document.addEventListener(
          "shopify:section:reorder",
          this.onSectionReorder
        );
        document.addEventListener("shopify:block:select", this.onBlockSelect);
        document.addEventListener(
          "shopify:block:deselect",
          this.onBlockDeselect
        );
        document.addEventListener("DOMContentLoaded", this.onLoadAll);
        window.addEventListener("resize", this.onResize);
      }
      /** This will be execute when whole DOM is loaded */

      load() {
        this.loadGlobal();
        this.breakpoint = this.getBreakpoint();
        this.wow = new (wow_default())().init();
        this.loadDrawers();
        this.handleAccordions();
        this.popup = null;
        const popupEl = document.querySelector("#popup");

        if (popupEl && window.location.pathname !== "/challenge") {
          // Don't show popup when we're filling CAPTCHA for contact form
          this.popup = new Popup(this, popupEl);
        }

        this.ageCheck = null;
        const ageEl = document.querySelector(".verification-popup-container");

        if (ageEl && window.location.pathname !== "/challenge") {
          // Don't show age-checker when we're filling CAPTCHA for contact form
          this.ageCheck = new AgeChecker(this, ageEl);
        }

        this.loadIcons(); // Newsletter form could be on contact-us page, so outside of sections

        this.newsletter = new Newsletter(this); // Login page doesn't have sections, load it here

        if (document.body.classList.contains("template-customers-login")) {
          this.login = new LoginPage(this);
        }

        if (document.body.classList.contains("template-search")) {
          this.searchPage = new SearchPage(
            this,
            document.querySelector("#search_results")
          );
        }

        if (document.body.classList.contains("template-customers-addresses")) {
          this.addressPage = new AddressPage(
            this,
            document.querySelector("#addresses")
          );
        } // This is for all video embeds, even outside sections

        this.makeVideoEmbedsResponsive();
        this.gridSwatches();
      }
    } // Make the theme object instance globally available

    window.wetheme = new Theme();

    window.onYouTubePlayerAPIReady = () => {
      window.wetheme.onYoutubeLoaded();
    };
  })();

  /******/
})();
//# sourceMappingURL=theme.js.map
